import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {

      // afrikaans
      // afrikaans
      /*
      afrikaans: {
        translations: {
          "-'n fout het voorgekom": 'n Fout het voorgekom!, //a
           "--adres": Adresse,
           "--advice": Advies,
           "--deur op voort te klik": Deur op voort te klik sal jy ontkoppel word van jou Veil Brillant-rekening, //b
           "--deur te klik op ontkoppel sal jy ontkoppel word": Deur op Ontkoppel te klik sal jy van jou izocash-rekening ontkoppel word,
           "--kontroleer jou virtuele nommer of probeer later weer": Gaan jou virtuele nommer na of probeer later weer, //c
           "--kontroleer jou virtuele nommer": Gaan jou virtuele nommer na,
           "--continue": Gaan voort,
           "--verbinding": Verbinding,
           "--saamwerk, leef in harmonie": Werk saam, leef in harmonie met ander,
           "--kies taal": virtuele telefoontaal,
           "--moenie mededinging verhoed nie": Moenie mededinging verhoed nie, gee almal 'n kans, //d
           "--disconnection": Ontkoppeling,
           "--vir alle virtuele foongebruikers": Vir alle virtuele foongebruikers word dit aanbeveel om 'n VPN te gebruik, //f
           "--gaan na aanmeldbladsy": Gaan na die aanmeldbladsy, //g
           "--histories": Histories, //h
           "--ek het rekening": Ek het reeds 'n rekening, //i
           "--ek het nie 'n rekening nie": Ek het nie 'n rekening nie,
           "--dit is jou huis": dit is jou huis,
           "--beeld / video +": Beeld / Video +,
           "--identiteit verifikasie": Identiteit verifikasie,
           "--izocash kliënteportaal": izocash kliënteportaal,
           "--identiteit update elke jaar": Identiteit update elke jaar,
           "--izocash koop aan": izocash Koop => izocash internasionaal,
           "--log in": Meld aan!, //l
           "--login": Meld aan,
           "--login by Veil Brilliant": Koppel aan Veil Brillant,
           "--login to Vixinol Store": Koppel aan Vixinol Store,
           "--teken gratis by jou Veil Brillant-rekening aan": Meld gratis aan by jou Veil Brillant-rekening om toegang tot hierdie kenmerk te kry,
           "--login sukses": Aanmelding suksesvol!,
           "--login nou": Meld nou aan!,
           "--logout success": Afmeld suksesvol!,
           "--log uit": Teken uit,
           "--logout": Meld af,
           "--nommer": Nommer, //n
           "--naam": Naam,
           "--nou meld aan": Meld nou aan!,
           "--geen verbod op belemmerende mededinging nie":
           "--geen jaloesie, geen haat": Geen jaloesie, geen haat, geen verdeeldheid,
           "--nee": Nee,
           "--amptelike adresse om toegang tot jou virtuele foon te verkry": Amptelike adresse om toegang tot jou virtuele foon te verkry, //o
           "--wagwoord": Wagwoord, //p
           "--punte-onttrekkings izocash": Punte-onttrekkings izocash,
           "--punte-onttrekkings": Punte-onttrekkings,
           "--verkieslik, gebruik 'n vpn": Gebruik verkieslik 'n VPN wat nie aan jou internetdiensverskaffer behoort nie,
           "--volharding betaal altyd af": Volharding betaal altyd op die ou end,
           "--reël": Reëls, //r
           "--recommendation": Aanbevelings,
           "--registrasie": Registrasie,
           "--registreer by Veil Brilliant": Registreer op Veil Brillant, //s
           "--registreer by vixinol winkel": Registreer op Vixinol Store,
           "--signup": Registreer,
           "--registrasie sukses": Registrasie suksesvol!,
           "--registreer gratis": Registreer gratis,
           "--registrasie sukses IA": Verbinding suksesvol",
           "--settings": "Instellings",
           "--instelling van die alrani-toepassing": Stel die Alrani-toepassing op,
           "--instelling van die izocash-toepassing": Konfigureer die izocash-toepassing,
           "--instelling van die Vixinol-toepassing": Konfigureer die Vixinol-toepassing,
           "--instelling van die Veil Brillant-toepassing": Konfigureer die Veil Brillant-toepassing,
           "--berging van beelde, video's": berging van beelde, video's en verskeie ander elemente,
           "--spoed van ontvangs": Spoed van ontvangs van data vanaf die datasentrum,
           "--spoed": Spoed,
           "--terminate": Beëindig, //t
           "--die vpn laat jou toe om toegang te verkry": Die VPN laat jou toe om toegang te verkry tot 'n webwerf of 'n toepassing wat jou internetdiensverskaffer op die swartlys geplaas het,
           "--die grootste boom was bo": Die grootste boom was bowenal 'n eenvoudige saadjie,
           "--raak die skerm": Raak die skerm om voort te gaan,
           "--probeer weer": Probeer weer!,
           "--gebruikersnaam": Gebruikersnaam, //u

           "--virtuele nommer": Virtuele nommer, //v
           "--virtuele fooninstellings": Virtuele fooninstellings,
           "--virtuele telefoontaal word toegepas": Die virtuele telefoontaal word by verstek op die toepassingsvlak toegepas,
           "--virtuele foon": Virtuele foon,
           "--validate": Bevestig,
           "--welkom by die izocash-kliënteportaal": Welkom by die izocash-kliënteportaal, //w
           "--skryf 'n superkode": Voer 'n superkode in,
           "--welkom by": Welkom by,
           "--waar mense se aandag gaan": Waar mense se aandag gaan, gaan geld,
           "--wenners volhard": Die wenners volhard,
           "--wil jy uit jou Alrani-rekening uitteken": Wil jy by jou Alrani-rekening afmeld?,
           "--ja": Ja, //j

           // land
           "--kongo": Kongo Brazzaville,
           "--kameroen": Kameroen,
           "--drc": DRK,
           "--ivoryCoast": Ivoorkus,

          // langue
          "--afrikaans": "Afrikaans", //a
          "--albanian": "Albanees",
          "--amharic": "Amharies",
          "--arabic": "Arabies",
          "--armenian": "Armeens",
          "--assamese": "Assamees",
          "--aymara": "Aymara",
          "--azerbaijani": "Azerbeidjans",
          "--bambara": "Bambara", //b
          "--basque": "Baskies",
          "--belarusian": "Wit-Russies",
          "--bengali": "Bengaals",
          "--bhojpuri": "Bhojpuri",
          "--bosnian": "Bosnies",
          "--bulgarian": "Bulgaars",
          "--catalan": "Katalaans", //c
          "--cebuano": "Cebuano",
          "--chichewa": "Chichewa",
          "--chineseSimplified": "Chinees (vereenvoudig)",
          "--chineseTraditional": "Chinees (tradisioneel)",
          "--corsican": "Korsikaans",
          "--croatian": "Kroaties",
          "--czech": "Tsjeggies",
          "--danish": "Deens", //d
          "--dhivehi": "Dhivehi",
          "--dogri": "Dogri",
          "--dutch": "Nederlands",
          "--english": "Engels", //e
          "--esperanto": "Esperanto",
          "--estonian": "Estnies",
          "--ewe": "Ooi",
          "--filipino": "Filippyns", //f
          "--finnish": "Fins",
          "--french": "Frans",
          "--frisian": "Fries",
          "--galician": "Galisies", //g
          "--georgian": "Georgies",
          "--german": "Duits",
          "--greek": "Grieks",
          "--guarani": "Guarani",
          "--gujarati": "Gujarati",
          "--haitianCreole": "Haïtiaans Kreools", //h
          "--hausa": "Hausa",
          "--hawaiian": "Hawaiiaans",
          "--hebrew": "Hebreeus",
          "--hindi": "Hindi",
          "--hmong": "Hmong",
          "--hungarian": "Hongaars",
          "--icelandic": "Yslands", //i
          "--igbo": "Igbo",
          "--ilocano": "Ilocano",
          "--indonesian": "Indonesies",
          "--irish": "Iers",
          "--italian": "Italiaans",
          "--japanese": "Japannese", //j
          "--javanese": "Javaans",
          "--kannada": "Kannada", //k
          "--kazakh": "Kasakstan",
          "--khmer": "Khmer",
          "--kinyarwanda": "Kinyarwanda",
          "--konkani": "Konkani",
          "--korean": "Koreaans",
          "--krio": "Krio",
          "--kurdishKurmanji": "Koerdies (Kurmanji)",
          "--kurdishSorani": "Koerdies (Sorani)",
          "--kyrgyz": "Kirgisies",
          "--lao": "Lao", //l
          "--latin": "Latyn",
          "--latvian": "Letties",
          "--lingala": "Lingala",
          "--lithuanian": "Litaus",
          "--luganda": "Luganda",
          "--luxembourgish": "Luxemburgs",
          "--macedonian": "Masedonies", //m
          "--maithili": "Maithili",
          "--malagasy": "Malgassies",
          "--malay": "Maleis",
          "--malayalam": "Malabaars",
          "--maltese": "Maltees",
          "--maori": "Maori",
          "--marathi": "Marathi",
          "--meiteilonManipuri": "Meiteilon (Manipuri)",
          "--mizo": "Mizo",
          "--mongolian": "Mongoolse",
          "--myanmarBurmese": "Myanmar (Birmaans)",
          "--nepali": "Nepalees", //n
          "--norwegian": "Noors",
          "--odiaOriya": "Odia (Oriya)", //o
          "--oromo": "Oromo",
          "--pashto": "Pasjto", //p
          "--persian": "Persies",
          "--polish": "Pools",
          "--portuguese": "Portugees",
          "--punjabi": "Punjabi",
          "--quechua": "Quechua", //q
          "--romanian": "Roemeens", //r
          "--russian": "Russies",
          "--samoan": "Samoaans", //s
          "--sanskrit": "Sanskrit",
          "--scotsGaelic": "Skots Gaelies",
          "--sepedi": "Sepedi",
          "--serbian": "Serwies",
          "--sesotho": "Sesotho",
          "--shona": "Shona",
          "--sindhi": "Sindhi",
          "--sinhala": "Sinhala",
          "--slovak": "Slowaaks",
          "--slovenian": "Sloweens",
          "--somali": "Somalies",
          "--spanish": "Spaans",
          "--sundanese": "Soendanees",
          "--swahili": "Swahili",
          "--swedish": "Sweeds",
          "--tajik": "Tadjieks", //t
          "--tamil": "Tamil",
          "--tatar": "Tataars",
          "--telugu": "Telugu",
          "--thai": "Thai",
          "--tigrinya": "Tigrinië",
          "--tsonga": "Tsonga",
          "--turkish": "Turks",
          "--turkmen": "Turkmeens",
          "--twi": "Twi",
          "--ukrainian": "Oekraïens", //u
          "--urdu": "Oerdoe",
          "--uyghur": "Uyghur",
          "--uzbek": "Oezbeeks",
          "--vietnamese": "Viëtnamees", //v
          "--welsh": "Wallies", //w
          "--xhosa": "Xhosa", //x
          "--yiddish": "Jiddisj", //y
          "--yoruba": "Yoruba",
          "--zulu": "Zoeloe", //z
        },
      },

      // albanian
      // albanian
      albanian: {
        translations: {
          "--një gabim ka ndodhur": Ka ndodhur një gabim!, //a
           "--adresa": Adresat,
           "--këshilla": Këshilla,
           "--duke klikuar te vazhdo": Duke klikuar te vazhdo, do të shkëputeni nga llogaria juaj Veil Brillant, //b
           "--duke klikuar në shkëputje do të shkëputeni": Duke klikuar në Shkëputje do të shkëputeni nga llogaria juaj izocash,
           "--kontrolloni numrin tuaj virtual ose provoni përsëri më vonë": Kontrolloni numrin tuaj virtual ose provoni përsëri më vonë, //c
           "--kontrolloni numrin tuaj virtual": Kontrolloni numrin tuaj virtual,
           "--vazhdim": Vazhdo,
           "--connection": Lidhja,
           "--bashkëpuno, jeto në harmoni": Bashkëpuno, jeto në harmoni me të tjerët,
           "--zgjidh gjuhën": Gjuha virtuale e telefonit,
           "--mos e pengo konkurrencën": Mos e pengo konkurrencën, jepi të gjithëve një shans, //d
           "--disconnection": Shkëputje,
           "--për të gjithë përdoruesit e telefonit virtual": Për të gjithë përdoruesit e telefonit virtual, rekomandohet përdorimi i një VPN, //f
           "--shko te faqja e hyrjes": Shko te faqja e hyrjes, //g
           "--historike": Historike, //h
           "--i kam llogari": Unë tashmë kam një llogari, //i
           "--nuk kam llogari": nuk kam llogari,
           "--është shtëpia jote": është shtëpia jote,
           "--imazh / video +": Imazh / Video +,
           "--verifikimi i identitetit": Verifikimi i identitetit,
           "--portali i klientëve izocash": Portali i klientëve izocash,
           "--Përditësimi i identitetit çdo vit": Përditësimi i identitetit çdo vit,
           "--izocash blej për": izocash Blej => izocash ndërkombëtare,
           "--log in": Identifikohu!, //l
           "--login": Hyni,
           "--login to veil brilliant": Lidhu me Veil Brillant,
           "--hyni në dyqanin vixinol": Lidhu me dyqanin Vixinol,
           "--hyni falas në llogarinë tuaj Veil Brillant": Hyni falas në llogarinë tuaj Veil Brillant për të hyrë në këtë veçori,
           "--login sukses": Hyrja me sukses!,
           "--login now": Identifikohu tani!,
           "--logout sukses": Dalja me sukses!,
           "--log out": Dil,
           "--logout": Dilni,
           "--number": Numri, //n
           "--name": Emri,
           "--tani log in": Tani, Identifikohu!,
           "--nuk ka ndalim për mbytjen e konkurrencës":
           "--pa xhelozi, pa urrejtje": Pa xhelozi, pa urrejtje, pa ndarje,
           "--jo": Jo,
           "--adresat zyrtare për të hyrë në telefonin tuaj virtual": Adresat zyrtare për të hyrë në telefonin tuaj virtual, //o
           "--password": Fjalëkalimi, //p
           "--pikë tërheqje izocash": Tërheqje pikësh izocash,
           "--tërheqjet e pikëve": Tërheqjet e pikëve,
           "--mundësisht, përdorni një vpn": Mundësisht, përdorni një VPN që nuk i përket ofruesit tuaj të shërbimit të internetit,
           "--Këmbëngulja gjithmonë shpërblehet": Këmbëngulja gjithmonë shpërblehet në fund,
           "--rule": Rregullat, //r
           "--rekomandim": Rekomandime,
           "--registration": Regjistrim,
           "--regjistrohu në veil brilliant": Regjistrohu në Veil Brillant, //s
           "--Regjistrohu në dyqanin vixinol": Regjistrohu në Dyqanin Vixinol,
           "--regjistrimi": Regjistrohu,
           "--suksesi i regjistrimit": Regjistrimi i suksesshëm!,
           "--Regjistrohu falas": Regjistrohu falas,
           “--suksesi i regjistrimit IA”: Lidhja e suksesshme”,
           "--settings": "Cilësimet",
           "--konfigurimi i aplikacionit alrani": Konfigurimi i aplikacionit Alrani,
           "--konfigurimi i aplikacionit izocash": Konfigurimi i aplikacionit izocash,
           "--konfigurimi i aplikacionit vixinol": Konfigurimi i aplikacionit Vixinol,
           "--konfigurimi i aplikacionit Veil Brillant": Konfigurimi i aplikacionit Veil Brillant,
           "--ruajtja e imazheve, videove": Ruajtja e imazheve, videove dhe disa elementeve të tjera,
           "--shpejtësia e marrjes": Shpejtësia e marrjes së të dhënave nga Qendra e të Dhënave,
           "--shpejtësi": Shpejtësia,
           "--përfundoj": Përfundoj, //t
           "--vpn ju lejon të aksesoni": VPN ju lejon të përdorni një sajt ose një aplikacion që ofruesi juaj i shërbimit të internetit e ka vendosur në listën e zezë,
           "--pema më e madhe ishte lart": Pema më e madhe ishte mbi të gjitha një farë e thjeshtë e vogël,
           "--prekni ekranin": Prekni ekranin për të vazhduar,
           "--provo përsëri": Provo përsëri!,
           "--username": Emri i përdoruesit, //u

           "--virtual number": Numri virtual, //v
           "--Cilësimet e telefonit virtual": Cilësimet e telefonit virtual,
           "--Zbatohet gjuha virtuale e telefonit": Gjuha e telefonit virtual aplikohet në nivelin e aplikacionit si parazgjedhje,
           "--telefon virtual": Telefon virtual,
           "--validate": Vërteto,
           "--mirë se erdhët në portalin e klientëve izocash": Mirë se vini në Portalin e Klientëve izocash, //w
           "--shkruaj një kod super": Fut një kod super,
           "--welcome to": Mirë se vini në,
           "--ku shkon vëmendja e njerëzve": Aty ku shkon vëmendja e njerëzve shkojnë paratë,
           "--winners persevere": Fituesit këmbëngulin,
           "--do të dëshironit të dilni nga llogaria juaj Alrani": Dëshironi të dilni nga llogaria juaj Alrani?,
           "--po": Po, //y

           // vend
           "--congo": Congo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--IvoryCoast": Bregu i Fildishtë,

          // langue
          "--afrikaans": "Afrikane", //a
          "--albanian": "Shqiptare",
          "--amharic": "Amharike",
          "--arabic": "Arabisht",
          "--armenian": "Armene",
          "--assamese": "Asamez",
          "--aymara": "Aymara",
          "--azerbaijani": "Azerbajxhani",
          "--bambara": "Bambara", //b
          "--basque": "Bask",
          "--belarusian": "Bjellorusisht",
          "--bengali": "Bengalisht",
          "--bhojpuri": "Bhojpuri",
          "--bosnian": "Boshnjake",
          "--bulgarian": "Bullgare",
          "--catalan": "Katalanas", //c
          "--cebuano": "Cebuano",
          "--chichewa": "Çiçeva",
          "--chineseSimplified": "Kineze (e Thjeshtuar)",
          "--chineseTraditional": "Kineze (e Tradita)",
          "--corsican": "Korsikane",
          "--croatian": "Kroate",
          "--czech": "Çeke",
          "--danish": "Daneze", //d
          "--dhivehi": "Dhivehi",
          "--dogri": "Dogri",
          "--dutch": "Holandeze",
          "--english": "Anglisht", //e
          "--esperanto": "Esperanto",
          "--estonian": "Estoneze",
          "--ewe": "Dele",
          "--filipino": "Filipinase", //f
          "--finnish": "Finlandez",
          "--french": "Frëngjisht",
          "--frisian": "Frizianisht",
          "--galician": "Galician", //g
          "--georgian": "Gjeorgjiane",
          "--german": "Gjermane",
          "--greek": "Greke",
          "--guarani": "Guarani",
          "--gujarati": "Guxharatisht",
          "--haitianCreole": "Kreole Haitiane", //h
          "--hausa": "Hausa",
          "--hawaiian": "Havajane",
          "--hebrew": "Hebraishtja",
          "--hindi": "Hindi",
          "--hmong": "Hmong",
          "--hungarian": "Hungareze",
          "--icelandic": "Islandeze", //i
          "--igbo": "Igbo",
          "--ilocano": "Ilocano",
          "--indonesian": "Indonezisht",
          "--irish": "Irlandez",
          "--italian": "Italisht",
          "--japanese": "Japoneze", //j
          "--javanese": "Javaneze",
          "--kannada": "Kanadeze", //k
          "--kazakh": "Kazake",
          "--khmer": "Khmer",
          "--kinyarwanda": "Kinyarwanda",
          "--konkani": "Konkani",
          "--korean": "Koreane",
          "--krio": "Krio",
          "--kurdishKurmanji": "Kurde (Kurmanji)",
          "--kurdishSorani": "Kurde (sorani)",
          "--kyrgyz": "Kirgize",
          "--lao": "Lao", //l
          "--latin": "Latinisht",
          "--latvian": "Letonisht",
          "--lingala": "Lingala",
          "--lithuanian": "Lituanisht",
          "--luganda": "Luganda",
          "--luxembourgish": "Luksemburgase",
          "--macedonian": "Maqedonase", //m
          "--maithili": "Maithili",
          "--malagasy": "Malagazi",
          "--malay": "Malay",
          "--malayalam": "Malajalamisht",
          "--maltese": "Malteze",
          "--maori": "Maori",
          "--marathi": "Marathi",
          "--meiteilonManipuri": "Meiteilon (Manipuri)",
          "--mizo": "Mizo",
          "--mongolian": "Mongolisht",
          "--myanmarBurmese": "Myanmar (Burmanisht)",
          "--nepali": "Nepalisht", //n
          "--norwegian": "Norvegjeze",
          "--odiaOriya": "Odia (Oriya)", //o
          "--oromo": "Oromo",
          "--pashto": "Pashto", //p
          "--persian": "Persisht",
          "--polish": "Polonisht",
          "--portuguese": "Portugeze",
          "--punjabi": "Punjabi",
          "--quechua": "Keçua", //q
          "--romanian": "Rumun", //r
          "--russian": "Ruse",
          "--samoan": "Samoan", //s
          "--sanskrit": "Sanskritishtja",
          "--scotsGaelic": "Gaelishte skoceze",
          "--sepedi": "Sepedi",
          "--serbian": "Serb",
          "--sesotho": "Sesoto",
          "--shona": "Shona",
          "--sindhi": "Sindhi",
          "--sinhala": "Sinhalisht",
          "--slovak": "Sllovake",
          "--slovenian": "Slloven",
          "--somali": "Somalez",
          "--spanish": "Spanjisht",
          "--sundanese": "Sundanez",
          "--swahili": "Suahili",
          "--swedish": "Suedeze",
          "--tajik": "Taxhikisht", //t
          "--tamil": "Tamile",
          "--tatar": "Tatar",
          "--telugu": "Telugu",
          "--thai": "Thai",
          "--tigrinya": "Tigrinja",
          "--tsonga": "Tsonga",
          "--turkish": "Turk",
          "--turkmen": "Turkmen",
          "--twi": "Twi",
          "--ukrainian": "Ukrainase", //u
          "--urdu": "Urdu",
          "--uyghur": "Ujgure",
          "--uzbek": "Uzbekistani",
          "--vietnamese": "Vietnameze", //v
          "--welsh": "Uellsisht", //w
          "--xhosa": "Xhosa", //x
          "--yiddish": "Jidish", //y
          "--yoruba": "Jorubisht",
          "--zulu": "Zulu", //z
        },
      },*/

      // **amharic
      // **amharic
      amharic: {
        translations: {
           "--an error has occurred": "ስህተት ተከስቷል!", //a
           "--address": "አድራሻዎች",
           "--advice": "ምክር",
           "--by clicking on continue": "ቀጥልን ጠቅ በማድረግ ከቪል ብሪላንት መለያዎ ይቋረጣሉ፣", //b
           "--by clicking on disconnect you will be disconnected": "አቋርጥ የሚለውን ጠቅ በማድረግ ከ izocash መለያዎ ይቋረጣሉ።",
           "--check your virtual number or try again later": "ምናባዊ ቁጥርዎን ያረጋግጡ ወይም ቆይተው እንደገና ይሞክሩ፣", //c
           "--check your virtual number": "የእርስዎን ምናባዊ ቁጥር ያረጋግጡ",
           "--continue": "ቀጥል",
           "--connection": "ግንኙነት",
           "--collaborate, live in harmony": "ተባበሩ፣ ከሌሎች ጋር ተስማምተው መኖር፣",
           "--don't prevent competition": "ውድድርን አትከልክሉ፣ ለሁሉም ዕድል ስጡ፣", //e
           "--disconnection": "ግንኙነት ማቋረጥ",
           "--for all virtual phone users": "ለሁሉም የቨርቹዋል ስልክ ተጠቃሚዎች ቪፒኤን እንዲጠቀሙ ይመከራል፣", //f
           "--go to login page": "ወደ የመግቢያ ገጹ ሂድ", //g
           "--historical": "ታሪካዊ", // h
           "--i have account": "አስቀድሞ መለያ አለኝ፣", //i
           "--i don't have account": "መለያ የለኝም",
           "--it is your house": "ቤትህ ነው",
           "--image / video +": "ምስል / ቪዲዮ +",
           "--identity verification": "የማንነት ማረጋገጫ፣",
           "--izocash customer portal": "izocash የደንበኛ ፖርታል",
           "--identity update every year": "የማንነት ማሻሻያ በየአመቱ፣",
           "--izocash buy to": "izocash Buy => አይዞካሽ አለምአቀፍ፣",
           "--log in": "ግባ!", //l
           "--login": "ግባ",
           "--login to veil brillant": "ከ Veil Brillant ጋር ይገናኙ",
           "--login to vixinol store": "ወደ Vixinol መደብር ይገናኙ",
           "--login for free to your veil brillant account": "ይህንን ባህሪ ለማግኘት ወደ እርስዎ የ Veil Brillant መለያ በነፃ ይግቡ ፣",
           "--login success": "መግባት ተሳክቷል!",
           "--login now": "አሁን ግባ!",
           "--logout success": "መውጣት ተሳክቷል!",
           "--log out": "ውጣ፣",
           "--logout": "ውጣ፣",
           "--number": "ቁጥር", //n
           "--name": "ስም",
           "--now log in": "አሁን, ግባ!",
           "--no ban on stifling competition": "ውድድርን ማፈን አይከለከልም",
           "--no jealousy, no hatred": "ቅናት የለም፣ ጥላቻ የለም፣ መለያየት የለም፣",
           "--no": "አይደለም",
           "--official addresses to access your virtual phone": "ምናባዊ ስልክዎን ለመድረስ ኦፊሴላዊ አድራሻዎች፣", //o
           "--password": "የይለፍ ቃል፣", //p
           "--points withdrawals izocash": "ነጥቦች withdrawals izocash",
           "--points withdrawals": "የነጥብ መውጣቶች፣",
           "--preferably, use a vpn": "በተሻለ ሁኔታ የበይነመረብ አገልግሎት አቅራቢዎ ያልሆነውን ቪፒኤን ይጠቀሙ፣",
           "--persistence always pays off": "ፅናት ሁል ጊዜም መጨረሻ ላይ ዋጋ ያስከፍላል።",
           "--rule": "ደንቦች", //r
           "--recommendation": "ምክሮች",
           "--registration": "ምዝገባ",
           "--signup to veil brillant": "በ Veil Brillant ላይ ይመዝገቡ", //s
           "--signup to vixinol store": "በ Vixinol መደብር ላይ ይመዝገቡ",
           "--signup": "ይመዝገቡ",
           "--signup success": "ምዝገባው ተሳክቷል!",
           "--signup for free": "በነጻ ይመዝገቡ",
           "--signup success IA": "ግንኙነት ተሳክቷል፣",
           "--settings": "ቅንጅቶች",
           "--setting up the alrani app": "የአልራኒ መተግበሪያን በማዋቀር ላይ",
           "--setting up the izocash app": "የ izocash መተግበሪያን በማዋቀር ላይ",
           "--setting up the vixinol app": "የቪክሲኖል መተግበሪያን በማዋቀር ላይ፣",
           "--setting up the veil brillant app": "የመጋረጃ ብሪላንት መተግበሪያን በማዋቀር ላይ፣",
           "--storage of images, videos": "የምስሎች፣ ቪዲዮዎች እና ሌሎች በርካታ አካላት ማከማቻ፣",
           "--speed of reception": "ከዳታ ሴንተር የመቀበል ፍጥነት",
           "--speed": "ፍጥነት",
           "--terminate": "አቋርጥ፣", //t
           "--the vpn allows you to access": "ቪፒኤን የኢንተርኔት አገልግሎት አቅራቢዎ በጥቁር መዝገብ ውስጥ ያስቀመጠውን ጣቢያ ወይም አፕሊኬሽን እንዲገቡ ይፈቅድልዎታል።",
           "--the largest tree was above": "ትልቁ ዛፍ ከሁሉም በላይ ቀላል የሆነ ትንሽ ዘር ነበር.",
           "--touch the screen": "ለመቀጠል ስክሪኑን ይንኩ።",
           "--try again": "እንደገና ይሞክሩ!",
           "--username": "የተጠቃሚ ስም", // u

           "--virtual number": "ምናባዊ ቁጥር፣", //v
           "--virtual phone": "ምናባዊ ስልክ",
           "--virtual phone settings": "ምናባዊ የስልክ ቅንብሮች",
           "--virtual phone language is applied": "የቨርቹዋል ስልክ ቋንቋ በነባሪነት በመተግበሪያ ደረጃ ይተገበራል፣",
           "--validate": "አረጋግጥ",
           "--welcome to the izocash customer portal": "እንኳን ወደ izocash የደንበኞች ፖርታል በደህና መጡ፣", //w
           "--write a super code": "ሱፐር ኮድ አስገባ፣",
           "--welcome to": "እንኳን ደህና መጣህ",
           "--where people's attention goes": "የሰዎች ትኩረት የሚሄድበት ገንዘብ",
           "--winners persevere": "አሸናፊዎቹ በጽናት",
           "--would you like to log out of your Alrani account": "ከአልራኒ መለያህ መውጣት ትፈልጋለህ?፣",
           "--yes": "አዎ", //y

           // pays
           "--congo": "ኮንጎ ብራዛቪል፣",
           "--cameroon": "ካሜሩን",
           "--drc": "DRC",
           "--ivoryCoast": "አይቮሪ ኮስት",

          // langue
          "--afrikaans": "አፍሪካንስ", //a
          "--albanian": "አልበንያኛ",
          "--amharic": "አማርኛ",
          "--arabic": "አረብኛ",
          "--armenian": "አርመንያኛ",
          "--assamese": "አሳሜሴ",
          "--aymara": "አይማራ",
          "--azerbaijani": "አዘርባጃኒ",
          "--bambara": "ባምባራ", //b
          "--basque": "ባስክ",
          "--belarusian": "ቤላሩሲያን",
          "--bengali": "ቤንጋሊ",
          "--bhojpuri": "Bhojpuri",
          "--bosnian": "ቦስንያን",
          "--bulgarian": "ቡልጋርያኛ",
          "--catalan": "ካታሊያን", //c
          "--cebuano": "ሴቡአኖ",
          "--chichewa": "ቺቼዋ",
          "--chineseSimplified": "ቻይንኛ (ቀላል)",
          "--chineseTraditional": "ቻይንኛ (ባህላዊ)",
          "--corsican": "ኮርሲካን",
          "--croatian": "ክሮኤሽያን",
          "--czech": "ቼክ",
          "--danish": "ዳኒሽ", //d
          "--dhivehi": "ዲቪሂ",
          "--dogri": "ዶግሪ",
          "--dutch": "ደች",
          "--english": "እንግሊዝኛ", //e
          "--esperanto": "እስፔራንቶ",
          "--estonian": "ኢስቶኒያን",
          "--ewe": "ኢዩ",
          "--filipino": "ፊሊፒኖ", //f
          "--finnish": "ፊኒሽ",
          "--french": "ፈረንሳይኛ",
          "--frisian": "ፍሪሲያን",
          "--galician": "ጋላሺያን", //g
          "--georgian": "ጆርጅያን",
          "--german": "ጀርመንኛ",
          "--greek": "ግሪክኛ",
          "--guarani": "ጉአራኒ",
          "--gujarati": "ጉጅራቲ",
          "--haitianCreole": "ሓይቲያን ክሬኦሌ", //h
          "--hausa": "ሃውሳ",
          "--hawaiian": "ሐዋያን",
          "--hebrew": "ሂብሩ",
          "--hindi": "ሂንዲ",
          "--hmong": "ሕሞንግ",
          "--hungarian": "ሃንጋሪያን",
          "--icelandic": "አይስላንዲ ክ", //i
          "--igbo": "ኢግቦ",
          "--ilocano": "ኢሎካኖ",
          "--indonesian": "ኢንዶኔዥያን",
          "--irish": "አይሪሽ",
          "--italian": "ጣሊያንኛ",
          "--japanese": "ጃፓንኛ", //j
          "--javanese": "ጃቫኒስ",
          "--kannada": "ካናዳ", //k
          "--kazakh": "ካዛክሀ",
          "--khmer": "ክመር",
          "--kinyarwanda": "ኪንያርዋንዳ",
          "--konkani": "ኮንካኒ",
          "--korean": "ኮሪያኛ",
          "--krio": "ክሪዮ",
          "--kurdishKurmanji": "ኩርድኛ (ኩርማንጂ)",
          "--kurdishSorani": "ኩርድኛ (ሶራኒ)",
          "--kyrgyz": "ክይርግያዝ",
          "--lao": "ላኦ", //l
          "--latin": "ላቲን",
          "--latvian": "ላትቪያን",
          "--lingala": "ሊንጋላ",
          "--lithuanian": "ሊቱኒያን",
          "--luganda": "ሉጋንዳ",
          "--luxembourgish": "ሉክዜምብርጊሽ",
          "--macedonian": "ማስዶንያን", //m
          "--maithili": "ማይቲሊ",
          "--malagasy": "ማላጋሲ",
          "--malay": "ማላይ",
          "--malayalam": "ማላያላም",
          "--maltese": "ማልትስ",
          "--maori": "ማኦሪይ",
          "--marathi": "ማራቲ",
          "--meiteilonManipuri": "ሜይቴሎን (ማኒፑሪ)",
          "--mizo": "ሚዞ",
          "--mongolian": "ሞኒጎሊያን",
          "--myanmarBurmese": "ምያንማር (በርማኛ)",
          "--nepali": "ኔፓሊ", //n
          "--norwegian": "ኖርወይኛ",
          "--odiaOriya": "ኦዲያ (ኦሪያ)", //o
          "--oromo": "ኦሮሞ",
          "--pashto": "ፓሽቶ", //p
          "--persian": "ፐርሽያን",
          "--polish": "ፖሊሽ",
          "--portuguese": "ፖርቹጋልኛ",
          "--punjabi": "ፑንጃቢ",
          "--quechua": "Quechua", //q
          "--romanian": "ሮማንያን", //r
          "--russian": "ራሺያኛ",
          "--samoan": "ሳሞአን", //s
          "--sanskrit": "ሳንስክሪት",
          "--scotsGaelic": "ስኮትስ ጌሊክ",
          "--sepedi": "ሰፔዲ",
          "--serbian": "ሰሪቢያን",
          "--sesotho": "ሰሶቶ",
          "--shona": "ሾና",
          "--sindhi": "ስንድሂ",
          "--sinhala": "ሲንሃላ",
          "--slovak": "ስሎቫክ",
          "--slovenian": "ስሎቬንያን",
          "--somali": "ሶማሊ",
          "--spanish": "ስፓንኛ",
          "--sundanese": "ሱዳናዊ",
          "--swahili": "ስዋሕሊ",
          "--swedish": "ስዊድንኛ",
          "--tajik": "ታጂክ", //t
          "--tamil": "ታሚል",
          "--tatar": "ታታር",
          "--telugu": "ተሉጉ",
          "--thai": "ታይ",
          "--tigrinya": "ትግርኛ",
          "--tsonga": "ጾንጋ",
          "--turkish": "ቱሪክሽ",
          "--turkmen": "ቱሪክሜን",
          "--twi": "Twi",
          "--ukrainian": "ዩክሬንያን", //u
          "--urdu": "ኡርዱ",
          "--uyghur": "ኡይግሁር",
          "--uzbek": "ኡዝቤክ",
          "--vietnamese": "ቪትናሜሴ", //v
          "--welsh": "ዋልሽ", //w
          "--xhosa": "ዛይሆሳ", //x
          "--yiddish": "ዪዲሽ", //y
          "--yoruba": "ዮሩባ",
          "--zulu": "ዙሉ", //z
        },
      },

      // **arabic
      // **arabic
      arabic: {
        translations: {
           "--an error has occurred": "حدث خطأ!،", //a
           "--address": "العناوين،",
           "--advice": "النصيحة،",
           "--by clicking on continue": "بالنقر على سيتم قطع اتصالك بحساب Veil Brillant الخاص بك،", //b
           "--by clicking on disconnect you will be disconnected": "بالنقر على قطع الاتصال، سيتم قطع الاتصال بحساب izocash الخاص بك،",
           "--check your virtual number or try again later": "تحقق من رقمك الافتراضي أو حاول مرة أخرى لاحقًا،", //c
           "--check your virtual number": "تحقق من رقمك الافتراضي،",
           "--continue": "متابعة،",
           "--connection": "اتصال،",
           "--collaborate, live in harmony": "التعاون، والعيش في وئام مع الآخرين،",
           "--don't prevent competition": "لا تمنع المنافسة، أعط الفرصة للجميع، ", //d
           "--disconnection": "قطع الاتصال،",
           "--for all virtual phone users": "لجميع مستخدمي الهاتف الظاهري، يوصى باستخدام VPN،", //f
           "--go to login page": "انتقل إلى صفحة تسجيل الدخول،", //g
           "--historical": "تاريخي،", //h
           "--i have account": "لدي حساب بالفعل،", //i
           "--i don't have account":" ليس لدي حساب،",
           "--it is your house": "إنه منزلك،",
           "--image / video +": "صورة / فيديو +،",
           "--identity verification": "التحقق من الهوية،",
           "--izocash customer portal": "بوابة عملاء izocash،",
           "--identity update every year": "تحديث الهوية كل عام،",
           "--if you have not registered": "إذا لم تكن مسجلا، يمكنك البدء في التسجيل الخاص بك",
           "--izocash buy to": "شراء izocash => izocash الدولية،",
           "--log in": "تسجيل الدخول!،", //l
           "--login": "دخول",
           "--login to veil brillant": "الاتصال بـ Veil Brillant",
           "--login to vixinol store": "اتصل بمتجر فيكسينول",
           "--login for free to your veil brillant account": "قم بتسجيل الدخول مجانًا إلى حساب Veil Brillant الخاص بك للوصول إلى هذه الميزة،",
           "--login success": "تم تسجيل الدخول بنجاح!,",
           "--login now": "سجل الدخول الآن!,",
           "--logout Success": "تم تسجيل الخروج بنجاح!,",
           "--log out": "تسجيل الخروج،",
           "--logout": "تسجيل الخروج،",
           "--number": "الرقم،", //n
           "--name": "اسم",
           "--now log in": "الآن، قم بتسجيل الدخول!",
           "--no ban on stifling competition": "لا يوجد حظر على خنق المنافسة",
           "--no jealousy, no hatred": "لا غيرة ولا كراهية ولا انقسامات،",
           "--no": "لا",
           "--official addresses to access your virtual phone": "العناوين الرسمية للوصول إلى هاتفك الافتراضي،", //o
           "--password": "كلمة المرور،", //p
           "--points withdrawals izocash": "سحب النقاط izocash،",
           "--points withdrawals": "سحب النقاط،",
           "--preferably, use a vpn": "يفضل استخدام VPN لا ينتمي إلى مزود خدمة الإنترنت الخاص بك،",
           "--persistence always pays off": "المثابرة تؤتي ثمارها دائمًا في النهاية،",
           "--please, check your virtual number": "من فضلك، تحقق من رقمك الافتراضي",
           "--please, try again later": "الرجاء معاودة المحاولة في وقت لاحق !",
           "--platform 1 for virtual applications": "المنصة رقم 1 للتطبيقات الافتراضية",
           "--rule": "القواعد،", //r
           "--recommendation": "التوصيات،",
           "--registration": "التسجيل،",
           "--signup to veil brillant": "قم بالتسجيل في Veil Brillant,", //s
           "--signup to vixinol store": "قم بالتسجيل في متجر فيكسينول،",
           "--signup": "التسجيل،",
           "--signup success": "تم التسجيل بنجاح!",
           "--signup for free": "سجل مجانًا",
           "--signup success IA": "الاتصال ناجح",
           "--settings": "الإعدادات",
           "--setting up the alrani app": "تكوين تطبيق الراني،",
           "--setting up the izocash app": "تكوين تطبيق izocash،",
           "--setting up the vixinol app": "تكوين تطبيق Vixinol،",
           "--setting up the veil brillant app": "تكوين تطبيق Veil Brillant،",
           "--storage of images, videos": "تخزين الصور ومقاطع الفيديو والعديد من العناصر الأخرى،",
           "--speed of reception": "سرعة استقبال البيانات من مركز البيانات،",
           "--speed": "السرعة،",
           "--terminate": "إنهاء،", //t
           "--the vpn allows you to access": "يسمح لك VPN بالوصول إلى موقع أو تطبيق قام مزود خدمة الإنترنت الخاص بك بإدراجه في القائمة السوداء،",
           "--the largest tree was above": "كانت الشجرة الأكبر قبل كل شيء بذرة صغيرة بسيطة،",
           "--touch the screen": "المس الشاشة للمتابعة،",
           "--try again": "حاول مرة أخرى!,",
           "--username": "اسم المستخدم،", //u
           "--virtual number": "الرقم الظاهري،", //v
           "--virtual phone": "الهاتف الافتراضي،",
           "--virtual phone settings": "إعدادات الهاتف الافتراضية،",
           "--virtual phone language": "لغة الهاتف الافتراضية،",
           "--virtual phone language is applied": "يتم تطبيق لغة الهاتف الظاهري على مستوى التطبيق بشكل افتراضي،",
           "--validate": "التحقق من الصحة،",
           "--welcome to the izocash customer portal": "مرحبًا بك في بوابة عملاء izocash،", //w
           "--write a super code": "أدخل رمزًا فائقًا،",
           "--welcome to": "مرحبًا بك،",
           "--where people's attention goes": "حيث يذهب انتباه الناس يذهب المال،",
           "--winners persevere": "الفائزون يثابرون",
           "--would you like to log out of your Alrani account": "هل تريد تسجيل الخروج من حساب الراني الخاص بك؟,",
           "--yes": "نعم،", //y

           // country
           "--congo": "الكونغو برازافيل،",
           "--cameroon": "الكاميرون،",
           "--drc": "جمهورية الكونغو الديمقراطية،",
           "--ivoryCoast": "ساحل العاج،",

          // langue
          "--afrikaans": "الأفريكانية", //a
          "--albanian": "الألبانية",
          "--amharic": "الأمهرية",
          "--arabic": "عربي",
          "--armenian": "الأرمنية",
          "--assamese": "الأسامية",
          "--aymara": "ايمارا",
          "--azerbaijani": "أذربيجان",
          "--bambara": "بامبارا", //b
          "--basque": "لغة الباسك",
          "--belarusian": "البيلاروسية",
          "--bengali": "البنغالية",
          "--bhojpuri": "البهوجبرية",
          "--bosnian": "بوسني",
          "--bulgarian": "البلغارية",
          "--catalan": "الكاتالونية", //c
          "--cebuano": "السيبيونو",
          "--chichewa": "تشيشيوا",
          "--chineseSimplified": "الصينية المبسطة",
          "--chineseTraditional": "تقاليد صينية",
          "--corsican": "كورسيكان",
          "--croatian": "الكرواتي",
          "--czech": "التشيكية",
          "--danish": "دانماركي", //d
          "--dhivehi": "Dhivehi",
          "--dogri": "دوجري",
          "--dutch": "هولندي",
          "--english": "إنجليزي", //e
          "--esperanto": "الاسبرانتو",
          "--estonian": "الإستونية",
          "--ewe": "نعجة",
          "--filipino": "الفلبينية", //f
          "--finnish": "الفنلندية",
          "--french": "فرنسي",
          "--frisian": "الفريزية",
          "--galician": "الجاليكية", //g
          "--georgian": "الجورجية",
          "--german": "ألمانية",
          "--greek": "اليونانية",
          "--guarani": "غواراني",
          "--gujarati": "الغوجاراتية",
          "--haitianCreole": "الكريولية الهايتية", //h
          "--hausa": "الهوسا",
          "--hawaiian": "هاواي",
          "--hebrew": "اللغة العبرية",
          "--hindi": "الهندية",
          "--hmong": "همونغ",
          "--hungarian": "الهنغارية",
          "--icelandic": "الأيسلندية", //i
          "--igbo": "الإيغبو",
          "--ilocano": "Ilocano",
          "--indonesian": "الأندونيسية",
          "--irish": "الأيرلندية",
          "--italian": "ايطالي",
          "--japanese": "اليابانية", //j
          "--javanese": "الجاوية",
          "--kannada": "الكانادا", //k
          "--kazakh": "الكازاخستانية",
          "--khmer": "الخمير",
          "--kinyarwanda": "كينيارواندا",
          "--konkani": "الكونكاني",
          "--korean": "الكورية",
          "--krio": "كريو",
          "--kurdishKurmanji": "الكردية (الكرمانجية)",
          "--kurdishSorani": "الكردية (السورانية)",
          "--kyrgyz": "قيرغيزستان",
          "--lao": "لاو", //l
          "--latin": "اللاتينية",
          "--latvian": "لاتفيا",
          "--lingala": "لينجالا",
          "--lithuanian": "الليتوانية",
          "--luganda": "لوغاندا",
          "--luxembourgish": "لوكسمبورغ",
          "--macedonian": "المقدونية", //m
          "--maithili": "مايثيلي",
          "--malagasy": "مدغشقر",
          "--malay": "لغة الملايو",
          "--malayalam": "المالايالامية",
          "--maltese": "المالطية",
          "--maori": "الماوري",
          "--marathi": "المهاراتية",
          "--meiteilonManipuri": "ميتيلون (مانيبوري)",
          "--mizo": "ميزو",
          "--mongolian": "المنغولية",
          "--myanmarBurmese": "ميانمار (البورمية)",
          "--nepali": "النيبالية", //n
          "--norwegian": "النرويجية",
          "--odiaOriya": "أوديا (الأوريا)", //o
          "--oromo": "الأورومو",
          "--pashto": "الباشتو", //p
          "--persian": "اللغة الفارسية",
          "--polish": "تلميع",
          "--portuguese": "البرتغالية",
          "--punjabi": "البنجابية",
          "--quechua": "الكيشوا", //q
          "--romanian": "روماني", //r
          "--russian": "الروسية",
          "--samoan": "ساموا", //s
          "--sanskrit": "السنسكريتية",
          "--scotsGaelic": "الغيلية الاسكتلندية",
          "--sepedi": "سيبيدي",
          "--serbian": "الصربية",
          "--sesotho": "سيسوتو",
          "--shona": "شونا",
          "--sindhi": "السندية",
          "--sinhala": "السنهالية",
          "--slovak": "السلوفاكية",
          "--slovenian": "السلوفينية",
          "--somali": "الصومالية",
          "--spanish": "الأسبانية",
          "--sundanese": "السندانية",
          "--swahili": "السواحلية",
          "--swedish": "السويدية",
          "--tajik": "الطاجيكية", //t
          "--tamil": "التاميل",
          "--tatar": "التتار",
          "--telugu": "التيلجو",
          "--thai": "التايلاندية",
          "--tigrinya": "التغرينية",
          "--tsonga": "تسونجا",
          "--turkish": "اللغة التركية",
          "--turkmen": "التركمان",
          "--twi": "Twi",
          "--ukrainian": "الأوكرانية", //u
          "--urdu": "الأردية",
          "--uyghur": "الويغور",
          "--uzbek": "الأوزبكية",
          "--vietnamese": "الفيتنامي", //v
          "--welsh": "تهرب من دفع الرهان", //w
          "--xhosa": "Xhosa", //x
          "--yiddish": "اليديشية", //y
          "--yoruba": "اليوروبا",
          "--zulu": "الزولو", //z
        },
      },

      // armenian
      // armenian
     /*
      armenian: {
        translations: {
          «--սխալ է տեղի ունեցել»: Սխալ է տեղի ունեցել!, //a
           «--հասցե»: Հասցեներ,
           «--խորհուրդ»: Խորհուրդ,
           «--սեղմելով շարունակել»: Սեղմելով շարունակել, դուք կանջատվեք ձեր Veil Brillant հաշվից, //b
           «--սեղմելով անջատման վրա՝ դուք կանջատվեք»: Սեղմելով Անջատել՝ դուք կկապվեք ձեր izocash հաշվից,
           «--ստուգեք ձեր վիրտուալ համարը կամ փորձեք ավելի ուշ»: Ստուգեք ձեր վիրտուալ համարը կամ փորձեք ավելի ուշ, //c
           «--ստուգեք ձեր վիրտուալ համարը»: Ստուգեք ձեր վիրտուալ համարը,
           «--շարունակել»: Շարունակել,
           «--միացում»: Միացում,
           «--համագործակցել, ապրել ներդաշնակության մեջ»: Համագործակցել, ապրել ներդաշնակորեն ուրիշների հետ,
           «--ընտրել լեզուն»: Վիրտուալ հեռախոսի լեզու,
           «--մի կանխիր մրցակցությունը»՝ Մի՛ կանխիր մրցակցությունը, բոլորին հնարավորություն տուր, //դ
           «--անջատում»: Անջատում,
           «--բոլոր վիրտուալ հեռախոսի օգտագործողների համար». Վիրտուալ հեռախոսի բոլոր օգտագործողների համար խորհուրդ է տրվում օգտագործել VPN, //f
           «--go to login page»: Գնալ դեպի մուտքի էջ, //g
           «--պատմական»՝ Պատմական, //հ
           «--i have account»: Ես արդեն ունեմ հաշիվ, //i
           «--Ես հաշիվ չունեմ»: Ես հաշիվ չունեմ,
           «--դա քո տունն է»: դա քո տունն է,
           «--պատկեր / վիդեո +»: Պատկեր / Վիդեո +,
           «--ինքնության ստուգում»՝ ինքնության ստուգում,
           «--izocash հաճախորդների պորտալ»: izocash Հաճախորդների պորտալ,
           «--ինքնության թարմացում ամեն տարի»: Ինքնության թարմացում ամեն տարի,
           «--izocash buy to»: izocash Գնել => izocash միջազգային,
           «--log in»: Մուտք գործեք!, //l
           «--login»: Մուտք գործեք,
           «--login to veil brilliant»: Միացեք Veil Brillant-ին,
           «--մուտք vixinol խանութ»: Միացեք Vixinol Store-ին,
           «--անվճար մուտք գործեք ձեր veil Brillant հաշիվ»: Մուտք գործեք անվճար ձեր Veil Brillant հաշիվ՝ այս հատկությունը մուտք գործելու համար,
           «--login success»: Մուտքը հաջող է,
           «--login now»: Մուտք գործեք հիմա:
           «--logout success»: Դուրս գալը հաջող է,
           «--log out»: Դուրս գալ,
           «--logout»: Դուրս գալ,
           «--համար»: Համար, //n
           "--name": Անուն,
           «--այժմ մուտք գործեք»: Այժմ, Մուտք գործեք:
           «--մրցակցությունը խեղդելու արգելք չկա».
           «--ոչ նախանձ, ոչ ատելություն»: Ոչ նախանձ, ոչ ատելություն, ոչ բաժանում,
           "--ոչ ոչ,
           «--պաշտոնական հասցեներ՝ ձեր վիրտուալ հեռախոս մուտք գործելու համար»: Պաշտոնական հասցեներ՝ ձեր վիրտուալ հեռախոս մուտք գործելու համար, //o
           «--password»: Գաղտնաբառ, //p
           «--միավորների դուրսբերում izocash»: Միավորների դուրսբերում izocash,
           «--միավորների դուրսբերում»: Միավորների դուրսբերում,
           «--ցանկալի է, օգտագործել vpn»: Ցանկալի է, օգտագործել VPN, որը չի պատկանում ձեր ինտերնետային ծառայության մատակարարին,
           «--Հաստատակամությունը միշտ արդյունք է տալիս»: Համառությունը միշտ ի վերջո արդյունք է տալիս,
           «--կանոն»: Կանոններ, //r
           «--առաջարկություն»: Առաջարկություններ,
           «--գրանցում»՝ գրանցում,
           «--գրանցվել veil brilliant»-ում. Գրանցվել Veil Brillant-ում, //s
           «--գրանցվել vixinol խանութում». Գրանցվել Vixinol Store-ում,
           «--գրանցում»: Գրանցվել,
           «--գրանցման հաջողություն». գրանցումը հաջող է,
           «-- Գրանցվել անվճար»: Գրանցվել անվճար,
           «--գրանցման հաջողություն IA»: Կապը հաջող է»,
           "--settings": "Settings",
           «--կարգավորել alrani հավելվածը»: Alrani հավելվածի կազմաձևում,
           «-- izocash հավելվածի կարգավորում»: izocash հավելվածի կարգավորում,
           «-- seting the vixinol հավելվածը»: Vixinol հավելվածի կարգավորում,
           «-- veil Brillant հավելվածի կարգավորում». Veil Brillant հավելվածի կարգավորում,
           «--պատկերների, տեսանյութերի պահպանում»՝ պատկերների, տեսանյութերի և մի շարք այլ տարրերի պահպանում,
           «--ընդունման արագություն». Տվյալների կենտրոնից տվյալների ընդունման արագություն,
           «--արագություն»: Արագություն,
           «--terminate»: Վերջացնել, //t
           «-- vpn-ը թույլ է տալիս մուտք գործել»: VPN-ը թույլ է տալիս մուտք գործել կայք կամ հավելված, որը ձեր ինտերնետային ծառայության մատակարարը ներառել է սև ցուցակում,
           «- Ամենամեծ ծառը վերևում էր»: Ամենամեծ ծառը ամենից առաջ պարզ փոքրիկ սերմ էր,
           «--touch the screen»: Շարունակելու համար հպեք էկրանին,
           «--փորձիր նորից»: Նորից փորձիր,
           «--username»: Մականուն, //u

           «--վիրտուալ համար»՝ վիրտուալ համար, //v
           «--վիրտուալ հեռախոսի կարգավորումներ»: Վիրտուալ հեռախոսի կարգավորումներ,
           «--վիրտուալ հեռախոսի լեզուն կիրառվում է»: Վիրտուալ հեռախոսի լեզուն կիրառվում է լռելյայնորեն հավելվածի մակարդակում,
           «--վիրտուալ հեռախոս»՝ վիրտուալ հեռախոս,
           «--validate»: Վավերացնել,
           «--բարի գալուստ izocash հաճախորդների պորտալ»: Բարի գալուստ izocash Հաճախորդների պորտալ, //w
           «--գրել գերծանրքաշային կոդ»: Մուտքագրեք սուպեր կոդը,
           «--welcome to»: Բարի գալուստ,
           «--Ուր է գնում մարդկանց ուշադրությունը»: Այնտեղ, ուր գնում է մարդկանց ուշադրությունը, գնում է փողը,
           «--հաղթողները համառում են»: Հաղթողները համառում են,
           «--կցանկանա՞ք դուրս գալ ձեր Alrani հաշվից»: Ցանկանու՞մ եք դուրս գալ ձեր Alrani հաշվից:
           «--այո»: Այո, //y

           // երկիր
           «--congo»: Կոնգո Բրազավիլ,
           «--cameroon»: Կամերուն,
           «--drc»: DRC,
           «--ivoryCoast»: Փղոսկրի Ափ,

          // langue
          "--afrikaans": "Աֆրիկանս", //a
          "--albanian": "ալբանացի",
          "--amharic": "ամհարերեն",
          "--arabic": "արաբերեն",
          "--armenian": "հայ",
          "--assamese": "ասամերեն",
          "--aymara": "Այմարա",
          "--azerbaijani": "Ադրբեջանական",
          "--bambara": "Բամբարա", //b
          "--basque": "բասկերեն",
          "--belarusian": "բելառուսական",
          "--bengali": "Բենգալերեն",
          "--bhojpuri": "Բհոջպուրի",
          "--bosnian": "բոսնիերեն",
          "--bulgarian": "բուլղարական",
          "--catalan": "կատալոներեն", //c
          "--cebuano": "Սեբուանո",
          "--chichewa": "Չիչևա",
          "--chineseSimplified": "Չինական (Պարզեցված)",
          "--chineseTraditional": "չինական (ավանդական)",
          "--corsican": "Կորսիկան",
          "--croatian": "խորվաթերեն",
          "--czech": "Չեխերեն",
          "--danish": "Դանիերեն", //d
          "--dhivehi": "Դիվեհի",
          "--dogri": "Դոգրի",
          "--dutch": "հոլանդերեն",
          "--english": "Անգլերեն", //e
          "--esperanto": "Էսպերանտո",
          "--estonian": "Էստոնական",
          "--ewe": "Ewe",
          "--filipino": "Ֆիլիպիներեն", //f
          "--finnish": "Ֆիններեն",
          "--french": "ֆրանսերեն",
          "--frisian": "ֆրիզ",
          "--galician": "գալինացի", //g
          "--georgian": "վրացական",
          "--german": "Գերմանական",
          "--greek": "Հունական",
          "--guarani": "Գուարանին",
          "--gujarati": "Գուջարաթի",
          "--haitianCreole": "Haitian Creole", //h
          "--hausa": "Hausa",
          "--hawaiian": "Hawaiian",
          "--hebrew": "Եբրայերեն",
          "--hindi": "հինդի",
          "--hmong": "Hmong",
          "--hungarian": "Հունգարերեն",
          "--icelandic": "Իսլանդական", //i
          "--igbo": "Իգբո",
          "--ilocano": "Ilocano",
          "--indonesian": "Ինդոնեզերեն",
          "--irish": "Իռլանդական",
          "--italian": "Իտալական",
          "--japanese": "ճապոներեն", //j
          "--javanese": "Javanese",
          "--kannada": "Կաննադա", //k
          "--kazakh": "Ղազախ",
          "--khmer": "Խմեր",
          "--kinyarwanda": "Kinyarwanda",
          "--konkani": "Կոնկանի",
          "--korean": "Կորեերեն",
          "--krio": "Krio",
          "--kurdishKurmanji": "Քրդերեն (Kurmanji)",
          "--kurdishSorani": "Քրդերեն (Սորանի)",
          "--kyrgyz": "Ղրղզերեն",
          "--lao": "Լաո", //l
          "--latin": "լատիներեն",
          "--latvian": "Լատվիերեն",
          "--lingala": "Lingala",
          "--lithuanian": "լիտվական",
          "--luganda": "Լուգանդա",
          "--luxembourgish": "Լյուքսեմբուրգերեն",
          "--macedonian": "մակեդոնական", //m
          "--maithili": "Maithili",
          "--malagasy": "Malagasy",
          "--malay": "Մալայերեն",
          "--malayalam": "Մալայալամ",
          "--maltese": "Մալթերեն",
          "--maori": "Maori",
          "--marathi": "Marathi",
          "--meiteilonManipuri": "Meiteilon (Manipuri)",
          "--mizo": "Mizo",
          "--mongolian": "մոնղոլական",
          "--myanmarBurmese": "Myanmar (Burmese)",
          "--nepali": "Նեպալերեն", //n
          "--norwegian": "Նորվեգերեն",
          "--odiaOriya": "Odia (Oriya)", //o
          "--oromo": "Oromo",
          "--pashto": "փաշթու", //p
          "--persian": "պարսկերեն",
          "--polish": "Լեհական",
          "--portuguese": "պորտուգալերեն",
          "--punjabi": "Փենջաբերեն",
          "--quechua": "Կեչուա", //q
          "--romanian": "ռումինական", //r
          "--russian": "ռուսերեն",
          "--samoan": "Սամոյան", //s
          "--sanskrit": "Սանսկրիտ",
          "--scotsGaelic": "Շոտլանդական Գելերեն",
          "--sepedi": "Sepedi",
          "--serbian": "սերբերեն",
          "--sesotho": "Սեսոտո",
          "--shona": "Շոնա",
          "--sindhi": "Սինդհի",
          "--sinhala": "Sinhala",
          "--slovak": "Slovak",
          "--slovenian": "Սլովեներեն",
          "--somali": "Somali",
          "--spanish": "Իսպաներեն",
          "--sundanese": "Sundanese",
          "--swahili": "Swahili",
          "--swedish": "Շվեդական",
          "--tajik": "տաջիկական", //t
          "--tamil": "Թամիլերեն",
          "--tatar": "թաթար",
          "--telugu": "Telugu",
          "--thai": "Թայերեն",
          "--tigrinya": "Tigrinya",
          "--tsonga": "Ցոնգա",
          "--turkish": "Թուրքերեն",
          "--turkmen": "Թուրքմեն",
          "--twi": "Twi",
          "--ukrainian": "ուկրաինական", //u
          "--urdu": "ուրդու",
          "--uyghur": "Ույղուր",
          "--uzbek": "ուզբեկ",
          "--vietnamese": "Vietnamese", //v
          "--welsh": "Welsh", //w
          "--xhosa": "Xhosa", //x
          "--yiddish": "Յիդիշ", //y
          "--yoruba": "Yoruba",
          "--zulu": "Զուլու", //z
        },
      },

      // assamese
      // assamese
      assamese: {
        translations: {
          "--এটা ভুল হৈছে": এটা ভুল হৈছে!, //a
           "--ঠিকনা": ঠিকনা,
           "--পৰামৰ্শ": পৰামৰ্শ,
           "--con continue ত ক্লিক কৰি": continue ত ক্লিক কৰিলে আপুনি আপোনাৰ Veil Brillant একাউণ্টৰ পৰা বিচ্ছিন্ন হ'ব, //b
           "--disconnect ত ক্লিক কৰিলে আপুনি বিচ্ছিন্ন হ'ব": Disconnect ত ক্লিক কৰিলে আপুনি আপোনাৰ izocash একাউণ্টৰ পৰা বিচ্ছিন্ন হ'ব,
           "--আপোনাৰ ভাৰ্চুৱেল নম্বৰ পৰীক্ষা কৰক বা পিছত পুনৰ চেষ্টা কৰক": আপোনাৰ ভাৰ্চুৱেল নম্বৰ পৰীক্ষা কৰক বা পিছত পুনৰ চেষ্টা কৰক, //c
           "--আপোনাৰ ভাৰ্চুৱেল নম্বৰ পৰীক্ষা কৰক": আপোনাৰ ভাৰ্চুৱেল নম্বৰ পৰীক্ষা কৰক,
           "--অব্যাহত": অব্যাহত ৰাখক,
           "--সংযোগ": সংযোগ,
           "--সহযোগিতা, সমন্বয়ত জীয়াই থকা": সহযোগিতা কৰা, আনৰ সৈতে মিলাপ্ৰীতিৰে জীয়াই থকা,
           "--ভাষা বাছক": ভাৰ্চুৱেল ফোন ভাষা,
           "--প্ৰতিযোগিতাত বাধা নিদিব": প্ৰতিযোগিতাত বাধা নিদিব, সকলোকে সুযোগ দিয়ক, //d
           "--বিচ্ছিন্ন": সংযোগ বিচ্ছিন্ন,
           "--সকলো ভাৰ্চুৱেল ফোন ব্যৱহাৰকাৰীৰ বাবে": সকলো ভাৰ্চুৱেল ফোন ব্যৱহাৰকাৰীৰ বাবে, এটা VPN, //f ব্যৱহাৰ কৰাটো উপদেশিত
           "--প্ৰৱেশ পৃষ্ঠালৈ যাওক": প্ৰৱেশ পৃষ্ঠালৈ যাওক, //g
           "--ঐতিহাসিক": ঐতিহাসিক, //h
           "--i have account": মোৰ ইতিমধ্যে এটা একাউণ্ট আছে, //i
           "--মোৰ একাউণ্ট নাই": মোৰ একাউণ্ট নাই,
           "--ই তোমাৰ ঘৰ": ই তোমাৰ ঘৰ,
           "--চিত্ৰ / ভিডিঅ' +": ছবি / ভিডিঅ' +,
           "--পৰিচয় পৰীক্ষণ": পৰিচয় পৰীক্ষণ,
           "--izocash গ্ৰাহক পৰ্টেল": izocash গ্ৰাহক পৰ্টেল,
           "--প্ৰতি বছৰে পৰিচয় আপডেট": প্ৰতি বছৰে পৰিচয় আপডেট,
           "--izocash কিনিব": izocash কিনিব => izocash আন্তর্জাতিক,
           "--log in": লগ ইন কৰক!, //l
           "--login": লগ ইন কৰক,
           "--login to veil brilliant": ওৰণি ব্রিলিয়েন্টৰ সৈতে সংযোগ কৰক,
           "--vixinol store ত প্ৰৱেশ কৰক": Vixinol Store ৰ সৈতে সংযোগ কৰক,
           "--আপোনাৰ veil Brillant একাউণ্টত বিনামূলীয়াকৈ লগ ইন কৰক": এই বৈশিষ্ট্যত প্ৰৱেশ কৰিবলৈ আপোনাৰ Veil Brillant একাউণ্টত বিনামূলীয়াকৈ লগ ইন কৰক,
           "--login success": লগইন সফল!,
           "--এতিয়া লগইন কৰক": এতিয়াই লগ ইন কৰক!,
           "--logout সফলতা": লগআউট সফল!,
           "--লগ আউট": লগআউট,
           "--logout": লগ আউট,
           "--সংখ্যা": সংখ্যা, //n
           "--নাম": নাম,
           "--এতিয়া লগ ইন কৰক": এতিয়া, লগ ইন কৰক!,
           "--প্ৰতিযোগিতা স্তব্ধ কৰাত নিষেধাজ্ঞা নাই":
           "--কোনো ঈৰ্ষা নাই, কোনো ঘৃণা নাই": কোনো ঈৰ্ষা নাই, কোনো ঘৃণা নাই, কোনো বিভাজন নাই,
           "--নাই": নাই,
           "--আপোনাৰ ভাৰ্চুৱেল ফোন অভিগম কৰিবলে অফিচিয়েল ঠিকনাসমূহ": আপোনাৰ ভাৰ্চুৱেল ফোন অভিগম কৰিবলে অফিচিয়েল ঠিকনাসমূহ, //o
           "--পাছৱৰ্ড": পাছৱৰ্ড, //p
           "--পইন্ট উলিওৱা izocash": পইন্ট উলিওৱা izocash,
           "--পইন্ট উলিওৱা": পইণ্ট উলিওৱা,
           "--পছন্দ, এটা vpn ব্যৱহাৰ কৰক": পছন্দসইভাৱে, এটা VPN ব্যৱহাৰ কৰক যি আপোনাৰ ইন্টাৰনেট সেৱা প্ৰদানকাৰীৰ অন্তৰ্গত নহয়,
           "--অধ্যৱসায়ে সদায় ফল দিয়ে": অধ্যৱসায়ে সদায় শেষত ফল দিয়ে,
           "--rule": নিয়ম, //r
           "--পৰামৰ্শ": পৰামৰ্শ,
           "--পঞ্জীয়ন": পঞ্জীয়ন,
           "--signup to veil brilliant": ওৰণি ব্রিলিয়েন্টত পঞ্জীয়ন কৰক, //s
           "--vixinol store লৈ চাইনআপ কৰক": Vixinol ষ্ট'ৰত পঞ্জীয়ন কৰক,
           "--signup": পঞ্জীয়ন কৰক,
           "--signup success": পঞ্জীয়ন সফল!,
           "--বিনামূলীয়াকৈ চাইনআপ কৰক": বিনামূলীয়াকৈ পঞ্জীয়ন কৰক,
           “--চাইনআপ সফলতা আই এ”: সংযোগ সফল”,
           "--ছেটিংছ": "ছেটিংছ",
           "--alrani এপটো সংস্থাপন কৰা": Alrani এপ্লিকেচন বিন্যাস কৰা,
           "--izocash এপটো সংস্থাপন কৰা": izocash এপ্লিকেচন বিন্যাস কৰা,
           "--vixinol এপটো সংস্থাপন কৰা": Vixinol এপ্লিকেচন বিন্যাস কৰা,
           "--ভেইল ব্রিলান্ট এপ্প্ সেট আপ": ওৰণি ব্রিলান্ট এপ্লিকেচন বিন্যাস কৰা,
           "--চিত্ৰ, ভিডিঅ'ৰ সংৰক্ষণ": ছবি, ভিডিঅ' আৰু অন্যান্য কেইবাটাও উপাদানৰ সংৰক্ষণ,
           "--গ্ৰহণৰ গতি": ডাটাচেণ্টাৰৰ পৰা তথ্য গ্ৰহণৰ গতি,
           "--গতি": গতি,
           "--terminate": সমাপ্ত কৰক, //t
           "--vpn এ আপোনাক অভিগম কৰাৰ অনুমতি দিয়ে": VPN এ আপোনাক এটা চাইট বা এটা এপ্লিকেচন অভিগম কৰাৰ অনুমতি দিয়ে যিটো আপোনাৰ ইণ্টাৰনেট সেৱা প্ৰদানকাৰীয়ে ব্লেকলিষ্ট কৰিছে,
           "--আটাইতকৈ ডাঙৰ গছটো ওপৰত আছিল": আটাইতকৈ ডাঙৰ গছজোপা আছিল সৰ্বোপৰি এটা সাধাৰণ সৰু বীজ,
           "--পৰ্দা স্পৰ্শ কৰক": আগবাঢ়ি যাবলৈ পৰ্দা স্পৰ্শ কৰক,
           "--আকৌ চেষ্টা কৰক": আকৌ চেষ্টা কৰক!,
           "--ব্যৱহাৰকাৰীৰ নাম": ব্যৱহাৰকাৰীৰ নাম, //u

           "--ভাৰ্চুৱেল নম্বৰ": ভাৰ্চুৱেল নম্বৰ, //v
           "--ভাৰ্চুৱেল ফোন ছেটিংছ": ভাৰ্চুৱেল ফোন ছেটিংছ,
           "--ভাৰ্চুৱেল ফোন ভাষা প্ৰয়োগ কৰা হৈছে": ভাৰ্চুৱেল ফোন ভাষা অবিকল্পিতভাৱে এপ্লিকেচন স্তৰত প্ৰয়োগ কৰা হয়,
           "--ভাৰ্চুৱেল ফোন": ভাৰ্চুৱেল ফোন,
           "--বৈধ কৰক": বৈধ কৰক,
           "--izocash গ্ৰাহক পৰ্টেললৈ স্বাগতম": izocash গ্ৰাহক পৰ্টেললৈ স্বাগতম, //w
           "--এটা চুপাৰ ক'ড লিখক": এটা চুপাৰ ক'ড দিয়ক,
           "--স্বাগতম": স্বাগতম,
           "--য'ত মানুহৰ মনোযোগ যায়": য'ত মানুহৰ মনোযোগ যায় পইচা যায়,
           "--বিজয়ীসকলে অধ্যৱসায় কৰে": বিজয়ীসকলে অধ্যৱসায় কৰে,
           "--আপুনি আপোনাৰ আলৰানি একাউণ্টৰ পৰা লগ আউট কৰিব বিচাৰেনে": আপুনি আপোনাৰ আলৰানি একাউণ্টৰ পৰা লগ আউট কৰিব বিচাৰেনে?,
           "--হয়": হয়, //y

           // দেশ
           "--কংগো": কংগো ব্ৰাজাভিল,
           "--কেমেৰুণ": কেমেৰুণ,
           "--drc": ডি আৰ চি,
           "--ivoryCoast": হাতীদাঁত উপকূল,

          // langue
          "--afrikaans": "আফ্ৰিকান", //a
          "--albanian": "আলবেনিয়ান",
          "--amharic": "আমহাৰিক",
          "--arabic": "আৰবী",
          "--armenian": "আৰ্মেনিয়ান",
          "--assamese": "অসমীয়া",
          "--aymara": "আয়মৰা",
          "--azerbaijani": "আজাৰবাইজানী",
          "--bambara": "বাম্বৰা", //b
          "--basque": "বাস্ক",
          "--belarusian": "বেলাৰুছিয়ান",
          "--bengali": "বাংলা",
          "--bhojpuri": "ভোজপুৰী",
          "--bosnian": "বছনিয়ান",
          "--bulgarian": "বুলগেৰিয়ান",
          "--catalan": "কাটালান", //c
          "--cebuano": "চেবুয়ানো",
          "--chichewa": "চিচেৱা",
          "--chineseSimplified": "চীনা (সৰলীকৃত)",
          "--chineseTraditional": "চীনা (পৰম্পৰাগত)",
          "--corsican": "কৰ্চিকান",
          "--croatian": "ক্ৰ'ৱেচিয়ান",
          "--czech": "চেক",
          "--danish": "ডেনিছ", //d
          "--dhivehi": "ধীভেহী",
          "--dogri": "ডগৰি",
          "--dutch": "ডাচ",
          "--english": "ইংৰাজী", //e
          "--esperanto": "এস্পেরান্টো",
          "--estonian": "ইষ্টোনিয়ান",
          "--ewe": "ভেড়া",
          "--filipino": "ফিলিপিনো", //f
          "--finnish": "ফিনিছ",
          "--french": "ফৰাচী",
          "--frisian": "ফ্ৰিজিয়ান",
          "--galician": "গালিচিয়ান", //g
          "--georgian": "জৰ্জিয়ান",
          "--german": "জাৰ্মান",
          "--greek": "গ্ৰীক",
          "--guarani": "গুয়াৰানি",
          "--gujarati": "গুজৰাটী",
          "--haitianCreole": "হাইটিয়ান ক্ৰিয়েল", //h
          "--hausa": "হাউছা",
          "--hawaiian": "হাৱাইয়ান",
          "--hebrew": "হিব্ৰু",
          "--hindi": "হিন্দী",
          "--hmong": "হমং",
          "--hungarian": "হাংগেৰিয়ান",
          "--icelandic": "আইচলেণ্ডিক", //i
          "--igbo": "ইগবো",
          "--ilocano": "ইলোকানো",
          "--indonesian": "ইণ্ডোনেছিয়ান",
          "--irish": "আইৰিছ",
          "--italian": "ইতালীয়",
          "--japanese": "জাপানী", //j
          "--javanese": "জাভানিজ",
          "--kannada": "কানাড়া", //k
          "--kazakh": "কাজাখ",
          "--khmer": "খ্মেৰ",
          "--kinyarwanda": "কিনিয়াৰৱাণ্ডা",
          "--konkani": "কংকনী",
          "--korean": "কোৰিয়ান",
          "--krio": "ক্ৰীও",
          "--kurdishKurmanji": "কুৰ্দি (কুৰ্মানজী)",
          "--kurdishSorani": "কুৰ্দি (সোৰানী)",
          "--kyrgyz": "কিৰ্গিজ",
          "--lao": "লাও", //l
          "--latin": "লেটিন",
          "--latvian": "লাটভিয়ান",
          "--lingala": "লিংগালা",
          "--lithuanian": "লিথুৱেনিয়ান",
          "--luganda": "লুগাণ্ডা",
          "--luxembourgish": "লাক্সেমবাৰ্গ",
          "--macedonian": "মেচিডোনিয়ান", //m
          "--maithili": "Maithili",
          "--malagasy": "মালাগাছি",
          "--malay": "মালয়",
          "--malayalam": "মালয়ালম",
          "--maltese": "মাল্টীজ",
          "--maori": "মাওৰী",
          "--marathi": "মাৰাঠী",
          "--meiteilonManipuri": "মেইটেইলন (মণিপুৰী)",
          "--mizo": "মিজো",
          "--mongolian": "মংগোলীয়",
          "--myanmarBurmese": "ম্যানমাৰ (বাৰ্মিজ)",
          "--nepali": "নেপালী", //n
          "--norwegian": "নৰ্ৱেজিয়ান",
          "--odiaOriya": "ওডিয়া (উড়িয়া)", //o
          "--oromo": "অৰোমো",      
          "--pashto": "পাষ্টো", //p
          "--persian": "পাৰ্চী",
          "--polish": "পোলিশ",
          "--portuguese": "পৰ্তুগীজ",
          "--punjabi": "পাঞ্জাবী",
          "--quechua": "কেচুয়া", //q
          "--romanian": "ৰোমানিয়ান", //r
          "--russian": "ৰাছিয়ান",
          "--samoan": "চামোয়ান", //s
          "--sanskrit": "সংস্কৃত",
          "--scotsGaelic": "স্কট গ্যালিক",
          "--sepedi": "চেপেডি",
          "--serbian": "ছাৰ্বিয়ান",
          "--sesotho": "চেসোথো",
          "--shona": "শোনা",
          "--sindhi": "সিন্ধী",
          "--sinhala": "সিংহল",
          "--slovak": "শ্লোভাক",
          "--slovenian": "স্লোভেনিয়ান",
          "--somali": "সোমালি",
          "--spanish": "স্পেনিছ",
          "--sundanese": "সুন্দানিজ",
          "--swahili": "শ্বাহিলি",
          "--swedish": "ছুইডিছ",
          "--tajik": "তাজিক", //t
          "--tamil": "তামিল",
          "--tatar": "টাটাৰ",
          "--telugu": "তেলেগু",
          "--thai": "থাই",
          "--tigrinya": "তিগ্ৰিনিয়া",
          "--tsonga": "ট্ছংগা",
          "--turkish": "তুৰ্কী",
          "--turkmen": "তুৰ্কমেন",
          "--twi": "টুই",
          "--ukrainian": "ইউক্ৰেইনীয", //u
          "--urdu": "উৰ্দু",
          "--uyghur": "উইঘুৰ",
          "--uzbek": "উজবেক",
          "--vietnamese": "ভিয়েটনামী", //v
          "--welsh": "ৱেলছ", //w
          "--xhosa": "Xhosa", //x
          "--yiddish": "য়িদ্দিছ", //y
          "--yoruba": "ইয়োৰুবা",
          "--zulu": "জুলু", //z
        },
      },

      // aymara
      // aymara
      aymara: {
        translations: {
          "--mä pantjasiwiw utji": Mä pantjasiw utji!, //a
           "--dirección": Uñt'ayawi, .
           "--iwxt'awi": Iwxt'awi,
           "--sarantañapataki ch’iqt’asa": sarantaskañapataki ch’iqt’asaxa Veil Brillant ukan cuentapat jithiqtañamawa, //b
           "--desconexión ukxaru ch’iqt’asaxa desconectatätawa": Desconexión ukxaru ch’iqt’asaxa izocash uka cuentat jithiqtañamawa,
           "--virtual jakhu uñakipaña jan ukax qhipa yant'aña": Virtual jakhu uñakipaña jan ukax qhipa yant'aña, //c
           "--virtual jakhu uñakipaña": Virtual jakhu uñakipaña,
           "--sarnaqaña": Ukhama,
           "---conexión": Uñt'ayawi,
           "--yanapt'asiña, mayacht'asis jakaña": Yanapt'asiña, mayninakamp mayacht'asis jakaña,
           "--aru ajlliñani": Virtual Phone Language,
           "--janiw atipt'asiñ jark'añati": Janiw atipt'asiñ jark'añati, taqiniruw ch'am churaña, //d
           "--desconexión": Jan walt'ayaña, .
           "--taqi virtual teléfono apnaqirinakataki": Taqi Virtual Phone apnaqirinakatakixa, VPN apnaqañaxa wali askiwa, //f
           "--mant'añ utar saraña": Uñt'añ utar saraña, //g
           "--histórico": Sarnaqäwi, //h
           "--nayax cuentanïtwa": Nayax nayratpach mä cuentanïtwa, //i
           "--janiw cuentanïkti": Janiw cuentanïkti,
           "--ukax jumanakan utamawa": ukax jumanakan utamawa,
           "--imajin / video +": Uñacht'äwi / Video +,
           "--identidad uñakipaña": Identidad uñakipaña, .
           "--izocash ukax mä portal de clientes": izocash ukax mä portal de clientes,
           "--identidad sapa mara machaqar tukuyaña": Identidad sapa mara machaqar tukuyaña,
           "--izocash alañataki": izocash Alañataki => izocash internacional,
           "--log in": Uñt'ayasiñataki!, //l
           "--login": Uñt'ayasiñataki,
           "--login to veil brillant": Velo Brillant ukar mantañamawa,
           "--vixinol tienda ukar mantañamawa": Vixinol tienda ukar mantañamawa,
           "--inaki mantam veil Brillant cuentamar": Inakiw mantam Veil Brillant cuentaman aka lurawiru mantañataki,
           "--login success": ¡Manqt'asiñax wali askiwa!,
           "--jichhax mantañamawa": Jichhax mantañamawa!,
           "--logout success": ¡Mistxañax wali askiwa!,
           "--mistxañani": Uñt'ayasiñataki,
           "--logout": Uñt'ayasiñataki,
           "--jakhu": Jakhu, //n
           "--sutin": Suti, .
           "--jichhax mantam": Jichhax, ¡Jichhax mantam!,
           "--janiw atipt'asiñ ch'amanchañax jark'atäkiti":
           "--janiw envidiasiñas utjkiti, janiw uñisiñas utjkiti": Janiw envidiasiñas utjkiti, janiw uñisiñas utjkiti, janiw jaljtañas utjkiti,
           "--janiwa": Janiwa,
           "--direcciones oficiales ukax teléfono virtual ukar mantañataki": Direcciones oficiales ukanakax teléfono virtual ukar mantañataki, //o
           "--contraseña": Contraseña, //p
           "--puntos apsuña izocash": Puntos apsuña izocash,
           "--puntos apsuña": Puntos apsuña,
           "--wali askiwa, mä vpn apnaqaña": Wali askiwa, mä VPN apnaqaña, ukax janiw internet servicio ukankiti,
           "--persistencia ukax sapa kutiw payllasi": Persistencia ukax sapa kutiw tukuyañatakix payllasi,
           "--rule": Kamachinaka, //r
           "--iwxt'awi": Iwxt'awinaka,
           "--registración": Qillqantayaña, .
           "--registrar a velo brillante": Velo Brillant ukan qillqantañamawa, //s
           "--vixinol tienda ukar qillqantañamawa": Vixinol tienda ukan qillqantañamawa,
           "--qillqt'asiña": Qillqt'asiñamawa,
           "--signup success": ¡Qillqt'asiñax wali askiwa!,
           "--inakiw qillqt'asiñama": Inakiw qillqt'asiñama,
           “--inscripción suma IA”: Conexión ukax wali askiwa”,
           "--settings": "Uñstayaña",
           "--alrani app ukar wakicht'aña": Alrani app ukar wakicht'aña,
           "--izocash app ukar wakicht'aña": izocash app ukar wakicht'aña,
           "--vixinol app ukar wakicht'aña": Vixinol uka apnaqañ wakicht'aña,
           "--velo Brillant app ukar utt'ayaña": Veil Brillant aplicación ukar wakicht'aña,
           "--imajinanaka, videonaka imaña": Imajinanaka, videonaka ukat walja yaqha elementonaka imaña,
           "--speed of reception": Datacenter ukan yatiyawinak jank'ak katuqaña,
           "--jank'aki": Jaqi, .
           "--tukuña": Tukuyaña, //t
           "--vpn ukax mantañ yanapt'i": VPN ukax mä sitio jan ukax mä aplicación ukar mantañ yanapt'i, ukax servicio de internet ukax ch'iyara lista ukan uñt'ayatawa,
           "--jach'a quqax patatänwa": Jach'a quqax taqi kunat sipans mä sanu jisk'a jatha,
           "--pantalla llamkt'aña": Pantalla llamkt'aña sarantañataki,
           "--mayamp yant'am": ¡Mayamp yant'am!,
           "--username": Usuario, //u

           "--virtual jakhu": Virtual jakhu, //v
           "--virtual teléfono ukan utt'ayatanakapa": Virtual teléfono ukan utt'ayata, .
           "--virtual Teléfono aru apnaqatawa": Teléfono Virtual aruxa apnaqawi nivel ukanxa apnaqatarakiwa,
           "--teléfono virtual": Teléfono virtual,
           "--chiqañchaña": Chiqañchaña, .
           "--izocash aljirinakatakix wali askiwa": izocash aljirinakatakix wali askiwa, //w
           "--mä super código qillqt'aña": Mä Super código qillqt'aña,
           "--wali suma katuqt'ata": Suma katuqt'ata,
           "--kawkhantix jaqinakan amuyupax saraski": Kawkhans jaqinakan amuyupax saraski qullqix saraski,
           "--atipt'irinakax ch'amanchasipxi": Atipirinakax ch'amanchasipxi,
           "--Alrani ukan cuentapat mistuñ munasmati": ¿Alrani ukan cuentapat mistuñ munasmati?,
           "--jïsa": Jisa, //y

           // marka
           "--congo": Congo Brazzaville, ukat juk'ampinaka.
           "--camerún": Camerún,
           "--drc": RDC, ukat juk'ampinaka.
           "--ivoryCoast": Costa de Marfil, ukat juk'ampinaka.

          // langue
          "--afrikaans": "Afrikaans", //a
          "--albanian": "Albanés",
          "--amharic": "Amharic",
          "--arabic": "árabe",
          "--armenian": "Armenio",
          "--assamese": "Assam aru",
          "--aymara": "Aymara",
          "--azerbaijani": "Azerbaiyano",
          "--bambara": "Bambara", //b
          "--basque": "Vasco",
          "--belarusian": "Bielorruso",
          "--bengali": "Bengali", 
          "--bhojpuri": "Bhojpuri", 
          "--bosnian": "Bosniano",
          "--bulgarian": "búlgaro",
          "--catalan": "catalán", //c
          "--cebuano": "Cebuano",
          "--chichewa": "Chichewa", 
          "--chineseSimplified": "Chino (Jan ch’amäki)",
          "--chineseTraditional": "Chino (Tradicional)",
          "--corsican": "Corsico",
          "--croatian": "Croata",
          "--czech": "Checo",
          "--danish": "Danés", //d
          "--dhivehi": "Dhivehi",
          "--dogri": "Dogri",
          "--dutch": "Holandés",
          "--english": "Inklisa", //e
          "--esperanto": "Esperanto",
          "--estonian": "Estonia",
          "--ewe": "Uwija",
          "--filipino": "Filipinas", //f
          "--finnish": "Finlandés",
          "--french": "Francés aru",
          "--frisian": "Frisiano",
          "--galician": "Galicia aru", //g
          "--georgian": "Georgia aru",
          "--german": "Alemán aru",
          "--greek": "Griego aru",
          "--guarani": "Guarani",
          "--gujarati": "Gujarat aru",
          "--haitianCreole": "Criollo Haitiano", //h
          "--hausa": "Hausa",
          "--hawaiian": "Hawaiano",
          "--hebrew": "Hebreo aru",
          "--hindi": "Hindi",
          "--hmong": "Hmong",
          "--hungarian": "Húngaro",
          "--icelandic": "Islandia aru", //i
          "--igbo": "Igbo",
          "--ilocano": "Ilocano",
          "--indonesian": "Indonesia aru",
          "--irish": "Irlanda aru",
          "--italian": "Italia aru",
          "--japanese": "Japonés", //j
          "--javanese": "Javanés",
          "--kannada": "Kannada", //k
          "--kazakh": "Kazaj aru",
          "--khmer": "Khmer",
          "--kinyarwanda": "Kinyarwanda",
          "--konkani": "Konkani",
          "--korean": "Corea aru",
          "--krio": "Krio",
          "--kurdishKurmanji": "kurdo (Kurmanji)",
          "--kurdishSorani": "kurdo (sorani)",
          "--kyrgyz": "Kirguisano",
          "--lao": "Lao", //l
          "--latin": "Latin aru",
          "--latvian": "Letonia aru",
          "--lingala": "Lingala",
          "--lithuanian": "Lituano",
          "--luganda": "Luganda",
          "--luxembourgish": "Luxemburgo",
          "--macedonian": "Macedonia", //m
          "--maithili": "Maithili aru",
          "--malagasy": "Malagas aru",
          "--malay": "Malay",
          "--malayalam": "Malayalam",
          "--maltese": "Malta aru",
          "--maori": "Maori",
          "--marathi": "Mara aru",
          "--meiteilonManipuri": "Meiteilon (Manipuri)",
          "--mizo": "Mizo",
          "--mongolian": "Mongol",
          "--myanmarBurmese":" Myanmar (Birmano)",
          "--nepali": "Nepal aru", //n
          "--norwegian": "Noruega aru",
          "--odiaOriya": "Odia (Oriya)", //o
          "--oromo": "Oromo", 
          "--pashto": "Pashto", //p
          "--persian": "Persa aru",
          "--polish": "Puli",
          "--portuguese": "Portugués",
          "--punjabi": "Punu aru",
          "--quechua": "Quechua", //q
          "--romanian": "Rumania aru", //r
          "--russian": "Ruso",
          "--samoan": "Samoano", //s
          "--sanskrit": "Sanscrito",
          "--scotsGaelic": "Escocia aru",
          "--sepedi": "Sepedi",
          "--serbian": "Serbio",
          "--sesotho": "Sesotho",
          "--shona": "Shona",
          "--sindhi": "Sindhi",
          "--sinhala": "Sinhala aru",
          "--slovak": "Eslovaco",
          "--slovenian": "Esloveno",
          "--somali": "Somalia aru",
          "--spanish": "Kastilla aru",
          "--sundanese": "Sundano",
          "--swahili": "Swahili aru",
          "--swedish": "Sueco aru",
          "--tajik": "Tajik aru", //t
          "--tamil": "Tamil",
          "--tatar": "Tatar",
          "--telugu": "Telugu",
          "--thai": "Tailandés",
          "--tigrinya": "Tigrina",
          "--tsonga": "Tsonga",
          "--turkish": "Turco aru",
          "--turkmen": "Turkmen",
          "--twi": "Twi",
          "--ukrainian": "Ucrania aru", //u
          "--urdu": "Urdu aru",
          "--uyghur": "Uyghur",
          "--uzbek": "Uzbek",
          "--vietnamese": "Vietnam aru", //v
          "--welsh": "Galés", //w
          "--xhosa": "Xhosa", //x
          "--yiddish": "Yiddish aru", //y
          "--yoruba": "Yoruba",
          "--zulu": "Zulu aru", //z
        },
      },

      // azerbaijani
      // azerbaijani
      azerbaijani: {
        "--bir xəta baş verdi": Səhv baş verdi!, //a
        "--address": Ünvanlar,
        "--məsləhət": Məsləhət,
        "--dəvam et üzərinə klikləməklə": Davam et üzərinə klikləməklə, Veil Brillant hesabınızla əlaqəniz kəsiləcək, //b
        "--bağlantıyı kəsin üzərinə klikləməklə əlaqəniz kəsiləcək": "Bağlantıyı kəs" üzərinə klikləməklə siz izocash hesabınızla əlaqəniz kəsiləcək,
        "--virtual nömrənizi yoxlayın və ya daha sonra yenidən cəhd edin": Virtual nömrənizi yoxlayın və ya daha sonra yenidən cəhd edin, //c
        "-- virtual nömrənizi yoxlayın": Virtual nömrənizi yoxlayın,
        "--davam et": Davam et,
        "--bağlantı": Bağlantı,
        "- əməkdaşlıq etmək, harmoniyada yaşamaq": əməkdaşlıq etmək, başqaları ilə harmoniyada yaşamaq,
        "--dili seçin": Virtual Telefon Dili,
        "--rəqabətə mane olma": Rəqabətə mane olma, hamıya şans ver, //d
        "--disconnection": Bağlantının kəsilməsi,
        "--bütün virtual telefon istifadəçiləri üçün": Bütün Virtual Telefon istifadəçiləri üçün VPN-dən istifadə etmək tövsiyə olunur, //f
        "--giriş səhifəsinə gedin": Giriş səhifəsinə keçin, //g
        "--tarixi": Tarixi, //h
        "--i have account": Mənim artıq hesabım var, //i
        "--i don't have account": Hesabım yoxdur,
        "--it is your house": o sənin evindir,
        "--şəkil / video +": Şəkil / Video +,
        "--identity verification": Şəxsiyyətin yoxlanılması,
        "--izocash müştəri portalı": izocash Müştəri Portalı,
        "--identity update every year": Hər il şəxsiyyət yeniləməsi,
        "--izocash buy to": izocash Buy => izocash beynəlxalq,
        "--giriş": Daxil ol!, //l
        "--login": Daxil ol,
        "--girl to veil brilliant": Veil Brillant-a qoşulun,
        "--vixinol mağazasına daxil olun": Vixinol Mağazasına qoşulun,
        "--ödəmə Brillant hesabınıza pulsuz daxil olun": Bu funksiyaya daxil olmaq üçün Veil Brillant hesabınıza pulsuz daxil olun,
        "--giriş müvəffəqiyyəti": Giriş uğurludur!,
        "--indi daxil ol": İndi daxil olun!,
        "--çıxış müvəffəqiyyəti": Uğurlu çıxış!,
        "--out": Çıxış,
        "--out": Çıxış,
        "--nömrə": Sayı, //n
        "--name": Ad,
        "--indi daxil ol": İndi, Daxil ol!,
        "--rəqabəti boğmağa qadağa yoxdur":
        "--qısqanclıq yox, nifrət yoxdur": Qısqanclıq, nifrət, ayrılıq yoxdur,
        "--yox yox,
        "--virtual telefonunuza daxil olmaq üçün rəsmi ünvanlar": Virtual telefonunuza daxil olmaq üçün rəsmi ünvanlar, //o
        "--password": Şifrə, //səh
        "--balların çıxarılması izocash": Balların çıxarılması izocash,
        "--balların çıxarılması": Xalların çıxarılması,
        "--tercihen vpn istifadə edin": Tercihen internet provayderinizə aid olmayan VPN-dən istifadə edin,
        "- əzmkarlıq həmişə öz bəhrəsini verir": Əzmkarlıq həmişə nəticə verir,
        "--qayda": Qaydalar, //r
        "--tövsiyə": Tövsiyələr,
        "--registration": Qeydiyyat,
        "--qeydiyyatdan keçin parıldamaq": Veil Brillant-da qeydiyyatdan keçin, //s
        "--vixinol mağazasına qeydiyyatdan keçin": Vixinol Mağazasında qeydiyyatdan keçin,
        "--qeydiyyat": Qeydiyyatdan keçin,
        "--qeydiyyat müvəffəqiyyəti": Qeydiyyat uğurlu oldu!,
        "--pulsuz qeydiyyatdan keçin": Pulsuz qeydiyyatdan keçin,
        “--qeydiyyatda müvəffəqiyyət IA”: Bağlantı uğurlu”,
        "--settings": "Parametrlər",
        "--alrani tətbiqinin qurulması": Alrani tətbiqinin konfiqurasiyası,
        "--izocash tətbiqinin qurulması": izocash tətbiqinin konfiqurasiyası,
        "--vixinol tətbiqinin qurulması": Vixinol tətbiqinin konfiqurasiyası,
        "--veil Brillant tətbiqinin qurulması": Veil Brillant tətbiqinin konfiqurasiyası,
        "--şəkillərin, videoların saxlanması": Şəkillərin, videoların və bir sıra digər elementlərin saxlanması,
        "--qəbul sürəti": Məlumat mərkəzindən məlumatların qəbulu sürəti,
        "--speed": Sürət,
        "--terminate": Sonlandır, //t
        "--vpn sizə daxil olmağa imkan verir": VPN sizə internet provayderinizin qara siyahıya saldığı sayta və ya proqrama daxil olmaq imkanı verir,
        "--en böyük ağac yuxarıda idi": Ən böyük ağac hər şeydən əvvəl sadə kiçik bir toxum idi,
        "--touch the screen": Davam etmək üçün ekrana toxunun,
        "--yenidən cəhd edin": Yenidən cəhd edin!,
        "--username": İstifadəçi adı, //u

        "--virtual nömrə": Virtual nömrə, //v
           "--virtual telefon parametrləri": Virtual telefon parametrləri,
           "--virtual Telefon dili tətbiq olunur": Virtual Telefon dili standart olaraq proqram səviyyəsində tətbiq edilir,
           "--virtual telefon": Virtual telefon,
           "--validate": Doğrulayın,
           "--izocash müştəri portalına xoş gəlmisiniz": izocash Müştəri Portalına xoş gəlmisiniz, //w
           "--super kod yaz": Super kod daxil edin,
           "--xoş gəlmisiniz": Xoş gəldiniz,
           "--insanların diqqəti hara gedir": İnsanların diqqəti hara gedirsə, pul hara gedir,
           "--qaliblər dözür": Qaliblər səbir edir,
           "--Alrani hesabınızdan çıxmaq istərdiniz": Alrani hesabınızdan çıxmaq istəyirsiniz?,
           "--bəli": Bəli, //y

           // ölkə
           "--konqo": Konqo Brazzavil,
           "--kamerun": Kamerun,
           "--drc": DRC,
           "--fil Dişi Sahili": Fil Dişi Sahili,

           // dil
        "--afrikaans": Afrikaans, //a
        "--alban": alban,
        "--amharic": Amharca,
        "--arabic": ərəb,
        "--armenian": erməni,
        "--assamese": assam,
        "--aymara": Aymara,
        "--azerbaijani": azərbaycanca,
        "--bambara": Bambara, //b
        "--bask": bask,
        "--belarus": belarus,
        "--bengali": Benqal,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosniya,
        "--bolqar": bolqar,
        "--catalan": Katalanca, //c
        "--cebuano": Sebuano,
        "--chichewa": Çiçeva,
        "--chineseSimplified": Çin (Sadələşdirilmiş),
        "--chineseTraditional": Çin (Ənənəvi),
        "--korsika": Korsika,
        "--xorvat": xorvat,
        "--çex": çex,
        "--danish": Danimarka, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": holland,
        "--english": İngilis, //e
        "--esperanto": Esperanto,
        "--estonian": eston,
        "--ewe": Ewe,
        "--filipino": Filippin, //f
        "--fin": Fin,
        "--fransızca": fransız,
        "--frisian": friz,
        "--galician": Qalisian, //g
        "--gürcü": gürcü,
        "--german": Alman,
        "--yunan": yunan,
        "--guarani": quarani,
        "--gujarati": gujarati,
        "--haitianCreole": Haiti Kreol, //h
        "--hausa": Hausa,
        "--hawaiian": Havay,
        "--İbranicə": İvrit,
        "--hindi": hindi,
        "--hmong": Hmong,
        "--macar": macar,
        "--icelandic": İslandiyaca, //i
        "--igbo": İqbo,
        "--ilocano": İlocano,
        "--indonesian": İndoneziya,
        "--irish": İrlandiya,
        "--italian": İtalyan,
        "--yaponca": Yapon, //j
        "--javanese": Yava,
        "--kannada": Kannada, //k
        "--qazax": qazax,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarvanda,
        "--konkani": Konkani,
        "--korean": Koreya,
        "--krio": Krio,
        "--kurdishKurmanci": Kürd (Kurmanci),
        "--kurdishSorani": Kürd (Sorani),
        "--qırğız": qırğız,
        "--lao": Lao, //l
        "--latın": Latın,
        "--latvian": latış,
        "--lingala": Linqala,
        "--litva": Litva,
        "--luganda": Luqanda,
        "--luxembourgish": Lüksemburqca,
        "--makedonca": makedon, //m
        "--maithili": Maithili,
        "--malagasy": Malaqas,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--malta": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--monqolca": monqol,
        "--myanmarBurmese": Myanmar (Birma),
        "--nepali": Nepal, //n
        "--norwegian": Norveç,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--puştu": Puştu, //səh
        "--fars": fars,
        "--polish": Polyak,
        "--portuguese": portuqal,
        "--punjabi": Pəncab,
        "--quechua": Keçua, //q
        "--rumıniya": Rumıniya, //r
        "--rus": rus,
        "--samoan": Samoa, //s
        "--sanskrit": sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": serb,
        "--sesotho": Sesoto,
        "--shona": Şona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--sloven": sloven,
        "--somali": Somali,
        "--spanish": İspan,
        "--sundan dili": sundan dili,
        "--swahili": suahili,
        "--swedish": isveç,
        "--tacik": tacik, //t
        "--tamil": Tamil,
        "--tatar": tatar,
        "--telugu": Teluqu,
        "--tay": Tay,
        "--tigrinya": Tigrinya,
        "--tsonqa": Tsonqa,
        "--türk": türkcə,
        "--türkmən": türkmən,
        "--twi": Twi,
        "--ukrainian": Ukrayna, //u
        "--urdu": Urdu,
        "--uyghur": uyğur,
        "--uzbek": özbək,
        "--vietnamese": Vyetnamca, //v
        "--welsh": Uels, //w
        "--xhosa": Xosa, //x
        "--yiddish": Yidiş, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z

      // bambara
      // bambara
      bambara: {
        translations: {
          "--fili dɔ kɛra": fili dɔ kɛra!, //a
           "--adrɛsi": Adrɛsiw,
           "--ladilikan": Ladilikan,
           "--ni i ye continue digi": Ni i ye continue digi i bɛna tigɛ ka bɔ i ka Veil Brillant jatebɔsɛbɛn na, //b
           "--ni i ye disconnect digi i bɛ tigɛ": Ni i ye Disconnect digi i bɛ tigɛ ka bɔ i ka izocash jatebɔsɛbɛn na,
           "--i ka nimɔrɔ virtuel lajɛ walima k'a lajɛ kokura kɔfɛ": I ka nimɔrɔ virtuel lajɛ walima k'a lajɛ kokura kɔfɛ, //c
           "--i ka nimɔrɔ virtuel lajɛ": I ka nimɔrɔ virtuel lajɛ,
           "--tɛmɛ": Tɛmɛ,
           "--jɛgɛn": Jɛɲɔgɔnya,
           "--ka baara kɛ ɲɔgɔn fɛ, ka ɲɛnamaya kɛ bɛn kɔnɔ": Baara kɛ ɲɔgɔn fɛ, ka ɲɛnamaya kɛ bɛn kɔnɔ ni mɔgɔ wɛrɛw ye,
           "--kan sugandi": Telefɔni kan lakika,
           "--kana ɲɔgɔndan bali": Kana ɲɔgɔndan bali, ka sababu di bɛɛ ma, //d
           "--jyɛnnatigɛ": Jɛɲɔgɔnya tigɛ, .
           "--telefɔni lakika baarakɛlaw bɛɛ ye": Telefɔni lakika baarakɛlaw bɛɛ fɛ, a ka ɲi ka baara kɛ ni VPN ye, //f
           "--taama don yɔrɔ la": Taga don yɔrɔ la, //g
           "--tariku": Tariku, //h
           "--i ye jate sɔrɔ": N ye jate sɔrɔ kaban, //i
           "--i tɛ jate sɔrɔ": N tɛ jate sɔrɔ,
           "--o ye i ka so ye": o ye i ka so ye,
           "--ja / wideyow +": Ja / Wideyo +,
           "--dantigɛli sɛgɛsɛgɛli": Danyɔrɔ sɛgɛsɛgɛli, .
           "--izocash ka kiliyanw ka dakun": izocash ka kiliyanw ka dakun,
           "--identité update san o san": Identity update san o san,
           "--izocash san ka": izocash San => izocash diɲɛ,
           "--don": Don!, //l
           "--don": Don,
           "--don ka veil brillant": Jɛɲɔgɔnya kɛ Veil Brillant kan,
           "--don vixinol magasin kɔnɔ": Jɛɲɔgɔnya kɛ Vixinol magasin na,
           "--don fu i ka veil Brillant jatebɔsɛbɛn kɔnɔ": Don fu i ka Veil Brillant jatebɔsɛbɛn kɔnɔ walasa ka se ka nin fɛɛrɛ in sɔrɔ,
           "--don ɲɛtaa": Donni ɲɛtaa!,
           "--don sisan": Don sisan!,
           "--logout ɲɛtaa": Bɔli ɲɛtaa!,
           "--bɔ": Bɔ,
           "--logout": Bɔ,
           "--jateden": Jateden, //n
           "--tɔgɔ": Tɔgɔ,
           "--sisan don": Sisan, Don!,
           "--dan tɛ ɲɛɲiniw dabɔli la":
           "--keleya tɛ, koniya tɛ": keleya tɛ, koniya tɛ, farali tɛ,
           "--ayi": Ayi,
           "--adrɛsi ofisiyaliw walasa ka se i ka telefɔni virtuel ma": Adrɛsi ofisiyaliw walasa ka don i ka telefɔni virtuel kɔnɔ, //o
           "--password": Daɲɛ dogolen, //p
           "--point bɔli izocash": Points bɔli izocash,
           "--point bɔli": Points bɔli,
           "--a ka fisa, ka baara kɛ ni vpn ye": A ka fisa, ka baara kɛ ni VPN ye min tɛ i ka ɛntɛrinɛti baarakɛyɔrɔ ta ye,
           "--timinandiya bɛ sara tuma bɛɛ": Timinandiya bɛ sara tuma bɛɛ laban na,
           "--sariya": Sariyaw, //r
           "--ladilikan": Ladilikanw,
           "--sɛbɛnni": Sɛbɛnni,
           "--signup to veil brillant": Aw ye aw tɔgɔ sɛbɛn Veil Brillant kan, //s
           "--i tɔgɔ sɛbɛn vixinol magasin na": I tɔgɔ sɛbɛn Vixinol magasin kan,
           "--signup": Aw ye aw tɔgɔ sɛbɛn,
           "--signup success": I tɔgɔ sɛbɛnni ɲɛnabɔra!,
           "--i tɔgɔ sɛbɛn fu": I tɔgɔ sɛbɛn fu,
           “--bolonɔbila ɲɛtaa IA”: Jɛɲɔgɔnya ɲɛtaa”,
           "--settings": "Labɛnw",
           "--alrani app sigili": Alrani porogaramu labɛnni,
           "--izocash app sigili": izocash porogaramu labɛnni,
           "--ka vixinol app sigi sen kan": Vixinol application labɛnni,
           "--ka veil Brillant app sigi sen kan": Veil Brillant application labɛnni,
           "--ja, wideyow marali": Jaw, wideyow ani fɛn damadɔ wɛrɛw marali,
           "--speed of reception": Kunnafoni sɔrɔli teliya ka bɔ Datacenter la,
           "--teliya": Teliya,
           "--terminate": Dabila, //t
           "--vpn b'a to i bɛ se ka don": VPN b'a to i bɛ se ka don yɔrɔ dɔ la walima porogaramu dɔ la, i ka ɛntɛrinɛti baarakɛyɔrɔ ye min bila lisi nɛrɛma kɔnɔ,
           "--jiri belebeleba tun bɛ san fɛ": Jiri belebeleba tun bɛ bɛɛ sanfɛ kisɛ fitinin nɔgɔman dɔ la,
           "--maga ekran kan": I bolo digi ekran kan walasa ka taa ɲɛ,
           "--a ɲini tugun": A ɲini tugun!,
           "--baarakɛla tɔgɔ": Baarakɛla tɔgɔ, //u

           "--jateden virtuel": Jate virtuel, //v
           "--telefɔni lakika sigicogo": Telefɔni lakika sigicogo,
           "--Telefɔnikan virtuel bɛ baara kɛ": Telefɔni kan virtuel bɛ baara kɛ baarakɛminɛnw hakɛ la ka kɛɲɛ ni a daminɛ ye,
           "--telefɔni virtuel": Telefɔni virtuel,
           "--dafalen": Tiɲɛni,
           "--aw ni ce izocash kiliyanw ka dakun na": Aw ni ce izocash kiliyanw ka dakun na, //w
           "--ka super code sɛbɛn": Super code dɔ don,
           "--aw ni ce": Aw ni ce,
           "--mɔgɔw hakili bɛ taa yɔrɔ min na": Mɔgɔw ​​hakili bɛ taa yɔrɔ min na wari bɛ taa,
           "--setigiw bɛ muɲu": Setigiw bɛ muɲu,
           "--i b'a fɛ ka bɔ i ka Alrani jatebɔsɛbɛn kɔnɔ wa": Yala i b'a fɛ ka bɔ i ka Alrani jatebɔsɛbɛn kɔnɔ wa?,
           "--ɔwɔ": Ɔwɔ, //y

           // jamana
           "--kongo": Kongo Brazaville,
           "--kameruni": Kameruni,
           "--drc": RDC,
           "--Kɔgɔjida ivoire": Côte Ivoire,

           // langue
        "--afirikikanw": Afirikikan, //a
        "--albanikan": Albanɛkan,
        "--amarikan": Amharikan,
        "--arabukan": Arabukan,
        "--armenikan": Armenikan,
        "--assamese": Assamese, .
        "--aymara": Aymara,
        "--azerbaïdjan": Azerbaïdjan,
        "--bambara": Bamanankan, //b
        "--bamanankan": Bamanankan,
        "--belarusian": Belaruskan,
        "--bengali": Bɛngali,
        "--bhojpuri": Bamanankan,
        "--bosnikan": Bosnikan,
        "--bulgarikan": Bulgarikan,
        "--katalan": Katalan, //c
        "--sebuano": Sebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Sinuwakan (Nɔgɔyalen),
        "--chineseLaada": Sinuwa (Laada),
        "--kɔrsikan": Kɔrsikan,
        "--kɔrɔsikan": Kɔrɔsikan,
        "--tcheki": Tcheki,
        "--danmakɛ": Danmakɛ, //d
        "--dhivehi": Ɲɛfɔli,
        "--dogri": Dogri, 1999.
        "--dutch": Ɔsitaralikan,
        "--bamanankan": Bamanankan, //e
        "--esperanto": Ɛsiperan,
        "--estonikan": Ɛsitɔnikan,
        "--sagaden": Sagaden,
        "--filipino": Filipinekan, //f
        "--finkan": Finlande,
        "--faransikan": Faransikan,
        "--frisikan": Frisikan,
        "--galician": Galisikan, //g
        "--georgikan": Georgiekan,
        "--alemaɲikan": Alemaɲikan,
        "--gɛrɛkikan": Gɛrɛkikan,
        "--guarani": Guarani,
        "--gujaratikan": Gujaratikan,
        "--haitianCreole": Haitikan Kreyol, //h
        "--hausa": Hausa,
        "--hawaiikan": Hawayikan,
        "--heburukan": Heburukan,
        "--hindi": Hindikan,
        "--hmong": Hmong, .
        "--hɔngirikan": Hɔngirikan,
        "--islandikan": Islandekan, //i
        "--igbo": Igbo,
        "--ilocano": Ilokan,
        "--indonezikan": Ɛndonezikan,
        "--irlandika": Irlandi,
        "--italikan": Italikan,
        "--japonkan": Zapɔnkan, //j
        "--javanakan": Javakan, .
        "--kannakan": Kannakan, //k
        "--kazakhstan": Kazak,
        "--khmer": Khmer, 1999.
        "--kinyarikan": Kinya,
        "--konkan": Konkan,
        "--korekan": Korekan,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdekan (Kurmanji),
        "--kurdishSorani": Kurdekan (Sorani),
        "--kirgisikan": Kirgizisi,
        "--lao": Lao, //l
        "--latin": Latin,
        "--letvikan": Letonikan,
        "--lingala": Lingala,
        "--lituwaniyakan": Lituwaniyakan,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourg,
        "--masedwanɛkan": Masedwanɛkan, //m
        "--maithili": Malikan,
        "--malagasi": Malagasi,
        "--malay": Malay,
        "--malayakan": Malayakan,
        "--maltese": Maliden,
        "--maori": Maori,
        "--marakan": Marakan,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolikan": Mɔngolikan,
        "--myanmarBurmekan": Myanmar (Birmankan),
        "--nepalikan": Nepalikan, //n
        "--norwegikan": Norvegekan,
        "--odiaOriya": Odiya (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persekan": Pɛrɛsikan,
        "--polish": Polisi,
        "--pɔrtugɛsikan": Pɔrtigɛkan,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romankan": Rumanikan, //r
        "--risikan": Irisikan,
        "--samoan": Samoan, //s
        "--sanskrikan": Sanskrikan,
        "--scotsGaelic": Ekɔsi Gaelic,
        "--sepedi": Sɛbɛnni,
        "--sɛrɛbikan": Sɛrɛbikan,
        "--fɔkan": Sesoto,
        "--shona": Shona, Bamako, Mali.
        "--sindi": Sinsinkan, 1999.
        "--sinhala": Sinhala, .
        "--slovakikan": Slovakikan,
        "--slovinikan": Slovinikan,
        "--somalikan": Somalikan,
        "--espagnol": Ɛsipaɲɔlikan,
        "--sundane": Sundakan, .
        "--swahilikan": Swahilikan,
        "--suwɛdikan": Suwɛdikan,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Tayilandi,
        "--tigrinya": Tigɛkan,
        "--tsonga": Tsonga,
        "--turkikan": Turkikan,
        "--turkmen": Turkimanw,
        "--twi": Twi,
        "--ukɛrɛnikan": Ukrayinakan, //u
        "--urdu": Urdukan,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--viyɛtnam": Vietnamkan, //v
        "--welsh": Waleskan, //w
        "--xhosa": Xhosa, //x
        "--yidikan": Yidikan, //y
        "--yoruba": Yoruba,
        "--zulu": Zulukan, //z
        },
      },

      // basque
      // basque
      basque: {
        translations: {
          "--an error has occurred": Errore bat gertatu da!, //a
           "--address": Helbideak,
           "--advice": Aholkua,
           "--jarraitu sakatuz": Jarraitu sakatuz zure Veil Brillant kontutik deskonektatuko zara, //b
           "--disconnect on clicking you will be disconnected": Deskonektatu klik eginez zure izocash kontutik deskonektatuko zara,
           "--check your virtual number or try again later": egiaztatu zure zenbaki birtuala edo saiatu berriro geroago, //c
           "--check your virtual number": Egiaztatu zure zenbaki birtuala,
           "--continue": Jarraitu,
           "--connection": Konexioa,
           "--kolaboratu, harmonian bizi": Elkarlanean aritu, besteekin harmonian bizi,
           "--choose language": Telefono birtualaren hizkuntza,
           "--ez prebenitzen lehia": Ez ezazu lehia eragotzi, denei aukera eman, //d
           "--disconnection": Deskonexioa,
           "--for all virtual phone users": Telefono birtualaren erabiltzaile guztientzat, VPN bat erabiltzea gomendatzen da, //f
           "--go to login page": Joan saioa hasteko orrira, //g
           "--historical": Historikoa, //h
           "--i have account": dagoeneko badut kontu bat, //i
           "--i don't have account": Ez daukat konturik,
           "--zure etxea da": zure etxea da,
           "--image / video +": Irudia / Bideoa +,
           "--identity verification": Identitatearen egiaztapena,
           "--izocash bezeroen ataria": izocash bezeroen ataria,
           "--identity update every year": Identitatearen eguneraketa urtero,
           "--izocash buy to": izocash Buy => izocash nazioarteko,
           "--log in": Hasi saioa!, //l
           "--login": Hasi saioa,
           "--login to veil brilliant": Konektatu Veil Brillant-era,
           "--login to vixinol store": konektatu Vixinol dendara,
           "--login for free to your veil Brillant account": Hasi saioa doan zure Veil Brillant kontuan eginbide honetara sartzeko,
           "--login success": Saioa hasi ondo!,
           "--login now": Hasi saioa orain!,
           "--logout success": Saioa amaitu ondo!,
           "--log out": Amaitu saioa,
           "--logout": Saioa amaitu,
           "--number": Zenbakia, //n
           "--name": Izena,
           "--now log in": Orain, hasi saioa!,
           "--lehia itotzeko debekurik ez":
           "--no jelosia, ez gorrotoa": ez jeloskortasunik, ez gorrotorik, ez zatiketarik,
           "--ez ez,
           "--oficial addresses to access your virtual phone": Helbide ofizialak zure telefono birtualean sartzeko, //o
           "--password": Pasahitza, //p
           "--points withdrawals izocash": Points retirazioak izocash,
           "--points withdrawals": puntuak kendu,
           "--preferably, use a vpn": hobe, erabili zure Interneteko zerbitzu-hornitzailearena ez den VPN bat,
           "--persistence always pay off": Iraunkortasunak beti ordaintzen du azkenean,
           "--rule": Arauak, //r
           "--recommendation": gomendioak,
           "--registration": Erregistroa,
           "--signup to veil brilliant": Erregistratu Veil Brillant-en, //s
           "--signup to vixinol store": erregistratu Vixinol dendan,
           "--signup": Erregistratu,
           "--signup success": Erregistratzea arrakastatsua da!,
           "--signup for free": erregistratu doan,
           “--signup success IA”: Konexioa arrakastatsua da”,
           "--settings": "Ezarpenak",
           "--setting the alrani app": Alrani aplikazioa konfiguratzen,
           "--setting up the izocash app": izocash aplikazioa konfiguratzen,
           "--setting up the vixinol app": Vixinol aplikazioa konfiguratzen,
           "--setting the veil Brillant aplikazioa": Veil Brillant aplikazioa konfiguratzen du,
           "--storage of images, videos": irudiak, bideoak eta beste hainbat elementu biltegiratzea,
           "--speed of receive": Datu-zentroko datuak jasotzeko abiadura,
           "--speed": Abiadura,
           "--terminate": Amaitu, //t
           "--the vpn allow you to access": VPNak zure Interneteko zerbitzu-hornitzaileak zerrenda beltzean jarri duen gune edo aplikazio batera sartzeko aukera ematen dizu,
           "--the most tree was above": Zuhaitz handiena hazi txiki sinple bat zen batez ere,
           "--touch the screen": ukitu pantaila jarraitzeko,
           "--try again": Saiatu berriro!,
           "--username": Erabiltzaile izena, //u

           "--virtual number": Zenbaki birtuala, //v
           "--virtual phone settings": telefono birtualaren ezarpenak,
           "--virtual Phone language is applyed": Telefono birtualaren hizkuntza aplikazio mailan aplikatzen da lehenespenez,
           "--virtual phone": Telefono birtuala,
           "--validate": Balidatu,
           "--welcome to the izocash customer portal": Ongi etorri izocash bezeroen atalera, //w
           "--write a super code": Sartu Super kodea,
           "--welcome to": Ongi etorri,
           "--pertsonen arreta nora doa": Jendearen arreta nora doa dirua,
           "--winners persevere": Irabazleek irauten dute,
           "--would you like it out your Alrani account": Zure Alrani kontutik saioa amaitu nahi duzu?,
           "--bai": Bai, //y

           // herrialdea
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Boli Kosta,

           // langue
        "--afrikans": Afrikaans, //a
        "--albanian": albaniera,
        "--amharic": Amharic,
        "--arabiar": arabiera,
        "--armeniarra": armeniarra,
        "--assamese": asamiera,
        "--aymara": aimara,
        "--azerbaijani": azerbaijanera,
        "--bambara": Bambara, //b
        "--euskara": euskara,
        "--bielorrusiera": bielorrusiera,
        "--bengali": bengalera,
        "--bhojpuri": Bhojpuri,
        "--bosniarra": bosniarra,
        "--bulgarian": bulgariera,
        "--catalan": katalana, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": txinera (sinplifikatua),
        "--chineseTraditional": txinera (tradizionala),
        "--corsican": korsikera,
        "--croatian": kroaziera,
        "--txekia": txekiera,
        "--danish": daniera, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--nederlandera": nederlandera,
        "--ingeles": ingelesa, //e
        "--esperanto": esperantoa,
        "--estoniera": estoniera,
        "--ewe": Ardia,
        "--filipino": Filipino, //f
        "--finnish": finlandiera,
        "--frantsesa": frantsesa,
        "--frisian": frisiera,
        "--galician": galego, //g
        "--georgian": georgiera,
        "--alemana": alemana,
        "--greek": greziera,
        "--guarani": guaraniera,
        "--gujarati": gujaratera,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": hebreera,
        "--hindi": hindia,
        "--hmong": Hmong,
        "--hungarian": hungariera,
        "--islandiera": islandiera, //i
        "--igbo": igboa,
        "--ilocano": Ilocano,
        "--indonesiera": indonesiera,
        "--irish": irlandera,
        "--italian": italiera,
        "--japoniera": japoniera, //j
        "--javanese": javanera,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": kinyarwanda,
        "--konkani": Konkani,
        "--korea": koreera,
        "--krio": Krio,
        "--kurdishKurmanji": kurduera (Kurmanji),
        "--kurdishSorani": kurduera (sorani),
        "--kyrgyz": kirgizera,
        "--lao": Lao, //l
        "--latin": latina,
        "--letvian": letoniera,
        "--lingala": lingala,
        "--lituaniera": lituaniera,
        "--luganda": Luganda,
        "--luxembourgish": luxenburgera,
        "--mazedoniar": mazedoniera, //m
        "--maithili": Maithili,
        "--malgasy": malgaxea,
        "--malay": malaysiera,
        "--malayalam": malayalamera,
        "--maltese": maltera,
        "--maori": maoria,
        "--marathi": marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongoliera,
        "--myanmarBurmese": Myanmar (birmania),
        "--nepali": nepalera, //n
        "--norwegian": norvegiera,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Paxtuera, //p
        "--pertsiera": persiera,
        "--polish": poloniera,
        "--portugesa": portugesa,
        "--punjabi": punjabera,
        "--quechua": kitxua, //q
        "--romanian": errumaniera, //r
        "--errusiera": errusiera,
        "--samoan": samoera, //s
        "--sanskrit": sanskritoa,
        "--scotsGaelic": eskoziar gaelikoa,
        "--sepedi": Sepedi,
        "--serbian": serbiera,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": sinhala,
        "--eslovakiera": eslovakiera,
        "--esloveniera": esloveniera,
        "--somalia": somaliera,
        "--gaztelania": gaztelania,
        "--sundanese": sundanera,
        "--swahili": Swahili,
        "--swedish": suediera,
        "--tajik": Tajik, //t
        "--tamil": tamil,
        "--tatar": tatariera,
        "--telugu": Telugu,
        "--thai": thailandiera,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turkiera,
        "--turkmen": turkmenera,
        "--twi": Twi,
        "--ukrainiera": ukrainera, //u
        "--urdu": Urdu,
        "--uigur": uigur,
        "--uzbek": uzbekera,
        "--vietnamese": vietnamera, //v
        "--welsh": galesera, //w
        "--xhosa": Xhosa, //x
        "--yiddish": yiddish, //y
        "--yoruba": yoruba,
        "--zulu": Zulu, //z
        },
      },

      // belarusian
      // belarusian
      belarusian: {
        translations: {
          "--an error has occurred": Адбылася памылка!, //a
          "--address": адрасы,
          "--advice": Парада,
          "--by clicking on continue": націскаючы на ​​кнопку працягваць, вы будзеце адключаны ад вашага ўліковага запісу Veil Brillant, //b
          "--націснуўшы на раз'яднанне, вы будзеце адключаны": націснуўшы на раз'яднанне, вы будзеце адключаны ад вашага ўліковага запісу izocash,
          «--check your virtual number or try again later»: Праверце свой віртуальны нумар або паўтарыце спробу пазней, //c
          "--check your virtual number": Праверце свой віртуальны нумар,
          "--continue": Працягнуць,
          "--connection": Злучэнне,
          "--collaborate, live in harmony": Супрацоўнічайце, жывіце ў гармоніі з іншымі,
          "--choose language": мова віртуальнага тэлефона,
          «--не перашкаджайце канкурэнцыі»: Не перашкаджайце канкурэнцыі, дайце кожнаму шанец, //d
          "--disconnection": Адключэнне,
          «--для ўсіх карыстальнікаў віртуальных тэлефонаў»: для ўсіх карыстальнікаў віртуальных тэлефонаў рэкамендуецца выкарыстоўваць VPN, //f
          "--go to login page": Перайсці на старонку ўваходу, //g
          "--historical": Гістарычны, //ч
          "--i have account": у мяне ўжо ёсць рахунак, //i
          «--i don't have account»: у мяне няма ўліковага запісу,
          "--гэта ваш дом": гэта ваш дом,
          "--image / video +": выява / відэа +,
          "--identity verification": праверка асобы,
          "--izocash customer portal": партал кліентаў izocash,
          "--ідэнтыфікацыйнае абнаўленне кожны год": абнаўленне ідэнтыфікацыйных дадзеных кожны год,
          "--izocash buy to": izocash Buy => izocash international,
          "--log in": Увайдзіце!, //l
          "--login": Увайсці,
          «--увайдзіце ў Veil Brillant»: падключыцеся да Veil Brillant,
          «--уваход у краму vixinol»: падключыцеся да крамы Vixinol,
          «--увайдзіце бясплатна ў свой уліковы запіс Veil Brillant»: увайдзіце бясплатна ў свой уліковы запіс Veil Brillant, каб атрымаць доступ да гэтай функцыі,
          "--login success": Уваход паспяховы!,
          "--login now": Увайдзіце зараз!,
          "--logout success": Выйсці паспяхова!,
          "--log out": Выйсці,
          "--logout": Выйсці,
          "--number": Нумар, //н
          "--name": імя,
          "--now log in": Зараз увайдзіце!,
          «--няма забароны на падаўленне канкурэнцыі»:
          «--без рэўнасці, без нянавісці»: без рэўнасці, без нянавісці, без падзелаў,
          "--не не,
          "--афіцыйныя адрасы для доступу да вашага віртуальнага тэлефона": афіцыйныя адрасы для доступу да вашага віртуальнага тэлефона //o
          "--password": Пароль, //с
          "--points выводы izocash": пункты зняцця izocash,
          "--points выводы": зняцце балаў,
          «--пажадана выкарыстоўваць vpn»: пажадана выкарыстоўваць VPN, які не належыць вашаму інтэрнэт-правайдэру,
          "--настойлівасць заўсёды акупляецца": настойлівасць заўсёды акупляецца ў рэшце рэшт,
          "--rule": Правілы, //r
          "--recommendation": Рэкамендацыі,
          "--registration": Рэгістрацыя,
          «--падпіска на Veil Brillant»: зарэгіструйцеся на Veil Brillant, //s
          «--зарэгістравацца ў краме vixinol»: зарэгіструйцеся ў краме Vixinol,
          "--signup": зарэгістравацца,
          "--signup success": рэгістрацыя паспяхова!,
          "--рэгістрацыя бясплатна": зарэгіструйцеся бясплатна,
          «--signup success IA»: злучэнне паспяховае»,
          "--settings": "Настройкі",
          "--настройка праграмы alrani": канфігурацыя праграмы Alrani,
          "--наладжванне прыкладання izocash": Налада прыкладання izocash,
          "--настройка праграмы vixinol": канфігурацыя праграмы Vixinol,
          «--наладжванне праграмы Veil Brillant»: Налада праграмы Veil Brillant,
          "--storage of images, videos": Захоўванне малюнкаў, відэа і некаторых іншых элементаў,
          «--хуткасць прыёму»: Хуткасць атрымання дадзеных з цэнтра апрацоўкі дадзеных,
          "--speed": хуткасць,
          "--terminate": Скончыць, //t
          «--vpn дазваляе вам атрымаць доступ»: VPN дазваляе вам атрымаць доступ да сайта або дадатку, якія ваш інтэрнэт-правайдэр занёс у чорны спіс,
          «--самае вялікае дрэва было вышэй»: самае вялікае дрэва было перш за ўсё простым маленькім зярняткам,
          "--touch the screen": Дакраніцеся да экрана, каб працягнуць,
          "--try again": паспрабуйце яшчэ раз!,
          "--username": Імя карыстальніка, //u

          "--virtual number": віртуальны нумар, //v
           "--virtual phone settings": налады віртуальнага тэлефона,
           «--прымяняецца мова віртуальнага тэлефона»: Мова віртуальнага тэлефона па змаўчанні прымяняецца на ўзроўні прыкладання,
           "--virtual phone": віртуальны тэлефон,
           "--validate": праверка,
           "--вітаем на партале кліентаў izocash": Сардэчна запрашаем на партал кліентаў izocash, //w
           "--write a super code": увядзіце суперкод,
           "--welcome to": Сардэчна запрашаем у,
           "--where people's attention goes goes": Куды ўвага людзей ідзе, грошы ідуць,
           «-winners persevere»: Пераможцы выстаяць,
           «--would you like to out of your Alrani account»: Вы хочаце выйсці са свайго ўліковага запісу Alrani?,
           "--yes": Так, //y

           // краіна
           "--congo": Конга Бразавіль,
           "--cameroon": Камерун,
           "--drc": ДРК,
           "--ivoryCoast": Бераг Слановай Косці,

           // мова
        "--афрыкаанс": афрыкаанс, //a
        "--albanian": албанскі,
        "--amharic": амхарскі,
        "--arabic": арабская,
        "--armenian": армянскі,
        "--assamese": асамская,
        "--aymara": аймара,
        "--azerbaijani": азербайджанскі,
        "--бамбара": Бамбара, // нар
        "--basque": баскскі,
        "--belarusian": беларускі,
        "--bengali": бенгальская,
        "--bhojpuri": бходжпурі,
        "--bosnian": басьнійскі,
        "--bulgarian": балгарскі,
        "--catalan": каталонскі, //c
        "--cebuano": кебуанскі,
        "--chichewa": Чычэва,
        "--chineseSimplified": кітайская (спрошчаная),
        "--chineseTraditional": кітайскі (традыцыйны),
        "--corsican": карсіканскі,
        "--croatian": харвацкая,
        "--czech": чэшскі,
        "--danish": дацкая, //d
        "--dhivehi": Дзівехі,
        "--dogri": Догры,
        "--dutch": галандскі,
        "--english": англійская, //e
        "--esperanto": эсперанта,
        "--estonian": эстонскі,
        "--ewe": авечка,
        "--filipino": філіпінскі, //f
        "--finnish": фінскі,
        "--france": французская,
        "--frisian": фрызская,
        "--galician": галісійскі, //г
        "--georgian": грузінскі,
        "--german": нямецкі,
        "--greek": грэцкі,
        "--guarani": Гуарані,
        "--gujarati": гуджараці,
        "--haitianCreole": гаіцянскі крэольскі, //ч
        "--hausa": хаўса,
        "--hawaiian": гавайскі,
        "--hebrew": іўрыт,
        "--hindi": хіндзі,
        "--hmong": Хмонг,
        "--hungarian": венгерскі,
        "--icelandic": ісландскі, //i
        "--igbo": ігба,
        "--ilocano": Ілакана,
        "--indonesian": інданезійскі,
        "--irish": ірландскі,
        "--italian": італьянскі,
        "--japanese": японскі, //j
        "--javanese": яванскі,
        "--kannada": каннада, //k
        "--kazakh": казахская,
        "--khmer": кхмерскі,
        "--kinyarwanda": кіньяруанда,
        "--konkani": канкані,
        "--korean": карэйская,
        "--krio": Крыо,
        "--kurdishKurmanji": курдская (курманджы),
        "--kurdishSorani": курдская (сарані),
        "--kyrgyz": кіргізскі,
        "--lao": Лао, //l
        "--latin": лацінскі,
        "--latvian": латышскі,
        "--lingala": Лінгала,
        "--lithuanian": літоўскі,
        "--luganda": Луганда,
        "--luxembourgish": люксембургскі,
        "--македонскі": македонскі, //м
        "--maithili": Майтхілі,
        "--malagasy": малагасійскі,
        "--malay": малайская,
        "--malayalam": малаялам,
        "--maltese": мальтыйская,
        "--maori": маары,
        "--marathi": маратхі,
        "--meiteilonManipuri": Мэйтэйлон (Маніпуры),
        "--mizo": Мізо,
        "--mongolian": мангольскі,
        "--myanmarBurmese": М'янма (бірманская),
        "--nepali": непальскі, //н
        "--norwegian": нарвежскі,
        "--odiaOriya": Одыя (Орыя), //o
        "--oromo": Арома,
        "--pashto": пушту, //с
        "--persian": фарсі,
        "--polish": польскі,
        "--portuguese": партугальская,
        "--punjabi": панджабі,
        "--quechua": кечуа, //q
        "--румынскі": румынскі, //р
        "--Russian": рускі,
        "--samoan": самаанскі, //s
        "--sanskrit": санскрыт,
        "--scotsGaelic": шатландская гэльская,
        "--sepedi": Сепеды,
        "--serbian": сербскі,
        "--sesotho": сесота,
        "--shona": шона,
        "--sindhi": сіндхі,
        "--sinhala": сінгальская,
        "--slovak": славацкая,
        "--slovenian": славенскі,
        "--somali": Самалі,
        "--spanish": іспанскі,
        "--sundanese": суданскі,
        "--swahili": суахілі,
        "--swedish": шведскі,
        "--таджык": таджыкскі, //т
        "--tamil": тамільская,
        "--tatar": татарскі,
        "--telugu": тэлугу,
        "--thai": тайская,
        "--tigrinya": тыгрынья,
        "--tsonga": Цонга,
        "--turkish": турэцкі,
        "--turkmen": туркменскі,
        "--twi": тві,
        «--укр»: украінскі, //у
        "--urdu": урду,
        "--uyghur": уйгурскі,
        "--uzbek": узбекскі,
        "--vietnamese": в'етнамская, //v
        "--welsh": валійская, //w
        "--xhosa": коса, //x
        "--ідыш": ідыш, //y
        "--yoruba": ёруба,
        "--zulu": зулу, //z
        },
      },

      // bengali
      // bengali
      bengali: {
        translations: {
          "--একটি ত্রুটি ঘটেছে": একটি ত্রুটি ঘটেছে!, //a
           "--address": ঠিকানা,
           "--advice": উপদেশ,
           "--এ ক্লিক করে চালিয়ে যান": অবিরত ক্লিক করে আপনি আপনার Veil Brillant অ্যাকাউন্ট থেকে সংযোগ বিচ্ছিন্ন হয়ে যাবেন, //b
           "--সংযোগ বিচ্ছিন্ন করাতে ক্লিক করলে আপনি সংযোগ বিচ্ছিন্ন হয়ে যাবেন": সংযোগ বিচ্ছিন্ন করার মাধ্যমে আপনি আপনার izocash অ্যাকাউন্ট থেকে সংযোগ বিচ্ছিন্ন হয়ে যাবেন,
           "--আপনার ভার্চুয়াল নম্বর পরীক্ষা করুন বা পরে আবার চেষ্টা করুন": আপনার ভার্চুয়াল নম্বর পরীক্ষা করুন বা পরে আবার চেষ্টা করুন, //c
           "--আপনার ভার্চুয়াল নম্বর পরীক্ষা করুন": আপনার ভার্চুয়াল নম্বর পরীক্ষা করুন,
           "--continue": চালিয়ে যান,
           "--সংযোগ": সংযোগ,
           "--সহযোগিতা করুন, সম্প্রীতিতে থাকুন": সহযোগিতা করুন, অন্যদের সাথে সাদৃশ্যে বাস করুন,
           "--ভাষা চয়ন করুন": ভার্চুয়াল ফোন ভাষা,
           "-প্রতিযোগিতা প্রতিরোধ করবেন না": প্রতিযোগিতায় বাধা দেবেন না, সবাইকে একটি সুযোগ দিন, //d
           "--সংযোগ বিচ্ছিন্ন": সংযোগ বিচ্ছিন্ন,
           "--সকল ভার্চুয়াল ফোন ব্যবহারকারীদের জন্য": সমস্ত ভার্চুয়াল ফোন ব্যবহারকারীদের জন্য, এটি একটি VPN ব্যবহার করার সুপারিশ করা হয়, //f
           "-- লগইন পৃষ্ঠায় যান": লগইন পৃষ্ঠায় যান, //g
           "--ঐতিহাসিক": ঐতিহাসিক, //ঘ
           "--আমার অ্যাকাউন্ট আছে": আমার ইতিমধ্যে একটি অ্যাকাউন্ট আছে, //i
           "--আমার অ্যাকাউন্ট নেই": আমার কোনো অ্যাকাউন্ট নেই,
           "-এটি আপনার বাড়ি": এটি আপনার বাড়ি,
           "--চিত্র / ভিডিও +": ছবি / ভিডিও +,
           "--পরিচয় যাচাইকরণ": পরিচয় যাচাইকরণ,
           "--izocash গ্রাহক পোর্টাল": izocash গ্রাহক পোর্টাল,
           "--পরিচয় আপডেট প্রতি বছর": প্রতি বছর পরিচয় আপডেট,
           "--izocash buy to": izocash Buy => izocash আন্তর্জাতিক,
           "--লগ ইন": লগ ইন!, //l
           "--login": লগ ইন,
           "-- login to veil brillant": Veil Brillant এর সাথে সংযোগ করুন,
           "--ভিক্সিনল স্টোরে লগইন করুন": ভিক্সিনল স্টোরের সাথে সংযোগ করুন,
           "--আপনার ওড়না ব্রিলিয়ান্ট অ্যাকাউন্টে বিনামূল্যে লগইন করুন": এই বৈশিষ্ট্যটি অ্যাক্সেস করতে আপনার ওয়েল ব্রিল্যান্ট অ্যাকাউন্টে বিনামূল্যে লগ ইন করুন,
           "--লগইন সফলতা": লগইন সফল!,
           "-- login now": এখন লগ ইন করুন!,
           "--লগআউট সফলতা": লগআউট সফল!,
           "--লগ আউট": লগআউট,
           "--logout": লগ আউট,
           "--সংখ্যা": সংখ্যা, //n
           "--নাম": নাম,
           "--এখন লগ ইন": এখন, লগ ইন!,
           "--- দমবন্ধ প্রতিযোগিতার উপর কোন নিষেধাজ্ঞা নেই":
           "--হিংসা নেই, ঘৃণা নেই": ঈর্ষা নেই, ঘৃণা নেই, বিভেদ নেই,
           "--না না,
           "আপনার ভার্চুয়াল ফোন অ্যাক্সেস করার জন্য অফিসিয়াল ঠিকানা": আপনার ভার্চুয়াল ফোন অ্যাক্সেস করার জন্য অফিসিয়াল ঠিকানা, //o
           "--পাসওয়ার্ড": পাসওয়ার্ড, //p
           "--পয়েন্ট প্রত্যাহার izocash": পয়েন্ট প্রত্যাহার izocash,
           "-পয়েন্ট প্রত্যাহার": পয়েন্ট প্রত্যাহার,
           "--preferably, use a vpn": বিশেষভাবে, একটি VPN ব্যবহার করুন যা আপনার ইন্টারনেট পরিষেবা প্রদানকারীর অন্তর্গত নয়,
           "---অধ্যবসায় সর্বদা অর্থ প্রদান করে": অধ্যবসায় সর্বদা শেষ পর্যন্ত পরিশোধ করে,
           "--রুল": নিয়ম, //r
           "--recommendation": সুপারিশ,
           "--Registration": নিবন্ধন,
           "--সাইন আপ টু ভেল ব্রিলিয়ান্ট": ভেল ব্রিলিয়ান্টে নিবন্ধন করুন, //s
           "--ভিক্সিনল স্টোরে সাইন আপ করুন": ভিক্সিনল স্টোরে নিবন্ধন করুন,
           "--সাইনআপ": নিবন্ধন করুন,
           "--সাইনআপ সাফল্য": নিবন্ধন সফল!,
           "--সাইনআপ বিনামূল্যে": বিনামূল্যে নিবন্ধন করুন,
           "--সাইনআপ সফল IA": সংযোগ সফল",
           "--settings": "সেটিংস",
           "--আলরানি অ্যাপ সেট আপ করা": আলরানি অ্যাপ্লিকেশন কনফিগার করা,
           "--izocash অ্যাপ সেট আপ করা": izocash অ্যাপ্লিকেশন কনফিগার করা,
           "-ভিক্সিনল অ্যাপ সেট আপ করা": ভিক্সিনল অ্যাপ্লিকেশন কনফিগার করা,
           "--ভেল ব্রিলিয়ান্ট অ্যাপ সেট আপ করা": ওড়না উজ্জ্বল অ্যাপ্লিকেশন কনফিগার করা,
           "--ইমেজ, ভিডিও স্টোরেজ": ছবি, ভিডিও এবং অন্যান্য অনেক উপাদানের স্টোরেজ,
           "--অভ্যর্থনার গতি": ডেটাসেন্টার থেকে ডেটা গ্রহণের গতি,
           "--গতি": গতি,
           "--টার্মিনেট": শেষ, //টি
           "--ভিপিএন আপনাকে অ্যাক্সেস করতে দেয়": ভিপিএন আপনাকে এমন একটি সাইট বা অ্যাপ্লিকেশন অ্যাক্সেস করতে দেয় যা আপনার ইন্টারনেট পরিষেবা প্রদানকারী কালো তালিকাভুক্ত করেছে,
           "---সবচেয়ে বড় গাছটি উপরে ছিল": সর্ববৃহৎ গাছটি ছিল একটি সাধারণ সামান্য বীজ,
           "--স্ক্রিন স্পর্শ করুন": চালিয়ে যেতে পর্দা স্পর্শ করুন,
           "--try again": আবার চেষ্টা করুন!,
           "--ব্যবহারকারীর নাম": ব্যবহারকারীর নাম, //u

           "--ভার্চুয়াল নম্বর": ভার্চুয়াল নম্বর, //v
           "--ভার্চুয়াল ফোন সেটিংস": ভার্চুয়াল ফোন সেটিংস,
           "--ভার্চুয়াল ফোন ভাষা প্রয়োগ করা হয়": ভার্চুয়াল ফোন ভাষা ডিফল্টরূপে অ্যাপ্লিকেশন স্তরে প্রয়োগ করা হয়,
           "--ভার্চুয়াল ফোন": ভার্চুয়াল ফোন,
           "--validate": যাচাই করুন,
           "-- izocash গ্রাহক পোর্টালে স্বাগতম": izocash গ্রাহক পোর্টালে স্বাগতম, //w
           "--একটি সুপার কোড লিখুন": একটি সুপার কোড লিখুন,
           "-ওয়েলকাম টু": স্বাগতম,
           "--- যেখানে মানুষের মনোযোগ যায়": যেখানে মানুষের মনোযোগ যায় টাকা যায়,
           "--বিজয়ী অধ্যবসায়": বিজয়ীরা অধ্যবসায়,
           "--আপনি কি আপনার আলরানি অ্যাকাউন্ট থেকে লগ আউট করতে চান": আপনি কি আপনার আলরানি অ্যাকাউন্ট থেকে লগ আউট করতে চান?,
           "--হ্যাঁ": হ্যাঁ, //y

           // দেশ
           "--কঙ্গো": কঙ্গো ব্রাজাভিল,
           "--cameroon": ক্যামেরুন,
           "--drc": DRC,
           "--ivoryCoast": আইভরি কোস্ট,

           // ভাষা
        "--আফ্রিকান্স": আফ্রিকান, //a
        "--আলবেনিয়ান": আলবেনিয়ান,
        "--আমহারিক": আমহারিক,
        "--আরবি": আরবি,
        "--আর্মেনিয়ান": আর্মেনিয়ান,
        "--assamese": অসমীয়া,
        "--আয়মারা": আয়মারা,
        "--আজারবাইজানি": আজারবাইজানীয়,
        "--বামবারা": বামবারা, //বি
        "--basque": বাস্ক,
        "---বেলারুশিয়ান": বেলারুশিয়ান,
        "--বাংলা": বাংলা,
        "--ভোজপুরি": ভোজপুরি,
        "--বসনিয়ান": বসনিয়ান,
        "--বুলগেরিয়ান": বুলগেরিয়ান,
        "--catalan": কাতালান, //c
        "--সেবুয়ানো": সেবুয়ানো,
        "--চিচেওয়া": চিচেওয়া,
        "--chineseSimplified": চীনা (সরলীকৃত),
        "--ChineseTraditional": চাইনিজ (ঐতিহ্যগত),
        "--কর্সিকান": কর্সিকান,
        "--ক্রোয়েশিয়ান": ক্রোয়েশিয়ান,
        "--চেক": চেক,
        "--danish": ড্যানিশ, //d
        "--ধিভেহি": দিভেহি,
        "--ডোগরি": ডোগরি,
        "--ডাচ": ডাচ,
        "--ইংরেজি": ইংরেজি, //ই
        "--এসপেরান্তো": এস্পেরান্তো,
        "--এস্তোনিয়ান": এস্তোনিয়ান,
        "--ewe": Ewe,
        "--ফিলিপিনো": ফিলিপিনো, //f
        "--ফিনিশ": ফিনিশ,
        "--ফ্রেঞ্চ": ফরাসি,
        "--ফ্রিসিয়ান": ফ্রিজিয়ান,
        "--গ্যালিসিয়ান": গ্যালিসিয়ান, //g
        "--জর্জিয়ান": জর্জিয়ান,
        "--জার্মান": জার্মান,
        "--greek": গ্রীক,
        "--গুয়ারানি": গুয়ারানি,
        "--গুজরাটি": গুজরাটি,
        "--haitianCreole": হাইতিয়ান ক্রেওল, //h
        "--hausa": হাউসা,
        "--হাওয়াইয়ান": হাওয়াইয়ান,
        "--হিব্রু": হিব্রু,
        "---হিন্দি": হিন্দি,
        "--hmong": Hmong,
        "--হাঙ্গেরিয়ান": হাঙ্গেরিয়ান,
        "--আইসল্যান্ডিক": আইসল্যান্ডিক, //i
        "--igbo": ইগবো,
        "--ilocano": Ilocano,
        "--ইন্দোনেশিয়ান": ইন্দোনেশিয়ান,
        "--আইরিশ": আইরিশ,
        "--ইটালিয়ান": ইতালীয়,
        "--জাপানি": জাপানিজ, //j
        "--জাভানিজ": জাভানিজ,
        "--কন্নড়": কন্নড়, //k
        "--কাজাখ": কাজাখ,
        "--খমের": খমের,
        "--কিনিয়ারওয়ান্ডা": কিনিয়ারওয়ান্ডা,
        "--কোঙ্কানি": কোঙ্কানি,
        "--কোরিয়ান": কোরিয়ান,
        "--ক্রিও": ক্রিও,
        "--kurdishKurmanji": কুর্দি (কুরমাঞ্জি),
        "--kurdishSorani": কুর্দি (সোরানি),
        "--কির্গিজ": কিরগিজ,
        "--lao": লাও, //l
        "--ল্যাটিন": ল্যাটিন,
        "--লাটভিয়ান": লাটভিয়ান,
        "--লিঙ্গালা": লিঙ্গালা,
        "--লিথুয়ানিয়ান": লিথুয়ানিয়ান,
        "--লুগান্ডা": লুগান্ডা,
        "--luxembourgish": Luxembourgish,
        "--ম্যাসিডোনিয়ান": ম্যাসেডোনিয়ান, //মি
        "--মৈথিলী": মৈথিলী,
        "--মালাগাসি": মালাগাসি,
        "--malay": মালয়,
        "--মালায়ালম": মালায়লাম,
        "--- মালটিজ": মাল্টিজ,
        "--মাওরি": মাওরি,
        "--মারাঠি": মারাঠি,
        "--মেইটেইলন মণিপুরি": মেইটেইলন (মণিপুরি),
        "--মিজো": মিজো,
        "--মঙ্গোলিয়ান": মঙ্গোলিয়ান,
        "--myanmarBurmese": মায়ানমার (বর্মী),
        "--নেপালি": নেপালি, //n
        "--নরওয়েজিয়ান": নরওয়েজিয়ান,
        "--odiaOriya": Odia (ওড়িয়া), //o
        "--oromo": ওরোমো,
        "--pashto": পশতু, //p
        "--পার্সিয়ান": ফার্সি,
        "--পলিশ": পোলিশ,
        "--পর্তুগিজ": পর্তুগিজ,
        "--পাঞ্জাবি": পাঞ্জাবি,
        "--quechua": কেচুয়া, //q
        "--রোমানিয়ান": রোমানিয়ান, //আর
        "--রাশিয়ান": রাশিয়ান,
        "--সমোয়ান": সামোয়ান, //s
        "--সংস্কৃত": সংস্কৃত,
        "--scotsGaelic": স্কটস গ্যালিক,
        "--সেপেদি": সেপেদি,
        "--সার্বিয়ান": সার্বিয়ান,
        "--সেসোথো": সেসোথো,
        "--শোনা": সোনা,
        "--sindhi": সিন্ধি,
        "--সিনহালা": সিংহল,
        "--স্লোভাক": স্লোভাক,
        "--স্লোভেনীয়": স্লোভেনীয়,
        "--সোমালি": সোমালি,
        "--স্প্যানিশ": স্প্যানিশ,
        "--সুদানিজ": সুদানিজ,
        "--স্বাহিলি": সোয়াহিলি,
        "--সুইডিশ": সুইডিশ,
        "--তাজিক": তাজিক, //t
        "--তামিল": তামিল,
        "--তাতার": তাতার,
        "--তেলেগু": তেলুগু,
        "--থাই": থাই,
        "--টাইগ্রিনিয়া": টাইগ্রিনিয়া,
        "--সোঙ্গা": সোঙ্গা,
        "--তুর্কি": তুর্কি,
        "--তুর্কমেন": তুর্কমেন,
        "--twi": টুই,
        "--ইউক্রেনীয়": ইউক্রেনীয়, //u
        "--urdu": উর্দু,
        "--উইঘুর": উইঘুর,
        "--উজবেক": উজবেক,
        "--ভিয়েতনামী": ভিয়েতনামী, //v
        "--welsh": ওয়েলশ, //w
        "--xhosa": জোসা, //x
        "--ইদ্দিশ": য়িদ্দিশ, //y
        "--yoruba": ইওরুবা,
        "--জুলু": জুলু, //z
        },
      },

      // bhojpuri
      // bhojpuri
      bhojpuri: {
        translations: {
          "--एक त्रुटि भइल बा": एगो त्रुटि भइल बा!, //a
          "--पता": पता, 1999 के बा।
          "--सलाह": सलाह, 1999 के बा।
          "--जारी पर क्लिक करके": जारी रखे पर क्लिक करके रउआ अपना वेल ब्रिलंट खाता से डिस्कनेक्ट हो जाईब, //b
          "--डिस्कनेक्ट पर क्लिक कइला से रउरा डिस्कनेक्ट हो जाईं": डिस्कनेक्ट पर क्लिक कइला से रउरा अपना इजोकैश खाता से डिस्कनेक्ट हो जाईं,
          "--अपना वर्चुअल नंबर के जांच करीं या बाद में दोबारा कोशिश करीं": आपन वर्चुअल नंबर के जांच करीं या बाद में दोबारा कोशिश करीं, //c
          "--अपना वर्चुअल नंबर के जांच करीं": आपन वर्चुअल नंबर के जांच करीं,
          "--जारी": जारी रखीं,
          "--कनेक्ट": कनेक्शन, 1999 के बा।
          "--सहयोग करीं, सामंजस्य में रहीं": सहयोग करीं, दोसरा के साथे सामंजस्य में रहीं,
          "--भाषा चुनीं": वर्चुअल फोन भाषा,
          "--प्रतिस्पर्धा मत रोकीं": प्रतिस्पर्धा मत रोकीं, सभका के मौका दीं, //d
          "--विच्छेद": कटौती, 1999 के बा।
          "--सब वर्चुअल फोन यूजर खातिर": सभ वर्चुअल फोन यूजर खातिर, वीपीएन, //f के इस्तेमाल करे के सलाह दिहल जाला
          "--लॉगिन पन्ना पर जाईं": लॉगिन पन्ना पर जाईं, //g
          "--ऐतिहासिक": ऐतिहासिक, //ज
          "--हमरा लगे खाता बा": हमरा लगे पहिले से खाता बा, //i
          "--हमरा लगे खाता नइखे": हमरा लगे खाता नइखे,
          "--ई तहार घर ह": इ तहार घर ह,
          "--छवि / वीडियो +": छवि / वीडियो +, के बा।
          "--पहचान सत्यापन": पहचान सत्यापन,
          "--izocash ग्राहक पोर्टल": izocash ग्राहक पोर्टल, 1999 के बा।
          "--हर साल पहचान अपडेट": हर साल पहचान अपडेट,
          "--izocash के खरीदें": izocash खरीदें => izocash अंतर्राष्ट्रीय,
          "--लॉग इन करीं": लॉग इन करीं!, //l
          "--लॉगिन": लॉग इन करीं,
          "--घूंघट शानदार से लॉगिन करीं": घूंघट शानदार से कनेक्ट करीं,
          "--विक्सिनॉल स्टोर में लॉगिन करीं": विक्सिनॉल स्टोर से कनेक्ट करीं,
          "--अपना घूंघट ब्रिलंट खाता में मुफ्त में लॉग इन करीं": एह सुविधा के एक्सेस करे खातिर अपना घूंघट ब्रिलंट खाता में मुफ्त में लॉग इन करीं,
          "--लॉगिन सफलता": लॉगिन सफल भइल!,
          "--अब लॉग इन करीं": अब लॉग इन करीं!,
          "--लॉगआउट सफलता": लॉगआउट सफल भइल!,
          "--लॉग आउट": लॉगआउट, 1999 के बा।
          "--लॉगआउट": लॉग आउट करीं,
          "--नंबर": संख्या, //एन के बा
          "--नाम": नाम, 1999 के बा।
          "--अब लॉग इन करीं": अब, लॉग इन करीं!,
          "--प्रतिस्पर्धा के दबावे पर कवनो रोक ना":
          "--ना ईर्ष्या, ना नफरत": ना ईर्ष्या, ना नफरत, ना बंटवारा,
          "--ना": ना, ना,
          "--अपना वर्चुअल फोन तक पहुँचे खातिर आधिकारिक पता": आपके वर्चुअल फोन तक पहुँचे खातिर आधिकारिक पता, //o
          "--पासवर्ड": पासवर्ड, //पृष्ठ 11 पर बा
          "--बिंदु निकासी izocash": अंक निकासी izocash, 1999 के बा।
          "--बिंदु निकासी": अंक निकासी, 1999 के बा।
          "--अच्छा तरीका से, vpn के इस्तेमाल करीं": बेहतर तरीका से, अइसन वीपीएन के इस्तेमाल करीं जवन आपके इंटरनेट सेवा प्रदाता के ना होखे,
          "--जिद हमेशा फल देला": जिद हमेशा अंत में फल देला,
          "--नियम": नियम, //आर के बा
          "--सिफारिश": सिफारिश कइल गइल,
          "--पंजीकरण": पंजीकरण, 1999 के बा।
          "--घूंघट शानदार करे खातिर साइनअप": घूंघट शानदार पर रजिस्टर करीं, //s
          "--विक्सिनॉल स्टोर में साइनअप करीं": विक्सिनॉल स्टोर पर रजिस्टर करीं,
          "--साइनअप": रजिस्टर करीं,
          "--साइनअप सफलता": रजिस्ट्रेशन सफल भइल!,
          "--मुफ्त में साइनअप करीं": मुफ्त में रजिस्टर करीं,
          “--साइनअप सफलता आईए”: कनेक्शन सफल”,
          "--सेटिंग्स": "सेटिंग्स",
          "--अलरानी ऐप के सेटअप कइल": अलरानी एप्लिकेशन के कॉन्फ़िगर कइल,
          "--izocash ऐप के सेटअप कइल": izocash एप्लिकेशन के कॉन्फ़िगर कइल,
          "--विक्सिनॉल ऐप के सेटअप कइल": विक्सिनॉल एप्लिकेशन के कॉन्फ़िगर कइल,
          "--घूंघट ब्रिलंट ऐप के सेटअप": घूंघट ब्रिलंट एप्लिकेशन के कॉन्फ़िगर कइल,
          "--बिम्ब, वीडियो के भंडारण": छवि, वीडियो आ कई गो अउरी तत्व सभ के भंडारण,
          "--रिसेप्शन के गति": डाटासेंटर से डेटा के रिसेप्शन के गति,
          "--गति": गति, 1999 के बा।
          "--समाप्त": समाप्त कइल, //टी
          "--vpn रउआ के एक्सेस करे के अनुमति देला": वीपीएन रउआ के कवनो साइट भा एप्लीकेशन तक पहुँचे के अनुमति देला जवना के रउआ इंटरनेट सेवा प्रदाता ब्लैकलिस्ट कइले बा,
          "--सबसे बड़का पेड़ ऊपर रहे": सबसे बड़का पेड़ सबले ऊपर एगो साधारण छोट बीज रहे,
          "--स्क्रीन के टच करीं": जारी रखे खातिर स्क्रीन के टच करीं,
          "--फिर से कोशिश करीं": दोबारा कोशिश करीं!,
          "--उपयोगकर्ता के नाम": प्रयोगकर्ता के नाम, //u

          "--वर्चुअल नंबर": वर्चुअल नंबर, //v
           "--वर्चुअल फोन सेटिंग्स": वर्चुअल फोन सेटिंग्स,
           "--वर्चुअल फोन भाषा लागू कइल गइल बा": वर्चुअल फोन भाषा डिफ़ॉल्ट रूप से एप्लीकेशन स्तर पर लागू कइल जाला,
           "--वर्चुअल फोन": वर्चुअल फोन, 1999 के बा।
           "--मान्य कइल": मान्य कइल,
           "--izocash ग्राहक पोर्टल पर राउर स्वागत बा": izocash ग्राहक पोर्टल पर राउर स्वागत बा, //w
           "--सुपर कोड लिखीं": सुपर कोड दर्ज करीं,
           "--के स्वागत बा": स्वागत बा,
           "--जहाँ लोग के ध्यान जाला": जहाँ लोग के ध्यान जाला पईसा जाला,
           "--विजेता लोग जिद्द करेला": विजेता लोग जिद्द करेला,
           "--का रउआ अपना अलरानी खाता से लॉग आउट कइल चाहत बानी": का रउआ अपना अलरानी खाता से लॉग आउट कइल चाहत बानी?,
           "--हाँ": हँ, //y

           // देश
           "--कांगो": कांगो ब्राज़ाविले, 1999 में भइल।
           "--कैमरून": कैमरून, 1999 के बा।
           "--drc": डीआरसी, 1999 के बा।
           "--ivoryCoast": आइवरी कोस्ट, 1999 के बा।

           // लैंग्वे के बा
        "--अफ्रीकन": अफ्रीकी, //ए
        "--अल्बेनियाई": अल्बेनियाई, 1999 के बा।
        "--अमहारिक": अमहारिक, 1999 में भइल।
        "--अरबी": अरबी, 1999 में भइल।
        "--आर्मेनियाई": आर्मेनियाई, 1999 के बा।
        "--असामी": असमिया, 1999 में भइल।
        "--अयमारा": आयमारा, 1999।
        "--अजरबैजानी": अजरबैजानी, 1999 के बा।
        "--बम्बरा": बम्बरा, //ख के बा
        "--बास्क": बास्क, 1999।
        "--बेलारूसी": बेलारूसी, 1999 के बा।
        "--बंगाली": बंगाली, 1999 में भइल रहे।
        "--भोजपुरी": भोजपुरी,
        "--बोस्नियाई": बोस्नियाई, 1999 के बा।
        "--बल्गेरियाई": बल्गेरियाई, 1999 के बा।
        "--कैटेलोनियाई": कैटेलोनियाई, //सी
        "--सेबुआनो": सेबुआनो, 1999 में भइल।
        "--चिचेवा": चिचेवा, 1999।
        "--chineseSimplified": चीनी (सरलीकृत),
        "--chineseTraditional": चीनी (पारंपरिक), के बा।
        "--कोर्सिकन": कोर्सिकन, 1999 के बा।
        "--क्रोएशियाई": क्रोएशियाई, 1999 के बा।
        "--चेक": चेक, 1999 के बा।
        "--डेनिश": डेनिश, //घ के बा
        "--धिवेही": धिवेही, 1999।
        "--डोगरी": डोगरी, 1999।
        "--डच": डच, 1999 के बा।
        "--अंग्रेजी": अंग्रेजी, //ई
        "--एस्पेरान्तो": एस्पेरान्तो, 1999 में भइल।
        "--एस्टोनियाई": एस्टोनियाई, 1999 के बा।
        "--भेड़": भेड़, 1999।
        "--फिलिपिनो": फिलिपिनो, //च के बा
        "--फिनिश": फिनिश, 1999 के बा।
        "--फ्रेंच": फ्रेंच, 1999 के बा।
        "--फ्रीजियन": फ्रीजियन, 1999 के बा।
        "--गैलिशियन्": गैलिशियन्, //जी
        "--जॉर्जियन": जॉर्जियाई, 1999 के बा।
        "--जर्मन": जर्मन, 1999 के बा।
        "--ग्रीक": ग्रीक, 1999 में भइल।
        "--गुआरानी": गुआरानी, 1999।
        "--गुजरती": गुजराती, 1999।
        "--haitianCreole": हैतीयन क्रियोल, //एच के बा
        "--हौसा": हौसा, 1999।
        "--हवाई": हवाईयन, 1999 के बा।
        "--हिब्रू": हिब्रू, 1999 में भइल।
        "--हिंदी": हिन्दी, 1999 में भइल।
        "--हमोंग": हमोंग, 1999 के बा।
        "--हंगरी": हंगरी, 1999 के बा।
        "--आइसलैंडिक": आइसलैंडिक, //i
        "--इग्बो": इग्बो, 1999 के बा।
        "--इलोकानो": इलोकानो, 1999 के बा।
        "--इंडोनेशियाई": इंडोनेशियाई, 1999 में भइल।
        "--आयरिश": आयरिश, 1999 के बा।
        "--इटैलियन": इटैलियन, 1999 में भइल।
        "--जापानी": जापानी, //जे के बा
        "--जावानी": जावानी, 1999 के बा।
        "--कन्नड़": कन्नड़, //क के बा
        "--कजाख": कजाख, 1999 में भइल।
        "--खमेर": खमेर, 1999 के बा।
        "--किन्यरवांडा": किन्यारवांडा, 1999 में भइल रहे।
        "--konkani": कोंकणी, 1999।
        "--कोरियाई": कोरियाई, 1999 के बा।
        "--क्रिओ": क्रिओ, 1999 के बा।
        "--kurdishKurmanji": कुर्द (कुर्मनजी), 1999 में भइल रहे।
        "--kurdishSorani": कुर्द (सोरानी), 1999 में भइल रहे।
        "--किर्गिज़": किर्गिज़, 1999 में भइल।
        "--लाओ": लाओ, //एल के बा
        "--लैटिन": लैटिन, 1999 में भइल।
        "--लातवियाई": लातवियाई, 1999 के बा।
        "--लिंगला": लिंगला, 1999 में भइल।
        "--लिथुआनियाई": लिथुआनियाई, 1999 में भइल।
        "--लुगांडा": लुगांडा, 1999 में भइल।
        "--लक्समबर्गिश": लक्समबर्ग, 1999 में भइल।
        "--मैसिडोनियाई": मैसिडोनियाई, //एम
        "--मैथिली": मैथिली,
        "--मालागासी": मालागासी, 1999 में भइल।
        "--मलय": मलय, 1999 के बा।
        "--मलयालम": मलयालम, 1999 में भइल।
        "--माल्टीज": माल्टीज, 1999 के बा।
        "--माओरी": माओरी, 1999।
        "--मराठी": मराठी, 1999।
        "--meiteilonManipuri": Meiteilon (मणिपुरी), 1999 में भइल रहे।
        "--मिजो": मिजो, 1999 में भइल रहे।
        "--मंगोलियन": मंगोलियाई, 1999 के बा।
        "--myanmarबर्मी": म्यांमार (बर्मी), 1999 में भइल रहे।
        "--नेपाली": नेपाली, //न
        "--नार्वे के": नार्वे के,
        "--ओडियाओरिया": ओडिया (उड़िया), //ओ
        "--ओरोमो": ओरोमो, 1999 में भइल रहे।
        "--पश्तो": पश्तो, //पृष्ठ 11 पर बा
        "--फारसी": फारसी, 1999 में भइल।
        "--पॉलिश": पॉलिश, 1999 के बा।
        "--पुर्तगाली": पुर्तगाली, 1999 में भइल।
        "--पंजाबी": पंजाबी, 1999 में भइल।
        "--क्वेचुआ": क्वेचुआ, //क्यू
        "--रोमानियन": रोमानियाई, //आर
        "--रूसी": रूसी, 1999 के बा।
        "--समोआन": समोआन, //एस के बा
        "--संस्कृत": संस्कृत, 1999 में भइल।
        "--scotsGaelic": स्कॉट्स गेलिक, 1999 के बा।
        "--सेपेडी": सेपेडी, 1999।
        "--सर्बियाई": सर्बियाई, 1999 के बा।
        "--सेसोथो": सेसोथो, 1999 में भइल रहे।
        "--शोना": शोना, 1999 में भइल रहे।
        "--सिंधी": सिंधी, 1999।
        "--सिंहला": सिंहली, 1999 में भइल।
        "--स्लोवाक": स्लोवाक, 1999 के बा।
        "--स्लोवेनियाई": स्लोवेनियाई, 1999 के बा।
        "--सोमाली": सोमाली, 1999 के बा।
        "--स्पेनिश": स्पेनिश, 1999 के बा।
        "--सुंडानी": सुंडानी, 1999 के बा।
        "--स्वाहिली": स्वाहिली, 1999 में भइल।
        "--स्वीडिश": स्वीडिश, 1999 के बा।
        "--ताजिक": ताजिक, //टी के बा
        "--तमिल": तमिल, 1999।
        "--तातार": तातार, 1999।
        "--तेलुगु": तेलुगु, 1999।
        "--थाई": थाई, 1999 के बा।
        "--tigrinya": तिग्रिनिया, 1999 में भइल रहे।
        "--त्सोंगा": त्सोंगा, 1999 के बा।
        "--तुर्की": तुर्की, 1999 में भइल।
        "--तुर्कमेन": तुर्कमेन, 1999 में भइल रहे।
        "--twi": ट्वी, 1999 के बा।
        "--यूक्रेनी": यूक्रेनी, //यू के बा
        "--उर्दू": उर्दू, 1999।
        "--उयघुर": उइघुर, 1999।
        "--उजबेक": उजबेक, 1999 में भइल रहे।
        "--वियतनाम": वियतनामी, //वी
        "--वेल्श": वेल्स, //डब्ल्यू के बा
        "--xhosa": ज़ोसा, //x के बा
        "--यिद्दिश": यिद्दीश, //वाई के बा
        "--योरूबा": योरूबा, 1999 के बा।
        "--जुलु": ज़ुलु, //जेड के बा
        },
      },

      // bosnian
      // bosnian
      bosnian: {
        translations: {
          "--došlo je do greške": Došlo je do greške!, //a
           "--address": Adrese,
           "--advice": Savjet,
           "--klikom na nastavak": Klikom na nastavak bit ćete isključeni sa svog Veil Brillant računa, //b
           "--klikom na prekinuti vezu bit ćete isključeni": Klikom na Disconnect bit ćete isključeni sa svog izocash računa,
           "--provjerite svoj virtualni broj ili pokušajte ponovo kasnije": Provjerite svoj virtualni broj ili pokušajte ponovo kasnije, //c
           "--provjerite svoj virtuelni broj": Provjerite svoj virtuelni broj,
           "--continue": Nastavi,
           "--connection": Veza,
           "--sarađujte, živite u harmoniji": Sarađujte, živite u harmoniji sa drugima,
           "--odaberi jezik": Virtuelni jezik telefona,
           "--ne sprečavaj konkurenciju": Ne sprečavaj konkurenciju, daj svima šansu, //d
           "--disconnection": Isključivanje,
           "--za sve korisnike virtualnog telefona": Za sve korisnike virtualnog telefona, preporučuje se korištenje VPN-a, //f
           "--idi na stranicu za prijavu": Idi na stranicu za prijavu, //g
           "--historical": Historical, //h
           "--imam nalog": Već imam nalog, //i
           "--nemam račun": nemam račun,
           "--to je tvoja kuća": to je tvoja kuća,
           "--slika / video +": slika / video +,
           "--verifikacija identiteta": provjera identiteta,
           "--izocash korisnički portal": izocash korisnički portal,
           "--ažuriranje identiteta svake godine": ažuriranje identiteta svake godine,
           "--izocash kupi za": izocash Kupi => izocash international,
           "--log in": Prijavite se!, //l
           "--login": Prijavite se,
           "--login to Veil Brillant": Povežite se na Veil Brillant,
           "--login to vixinol store": Povežite se s prodavnicom Vixinol,
           "--prijavite se besplatno na svoj Veil Brillant nalog": Prijavite se besplatno na svoj Veil Brillant nalog da biste pristupili ovoj funkciji,
           "--login success": Prijava je uspješna!,
           "--login now": Prijavite se sada!,
           "--logout success": Odjava je uspješna!,
           "--log out": Odjava,
           "--logout": Odjava,
           "--broj": Broj, //n
           "--name": Ime,
           "--sad log in": Sada, prijavite se!,
           "--nema zabrane gušenja konkurencije":
           "--bez ljubomore, bez mržnje": Bez ljubomore, bez mržnje, bez podjela,
           "--ne ne,
           "--zvanične adrese za pristup vašem virtuelnom telefonu": Službene adrese za pristup vašem virtuelnom telefonu, //o
           "--password": Lozinka, //str
           "--points podizanja izocash": Points withdrawals izocash,
           "--povlačenje bodova": Povlačenje bodova,
           "--poželjno, koristite vpn": Po mogućnosti koristite VPN koji ne pripada vašem dobavljaču internetskih usluga,
           "--upornost se uvijek isplati": Upornost se na kraju uvijek isplati,
           "--pravilo": Pravila, //r
           "--recommendation": Preporuke,
           "--registration": Registracija,
           "--prijava za veil brilliant": Registrirajte se na Veil Brillant, //s
           "--prijava u prodavnicu vixinol": Registrirajte se na Vixinol prodavnici,
           "--signup": Registracija,
           "--signup success": Registracija je uspjela!,
           "--registrirajte se besplatno": Registrirajte se besplatno,
           “--uspješna registracija IA”: Veza uspješna”,
           "--settings": "Postavke",
           "--postavljanje aplikacije alrani": Konfiguriranje aplikacije Alrani,
           "--podešavanje aplikacije izocash": Konfigurisanje aplikacije izocash,
           "--podešavanje aplikacije vixinol": konfigurisanje aplikacije Vixinol,
           "--postavljanje aplikacije Veil Brillant": Konfiguriranje aplikacije Veil Brillant,
           "--pohrana slika, video zapisa": Pohrana slika, video zapisa i nekoliko drugih elemenata,
           "--brzina prijema": Brzina prijema podataka iz Data centra,
           "--speed": brzina,
           "--terminate": Završi, //t
           "--vpn vam omogućava pristup": VPN vam omogućava pristup web-mjestu ili aplikaciji koju je vaš internet provajder stavio na crnu listu,
           "--najveće drvo je bilo iznad": Najveće drvo je bilo pre svega jednostavno malo seme,
           "--dodirni ekran": Dodirnite ekran da nastavite,
           "--pokušaj ponovo": Pokušajte ponovo!,
           "--username": Korisničko ime, //u

           "--virtualni broj": Virtuelni broj, //v
           "--virtualne postavke telefona": Postavke virtuelnog telefona,
           "--virtualni jezik telefona je primijenjen": Jezik virtuelnog telefona se prema zadanim postavkama primjenjuje na nivou aplikacije,
           "--virtualni telefon": Virtuelni telefon,
           "--validate": Potvrda,
           "--dobrodošli na portal za korisnike izocash": Dobrodošli na portal za korisnike izocash, //w
           "--write a super code": Unesite Super kod,
           "--welcome to": Dobrodošli u,
           "--kuda ide pažnja ljudi": Gdje ide pažnja ljudi ide novac,
           "--winners persevers": Pobjednici istraju,
           "--da li se želite odjaviti sa svog Alrani naloga": Želite li da se odjavite sa svog Alrani naloga?,
           "--yes": Da, //y

           // zemlja
           "--kongo": Kongo Brazavil,
           "--kamerun": Kamerun,
           "--drc": DRC,
           "--IvoryCoast": Obala Slonovače,
           
           // langue
        "--afrikaans": afrikaans, //a
        "--albanski": albanski,
        "--amharski": amharski,
        "--arapic": arapski,
        "--armenski": jermenski,
        "--asamski": asamski,
        "--aymara": Aymara,
        "--azerbajdžanski": azerbejdžanski,
        "--bambara": Bambara, //b
        "--basque": baskijski,
        "--belarusian": bjeloruski,
        "--bengalski": bengalski,
        "--bhojpuri": bhojpuri,
        "--bosnian": bosanski,
        "--bugarski": bugarski,
        "--katalonski": katalonski, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kineski (pojednostavljeni),
        "--chineseTraditional": kineski (tradicionalni),
        "--corsican": korzikanski,
        "--hrvatski": hrvatski,
        "--češki": češki,
        "--danish": danski, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--holandski": holandski,
        "--engleski": engleski, //e
        "--esperanto": esperanto,
        "--estonian": estonski,
        "--ewe": Ewe,
        "--filipino": filipinski, //f
        "--finnish": finski,
        "--francuski": francuski,
        "--frizijski": frizijski,
        "--galicijski": galicijski, //g
        "--gruzijski": gruzijski,
        "--njemački": njemački,
        "--grčki": grčki,
        "--guarani": Guarani,
        "--gudžarati": gudžarati,
        "--haitianCreole": haićanski kreolski, //h
        "--hausa": Hausa,
        "--hawaiian": havajski,
        "--hebrew": hebrejski,
        "--hindi": hindi,
        "--hmong": Hmong,
        "--mađarski": mađarski,
        "--islandski": islandski, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--idonezijski": indonežanski,
        "--irish": irski,
        "--italijanski": italijanski,
        "--japanese": japanski, //j
        "--javanese": javanski,
        "--kannada": kannada, //k
        "--kazakh": kazaški,
        "--khmer": kmerski,
        "--kinyarwanda": kinyarwanda,
        "--konkani": Konkani,
        "--korean": korejski,
        "--krio": Krio,
        "--kurdishKurmanji": kurdski (Kurmanji),
        "--kurdishSorani": kurdski (sorani),
        "--kyrgyz": kirgiski,
        "--lao": Lao, //l
        "--latin": latinica,
        "--latvijski": letonski,
        "--lingala": Lingala,
        "--litvanski": litvanski,
        "--luganda": Luganda,
        "--luxembourgish": luksemburški,
        "--makedonski": makedonski, //m
        "--maithili": maithili,
        "--magaskarski": malgaški,
        "--malay": malajski,
        "--malajalam": malajalam,
        "--maltese": malteški,
        "--maori": maori,
        "--marathi": marati,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolski": mongolski,
        "--myanmarburmanski": mianmar (burmanski),
        "--nepali": nepalski, //n
        "--norveški": norveški,
        "--odiaOriya": Odia (Orija), //o
        "--oromo": Oromo,
        "--pašto": pašto, //str
        "--perzijski": perzijski,
        "--polish": poljski,
        "--portugalski": portugalski,
        "--pandžabi": pandžabi,
        "--quechua": kečua, //q
        "--rumunski": rumunski, //r
        "--russian": ruski,
        "--samoan": samoanski, //s
        "--sanskrit": sanskrit,
        "--scotsGaelic": Škotski galski,
        "--sepedi": Sepedi,
        "--srpski": srpski,
        "--sesotho": sesoto,
        "--shona": Šona,
        "--sindhi": sindhi,
        "--sinhala": sinhalski,
        "--slovak": slovački,
        "--slovenski": slovenski,
        "--somali": somalijski,
        "--španski": španski,
        "--sundanese": sundanski,
        "--swahili": svahili,
        "--švedski": švedski,
        "--tajik": tadžički, //t
        "--tamil": tamilski,
        "--tatar": tatarski,
        "--telugu": teluški,
        "--thai": tajlandski,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turski,
        "--turkmen": turkmenski,
        "--twi": Twi,
        "--ukrajinski": ukrajinski, //u
        "--urdu": urdu,
        "--uyghur": ujgurski,
        "--uzbek": uzbečki,
        "--vijetnamski": vijetnamski, //v
        "--welsh": velški, //w
        "--xhosa": Xhosa, //x
        "--yiddish": jidiš, //y
        "--yoruba": joruba,
        "--zulu": Zulu, //z
        },
      },

      // bulgarian
      // bulgarian
      bulgarian: {
        translations: {
          "--възникна грешка": Възникна грешка!, //a
          "--address": Адреси,
          "--advice": Съвет,
          „--чрез щракване върху продължаване“: Щраквайки върху продължаване, връзката с вашия акаунт в Veil Brillant ще бъде прекъсната, //b
          „--като щракнете върху прекъсване на връзката, ще бъдете прекъснати“: Като щракнете върху Прекъсване на връзката, ще бъдете прекъснати от вашия акаунт в izocash,
          "--проверете своя виртуален номер или опитайте отново по-късно": Проверете вашия виртуален номер или опитайте отново по-късно, //c
          "--проверете своя виртуален номер": Проверете вашия виртуален номер,
          "--continue": Продължете,
          "--connection": Връзка,
          "--collaborate, live in harmony": Сътрудничете, живейте в хармония с другите,
          "--изберете език": Виртуален телефонен език,
          "--не предотвратявайте конкуренцията": Не предотвратявайте конкуренцията, дайте шанс на всички, //d
          "--disconnection": Прекъсване на връзката,
          „--за всички потребители на виртуални телефони“: За всички потребители на виртуални телефони се препоръчва да използват VPN, //f
          "--go to login page": Отидете на страницата за вход, //g
          "--historical": Исторически, //h
          "--i have account": Вече имам акаунт, //i
          "--нямам акаунт": нямам акаунт,
          "--it is your house": това е твоята къща,
          "--image / video +": Изображение / Video +,
          "--identity verification": Проверка на самоличността,
          "--izocash портал за клиенти": izocash портал за клиенти,
          "--identity update every year": Актуализация на самоличността всяка година,
          "--izocash buy to": izocash Buy => izocash international,
          "--влезте": Влезте!, //l
          "--login": Влезте,
          "--влезте в veil brilliant": Свържете се с Veil Brillant,
          „--влезте в магазина на vixinol“: Свържете се с магазина на Vixinol,
          „--влезте безплатно във вашия акаунт във Veil Brillant“: Влезте безплатно във вашия акаунт в Veil Brillant за достъп до тази функция,
          "--login success": Успешно влизане!,
          "--login now": Влезте сега!,
          "--logout success": Успешно излизане!,
          "--log out": Изход,
          "--logout": Излезте,
          "--number": Число, //n
          "--name": Име,
          "--now log in": Сега, влезте!,
          „--без забрана за задушаване на конкуренцията“:
          "--без ревност, без омраза": Без ревност, без омраза, без разделения,
          "--не не,
          "--официални адреси за достъп до вашия виртуален телефон": Официални адреси за достъп до вашия виртуален телефон, //o
          "--password": Парола, //стр
          "--теглене на точки izocash": Теглене на точки izocash,
          "--теглене на точки": Теглене на точки,
          „--за предпочитане, използвайте vpn“: За предпочитане е да използвате VPN, който не принадлежи на вашия доставчик на интернет услуги,
          „--постоянството винаги се отплаща“: Постоянството винаги се отплаща в крайна сметка,
          "--rule": Правила, //r
          "--recommendation": Препоръки,
          "--registration": Регистрация,
          "--регистрирайте се за veil brilliant": Регистрирайте се на Veil Brillant, //s
          „--регистрирайте се в магазина на vixinol“: Регистрирайте се в магазина на Vixinol,
          "--signup": Регистрирайте се,
          "--signup success": Регистрацията е успешна!,
          „--регистрирайте се безплатно“: Регистрирайте се безплатно,
          „--успешна регистрация IA“: Успешна връзка“,
          "--settings": "Настройки",
          "--настройване на приложението alrani": Конфигуриране на приложението Alrani,
          "--настройване на приложението izocash": Конфигуриране на приложението izocash,
          „--настройване на приложението vixinol“: Конфигуриране на приложението Vixinol,
          „--настройване на приложението Veil Brillant“: Конфигуриране на приложението Veil Brillant,
          "--съхранение на изображения, видеоклипове": Съхранение на изображения, видеоклипове и няколко други елемента,
          "--скорост на приемане": Скорост на получаване на данни от центъра за данни,
          "--speed": Скорост,
          "--terminate": Прекратяване, //t
          „--vpn ви позволява достъп“: VPN ви позволява достъп до сайт или приложение, което вашият доставчик на интернет услуги е включил в черния списък,
          „--най-голямото дърво беше горе“: Най-голямото дърво беше преди всичко просто малко семе,
          "--touch the screen": Докоснете екрана, за да продължите,
          "--try again": Опитайте отново!,
          "--username": потребителско име, //u

          "--virtual number": Виртуален номер, //v
           "--virtual phone settings": настройки на виртуален телефон,
           „--прилага се език на виртуалния телефон“: Езикът на виртуалния телефон се прилага на ниво приложение по подразбиране,
           "--virtual phone": Виртуален телефон,
           "--validate": Проверка,
           "--добре дошли в портала за клиенти на izocash": Добре дошли в портала за клиенти на izocash, //w
           "--write a super code": Въведете супер код,
           "--добре дошли в": Добре дошли в,
           „--където отива вниманието на хората“: Където отива вниманието на хората отиват парите,
           "--winners persevere": Победителите продължават,
           „--бихте ли искали да излезете от вашия акаунт в Alrani“: Искате ли да излезете от вашия акаунт в Alrani?,
           "--yes": Да, //y

           // държава
           "--congo": Конго Бразавил,
           "--cameroon": Камерун,
           "--drc": ДРК,
           "--ivoryCoast": Кот д'Ивоар,

           // език
        "--африкаанс": африканс, //a
        "--albanian": албански,
        "--amharic": амхарски,
        "--arabic": арабски,
        "--armenian": арменски,
        "--assamese": асамски,
        "--aymara": аймара,
        "--azerbaijani": азербайджански,
        "--bambara": Бамбара, //b
        "--basque": баски,
        "--беларуски": беларуски,
        "--bengali": бенгалски,
        "--bhojpuri": бходжпури,
        "--bosnian": босненски,
        "--bulgarian": български,
        "--catalan": каталонски, //c
        "--cebuano": себуано,
        "--chichewa": Чичева,
        "--chineseSimplified": китайски (опростен),
        "--chineseTraditional": китайски (традиционен),
        "--corsican": корсикански,
        "--croatian": хърватски,
        "--czech": чешки,
        "--danish": датски, //d
        "--dhivehi": дивехи,
        "--dogri": Догри,
        "--dutch": холандски,
        "--english": английски, //e
        "--esperanto": Есперанто,
        "--estonian": естонски,
        "--ewe": Еве,
        "--filipino": филипински, //f
        "--finnish": фински,
        "--френски": френски,
        "--frisian": фризийски,
        "--galician": галисийски, //g
        "--грузински": грузински,
        "--german": немски,
        "--greek": гръцки,
        "--гуарани": Гуарани,
        "--gujarati": гуджарати,
        "--haitianCreole": хаитянски креолски, //h
        "--hausa": Хауса,
        "--hawaiian": хавайски,
        "--hebrew": иврит,
        "--hindi": хинди,
        "--hmong": Хмонг,
        "--hungarian": унгарски,
        "--исландски": исландски, //i
        "--igbo": Игбо,
        "--ilocano": Илокано,
        "--indonesian": индонезийски,
        "--irish": ирландски,
        "--italian": италиански,
        "--japanese": японски, //j
        "--javanese": явански,
        "--kannada": каннада, //k
        "--kazakh": казахски,
        "--khmer": кхмерски,
        "--kinyarwanda": Киняруанда,
        "--konkani": Конкани,
        "--korean": корейски,
        "--krio": Крио,
        "--kurdishKurmanji": кюрдски (Kurmanji),
        "--kurdishSorani": кюрдски (сорани),
        "--kyrgyz": киргизки,
        "--lao": Лао, //l
        "--latin": латински,
        "--latvian": латвийски,
        "--лингала": Лингала,
        "--lithuanian": литовски,
        "--luganda": Луганда,
        "--luxembourgish": люксембургски,
        "--македонски": македонски, //м
        "--maithili": майтхили,
        "--malagasy": мадагаскарски,
        "--malay": малайски,
        "--malayalam": малаялам,
        "--maltese": малтийски,
        "--maori": Маори,
        "--marathi": маратхи,
        "--meiteilonManipuri": Мейтейлон (Манипури),
        "--mizo": Мизо,
        "--mongolian": монголски,
        "--myanmarBurmese": Мианмар (бирмански),
        "--непалски": непалски, //n
        "--norwegian": норвежки,
        "--odiaOriya": Одия (Ория), //o
        "--oromo": Оромо,
        "--пащу": пущу, //стр
        "--persian": персийски,
        "--polish": полски,
        "--portuguese": португалски,
        "--punjabi": Пенджаби,
        "--quechua": Кечуа, //q
        "--румънски": румънски, //r
        "--руски": руски,
        "--samoan": самоански, //s
        "--санскрит": санскрит,
        "--scotsGaelic": шотландски галски,
        "--sepedi": Сепеди,
        "--сръбски": сръбски,
        "--sesoto": сесото,
        "--shona": Шона,
        "--sindhi": Синдхи,
        "--sinhala": сингалски,
        "--slovak": словашки,
        "--slovenian": словенски,
        "--somali": сомалийски,
        "--spanish": испански,
        "--sundanese": сундански,
        "--суахили": суахили,
        "--swedish": шведски,
        "--таджик": таджикски, //t
        "--tamil": тамилски,
        "--tatar": татарски,
        "--telugu": телугу,
        "--thai": тайландски,
        "--тигриня": Тигриня,
        "--tsonga": Цонга,
        "--turkish": турски,
        "--turkmen": туркменски,
        "--twi": Twi,
        "--ukrainian": украински, //u
        "--urdu": урду,
        "--uyghur": уйгурски,
        "--uzbek": узбекски,
        "--vietnamese": виетнамски, //v
        "--welsh": уелски, //w
        "--xhosa": Коса, //x
        "--yiddish": идиш, //y
        "--yoruba": йоруба,
        "--zulu": зулу, //z
        },
      },

      // catalan
      // catalan
      catalan: {
        translations: {
          "--s'ha produït un error": S'ha produït un error!, //a
          "--address": adreces,
          "--advice": Consell,
          "--fent clic a continuar": fent clic a continuar se us desconnectarà del vostre compte de Veil Brillant, //b
          "--fer clic a desconnectar se us desconnectarà": fent clic a Desconnectar se us desconnectarà del vostre compte izocash,
          "--check your virtual number or try again later": comproveu el vostre número virtual o torneu-ho a provar més tard, //c
          "--check your virtual number": comproveu el vostre número virtual,
          "--continue": Continua,
          "--connection": connexió,
          "--collaborar, viure en harmonia": Col·laborar, viure en harmonia amb els altres,
          "--choose language": Idioma del telèfon virtual,
          "--no impedir la competició": No impedir la competència, donar una oportunitat a tothom, //d
          "--disconnection": Desconnexió,
          "--for all virtual phone users": per a tots els usuaris de Virtual Phone, es recomana utilitzar una VPN, //f
          "--go to login page": aneu a la pàgina d'inici de sessió, //g
          "--historical": Històric, //h
          "--I have account": Ja tinc un compte, //i
          "--no tinc compte": no tinc cap compte,
          "--és la teva casa": és la teva casa,
          "--image / video +": imatge/vídeo +,
          "--identity verification": verificació d'identitat,
          "--izocash portal de clients": portal de clients izocash,
          "--identity update every year": actualització d'identitat cada any,
          "--izocash comprar a": izocash Buy => izocash internacional,
          "--log in": Inicieu sessió!, //l
          "--login": Inicieu sessió,
          "--login to veil brillant": connecteu-vos a Veil Brillant,
          "--login to vixinol store": connecteu-vos a Vixinol Store,
          "--inicieu sessió gratuïtament al vostre compte de Veil Brillant": inicieu sessió gratuïtament al vostre compte de Veil Brillant per accedir a aquesta funció,
          "--login success": Inici de sessió correcte!,
          "--login now": Inicieu sessió ara!,
          "--logout success": Tanqueu la sessió correcta!,
          "--log out": tancar la sessió,
          "--logout": tancar la sessió,
          "--number": nombre, //n
          "--name": nom,
          "--now log in": Ara, inicieu sessió!,
          "--no prohibeix sufocar la competència":
          "--sense gelosia, sense odi": sense gelosia, sense odi, sense divisions,
          "--no": No,
          "--oficial addresses to access your virtual phone": adreces oficials per accedir al vostre telèfon virtual, //o
          "--password": contrasenya, //p
          "--points retirades izocash": Retirada de punts izocash,
          "--points retirades": retirades de punts,
          "--preferably, use a vpn": preferiblement, utilitzeu una VPN que no pertanyi al vostre proveïdor de serveis d'Internet,
          "--persistence always pay off": La persistència sempre paga els seus fruits al final,
          "--rule": regles, //r
          "--recommendation": recomanacions,
          "--registration": Registre,
          "--signup to veil brillant": registreu-vos a Veil Brillant, //s
          "--inscriure's a la botiga vixinol": registreu-vos a la botiga Vixinol,
          "--signup": registre,
          "--signup success": Registre correcte!,
          "--signup for free": registreu-vos gratuïtament,
          "--signup success IA": connexió correcta",
          "--settings": "Configuració",
          "--setting up the alrani app": Configuració de l'aplicació Alrani,
          "--configuració de l'aplicació izocash": Configuració de l'aplicació izocash,
          "--setting up the vixinol app": Configuració de l'aplicació Vixinol,
          "--setting up the veil Brillant app": Configuració de l'aplicació Veil Brillant,
          "--emmagatzematge d'imatges, vídeos": emmagatzematge d'imatges, vídeos i diversos altres elements,
          "--speed of reception": velocitat de recepció de dades del centre de dades,
          "--speed": velocitat,
          "--terminate": Termina, //t
          "--la VPN us permet accedir": la VPN us permet accedir a un lloc o a una aplicació que el vostre proveïdor de serveis d'Internet té a la llista negra,
          "--l'arbre més gran estava a sobre": L'arbre més gran era sobretot una simple llavor,
          "--touch the screen": toqueu la pantalla per continuar,
          "--try again": Torna-ho a provar!,
          "--username": Nom d'usuari, //u

          "--virtual number": número virtual, //v
           "--virtual phone settings": configuració del telèfon virtual,
           "--s'aplica l'idioma del telèfon virtual": l'idioma del telèfon virtual s'aplica al nivell d'aplicació de manera predeterminada,
           "--virtual phone": telèfon virtual,
           "--validate": Valida,
           "--benvingut al portal del client izocash": Benvingut al portal del client izocash, //w
           "--write a super code": introduïu un super codi,
           "--welcome to": Benvingut a,
           "--on va l'atenció de la gent": on va l'atenció de la gent van els diners,
           "--winners persevere": els guanyadors perseveren,
           "--vols tancar la sessió del teu compte d'Alrani": vols tancar la sessió del teu compte d'Alrani?,
           "--yes": Sí, //y

           // país
           "--congo": Congo Brazzaville,
           "--camerun": Camerun,
           "--drc": RDC,
           "--ivoryCoast": Costa d'Ivori,

           // llengua
        "--afrikaans": Afrikàans, //a
        "--albanian": albanès,
        "--amharic": amàric,
        "--àrab": àrab,
        "--armenian": armeni,
        "--assamese": assamès,
        "--aymara": aimara,
        "--azerbaijani": azerbaidjan,
        "--bambara": Bambara, //b
        "--basc": basc,
        "--bielorús": bielorús,
        "--bengali": bengalí,
        "--bhojpuri": Bhojpuri,
        "--bosnian": bosnià,
        "--bulgarian": búlgar,
        "--catalan": català, //c
        "--cebuano": cebuà,
        "--chichewa": Chichewa,
        "--chineseSimplified": xinès (simplificat),
        "--chineseTraditional": xinès (tradicional),
        "--corsic": cors,
        "--croatian": croat,
        "--txec": txec,
        "--danish": danès, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--neerlandès": holandès,
        "--anglés": anglès, //e
        "--esperanto": esperanto,
        "--estonian": estonià,
        "--ewe": Ovella,
        "--filipino": filipí, //f
        "--finès": finès,
        "--francès": francès,
        "--frisian": frisó,
        "--galician": gallec, //g
        "--georgian": georgià,
        "--german": alemany,
        "--greek": grec,
        "--guarani": guaraní,
        "--gujarati": gujarati,
        "--haitianCreole": crioll haitiano, //h
        "--hausa": Hausa,
        "--hawaiian": hawaià,
        "--hebreu": hebreu,
        "--hindi": hindi,
        "--hmong": Hmong,
        "--hungarian": hongarès,
        "--islandic": islandès, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": indonesi,
        "--irlandès": irlandès,
        "--italià": italià,
        "--japonès": japonès, //j
        "--javanese": javanès,
        "--kannada": Kannada, //k
        "--kazakh": kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": kinyarwanda,
        "--konkani": Konkani,
        "--corean": coreà,
        "--krio": Krio,
        "--kurdishKurmanji": kurd (Kurmanji),
        "--kurdishSorani": kurd (sorani),
        "--kyrgyz": kirguiz,
        "--lao": Lao, //l
        "--latin": llatí,
        "--letvian": letó,
        "--lingala": lingala,
        "--lituanian": lituà,
        "--luganda": Luganda,
        "--luxembourgish": luxemburguès,
        "--macedonian": macedoni, //m
        "--maithili": Maithili,
        "--malgasy": malgaxe,
        "--malay": malai,
        "--malayalam": malayalam,
        "--maltese": maltès,
        "--maori": maorí,
        "--marathi": marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongol,
        "--myanmarBurmese": Myanmar (birmà),
        "--nepali": nepalí, //n
        "--noruec": noruec,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persa": persa,
        "--polish": polonès,
        "--portuguese": portuguès,
        "--punjabi": panjabi,
        "--quechua": quítxua, //q
        "--romanian": romanès, //r
        "--rus": rus,
        "--samoan": samoà, //s
        "--sanskrit": sànscrit,
        "--scotsGaelic": gaèlic escocès,
        "--sepedi": Sepedi,
        "--serbian": serbi,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": cingalès,
        "--eslovac": eslovac,
        "--eslovènia": eslovè,
        "--somali": somali,
        "--espanyol": espanyol,
        "--sundanese": sundanès,
        "--swahili": suahili,
        "--swedish": suec,
        "--tajik": Tadjik, //t
        "--tamil": tàmil,
        "--tatar": tàrtar,
        "--telugu": telugu,
        "--thai": tailandès,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turk": turc,
        "--turkmen": turkmen,
        "--twi": Twi,
        "--ucraïnès": ucraïnès, //u
        "--urdu": urdú,
        "--uigur": uigur,
        "--uzbek": uzbek,
        "--vietnamese": vietnamita, //v
        "--welsh": gal·lès, //w
        "--xhosa": Xhosa, //x
        "--yiddish": yiddish, //y
        "--yoruba": ioruba,
        "--zulu": zulú, //z
        },
      },

      // cebuano
      // cebuano
      cebuano: {
        translations: {
          "--an error has occurred": Usa ka sayop ang nahitabo!, //a
           "--address": Mga adres,
           "--advice": Tambag,
           "--by clicking on continue": Pinaagi sa pag-klik sa continue ma-disconnect ka sa imong Veil Brillant account, //b
           "--by clicking on disconnect you will be disconnected": Pinaagi sa pag-klik sa Disconnect ikaw ma-disconnect sa imong izocash account,
           "--susiha ang imong virtual nga numero o sulayi pag-usab unya": Susiha ang imong virtual nga numero o sulayi pag-usab sa ulahi, //c
           "--check ang imong virtual nga numero": Susiha ang imong virtual nga numero,
           "--padayon": Padayon,
           "--koneksyon": Koneksyon,
           "--collaborate, live in harmony": Pagtinabangay, pagpuyo nga nahiuyon sa uban,
           "--choose language": Virtual Phone Language,
           "--don't prevent competition": Ayaw pugngi ang kompetisyon, hatagi ug higayon ang tanan, //d
           "--disconnection": Pagdiskonekta,
           "--for all virtual phone users": Para sa tanang Virtual Phone users, girekomendar ang paggamit ug VPN, //f
           "--go to login page": Adto sa login page, //g
           "--historical": Kasaysayan, //h
           "--i have account": Naa na koy account, //i
           "--wala koy account": Wala koy account,
           "--kini imong balay": kini imong balay,
           "--image / video +": Hulagway / Video +,
           "--identity verification": Pagpamatuod sa identidad,
           "--izocash customer portal": izocash Customer Portal,
           "--identity update kada tuig": Identity update kada tuig,
           "--izocash buy to": izocash Buy => izocash nga internasyonal,
           "--log in": Log in!, //l
           "--login": Log in,
           "--login to veil brilliant": Sumpaysumpaya sa Veil Brillant,
           "--login sa vixinol store": Sumpaysumpaya sa Vixinol Store,
           "--login nga libre sa imong veil Brillant account": Log in nga libre sa imong Veil Brillant nga account aron ma-access kini nga feature,
           "--login success": Malampuson ang pag-login!,
           "--login now": Log in karon!,
           "--logout success": Malampuson ang pag-logout!,
           "--log out": Pag-logout,
           "--logout": Log out,
           "--number": Numero, //n
           "--name": Ngalan,
           "--now log in": Karon, Log in!,
           "--walay pagdili sa pagpugong sa kompetisyon":
           "--walay pangabugho, walay pagdumot": Walay pangabugho, walay pagdumot, walay pagkabahin,
           "--dili dili,
           "--opisyal nga mga adres aron ma-access ang imong virtual nga telepono": Opisyal nga mga adres aron ma-access ang imong virtual nga telepono, //o
           "--password": Pasword, //p
           "--points withdrawals izocash": Points Withdrawals izocash,
           "--points withdrawals": Points Withdrawals,
           "--mas maayo, gamita ang vpn": Mas maayo, gamita ang VPN nga dili iya sa imong internet service provider,
           "--persistence always pays off": Ang pagkamakanunayon kanunay nga mabayran sa katapusan,
           "--rule": Mga lagda, //r
           "--recommendation": Mga rekomendasyon,
           "--registration": Pagparehistro,
           "--signup to veil brilliant": Register sa Veil Brillant, //s
           "--signup to vixinol store": Register sa Vixinol Store,
           "--signup": Pagrehistro,
           "--signup success": Malampuson ang pagparehistro!,
           "--signup for free": Pagrehistro nga libre,
           "--signup success IA": Malampuson ang koneksyon",
           "--settings": "Mga setting",
           "--set up the alrani app": Pag-configure sa Alrani application,
           "--setting up the izocash app": Pag-configure sa izocash application,
           "--set up the vixinol app": Pag-configure sa Vixinol application,
           "--set up the veil Brillant app": Pag-configure sa Veil Brillant nga aplikasyon,
           "--storage of images, videos": Pagtipig sa mga hulagway, video ug uban pang elemento,
           "--speed of reception": Speed ​​sa pagdawat sa data gikan sa Datacenter,
           "--speed": Bilis,
           "--terminate": Tapuson, //t
           "--ang vpn nagtugot kanimo sa pag-access": Ang VPN nagtugot kanimo sa pag-access sa usa ka site o usa ka aplikasyon nga gi-blacklist sa imong internet service provider,
           "--ang kinadak-ang kahoy sa ibabaw": Ang kinadak-ang kahoy labaw sa tanan usa ka yano nga gamay nga liso,
           "--touch the screen": Paghikap sa screen aron magpadayon,
           "--try again": Sulayi pag-usab!,
           "--username": Username, //u

           "--virtual number": Virtual nga numero, //v
           "--virtual phone settings": Virtual setting sa telepono,
           "--virtual Phone language is applied": Ang Virtual Phone nga pinulongan kay gipadapat sa lebel sa aplikasyon pinaagi sa default,
           "--virtual phone": Virtual nga telepono,
           "--validate": I-validate,
           "--welcome sa izocash customer portal": Welcome sa izocash Customer Portal, //w
           "--write a super code": Pagsulod ug Super code,
           "--welcome to": Welcome sa,
           "--diin ang atensyon sa mga tawo moadto": Kung diin ang atensyon sa mga tawo moadto ang kuwarta,
           "--winners persevere": Ang mga mananaog nagpadayon,
           "--gusto ka ba nga mu-log out sa imong Alrani account": Gusto ka bang mu-log out sa imong Alrani account?,
           "--oo": Oo, //y

           // nasod
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // pinulongan
        "--afrikaans": Aprikaans, //a
        "--albanian": Albaniano,
        "--amharic": Amharic,
        "--arabic": Arabiko,
        "--armenian": Armenian,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusian,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnian,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Intsik (Gisimple),
        "--chineseTraditional": Intsik (Tradisyonal),
        "--corsican": Corsican,
        "--croatian": Croatian,
        "--czech": Czech,
        "--danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Dutch,
        "--english": English, //e
        "--esperanto": Esperanto,
        "--estonian": Estonian,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": Pinlandes,
        "--french": Pranses,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "--german": Aleman,
        "--greek": Griyego,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": Hebreohanon,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilokano,
        "--indonesian": Indonesian,
        "--irish": Irish,
        "--italian": Italyano,
        "--japanese": Hapon, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Koreano,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": Latviano,
        "--lingala": Lingala,
        "--lithuanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Macedonian, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Persian,
        "--polish": Polish,
        "--portuguese": Portuges,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--russian": Ruso,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbiano,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Kinatsila,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Swedish,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turko,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ukrainian, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // chichewa
      // chichewa
      chichewa: {
        translations: {
          "--pachitika cholakwika": Pachitika cholakwika!, //a
           "--adilesi": Maadiresi,
           "--advice": Malangizo,
           "-- podina pitilizani": Mukadina pitilizani mudzachotsedwa ku akaunti yanu ya Veil Brillant, //b
           "-- podina pa disconnect mudzachotsedwa": Mukadina pa Disconnect mudzachotsedwa mu akaunti yanu ya izocash,
           "--onani nambala yanu yeniyeni kapena yesaninso nthawi ina": Onani nambala yanu yeniyeni kapena yesaninso nthawi ina, //c
           "--fufuzani nambala yanu yeniyeni": Onani nambala yanu yeniyeni,
           "--pitiliza": Pitirizani,
           "--kugwirizana": kugwirizana,
           "--thandizana, khalani mogwirizana": Gwirizanani, khalani mogwirizana ndi ena,
           "--chosa chilankhulo": Chiyankhulo cha Mafoni Owona,
           "--musalepheretse mpikisano": Osaletsa mpikisano, perekani mwayi kwa aliyense, //d
           "--disconnection": kusagwirizana,
           "- kwa onse ogwiritsa ntchito mafoni": Kwa onse ogwiritsa ntchito Mafoni Owona, ndizovomerezeka kugwiritsa ntchito VPN, //f
           "--pitani patsamba lolowera": Pitani patsamba lolowera, //g
           "--mbiri": Mbiri, //h
           "--ndili ndi akaunti": Ndili ndi akaunti, //i
           "--ndilibe akaunti": Ndilibe akaunti,
           "--ndi nyumba yanu": ndi nyumba yanu,
           "-- chithunzi / kanema +": Chithunzi / Kanema +,
           "--chidziwitso": Chitsimikizo,
           "--izocash kasitomala portal": izocash Customer Portal,
           "--zidziwitso zosintha chaka chilichonse": Kusintha kwa Identity chaka chilichonse,
           "--izocash buy to": izocash Buy => izocash international,
           "--lowani": Lowani!, //l
           "--lowani": Lowani,
           "- lowani ku chophimba chowala": Lumikizani ku Veil Brillant,
           "--lowani ku sitolo ya vixinol": Lumikizani ku Vixinol Store,
           "--lowani kwaulere ku akaunti yanu yotchinga Brillant": Lowani kwaulere ku akaunti yanu ya Veil Brillant kuti mupeze izi,
           "--kulowa bwino": Lowetsani bwino!,
           "--lowani tsopano": Lowani tsopano!,
           "--logout kupambana": Kutuluka bwino!,
           "--log out": Lowani,
           "--logout": Tulukani,
           "--nambala": Nambala, //n
           "--name": Dzina,
           "--now lowani": Tsopano, Lowani!,
           "--palibe choletsa kuletsa mpikisano":
           "--palibe nsanje, palibe udani": Palibe nsanje, palibe udani, palibe magawano;
           "--ayi": Ayi,
           "--maadiresi ovomerezeka kuti mupeze foni yanu yeniyeni": Maadiresi ovomerezeka kuti mupeze foni yanu yeniyeni, //o
           "--password": Chinsinsi, //p
           "-points withdrawals izocash": Mapoints Withdrawals izocash,
           "--points withdrawals": Kuchotsa Mfundo,
           "-- makamaka, gwiritsani ntchito vpn": Makamaka, gwiritsani ntchito VPN yomwe si ya omwe akukuthandizani pa intaneti,
           "-- kulimbikira kumapindulitsa nthawi zonse": Kulimbikira nthawi zonse kumapindulitsa pamapeto pake,
           "--rule": Malamulo, //r
           "--recommendation": Malangizo,
           "--registration": Kulembetsa,
           "--signup to veil brilliant": Lembani pa Veil Brillant, //s
           "--lowani ku sitolo ya vixinol": Lembani pa Vixinol Store,
           "--signup": Register,
           "--signup kupambana": Kulembetsa kwapambana!,
           "--signup for free": Lembani kwaulere,
           "--signup kupambana IA": Kulumikizana bwino",
           "--settings": "Zokonda",
           "-kukhazikitsa pulogalamu ya alrani": Kukonza pulogalamu ya Alrani,
           "--kukhazikitsa pulogalamu ya izocash": Kukonza pulogalamu ya izocash,
           "-kukhazikitsa pulogalamu ya vixinol": Kukonza pulogalamu ya Vixinol,
           "--kukhazikitsa pulogalamu ya Brillant yophimba": Kukonza pulogalamu ya Veil Brillant,
           "--kusungira zithunzi, makanema": Kusungirako zithunzi, makanema ndi zinthu zina zingapo,
           "--Speed ​​of Reception": Kuthamanga kwa kulandila kwa data kuchokera ku Datacenter,
           "--liwiro": Liwiro,
           "--thetsa": Kuthetsa, //t
           "-the vpn imakupatsani mwayi wofikira": VPN imakupatsani mwayi wofikira patsamba kapena pulogalamu yomwe wopereka chithandizo chanu pa intaneti adayiyika,
           "- mtengo waukulu kwambiri unali pamwamba": Mtengo waukulu kwambiri unali pamwamba pa kambewu kakang'ono,
           "--touch the screen": Gwirani chinsalu kuti mupitilize,
           "--try again": Yesaninso!,
           "--username": Dzina, //u

           "--virtual number": Nambala yeniyeni, //v
           "--zokonda pa foni": Zokonda pa foni yam'manja,
           "--Chilankhulo cha Phone chagwiritsidwa ntchito": Chiyankhulo cha Virtual Phone chimagwiritsidwa ntchito pamlingo wa pulogalamu mwachisawawa,
           "--foni yeniyeni": Foni yeniyeni,
           "--tsimikizira": Tsimikizani,
           "- Welcome to izocash kasitomala portal": Takulandirani ku izocash Customer Portal, //w
           "--lembani nambala yapamwamba kwambiri": Lowetsani Super code,
           "--welcome to": Takulandirani ku,
           "--komwe chidwi cha anthu chimapita": Kumene anthu amapitako ndalama,
           "--winners pirira": Opambana amapirira,
           "--kodi mungafune kutuluka mu akaunti yanu ya Alrani": Kodi mukufuna kutuluka mu akaunti yanu ya Alrani?,
           "--inde": Inde, //y

           // dziko
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // langa
        "--Aafrikaans": Afrikaans, //a
        "--albanian": Chialbania,
        "--amharic": Chiamharic,
        "--arabic": Chiarabu,
        "--Armenia": Chiameniya,
        "--assamese": Assamese,
        "--aymara": Ayimara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--chibelarusi": Chibelarusi,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Bosnia,
        "--bulgarian": Chibugariya,
        "--catalan": Chikatalani, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "-chineseSimplified": Chitchaina (Chosavuta),
        "--chineseTraditional": Chinese (Traditional),
        "--corsican": Corsican,
        "--Croatian": Chikroatia,
        "--Czech": Czech,
        "--danish": Chidanishi, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Dutch": Dutch,
        "--english": Chingerezi, //e
        "--esperanto": Esperanto,
        "--estonian": Chiestonia,
        "--ewe": Ayi,
        "--filipino": Chifilipino, //f
        "-- Finnish": Chifinishi,
        "--French": French,
        "--frisian": Chifrisian,
        "--galician": Chigalikiya, //g
        "-- georgian": Chijojiya,
        "--German": Chijeremani,
        "--Greek": Greek,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Chikiliyo cha ku Haiti, //h
        "--hausa": Hausa,
        "--hawaiian": Chihawai,
        "--Hebrew": Chihebri,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--chihungarian": Chihangare,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "-- ilocano": Ilocano,
        "--indonesian": Indonesian,
        "- Irish": Irish,
        "--italian": Chitaliyana,
        "--japanese": Japanese, //j
        "--javanese": Chijavani,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Chikorea,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Chilatini,
        "--latvian": Chilativiya,
        "--lingala": Lingala,
        "--lithuanian": Chilithuania,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Chimakedoniya, //m
        "--maithili": Maithili,
        "--malagasy": Chimalagasi,
        "--malay": Chimaleya,
        "--malayalam": Malayalam,
        "--Maltese": Chimalta,
        "--maori": Chimaori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--chinorwe": Chinorwe,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--Persian": Persian,
        "--Polish": Chipolishi,
        "--Portuguese": Chipwitikizi,
        "--punjabi": Chipunjabi,
        "--quechua": Quechua, //q
        "--romanian": Chiromania, //r
        "--Russian": Chirasha,
        "--samoan": Chisamoa, //s
        "--Sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Chisebiya,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Chisilovaki,
        "--slovenian": Chisiloveniya,
        "--somali": Somali,
        "--Spanish": Spanish,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--Swedish": Swedish,
        "--tajik": Tajik, //t
        "--tamil": Chitamil,
        "--Tatar": Chitata,
        "- telugu": Chitelugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--Turkish": Chituruki,
        "--Turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Chiyukireniya, //u
        "--urdu": Chiurdu,
        "--uyghur": Uyghur,
        "--Uzbek": Chiuzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Chiyoruba,
        "--zulu": Zulu, //z
        },
      }, */

      // **chineseSimplified
      // **chineseSimplified
      chineseSimplified: {
        translations: {
          "--an error has occurred": "发生错误", //a
          "--address": "地址",
          "--advice": "建议",
          "--by clicking on continue": "点击继续，您将与您的 Veil Brillant 帐户断开连接", //b
          "--by clicking on disconnect you will be disconnected": "通过单击断开连接，您将与您的 izocash 帐户断开连接",
          "--check your virtual number or try again later": "检查您的虚拟号码或稍后再试", //c
          "--check your virtual number": "检查您的虚拟号码",
          "--continue": "继续",
          "--connection": "连接",
          "--collaborate, live in harmony": "与他人协作，和谐相处",
          "--don't prevent competition": "不阻止竞争，给每个人机会", //d
          "--disconnection": "断开连接",
          "--for all virtual phone users": "对于所有虚拟电话用户，建议使用VPN", //f
          "--go to login page": "转到登录页面", //g
          "--historical": "历史", //h
          "--i have account": "我已经有一个帐户", //i
          "--i don't have account": "我没有帐户",
          "--it is your house": "这是你的房子",
          "--image / video +": "图像/视频+",
          "--identity verification": "身份验证",
          "--izocash customer portal": "izocash 客户门户",
          "--identity update every year": "身份每年更新",
          "--izocash buy to": "izocash 购买 => izocash 国际",
          "--if you have not registered": "如果您还没有注册，您可以开始注册",
          "--log in": "登录！", //l
          "--login": "登录",
          "--login to veil brillant": "连接到 Veil Brillant",
          "--login to vixinol store": "连接到 Vixinol 商店",
          "--login for free to your veil brillant account": "免费登录您的 Veil Brillant 帐户即可使用此功能",
          "--login success": "登录成功！",
          "--login now": "立即登录！",
          "--logout success": "注销成功！",
          "--log out": "注销",
          "--logout": "注销",
          "--number": "数字",//n
          "--name": "姓名",
          "--now log in": "现在，登录！",
          "--no ban on stifling competition": "不禁止抑制竞争",
          "--no jealousy, no hatred": "没有嫉妒，没有仇恨，没有分裂",
          "--no": "不",
          "--official addresses to access your virtual phone": "访问您的虚拟电话的官方地址", //o
          "--password": "密码", //p
          "--points withdrawals izocash": "积分提现 izocash",
          "--points withdrawals": "积分提现",
          "--preferably, use a vpn": "最好使用不属于您的互联网服务提供商的 VPN",
          "--persistence always pays off": "坚持最终总会有回报",
          "--please, check your virtual number": "请检查您的虚拟号码", 
          "--please, try again later": "请稍后再试 ！",
          "--platform 1 for virtual applications": "虚拟应用程序的 N°1 平台",
          "--rule": "规则", //r
          "--recommendation": "建议",
          "--registration": "注册",
          "--signup to veil brillant": "在 Veil Brillant 上注册",//s
          "--signup to vixinol store": "在 Vixinol Store 上注册",
          "--signup": "注册",
          "--signup success": "注册成功！",
          "--signup for free": "免费注册",
          "--signup success IA": "连接成功”",
          "--settings": "设置",
          "--setting up the alrani app": "配置Alrani应用程序",
          "--setting up the izocash app": "配置 izocash 应用程序",
          "--setting up the vixinol app": "配置 Vixinol 应用程序",
          "--setting up the veil brillant app": "配置 Veil Brillant 应用程序",
          "--storage of images, videos": "图像、视频和其他几个元素的存储",
          "--speed of reception": "从数据中心接收数据的速度",
          "--speed": "速度",
          "--terminate": "终止", //t
          "--the vpn allows you to access": "VPN 允许您访问您的互联网服务提供商已列入黑名单的网站或应用程序",
          "--the largest tree was above": "最大的树首先是一颗简单的小种子",
          "--touch the screen": "触摸屏幕继续", 
          "--try again": "再试一次！", 
          "--username": "用户名", //u
          "--virtual number": "虚拟号码", //v
          "--virtual phone": "虚拟电话",
          "--virtual phone settings": "虚拟电话设置",
          "--virtual phone language": "虚拟电话语言", 
          "--virtual phone language is applied": "默认在应用程序级别应用虚拟电话语言",
          "--validate": "验证",
          "--welcome to the izocash customer portal": "欢迎来到 izocash 客户门户", //w
          "--write a super code": "输入超级代码",
          "--welcome to": "欢迎来到",
          "--where people's attention goes": "人们的注意力去哪里，钱就去哪里",
          "--winners persevere": "胜利者坚持",
          "--would you like to log out of your Alrani account": "您想退出您的 Alrani 帐户吗？",
          "--yes": "是的", //y

          // country
           "--congo": "刚果布拉柴维尔",
           "--cameroon": "喀麦隆",
           "--drc": "刚果民主共和国",
           "--ivoryCoast": "象牙海岸",

           // langues
           "--afrikaans": "南非荷兰语", //a
           "--albanian": "阿尔巴尼亚语",
           "--amharic": "阿姆哈拉语",
           "--arabic": "阿拉伯语",
           "--armenian": "亚美尼亚语",
           "--assamese": "阿萨姆语",
           "--aymara": "艾马拉",
           "--azerbaijani": "阿塞拜疆语",
           "--bambara": "班巴拉", //b
           "--basque": "巴斯克语",
           "--belarusian": "白俄罗斯语", 
           "--bengali": "孟加拉语",
           "--bhojpuri": "博杰普尔",
           "--bosnian": "波斯尼亚语",
           "--bulgarian": "保加利亚语",
           "--catalan": "加泰罗尼亚语", //c
           "--cebuano": "宿务语", 
           "--chichewa": "奇切瓦语", 
           "--chineseSimplified": "中文（简体）", 
           "--chineseTraditional" : "中文（繁体）", 
           "--corsican" : "科西嘉岛", 
           "--croatian": "克罗地亚语", 
           "--czech": "捷克语", 
           "--danish": "丹麦语", //d
           "--dhivehi": "迪维希语",
           "--dogri": "多格里",
           "--dutch": "荷兰语",
           "--english": "英语", //e
           "--esperanto": "世界语",
           "--estonian": "爱沙尼亚语",
           "--ewe": "母羊",
           "--filipino": "菲律宾语",//f
           "--finnish": "芬兰语",
           "--french": "法语",
           "--frisian": "弗里斯兰语",
           "--galician": "加利西亚语",//g
           "--georgian": "格鲁吉亚语",
           "--german": "德语",
           "--greek": "希腊语",
           "--guarani": "瓜拉尼语",
           "--gujarati": "古吉拉特语",
           "--haitianCreole": "海地克里奥尔语", //h
           "--hausa": "豪萨语",
           "--hawaiian": "夏威夷语",
           "--hebrew": "希伯来语",
           "--hindi": "印地语",
           "--hmong": "苗族",
           "--hungarian": "匈牙利语",
           "--icelandic": "冰岛语", //i
           "--igbo": "伊博语",
           "--ilocano": "伊洛卡诺",
           "--indonesian": "印度尼西亚语",
           "--irish": "爱尔兰语",
           "--italian": "意大利语",
           "--japanese": "日语", //j
           "--javanese": "爪哇语", 
           "--kannada": "卡纳达语", //k
           "--kazakh": "哈萨克语",
           "--khmer": "高棉语",
           "--kinyarwanda": "基尼亚卢旺达语",
           "--konkani": "孔卡尼语",
           "--korean": "韩语",
           "--krio": "克里欧",
           "--kurdishKurmanji": "库尔德语（Kurmanji）",
           "--kurdishSorani": "库尔德语（Sorani）",
           "--kyrgyz": "吉尔吉斯语",
           "--lao": "老挝", //l
           "--latin": "拉丁语", 
           "--latvian": "拉脱维亚语", 
           "--lingala": "林加拉", 
           "--lithuanian": "立陶宛语", 
           "--luganda": "卢干达", 
           "--luxembourgish": "卢森堡语", 
           "--macedonian": "马其顿语", //m
           "--maithili": "迈蒂利",
           "--malagasy": "马达加斯加语",
           "--malay": "马来语",
           "--malayalam": "马拉雅拉姆语",
           "--maltese": "马耳他语",
           "--maori": "毛利人",
           "--marathi": "马拉地语",
           "--mizo": "米佐",
           "--mongolian": "蒙古语",
           "--myanmarBurmese": "缅甸（缅甸语）",
           "--nepali": "尼泊尔语", //n
           "--norwegian": "挪威语", 
           "--odiaOriya": "奥迪亚（奥里亚语）", //o
           "--oromo": "奥罗莫",
           "--pashto": "普什图语", //p
           "--persian": "波斯语",
           "--polish": "波兰语",
           "--portuguese": "葡萄牙语",
           "--punjabi": "旁遮普语",
           "--quechua": "盖丘亚语", //q
           "--romanian": "罗马尼亚语", //r
           "--russian": "俄语",
           "--samoan": "萨摩亚语",//s
           "--sanskrit": "梵文",
           "--scotsGaelic": "苏格兰盖尔语",
           "--sepedi": "塞佩迪",
           "--serbian": "塞尔维亚语",
           "--sesotho": "塞索托",
           "--shona": "修纳语",
           "--sindhi": "信德语",
           "--sinhala": "僧伽罗语",
           "--slovak": "斯洛伐克语",
           "--slovenian": "斯洛文尼亚语",
           "--somali": "索马里语",
           "--spanish": "西班牙语",
           "--sundanese": "巽他语",
           "--swahili": "斯瓦希里语",
           "--swedish": "瑞典语",
           "--tajik": "塔吉克语", //t
           "--tamil": "泰米尔语", 
           "--tatar": "鞑靼人", 
           "--telugu": "泰卢固语", 
           "--thai": "泰语", 
           "--tigrinya": "提格里尼亚", 
           "--tsonga": "特松加", 
           "--turkish": "土耳其语", 
           "--turkmen": "土库曼",
           "--twi": "契维语",
           "--ukrainian": "乌克兰语",//u
           "--urdu": "乌尔都语",
           "--uyghur": "维吾尔语",
           "--uzbek": "乌兹别克语",
           "--vietnamese": "越南语", //v
           "--welsh": "威尔士语", //w
           "--xhosa": "科萨语", //x
           "--yiddish": "意第绪语", //y
           "--yoruba": "约鲁巴语", 
           "--zulu": "祖鲁语", //z
         },
      },

      // chineseTraditional
      /*
      chineseTraditional: {
        translations: {
          "--發生錯誤": 發生錯誤！, //a
           “--address”：地址，
           “--advice”：建議，
           「--點擊繼續」：點擊繼續，您將與您的 Veil Brillant 帳戶斷開連接，//b
           「--透過點擊斷開連接，您將斷開連接」：透過點擊斷開連接，您將與您的 izocash 帳戶斷開連接，
           「--檢查您的虛擬號碼或稍後再試」：檢查您的虛擬號碼或稍後再試，//c
           “--檢查您的虛擬號碼”：檢查您的虛擬號碼，
           「--繼續」：繼續，
           「--連接」：連接，
           「－協作，和諧相處」：與他人協作，和諧相處，
           「--選擇語言」：虛擬電話語言，
           「--不阻止競爭」：不阻止競爭，給每個人機會，//d
           “--disconnection”：斷開連接，
           "--for all virtual Phone users": 對於所有虛擬電話用戶，建議使用VPN，//f
           「--前往登入頁面」：前往登入頁面，//g
           「--歷史」：歷史，//h
           “--i have account”：我已經有一個帳戶，//i
           「--我沒有帳戶」：我沒有帳戶，
           「——這是你的房子」：這是你的房子，
           “--圖像/視訊+”：圖像/視訊+，
           “--身份驗證”：身份驗證，
           “--izocash 客戶門戶”：izocash 客戶門戶，
           「--identity update everyyear」：身分每年更新，
           「--izocash 購買至」：izocash 購買 => izocash 國際，
           "--log in": 登入！, //l
           “--login”：登錄，
           「--登入 veil beautiful」：連接到 Veil Brillant，
           「--登入 vixinol 商店」：連線到 Vixinol 商店，
           「--免費登入您的 veil Brillant 帳戶」：免費登入您的 Veil Brillant 帳戶即可使用此功能，
           "--login success": 登入成功！,
           「--立即登入」：立即登入！,
           "--logout success": 註銷成功！,
           “--log out”：註銷，
           “--logout”：註銷，
           “--number”：數字，//n
           “--name”：姓名，
           「--現在登入」：現在，登入！，
           「——不禁止抑制競爭」：
           「——沒有嫉妒，沒有仇恨」：沒有嫉妒，沒有仇恨，沒有分裂，
           「 - 不，不，
           “--訪問您的虛擬電話的官方地址”：訪問您的虛擬電話的官方地址，//o
           “--password”：密碼，//p
           「--積分提現 izocash」：積分提現 izocash，
           「--積分提現」：積分提現，
           「--preferively, use a vpn」：最好使用不屬於您的網路服務供應商的 VPN，
           《－堅持總會有回報》：堅持最終總會有回報，
           “--rule”：規則，//r
           「--recommendation」：建議，
           「--註冊」：註冊，
           “--signup to veil beautiful”：在 Veil Brillant 上註冊，//s
           「--signup to vixinol store」：在 Vixinol Store 上註冊，
           “--signup”：註冊，
           "--signup success": 註冊成功！,
           “--signup for free”：免費註冊，
           “--註冊成功IA”：連線成功”，
           "--settings": "設定",
           「--設定alrani應用程式」：配置Alrani應用程序，
           “--設定 izocash 應用程式”：配置 izocash 應用程序，
           “--設定 vixinol 應用程式”：配置 Vixinol 應用程序，
           “--設定 veil Brillant 應用程式”：配置 Veil Brillant 應用程序，
           「--影像、影片的儲存」：影像、影片和其他幾個元素的存儲，
           「--接收速度」：從資料中心接收資料的速度，
           “--speed”：速度，
           “--terminate”：終止，//t
           「--VPN 允許您訪問」：VPN 允許您訪問您的互聯網服務提供者已列入黑名單的網站或應用程序，
           「——最大的樹在上面」：最大的樹首先是一顆簡單的小種子，
           「--觸控螢幕」：觸控螢幕繼續，
           「--再試一次」：再試一次！，
           “--username”：使用者名，//u

           "--虛擬號碼": 虛擬號碼, //v
           “--虛擬電話設定”：虛擬電話設置，
           「--應用虛擬電話語言」：預設在應用程式層級應用虛擬電話語言，
           “--虛擬電話”：虛擬電話，
           “--validate”：驗證，
           「--歡迎來到 izocash 客戶門戶」：歡迎來到 izocash 客戶門戶，//w
           “--寫入超級代碼”：輸入超級代碼，
           “--歡迎來到”：歡迎來到，
           「——人們的注意力去哪裡」：人們的注意力去哪裡，錢就去哪裡，
           「——勝利者堅持」：勝利者堅持，
           「--would you like to log out of your Alrani account」：您想退出您的 Alrani 帳戶嗎？,
           “--yes”：是的，//y

           //國家
           “--congo”：剛果布拉柴維爾，
           「--喀麥隆」：喀麥隆，
           “--drc”：剛果民主共和國，
           「--象牙海岸」：象牙海岸，

           // 語言
        “--南非荷蘭語”：南非荷蘭語，//a
        “--albanian”：阿爾巴尼亞語，
        “--阿姆哈拉語”：阿姆哈拉語，
        “--arabic”：阿拉伯語，
        「--亞美尼亞語」：亞美尼亞語，
        “--阿薩姆語”：阿薩姆語，
        「--艾馬拉」：艾馬拉，
        「--azerbaijani」：阿塞拜疆語，
        “--bambara”：班巴拉，//b
        “--basque”：巴斯克語，
        「--白俄羅斯語」：白俄羅斯語，
        “--孟加拉語”：孟加拉語，
        「--bhojpuri」：博傑普爾，
        “--波斯尼亞語”：波斯尼亞語，
        “--bulgarian”：保加利亞語，
        “--catalan”：加泰隆尼亞語，//c
        “--cebuano”：宿霧語，
        「--chichewa」：奇切瓦語，
        "--chineseSimplified": 中文（簡體），
        "--chineseTraditional": 中文（繁體），
        “--corsican”：科西嘉島，
        「--克羅埃西亞語」：克羅埃西亞語，
        “--czech”：捷克語，
        “--danish”：丹麥語，//d
        「--迪維希語」：迪維希語，
        「--dogri」：多格里，
        “--dutch”：荷蘭語，
        “--english”：英語，//e
        “--esperanto”：世界語，
        “--estonian”：愛沙尼亞語，
        “--ewe”：母羊，
        「--菲律賓語」：菲律賓語，//f
        “--finnish”：芬蘭語，
        “--french”：法語，
        「--弗里斯蘭語」：弗里斯蘭語，
        “--galician”：加利西亞語，//g
        “--georgian”：格魯吉亞語，
        “--德語”：德語，
        “--希臘語”：希臘語，
        “--瓜拉尼”：瓜拉尼語，
        「--古吉拉特語」：古吉拉特語，
        “--haitianCreole”：海地克里奧爾語，//h
        “--hausa”：豪薩語，
        “--hawaiian”：夏威夷語，
        “--希伯來語”：希伯來語，
        “--印地語”：印地語，
        「--苗族」：苗族，
        「--匈牙利語」：匈牙利語，
        “--icelandic”：冰島語，//i
        「--igbo」：伊博語，
        「--ilocano」：伊洛卡諾，
        “--indonesian”：印尼語，
        “--愛爾蘭”：愛爾蘭語，
        “--italian”：義大利語，
        “--japanese”：日語，//j
        “--javanese”：爪哇語，
        “--kannada”：卡納達語，//k
        “--哈薩克語”：哈薩克語，
        “--khmer”：高棉語，
        「--kinyarwanda」：基尼亞盧安達語，
        “--konkani”：孔卡尼語，
        “--korean”：韓語，
        “--krio”：克里歐，
        「--kurdishKurmanji」：庫德語（Kurmanji），
        「--kurdishSorani」：庫德語（Sorani），
        「--kyrgyz」：吉爾吉斯語，
        「--lao」：寮國，//l
        “--latin”：拉丁語，
        “--latvian”：拉脫維亞語，
        「--林加拉」：林加拉，
        「--立陶宛語」：立陶宛語，
        「--luganda」：盧幹達，
        「--luxembourgish」：盧森堡語，
        “--macedonian”：馬其頓語，//m
        「--邁蒂利​​」：邁蒂利，
        「--馬達加斯加」：馬達加斯加語，
        “--malay”：馬來語，
        「--馬拉雅拉姆語」：馬拉雅拉姆語，
        “--maltese”：馬耳他語，
        “--maori”：毛利人，
        「--馬拉地語」：馬拉地語，
        「--meiteilonManipuri」：Meiteilon（曼尼普里），
        “--mizo”：米佐，
        “--mongolian”：蒙古語，
        「--myanmarBurmese」：緬甸（緬甸語），
        “--nepali”：尼泊爾語，//n
        “--norwegian”：挪威語，
        「--odiaOriya」：奧迪亞（奧裡亞語），//o
        「--oromo」：奧羅莫，
        “--pashto”：普什圖語，//p
        “--persian”：波斯語，
        “--polish”：波蘭語，
        “--葡萄牙語”：葡萄牙語，
        「--punjabi」：旁遮普語，
        「--quechua」：蓋丘亞語，//q
        “--romanian”：羅馬尼亞語，//r
        “-- Russian”：俄語，
        “--samoan”：薩摩亞語，//s
        “--sanskrit”：梵文，
        “--scotsGaelic”：蘇格蘭蓋爾語，
        “--sepedi”：塞佩迪，
        “--serbian”：塞爾維亞語，
        「--塞索托」：塞索托，
        「--修納語」：修納語，
        “--sindhi”：信德語，
        「--sinhala」：僧伽羅語，
        “--slovak”：斯洛伐克語，
        「--斯洛維尼亞語」：斯洛維尼亞語，
        “--somali”：索馬利語，
        “--spanish”：西班牙語，
        「--巽他語」：巽他語，
        「--斯瓦希里語」：斯瓦希里語，
        “--swedish”：瑞典語，
        “--tajik”：塔吉克語，//t
        “--tamil”：泰米爾語，
        「--韃靼」：韃靼人，
        「--泰盧固語」：泰盧固語，
        “--thai”：泰語，
        「--tigrinya」：提格里尼亞，
        「--特松加」：特松加，
        “--土耳其語”：土耳其語，
        “--土庫曼”：土庫曼，
        「--twi」：契維語，
        “--ukrainian”：烏克蘭語，//u
        「--urdu」：烏爾都語，
        「--維吾爾語」：維吾爾語，
        「--uzbek」：烏茲別克語，
        “--vietnamese”：越南語，//v
        “--welsh”：威爾斯語，//w
        “--xhosa”：科薩語，//x
        “--yiddish”：意第緒語，//y
        「--約魯巴語」：約魯巴語，
        “--zulu”：祖魯語，//z
        },
      },

      // corsican
      // corsican
      corsican: {
        translations: {
          "--an error has occurred": Un errore hè accadutu !, //a
          "--address": Indirizzi,
          "--advice": Cunsigliu,
          "--cliccandu nant'à cuntinuà": Cliccà nant'à cuntinuà vi sarà disconnected da u vostru contu Veil Brillant, //b
          "--cliccandu nant'à disconnect vi sarà disconnected": Cliccà nant'à Disconnect vi sarà disconnected da u vostru contu izocash,
          "--check your virtual number or try again later": Verificate u vostru numeru virtuale o pruvate più tardi, //c
          "--check your virtual number": Verificate u vostru numeru virtuale,
          "--continue": Cuntinuà,
          "--connection": Cunnessu,
          "--collaborate, live in armunia": Collaborate, campà in armunia cù l'altri,
          "--choose language": Lingua Virtual Phone,
          "--n'impedisce micca a cumpetizione": Ùn impedisce micca a cumpetizione, dà à tutti una chance, //d
          "--disconnection": Disconnection,
          "--for all virtual phone users": Per tutti l'utilizatori di u telefuninu virtuale, hè cunsigliatu di utilizà una VPN, //f
          "--go to login page": Andate à a pagina di login, //g
          "--storicu": Storicu, //h
          "--I have account": Aghju digià un contu, //i
          "--I have not have account": Ùn aghju micca contu,
          "--hè a to casa": hè a to casa,
          "--image / video +": Image / Video +,
          "--identity verification": Verificazione di l'identità,
          "--izocash portale di i clienti": Portal di i clienti izocash,
          "--identity update every year": Actualizazione di l'identità ogni annu,
          "--izocash buy to": izocash Buy => izocash internaziunale,
          "--log in": Accedi!, //l
          "--login": accede,
          "--login to veil brilliant": Cunnettete à Veil Brillant,
          "--login to vixinol store": Cunnettete à Vixinol Store,
          "--login for free to your veil Brillant account": Accedi gratuitamente à u vostru contu Veil Brillant per accede à sta funzione,
          "--login success": Login successu !,
          "--login now": Entra avà !,
          "--logout success": Logout successu !,
          "--log out": Logout,
          "--logout": Esci,
          "--number": Numeru, //n
          "--name": Nome,
          "--now log in": Avà, accede !,
          "--senza pruibizione di a cumpetizione suffocante":
          "--no jealousy, no hatre": Nisuna gelosia, nè odiu, nè divisioni,
          "--no": Innò,
          "--official addresses to access your virtual phone": Indirizzi ufficiali per accede à u vostru telefunu virtuale, //o
          "--password": Password, //p
          "--points retirements izocash": Ritirata punti izocash,
          "--points withdrawals": Ritirata di punti,
          "--preferably, use a vpn": Preferibilmente, aduprate una VPN chì ùn appartene micca à u vostru fornitore di servizii Internet,
          "--persistence always pay off": A persistenza sempre paga à a fine,
          "--rule": Reguli, //r
          "--recommendation": Raccomandazioni,
          "--registration": Registrazione,
          "--signup to veil brilliant": Registrate in Veil Brillant, //s
          "--signup to vixinol store": Registratevi in ​​Vixinol Store,
          "--signup": Registru,
          "--signup success": Registrazione successu !,
          "--signup for free": Registrate gratuitamente,
          "--signup success IA": Cunnessione successu",
          "--settings": "Settings",
          "--setting up the alrani app": Configurazione di l'applicazione Alrani,
          "--setting up the izocash app": Configurazione di l'applicazione izocash,
          "--setting up the vixinol app": Configurazione di l'applicazione Vixinol,
          "--setting up the veil Brillant app": Configurazione di l'applicazione Veil Brillant,
          "--storage of images, videos": Almacenamiento d'imaghjini, video è parechji altri elementi,
          "--speed of reception": Velocità di ricezione di dati da u Datacenter,
          "--speed": vitezza,
          "--terminate": Termina, //t
          "--u vpn vi permette di accede": A VPN vi permette di accede à un situ o una applicazione chì u vostru fornitore di serviziu di Internet hà in lista negra,
          "--l'arburu più grande era sopra": L'arbulu più grande era sopratuttu una simprici piccula sumente,
          "--touch the screen": Toccate u screnu per cuntinuà,
          "--try again": Pruvate di novu !,
          "--username": Username, //u

          "--virtual number": Numeru virtuale, //v
           "--virtual phone settings": paràmetri di u telefuninu virtuale,
           "--Virtual Phone language is applyed": A lingua Virtual Phone hè applicata à u livellu di l'applicazione per difettu,
           "--virtual phone": telefonu virtuale,
           "--validate": Validate,
           "--benvenuti à u portale di i clienti izocash": Benvenuti à u portale di i clienti izocash, //w
           "--write a super code": Inserite un super codice,
           "--benvenuti à": Benvenuti à,
           "--induve l'attenzione di a ghjente va": induve l'attenzione di a ghjente va i soldi,
           "--winners persevere": I vincitori perseveranu,
           "--Would you like to log out from your Alrani account": Vulete uscite da u vostru contu Alrani ?,
           "--yes": Iè, //y

           // paese
           "--congo": Congo Brazzaville,
           "--camerun": Camerun,
           "--drc": DRC,
           "--ivoryCoast": Costa d'Ivory,

           // langue
        "--afrikaans": Afrikaans, //a
        "--albanian": albanese,
        "--amharic": Amharic,
        "--arabic": arabu,
        "--armenian": armenu,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": bascu,
        "--bielorussu": bielorussu,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnian,
        "--bulgarian": bulgaru,
        "--catalan": Catalanu, //c
        "--cebuano": Cebuanu,
        "--chichewa": Chichewa,
        "--chineseSimplified": Chinese (Simplified),
        "--chineseTraditional": Chinese (Tradiziunale),
        "--corsi" : corsu,
        "--croatian": Croatu,
        "--czech": cecu,
        "--danish": Danese, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--olandese": Olandese,
        "--english": inglese, //e
        "--esperanto": Esperanto,
        "--estonian": estone,
        "--ewe": pecora,
        "--filipinu": Filippinu, //f
        "--finnish": finlandese,
        "--francese": francese,
        "--frisian": frisone,
        "--galician": galician, //g
        "--georgian": georgianu,
        "--german": tedescu,
        "--greek": grecu,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": criolu haitianu, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": ebreu,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Ungherese,
        "--islandic": islandese, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": Indonesian,
        "--irish": irlandese,
        "--italian": talianu,
        "--giapponese": Japanese, //j
        "--javanese": giavanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--corean": coreanu,
        "--krio": Krio,
        "--kurdishKurmanji": Curdu (Kurmanji),
        "--kurdishSorani": Kurdu (Sorani),
        "--kyrgyz": Kirghizistan,
        "--lao": Lao, //l
        "--latin": latinu,
        "--latvian": lettone,
        "--lingala": Lingala,
        "--lithuanian": lituanu,
        "--luganda": Luganda,
        "--luxembourgish": lussemburghese,
        "--macedonian": Macedone, //m
        "--maithili": Maithili,
        "--malgasy": malgache,
        "--malay": malese,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (birmanu),
        "--nepali": Nepali, //n
        "--norwegian": norvegese,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Persian,
        "--polish": Polacco,
        "--portuguese": Portuguese,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--rumanu": rumenu, //r
        "--russu": Russu,
        "--samoan": Samoan, //s
        "--sanskrit": sanscritu,
        "--scotsGaelic": gaelicu scozzese,
        "--sepedi": Sepedi,
        "--serbian": Serbu,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": slovacco,
        "--sloveno": sloveno,
        "--somali": Somali,
        "--spagnolu": spagnolu,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Svedese,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": tataru,
        "--telugu": Telugu,
        "--thai": tailandese,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turcu,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": ucrainu, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": vietnamita, //v
        "--welsh": gallese, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // croatian
      // croatian
      croatian: {
        translations: {
          "--dogodila se pogreška": Došlo je do pogreške!, //a
           "--adresa": Adrese,
           "--advice": savjet,
           "--klikom na nastavak": Klikom na nastavak bit ćete isključeni s vašeg Veil Brillant računa, //b
           "--klikom na Disconnect bit ćete isključeni": Klikom na Disconnect bit ćete isključeni s vašeg izocash računa,
           "--provjerite svoj virtualni broj ili pokušajte ponovno kasnije": Provjerite svoj virtualni broj ili pokušajte ponovno kasnije, //c
           "--check your virtual number": Provjerite svoj virtualni broj,
           "--Nastavi Nastavi,
           "--connection": veza,
           "--surađivati, živjeti u harmoniji": surađivati, živjeti u harmoniji s drugima,
           "--choose language": Virtualni telefonski jezik,
           "--ne sprječavaj konkurenciju": Ne sprječavaj konkurenciju, daj svima priliku, //d
           "--disconnection": prekid veze,
           "--za sve korisnike virtualnih telefona": Za sve korisnike virtualnih telefona preporučuje se korištenje VPN-a, //f
           "--go to login page": Idite na stranicu za prijavu, //g
           "--historical": Povijesni, //h
           "--i have account": Već imam račun, //i
           "--i don't have account": Nemam račun,
           "--to je tvoja kuća": to je tvoja kuća,
           "--image / video +": slika / video +,
           "--identity verification": Provjera identiteta,
           "--izocash korisnički portal": izocash korisnički portal,
           "--identitet update svake godine": Ažuriranje identiteta svake godine,
           "--izocash kupiti za": izocash kupiti => izocash međunarodno,
           "--log in": Prijavite se!, //l
           "--login": Prijavite se,
           "--prijavite se na Veil Brillant": Povežite se na Veil Brillant,
           "--prijava na trgovinu vixinol": Povežite se na trgovinu Vixinol,
           "--besplatno se prijavite na svoj Veil Brillant račun": Prijavite se besplatno na svoj Veil Brillant račun za pristup ovoj značajki,
           "--uspješna prijava": Uspješna prijava!,
           "--login now": Prijavite se sada!,
           "--odjava uspješna": uspješna odjava!,
           "--log out": odjava,
           "--logout": odjava,
           "--number": Broj, //n
           "--name": Ime,
           "--now log in": Sada se prijavite!,
           "--nema zabrane gušenja konkurencije":
           "--bez ljubomore, bez mržnje": Nema ljubomore, nema mržnje, nema podjela,
           "--ne ne,
           "--službene adrese za pristup vašem virtualnom telefonu": Službene adrese za pristup vašem virtualnom telefonu, //o
           "--password": Lozinka, //str
           "--bodovi povlačenja izocash": Povlačenja bodova izocash,
           "--povlačenja bodova": Povlačenja bodova,
           "--preferably, use a vpn": Po mogućnosti, koristite VPN koji ne pripada vašem pružatelju internetskih usluga,
           "--upornost se uvijek isplati": upornost se na kraju uvijek isplati,
           "--pravilo": Pravila, //r
           "--recommendation": Preporuke,
           "--registration": Registracija,
           "--prijava na Veil Brilliant": Registrirajte se na Veil Brillant, //s
           "--prijavite se u trgovinu vixinol": Registrirajte se na trgovini Vixinol,
           "--signup": Registracija,
           "--signup success": Registracija uspješna!,
           "--registracija besplatno": Registrirajte se besplatno,
           “--uspjeh prijave IA”: povezivanje uspješno”,
           "--settings": "Postavke",
           "--postavljanje aplikacije alrani": Konfiguriranje aplikacije Alrani,
           "--postavljanje izocash aplikacije": Konfiguriranje izocash aplikacije,
           "--postavljanje aplikacije vixinol": Konfiguriranje aplikacije Vixinol,
           "--postavljanje aplikacije Veil Brillant": Konfiguriranje aplikacije Veil Brillant,
           "--pohrana slika, videa": pohrana slika, videa i nekoliko drugih elemenata,
           "--brzina prijema": Brzina prijema podataka iz podatkovnog centra,
           "--speed": brzina,
           "--terminate": Prekini, //t
           "--vpn vam omogućuje pristup": VPN vam omogućuje pristup stranici ili aplikaciji koju je vaš pružatelj internetskih usluga stavio na crnu listu,
           "--najveće stablo bilo je gore": Najveće stablo bilo je prije svega jednostavno malo sjeme,
           "--dodirni zaslon": Dodirnite zaslon za nastavak,
           "--pokušaj ponovno": Pokušajte ponovno!,
           "--username": Korisničko ime, //u

           "--virtualni broj": Virtualni broj, //v
           "--virtualne postavke telefona": postavke virtualnog telefona,
           "--primijenjen je jezik virtualnog telefona": Jezik virtualnog telefona primjenjuje se prema zadanim postavkama na razini aplikacije,
           "--virtualni telefon": Virtualni telefon,
           "--validate": potvrdi,
           "--dobrodošli na izocash korisnički portal": Dobro došli na izocash korisnički portal, //w
           "--write a super code": Unesite super kod,
           "--welcome to": Dobro došli u,
           "--kuda ide pažnja ljudi": Gdje ide pažnja ljudi ide i novac,
           "-winners persevere": Pobjednici ustraju,
           "--želite li se odjaviti sa svog Alrani računa": Želite li se odjaviti sa svog Alrani računa?,
           "--yes": Da, //y

           // zemlja
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--IvoryCoast": Obala Bjelokosti,

           // jezik
        "--afrikaans": afrikaans, //a
        "--albanian": albanski,
        "--amharski": amharski,
        "--arabic": arapski,
        "--armenian": armenski,
        "--asamski": asamski,
        "--aymara": Aymara,
        "--azerbaijani": azerbajdžanski,
        "--bambara": Bambara, //b
        "--basque": baskijski,
        "--bjeloruski": bjeloruski,
        "--bengali": bengalski,
        "--bhojpuri": bhojpuri,
        "--bosnian": bosanski,
        "--bugarski": bugarski,
        "--katalonski": katalonski, //c
        "--cebuano": cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kineski (pojednostavljeni),
        "--chineseTraditional": kineski (tradicionalni),
        "--corsican": Korzikanac,
        "--croatian": hrvatski,
        "--češki": češki,
        "--danski": danski, //d
        "--dhivehi": divehi,
        "--dogri": Dogri,
        "--dutch": nizozemski,
        "--engleski": engleski, //e
        "--esperanto": esperanto,
        "--estonian": estonski,
        "--ewe": ovca,
        "--filipino": filipinski, //f
        "--finnish": finski,
        "--francuski": francuski,
        "--frizijski": frizijski,
        "--galicijski": galicijski, //g
        "--gruzijski": gruzijski,
        "-njemački": njemački,
        "--greek": grčki,
        "--guarani": guarani,
        "--gujarati": gudžarati,
        "--haitianCreole": haićanski kreolski, //h
        "--hausa": Hausa,
        "--havajski": havajski,
        "--hebrejski": hebrejski,
        "--hindi": hindski,
        "--hmong": Hmong,
        "--hungarian": mađarski,
        "--islandski": islandski, //i
        "--igbo": Igbo,
        "--ilocano": Iločan,
        "--indonesian": indonezijski,
        "--irish": irski,
        "--italian": talijanski,
        "--japanese": japanski, //j
        "--javanese": javanski,
        "--kannada": kanada, //k
        "--kazakh": kazaški,
        "--khmer": kmerski,
        "--kinyarwanda": kinyarwanda,
        "--konkani": Konkani,
        "--korean": korejski,
        "--krio": Krio,
        "--kurdishKurmanji": kurdski (Kurmanji),
        "--kurdishSorani": kurdski (Sorani),
        "--kyrgyz": kirgiski,
        "--lao": Lao, //l
        "--latin": latinica,
        "--latvijski": latvijski,
        "--lingala": lingala,
        "--litvanski": litvanski,
        "--luganda": luganda,
        "--luxembourgish": luksemburški,
        "--makedonski": makedonski, //m
        "--maithili": Maithili,
        "--malagasy": malgaški,
        "--malay": malajski,
        "--malayalam": malajalamski,
        "--maltese": malteški,
        "--maori": maorski,
        "--marathi": marati,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": mizo,
        "--mongolski": mongolski,
        "--mjanmarburmanski": mianmar (burmanski),
        "--nepali": nepalski, //n
        "--norwegian": norveški,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--paštu": paštu, //str
        "--perzijski": perzijski,
        "--polish": poljski,
        "--portuguese": portugalski,
        "--punjabi": pandžapski,
        "--quechua": kečuanski, //q
        "--rumunjski": rumunjski, //r
        "--ruski": ruski,
        "--samoan": samoanski, //s
        "--sanskrt": sanskrt,
        "--scotsGaelic": škotski galski,
        "--sepedi": Sepedi,
        "--srpski": srpski,
        "--sesotho": sesoto,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": sinhalski,
        "--slovak": slovački,
        "--slovenian": slovenski,
        "--somali": somalski,
        "--spanish": španjolski,
        "--sundanese": sundanski,
        "--swahili": svahili,
        "--swedish": švedski,
        "--tadžik": tadžički, //t
        "--tamil": tamilski,
        "--tatar": tatarski,
        "--telugu": telugu,
        "--thai": tajlandski,
        "--tigrinya": tigrinja,
        "--tsonga": Tsonga,
        "--turkish": turski,
        "--turkmen": turkmenski,
        "--twi": Twi,
        "--ukrajinski": ukrajinski, //u
        "--urdu": urdu,
        "--uyghur": ujgurski,
        "--uzbek": uzbečki,
        "--vijetnamski": vijetnamski, //v
        "--welsh": velški, //w
        "--xhosa": Xhosa, //x
        "--jidiš": jidiš, //y
        "--yoruba": Joruba,
        "--zulu": Zulu, //z
        },
      },

      // czech
      // czech
      czech: {
        translations: {
          "-- došlo k chybě": Došlo k chybě!, //a
           "--address": adresy,
           "--advice": rada,
           "--kliknutím na pokračovat": Kliknutím na pokračovat budete odpojeni od svého účtu Veil Brillant, //b
           "--kliknutím na odpojit budete odpojeni": Kliknutím na Odpojit budete odpojeni od svého účtu izocash,
           "--check your virtual number or try again later": Zkontrolujte své virtuální číslo nebo to zkuste znovu později, //c
           "--check your virtual number": Zkontrolujte své virtuální číslo,
           "--Pokračovat Pokračovat,
           "--connection": připojení,
           "--spolupracujte, žijte v harmonii": Spolupracujte, žijte v souladu s ostatními,
           "--choose language": Jazyk virtuálního telefonu,
           "--don't prevent competition": Nebraňte konkurenci, dejte každému šanci, //d
           "--disconnection": odpojení,
           "--for all virtual phone users": Pro všechny uživatele virtuálního telefonu se doporučuje používat VPN, //f
           "--go to login page": Přejít na přihlašovací stránku, //g
           "--historický": Historický, //h
           "--i have account": Již mám účet, //i
           "--nemám účet": nemám účet,
           "--to je tvůj dům": je to tvůj dům,
           "--image / video +": Obrázek / Video +,
           "--identity authentication": ověření identity,
           "--izocash zákaznický portál": zákaznický portál izocash,
           "--identity update every year": aktualizace identity každý rok,
           "--izocash koupit do": izocash Koupit => izocash mezinárodní,
           "--log in": Přihlásit se!, //l
           "--login": Přihlaste se,
           "--login to Veil Brillant": Připojte se k Veil Brillant,
           "--login to vixinol store": Připojení k Vixinol Store,
           "--přihlaste se zdarma ke svému účtu Veil Brillant": Pro přístup k této funkci se zdarma přihlaste ke svému účtu Veil Brillant,
           "--login success": přihlášení úspěšné!,
           "--login now": Přihlaste se nyní!,
           "--logout success": Odhlášení úspěšné!,
           "--log out": Odhlášení,
           "--logout": Odhlásit se,
           "--number": číslo, //n
           "--name": jméno,
           "--now log in": Nyní, přihlaste se!,
           "--žádný zákaz potlačování konkurence":
           "--žádná žárlivost, žádná nenávist": žádná žárlivost, žádná nenávist, žádné rozdělení,
           "--ne": Ne,
           "--oficiální adresy pro přístup k vašemu virtuálnímu telefonu": Oficiální adresy pro přístup k vašemu virtuálnímu telefonu, //o
           "--password": Heslo, //s
           "--body výběry izocash": výběry bodů izocash,
           "--výběry bodů": výběry bodů,
           "--raději použijte vpn": Přednostně použijte VPN, která nepatří vašemu poskytovateli internetových služeb,
           "--vytrvalost se vždy vyplácí": Vytrvalost se nakonec vždy vyplatí,
           "--rule": Pravidla, //r
           "--recommendation": doporučení,
           "--registrace": registrace,
           "--registrace k závoji brilantní": Zaregistrujte se na Veil Brillant, //s
           "--signup to vixinol store": Zaregistrujte se na Vixinol Store,
           "--signup": Zaregistrujte se,
           "--signup success": Registrace úspěšná!,
           "--registrace zdarma": Zaregistrujte se zdarma,
           "--signup success IA": Připojení úspěšné",
           "--settings": "Nastavení",
           "--setting the alrani app": Konfigurace aplikace Alrani,
           "--setting the izocash app": Konfigurace aplikace izocash,
           "--setting the vixinol app": Konfigurace aplikace Vixinol,
           "--setting the Veil Brillant app": Konfigurace aplikace Veil Brillant,
           "--storage of images, videos": Ukládání obrázků, videí a několika dalších prvků,
           "--speed of income": rychlost příjmu dat z datového centra,
           "--speed": rychlost,
           "--terminate": Ukončení, //t
           "--vpn vám umožňuje přístup": VPN vám umožňuje přístup k webu nebo aplikaci, kterou váš poskytovatel internetových služeb zařadil na černou listinu,
           "--největší strom byl nahoře": Největší strom byl především prosté malé semínko,
           "--touch the screen": Dotykem obrazovky pokračujte,
           "--try again": Zkuste to znovu!,
           "--username": uživatelské jméno, //u

           "--virtual number": Virtuální číslo, //v
           "--nastavení virtuálního telefonu": nastavení virtuálního telefonu,
           "--jazyk virtuálního telefonu je použit": Ve výchozím nastavení je na úrovni aplikace použit jazyk virtuálního telefonu,
           "--virtual phone": virtuální telefon,
           "--validate": Ověřit,
           "--vítejte na zákaznickém portálu izocash": Vítejte na zákaznickém portálu izocash, //w
           "--write a super code": Zadejte super kód,
           "--welcome to": Vítejte,
           "--kam jde pozornost lidí": Kam jde pozornost lidí, jdou peníze,
           "--winners persevere": Vítězové vytrvají,
           "--chtěli byste se odhlásit ze svého účtu Alrani": Chcete se odhlásit ze svého účtu Alrani?,
           "--yes": Ano, //y

           // země
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Pobřeží slonoviny,

           // jazyk
        "--afrikaans": afrikánština, //a
        "--albanian": albánština,
        "--amharština": amharština,
        "--arabic": arabština,
        "--armenian": arménština,
        "--assamese": asámština,
        "--aymara": ajmarština,
        "--azerbaijani": ázerbájdžánština,
        "--bambara": Bambara, //b
        "--basque": baskičtina,
        "--běloruský": běloruština,
        "--bengali": bengálština,
        "--bhojpuri": bhojpuri,
        "--bosnian": bosenština,
        "--bulgarian": bulharština,
        "--catalan": katalánština, //c
        "--cebuano": cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": čínština (zjednodušená),
        "--chineseTraditional": čínština (tradiční),
        "--corsican": korsický,
        "--croatian": chorvatština,
        "--czech": čeština,
        "--dánština": dánština, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--holandština": holandština,
        "--english": angličtina, //e
        "--esperanto": esperanto,
        "--estonian": estonština,
        "--ewe": ovečka,
        "--filipino": filipínština, //f
        "--finnish": finština,
        "--french": francouzština,
        "--fríština": fríština,
        "--galicijština": galicijština, //g
        "--georgian": gruzínština,
        "--german": německy,
        "--greek": řečtina,
        "--guarani": guarani,
        "--gudžarátština": gudžarátština,
        "--haitianCreole": haitská kreolština, //h
        "--hausa": Hausa,
        "--hawaiian": havajština,
        "--hebrew": hebrejština,
        "--hindi": hindština,
        "--hmong": Hmong,
        "--maďarština": maďarština,
        "--islandic": islandština, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": indonéština,
        "--irish": irština,
        "--italian": italština,
        "--japanese": japonština, //j
        "--javanese": jávština,
        "--kannada": kannadština, //k
        "--kazakh": kazašština,
        "--khmer": khmerština,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": konkani,
        "--korean": korejština,
        "--krio": Krio,
        "--kurdishKurmanji": kurdština (Kurmanji),
        "--kurdishSorani": kurdština (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": laoština, //l
        "--latin": latina,
        "--latvian": lotyština,
        "--lingala": lingala,
        "--litevština": litevština,
        "--luganda": Luganda,
        "--luxemburština": lucemburština,
        "--makedonian": makedonština, //m
        "--maithili": maithili,
        "--malagasy": malgaština,
        "--malajština": malajština,
        "--malayalam": malajálamština,
        "--maltese": maltština,
        "--maori": maorština,
        "--marathi": maráthština,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolský": mongolština,
        "--myanmarBurmese": Myanmar (barmština),
        "--nepali": nepálština, //n
        "--norwegian": norština,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": paštština, //p
        "--persian": perština,
        "--polish": polština,
        "--portuguese": portugalština,
        "--punjabi": pandžábština,
        "--quechua": kečuánština, //q
        "--rumunian": rumunština, //r
        "--russian": ruština,
        "--samoan": samojština, //s
        "--sanskrit": sanskrt,
        "--scotsGaelic": skotská gaelština,
        "--sepedi": Sepedi,
        "--srbský": srbština,
        "--sesotho": sesotho,
        "--shona": Shona,
        "--sindhi": sindhi,
        "--sinhala": sinhálština,
        "--slovak": slovenština,
        "--slovinian": slovinština,
        "--somali": somálština,
        "--spanish": španělština,
        "--sundanese": sundánština,
        "--swahili": svahilština,
        "--swedish": švédština,
        "--tajik": tádžičtina, //t
        "--tamil": tamilština,
        "--tatar": tatarský,
        "--telugu": telugština,
        "--thai": thajština,
        "--tigrinya": tigrinya,
        "--tsonga": Tsonga,
        "--turecký": turečtina,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": ukrajinština, //u
        "--urdu": urdština,
        "--uyghur": Ujgur,
        "--uzbek": uzbecký,
        "--vietnamese": vietnamština, //v
        "--welsh": velština, //w
        "--xhosa": Xhosa, //x
        "--jidiš": jidiš, //y
        "--yoruba": jorubština,
        "--zulu": zuluština, //z
        },
      },

      // danish
      // danish
      danish: {
        translations: {
          "--en fejl er opstået": Der er opstået en fejl!, //a
           "--adresse": Adresser,
           "--advice": Råd,
           "--ved at klikke på fortsæt": Ved at klikke på fortsæt vil du blive afbrudt fra din Veil Brillant-konto, //b
           "--ved at klikke på afbryd forbindelsen vil du blive afbrudt": Ved at klikke på Afbryd forbindelsen vil du blive afbrudt fra din izocash-konto,
           "--tjek dit virtuelle nummer eller prøv igen senere": Tjek dit virtuelle nummer eller prøv igen senere, //c
           "--tjek dit virtuelle nummer": Tjek dit virtuelle nummer,
           "--fortsæt": Fortsæt,
           "--forbindelse": Forbindelse,
           "--samarbejde, lev i harmoni": Samarbejd, lev i harmoni med andre,
           "--vælg sprog": Virtuelt telefonsprog,
           "--hindr ikke konkurrence": Forhindr ikke konkurrence, giv alle en chance, //d
           "--disconnection": Afbrydelse,
           "--for alle virtuelle telefonbrugere": For alle virtuelle telefonbrugere anbefales det at bruge en VPN, //f
           "--gå til login-side": Gå til login-siden, //g
           "--historisk": Historisk, //h
           "--i have account": Jeg har allerede en konto, //i
           "--jeg har ikke en konto": Jeg har ikke en konto,
           "--det er dit hus": det er dit hus,
           "--image / video +": Billede / Video +,
           "--identitetsbekræftelse": Identitetsbekræftelse,
           "--izocash kundeportal": izocash kundeportal,
           "--identitetsopdatering hvert år": Identitetsopdatering hvert år,
           "--izocash køb til": izocash Køb => izocash international,
           "--log ind": Log ind!, //l
           "--login": Log ind,
           "--login til veil brilliant": Opret forbindelse til Veil Brillant,
           "--login til Vixinol Store": Opret forbindelse til Vixinol Store,
           "--login gratis på din Veil Brillant-konto": Log gratis ind på din Veil Brillant-konto for at få adgang til denne funktion,
           "--login succes": Login lykkedes!,
           "--login nu": Log ind nu!,
           "--logout succes": Log ud vellykket!,
           "--log ud": Log ud,
           "--logout": Log ud,
           "--nummer": Nummer, //n
           "--name": Navn,
           "--now log in": Log nu ind!,
           "--intet forbud mod at kvæle konkurrence":
           "--ingen jalousi, intet had": Ingen jalousi, intet had, ingen splittelse,
           "--Nej nej,
           "--officielle adresser til at få adgang til din virtuelle telefon": Officielle adresser til at få adgang til din virtuelle telefon, //o
           "--password": Adgangskode, //s
           "--pointudbetalinger izocash": Pointudtrækninger izocash,
           "--pointudtrækninger": Pointudbetalinger,
           "--helst, brug en vpn": Brug helst en VPN, der ikke tilhører din internetudbyder,
           "--vedholdenhed betaler sig altid": Vedholdenhed betaler sig altid i sidste ende,
           "--rule": Regler, //r
           "--recommendation": Anbefalinger,
           "--registration": Registrering,
           "--tilmeld dig til veil brilliant": Tilmeld dig på Veil Brillant, //s
           "--tilmeld dig vixinol butik": Tilmeld dig på Vixinol Store,
           "--signup": Registrer,
           "--signup success": Registreringen lykkedes!,
           "--tilmeld dig gratis": Tilmeld dig gratis,
           "--signup success IA": Forbindelsen lykkedes",
           "--settings": "Indstillinger",
           "--opsætning af alrani-appen": Konfiguration af Alrani-applikationen,
           "--opsætning af izocash-appen": Konfiguration af izocash-applikationen,
           "--opsætning af vixinol-appen": Konfiguration af Vixinol-applikationen,
           "--opsætning af Veil Brillant-appen": Konfiguration af Veil Brillant-applikationen,
           "--lagring af billeder, videoer": Lagring af billeder, videoer og flere andre elementer,
           "--speed of reception": Hastighed for modtagelse af data fra datacenteret,
           "--speed": Hastighed,
           "--terminate": Afslut, //t
           "--vpn giver dig adgang": VPN giver dig adgang til et websted eller en applikation, som din internetudbyder har sortlistet,
           "--det største træ var ovenover": Det største træ var frem for alt et simpelt lille frø,
           "--touch the screen": Tryk på skærmen for at fortsætte,
           "--try again": Prøv igen!,
           "--brugernavn": Brugernavn, //u

           "--virtuelt nummer": Virtuelt nummer, //v
           "--virtuelle telefonindstillinger": Virtuelle telefonindstillinger,
           "--virtuel telefonsprog er anvendt": Det virtuelle telefonsprog anvendes som standard på applikationsniveau,
           "--virtual phone": Virtuel telefon,
           "--validate": Valider,
           "--velkommen til izocash-kundeportalen": Velkommen til izocash-kundeportalen, //w
           "--skriv en superkode": Indtast en superkode,
           "--velkommen til": Velkommen til,
           "--hvor folks opmærksomhed går": Hvor folks opmærksomhed går, går pengene,
           "--vindere holder ud": Vinderne holder ud,
           "--vil du gerne logge ud af din Alrani-konto": Vil du logge ud af din Alrani-konto?,
           "--yes": Ja, //y

           // Land
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroun,
           "--drc": DRC,
           "--ivoryCoast": Elfenbenskysten,

           // sprog
        "--afrikaans": Afrikaans, //a
        "--albanian": albansk,
        "--amharisk": amharisk,
        "--arabic": arabisk,
        "--armensk": armensk,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbajdsjansk": aserbajdsjansk,
        "--bambara": Bambara, //b
        "--basque": baskisk,
        "--hviderussisk": hviderussisk,
        "--bengali": bengalsk,
        "--bhojpuri": Bhojpuri,
        "--bosnisk": bosnisk,
        "--bulgarsk": bulgarsk,
        "--catalansk": catalansk, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kinesisk (forenklet),
        "--chineseTraditional": kinesisk (traditionel),
        "--corsican": korsikansk,
        "--croatian": kroatisk,
        "--tjekkisk": tjekkisk,
        "--danish": dansk, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--hollandsk": hollandsk,
        "--engelsk": Engelsk, //e
        "--esperanto": Esperanto,
        "--estisk": estisk,
        "--ewe": Moder,
        "--filippinsk": filippinsk, //f
        "--finnish": finsk,
        "--fransk": fransk,
        "--frisian": frisisk,
        "--galicisk": galicisk, //g
        "--georgian": georgisk,
        "--german": tysk,
        "--greek": græsk,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": haitisk kreolsk, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiiansk,
        "--hebrew": hebraisk,
        "--hindi": hindi,
        "--hmong": Hmong,
        "--hungarian": ungarsk,
        "--islandsk": islandsk, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesisk": indonesisk,
        "--irish": irsk,
        "--italiensk": italiensk,
        "--japansk": japansk, //j
        "--javanese": javanesisk,
        "--kannada": Kannada, //k
        "--kasakh": kasakhisk,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": koreansk,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdisk (Kurmanji),
        "--kurdishSorani": kurdisk (Sorani),
        "--kyrgyz": Kirgisisk,
        "--lao": Lao, //l
        "--latin": latin,
        "--latvisk": lettisk,
        "--lingala": Lingala,
        "--litauisk": litauisk,
        "--luganda": Luganda,
        "--luxembourgish": luxembourgsk,
        "--makedonsk": makedonsk, //m
        "--maithili": Maithili,
        "--malagasy": madagaskisk,
        "--malay": malaysisk,
        "--malayalam": malayalam,
        "--maltesisk": maltesisk,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolsk": mongolsk,
        "--myanmarburmesisk": Myanmar (burmesisk),
        "--nepali": nepalesisk, //n
        "--norsk": norsk,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //s
        "--persisk": persisk,
        "--polsk": polsk,
        "--portuguese": portugisisk,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--rumænsk": rumænsk, //r
        "--russisk": russisk,
        "--samoan": samoansk, //s
        "--sanskrit": sanskrit,
        "--scotsGaelic": skotsk gælisk,
        "--sepedi": Sepedi,
        "--serbian": serbisk,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": singalesisk,
        "--slovak": slovakisk,
        "--slovensk": slovensk,
        "--somali": Somali,
        "--spanish": spansk,
        "--sundanese": sundanesisk,
        "--swahili": Swahili,
        "--svensk": svensk,
        "--tajik": Tadsjikisk, //t
        "--tamil": Tamil,
        "--tatar": tatarisk,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--tyrkisk": tyrkisk,
        "--turkmen": turkmenske,
        "--twi": Twi,
        "--ukrainsk": ukrainsk, //u
        "--urdu": Urdu,
        "--uyghur": uigurisk,
        "--uzbek": usbekisk,
        "--vietnamesisk": vietnamesisk, //v
        "--welsh": walisisk, //w
        "--xhosa": Xhosa, //x
        "--jiddisch": Jiddisch, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // dhivehi
      // dhivehi
      dhivehi: {
        translations: {
          "--ގޯހެއް ދިމާވެއްޖެ": ގޯހެއް ދިމާވެއްޖެ!، //a
           "--address": އެޑްރެސްތައް،
           "--ލަފާ": ނަސޭހަތް،
           "--continu އަށް ކްލިކް ކުރުމުން": continue އަށް ކްލިކް ކުރުމުން ވީލް ބްރިލަންޓް އެކައުންޓުން ގުޅުން ކަނޑާލެވޭނެ، //b
           "--ޑިސްކަނެކްޓް އަށް ކްލިކް ކުރުމުން ކަނެކްޓް ވާނެ": ޑިސްކަނެކްޓް އަށް ކްލިކް ކުރުމުން އައިޒޯކޭޝް އެކައުންޓުން ކަނެކްޓް ވާނެ،
           "--ތިމާގެ ވާޗުއަލް ނަންބަރު ޗެކްކުރުން ނުވަތަ ފަހުން އަލުން މަސައްކަތްކުރުން": ތިބާގެ ވާޗުއަލް ނަންބަރު ޗެކްކުރުން ނުވަތަ ފަހުން އަލުން މަސައްކަތްކުރުން، //c
           "--ތިމާގެ ވާޗުއަލް ނަންބަރު ޗެކްކުރުން": ތިބާގެ ވާޗުއަލް ނަންބަރު ޗެކްކުރުން،
           "--ކުރިއަށް ދިއުން": ކުރިއަށް ގެންދަވާ،
           "--ގުޅުން": ގުޅުން،
           "--އެއްބާރުލުން ދިނުން، އެއްބައިވަންތަކަމާއެކު އުޅުން": އެއްބާރުލުން ދިނުން، އެހެން މީހުންނާ އެއްބައިވަންތަކަމާއެކު އުޅުން،
           "--ބަސް ހޮވުން": ވާޗުއަލް ފޯނު ބަސް،
           "-- ވާދަވެރިކަން ހުއްޓުވާކަށް ނުޖެހޭ": ވާދަވެރިކަން ހުއްޓުވާކަށް ނުޖެހޭ، އެންމެންނަށް ފުރުސަތު ދޭ، //ދ
           "--disconnection": ގުޅުން ކަނޑާލުން،
           "--ހުރިހާ ވާޗުއަލް ފޯނު ބޭނުންކުރާ ފަރާތްތަކަށް": ވާޗުއަލް ފޯނު ބޭނުންކުރާ ހުރިހާ ފަރާތްތަކަށް ވީޕީއެން، //f ބޭނުންކުރުން ރަނގަޅެވެ
           "--ލޮގިން ޕޭޖަށް ދިއުން": ލޮގިން ޕޭޖަށް ދިއުން، //ގ
           "--ތާރީޚީ": ތާރީޚީ، //ހ
           "--އަހަރެންގެ އެކައުންޓެއް އެބައޮތް": އަހަރެންގެ އެކައުންޓެއް މިހާރުވެސް އެބައޮތް، //i
           "--އަހަރެންގެ އެކައުންޓެއް ނެތް": އަހަރެންގެ އެކައުންޓެއް ނެތް،
           "--އެއީ ތިބާގެ ގެ": އެއީ ތިބާގެ ގެ،
           "--ތަސްވީރު / ވީޑިއޯ +": ތަސްވީރު / ވީޑިއޯ +،
           "--އައިޑެންޓިޓީ ވެރިފިކޭޝަން": އައިޑެންޓިޓީ ވެރިފިކޭޝަން،
           "--izocash ކަސްޓަމަރ ޕޯޓަލް": izocash ކަސްޓަމަރ ޕޯޓަލް،
           "--ކޮންމެ އަހަރަކު އައިޑެންޓިޓީ އަޕްޑޭޓްކުރުން": ކޮންމެ އަހަރަކު އައިޑެންޓިޓީ އަޕްޑޭޓްކުރުން،
           "--izocash ގަންނަން": izocash ގަންނަން => izocash އިންޓަނޭޝަނަލް،
           "--ލޮގް އިން": ލޮގް އިން!، //l
           "--ލޮގިން": ލޮގްއިން،
           "--login to veil brilliant": ވެއިލް ބްރިލަންޓް އާއި ގުޅުން،
           "--login to vixinol store": ވިކްސިނޯލް ސްޓޯރ އާއި ގުޅުން،
           "--login for free to your veil Brillant account": މި ފީޗާއަށް ވަނުމަށް ވެއިލް ބްރިލަންޓް އެކައުންޓަށް ހިލޭ ލޮގިން ވެލައްވާ،
           "--ލޮގިން ކާމިޔާބު": ލޮގިން ކާމިޔާބު!،
           "--މިހާރު ލޮގިން ކޮށްލައްވާ": މިހާރު ލޮގިން ވެލައްވާ!،
           "--ލޮގްއައުޓް ކާމިޔާބު": ލޮގްއައުޓް ކާމިޔާބު!،
           "--ލޮގް އައުޓް": ލޮގްއައުޓް،
           "--logout": ލޮގްއައުޓް،
           "--ނަންބަރު": ނަންބަރު، //n
           "--ނަން": ނަން،
           "--މިހާރު ލޮގް އިން": މިހާރު، ލޮގް އިން!،
           "--ވާދަވެރިކަން ހުއްޓުވުން މަނާކުރުން":
           "--ހަސަދަވެރިކަމެއް، ނަފްރަތެއް": ހަސަދަވެރިކަމެއް، ނަފްރަތެއް، ބައިބައިވުންތަކެއް،
           "--ނޫން": ނޫން،
           "--ވާޗުއަލް ފޯނަށް ވަދެވޭނެ ރަސްމީ އެޑްރެސްތައް": ވާޗުއަލް ފޯނަށް ވަދެވޭނެ ރަސްމީ އެޑްރެސްތައް، //o
           "--ޕާސްވޯޑް": ޕާސްވޯޑް، //ޞ
           "--ޕޮއިންޓްސް ވިތުޑްރަވަލްސް އިޒޯކޭޝް": ޕޮއިންޓްސް ވިތުޑްރަވަލްސް އިޒޯކޭޝް،
           "--ޕޮއިންޓް ވިތުޑްރަވަލްސް": ޕޮއިންޓް ވިތުޑްރަވަލްސް،
           "--ރަނގަޅީ، ވީޕީއެން ބޭނުންކުރުން": އިސްކަންދެވޭނީ، ތިބާގެ އިންޓަރނެޓް ޚިދުމަތްދޭ ފަރާތަށް ނިސްބަތް ނުވާ ވީޕީއެން ބޭނުންކުރުން،
           "-- ސާބިތުކަމުން އަބަދުވެސް ފައިދާ ލިބެނީ": ސާބިތުކަމުން އަބަދުވެސް ނަތީޖާ ލިބެނީ ނިމުމުގައި،
           "--rule": ގަވާއިދުތައް، //r
           "--ލަފާ": ލަފާ،
           "--ރަޖިސްޓްރޭޝަން": ރަޖިސްޓްރޭޝަން،
           "--signup to veil brilliant": ވެއިލް ބްރިލަންޓްގައި ރަޖިސްޓްރީވުން، //s
           "--ވިކްސިނޯލް ފިހާރައަށް ސޮއިކުރުން": ވިކްސިނޯލް ފިހާރައިން ރަޖިސްޓްރީވުން،
           "--ސައިންއަޕް": ރަޖިސްޓްރީ ކުރުން،
           "--ސައިންއަޕް ކާމިޔާބު": ރަޖިސްޓްރޭޝަން ކާމިޔާބު!،
           "--ހިލޭ ސޮއިކުރުން": ހިލޭ ރަޖިސްޓްރީ ކުރުން،
           “--ސައިންއަޕް ކާމިޔާބު އައިއޭ”: ކަނެކްޝަން ކާމިޔާބު”,
           "--ސެޓިންގސް": "ސެޓިންގސް"،
           "--އަލްރާނީ އެޕް ސެޓްއަޕްކުރުން": އަލްރާނީ އެޕްލިކޭޝަން ކޮންފިގްރޭޓްކުރުން،
           "--އައިޒޯކޭޝް އެޕް ސެޓްއަޕްކުރުން": އައިޒޯކޭޝް އެޕްލިކޭޝަން ކޮންފިގްރޭޓްކުރުން،
           "--ވިކްސިނޯލް އެޕް ސެޓްއަޕްކުރުން": ވިކްސިނޯލް އެޕްލިކޭޝަން ކޮންފިގްރޭޓްކުރުން،
           "--ވެއިލް ބްރިލަންޓް އެޕް ސެޓްއަޕްކުރުން": ވެއިލް ބްރިލަންޓް އެޕްލިކޭޝަން ކޮންފިގްރޭޓްކުރުން،
           "--ތަސްވީރު، ވީޑިއޯ ރައްކާކުރުން": ތަސްވީރު، ވީޑިއޯ އަދި އެހެނިހެން ބައެއް އުފެއްދުންތައް ރައްކާކުރުން،
           "--ސްޕީޑް އޮފް ރިސެޕްޝަން": ޑޭޓާސެންޓަރ އިން ޑޭޓާ ލިބޭ ސްޕީޑް،
           "--ސްޕީޑް": ސްޕީޑް،
           "--terminate": ނިންމާލުން، //t
           "--the vpn allows you to access": ވީޕީއެން މެދުވެރިކޮށް އިންޓަނެޓް ހިދުމަތްދޭ ފަރާތުން ބްލެކްލިސްޓްކޮށްފައިވާ ސައިޓަކަށް ނުވަތަ އެޕްލިކޭޝަނަކަށް ވަދެވޭނެ،
           "--އެންމެ ބޮޑު ގަސް އޮތީ މަތީގައި": އެންމެ ބޮޑު ގަހަކީ އެންމެ މަތީގައި އާދައިގެ ކުޑަ އޮށެއް،
           "--ސްކްރީންގައި އަތްލާށެވެ": ކުރިއަށް ދިއުމަށް ސްކްރީނުގައި އަތްލާށެވެ،
           "--އަނެއްކާވެސް މަސައްކަތް ކުރާށެވެ": އަނެއްކާވެސް މަސައްކަތް ކުރާށެވެ!،
           "--ޔޫޒަރނޭމް": ޔޫޒަރނޭމް، //u

           "--ވާޗުއަލް ނަންބަރު": ވާޗުއަލް ނަންބަރު، //v
           "--ވާޗުއަލް ފޯނު ސެޓިންގސް": ވާޗުއަލް ފޯނު ސެޓިންގސް،
           "--ވަރޗުއަލް ފޯން ލޭންގުއޭޖް އެޕްލައި ކުރެވެނީ": ވާޗުއަލް ފޯން ލޭންގުއޭޖް އެޕްލައި ކުރެވެނީ އެޕްލިކޭޝަން ލެވެލްގައި ޑިފޯލްޓްކޮށް،
           "--ވާޗުއަލް ފޯނު": ވާޗުއަލް ފޯނު،
           "--ސައްހަކުރުން": ސައްހަކުރުން،
           "--އިޒޯކޭޝް ކަސްޓަމަރ ޕޯޓަލްއަށް މަރުހަބާ": އިޒޯކޭޝް ކަސްޓަމަރ ޕޯޓަލްއަށް މަރުހަބާ، //w
           "--ސުޕަރ ކޯޑެއް ލިޔެލާށެވެ": ސުޕަރ ކޯޑެއް ލިޔެ،
           "--މަރުހަބާ": މަރުހަބާ،
           "--މީހުންގެ ސަމާލުކަން ދާ ތަނެއް": މީހުންގެ ސަމާލުކަން ދާ ތަނެއް ފައިސާ ދާ ތަނެއް،
           "--މޮޅުވާ މީހުން ކެތްތެރިވުން": ކާމިޔާބު ހޯދާ މީހުން ކެތްތެރިވުން،
           "--އަލްރާނީ އެކައުންޓުން ލޮގް އައުޓް ކުރަން ބޭނުންތޯ": އަލްރާނީ އެކައުންޓުން ލޮގް އައުޓް ކުރަން ބޭނުން ހެއްޔެވެ؟،
           "--އާނ": އާދެ، //y

           // ޤައުމު
           "--ކޮންގޯ": ކޮންގޯ ބްރެޒާވިލް،
           "--ކެމަރޫން": ކެމަރޫން،
           "--drc": ދިވެހިރާއްޖެ،
           "--ivoryCoast": އައިވަރީ ކޯސްޓް،

           // ލަންގް
        "--އެފްރިކާންސް": އެފްރިކަންސް، //a
        "--އަލްބޭނިއަން": އަލްބޭނިއާ،
        "--އަމްހާރިކް": އަމްހާރިކް،
        "--އަރަބި": ޢަރަބި،
        "--އާރްމީނިއަން": އަރްމީނިއާ،
        "--އަސަމީ": އަސަމީ،
        "--aymara": އައިމަރާ،
        "--އަޒަރުބައިޖާނީ": އަޒަރުބައިޖާނު،
        "--ބަމްބާރާ": ބަމްބަރާ، //ބ
        "--ބަސްކް": ބާސްކް،
        "--ބެލަރޫޝިއަން": ބެލަރޫސިއަން،
        "--ބެންގަލީ": ބަންގާޅު،
        "--bhojpuri": ބޮޖްޕޫރީ،
        "--ބޮސްނިއާ": ބޮސްނިއާ،
        "--ބަލްގޭރިއަން": ބަލްގޭރިއަން،
        "--ކެޓަލޯނިއާ": ކެޓަލޯނިއާ، //c
        "--ސެބޫއާނޯ": ސެބޫއާނޯ،
        "--ޗިޗެވާ": ޗިޗެވާ،
        "--chineseSimplified": ޗައިނީސް (ފަސޭހަކޮށްފައިވާ)،
        "--chineseTraditional": ޗައިނީސް (ސަގާފީ)،
        "--ކޯސިކަން": ކޯސިކަން،
        "--ކްރޮއޭޝިއަން": ކްރޮއޭޝިއަން،
        "--ޗެކް": ޗެކް،
        "--danish": ޑެނިޝް، //ދ
        "--ދިވެހި": ދިވެހި،
        "--ޑޮގްރީ": ޑޮގްރީ،
        "--ޑަޗް": ޑަޗް،
        "--ދިވެހި": އިނގިރޭސި، //e
        "--އެސްޕެރަންޓޯ": އެސްޕެރަންޓޯ،
        "--އެސްޓޯނިއަން": އެސްޓޯނިއާ،
        "--އެވް": އީވް،
        "--ފިލިޕީނޯ": ފިލިޕީންސް، //ފ
        "--ފިންލޭންޑް": ފިންލޭންޑް،
        "--ފްރެންޗް": ފްރެންޗް،
        "--ފްރިޝިއަން": ފްރިޝިއަން،
        "--ގަލިޝިއަން": ގަލިޝިއަން، //ގ
        "--ޖޯޖިއަން": ޖޯޖިއަން،
        "--ޖަރުމަނު": ޖަރުމަނު،
        "--ގްރީކް": ގްރީކް،
        "--ގުއަރާނީ": ގުއަރާނީ،
        "--ގުޖުރާތީ": ގުޖުރާތީ،
        "--haitianCreole": ހޭޓިއަން ކްރިއޯލް، //h
        "--ހައުސާ": ހައުސާ،
        "--ހަވާއީ": ހަވާއީ،
        "--އިބްރާހީމީ": އިބްރާހީމީ،
        "--ހިންދީ": ހިންދީ،
        "--ހުމޮންގް": ހިމޮންގް،
        "--ހަންގޭރީ": ހަންގޭރީ،
        "--އައިސްލޭންޑް": އައިސްލޭންޑް، //i
        "--އިގްބޯ": އިގްބޯ،
        "--ilocano": އިލޮކާނޯ،
        "--އިންޑޮނޭޝިއަން": އިންޑޮނޭޝިއާ،
        "--އައިރިޝް": އައިރިޝް،
        "--އިޓަލީ": އިޓަލީ،
        "--ޖަޕާނު": ޖަޕާނު، //ޖ
        "--ޖަވާނީޒް": ޖާވާނީޒް،
        "--ކަނޑު": ކަނާތު، //ކ
        "--ކަޒަޚް": ކަޒަޚް،
        "--ޚްމޭރު": ޚްމޭރު،
        "--ކިނިޔަރުވާންޑާ": ކިނިޔަރުވާންޑާ،
        "--konkani": ކޮންކަނީ،
        "--ކޮރެއަން": ކޮރެއާ،
        "--ކްރިއޯ": ކްރިއޯ،
        "--kurdishKurmanji": ކުރުދީ (ކުރްމާންޖީ)،
        "--kurdishSorani": ކުރުދީ (ސޮރާނީ)،
        "--kyrgyz": ކިރްގިޒް،
        "--ލާއޯ": ލާއޯ، //ލ
        "--ލެޓިން": ލެޓިން،
        "--ލެޓްވިއާ": ލެޓްވިއާ،
        "--ލިންގަލާ": ލިންގަލާ،
        "--ލިތުއޭނިއާ": ލިތުއޭނިއާ،
        "--ލުގަންޑާ": ލުގަންޑާ،
        "--luxembourgish": ލަކްޒަމްބަރޖިޝް،
        "--މެސެޑޯނިއަން": މެސެޑޯނިއަން، //މ
        "--maithili": މައިތިރި،
        "--މަލަގަސީ": މާލެގަސީ،
        "--މާލެ": މާލެ،
        "--މާލެ": މާލެ،
        "--މޯލްޓާ": މޯލްޓާ،
        "--މައޯރީ": މައޯރީ،
        "--މަރަތީ": މަރާތީ،
        "--meiteilonManipuri": މެއިޓެއިލޮން (މަނިޕޫރީ)،
        "--މިޒޯ": މިޒޯ،
        "--މޮންގޯލިއަން": މޮންގޯލިއަން،
        "--myanmarބަރުމާ": މިޔަންމާ (ބަރުމާ)،
        "--nepali": ނޭޕާލީ، //ނ
        "--ނޯވޭޖިއަން": ނޯވޭޖިއަން،
        "--odiaOriya": އޮޑިއާ (އޮރިޔާ)، //o
        "--oromo": އޮރޯމޯ،
        "--ޕަޝްޓޯ": ޕަޝްޓޯ، //ޞ
        "--ފާރިސީ": ފާރިސީ،
        "--ޕޮލިޝް": ޕޮލިޝް،
        "--ޕޯޗުގީޒް": ޕޯޗުގީޒް،
        "--ޕަންޖާބީ": ޕަންޖާބީ،
        "--ކުއެޗުއާ": ކުއެޗުއާ، //q
        "--ރޯމޭނިއަން": ރޫމިނިއަން، //ރ
        "--ރަޝިޔާ": ރަޝިޔާ،
        "--ސަމޯއަން": ސަމޯއާ، //ސ
        "--ސަންސްކްރިޓް": ސަންސްކްރިޓް،
        "--scotsGaelic": ސްކޮޓްސް ގޭލިކް،
        "--ސެޕެޑީ": ސެޕެޑީ،
        "--ސާބިއަން": ސާބިއަން،
        "--ސެސޯތޯ": ސެސޯތޯ،
        "--ޝޯނާ": ޝޯނާ،
        "--ސިންދީ": ސިންދީ،
        "--ސިންހަލާ": ސިންގަޅަ،
        "--ސްލޮވާކިއާ": ސްލޮވާކިއާ،
        "--ސްލޮވޭނިއާ": ސްލޮވޭނިއާ،
        "--ސޯމާލީ": ސޯމާލިއާ،
        "--ސްޕެނިޝް": ސްޕެނިޝް،
        "--ސުންޑާނީޒް": ސުންޑަނީޒް،
        "--ސްވާހިލީ": ސްވާހިލީ،
        "--ސްވިޑެން": ސްވިޑެން،
        "--ތަޖިކް": ތާޖިކް، //t
        "--ތަމަޅަ": ތަމަޅަ،
        "--ތަތާރު": ތަތާރު،
        "--ޓެލަގޫ": ޓެލަގޫ،
        "--ތައި": ތައި،
        "--tigrinya": ދިވެހީން،
        "--tsonga": ޓްސޮންގާ،
        "--ތުރުކީ": ތުރުކީ،
        "--ތުރުކުމަނުން": ތުރުކީ،
        "--twi": ޓްވީ،
        "--ޔޫކްރެއިން": ޔޫކްރޭން، //u
        "--urdu": އުރުދޫ،
        "--އުއިޣުރު": އުއިގޫރު،
        "--އުޒްބެކް": އުޒްބެކް،
        "--ވިއެޓްނާމް": ވިއެޓްނާމް، //v
        "--ވެލްޝް": ވެލްޝް، //ވ
        "--xhosa": ކްސޯސާ، //x
        "--ޔިޑިޝް": ޔިޑިޝް، //ޔައި
        "--ޔޯރޫބާ": ޔޯރޫބާ،
        "--ޒޫލޫ": ޒުލޫ، //ޒެޑް
        },
      },

      // dogri
      // dogri
      dogri: {
        translations: {
          "--एक त्रुटि होई गेई ऐ": इक त्रुटि होई गेई ऐ!, //a
          "--पता": पते,
          "--सलाह": सलाह,
          "--जारी पर क्लिक करियै": जारी रक्खो पर क्लिक करने कन्नै तुस अपने घूंघट ब्रिलंट खाते थमां डिस्कनेक्ट होई जागे, //b
          "--डिस्कनेक्ट पर क्लिक करने कन्नै तुस डिस्कनेक्ट होई जागे": डिस्कनेक्ट पर क्लिक करने कन्नै तुस अपने izocash खाते थमां डिस्कनेक्ट होई जागे,
          "--अपने आभासी नंबर दी जांच करो जां बाद च दुबारा कोशश करो": अपने आभासी नंबर दी जांच करो जां बाद च दुबारा कोशश करो, //c
          "--अपने आभासी नंबर दी जांच करो": अपने आभासी नंबर दी जांच करो,
          "--जारी रखो": जारी रखो,
          "--कनेक्ट": कनेक्शन,
          "--सहयोग करना, तालमेल च जीना": सहयोग करना, दुए कन्नै तालमेल च जीना,
          "--भाषा चुनें": आभासी फोन भाषा,
          "--प्रतिस्पर्धा गी नेईं रोको": प्रतिस्पर्धा गी नेईं रोको, हर कुसै गी मौका देओ, //d
          "--डिस्कनेक्ट": डिस्कनेक्ट करना,
          "--सभनें वर्चुअल फोन बरतूनियें आस्तै": सारे वर्चुअल फोन बरतूनी आस्तै, वीपीएन, //f दा इस्तेमाल करने दी सलाह दित्ती जंदी ऐ
          "--लॉगिन पृष्ठ पर जाओ": लॉगिन पृष्ठ पर जाओ, //जी
          "--ऐतिहासिक": ऐतिहासिक, //एच
          "--मेरे कोल खाता ऐ": मेरे कोल पैह् ले थमां गै इक खाता ऐ, //मैं
          "--मेरे कोल खाता नेईं ऐ": मेरा खाता नेईं ऐ,
          "--तेरा घर ऐ": तेरा घर ऐ,
          "--छवि / वीडियो +": छवि / वीडियो +,
          "--पहचान सत्यापन": पन्छान सत्यापन,
          "--izocash ग्राहक पोर्टल": izocash ग्राहक पोर्टल,
          "--हर साल पन्छान अपडेट": हर साल पन्छान अपडेट,
          "--izocash खरीदें गी": izocash खरीदें => izocash अंतरराष्ट्रीय,
          "--लॉग इन": लॉग इन!, //एल
          "--लॉगिन": लॉग इन,
          "--घूंघट शानदार करने आस्तै लॉगिन": घूंघट शानदार कन्नै कनेक्ट करो,
          "--विक्सिनॉल स्टोर च लॉगिन करो": विक्सिनॉल स्टोर कन्नै कनेक्ट करो,
          "--अपने घूंघट ब्रिलंट खाते च मुफ्त लॉग इन करो": इस सुविधा गी एक्सेस करने लेई अपने घूंघट ब्रिलंट खाते च मुफ्त लॉग इन करो,
          "--लॉगिन सफलता": लॉगिन सफल!,
          "--अब लॉग इन करो": अज्जै थमां गै लॉग इन करो!,
          "--लॉगआउट सफलता": लॉगआउट सफल!,
          "--लॉग आउट": लॉगआउट,
          "--लॉगआउट": लॉग आउट,
          "--नंबर": नंबर, //एन
          "--नाम": नाम,
          "--अब लॉग इन करो": हुण, लॉग इन करो!,
          "--प्रतिस्पर्धा गी दबाने पर कोई रोक नेईं":
          "--ना ईर्ष्या, ना नफरत": ना ईर्ष्या, ना नफरत, ना बंटवारा,
          "--नहीं": नहीं,
          "--अपने आभासी फोन गी एक्सेस करने लेई आधिकारिक पते": अपने आभासी फोन गी एक्सेस करने लेई आधिकारिक पते, //o
          "--पासवर्ड": पासवर्ड, //पी
          "--बिंदु निकासी izocash": अंक निकासी izocash,
          "--बिंदु वापसी": अंक वापसी,
          "--अधिमानतः, इक vpn दा इस्तेमाल करो": अधिमानतः, इक वीपीएन दा इस्तेमाल करो जेह् ड़ा तुंदे इंटरनेट सेवा प्रदाता कन्नै सरबंधत नेईं ऐ,
          "--जिद्द हमेशा फलदा-फूलदा ऐ": जिद हमेशा अंत च फलदा ऐ,
          "--नियम": नियम, //आर
          "--सिफारिश": सिफारिशें,
          "--पंजीकरण": पंजीकरण,
          "--घूंघट शानदार करने लेई साइनअप": घूंघट शानदार पर रजिस्टर करो, //s
          "--विक्सिनॉल स्टोर च साइनअप करो": विक्सिनॉल स्टोर पर रजिस्टर करो,
          "--साइनअप": रजिस्टर करो,
          "--साइनअप सफलता": पंजीकरण सफल!,
          "--मुफ्त च साइनअप करो": मुफ्त रजिस्टर करो,
          “--साइनअप सफलता आईए”: कनेक्शन सफल”,
          "--सेटिंग्स": "सेटिंग्स",
          "--अलरानी ऐप गी सेट करना": अलरानी एप्लिकेशन गी कॉन्फ़िगर करना,
          "--izocash ऐप गी सेट करना": izocash एप्लिकेशन गी कॉन्फ़िगर करना,
          "--विक्सिनॉल ऐप गी सेट करना": विक्सिनॉल एप्लिकेशन गी कॉन्फ़िगर करना,
          "--घूंघट ब्रिलंट ऐप गी सेट करना": घूंघट ब्रिलंट एप्लिकेशन गी कॉन्फ़िगर करना,
          "--छवि, वीडियो दा भंडारण": छवि, वीडियो ते केईं होर तत्वें दा भंडारण,
          "--रिसेप्शन दी गति": डाटासेंटर थमां डेटा रिसेप्शन दी गति,
          "--गति": गति,
          "--समाप्त करना": समाप्त करना, //टी
          "--vpn तुसेंगी एक्सेस करने दी इजाजत दिंदा ऐ": वीपीएन तुसेंगी कुसै साइट जां ऐपलीकेशन गी एक्सेस करने दी इजाजत दिंदा ऐ जेह् ड़ी तुंदे इंटरनेट सेवा प्रदाता ने ब्लैकलिस्ट कीती ऐ,
          "--सबसे बडा पेड़ ऊपर था": सब तों वड्डा पेड़ सब तों उपर इक साधारण छोटा बीज सी,
          "--स्क्रीन गी टच करो": जारी रखने लेई स्क्रीन गी टच करो,
          "--फिर कोशिश करो": फिर कोशिश करो!,
          "--उपयोगकर्ता दा नांऽ": उपयोगकर्ता दा नांऽ, //यू

          "--वर्चुअल नंबर": आभासी नंबर, //v
           "--वर्चुअल फोन सेटिंग्स": आभासी फोन सेटिंग्स,
           "--वर्चुअल फोन लैंग्वेज लागू कीती जंदी ऐ": वर्चुअल फोन लैंग्वेज गी डिफ़ॉल्ट रूप कन्नै एप्लिकेशन स्तर पर लागू कीता जंदा ऐ,
           "--वर्चुअल फोन": आभासी फोन,
           "--मान्य करना": मान्य करना,
           "--izocash ग्राहक पोर्टल च तुंदा सुआगत ऐ": izocash ग्राहक पोर्टल च तुंदा सुआगत ऐ, //w
           "--एक सुपर कोड लिखो": इक सुपर कोड दर्ज करो,
           "--स्वागत ऐ": स्वागत ऐ,
           "--जहां लोकां दा ध्यान जांदा है": जित्थे लोकां दा ध्यान पैसा जांदा है,
           "--विजेता दृढ़ता": विजेता दृढ़ता,
           "--क्या तुस अपने अलरानी खाते थमां लॉग आउट करना चांह् दे ओ": क्या तुस अपने अलरानी खाते थमां लॉग आउट करना चांह् दे ओ?,
           "--हां": हां, //वाई

           // देश
           "--कांगो": कांगो ब्राज़ाविले, 1999।
           "--कैमरून": कैमरून,
           "--drc": डीआरसी, 1999।
           "--ivoryCoast": आइवरी कोस्ट, 1999।

           // लैंग्वे
        "--afrikaans": अफ्रीकी, //ए
        "--अल्बेनियाई": अल्बेनियाई,
        "--अम्हारिक": अमहारिक,
        "--अरबी": अरबी,
        "--आर्मेनियाई": आर्मेनियाई,
        "--असामी": असमिया,
        "--अयमारा": आयमारा,
        "--अजरबैजानी": अजरबैजानी,
        "--बम्बरा": बम्बरा, //बी
        "--बास्क": बास्क,
        "--बेलारूसी": बेलारूसी,
        "--बंगाली": बंगाली,
        "--भोजपुरी": भोजपुरी,
        "--बोस्नियाई": बोस्नियाई,
        "--बल्गेरियाई": बल्गेरियाई,
        "--कैटलन": कैटेलोनियाई, //सी
        "--सेबुआनो": सेबुआनो,
        "--चिचेवा": चिचेवा,
        "--chineseSimplified": चीनी (सरलीकृत),
        "--chineseTraditional": चीनी (पारंपरिक),
        "--कोर्सिकन": कोर्सिकन,
        "--क्रोएशियाई": क्रोएशियाई,
        "--चेक": चेक,
        "--डेनिश": डेनिश, //डी
        "--धिवेही": धिवेही,
        "--डोगरी": डोगरी,
        "--डच": डच,
        "--अंग्रेजी": अंग्रेजी, //ई
        "--एस्पेरान्तो": एस्पेरान्तो,
        "--एस्टोनियाई": एस्टोनियाई,
        "--भेड़": भेड़,
        "--फिलिपिनो": फिलिपिनो, //च
        "--फिनिश": फिनिश,
        "--फ्रेंच": फ्रेंच,
        "--फ्रीज़ियन": फ्रीसियन,
        "--गैलिशियन्": गैलिशियन्, //जी
        "--जॉर्जियन": जॉर्जियाई,
        "--जर्मन": जर्मन,
        "--ग्रीक": ग्रीक,
        "--गुआरानी": गुआरानी,
        "--गुजरती": गुजराती,
        "--haitianCreole": हैती क्रियोल, //एच
        "--हौसा": हौसा,
        "--हवाई": हवाई,
        "--इब्रानी": इब्रानी,
        "--हिंदी": हिंदी,
        "--हमोंग": हमोंग,
        "--हंगरी": हंगरी,
        "--आइसलैंडिक": आइसलैंडिक, //मैं
        "--इग्बो": इग्बो,
        "--इलोकानो": इलोकानो,
        "--इंडोनेशियाई": इंडोनेशियाई,
        "--आयरिश": आयरिश,
        "--इटालियन": इतालवी,
        "--जापानी": जापानी, // जे
        "--जावानी": जावानी,
        "--कन्नड़": कन्नड़, //क
        "--कजाख": कजाख,
        "--खमेर": खमेर,
        "--किन्यरवांडा": किन्यरवांडा,
        "--konkani": कोंकणी,
        "--कोरियाई": कोरियाई,
        "--क्रिओ": क्रिओ,
        "--kurdishKurmanji": कुर्द (कुर्मनजी),
        "--kurdishSorani": कुर्द (सोरानी),
        "--किर्गिज़": किर्गिज़,
        "--लाओ": लाओ, //एल
        "--लैटिन": लैटिन,
        "--लातवियाई": लातवियाई,
        "--लिंगला": लिंगला,
        "--लिथुआनियाई": लिथुआनियाई,
        "--लुगांडा": लुगांडा,
        "--लक्समबर्गिश": लक्समबर्ग,
        "--मैसिडोनियाई": मैसिडोनियाई, //एम
        "--मैथिली": मैथिली,
        "--मालागासी": मालागासी,
        "--मलय": मलय,
        "--मलयालम": मलयालम,
        "--माल्टीज़": माल्टीज़,
        "--माओरी": माओरी,
        "--मराठी": मराठी,
        "--मेइतेइलोनमणिपुरी": मेइतेइलोन (मणिपुरी),
        "--मिज़ो": मिजो,
        "--मंगोली": मंगोलियाई,
        "--myanmarबर्मी": म्यांमार (बर्मी),
        "--नेपाली": नेपाली, //न
        "--नार्वे": नार्वे,
        "--ओडियाओरिया": ओडिया (उड़िया), //ओ
        "--ओरोमो": ओरोमो,
        "--पश्तो": पश्तो, //पी
        "--फारसी": फारसी,
        "--पालिश": पॉलिश,
        "--पुर्तगाली": पुर्तगाली,
        "--पंजाबी": पंजाबी,
        "--क्वेचुआ": क्वेचुआ, //क्यू
        "--रोमानियन": रोमानियाई, //आर
        "--रूसी": रूसी,
        "--समोआन": समोआन, //एस
        "--संस्कृत": संस्कृत,
        "--scotsGaelic": स्कॉट्स गैलिक,
        "--सेपेडी": सेपेडी,
        "--सर्बियाई": सर्बियाई,
        "--सेसोथो": सेसोथो,
        "--शोना": शोना,
        "--सिंधी": सिंधी,
        "--सिंहला": सिंहली,
        "--स्लोवाक": स्लोवाक,
        "--स्लोवेनियाई": स्लोवेनियाई,
        "--सोमाली": सोमाली,
        "--स्पेनिश": स्पैनिश,
        "--सुंडानीज़": सुंडानी,
        "--स्वाहिली": स्वाहिली,
        "--स्वीडिश": स्वीडिश,
        "--ताजिक": ताजिक, //टी
        "--तमिल": तमिल,
        "--तातार": तातार,
        "--तेलुगु": तेलुगु,
        "--थाई": थाई,
        "--तिग्रिनिया": तिग्रिनिया,
        "--त्सोंगा": त्सोंगा,
        "--तुर्की": तुर्की,
        "--तुर्कमेन": तुर्कमेन,
        "--ट्वी": ट्वी,
        "--यूक्रेनी": यूक्रेनी, //यू
        "--उर्दू": उर्दू,
        "--उयघुर": उयघुर,
        "--उज़बेक": उजबेक,
        "--वियतनाम": वियतनामी, //वी
        "--वेल्श": वेल्स, //डब्ल्यू
        "--xhosa": ज़ोसा, //एक्स
        "--यिद्दीश": यिद्दीश, //वाई
        "--योरूबा": योरूबा,
        "--ज़ुलु": ज़ुलु, //जेड
        },
      },

      // dutch
      // dutch
      dutch: {
        translations: {
          "--er is een fout opgetreden": Er is een fout opgetreden!, //a
           "--adres": Adressen,
           "--advies": Advies,
           "--door op doorgaan te klikken": Door op doorgaan te klikken wordt de verbinding met uw Veil Brillant-account verbroken, //b
           "--door op de verbinding verbreken te klikken, wordt de verbinding verbroken": Door op de verbinding verbreken te klikken, wordt de verbinding met uw izocash-account verbroken,
           "--controleer uw virtuele nummer of probeer het later opnieuw": Controleer uw virtuele nummer of probeer het later opnieuw, //c
           "--controleer uw virtuele nummer": Controleer uw virtuele nummer,
           "--doorgaan": Doorgaan,
           "--verbinding": Verbinding,
           "--samenwerken, leven in harmonie": Werk samen, leef in harmonie met anderen,
           "--kies taal": Virtuele telefoontaal,
           "--verhinder concurrentie niet": Voorkom concurrentie niet, geef iedereen een kans, //d
           "--disconnection": Verbinding verbroken,
           "--voor alle gebruikers van virtuele telefoons": Voor alle gebruikers van virtuele telefoons wordt het aanbevolen om een ​​VPN te gebruiken, //f
           "--ga naar de inlogpagina": Ga naar de inlogpagina, //g
           "--historisch": Historisch, //h
           "--i have account": Ik heb al een account, //i
           "--ik heb geen account": ik heb geen account,
           "--het is jouw huis": het is jouw huis,
           "--afbeelding / video +": Afbeelding / Video +,
           "--identiteitsverificatie": Identiteitsverificatie,
           "--izocash klantenportaal": izocash Klantenportaal,
           "--identiteitsupdate elk jaar": Identiteitsupdate elk jaar,
           "--izocash kopen naar": izocash Kopen => izocash internationaal,
           "--log in": Inloggen!, //l
           "--Log in log in,
           "--inloggen bij sluier briljant": Maak verbinding met Veil Brillant,
           "--inloggen op vixinol winkel": Maak verbinding met Vixinol Winkel,
           "--log gratis in op uw Veil Brillant-account": Log gratis in op uw Veil Brillant-account om toegang te krijgen tot deze functie,
           "--login succes": Inloggen succesvol!,
           "--meld u nu aan": Meld u nu aan!,
           "--uitloggen succesvol": Uitloggen succesvol!,
           "--uitloggen": Uitloggen,
           "--uitloggen": Uitloggen,
           "--nummer": Getal, //n
           "--naam naam,
           "--nu inloggen": Nu inloggen!,
           "--geen verbod op het onderdrukken van de concurrentie":
           "-geen jaloezie, geen haat": Geen jaloezie, geen haat, geen verdeeldheid,
           "--Nee nee,
           "--officiële adressen voor toegang tot uw virtuele telefoon": Officiële adressen voor toegang tot uw virtuele telefoon, //o
           "--wachtwoord": Wachtwoord, //p
           "--puntenopnames izocash": Puntenopnames izocash,
           "--puntenopnamen": Puntenopnamen,
           "--gebruik bij voorkeur een vpn": gebruik bij voorkeur een VPN die niet van uw internetprovider is,
           "--volharding loont altijd": Volharding loont uiteindelijk altijd,
           "--rule": Regels, //r
           "--aanbeveling": aanbevelingen,
           "--registratie": Registratie,
           "--meld je aan voor sluier briljant": Registreer je op Veil Brillant, //s
           "--meld u aan bij de vixinol-winkel": Registreer u bij de Vixinol-winkel,
           "--aanmelden": Registreren,
           "--aanmelding succesvol": Registratie succesvol!,
           "--gratis aanmelden": Gratis registreren,
           “--aanmelding succes IA”: Verbinding succesvol”,
           "--settings": "Instellingen",
           "--de alrani-app instellen": De Alrani-app configureren,
           "--de izocash-app instellen": De izocash-applicatie configureren,
           "--de vixinol-app instellen": De Vixinol-applicatie configureren,
           "--de veil Brillant-app instellen": De Veil Brillant-app configureren,
           "--opslag van afbeeldingen, video's": opslag van afbeeldingen, video's en verschillende andere elementen,
           "--ontvangstsnelheid": snelheid van ontvangst van gegevens uit het datacentrum,
           "--snelheid": Snelheid,
           "--terminate": Beëindig, //t
           "--de vpn geeft u toegang": Met de VPN krijgt u toegang tot een site of applicatie die uw internetprovider op de zwarte lijst heeft gezet,
           "-de grootste boom was boven": De grootste boom was vooral een eenvoudig klein zaadje,
           "--raak het scherm aan": raak het scherm aan om door te gaan,
           "--probeer opnieuw": Probeer het opnieuw!,
           "--gebruikersnaam": Gebruikersnaam, //u

           "--virtueel nummer": Virtueel nummer, //v
           "--virtuele telefooninstellingen": Virtuele telefooninstellingen,
           "--virtuele telefoontaal wordt toegepast": de virtuele telefoontaal wordt standaard toegepast op applicatieniveau,
           "--virtuele telefoon": Virtuele telefoon,
           "--validate": Valideren,
           "--welkom bij het izocash-klantenportaal": Welkom bij het izocash-klantenportaal, //w
           "--schrijf een supercode": Voer een Supercode in,
           "--welkom bij": Welkom bij,
           "--waar de aandacht van mensen naartoe gaat": Waar de aandacht van mensen naartoe gaat, gaat geld,
           "--winnaars volharden": De winnaars volharden,
           "--wilt u zich afmelden bij uw Alrani-account": Wilt u zich afmelden bij uw Alrani-account?,
           "--ja": Ja, //y

           // land
           "--congo": Congo-Brazzaville,
           "--kameroen": Kameroen,
           "--drc": Democratische Republiek Congo,
           "--ivoorkust": Ivoorkust,

           // taal
        "--afrikaans": Afrikaans, //a
        "--albanees": Albanees,
        "--amhaars": Amhaars,
        "--arabisch": Arabisch,
        "--armeens": Armeens,
        "--assamees": Assamees,
        "--aymara": Aymara,
        "--azerbeidzjaans": Azerbeidzjaans,
        "--bambara": Bambara, //b
        "--baskisch": Baskisch,
        "--Wit-Russisch": Wit-Russisch,
        "--bengali": Bengaals,
        "--bhojpuri": Bhojpuri,
        "--bosnisch": Bosnisch,
        "--bulgaars": Bulgaars,
        "--catalaans": Catalaans, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chinees vereenvoudigd": Chinees (vereenvoudigd),
        "--chineseTraditioneel": Chinees (traditioneel),
        "--corsicaans": Corsicaans,
        "--kroatisch": Kroatisch,
        "--tsjechisch": Tsjechisch,
        "--deens": Deens, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Nederlands,
        "--english": Engels, //e
        "--esperanto": Esperanto,
        "--estlands": Ests,
        "--ooi": Ooi,
        "--filipijns": Filipijns, //f
        "--fins": Fins,
        "--frans": Frans,
        "--Fries": Fries,
        "--Galicisch": Galicisch, //g
        "--georgisch": Georgisch,
        "--duits": Duits,
        "--grieks": Grieks,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--Haïtiaans Creools": Haïtiaans Creools, //h
        "--hausa": Hausa,
        "--hawaiiaans": Hawaïaans,
        "--hebreeuws": Hebreeuws,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--Hongaars": Hongaars,
        "--ijslands": IJslands, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesisch": Indonesisch,
        "--iers": Iers,
        "--italiaans": Italiaans,
        "--japans": Japans, //j
        "--Javaans": Javaans,
        "--kannada": Kannada, //k
        "--kazachs": Kazachs,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--Koreaans": Koreaans,
        "--krio": Krio,
        "--koerdischKurmanji": Koerdisch (Kurmanji),
        "--koerdischeSorani": Koerdisch (Sorani),
        "--Kirgizisch": Kirgizisch,
        "--lao": Laos, //l
        "--latijn": Latijn,
        "--lets": Lets,
        "--lingala": Lingala,
        "--litouws": Litouws,
        "--luganda": Luganda,
        "--luxemburgs": Luxemburgs,
        "--macedonisch": Macedonisch, //m
        "--maithili": Maithili,
        "--malagasy": Malagasi,
        "--maleis": Maleis,
        "--malayalam": Malayalam,
        "--maltees": Maltees,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongools": Mongools,
        "--myanmarBirmees": Myanmar (Birmaans),
        "--nepali": Nepalees, //n
        "--Noors": Noors,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pasjtoe": Pasjtoe, //p
        "--Perzisch": Perzisch,
        "--polijsten": Pools,
        "--portugees": Portugees,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--roeemeens": Roemeens, //r
        "--russisch": Russisch,
        "--samoaans": Samoaans, //s
        "--Sanskriet": Sanskriet,
        "--Schots-Gaelisch": Schots-Gaelisch,
        "--sepedi": Sepedi,
        "--servisch": Servisch,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--singalees": Singalees,
        "--slowaaks": Slowaaks,
        "--Sloveens": Sloveens,
        "--Somalisch": Somalisch,
        "--spaans": Spaans,
        "--Soendanees": Soendanees,
        "--swahili": Swahili,
        "--zweeds": Zweeds,
        "--tadzjiekse": Tadzjiekse, //t
        "--tamil": Tamil,
        "--tataars": Tataars,
        "--telugu": Telugu,
        "--thai": Thais,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turks": Turks,
        "--Turkmeens": Turkmeens,
        "--twi": Twi,
        "--Oekraïens": Oekraïens, //u
        "--urdu": Urdu,
        "--oeigoerse": Oeigoerse,
        "--Oezbeeks": Oezbeeks,
        "--vietnamees": Vietnamees, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--Jiddisch": Jiddisch, //y
        "--yoruba": Yoruba,
        "--zulu": Zoeloe, //z
        },
      },
      */

      // **english
      // **english
      english: {
        translations: {
           "--an error has occurred": "Une erreur s'est produite !", //a
           "--address": "Addresses",
           "--advice": "Advice",
           "--by clicking on continue": "By clicking on continue you will be disconnected from your Veil Brillant account", //b
           "--by clicking on disconnect you will be disconnected": "By clicking on Disconnect you will be disconnected from your izocash account",
           "--check your virtual number or try again later": "Vérifier votre numéro de téléphone ou réessayer plus tard", //c
           "--check your virtual number": "Check your Virtual number",
           "--continue": "Continue",
           "--connection": "Connexion",
           "--collaborate, live in harmony": "Collaborate, live in harmony with others",
           "--don't prevent competition": "Don't prevent competition, give everyone a chance", //d
           "--disconnection": "Disconnection",
           "--for all virtual phone users": "For all Virtual Phone users, it is recommended to use a VPN", //f
           "--go to login page": "Go to the login page", //g
           "--historical": "Historical", //h
           "--i have account": "J'ai déjà un compte", //i
           "--i don't have account": "Je n'ai pas de compte",
           "--it is your house": "c'est votre maison",
           "--if you have not registered": "Si vous n'êtes pas encore inscrit vous pouvez débuter votre inscription", //new
           "--image / video +": "Image / Video +",
           "--identity verification": "Identity verification",
           "--izocash customer portal": "Portail des clients izocash",
           "--identity update every year": "Identity update every year",
           "--izocash buy to": "izocash Buy => izocash international",
           "--log in": "Connectez-vous !", //l
           "--login": "Se connecter",
           "--login to veil brillant": "Login to Veil Brillant",
           "--login to vixinol store": "Login to Vixinol Store",
           "--login for free to your veil brillant account": "Login for free to your Veil Brillant account to access this feature",
           "--login success": "Connexion réussie !",
           "--login now": "Se connecter maintenant !",
           "--logout success": "Déconnexion réussie !",
           "--log out": "Se déconnecter",
           "--logout": "Déconnexion",
           "--number": "Numéro", //n
           "--name": "Nom",
           "--now log in": "Now, log in!",
           "--no ban on stifling competition": "No ban on stifling competition",
           "--no jealousy, no hatred": "No jealousy, no hatred, no divisions",
           "--no": "No",
           "--official addresses to access your virtual phone": "Official addresses to access your Virtual phone", //o
           "--password": "Mot de passe", //p
           "--points withdrawals izocash": "Points Withdrawals izocash",
           "--points withdrawals": "Points Withdrawals",
           "--preferably, use a vpn": "Preferably, use a VPN that does not belong to your internet service provider",
           "--persistence always pays off": "Persistence always pays off in the end",
           "--please, check your virtual number": "Please, Check your Virtual number",
           "--please, try again later": "Please, try again later !",
           "--platform 1 for virtual applications": "Nº1 platform for virtual applications",
           "--rule": "Rules", //r
           "--recommendation": "Recommendations",
           "--registration": "Inscription",
           "--signup to veil brillant": "Signup on Veil Brillant", //s
           "--signup to vixinol store": "Signup on Vixinol Store",
           "--signup": "S'inscrire",
           "--signup success": "Inscription réussie !",
           "--signup for free": "S'inscrire gratuitement",
           "--signup success IA": "Connexion réussie",
           "--settings": "Settings",
           "--setting up the alrani app": "Configuring the Alrani application",
           "--setting up the izocash app": "Configuring the izocash application",
           "--setting up the vixinol app": "Configuring the Vixinol application",
           "--setting up the veil brillant app": "Configuring the Veil Brillant application",
           "--storage of images, videos": "Storage of images, videos and several other elements",
           "--speed of reception": "Speed of reception of data from the Datacenter",
           "--speed": "Speed",
           "--terminate": "Terminer", //t
           "--the vpn allows you to access": "The VPN allows you to access a site or an application that your internet service provider has blacklisted",
           "--the largest tree was above": "The largest tree was above all a simple little seed",
           "--touch the screen": "Touch the screen to continue",
           "--try again": "Try again!",
           "--phone number": "Numéro de téléphone",
           "--username": "Nom d'utlisateur", //u
           "--virtual number": "Numéro virtuel", //v
           "--virtual phone": "La messagerie 2025",
           "--virtual phone language": "Virtual Phone Language",
           "--virtual phone settings": "Virtual Phone Settings",
           "--virtual phone language is applied": "The Virtual Phone language is applied at the application level by default",
           "--validate": "Valider",
           "--welcome to the izocash customer portal": "Bienvenue sur le portail des clients izocash", //w
           "--write a super code": "Enter a Super code",
           "--welcome to": "Bienvenue sur",
           "--where people's attention goes": "Where people's attention goes money goes",
           "--winners persevere": "Les gagnants persévèrent",
           "--would you like to log out of your florinato account": "Do you want to log out of your Florinato account?",
           "--yes": "Yes", //y

           // country
           "--congo": "Congo Brazzaville",
           "--cameroon": "Cameroon",
           "--drc": "DRC",
           "--ivoryCoast": "Ivory Coast",

          // langue
          "--afrikaans": "Afrikaans", //a
          "--albanian": "Albanian",
          "--amharic": "Amharic",
          "--arabic": "Arabic",
          "--armenian": "Armenian",
          "--assamese": "Assamese",
          "--aymara": "Aymara",
          "--azerbaijani": "Azerbaijani",
          "--bambara": "Bambara", //b
          "--basque": "Basque",
          "--belarusian": "Belarusian",
          "--bengali": "Bengali",
          "--bhojpuri": "Bhojpuri",
          "--bosnian": "Bosnian",
          "--bulgarian": "Bulgarian",
          "--catalan": "Catalan", //c
          "--cebuano": "Cebuano",
          "--chichewa": "Chichewa",
          "--chineseSimplified": "Chinese (Simplified)",
          "--chineseTraditional": "Chinese (Traditional)",
          "--corsican": "Corsican",
          "--croatian": "Croatian",
          "--czech": "Czech",
          "--danish": "Danish", //d
          "--dhivehi": "Dhivehi",
          "--dogri": "Dogri",
          "--dutch": "Dutch",
          "--english": "English", //e
          "--esperanto": "Esperanto",
          "--estonian": "Estonian",
          "--ewe": "Ewe",
          "--filipino": "Filipino", //f
          "--finnish": "Finnish",
          "--french": "French",
          "--frisian": "Frisian",
          "--galician": "Galician", //g
          "--georgian": "Georgian",
          "--german": "German",
          "--greek": "Greek",
          "--guarani": "Guarani",
          "--gujarati": "Gujarati",
          "--haitianCreole": "Haitian Creole", //h
          "--hausa": "Hausa",
          "--hawaiian": "Hawaiian",
          "--hebrew": "Hebrew",
          "--hindi": "Hindi",
          "--hmong": "Hmong",
          "--hungarian": "Hungarian",
          "--icelandic": "Icelandic", //i
          "--igbo": "Igbo",
          "--ilocano": "Ilocano",
          "--indonesian": "Indonesian",
          "--irish": "Irish",
          "--italian": "Italian",
          "--japanese": "Japanese", //j
          "--javanese": "Javanese",
          "--kannada": "Kannada", //k
          "--kazakh": "Kazakh",
          "--khmer": "Khmer",
          "--kinyarwanda": "Kinyarwanda",
          "--konkani": "Konkani",
          "--korean": "Korean",
          "--krio": "Krio",
          "--kurdishKurmanji": "Kurdish (Kurmanji)",
          "--kurdishSorani": "Kurdish (Sorani)",
          "--kyrgyz": "Kyrgyz",
          "--lao": "Lao", //l
          "--latin": "Latin",
          "--latvian": "Latvian",
          "--lingala": "Lingala",
          "--lithuanian": "Lithuanian",
          "--luganda": "Luganda",
          "--luxembourgish": "Luxembourgish",
          "--macedonian": "Macedonian", //m
          "--maithili": "Maithili",
          "--malagasy": "Malagasy",
          "--malay": "Malay",
          "--malayalam": "Malayalam",
          "--maltese": "Maltese",
          "--maori": "Maori",
          "--marathi": "Marathi",
          "--mizo": "Mizo",
          "--mongolian": "Mongolian",
          "--myanmarBurmese": "Myanmar (Burmese)",
          "--nepali": "Nepali", //n
          "--norwegian": "Norwegian",
          "--odiaOriya": "Odia (Oriya)", //o
          "--oromo": "Oromo",
          "--pashto": "Pashto", //p
          "--persian": "Persian",
          "--polish": "Polish",
          "--portuguese": "Portuguese",
          "--punjabi": "Punjabi",
          "--quechua": "Quechua", //q
          "--romanian": "Romanian", //r
          "--russian": "Russian",
          "--samoan": "Samoan", //s
          "--sanskrit": "Sanskrit",
          "--scotsGaelic": "Scots Gaelic",
          "--sepedi": "Sepedi",
          "--serbian": "Serbian",
          "--sesotho": "Sesotho",
          "--shona": "Shona",
          "--sindhi": "Sindhi",
          "--sinhala": "Sinhala",
          "--slovak": "Slovak",
          "--slovenian": "Slovenian",
          "--somali": "Somali",
          "--spanish": "Spanish",
          "--sundanese": "Sundanese",
          "--swahili": "Swahili",
          "--swedish": "Swedish",
          "--tajik": "Tajik", //t
          "--tamil": "Tamil",
          "--tatar": "Tatar",
          "--telugu": "Telugu",
          "--thai": "Thai",
          "--tigrinya": "Tigrinya",
          "--tsonga": "Tsonga",
          "--turkish": "Turkish",
          "--turkmen": "Turkmen",
          "--twi": "Twi",
          "--ukrainian": "Ukrainian", //u
          "--urdu": "Urdu",
          "--uyghur": "Uyghur",
          "--uzbek": "Uzbek",
          "--vietnamese": "Vietnamese", //v
          "--welsh": "Welsh", //w
          "--xhosa": "Xhosa", //x
          "--yiddish": "Yiddish", //y
          "--yoruba": "Yoruba",
          "--zulu": "Zulu", //z
        },
      },

      // **esperanto
      // **esperanto
      /*
      esperanto: {
        translations: {
          "--an error has occurred": Eraro okazis!, //a
           "--address": Adresoj,
           "--advice": Konsilo,
           "--klakante sur daŭrigi": Alklakante daŭrigi vi estos malkonektita de via Veil Brillant-konto, //b
           "--klakante sur malkonekti vi estos malkonektita": Alklakante malkonekti vi estos malkonektita de via izocash-konto,
           "--kontrolu vian virtualan numeron aŭ provu denove poste": Kontrolu vian virtualan numeron aŭ provu denove poste, //c
           "--check your virtual number": Kontrolu vian virtualan numeron,
           "--continue": Daŭrigu,
           "--connection": Konekto,
           "--kunlabori, vivi en harmonio": Kunlabori, vivi en harmonio kun aliaj,
           "--choose language": Virtuala Telefona Lingvo,
           "--ne preventi konkuradon": Ne malhelpu konkurencon, donu al ĉiuj ŝancon, //d
           "--disconnection": Malkonekto,
           "--for all virtual phone users": Por ĉiuj uzantoj de Virtual Phone, oni rekomendas uzi VPN, //f
           "--go to login page": Iru al la ensalutpaĝo, //g
           "--historical": Historia, //h
           "--i havas konton": Mi jam havas konton, //i
           "--i ne havas konton": Mi ne havas konton,
           "--ĝi estas via domo": ĝi estas via domo,
           "--image / video +": Bildo / Video +,
           "--identity verification": Kontrolo de identeco,
           "--izocash klienta portalo": izocash Klienta Portalo,
           "--identity update every year": Identeca ĝisdatigo ĉiujare,
           "--izocash buy to": izocash Buy => izocash internacia,
           "--salutu": Ensalutu!, //l
           "--login": Ensalutu,
           "--login to veil brilliant": Konekti al Veil Brillant,
           "--login to vixinol store": Konekti al Vixinol Store,
           "--ensalutu senpage al via veil Brillant-konto": Ensalutu senpage al via Veil Brillant-konto por aliri ĉi tiun funkcion,
           "--login success": Ensalutu sukcesa!,
           "--login now": Ensalutu nun!,
           "--logout success": Elsaluto sukcesa!,
           "--log out": Elsaluti,
           "--logout": Elsaluti,
           "--number": Nombro, //n
           "--name": Nomo,
           "--now log in": Nun, Ensalutu!,
           "--neniu malpermeso sufoki konkurencon":
           "--no jealousy, no hatred": Neniu ĵaluzo, neniu malamo, neniuj dividoj,
           "--ne ne,
           "--oficial addresses to access your virtual phone": Oficialaj adresoj por aliri vian virtualan telefonon, //o
           "--password": Pasvorto, //p
           "--points withdrawals izocash": Punktaj retiroj izocash,
           "--points withdrawals": Punktretiroj,
           "--preferably, use a vpn": Prefere, uzu VPN kiu ne apartenas al via provizanto de retservo,
           "--persistence always pay off": La persisto ĉiam pagas la finon,
           "--rule": Reguloj, //r
           "--recommendation": Rekomendoj,
           "--registration": Registrado,
           "--signup to veil brilliant": Registriĝi ĉe Veil Brillant, //s
           "--registru al vixinol-vendejo": Registriĝi ĉe Vixinol-vendejo,
           "--signup": Registriĝi,
           "--signup success": Registrado sukcesa!,
           "--signup for free": Registriĝi senpage,
           "--subskribo sukcesa IA": Konekto sukcesa",
           "--settings": "Agordoj",
           "--setting up the alrani app": Agordante la Alrani-aplikaĵon,
           "--agordi la izocash-aplikaĵon": Agordante la izocash-aplikaĵon,
           "--setting up the vixinol app": Agordante la Vixinol-aplikaĵon,
           "--setting up the veil Brillant app": Agordante la aplikaĵon Veil Brillant,
           "--storage of images, videos": Stokado de bildoj, videoj kaj pluraj aliaj elementoj,
           "--rapideco de ricevo": Rapido de ricevo de datumoj de la Datumarcentro,
           "--speed": Rapido,
           "--terminate": Finigi, //t
           "--la vpn permesas al vi aliri": La VPN permesas al vi aliri retejon aŭ aplikaĵon, kiun via provizanto de retservo havas en nigra listo,
           "--the most tree was above": La plej granda arbo estis antaŭ ĉio simpla eta semo,
           "--touch the screen": Tuŝu la ekranon por daŭrigi,
           "--try again": Provu denove!,
           "--username": Uzantnomo, //u

           "--virtual number": Virtuala nombro, //v
           "--virtual phone settings": agordoj de virtuala telefono,
           "--virtual Phone language is applyed": La lingvo Virtual Phone aplikas defaŭlte ĉe la aplika nivelo,
           "--virtual phone": Virtuala telefono,
           "--validate": validigi,
           "--bonvenon al la portalo de klientoj izocash": Bonvenon al la portalo de klientoj izocash, //w
           "--write a super code": Enigu Superkodon,
           "--welcome to": Bonvenon al,
           "--where people's attention goes": Kien la atento de homoj iras mono iras,
           "--winners persevere": La venkintoj persistas,
           "--would you like to elsal out of your Alrani-konto": Ĉu vi volas elsaluti el via Alrani-konto?,
           "--yes": Jes, //y

           // lando
           "--congo": Kongo Brazavilo,
           "--cameroon": Kamerunio,
           "--drc": DRC,
           "--ivoryCoast": Ebura Bordo,

           // langue
        "--afrikaans": afrikansa, //a
        "--albanian": albana,
        "--amharic": Amhara,
        "--arabic": araba,
        "--armenian": armena,
        "--assamese": Asama,
        "--ajmara": Aymara,
        "--azerbaijani": azera,
        "--bambara": Bambara, //b
        "--eŭska": eŭska,
        "--belarusian": Belarusian,
        "--bengala": bengala,
        "--bhojpuri": Bhojpuri,
        "--bosnian": bosnia,
        "--bulgara": bulgara,
        "--catalan": kataluna, //c
        "--cebuano": Cebuano,
        "--chichewa": Ĉiĉeva,
        "--chineseSimplified": Ĉina (Simpligita),
        "--chineseTraditional": Ĉina (Tradicia),
        "--corsican": korsika,
        "--croatian": kroata,
        "--ĉeĥa": ĉeĥa,
        "--danish": Dana, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--nederlanda": nederlanda,
        "--english": angla, //e
        "--esperanto": Esperanto,
        "--estonian": estona,
        "--ewe": Ŝafino,
        "--filipino": Filipino, //f
        "--finna": finna,
        "--franca": franca,
        "--frisian": frisa,
        "--galician": galego, //g
        "--georgian": kartvela,
        "--german": germana,
        "--greek": greka,
        "--guarani": gvarania,
        "--gujarati": gujaratio,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": havaja,
        "--hebrew": hebrea,
        "--hindi": hinda,
        "--hmong": Hmong,
        "--hungarian": Hungara,
        "--icelandic": islande, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonezia": indonezia,
        "--irish": irlandano,
        "--italiano": itala,
        "--japana": Japana, //j
        "--javanese": la java,
        "--kannada": Kannada, //k
        "--kazakh": kazaĥa,
        "--khmer": ĥmeroj,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": konkana,
        "--korea": korea,
        "--krio": Krio,
        "--kurdishKurmanji": kurda (Kurmanji),
        "--kurdishSorani": kurda (Sorani),
        "--kyrgyz": kirgizoj,
        "--lao": Lao, //l
        "--latin": latina,
        "--latvian": latva,
        "--lingala": Lingala,
        "--lithuanian": litova,
        "--luganda": Lugando,
        "--luxembourgish": luksemburga,
        "--macedonian": makedona, //m
        "--maithili": Maithili,
        "--malgasy": madagaskara,
        "--malaja": malaja,
        "--malayalam": la malajala,
        "--maltese": malta,
        "--maori": maora,
        "--marathi": Maratio,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongola,
        "--myanmarBurmese": Mjanmao (birma),
        "--nepali": nepala, //n
        "--norvegiano": norvega,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Paŝto, //p
        "--persa": la persa,
        "--polish": pola,
        "--portugala": portugala,
        "--punjabi": panĝaba,
        "--quechua": keĉua, //q
        "--romanian": rumana, //r
        "--rusa": rusa,
        "--samoan": samoano, //s
        "--sanskrit": sanskrito,
        "--scotsGaelic": la skotgaela,
        "--sepedi": Sepedi,
        "--serbian": serba,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": sinhala,
        "--slovak": la slovaka,
        "--slovena": slovena,
        "--somali": somalo,
        "--hispana": hispana,
        "--sundanese": sundano,
        "--svahili": svahila,
        "--sveda": sveda,
        "--tajik": taĝiko, //t
        "--tamil": tamila,
        "--tatar": tataro,
        "--telugu": la telugua,
        "--thai": tajlanda,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turka,
        "--turkmen": turkmeno,
        "--twi": Twi,
        "--ukrainian": ukraina, //u
        "--urdu": Urdu,
        "--uyghur": ujgura,
        "--uzbek": uzbeko,
        "--vietnamese": vjetnama, //v
        "--welsh": kimra lingvo, //w
        "--xhosa": la kosa, //x
        "--jidish": jida, //y
        "--yoruba": Jorubo,
        "--zulu": la zulua, //z
        },
      },

      // estonian
      // estonian
      estonian: {
        translations: {
          "--ilmunud viga": ilmnes viga!, //a
           "--aadress": aadressid,
           "--nõuanne": nõuanne,
           "--klõpsates nuppu Jätka": Jätka klõpsamisel katkestatakse ühendus oma Veil Brillanti kontoga, //b
           "--klõpsates nupul Katkesta ühendus katkestatakse teie ühendus": Kui klõpsate nupul Katkesta ühendus, katkestatakse ühendus teie izocashi kontoga,
           "--kontrollige oma virtuaalset numbrit või proovige hiljem uuesti": kontrollige oma virtuaalset numbrit või proovige hiljem uuesti //c
           "--check your virtual number": kontrollige oma virtuaalset numbrit,
           "--continue": jätka,
           "--connection": ühendus,
           "--teha koostööd, elage harmoonias": tehke koostööd, elage teistega harmoonias,
           "--choose language": virtuaalse telefoni keel,
           "--ei takista konkurentsi": Ära takista konkurentsi, anna igaühele võimalus, //d
           "--disconnection": ühenduse katkestamine,
           "--kõigile virtuaaltelefoni kasutajatele": kõikidel virtuaaltelefoni kasutajatel on soovitatav kasutada VPN-i, //f
           "--mine sisselogimislehele": minge sisselogimislehele, //g
           "--ajalooline": ajalooline, //h
           "--mul on konto": mul on juba konto, //i
           "--mul ei ole kontot": mul pole kontot,
           "--see on teie maja": see on teie maja,
           "--pilt / video +": pilt / video +,
           "--identiteedi kinnitamine": identiteedi kinnitamine,
           "--izocashi kliendiportaal": izocashi kliendiportaal,
           "--identiteedi värskendus igal aastal": identiteedi värskendus igal aastal,
           "--izocash osta": izocash osta => izocash rahvusvaheline,
           "--log in": Logi sisse!, //l
           "--login": logige sisse,
           "--login to veil brilliant": looge ühendus teenusega Veil Brillant,
           "--login to vixinol Store": ühendage Vixinol Store'iga,
           "--sisene tasuta oma veil Brillanti kontole": selle funktsiooni kasutamiseks logige tasuta sisse oma Veil Brillanti kontole,
           "--sisselogimine õnnestus": sisselogimine õnnestus!,
           "--login now": Logi kohe sisse!,
           "--logout success": väljalogimine õnnestus!,
           "--log out": väljalogimine,
           "--logout": logi välja,
           "--number": arv, //n
           "--nimi": nimi,
           "--now logi in": nüüd, logi sisse!,
           "-- konkurentsi lämmatamise keeld pole":
           "-- pole armukadedust, pole vihkamist": pole armukadedust, pole vihkamist, pole lahkarvamusi,
           "--ei ei,
           "--ametlikud aadressid virtuaalsele telefonile juurdepääsuks": ametlikud aadressid virtuaalsele telefonile juurdepääsuks, //o
           "--parool": parool, //lk
           "--punktide väljavõtmine izocash": punktide väljavõtmine izocash,
           "--punktide väljavõtmine": punktide väljavõtmine,
           "-- eelistatavalt kasutage vpn-i": eelistatavalt kasutage VPN-i, mis ei kuulu teie Interneti-teenuse pakkujale,
           "--püsivus tasub alati ära": püsivus tasub lõpuks alati ära,
           "--rule": reeglid, //r
           "--recommendation": soovitused,
           "--registration": registreerimine,
           "--signup to veil brilliant": registreeruge saidil Veil Brillant, //s
           "--registreerumine vixinoli poodi": registreeruge Vixinoli poes,
           "--signup": registreeru,
           "--registreerimine õnnestus": registreerimine õnnestus!,
           "--registreeru tasuta": registreeruge tasuta,
           "--registreerimine õnnestus IA": ühendus õnnestus",
           "--settings": "Seaded",
           "--alrani rakenduse seadistamine": Alrani rakenduse konfigureerimine,
           "--izocashi rakenduse seadistamine": izocashi rakenduse konfigureerimine,
           "--vixinoli rakenduse seadistamine": rakenduse Vixinol konfigureerimine,
           "--rakenduse Veil Brillant seadistamine": rakenduse Veil Brillant konfigureerimine,
           "--piltide, videote salvestamine": piltide, videote ja mitmete muude elementide salvestamine,
           "--vastuvõtukiirus": andmekeskusest andmete vastuvõtmise kiirus,
           "--speed": kiirus,
           "--lõpetada": lõpetada, //t
           "--vpn võimaldab teil juurde pääseda": VPN võimaldab teil pääseda juurde saidile või rakendusele, mille teie Interneti-teenuse pakkuja on lisanud musta nimekirja,
           "-- suurim puu oli ülal": suurim puu oli ennekõike lihtne seeme,
           "--touch the screen": puudutage jätkamiseks ekraani,
           "--try again": proovi uuesti!,
           "--kasutajanimi": kasutajanimi, //u

           "--virtuaalne number": virtuaalne number, //v
           "--virtual phone settings": virtuaalse telefoni seaded,
           "--virtuaalne telefoni keel on rakendatud": virtuaalse telefoni keelt rakendatakse vaikimisi rakenduse tasemel,
           "--virtuaalne telefon": virtuaalne telefon,
           "--validate": kinnitage,
           "--tere tulemast izocashi kliendiportaali": Tere tulemast izocashi kliendiportaali, //w
           "--kirjuta superkood": sisestage superkood,
           "--welcome to": Tere tulemast,
           "--kuhu läheb inimeste tähelepanu": kuhu läheb inimeste tähelepanu, läheb raha,
           "-- võitjad püsivad": võitjad püsivad,
           "--kas soovite oma Alrani kontolt välja logida": Kas soovite oma Alrani kontolt välja logida?,
           "--yes": Jah, //y

           // riik
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": Kongo Demokraatlik Vabariik,
           "--ivoryCoast": Elevandiluurannik,

           // keel
        "--afrikaans": afrikaans, //a
        "--albanian": albaania,
        "--amharic": amhari,
        "--araabia": araabia,
        "--armenian": armeenia,
        "--assamese": assami,
        "--aymara": aimara,
        "--aserbaidžaani": aserbaidžaani,
        "--bambara": bambara, //b
        "--baski": baski,
        "--valgevene": valgevene,
        "--bengali": bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": bosnia,
        "--bulgaaria": bulgaaria,
        "--katalaani": katalaani, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": hiina (lihtsustatud),
        "--chineseTraditional": hiina (traditsiooniline),
        "--corsican": korsika,
        "--horvaatia": horvaadi,
        "--tšehhi": tšehhi,
        "--danish": taani, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": hollandi,
        "--english": inglise keel, //e
        "--esperanto": esperanto,
        "--eesti": eesti keel,
        "--ute": utt,
        "--filipino": filipino, //f
        "--soome": soome,
        "--french": prantsuse keel,
        "--friisi": friisi keel,
        "--galician": galeegi, //g
        "--gruusia": gruusia,
        "--saksa": saksa,
        "--kreeka": kreeka,
        "--guarani": guarani,
        "--gujarati": gudžarati,
        "--haiti kreool": Haiti kreool, //h
        "--hausa": hausa,
        "--hawaiian": havai,
        "--heebrea": heebrea,
        "--hindi": hindi,
        "--hmong": hmong,
        "--ungari": ungari,
        "--islandi": islandi, //i
        "--igbo": igbo,
        "--ilocano": Ilocano,
        "--indonesian": indoneesia,
        "--irish": iiri,
        "--itaalia": itaalia,
        "--jaapani": jaapani, //j
        "--javanese": jaava,
        "--kannada": kannada, //k
        "--kasahh": kasahhi,
        "--khmer": khmeerid,
        "--kinyarwanda": kinyarwanda,
        "--konkani": konkani,
        "--korea": korea,
        "--krio": Krio,
        "--kurdishKurmanji": kurdi (kurmanji),
        "--kurdishSorani": kurdi (sorani),
        "--kirgiis": kirgiis,
        "--lao": Lao, //l
        "--ladina": ladina,
        "--läti": läti,
        "--lingala": lingala,
        "--leedu": leedu,
        "--luganda": Luganda,
        "--luxembourgish": luxembourgish,
        "--makedoonia": makedoonia, //m
        "--maithili": Maithili,
        "--malagassi": malagassi,
        "--malay": malai,
        "--malajalam": malajalam,
        "--maltese": malta keel,
        "--maoori": maoori,
        "--marathi": marati,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongoolia,
        "--myanmarBurmese": Myanmar (birma),
        "--nepali": nepali, //n
        "--norra": norra,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pašto": puštu, //lk
        "--pärsia": pärsia,
        "--polish": poola,
        "--portugali": portugali keel,
        "--panjabi": pandžabi,
        "--quechua": ketšua, //q
        "--rumeenia": rumeenia, //r
        "--vene": vene,
        "--samoa": samoa, //s
        "--sanskrit": sanskrit,
        "--scotsGaelic": šoti gaeli,
        "--sepedi": Sepedi,
        "--serbian": serbia,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": sindhi,
        "--sinhala": singali keel,
        "--slovak": slovaki,
        "--sloveenia": sloveeni,
        "--somali": somaali,
        "--spanish": hispaania,
        "--sundanese": sundaani,
        "--swahili": suahiili,
        "--rootsi": rootsi,
        "--tadžikik": tadžiki, //t
        "--tamil": tamili,
        "--tatar": tatar,
        "--telugu": telugu,
        "--thai": tai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": türgi,
        "--türkmeen": türkmeen,
        "--twi": Twi,
        "--ukraina": ukraina, //u
        "--urdu": urdu,
        "--uyguur": uiguurid,
        "--uzbek": usbeki,
        "--vietnami": vietnami, //v
        "--welsh": kõmri, //w
        "--xhosa": Xhosa, //x
        "--jidiš": jidiš, //y
        "--joruba": joruba,
        "--zulu": sulu, //z
        },
      },

      // ewe
      // ewe
      ewe: {
        translations: {
          "--vodada aɖe dzɔ": Vodada aɖe dzɔ!, //a
          "--adrɛs": Adrɛswo, .
          "--aɖaŋuɖoɖo": Aɖaŋuɖoɖo, .
          "--to asiƒoƒo ɖe continue dzi": Ne èzi continue dzi la, woaɖe kadodo ɖa le wò Veil Brillant akɔnta ŋu, //b
          "--ne èzi disconnect dzi la, woaɖe kadodo ɖa": Ne èzi Disconnect dzi la, woaɖe kadodo ɖa le wò zocash akɔnta ŋu,
          "--kpɔ wò virtual xexlẽdzesi alo gadze agbagba emegbe": Kpɔ wò virtual xexlẽdzesi alo gadze agbagba emegbe, //c
          "--kpɔ wò virtual xexlẽdzesi": Kpɔ wò virtual xexlẽdzesi, .
          "--yi edzi": Yi edzi, .
          "--kadodo": Kadodo, .
          "--wɔ nu aduadu, nɔ agbe le ɖekawɔwɔ me": Wɔ nu aduadu, nɔ agbe le ɖekawɔwɔ me kple ame bubuwo,
          "--tia gbegbɔgblɔ": Virtual Phone Language, .
          "--mègaxe mɔ ɖe hoʋiʋli nu o": Mègaxe mɔ ɖe hoʋiʋli nu o, na mɔnukpɔkpɔ amesiame, //d
          "--disconnection": Kadodo ɖeɖeɖa, .
          "--na virtual phone zãlawo katã": Le Virtual Phone zãlawo katã gome la, wokafui be woazã VPN, //f
          "--yi axa si dzi woge ɖo": Yi axa si dzi woge ɖo, //g
          "--ŋutinya": Ŋutinya, //h
          "--i have account": Akɔnta le asinye xoxo, //i
          "--nyemekpɔ akɔnta o": Nyemekpɔ akɔnta o, .
          "--wò aƒee": wò aƒee, .
          "--nɔnɔmetata / video +": Nɔnɔmetata / Video +,
          "--amenyenye ƒe kpeɖodzinana": Dzesidede ame ƒe kpeɖodzi, .
          "--izocash ƒe asisiwo ƒe nyatakakadzraɖoƒe": izocash ƒe asisiwo ƒe nyatakakadzraɖoƒe,
          "--akɔntabubu ƒe yeye ƒe sia ƒe": Dzesidede ame ƒe yeye ƒe sia ƒe,
          "--izocash ƒle na": izocash Ƒle => izocash dukɔwo dome,
          "--ge ɖe eme": Ge ɖe eme!, //l
          "--ge ɖe eme": Ge ɖe eme, .
          "--ge ɖe veil brilliant": Do ka kple Veil Brillant, .
          "--ge ɖe vixinol fiase me": Do ka kple Vixinol Fiase,
          "--ge ɖe wò veil Brillant akɔnta me femaxee": Ge ɖe wò Veil Brillant akɔnta me femaxee be nàkpɔ nɔnɔme sia,
          "--login dzidzedzekpɔkpɔ": Geɖe dzidzedzetɔe!,
          "--ge ɖe eme fifia": Ge ɖe eme fifia!,
          "--logout dzidzedzekpɔkpɔ": Logout dzidzedzekpɔkpɔ!,
          "--do go": Do go, .
          "--logout": Do go, .
          "--xexlẽdzesi": Xexlẽdzesi, //n
          "--ŋkɔ": Ŋkɔ, .
          "--fifia ge ɖe eme": Azɔ, Ge ɖe eme!,
          "--womaxe mɔ ɖe hoʋiʋli nutsitsi nu o":
          "--ŋuʋaʋã aɖeke meli o, fuléle aɖeke meli o": Ŋuʋaʋã aɖeke meli o, fuléle aɖeke meli o, mama aɖeke meli o,
          "--ao": Ao, .
          "--official addresses to access your virtual phone": Adrɛs siwo dziɖuɖua da asi ɖo be nàge ɖe wò telefon ŋutɔŋutɔ me, //o
          "--nyagbe": Nyagbe, //p
          "--points ƒe gaɖeɖe izocash": Points ƒe gaɖeɖe izocash, .
          "--points withdrawals": Points ƒe ɖeɖeɖa, .
          "--anyo wu, zã vpn": Anyo wu, zã VPN si menye wò internet dɔwɔƒe tɔ o,
          "--kutrikuku ɖea vi ɣesiaɣi": Kutrikuku ɖea vi ɣesiaɣi le nuwuwu,
          "--se": Sewo, //r
          "--kafukafu": Aɖaŋuɖoɖowo, .
          "--ŋkɔ ŋɔŋlɔ": Ŋkɔ ŋɔŋlɔ, .
          "--signup to veil brilliant": Ŋlɔ ŋkɔ ɖe Veil Brillant, //s
          "--de asi vixinol fiase me": Ŋlɔ ŋkɔ ɖe Vixinol Fiase me,
          "--signup": Ŋlɔ ŋkɔ, .
          "--signup success": Ŋkɔ ŋɔŋlɔ kpɔ dzidzedze!,
          "--de asi agbalẽ te femaxee": Ŋlɔ ŋkɔ femaxee,
          “--signup dzidzedzekpɔkpɔ IA”: Kadodo dzidzedzetɔe”,
          "--ɖoɖowo": "Nɔnɔmewo",
          "--alrani dɔwɔɖoɖoa ɖoɖo": Alrani dɔwɔɖoɖoa ƒe ɖoɖowɔwɔ, .
          "--izocash dɔwɔɖoɖoa ɖoɖo": Izocash dɔwɔɖoɖoa ɖoɖo, .
          "--vixinol dɔwɔɖoɖoa ɖoɖo": Vixinol dɔwɔɖoɖoa ƒe ɖoɖowɔwɔ, .
          "--ɖoɖo ɖe veil Brillant dɔwɔɖoɖoa ŋu": Veil Brillant dɔwɔɖoɖoa ƒe ɖoɖowɔwɔ,
          "--nɔnɔmetatawo, videowo dzraɖoƒe": Nɔnɔmetatawo, videowo kple nu bubu geɖewo dzraɖoƒe, .
          "--speed of reception": Nyatakakawo xɔxɔ kabakaba tso Datacenter, .
          "--duƒuƒu": Duƒuƒu, .
          "--wu enu": Nuwuwu, //t
          "--vpn la ɖea mɔ na wò be nàge ɖe eme": VPN la ɖea mɔ na wò be nàge ɖe nyatakakadzraɖoƒe alo dɔwɔnu aɖe si wò internet dɔwɔƒea ŋlɔ ŋkɔ yibɔ me,
          "--ati gãtɔ kekeake nɔ etame": Ati gãtɔ kekeake nye nuku sue bɔbɔe aɖe ƒo wo katã ta, .
          "--ka asi screen la ŋu": Ka asi screen la ŋu be nàyi edzi,
          "--gate kpɔ ake": Gadze agbagba ake!,
          "--zãla ƒe ŋkɔ": Zãla ƒe ŋkɔ, //u

          "--xexlẽdzesi ŋutɔŋutɔ": Xexlẽdzesi ŋutɔŋutɔ, //v
           "--telefon ŋutɔŋutɔ ƒe ɖoɖowo": Telefon ŋutɔŋutɔ ƒe ɖoɖowo, .
           "--virtual Phone language is applied": Wozã Virtual Phone gbegbɔgblɔ le dɔwɔwɔ ƒe ɖoɖo nu le gɔmedzedzea me,
           "--telefon ŋutɔŋutɔ": Telefon ŋutɔŋutɔ, .
           "--da asi ɖe edzi": Da asi ɖe edzi, .
           "--míexɔ wò nyuie ɖe izocash ƒe asisiwo ƒe nyatakakadzraɖoƒe": Míexɔ wò nyuie ɖe izocash ƒe asisiwo ƒe nyatakakadzraɖoƒe, //w
           "--ŋlɔ super code": Ŋlɔ Super code, .
           "--xɔ mi nyuie ɖe": Míexɔ mi nyuie ɖe,
           "--afisi amewo ƒe susu yia": Afisi amewo ƒe susu yia ga yia, .
           "--dziɖulawo doa dzi": Aʋadziɖulawo doa dzi, .
           "--àdi be yeado le yeƒe Alrani akɔnta mea": Èdi be yeado le yeƒe Alrani akɔnta mea?,
           "--ẽ": Ɛ̃, //y

           // dukᴐ
           "--kongo": Kongo Brazzaville, ƒe 1999 me.
           "--cameroon": Cameroon, ƒe 1999 me.
           "--drc": DRC, 1999 me.
           "--ivoryCoast": Akɔbliƒuta,

           // gbegbɔgblɔ
        "--afrikaans": Afrikagbe, //a
        "--albaniagbe": Albaniagbe, .
        "--amharic": Amharicgbe, .
        "--arabgbe": Arabgbe, .
        "--armeniagbe": Armeniagbe, .
        "--assamese": Assamegbe, .
        "--aymara": Aymaragbe, .
        "--azerbaijangbe": Azerbaijangbe, .
        "--bambara": Bambaragbe, //b
        "--basque": Basquegbe, .
        "--belarusian": Belarusgbe, .
        "--bengali": Bengaligbe, .
        "--bhojpuri": Gbegbɔgblɔ, .
        "--bosniagbe": Bosniagbe, .
        "--bulgariagbe": Bulgariagbe, .
        "--catalan": Catalangbe, //c
        "--cebuano": Cebuano, .
        "--chichewa": Chichewa, .
        "--chineseSimplified": Chinagbe (Wowɔe bɔbɔe), .
        "--chineseDekɔnu": Chinagbe (Dekɔnu), .
        "--korsika": Korsika, .
        "--croatiagbe": Croatiagbe, .
        "--czech": Czechgbe, .
        "--danish": Denmarkgbe, //d
        "--dhivehi": Amegbetɔ, .
        "--dogri": Dogri, .
        "--dutch": Hollandgbe, .
        "--eʋegbe": Eʋegbe, //e
        "--esperanto": Esperantogbe, .
        "--estoniagbe": Estoniagbe, .
        "--nyitsu": Alẽvi, .
        "--filipino": Filipinogbe, //f
        "--finnish": Finlandgbe, .
        "--fransegbe": Fransegbe, .
        "--frisian": Frisiagbe, .
        "--galician": Galiciangbe, //g
        "--georgian": Georgiagbe, .
        "--germangbe": Germanygbe, .
        "--helagbe": Helagbe, .
        "--guarani": Guarani, .
        "--gujarati": Gujaratigbe, .
        "--haitianCreole": Haititɔwo ƒe Creolegbe, //h
        "--hausa": Hausa, .
        "--hawaiigbe": Hawaiigbe, .
        "--hebrigbe": Hebrigbe, .
        "--hindi": Hindigbe, .
        "--hmong": Hmonggbe, .
        "--hungary": Hungarygbe, .
        "--icelandgbe": Icelandgbe, //i
        "--igbo": Igbogbe, .
        "--ilocano": Ilocano, .
        "--indonesiagbe": Indonesiagbe, .
        "--irish": Irelandgbe, .
        "--italygbe": Italygbe, .
        "--japangbe": Japangbe, //j
        "--javanese": Javagbe, .
        "--kannada": Kannadagbe, //k
        "--kazakhstan": Kazakhstan, .
        "--khmer": Khmer, .
        "--kinyarwanda": Kinyarwanda, .
        "--konkani": Konkangbe, .
        "--korean": Koreagbe, .
        "--krio": Krio, .
        "--kurdishKurmanji": Kurdgbe (Kurmanji), .
        "--kurdishSorani": Kurdgbe (Soranigbe), .
        "--kyrgyzgbe": Kyrgyzgbe, .
        "--lao": Laogbe, //l
        "--latin": Latingbe, .
        "--latviagbe": Latviagbe, .
        "--lingala": Lingalagbe, .
        "--lithuaniagbe": Lithuaniagbe, .
        "--luganda": Luganda, .
        "--luxembourgish": Luxembourgishgbe, .
        "--makedoniagbe": Makedoniagbe, //m
        "--maithili": Maithiligbe, .
        "--malagasy": Malagasygbe, .
        "--malay": Malaygbe, .
        "--malayalam": Malayalam, .
        "--maltagbe": Maltagbe, .
        "--maori": Maoritɔ, .
        "--marathi": Marathigbe, .
        "--meiteilonManipuri": Meiteilon (Amegbetɔ), .
        "--mizo": Mizo, .
        "--mongoliagbe": Mongoliagbe, .
        "--myanmarBurmagbe": Myanmar (Burmagbe), .
        "--nepali": Nepaligbe, //n
        "--norwaygbe": Norwaygbe, .
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo, .
        "--pashto": Pashtogbe, //axa 10
        "--persiagbe": Persiagbe, .
        "--polish": Polandgbe, .
        "--portuguese": Portugalgbe, .
        "--punjabi": Punjabi, .
        "--quechua": Quechuagbe, //q
        "--romaniagbe": Romaniagbe, //r
        "--russiagbe": Russiagbe, .
        "--samoan": Samoagbe, //s
        "--sanskrit": Sanskritgbe, .
        "--scotsGaelic": Scotlandtɔwo ƒe Gaelicgbe, .
        "--sepedi": Gbeƒãɖeɖe, .
        "--serbiagbe": Serbiagbe, .
        "--sesotho": Gbegbe me tɔ, .
        "--shona": Shona, .
        "--sindhi": Sindhigbe, .
        "--sinhala": Sinhalagbe, .
        "--slovak": Slovakgbe, .
        "--sloveniagbe": Sloveniagbe, .
        "--somali": Somaliagbe, .
        "--spaniagbe": Spaingbe, .
        "--sundanegbe": Sundangbe, .
        "--swahili": Swahiligbe, .
        "--swedish": Swedengbe, .
        "--tajik": Tajikgbe, //t
        "--tamil": Tamilgbe, .
        "--tatar": Tatar, .
        "--telugu": Telugugbe, .
        "--thaigbe": Thailandgbe, .
        "--tigrinya": Tigrinya, .
        "--tsonga": Tsonga, .
        "--turkish": Turkeygbe, .
        "--turkmen": Turkmen, .
        "--twi": Twi, 1999.
        "--ukrainegbe": Ukrainegbe, //u
        "--urdu": Urdugbe, .
        "--uyghur": Uyghur, .
        "--uzbekgbe": Uzbekgbe, .
        "--vietnagbe": Vietnamgbe, //v
        "--welsh": Welshgbe, //w
        "--xhosa": Xhosagbe, //x
        "--yiddish": Yiddishgbe, //y
        "--yoruba": Yorubagbe, .
        "--zulu": Zulugbe, //z
        },
      },
   
      // filipino
      // filipino
      filipino: {
        translations: {
          "--an error has occurred": May naganap na error!, //a
           "--address": Mga address,
           "--advice": Payo,
           "--sa pamamagitan ng pag-click sa magpatuloy": Sa pamamagitan ng pag-click sa magpatuloy, madidiskonekta ka sa iyong Veil Brillant account, //b
           "--sa pamamagitan ng pag-click sa idiskonekta ikaw ay madidiskonekta": Sa pamamagitan ng pag-click sa Idiskonekta ikaw ay madidiskonekta sa iyong izocash account,
           "--suriin ang iyong virtual na numero o subukang muli sa ibang pagkakataon": Suriin ang iyong virtual na numero o subukang muli sa ibang pagkakataon, //c
           "--check ang iyong virtual na numero": Suriin ang iyong virtual na numero,
           "--continue": Magpatuloy,
           "--connection": Koneksyon,
           "--collaborate, live in harmony": Makipagtulungan, mamuhay nang naaayon sa iba,
           "--choose language": Virtual Phone Language,
           "--don't prevent competition": Huwag pigilan ang kompetisyon, bigyan ang lahat ng pagkakataon, //d
           "--disconnection": Pagdiskonekta,
           "--for all virtual phone users": Para sa lahat ng user ng Virtual Phone, inirerekomendang gumamit ng VPN, //f
           "--go to login page": Pumunta sa login page, //g
           "--historical": Makasaysayan, //h
           "--i have account": Mayroon na akong account, //i
           "--wala akong account": Wala akong account,
           "--ito ay iyong bahay": ito ay iyong bahay,
           "--image / video +": Imahe / Video +,
           "--identity verification": Pag-verify ng pagkakakilanlan,
           "--izocash customer portal": izocash Customer Portal,
           "--update ng pagkakakilanlan bawat taon": Pag-update ng pagkakakilanlan bawat taon,
           "--izocash buy to": izocash Buy => izocash international,
           "--log in": Mag-log in!, //l
           "--login": Mag-log in,
           "--login to veil brilliant": Kumonekta sa Veil Brillant,
           "--login to vixinol store": Kumonekta sa Vixinol Store,
           "--login nang libre sa iyong veil Brillant account": Mag-log in nang libre sa iyong Veil Brillant account para ma-access ang feature na ito,
           "--login success": Matagumpay ang pag-log in!,
           "--login now": Mag-log in na!,
           "--logout success": Matagumpay ang pag-logout!,
           "--log out": Logout,
           "--logout": Mag-log out,
           "--number": Numero, //n
           "--name": Pangalan,
           "--now log in": Ngayon, Log in!,
           "--walang pagbabawal sa pagpigil sa kumpetisyon":
           "--no jealousy, no hatred": Walang selos, walang poot, walang hatian,
           "--hindi hindi,
           "--official addresses to access your virtual phone": Opisyal na address para ma-access ang virtual phone mo, //o
           "--password": Password, //p
           "--points withdrawals izocash": Points Withdrawals izocash,
           "--points withdrawals": Points Withdrawals,
           "--mas mabuti, gumamit ng vpn": Mas mabuti, gumamit ng VPN na hindi kabilang sa iyong internet service provider,
           "--persistence always pays": Ang pagtitiyaga ay laging nagbubunga sa huli,
           "--rule": Mga Panuntunan, //r
           "--recommendation": Mga Rekomendasyon,
           "--registration": Pagpaparehistro,
           "--signup to veil brilliant": Magrehistro sa Veil Brillant, //s
           "--signup sa vixinol store": Magrehistro sa Vixinol Store,
           "--signup": Magrehistro,
           "--signup success": Matagumpay ang pagpaparehistro!,
           "--signup for free": Magrehistro nang libre,
           "--signup success IA": Matagumpay ang koneksyon",
           "--settings": "Mga Setting",
           "--set up the alrani app": Pag-configure ng Alrani application,
           "--set up the izocash app": Pag-configure ng izocash application,
           "--set up the vixinol app": Pag-configure ng Vixinol application,
           "--set up the veil Brillant app": Pag-configure ng Veil Brillant application,
           "--storage of images, videos": Storage ng mga larawan, video at ilang iba pang elemento,
           "--bilis ng pagtanggap": Bilis ng pagtanggap ng data mula sa Datacenter,
           "--speed": Bilis,
           "--terminate": Wakasan, //t
           "--pinahihintulutan ka ng vpn na ma-access": Binibigyang-daan ka ng VPN na ma-access ang isang site o isang application na na-blacklist ng iyong internet service provider,
           "--ang pinakamalaking puno ay nasa itaas": Ang pinakamalaking puno ay higit sa lahat isang simpleng maliit na buto,
           "--touch the screen": Pindutin ang screen upang magpatuloy,
           "--try again": Subukan ulit!,
           "--username": Username, //u

           "--virtual number": Virtual na numero, //v
           "--virtual phone settings": Mga setting ng virtual na telepono,
           "--virtual Phone language is applied": Ang Virtual Phone language ay inilapat sa antas ng aplikasyon bilang default,
           "--virtual phone": Virtual na telepono,
           "--validate": Patunayan,
           "--welcome sa izocash customer portal": Welcome sa izocash Customer Portal, //w
           "--write a super code": Maglagay ng Super code,
           "--welcome to": Maligayang pagdating sa,
           "--kung saan napupunta ang atensyon ng mga tao": Kung saan napupunta ang atensyon ng mga tao napupunta ang pera,
           "--winners persevere": Ang mga nanalo ay matiyaga,
           "--gusto mo bang mag-log out sa iyong Alrani account": Gusto mo bang mag-log out sa iyong Alrani account?,
           "--oo": Oo, //y

           // bansa
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // wika
        "--afrikaans": Afrikaans, //a
        "--albanian": Albanian,
        "--amharic": Amharic,
        "--arabic": Arabic,
        "--armenian": Armenian,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusian,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnian,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Chinese (Simplified),
        "--chineseTraditional": Chinese (Tradisyonal),
        "--corsican": Corsican,
        "--croatian": Croatian,
        "--czech": Czech,
        "--danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Dutch,
        "--english": Ingles, //e
        "--esperanto": Esperanto,
        "--estonian": Estonian,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": Finnish,
        "--french": Pranses,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "--german": Aleman,
        "--greek": Griyego,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": Hebrew,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilokano,
        "--indonesian": Indonesian,
        "--irish": Irish,
        "--italian": Italyano,
        "--japanese": Japanese, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Korean,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": Latvian,
        "--lingala": Lingala,
        "--lithuanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Macedonian, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Persian,
        "--polish": Polish,
        "--portuguese": Portuges,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--russian": Ruso,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Espanyol,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Swedish,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turkish,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ukrainian, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // finnish
      // finnish
      finnish: {
        translations: {
          "--virhe on tapahtunut": On tapahtunut virhe!, //a
           "--osoite": osoitteet,
           "--advice": neuvoja,
           "--napsauttamalla jatka": Jatka napsauttamalla sinua katkaistaan ​​Veil Brillant -tiliisi, //b
           "--napsauttamalla katkaise yhteys katkaistaan": Klikkaamalla Katkaise yhteys katkaistaan ​​yhteyden izocash-tiliisi,
           "--tarkista virtuaalinumerosi tai yritä myöhemmin uudelleen": Tarkista virtuaalinumerosi tai yritä myöhemmin uudelleen, //c
           "--tarkista virtuaalinumerosi": Tarkista virtuaalinumerosi,
           "--continue": Jatka,
           "--connection": Yhteys,
           "--yhteistyöhön, elä harmoniassa": Tee yhteistyötä, elä sopusoinnussa muiden kanssa,
           "--choose language": Virtuaalipuhelimen kieli,
           "--älä estä kilpailua": Älä estä kilpailua, anna kaikille mahdollisuus, //d
           "--disconnection": Yhteyden katkeaminen,
           "-- kaikille virtuaalipuhelimen käyttäjille": Kaikille virtuaalipuhelimen käyttäjille suositellaan VPN:n käyttöä, //f
           "--siirry kirjautumissivulle": Siirry kirjautumissivulle, //g
           "--historiallinen": Historiallinen, //h
           "--i have account": Minulla on jo tili, //i
           "--i don't have account": Minulla ei ole tiliä,
           "--se on sinun talosi": se on sinun talosi,
           "--kuva / video +": Kuva / video +,
           "--identity verification": henkilöllisyyden vahvistus,
           "--izocash-asiakasportaali": izocash-asiakasportaali,
           "--identiteettipäivitys vuosittain": Identiteettipäivitys vuosittain,
           "--izocash ostaa": izocash Osta => izocash kansainvälinen,
           "--log in": Kirjaudu sisään!, //l
           "--login": Kirjaudu sisään,
           "--login to veil brilliant": Yhdistä Veil Brillantiin,
           "--login to Vixinol Store": Yhdistä Vixinol Storeen,
           "--kirjaudu sisään ilmaiseksi veil Brillant -tilillesi": Kirjaudu sisään ilmaiseksi Veil Brillant -tilillesi käyttääksesi tätä ominaisuutta,
           "--sisäänkirjautuminen onnistui": Kirjautuminen onnistui!,
           "--login now": Kirjaudu sisään nyt!,
           "--logout onnistui": Uloskirjautuminen onnistui!,
           "--log out": Kirjaudu ulos,
           "--logout": Kirjaudu ulos,
           "--numero": Numero, //n
           "--nimi": Nimi,
           "--nyt kirjaudu sisään": Nyt, kirjaudu sisään!,
           "--ei kilpailun tukahduttamiskieltoa":
           "--ei kateutta, ei vihaa": Ei kateutta, ei vihaa, ei hajaannusta,
           "--ei ei,
           "--viralliset osoitteet virtuaalipuhelimeen pääsyä varten": Viralliset osoitteet virtuaalipuhelimesi käyttöä varten, //o
           "--password": Salasana, //s
           "--pisteiden nostot izocash": Points Nostot izocash,
           "--pisteiden nostot": Pisteiden nostot,
           "-- mieluiten käytä vpn:tä": Käytä mieluiten VPN-verkkoa, joka ei kuulu Internet-palveluntarjoajallesi,
           "-- sinnikkyys kannattaa aina": sinnikkyys maksaa aina lopulta,
           "--rule": säännöt, //r
           "--recommendation": Suositukset,
           "--registration": rekisteröinti,
           "--signup to veil brilliant": Rekisteröidy Veil Brillantiin, //s
           "--signup to vixinol store": Rekisteröidy Vixinol Storeen,
           "--signup": Rekisteröidy,
           "--rekisteröinti onnistui": Rekisteröinti onnistui!,
           "--signup for free": Rekisteröidy ilmaiseksi,
           "--rekisteröinnin onnistuminen IA": Yhteys onnistui",
           "--settings": "Asetukset",
           "--alrani-sovelluksen määrittäminen": Alrani-sovelluksen määrittäminen,
           "--izocash-sovelluksen määrittäminen": Izocash-sovelluksen määrittäminen,
           "--vixinol-sovelluksen määrittäminen": Vixinol-sovelluksen määrittäminen,
           "--veil Brillant -sovelluksen määrittäminen": Veil Brillant -sovelluksen määrittäminen,
           "--kuvien, videoiden tallennus": Kuvien, videoiden ja useiden muiden elementtien tallennus,
           "--vastaanottonopeus": Datakeskuksen tietojen vastaanottonopeus,
           "--nopeus": nopeus,
           "--terminate": Lopeta, //t
           "--vpn mahdollistaa pääsyn": VPN:n avulla voit käyttää sivustoa tai sovellusta, jonka Internet-palveluntarjoajasi on lisännyt mustalle listalle,
           "--yläpuolella oli suurin puu": Suurin puu oli ennen kaikkea yksinkertainen pieni siemen,
           "--touch the screen": Kosketa näyttöä jatkaaksesi,
           "--yritä uudelleen": Yritä uudelleen!,
           "--username": Käyttäjätunnus, //u

           "--virtuaalinumero": Virtuaalinen numero, //v
           "--virtuaalipuhelimen asetukset": Virtuaalipuhelimen asetukset,
           "--virtuaalipuhelimen kieli on käytössä": Virtuaalipuhelimen kieltä käytetään oletusarvoisesti sovellustasolla,
           "--virtuaalinen puhelin": Virtuaalinen puhelin,
           "--validate": Vahvista,
           "--tervetuloa izocashin asiakasportaaliin": Tervetuloa izocashin asiakasportaaliin, //w
           "--kirjoita superkoodi": Syötä superkoodi,
           "--welcome to": Tervetuloa,
           "--minne ihmisten huomio menee": Minne ihmisten huomio menee, raha menee,
           "--voittajat kestävät": Voittajat kestävät,
           "--haluatko kirjautua ulos Alrani-tililtäsi": Haluatko kirjautua ulos Alrani-tililtäsi?,
           "--yes": Kyllä, //y

           // maa
           "--congo": Kongo Brazzaville,
           "--kamerun": Kamerun,
           "--drc": Kongon demokraattinen tasavalta,
           "--ivoryCoast": Norsunluurannikko,

           // kieli
        "--afrikaans": afrikaans, //a
        "--albanian": albania,
        "--amhara": amhara,
        "--arabia": arabia,
        "--armenian": armenia,
        "--assamese": assami,
        "--aymara": Aymara,
        "--azerbaidžani": Azerbaidžani,
        "--bambara": Bambara, //b
        "--baski": baski,
        "--valko-Venäjä": Valko-Venäjä,
        "--bengali": bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnialainen": bosnia,
        "--bulgaria": bulgaria,
        "--katalaani": katalaani, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kiina (yksinkertaistettu),
        "--chineseTraditional": kiina (perinteinen),
        "--corsican": korsikalainen,
        "--kroatia": kroatia,
        "--tsekki": tšekki,
        "--danish": tanska, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": hollanti,
        "--english": englanti, //e
        "--esperanto": esperanto,
        "--viro": viro,
        "--uuhi": uuhi,
        "--filipino": filippiiniläinen, //f
        "--suomi": suomi,
        "--french": ranska,
        "--friisi": friisi,
        "--galicia": Galicia, //g
        "--georgian": Georgia,
        "--saksa": saksa,
        "--kreikka": kreikka,
        "--guarani": guarani,
        "--gujarati": gujarati,
        "--haitianCreole": Haitin kreoli, //h
        "--hausa": Hausa,
        "--havaiji": havaijilainen,
        "--heprea": heprea,
        "--hindi": hindi,
        "--hmong": hmong,
        "--ungari": unkari,
        "--islantilainen": islanti, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": indonesia,
        "--irish": irlanti,
        "--italia": italia,
        "--japanilainen": japani, //j
        "--javanese": jaava,
        "--kannada": kannada, //k
        "--kazakh": kazakstani,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korea": korea,
        "--krio": Krio,
        "--kurdishKurmanji": kurdi (kurmanji),
        "--kurdishSorani": kurdi (sorani),
        "--kirgyz": Kirgisia,
        "--lao": Lao, //l
        "--latin": latina,
        "--latvia": latvia,
        "--lingala": Lingala,
        "--lietuva": liettua,
        "--luganda": Luganda,
        "--luxembourgish": Luxemburg,
        "--makedonia": makedonia, //m
        "--maithili": Maithili,
        "--malagassi": malagassi,
        "--malay": malaiji,
        "--malayalam": malajalam,
        "--malta": malta,
        "--maori": maori,
        "--marathi": marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongolia,
        "--myanmarBurmese": Myanmar (burma),
        "--nepali": Nepali, //n
        "--norja": norja,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": pashto, //s
        "--persian": persia,
        "--polish": puola,
        "--portuguese": portugali,
        "--panjabi": Punjabi,
        "--quechua": ketšua, //q
        "--romania": romania, //r
        "--venäläinen": venäjä,
        "--samoa": samoa, //s
        "--sanskrit": sanskrit,
        "--scotsgaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": serbia,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": sinhala,
        "--slovak": slovakki,
        "--slovenia": slovenia,
        "--somali": Somali,
        "--spanish": espanja,
        "--sundanese": sundalainen,
        "--swahili": swahili,
        "--ruotsi": ruotsi,
        "--tajik": tadžiki, //t
        "--tamil": tamili,
        "--tatar": tataari,
        "--telugu": telugu,
        "--thai": thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turkki,
        "--turkmen": turkmeeni,
        "--twi": Twi,
        "--ukrainalainen": ukraina, //u
        "--urdu": urdu,
        "--uyghur": uiguuri,
        "--uzbek": Uzbek,
        "--vietnam": vietnami, //v
        "--welsh": kymri, //w
        "--xhosa": Xhosa, //x
        "--jiddish": jiddish, //y
        "--joruba": joruba,
        "--zulu": Zulu, //z
        },
      },*/
      
      // **french
      // **french
      french: {
        translations: {
          "--an error has occurred": "Une erreur s'est produite !", //a
          "--address": "Adresses",
          "--advice": "Conseils",
          "--by clicking on continue": "En cliquant sur continuer vous serez déconnecter de votre compte Veil Brillant", //b
          "--by clicking on disconnect you will be disconnected": "En cliquant sur Se déconnecter vous serez déconnecter de votre compte izocash",
          "--check your virtual number or try again later": "Vérifier votre Numéro virtuel ou rééssayer plus tard", //c
          "--check your virtual number": "Vérifier votre Numéro virtuel",
          "--continue": "Continuer",
          "--connection": "Connexion",
          "--collaborate, live in harmony": "Collaborer, vivre en harmonie avec les autres",
          "--don't prevent competition": "Ne pas empêcher la concurrence, donner la chance à tout le monde", //d
          "--disconnection": "Déconnexion",
          "--for all virtual phone users": "Pour tout les utilisateurs du Téléphone virtuel, il est recommandé d'utiliser un VPN", //f
          "--go to login page": "Aller sur la page de connexion", //g
          "--historical": "Historique", //h
          "--i have account": "j'ai déjà un compte", //i
          "--i don't have account": "je n'ai pas de compte",
          "--it is your house": "c'est votre maison",
          "--if you have not registered": "Si vous n'êtes pas encore inscrit vous pouvez débuter votre inscription", //new
          "--image / video +": "Image / Vidéo +",
          "--identity verification": "Vérification d'identité",
          "--izocash customer portal": "Portail des Clients izocash",
          "--identity update every year": "Actualisation d'identité chaque année",
          "--izocash buy to": "izocash Buy => izocash international",
          "--log in": "Connectez-vous !", //l
          "--login": "Se connecter",
          "--login to veil brillant": "Se connecter sur Veil Brillant",
          "--login to vixinol store": "Se connecter sur Vixinol Store",
          "--login for free to your veil brillant account": "Connectez-vous gratuitement à votre compte Veil Brillant pour accéder à cette fonctionnalitée",
          "--login success": "Connexion réussie !",
          "--login now": "Connectez-vous maintenant !",
          "--logout success": "Déconnexion réussie !",
          "--log out": "Déconnexion",
          "--logout": "Se déconnecter",
          "--number": "Numéro", //n
          "--name": "Nom",
          "--now log in": "Maintenant, Connectez-vous !",
          "--no ban on stifling competition": "Pas interdit d'étouffer la concurrence",
          "--no jealousy, no hatred": "Pas de jalousie, pas de haine, pas de divisions",
          "--no": "Non",
          "--official addresses to access your virtual phone": "Adresses officielles pour accéder à votre Téléphone virtuel", //o
          "--password": "Mot de passe", //p
          "--points withdrawals izocash": "Points Retraits izocash",
          "--points withdrawals": "Points Retraits",
          "--preferably, use a vpn": "De préférence, utiliser un VPN qui n'appartient pas à votre fournisseur d'accès à internet",
          "--persistence always pays off": "La persévérance finit toujours par payer",
          "--please, check your virtual number": "S'il vous plait, Vérifier votre Numéro virtuel", //new
          "--please, try again later": "Veuillez rééssayer plus tard !", //new
          "--platform 1 for virtual applications": "Plateforme Nº1 des applications Virtuelles", //new
          "--rule": "Règles", //r
          "--recommendation": "Recommandations",
          "--registration": "Inscription",
          "--signup to veil brillant": "S'inscrire sur Veil Brillant", //s
          "--signup to vixinol store": "S'inscrire sur Vixinol Store",
          "--signup": "S'inscrire",
          "--signup success": "Inscription réussie !",
          "--signup for free": "S'inscrire gratuitement",
          "--signup success IA": "Connexion réussie”",
          "--settings": "Paramètres",
          "--setting up the alrani app": "Configuration de l'application Alrani", 
          "--setting up the izocash app": "Configuration de l'application izocash", 
          "--setting up the vixinol app": "Configuration de l'application Vixinol", 
          "--setting up the veil brillant app": "Configuration de l'application Veil Brillant",
          "--storage of images, videos": "Stockage des images, vidéos et plusieurs autres éléments",
          "--speed of reception": "Vitesse de Réception des données en provenance du Datacenter",
          "--speed": "Vitesse", 
          "--terminate": "Terminer", //t
          "--the vpn allows you to access": "Le VPN vous permet d'accéder à un site ou une application que votre fournisseur d'accès à internet à blacklister",
          "--the largest tree was above": "Le plus grand des arbres était avant tout une simple petite graine",
          "--touch the screen": "Toucher l'écran pour continuer",
          "--try again": "Réessayer !",
          "--phone number": "Numéro de téléphone",
          "--username": "Nom d'utilisateur", //u
          "--virtual number": "Numéro virtuel", //v
          "--virtual phone": "La messagerie 2025",
          "--virtual phone settings": "Paramètres du Téléphone Virtuel", 
          "--virtual phone language": "Langue du Téléphone Virtuel", //new (ca a remplacer par --choose language)
          "--virtual phone language is applied": "La langue du Téléphone Virtuel est appliquée au niveau des applications par défaut",
          "--validate": "Valider",
          "--welcome to the izocash customer portal": "Bienvenue sur le Portail des Clients izocash", //w
          "--write a super code": "Saisir un Super code",
          "--welcome to": "Bienvenue sur",
          "--where people's attention goes": "Là où l'attention des gens va l'argent suis",
          "--winners persevere": "Les gagnants persévèrent",
          "--would you like to log out of your florinato account": "Souhaitez-vous se déconnecter de votre compte Florinato ?",
          "--yes": "Oui", //y

          // country
          "--congo": "Congo Brazzaville",
          "--cameroon": "Cameroun",
          "--drc": "RDC",
          "--ivoryCoast": "Côte d'ivoire",

          //langue
        "--afrikaans": "Afrikaans", //a
        "--albanian": "Albanais",
        "--amharic": "Amharique",
        "--arabic": "Arabe",
        "--armenian": "Arménien",
        "--assamese": "Assamais",
        "--aymara": "Aymara",
        "--azerbaijani": "Azerbaïdjanais",
        "--bambara": "Bambara", //b
        "--basque": "Basque",
        "--belarusian": "Biélorusse",
        "--bengali": "Bengali",
        "--bhojpuri": "Bhojpuri",
        "--bosnian": "Bosniaque",
        "--bulgarian": "Bulgare",
        "--catalan": "Catalan", //c
        "--cebuano": "Cebuano",
        "--chichewa": "Chichewa",
        "--chineseSimplified": "Chinois (Simplifié)",
        "--chineseTraditional" : "Chinois (Traditionnel)",
        "--corsican" : "Corse",
        "--croatian": "Croate",
        "--czech": "Tchèque",
        "--danish": "Danois", //d
        "--dhivehi": "Dhivehi",
        "--dogri": "Dogri",
        "--dutch": "Néerlandais",
        "--english": "Anglais", //e
        "--esperanto": "Espéranto",
        "--estonian": "Estonien",
        "--ewe": "Ewe",
        "--filipino": "Philippin", //f
        "--finnish": "Finnois",
        "--french": "Français",
        "--frisian": "Frison",
        "--galician": "Galicien", //g
        "--georgian": "Géorgien",
        "--german": "Allemand",
        "--greek": "grec",
        "--guarani": "Guarani",
        "--gujarati": "Gujarati",
        "--haitianCreole": "Créole haïtien", //h
        "--hausa": "Haoussa",
        "--hawaiian": "Hawaïen",
        "--hebrew": "Hébreu",
        "--hindi": "Hindi",
        "--hmong": "Hmong",
        "--hungarian": "Hongrois",
        "--icelandic": "islandais", //i
        "--igbo": "Igbo",
        "--ilocano": "ilocano",
        "--indonesian": "indonésien",
        "--irish": "irlandais",
        "--italian": "italien",
        "--japanese": "Japonais", //j
        "--javanese": "javanais",
        "--kannada": "Kannada", //k
        "--kazakh": "Kazakh",
        "--khmer": "Khmer",
        "--kinyarwanda": "Kinyarwanda",
        "--konkani": "Konkani",
        "--korean": "coréen",
        "--krio": "Krio",
        "--kurdishKurmanji": "kurde (Kurmanji)",
        "--kurdishSorani": "kurde (sorani)",
        "--kyrgyz": "Kirghize",
        "--lao": "Laotien", //l
        "--latin": "latin",
        "--latvian": "letton",
        "--lingala": "Lingala",
        "--lithuanian": "lituanien",
        "--luganda": "Luganda",
        "--luxembourgish": "luxembourgeois",
        "--macedonian": "Macédonien", //m
        "--maithili": "Maithili",
        "--malagasy": "malgache",
        "--malay": "malais",
        "--malayalam": "Malayalam",
        "--maltese": "maltais",
        "--maori": "Maori",
        "--marathi": "Marathi",
        "--mizo": "Mizo",
        "--mongolian": "mongol",
        "--myanmarBurmese": "Myanmar (birman)",
        "--nepali": "népalais", //n
        "--norwegian": "norvégien",
        "--odiaOriya": "Odia (Oriya)", //o
        "--oromo": "Oromo",
        "--pashto": "Pashto", //p
        "--persian": "persan",
        "--polish": "polonais",
        "--portuguese": "Portugais",
        "--punjabi": "Pendjabi",
        "--quechua": "Quechua", //q
        "--romanian": "roumain", //r
        "--russian": "Russe",
        "--samoan": "Samoan", //s
        "--sanskrit": "Sanskrit",
        "--scotsGaelic": "gaélique écossais",
        "--sepedi": "Sepedi",
        "--serbian": "serbe",
        "--sesotho": "Sésotho",
        "--shona": "Shona",
        "--sindhi": "sindhi",
        "--sinhala": "cinghalais",
        "--slovak": "slovaque",
        "--slovenian": "slovène",
        "--somali": "somali",
        "--spanish": "Espagnol",
        "--sundanese": "sundanais",
        "--swahili": "Swahili",
        "--swedish": "suédois",
        "--tajik": "tadjik", //t
        "--tamil": "tamoul",
        "--tatar": "Tatar",
        "--telugu": "télougou",
        "--thai": "thaï",
        "--tigrinya": "Tigrinya",
        "--tsonga": "Tsonga",
        "--turkish": "turc",
        "--turkmen": "Turkmènes",
        "--twi": "Twi",
        "--ukrainian": "Ukrainien", //u
        "--urdu": "ourdou",
        "--uyghur": "Ouïghour",
        "--uzbek": "ouzbek",
        "--vietnamese": "vietnamien", //v
        "--welsh": "gallois", //w
        "--xhosa": "Xhosa", //x
        "--yiddish": "yiddish", //y
        "--yoruba": "Yorouba",
        "--zulu": "zoulou", //z
        },
      },
      
      // **frisian
      // **frisian
      /*
      frisian: {
        translations: {
          "--an error has occurred": "Der is in flater bard!", //a
          "--address": "Adressen",
          "--advice": "Advys",
          "--by clicking on continue": "Troch op trochgean te klikken wurde jo loskeppele fan jo Veil Brillant-akkount", //b
          "--by clicking on disconnect you will be disconnected": "Troch te klikken op Ferbine wurde jo loskeppele fan jo izocash-akkount",
          "--check your virtual number or try again later": "Kontrolearje jo firtuele nûmer of besykje it letter nochris", //c
          "--check your virtual number": "Kontrolearje jo firtuele nûmer",
          "--continue": "Trochgean",
          "--connection": "Ferbining",
          "--collaborate, live in harmony": "gearwurkje, libje yn harmony mei oaren",
          "--choose language": "Firtuele telefoantaal",
          "--don't prevent competition": "Konkurrinsje net foarkomme, elkenien in kâns jaan", //d
          "--disconnection": "Disconnection",
          "--for all virtual phone users": "Foar alle brûkers fan firtuele tillefoan wurdt it oanrikkemandearre om in VPN te brûken", //f
          "--go to login page": "Gean nei de oanmeldside", //g
          "--historical": "Histoarysk", //h
           "--i have account": "Ik haw al in akkount", //i
           "--i don't have account": "ik haw gjin akkount",
           "--it is your house": "it is dyn hûs",
           "--image / video +": "Ofbylding / fideo +",
           "--identity verification": "Identiteit ferifikaasje",
           "--izocash customer portal": "izocash klantportaal",
           "--identity update every year": "Identiteit update elk jier",
           "--izocash buy to": "izocash Keapje => izocash ynternasjonaal",
           "--log in": "Oanmelde!", //l
           "--login": "Oanmelde",
           "--login to veil brilliant": Ferbine mei Veil Brillant,
           "--login to vixinol store": Ferbine mei Vixinol Store,
           "--login for free to your veil brillant account": Meld jo fergees oan by jo Veil Brillant-akkount om tagong te krijen ta dizze funksje,
           "--login success": Oanmelde slagge!,
           "--login now": No oanmelde!,
           "--logout success": Ofmelde slagge!,
           "--log out": Ofmelde,
           "--logout": Ofmelde,
           "--number": Getal, //n
           "--name": Namme,
           "--now log in": "No, oanmelde!",
           "--no ban on stifling competition": "gjin ferbod op ferstikkende konkurrinsje"
           "--gjin oergeunst, gjin haat": Gjin oergeunst, gjin haat, gjin ferdieling,
           "--no": "Nee",
           "--offisjele adressen om tagong te krijen ta jo firtuele tillefoan": Offisjele adressen om tagong te krijen ta jo firtuele tillefoan, //o
           "--wachtwurd": Wachtwurd, //p
           "--punten weromlûken izocash": Punten weromlûken izocash,
           "--punten weromlûken": Punten weromlûken,
           "--foarkar, brûk in vpn": Brûk it leafst in VPN dy't net heart by jo ynternettsjinstprovider,
           "--persistinsje betellet altyd út": Persistinsje betellet altyd op it ein,
           "--rule": Regels, //r
           "--recommendation": Oanbefellings,
           "--registraasje": Registraasje,
           "--oanmelde by veil briljant": Registrearje op Veil Brillant, //s
           "--oanmelde by vixinol winkel": Registrearje op Vixinol Store,
           "--signup": Registrearje,
           "--signup súkses": Registraasje slagge!,
           "--registrearje fergees": Registrearje fergees,
           "--registraasje súkses IA": Ferbining suksesfol",
           "--settings": "Ynstellings",
           "--de alrani-app ynstelle": De Alrani-applikaasje konfigurearje,
           "--de izocash-app ynstelle": De izocash-applikaasje konfigurearje,
           "--de Vixinol-app ynstelle": De Vixinol-applikaasje konfigurearje,
           "--de Veil Brillant-app ynstelle": De Veil Brillant-applikaasje konfigurearje,
           "--opslach fan ôfbyldings, fideo's": opslach fan ôfbyldings, fideo's en ferskate oare eleminten,
           "--snelheid fan ûntfangst": Snelheid fan ûntfangst fan gegevens fan it Datacenter,
           "--speed": Faasje,
           "--terminate": Beëinigje, //t
           "--de vpn lit jo tagong krije": De VPN lit jo tagong krije ta in side of in applikaasje dy't jo ynternettsjinstprovider op 'e swarte list hat,
           "--de grutste beam wie boppe": De grutste beam wie boppe alles in ienfâldich lyts sied,
           "--touch the screen": Tik op it skerm om troch te gean,
           "--try again": Besykje it nochris!,
           "--brûkersnamme": Brûkersnamme, //u

           "--firtual number": Firtueel nûmer, //v
           "--virtuele telefoanynstellingen": Firtuele telefoanynstellingen,
           "--virtuele telefoantaal wurdt tapast": De firtuele telefoantaal wurdt standert tapast op it tapassingsnivo,
           "--firtual phone": Firtuele telefoan,
           "--validate": Validearje,
           "--wolkom by it izocash klantportaal": Wolkom by it izocash klantportaal, //w
           "--skriuw in superkoade": Fier in superkoade yn,
           "--wolkom by": Wolkom by,
           "--wêr't de oandacht fan minsken giet": Wêr't de oandacht fan minsken giet, giet jild,
           "--winners persevere": De winners persevere,
           "--wolle jo ôfmelde fan jo Alrani-akkount": Wolle jo jo ôfmelde by jo Alrani-akkount?,
           "--ja": Ja, //y

           // lân
           "--kongo": Kongo Brazzaville,
           "--kameroen": Kameroen,
           "--drc": DRC,
           "--ivoryCoast": Ivoarkust,

          // taal
        "--afrikaans": Afrikaansk, //a
        "--albaansk": Albaneesk,
        "--amharysk": Amharysk,
        "--arabysk": Arabysk,
        "--armenian": Armeensk,
        "--assameesk": Assameesk,
        "--aymara": Aymara,
        "--azerbeidzjaansk": Azerbeidzjaansk,
        "--bambara": Bambara, //b
        "--baskysk": Baskysk,
        "--wyt-Russysk": Wyt-Russysk,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnysk": Bosnysk,
        "--bulgaarsk": Bulgaarsk,
        "--katalaansk": Katalaansk, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Sineesk (Simplified),
        "--chineseTraditional": Sineesk (tradisjoneel),
        "--corsican": Korsikaansk,
        "--kroätysk": kroätysk,
        "--tsjech": Tsjechysk,
        "--deensk": Deensk, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--nederlânsk": Nederlânsk,
        "--english": Ingelsk, //e
        "--esperanto": Esperanto,
        "--estysk": Estsk,
        "--aai": aai,
        "--filipino": Filipynsk, //f
        "--finsk": Finsk,
        "--frânsk": Frânsk,
        "--frysk": Frysk,
        "--galisysk": Galisysk, //g
        "--georgian": Georgysk,
        "--dútsk": Dútsk,
        "--greek": Gryksk,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haïtysk kreoalsk, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaïaansk,
        "--hebrew": Hebrieusk,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hongaarsk,
        "--icelandic": Yslânsk, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--yndonesysk": Yndonesysk,
        "--irish": Iersk,
        "--italian": Italjaansk,
        "--japansk": Japansk, //j
        "--javanese": Javaansk,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--koreaansk": Koreaansk,
        "--krio": krio,
        "--kurdishKurmanji": Koerdysk (Kurmanji),
        "--kurdishSorani": Koerdysk (Sorani),
        "--kyrgyz": Kirgizysk,
        "--lao": Lao, //l
        "--latyn": Latyn,
        "--latysk": Letsk,
        "--lingala": Lingala,
        "--litousk": Litousk,
        "--luganda": Luganda,
        "--lúksemboarchsk": Lúksemboarchsk,
        "--masedoanysk": Masedoanysk, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--maleysk": Maleisk,
        "--malayalam": Malayalam,
        "--malteesk": Malteesk,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongoalsk": Mongoalsk,
        "--myanmarBirmeesk": Myanmar (Birmaansk),
        "--nepali": Nepaleesk, //n
        "--norwegian": Noarsk,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persysk": Perzysk,
        "--poalsk": Poalsk,
        "--portugeesk": Portegeesk,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--roemeensk": Roemeensk, //r
        "--russysk": Russysk,
        "--samoan": Samoan, //s
        "--sanskryt": Sanskryt,
        "--scotsGaelic": Skotsk Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Servysk,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slowaaksk,
        "--sloveensk": Sloveensk,
        "--somalysk": Somalysk,
        "--spanish": Spaansk,
        "--sundanese": Soendaneesk,
        "--swahili": Swahili,
        "--swedish": Sweedsk,
        "--tajik": Tadzjik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--Taisk": Taisk,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turksk,
        "--turkmen": Turkmen,
        "--twi": twa,
        "--ukrainian": Oekraynsk, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Oezbek,
        "--fietnameesk": Fietnameesk, //v
        "--welsk": Welsk, //w
        "--xhosa": Xhosa, //x
        "--jiddysk": Jiddysk, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
         
        },
      },

      // galician
      // galician
      galician: {
        translations: {
          
           "--an error has occurred": "Produciuse un erro!", //a
           "--address": "enderezos",
           "--advice": "Consello",
           "--by clicking on continue": "ao facer clic en continuar, desconectarase da súa conta de Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "ao facer clic en Desconectar, desconectarase da túa conta izocash",
           "--check your virtual number or try again later": "Comproba o teu número virtual ou téntao de novo máis tarde", //c
           "--check your virtual number": "comproba o teu número virtual",
           "--continue": "Continuar",
           "--connection": "conexión",
           "--collaborate, live in harmony": "Colaborar, vivir en harmonía cos demais",
           "--choose language": "idioma do teléfono virtual",
           "--don't prevent competition": "Non impida a competencia, dálle a todos unha oportunidade", //d
           "--disconnection": "Desconexión",
           "--for all virtual phone users": "para todos os usuarios de Virtual Phone, recoméndase usar unha VPN", //f
           "--go to login page": "Vaia á páxina de inicio de sesión", //g
           "--historical": "Histórico", //h

           "--I have account": Xa teño unha conta, //i
           "--i don't have account": non teño unha conta,
           "--é a túa casa": é a túa casa,
           "--image / video +": Imaxe / Vídeo +,
           "--identity verification": verificación de identidade,
           "--izocash customer portal": izocash Customer Portal,
           "--identity update every year": actualización de identidade cada ano,
           "--izocash buy to": izocash Buy => izocash internacional,
           "--log in": Iniciar sesión!, //l
           "--login": Iniciar sesión,
           "--login to veil brilliant": Conéctese a Veil Brillant,
           "--login to vixinol store": Conéctese a Vixinol Store,
           "--login for free to your veil Brillant account": inicie sesión de balde na súa conta de Veil Brillant para acceder a esta función.
           "--login success": inicio de sesión exitoso!,
           "--login now": Inicia sesión agora!,
           "--logout success": Pecha de sesión exitosa!,
           "--log out": Pechar sesión,
           "--logout": Pechar sesión,
           "--number": número, //n
           "--name": Nome,
           "--now log in": Agora, inicia sesión!,
           "--sen prohibición de sufocar a competencia":
           "--no celos, sen odio": sen celos, sen odio, sen divisións,
           "--non non,
           "--oficial addresses to access your virtual phone": enderezos oficiais para acceder ao teu teléfono virtual, //o
           "--password": contrasinal, //p
           "--points retiradas izocash": Puntos retiradas izocash,
           "--points retiradas": puntos retirados,
           "--preferably, use a vpn": preferiblemente, use unha VPN que non pertenza ao seu provedor de servizos de Internet,
           "--persistence always pay off": A persistencia sempre paga os seus froitos ao final,
           "--rule": Regras, //r
           "--recommendation": recomendacións,
           "--registration": rexistro,
           "--signup to veil brilliant": Rexístrese en Veil Brillant, //s
           "--subscribirse na tenda vixinol": rexistrarse na tenda Vixinol,
           "--signup": rexistrarse,
           "--signup success": Rexistro exitoso!,
           "--signup for free": rexistrarse de balde,
           “--signup success IA”: conexión exitosa”,
           "--settings": "Configuración",
           "--setting up the alrani app": configurando a aplicación Alrani,
           "--setting up the izocash app": configurando a aplicación izocash,
           "--setting up the vixinol app": configurando a aplicación Vixinol,
           "--setting up the veil Brillant app": configurando a aplicación Veil Brillant,
           "--storage of images, videos": almacenamento de imaxes, vídeos e outros elementos,
           "--speed of reception": velocidade de recepción de datos do centro de datos,
           "--speed": velocidade,
           "--terminate": Terminar, //t
           "--the vpn allow you to access": a VPN permítelle acceder a un sitio ou a unha aplicación que o seu fornecedor de servizos de Internet incluíu na lista negra,
           "--the greatest tree was above": a árbore máis grande era sobre todo unha simple pequena semente,
           "--touch the screen": toca a pantalla para continuar,
           "--try again": Téntao de novo!,
           "--username": Nome de usuario, //u

           "--número virtual": número virtual, //v
           "--virtual phone settings": configuración do teléfono virtual,
           "--aplícase o idioma do teléfono virtual": o idioma do teléfono virtual aplícase a nivel de aplicación por defecto,
           "--virtual phone": Teléfono virtual,
           "--validate": validar,
           "--welcome to the izocash customer portal": Benvido ao izocash Customer Portal, //w
           "--write a super code": introduce un super código,
           "--welcome to": Benvido a,
           "--onde vai a atención da xente": onde vai a atención da xente vai o diñeiro,
           "--winners persevere": Os gañadores perseveran,
           "--would you like to log out of your Alrani account": Queres pechar sesión na túa conta Alrani?,
           "--yes": Si, //y

           // país
           "--congo": Congo Brazzaville,
           "--cameroon": Camerún,
           "--drc": DRC,
           "--ivoryCoast": Costa de Marfil,

           // lingua
        "--afrikaans": afrikáans, //a
        "--albanian": albanés,
        "--amharic": amárico,
        "--arabic": árabe,
        "--armenio": armenio,
        "--assamese": asamés,
        "--aymara": aimara,
        "--azerbaijani": azerbaiano,
        "--bambara": Bambara, //b
        "--basque": éuscaro,
        "--bielorruso": bielorruso,
        "--bengalí": bengalí,
        "--bhojpuri": Bhojpuri,
        "--bosnian": bosnio,
        "--bulgarian": búlgaro,
        "--catalán": catalán, //c
        "--cebuano": cebuano,
        "--chichewa": chichewa,
        "--chineseSimplified": chinés (simplificado),
        "--chineseTraditional": chinés (tradicional),
        "--corsican": corso,
        "--croatian": croata,
        "--checo": checo,
        "--danish": danés, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--neerlandés": holandés,
        "--inglés": inglés, //e
        "--esperanto": esperanto,
        "--estonian": estonio,
        "--ewe": ovella,
        "--filipino": filipino, //f
        "--finlandés": finés,
        "--francés": francés,
        "--frisian": frisón,
        "--galician": galego, //g
        "--georgian": xeorxiano,
        "--alemán": alemán,
        "--greek": grego,
        "--guarani": guaraní,
        "--gujarati": gujarati,
        "--criollo haitiano": crioulo haitiano, //h
        "--hausa": Hausa,
        "--hawaiian": hawaiano,
        "--hebrew": hebreo,
        "--hindi": hindi,
        "--hmong": Hmong,
        "--hungarian": húngaro,
        "--islandic": islandés, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesio": indonesio,
        "--irish": irlandés,
        "--italian": italiano,
        "--xaponés": xaponés, //j
        "--javanese": xavanés,
        "--kannada": kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": kinyarwanda,
        "--konkani": Konkani,
        "--corean": coreano,
        "--krio": Krio,
        "--kurdishKurmanji": kurdo (Kurmanji),
        "--kurdishSorani": kurdo (sorani),
        "--kyrgyz": Kirguiz,
        "--lao": Lao, //l
        "--latín": latín,
        "--latvian": letón,
        "--lingala": lingala,
        "--lituanian": lituano,
        "--luganda": Luganda,
        "--luxembourgish": luxemburgués,
        "--macedonian": macedonio, //m
        "--maithili": Maithili,
        "--malgaxe": malgache,
        "--malay": malaio,
        "--malayalam": malayalam,
        "--maltese": maltés,
        "--maori": maorí,
        "--marathi": marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongol,
        "--myanmarBurmese": Myanmar (birmano),
        "--nepalí": nepalí, //n
        "--noruegués": noruegués,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persa": persa,
        "--polish": polaco,
        "--portuguese": portugués,
        "--punjabi": punjabi,
        "--quechua": Quechua, //q
        "--romanian": romanés, //r
        "--rusan": ruso,
        "--samoan": samoano, //s
        "--sanskrit": sánscrito,
        "--scotsGaelic": gaélico escocés,
        "--sepedi": Sepedi,
        "--serbian": serbio,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": sindhi,
        "--sinhala": cingalés,
        "--eslovaco": eslovaco,
        "--esloveno": esloveno,
        "--somali": somalí,
        "--español": español,
        "--sundanese": sundanés,
        "--swahili": suahili,
        "--swedish": sueco,
        "--tajik": taxico, //t
        "--tamil": tamil,
        "--tatar": tártaro,
        "--telugu": telugu,
        "--thai": tailandés,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turco,
        "--turkmen": turcomano,
        "--twi": Twi,
        "--ucraíno": ucraíno, //u
        "--urdu": urdú,
        "--uyghur": uigur,
        "--uzbek": uzbeco,
        "--vietnamese": vietnamita, //v
        "--welsh": galés, //w
        "--xhosa": Xhosa, //x
        "--yiddish": yiddish, //y
        "--yoruba": ioruba,
        "--zulú": zulú, //z
        },
      },

      // **georgian
      // **georgian
      georgian: {
        translations: {
          "--an error has occurred": "მოხდა შეცდომა!", //a
          "--address": "მისამართები",
          "--advice": "რჩევა",
          "--by clicking on continue": "გაგრძელებაზე დაწკაპუნებით თქვენ გათიშული იქნებით თქვენი Veil Brillant ანგარიშიდან", //b
          "--by clicking on disconnect you will be disconnected": "გათიშვაზე დაწკაპუნებით თქვენ გაითიშებით თქვენი izocash ანგარიშიდან",
          "--check your virtual number or try again later": "შეამოწმეთ თქვენი ვირტუალური ნომერი ან სცადეთ მოგვიანებით", //c
          "--check your virtual number": "შეამოწმეთ თქვენი ვირტუალური ნომერი",
          "--continue": "გაგრძელება",
          "--connection": "კავშირი",
          "--collaborate, live in harmony": "ითანამშრომლე, იცხოვრე სხვებთან ჰარმონიაში",
          "--choose language": "ვირტუალური ტელეფონის ენა",
          "--don't prevent competition": "ნუ უშლის ხელს კონკურენციას, მიეცი ყველას შანსი", //d
          "--disconnection": "გათიშვა",
          "--for all virtual phone users": "ვირტუალური ტელეფონის ყველა მომხმარებლისთვის რეკომენდებულია VPN-ის გამოყენება", //f
          "--go to login page": "გადადით შესვლის გვერდზე", //g
          "--historical": "ისტორიული", //h


           "--i have account": მე უკვე მაქვს ანგარიში, //i
           "--მე არ მაქვს ანგარიში": მე არ მაქვს ანგარიში,
           "--ეს შენი სახლია": შენი სახლია,
           "--სურათი / ვიდეო +": სურათი / ვიდეო +,
           "--იდენტობის შემოწმება": პირადობის დადასტურება,
           "--izocash მომხმარებელთა პორტალი": izocash მომხმარებელთა პორტალი,
           "--იდენტობის განახლება ყოველწლიურად": პირადობის განახლება ყოველწლიურად,
           "--izocash buy to": izocash ყიდვა => izocash international,
           "--log in": შესვლა!, //ლ
           "--login": შესვლა,
           "--login to veil brilliant": დაკავშირება Veil Brillant,
           "--შედით ვიქსინოლის მაღაზიაში": დაუკავშირდით Vixinol Store-ს,
           "--უფასოდ შედით თქვენს Veil Brillant ანგარიშზე": შედით უფასოდ თქვენს Veil Brillant ანგარიშზე, რომ შეხვიდეთ ამ ფუნქციაზე,
           "--login success": შესვლა წარმატებულია!,
           "--შესვლა ახლა": შედით ახლავე!,
           "--logout წარმატება": გამოსვლა წარმატებულია!,
           "--log out": გამოსვლა,
           "--logout": გასვლა,
           "--number": ნომერი, //n
           "--name": სახელი,
           "-- now log in": ახლა, შედით!,
           "--კონკურენციის ჩახშობის აკრძალვა არ არის":
           "--არა ეჭვიანობა, არა სიძულვილი": არა ეჭვიანობა, არა სიძულვილი, არა განხეთქილება,
           "--არა არა,
           "--ოფიციალური მისამართები თქვენს ვირტუალურ ტელეფონზე წვდომისთვის": ოფიციალური მისამართები თქვენს ვირტუალურ ტელეფონზე წვდომისთვის, //o
           "--პაროლი": პაროლი, //გვ
           "--ქულების გატანა izocash": ქულების ამოღება izocash,
           "--ქულების გატანა": ქულების ამოღება,
           "--სასურველია, გამოიყენოთ vpn": სასურველია გამოიყენოთ VPN, რომელიც არ ეკუთვნის თქვენს ინტერნეტ სერვისის პროვაიდერს,
           "--გამძლეობა ყოველთვის ანაზღაურდება": გამძლეობა ყოველთვის იხდის ბოლოს,
           "--rule": წესები, //r
           "--რეკომენდაცია": რეკომენდაციები,
           "--რეგისტრაცია": რეგისტრაცია,
           "--signup to veil brilliant": რეგისტრაცია Veil Brillant-ზე, //s
           "--დარეგისტრირება ვიქსინოლის მაღაზიაში": დარეგისტრირდით Vixinol Store-ში,
           "--რეგისტრაცია": რეგისტრაცია,
           "--რეგისტრაციის წარმატება": რეგისტრაცია წარმატებულია!,
           "--დარეგისტრირება უფასოდ": დარეგისტრირდით უფასოდ,
           "--რეგისტრაციის წარმატება IA": კავშირი წარმატებულია",
           "--პარამეტრები": "პარამეტრები",
           "--alrani აპლიკაციის დაყენება": Alrani აპლიკაციის კონფიგურაცია,
           "--izocash აპლიკაციის დაყენება": izocash აპლიკაციის კონფიგურაცია,
           "--ვიქსინოლის აპის დაყენება": ვიქსინოლის აპლიკაციის კონფიგურაცია,
           "--veil Brillant აპის დაყენება": Veil Brillant აპლიკაციის კონფიგურაცია,
           "--სურათების, ვიდეოების შენახვა": სურათების, ვიდეოების და რამდენიმე სხვა ელემენტის შენახვა,
           "--მიღების სიჩქარე": მონაცემთა მიღების სიჩქარე მონაცემთა ცენტრიდან,
           "--speed": სიჩქარე,
           "--გაწყვეტილება": შეწყვეტა, //ტ
           "--vpn გაძლევთ წვდომას": VPN გაძლევთ საშუალებას შეხვიდეთ საიტზე ან აპლიკაციაზე, რომელიც თქვენს ინტერნეტ სერვისის პროვაიდერს აქვს შავ სიაში,
           "--ყველაზე დიდი ხე იყო ზემოთ": ყველაზე დიდი ხე იყო უბრალო პატარა თესლი,
           "--შეეხეთ ეკრანს": შეეხეთ ეკრანს გასაგრძელებლად,
           "--სცადეთ ისევ": სცადეთ კიდევ ერთხელ!,
           "--username": მომხმარებლის სახელი, //u


           "--ვირტუალური ნომერი": ვირტუალური ნომერი, //v
           "--ვირტუალური ტელეფონის პარამეტრები": ვირტუალური ტელეფონის პარამეტრები,
           "--ვირტუალური ტელეფონის ენა გამოიყენება": ვირტუალური ტელეფონის ენა გამოიყენება აპლიკაციის დონეზე ნაგულისხმევად,
           "--ვირტუალური ტელეფონი": ვირტუალური ტელეფონი,
           "--validate": დადასტურება,
           "--კეთილი იყოს თქვენი მობრძანება izocash მომხმარებელთა პორტალზე": კეთილი იყოს თქვენი მობრძანება izocash მომხმარებელთა პორტალზე, //w
           "--დაწერეთ სუპერ კოდი": შეიყვანეთ სუპერ კოდი,
           "--welcome to": მოგესალმებით,
           "--იქ სადაც ხალხის ყურადღება მიდის": სადაც ხალხის ყურადღება მიდის, მიდის ფული,
           "--winners persevere": გამარჯვებულები აგრძელებენ,
           "--გსურთ გამოხვიდეთ თქვენი Alrani ანგარიშიდან": გსურთ გამოხვიდეთ თქვენი Alrani ანგარიშიდან?,
           "--yes": დიახ, //y

           // ქვეყანა
           "--კონგო": კონგო ბრაზავილი,
           "--კამერუნი": კამერუნი,
           "--drc": DRC,
           "--ivoryCoast": სპილოს ძვლის სანაპირო,


          // ენა
        "-- afrikaans": აფრიკაანსი, //ა
        "--ალბანური": ალბანური,
        "--ამჰარული": ამჰარული,
        "--არაბული": არაბული,
        "--სომხური": სომხური,
        "--ასამური": ასამური,
        "--aymara": აიმარა,
        "--აზერბაიჯანული": აზერბაიჯანული,
        „--ბამბარა“: ბამბარა, //ბ
        "--basque": ბასკური,
        "--belarusian": ბელორუსული,
        "--bengali": ბენგალური,
        "--bhojpuri": ბოჯპური,
        "--ბოსნიური": ბოსნიური,
        "--ბულგარული": ბულგარული,
        "--catalan": კატალანური, //გ
        "--cebuano": Cebuano,
        "--ჩიჩევა": ჩიჩევა,
        "--chineseSimplified": ჩინური (გამარტივებული),
        "--chineseTraditional": ჩინური (ტრადიციული),
        "--corsican": კორსიკული,
        "--croatian": ხორვატული,
        "--ჩეხური": ჩეხური,
        „--დანიური“: დანიური, //დ
        "--dhivehi": დივეჰი,
        "--დოგრი": დოგრი,
        "--ჰოლანდიური": ჰოლანდიური,
        „--ინგლისური“: ინგლისური, //ე
        "--ესპერანტო": ესპერანტო,
        "--ესტონური": ესტონური,
        "--ევა": ცხვარი,
        „--ფილიპინო“: ფილიპინელი, //ფ
        "--ფინური": ფინური,
        "--ფრანგული": ფრანგული,
        "--frisian": ფრიზიული,
        „--გალისური“: გალისიური, //გ
        "--ქართული": ქართული,
        "--გერმანული": გერმანული,
        "--ბერძნული": ბერძნული,
        "--გუარანი": გუარანი,
        "--გუჯარათი": გუჯარათი,
        "--haitianCreole": ჰაიტური კრეოლი, //სთ
        "--ჰაუსა": ჰაუსა,
        "--ჰავაური": ჰავაიური,
        "--ებრაული": ებრაული,
        "--ჰინდი": ჰინდი,
        "--hmong": ჰმონგი,
        "--უნგრელი": უნგრული,
        "--ისლანდიური": ისლანდიური, //ი
        "--igbo": იგბო,
        "--ილოკანო": ილოკანო,
        "--ინდონეზია": ინდონეზიური,
        "--ირლანდიური": ირლანდიური,
        "--იტალიური": იტალიური,
        „--იაპონური“: იაპონური, //ჯ
        "--იავანური": იავური,
        „--კანადა“: კანადა, //კ
        "--ყაზახური": ყაზახური,
        "--khmer": ქმერული,
        "--kinyarwanda": კინიარუანდა,
        "--კონკანი": კონკანი,
        "--კორეული": კორეული,
        "--krio": კრიო,
        "--kurdishKurmanji": ქურთული (კურმანჯი),
        "--kurdishSorani": ქურთული (სორანი),
        "--kyrgyz": ყირგიზული,
        „--ლაო“: ლაო, //ლ
        "--ლათინური": ლათინური,
        "--ლატვიური": ლატვიური,
        "--lingala": ლინგალა,
        "--ლიტვური": ლიტვური,
        "--ლუგანდა": ლუგანდა,
        "--ლუქსემბურგული": ლუქსემბურგული,
        „--მაკედონური“: მაკედონური, //მ
        "--მაითილი": მაითილი,
        "--malagasy": მალაგასიური,
        "--მალაი": მალაიური,
        "--malayalam": მალაიალამური,
        "--მალტური": მალტური,
        "--მაორი": მაორი,
        "--marathi": მარათჰი,
        "--meiteilonManipuri": მეიტეილონი (მანიპური),
        "--მიზო": მიზო,
        "--მონღოლური": მონღოლური,
        "--myanmarBurmese": მიანმარი (ბირმული),
        "--nepali": ნეპალური, //ნ
        "--ნორვეგიული": ნორვეგიული,
        "--odiaOriya": ოდია (ორია), //ო
        "--ორომო": ორომო,
        „--პუშტუ“: პუშტუ, //გვ
        "--სპარსული": სპარსული,
        "--პოლონური": პოლონური,
        "--პორტუგალიური": პორტუგალიური,
        "--პენჯაბი": პენჯაბური,
        „--კეჩუა“: კეჩუა, //ქ
        „--რუმინული“: რუმინული, //რ
        "--რუსული": რუსული,
        „--სამოანო“: სამოური, //ს
        "--სანსკრიტი": სანსკრიტი,
        "--scotsGaelic": შოტლანდიური გელური,
        "--სეპედი": სეპედი,
        "--სერბული": სერბული,
        "--სესოთო": სესოთო,
        "--შონა": შონა,
        "--სინდი": სინდი,
        "--sinhala": სინჰალური,
        "--სლოვაკური": სლოვაკური,
        "--სლოვენური": სლოვენური,
        "--სომალი": სომალიური,
        "--ესპანური": ესპანური,
        "--სუნდური": სუნდური,
        "--swahili": სუაჰილი,
        "--შვედური": შვედური,
        „--ტაჯიკური“: ტაჯიკური, //ტ
        "--tamil": ტამილური,
        "--თათრული": თათრული,
        "--ტელუგუ": ტელუგუ,
        "--ტაი": ტაილანდური,
        "--ტიგრინია": ტიგრინია,
        "--ცონგა": ცონგა,
        "--თურქული": თურქული,
        "--თურქმენი": თურქმენული,
        "--twi": Twi,
        „--უკრაინული“: უკრაინული, //უ
        "--ურდუ": ურდუ,
        "--უიღური": უიღური,
        "--უზბეკი": უზბეკური,
        „--ვიეტნამური“: ვიეტნამური, //ვ
        "--welsh": უელსური, //ვ
        „--ხოსა“: ხოსა, //ქ
        „--იდიში“: იდიში, //ი
        "--yoruba": იორუბა,
        „--ზულუ“: ზულუ, //ზ
        },
      },*/

      // **german
      // **german
      german: {
        translations: {
          "--an error has occurred": "Ein Fehler ist aufgetreten!", //a
          "--address": "Adressen",
          "--advice": "Rat",
          "--by clicking on continue": "Durch Klicken auf Weiter werden Sie von Ihrem Veil Brillant-Konto getrennt", //b
          "--by clicking on disconnect you will be disconnected": "Durch Klicken auf Trennen werden Sie von Ihrem izocash-Konto getrennt",
          "--check your virtual number or try again later": "Überprüfen Sie Ihre virtuelle Nummer oder versuchen Sie es später erneut", //c
          "--check your virtual number": "Überprüfen Sie Ihre virtuelle Nummer",
          "--continue": "Weiter",
          "--connection": "Verbindung",
          "--collaborate, live in harmony": "Zusammenarbeiten, in Harmonie mit anderen leben",
          "--virtual phone language": "Virtuelle Telefonsprache",
          "--don't prevent competition": "Verhindern Sie nicht den Wettbewerb, geben Sie jedem eine Chance", //d
          "--disconnection": "Trennung",
          "--for all virtual phone users": "Für alle Benutzer virtueller Telefone wird die Verwendung eines VPN empfohlen", //f
          "--go to login page": "Gehe zur Anmeldeseite", //g
          "--historical": "Historisch", //h
          "--i have account": "Ich habe bereits ein Konto", //i
          "--i don't have account": "Ich habe kein Konto",
          "--it is your house": "es ist dein Haus",
          "--image / video +": "Bild / Video +",
           "--identity verification": "Identitätsüberprüfung",
           "--izocash customer portal": "izocash Kundenportal",
           "--identity update every year": "Identitätsaktualisierung jedes Jahr",
           "--izocash buy to": "izocash Buy => izocash international",
           "--log in": "Anmelden!", //l
           "--login": "Einloggen",
           "--login to veil brillant": "Mit Veil Brillant verbinden",
           "--login to vixinol store": "tellen Sie eine Verbindung zum Vixinol Store her.",
           "--login for free to your veil brillant account": "Melden Sie sich kostenlos bei Ihrem Veil Brillant-Konto an, um auf diese Funktion zuzugreifen.",
           "--login success": "Anmeldung erfolgreich!",
           "--login now": "Jetzt anmelden!",
           "--logout success": "Abmeldung erfolgreich!",
           "--log out": "Abmelden",
           "--logout": "Abmelden",
           "--number": "Zahl", //n
           "--name": "Name",
           "--now log in": "Jetzt anmelden!",
           "--no ban on stifling competition": "kein Wettbewerbsverbot",
           "--no jealousy, no hatred": "Keine Eifersucht, kein Hass, keine Spaltungen",
           "--no": "Nein",
           "--official addresses to access your virtual phone": "Offizielle Adressen für den Zugriff auf Ihr virtuelles Telefon", //o
           "--password": "Passwort", //p
           "--points withdrawals izocash": "Punkteabhebungen izocash",
           "--points withdrawals": "Punkteauszahlungen",
           "--preferably, use a vpn": "Verwenden Sie vorzugsweise ein VPN, das nicht zu Ihrem Internetdienstanbieter gehört.",
           "--persistence always pays off": "Beharrlichkeit zahlt sich am Ende immer aus",
           "--rule": "Regeln", //r
           "--recommendation": "Empfehlungen",
           "--registration": "Registrierung",
           "--signup to veil brillant": "Registrieren Sie sich bei Veil Brillant", //s
           "--signup to vixinol store": "Registrieren Sie sich im Vixinol Store",
           "--signup": "Registrieren",
           "--signup success": "Registrierung erfolgreich!",
           "--signup for free": "Kostenlos registrieren",
           "--signup success IA": "Verbindung erfolgreich“",
           "--settings": "Einstellungen",
           "--setting up the alrani app": "Konfigurieren der Alrani-Anwendung",
           "--setting up the izocash app": "Konfigurieren der izocash-Anwendung",
           "--setting up the vixinol app": "Konfigurieren der Vixinol-Anwendung",
           "--setting up the veil Brillant app": "Konfigurieren der Veil Brillant-Anwendung",
           "--storage of images, videos": "Speicherung von Bildern, Videos und mehreren anderen Elementen",
           "--speed of reception": "Empfangsgeschwindigkeit der Daten vom Rechenzentrum",
           "--speed": "Geschwindigkeit",
           "--terminate": "Beenden", //t
           "--the vpn allows you to access": "Das VPN ermöglicht Ihnen den Zugriff auf eine Website oder eine Anwendung, die Ihr Internetdienstanbieter auf die schwarze Liste gesetzt hat.",
           "--the largest tree was above": "Der größte Baum war vor allem ein einfacher kleiner Samen",
           "--touch the screen": "Berühren Sie den Bildschirm, um fortzufahren.",
           "--try again": "Versuchen Sie es noch einmal!",
           "--username": "Benutzername", //u
           "--virtual number": "Virtuelle Nummer", //v
           "--virtual phone Settings": "Einstellungen des virtuellen Telefons",
           "--virtual phone language is applied": "Die Sprache des virtuellen Telefons wird standardmäßig auf Anwendungsebene angewendet.",
           "--virtual phone": "Virtuelles Telefon",
           "--validate": "Validieren",
           "--welcome to the izocash customer portal": "Willkommen im izocash-Kundenportal", //w
           "--write a super code": "Geben Sie einen Supercode ein",
           "--welcome to": "Willkommen bei",
           "--where people's attention goes": "Wohin die Aufmerksamkeit der Menschen geht, geht Geld",
           "--winners persevere": "Die Gewinner halten durch",
           "--would you like to log out of your Alrani account": "Möchten Sie sich von Ihrem Alrani-Konto abmelden?",
           "--yes": "Ja", //y

           // pays
           "--congo": "Kongo Brazzaville",
           "--cameroon": "Kamerun",
           "--drc": "DRC",
           "--ivoryCoast": "Elfenbeinküste",

           // langue
        "--afrikaans": "Afrikaans", //a
        "--albanian": "Albanisch",
        "--amharic": "Amharisch",
        "--arabic": "Arabisch",
        "--armenian": "Armenisch",
        "--assamese": "Assamesisch",
        "--aymara": "Aymara",
        "--azerbaijani": "Aserbaidschanisch",
        "--bambara": "Bambara", //b
        "--basque": "Baskisch",
        "--belarusian": "Weißrussisch",
        "--bengali": "Bengali",
        "--bhojpuri": "Bhojpuri",
        "--bosnian": "Bosnisch",
        "--bulgarian": "Bulgarisch",
        "--catalan": "Katalanisch", //c
        "--cebuano": "Cebuano",
        "--chichewa": "Chichewa",
        "--chineseSimplified": "Chinesisch (vereinfacht)",
        "--chineseTraditional": "Chinesisch (traditionell)",
        "--corsican": "Korsisch",
        "--croatian": "Kroatisch",
        "--czech": "Tschechisch",
        "--danish": "Dänisch", //d
        "--dhivehi": "Dhivehi",
        "--dogri": "Dogri",
        "--dutch": "Niederländisch",
        "--english": "Englisch", //e
        "--esperanto": "Esperanto",
        "--estonian": "Estnisch",
        "--ewe": "Ewe",
        "--filipino": "Filipino", //f
        "--finnish": "Finnisch",
        "--french": "Französisch",
        "--frisian": "Friesisch",
        "--galician": "Galizisch", //g
        "--georgian": "Georgisch",
        "--german": "Deutsch",
        "--greek": "Griechisch",
        "--guarani": "Guarani",
        "--gujarati": "Gujarati",
        "--haitianCreole": "Haitianisches Kreol", //h
        "--hausa": "Hausa",
        "--hawaiian": "Hawaiianisch",
        "--hebrew": "Hebräisch",
        "--hindi": "Hindi",
        "--hmong": "Hmong",
        "--hungarian": "Ungarisch",
        "--icelandic": "Isländisch", //i
        "--igbo": "Igbo",
        "--ilocano": "Ilocano",
        "--indonesian": "Indonesisch",
        "--irish": "irisch",
        "--italian": "Italienisch",
        "--japanese": "Japanisch", //j
        "--javanese": "Javanisch",
        "--kannada": "Kannada", //k
        "--kazakh": "Kasachisch",
        "--khmer": "Khmer",
        "--kinyarwanda": "Kinyarwanda",
        "--konkani": "Konkani",
        "--korean": "Koreanisch",
        "--krio": "Krio",
        "--kurdishKurmanji": "Kurdisch (Kurmanji)",
        "--kurdishSorani": "Kurdisch (Sorani)",
        "--kyrgyz": "Kirgisisch",
        "--lao": "Lao", //l
        "--latin": "Latein",
        "--latvian": "Lettisch",
        "--lingala": "Lingala",
        "--lituanian": "Litauisch",
        "--luganda": "Luganda",
        "--luxembourgish": "Luxemburgisch",
        "--macedonian": "Mazedonisch", //m
        "--maithili": "Maithili",
        "--malagasy": "Madagassisch",
        "--malay": "Malaiisch",
        "--malayalam": "Malayalam",
        "--maltese": "Maltesisch",
        "--maori": "Maori",
        "--marathi": "Marathi",
        "--mizo": "Mizo",
        "--mongolian": "Mongolisch",
        "--myanmarBurmese": "Myanmar (Burmesisch)",
        "--nepali": "Nepali", //n
        "--norwegian": "Norwegisch",
        "--odiaOriya": "Odia (Oriya)", //o
        "--oromo": "Oromo",
        "--pashto": "Paschtu", //S
        "--persian": "Persisch",
        "--polish": "Polnisch",
        "--portuguese": "Portugiesisch",
        "--punjabi": "Punjabi",
        "--quechua": "Quechua", //q
        "--romanian": "Rumänisch", //r
        "--russian": "Russisch",
        "--samoan": "Samoanisch", //s
        "--sanskrit": "Sanskrit",
        "--scotsGaelic": "Schottisches Gälisch",
        "--sepedi": "Sepedi",
        "--serbian": "Serbisch",
        "--sesotho": "Sesotho",
        "--shona": "Shona",
        "--sindhi": "Sindhi",
        "--sinhala": "Singhalesisch",
        "--slovak": "Slowakisch",
        "--slovenian": "Slowenisch",
        "--somali": "Somali",
        "--spanish": "Spanisch",
        "--sundanese": "Sundanesisch",
        "--swahili": "Suaheli",
        "--swedish": "Schwedisch",
        "--tajik": "Tadschikisch", //t
        "--tamil": "Tamilisch",
        "--tatar": "tatarisch",
        "--telugu": "Telugu",
        "--thai": "Thailändisch",
        "--tigrinya": "Tigrinya",
        "--tsonga": "Tsonga",
        "--turkish": "Türkisch",
        "--turkmen": "Turkmenisch",
        "--twi": "Twi",
        "--ukrainian": "Ukrainisch", //u
        "--urdu": "Urdu",
        "--uyghur": "Uigurisch",
        "--uzbek": "Usbekisch",
        "--vietnamese": "Vietnamesisch", //v
        "--welsh": "Walisisch", //w
        "--xhosa": "Xhosa", //x
        "--yiddish": "Jiddisch", //y
        "--yoruba": "Yoruba",
        "--zulu": "Zulu", //z
        },
      },

      // **greek
      // **greek
      /*greek: {
        translations: {
          "--an error has occurred": "Παρουσιάστηκε σφάλμα!", //a
          "--address": "Διευθύνσεις",
          "--advice": "Συμβουλή",
          "--by clicking on continue": "Κάνοντας κλικ στο Συνέχεια θα αποσυνδεθείτε από τον λογαριασμό σας Veil Brillant", //b
          "--by clicking on disconnect you will be disconnected": "Κάνοντας κλικ στο Αποσύνδεση θα αποσυνδεθείτε από τον λογαριασμό σας στο izocash",
          "--check your virtual number or try again later": "Ελέγξτε τον εικονικό σας αριθμό ή δοκιμάστε ξανά αργότερα", //c
          "--check your virtual number": "Ελέγξτε τον εικονικό σας αριθμό",
          "--continue": "Συνέχεια",
          "--connection": "Σύνδεση",
          "--collaborate, live in harmony": "Συνεργάζεστε, ζείτε σε αρμονία με άλλους",
          "--choose language": "Γλώσσα εικονικού τηλεφώνου",
          "--don't prevent competition": "Μην αποτρέπετε τον ανταγωνισμό, δώστε σε όλους μια ευκαιρία", //d
          "--disconnection": "Αποσύνδεση",
          "--for all virtual phone users": "Για όλους τους χρήστες εικονικών τηλεφώνων, συνιστάται η χρήση VPN", //f
          "--go to login page": "Μεταβείτε στη σελίδα σύνδεσης", //g
          "--historical": "Ιστορικό", //h


           "--έχω λογαριασμό": Έχω ήδη λογαριασμό, //i
           "--δεν έχω λογαριασμό": δεν έχω λογαριασμό,
           "-- είναι το σπίτι σου": είναι το σπίτι σου,
           "--εικόνα / βίντεο +": Εικόνα / Βίντεο +,
           "--επαλήθευση ταυτότητας": Επαλήθευση ταυτότητας,
           "--izocash πύλη πελατών": Πύλη πελατών izocash,
           "--ενημέρωση ταυτότητας κάθε χρόνο": Ενημέρωση ταυτότητας κάθε χρόνο,
           "--izocash buy to": izocash Αγορά => izocash international,
           "--log in": Σύνδεση!, //l
           "--login": Είσοδος,
           "--login to veil brilliant": Σύνδεση στο Veil Brillant,
           "--login to vixinol store": Σύνδεση στο Vixinol Store,
           "--συνδεθείτε δωρεάν στον λογαριασμό σας στο Veil Brillant": Συνδεθείτε δωρεάν στον λογαριασμό σας στο Veil Brillant για πρόσβαση σε αυτήν τη λειτουργία,
           "--login success": Επιτυχής σύνδεση!,
           "--login now": Συνδεθείτε τώρα!,
           "--επιτυχία αποσύνδεσης": Επιτυχής αποσύνδεση!,
           "--log out": Αποσύνδεση,
           "--logout": Αποσύνδεση,
           "--number": Αριθμός, //n
           "--name": Όνομα,
           "--τώρα συνδεθείτε": Τώρα, συνδεθείτε!,
           "--καμία απαγόρευση καταπνιγμού του ανταγωνισμού":
           "--χωρίς ζήλια, χωρίς μίσος": Χωρίς ζήλια, χωρίς μίσος, χωρίς διαιρέσεις,
           "--όχι όχι,
           "--επίσημες διευθύνσεις για πρόσβαση στο εικονικό σας τηλέφωνο": Επίσημες διευθύνσεις για πρόσβαση στο εικονικό σας τηλέφωνο, //o
           "--password": Κωδικός πρόσβασης, //σελ
           "--πόντους αναλήψεις izocash": Αναλήψεις πόντων izocash,
           "--Αποσύρσεις πόντων": Αναλήψεις πόντων,
           "--κατά προτίμηση, χρήση vpn": Κατά προτίμηση, χρησιμοποιήστε ένα VPN που δεν ανήκει στον πάροχο υπηρεσιών διαδικτύου σας,
           "--η επιμονή αποδίδει πάντα": Η επιμονή πάντα αποδίδει στο τέλος,
           "--rule": Κανόνες, //r
           "--σύσταση": Συστάσεις,
           "--registration": Εγγραφή,
           "--εγγραφή στο veil brilliant": Εγγραφείτε στο Veil Brillant, //s
           "--εγγραφή στο κατάστημα vixinol": Εγγραφείτε στο κατάστημα Vixinol,
           "--εγγραφή": Εγγραφή,
           "--επιτυχία εγγραφής": Η εγγραφή επιτυχής!,
           "--εγγραφή δωρεάν": Εγγραφείτε δωρεάν,
           "--επιτυχία εγγραφής IA": Η σύνδεση επιτυχής",
           "--settings": "Ρυθμίσεις",
           "--ρύθμιση της εφαρμογής alrani": Διαμόρφωση της εφαρμογής Alrani,
           "--ρύθμιση της εφαρμογής izocash": Διαμόρφωση της εφαρμογής izocash,
           "--Ρύθμιση της εφαρμογής vixinol": Διαμόρφωση της εφαρμογής Vixinol,
           "--Ρύθμιση της εφαρμογής Veil Brillant": Διαμόρφωση της εφαρμογής Veil Brillant,
           "--αποθήκευση εικόνων, βίντεο": Αποθήκευση εικόνων, βίντεο και πολλών άλλων στοιχείων,
           "--ταχύτητα λήψης": Ταχύτητα λήψης δεδομένων από το Datacenter,
           "--ταχύτητα": Ταχύτητα,
           "--terminate": Τερματισμός, //t
           "--το vpn σας επιτρέπει να έχετε πρόσβαση": Το VPN σάς επιτρέπει να έχετε πρόσβαση σε έναν ιστότοπο ή μια εφαρμογή που ο πάροχος υπηρεσιών διαδικτύου σας έχει συμπεριλάβει στη μαύρη λίστα,
           "--το μεγαλύτερο δέντρο ήταν από πάνω": Το μεγαλύτερο δέντρο ήταν πάνω από όλα ένας απλός μικρός σπόρος,
           "--touch the screen": Αγγίξτε την οθόνη για να συνεχίσετε,
           "--try again": Δοκιμάστε ξανά!,
           "--username": Όνομα χρήστη, //u

           "--virtual number": Εικονικός αριθμός, //v
           "--virtual phone settings": Ρυθμίσεις εικονικού τηλεφώνου,
           "--εφαρμόζεται η γλώσσα εικονικού τηλεφώνου": Η γλώσσα του εικονικού τηλεφώνου εφαρμόζεται σε επίπεδο εφαρμογής από προεπιλογή,
           "--εικονικό τηλέφωνο": Εικονικό τηλέφωνο,
           "--validate": επικύρωση,
           "--καλώς ήρθατε στην πύλη πελατών izocash": Καλώς ήρθατε στην Πύλη πελατών izocash, //w
           "--write a super code": Εισαγάγετε έναν Super code,
           "--welcome to": Καλώς ήρθατε στο,
           "--όπου πηγαίνει η προσοχή των ανθρώπων": Όπου πάει η προσοχή των ανθρώπων, πάνε τα χρήματα,
           "--winners persevere": Οι νικητές επιμένουν,
           "--θα θέλατε να αποσυνδεθείτε από τον λογαριασμό σας Alrani": Θέλετε να αποσυνδεθείτε από τον λογαριασμό σας στο Alrani;,
           "--yes": Ναι, //y

           // Χώρα
           "--congo": Congo Brazzaville,
           "--καμερούν": Καμερούν,
           "--drc": ΛΔΚ,
           "--IvoryCoast": Ακτή Ελεφαντοστού,

         // γλώσσα
        "-- afrikaans": Αφρικάανς, //α
        "--αλβανικό": αλβανικό,
        "--amharic": Αμαρικά,
        "--αραβικά": αραβικά,
        "--αρμένιος": αρμενικός,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Αζερμπαϊτζάν,
        «--μπαμπάρα»: Μπαμπάρα, //β
        "--basque": βασκικός,
        "--belarusian": Λευκορωσικά,
        "--bengali": Μπενγκάλι,
        "--bhojpuri": Μποτζπουρί,
        "--Βοσνιακός": Βόσνιος,
        "--βουλγαρικό": βουλγαρικό,
        «--καταλανικός»: καταλανικός, //γ
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Κινέζικα (Απλοποιημένα),
        "--chineseTraditional": Κινέζικα (Παραδοσιακό),
        "--corsican": Κορσικανός,
        "--κροατικό": κροατικό,
        "--τσεχικά": Τσεχικά,
        «--δανικά»: Δανέζικα, //δ
        "--dhivehi": Ντιβέχι,
        "--dogri": Dogri,
        "--ολλανδικά": Ολλανδικά,
        "--αγγλικά": αγγλικά, //e
        "--esperanto": Εσπεράντο,
        "--εσθονικά": εσθονικά,
        "--προβατίνα": Προβατίνα,
        "--filipino": φιλιππινέζικο, //f
        "--finnish": φινλανδικά,
        "--γαλλικά": γαλλικά,
        "--frisian": Φριζιανός,
        «--galician»: Γαλικιανός, //g
        "--γεωργιανός": γεωργιανός,
        "--γερμανικά": Γερμανικά,
        "--ελληνικά": ελληνικά,
        "--guarani": Γκουαρανί,
        "--γκουτζαράτι": Γκουτζαράτι,
        "--haitianCreole": Αϊτινή κρεολική, //h
        "--hausa": Hausa,
        "--hawaiian": Χαβάης,
        "--εβραϊκά": Εβραϊκά,
        "--hindi": Χίντι,
        "--hmong": Χμονγκ,
        "--ουγγρικά": ουγγρικά,
        "--ισλανδικά": Ισλανδικά, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": Ινδονησιακά,
        "--irish": Ιρλανδός,
        "--ιταλικά": ιταλικά,
        "--ιαπωνικά": Ιαπωνικά, //j
        "--javanese": Ιάβας,
        "--kannada": Κανάντα, //k
        "--kazakh": Καζακστάν,
        "--khmer": Χμερ,
        "--kinyarwanda": Κινιαρβάντα,
        "--konkani": Konkani,
        "--κορεατικό": Κορεάτικο,
        "--krio": Κριό,
        "--kurdishKurmanji": Κουρδικά (κουρμαντζί),
        "--kurdishSorani": Κουρδικά (Σορανί),
        "--kyrgyz": Κιργιζικά,
        «--λάο»: Λάο, //λ
        "--latin": Λατινικά,
        "--latvian": Λετονικό,
        "--lingala": Lingala,
        "--λιθουανικά": λιθουανικά,
        "--luganda": Λουγκάντα,
        "--λουξεμβουργιανό": λουξεμβουργιανό,
        "--μακεδονικός": Μακεδονικός, //μ
        "--maithili": Μαιθήλι,
        "--malagasy": Μαδαγασκάρης,
        "-- malay": Μαλαισιανό,
        "--malayalam": Μαλαγιαλάμ,
        "--maltese": μαλτέζικο,
        "--maori": Μαορί,
        "--marathi": Μαράθι,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--Μογγολικά": Μογγολικά,
        "--myanmarBurmese": Μιανμάρ (Βιρμανικά),
        "--nepali": Νεπάλ, //n
        "--norwegian": Νορβηγικά,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Πάστο, //σελ
        "--περσικά": περσικά,
        "-- polish": Πολωνικό,
        "--πορτογαλικά": Πορτογαλικά,
        "--punjabi": Παντζάμπι,
        "--quechua": Κέτσουα, //q
        "--ρουμανικός": ρουμανικός, //r
        "--ρωσικά": Ρωσικά,
        «--samoan»: Samoan, //s
        "--σανσκριτικά": σανσκριτικά,
        "--scotsGaelic": Σκωτικά Γαελικά,
        "--sepedi": Sepedi,
        "--Σερβικά": Σερβικά,
        "--sesotho": Σεσόθο,
        "--shona": Shona,
        "--sindhi": Σίντι,
        "--sinhala": Σινχαλά,
        "--slovak": Σλοβάκικο,
        "--σλοβενικά": σλοβενικά,
        "--σομαλί": Σομαλικά,
        "--ισπανικά": Ισπανικά,
        "--Sundanese": Σουνδανός,
        "--swahili": Σουαχίλι,
        "--σουηδικά": σουηδικά,
        "--τατζίκ": τατζίκ, //τ
        "--tamil": Ταμίλ,
        "--tatar": Τατάρ,
        "--telugu": Τελούγκου,
        "--thai": Ταϊλανδέζικο,
        "--tigrinya": Tigrinya,
        "--τσόνγκα": Τσόνγκα,
        "--τουρκικά": Τουρκικά,
        "--turkmen": Τουρκμενιστάν,
        "--twi": Twi,
        "--ουκραίνικο": ουκρανικό, //u
        "--urdu": Ουρντού,
        "--Uyghur": Ουιγούρος,
        "--uzbek": Ουζμπεκιστάν,
        "--vietnamese": βιετναμέζικο, //v
        "--welsh": ουαλικά, //w
        "--xhosa": Xhosa, //x
        "--Γιντίσ": Γίντις, //υ
        "--yoruba": Γιορούμπα,
        «--ζουλού»: Ζουλού, //ζ


        },
      },

      // **guarani
      // **guarani
      guarani: {
        translations: {
          "--an error has occurred": "Oiko peteĩ jejavy!", //a
          "--address": "Ñe’ẽmondo",
          "--advice": "Consejo",
          "--by clicking on continue": "Emboguapývo continuo rehe oñemboykéta nde cuenta Veil Brillant-gui", //b
          "--by clicking on disconnect you will be disconnected": "Emboguapývo Desconexión rehe reñemboykéta nde cuenta izocash-gui",
          "--check your virtual number or try again later": "Ehecháke nde papapy virtual térã eñeha'ã jey upe rire", //c
          "--check your virtual number": "Ehecháke nde papapy virtual",
          "--continue": "Oñemotenonde",
          "--connection": "Ñembojoaju",
          "--collaborate, live in harmony": "Oñomoirũ, oiko joajúpe ambue tapicha ndive",
          "--choose language": "Ñe'ẽ Teléfono Virtual",
          "--don't prevent competition": "Ani rejoko competencia, eme'ẽ opavavépe pa'ũ", //d
          "--disconnection": "Ñembogue",
          "--for all virtual phone users": "Opaite Teléfono Virtual puruhárape g̃uarã, oñemboheko ojepuru hag̃ua peteĩ VPN", //f
          "--go to login page": "Eike página jeikerãme", //g
          "--historical": "Tembiasakue rehegua", //h

           "--areko cuenta": Che aguerekóma peteĩ cuenta, //i
           "--ndarekói cuenta": Ndarekói cuenta,
           "--ha'e nde róga": ha'e nde róga,
           "--ta'ãnga / ta'ãngamýi +": Ta'ãnga / Ta'ãngamýi +,
           "--identidad jehechauka": Identidad jehechauka,
           "--izocash cliente portal": izocash Ñe’ẽryru ñemuha rehegua,
           "--identidad ñembopyahu káda arýpe": Identidad ñembopyahu káda arýpe,
           "--izocash ojogua haguã": izocash Ojogua => izocash internacional,
           "--eike": ¡Eike!, //l
           "--login": Eike,
           "--eike velo brillante-pe": Embojoaju Velo Brillant-pe,
           "--eike vixinol tenda rehe": Embojoaju Vixinol tenda ndive,
           "--eike gratis nde cuenta Veil Brillant-pe": Eike gratis nde cuenta Veil Brillant-pe reike hag̃ua ko mba’ekuaarãme,
           "--oike porã": ¡Oike porã!,
           "--eike ko'ágã": Eike ko'ágã!,
           "--logout éxito": ¡Osẽ porã!,
           "--osẽ": Osẽ, .
           "--logout": Osẽ, .
           "--papapy": Papapy, //n
           "--téra": Téra, .
           "--ko'ágã eike": Ko'ágã, Eike!,
           "--ndaipóri prohibición oñemboty haguã competencia":
           "--ndaipóri celos, no odio": Ndaipóri celos, no odio, no división,
           "--nahániri": Nahániri,
           "--dirección oficial ojeike hag̃ua ne teléfono virtual-pe": Dirección oficial ojeike hag̃ua ne teléfono virtual-pe, //o
           "--ñe’ẽñemi": Ñe’ẽñemi, //p
           "--punto retiro izocash": Punto Retiro izocash,
           "--punto retiro": Punto Retiro, .
           "--iporãvéta, eipuru peteĩ vpn": Iporãvéramo, eipuru peteĩ VPN ndaha’éiva ne puruhára servicio internet mba’e,
           "--persistencia akóinte opaga": Persistencia akóinte opaga ipahápe,
           "--regla": Regla, //r
           "--recomendación": Ñe’ẽmondo, .
           "--inscripción": Ñemboguapy, .
           "--inscripción a velo brillante": Ejeregistra Velo Brillante-pe, //s
           "--eñeanota tenda vixinol-pe": Ejeregistra Vixinol Store-pe,
           "--inskrivi": Ejeregistra,
           "--inscripción éxito": ¡Osẽ porã inscripción!,
           "--eñeanota gratis": Ejeregistra gratis,
           “--inscripción éxito IA”: Ñembojoaju osẽ porã”,
           "--ñemboheko": "Ñemboheko",
           "--omohenda alrani app": Oñemohenda Alrani purupyrã,
           "--omohenda izocash purupyrã": Oñemohenda izocash purupyrã,
           "--omohenda vixinol app": Oñemohenda Vixinol purupyrã,
           "--omohenda pe aplicación velo Brillant": Oñemohenda pe aplicación Veil Brillant,
           "--ta'ãngamýi, ta'ãngamýi ñeñongatu": Ta'ãngamýi, ta'ãngamýi ha heta ambue mba'e ñeñongatu,
           "--velocidad de recepción": Ojegueraha pyaꞌe hag̃ua umi dato Datacenter-gui,
           "--velocidad": Velocidad, .
           "--terminar": Opa, //t
           "--pe vpn oheja ndéve reike": VPN oheja ndéve reike peteĩ ñanduti renda térã peteĩ purupyrã ne ñe’ẽmondo internet puruhára omoĩva’ekue lista morotĩme,
           "--pe yvyra tuichavéva oĩkuri yvate": Pe yvyra tuichavéva ha'e opa mba'e ári peteĩ semilla michĩ simple,
           "--epoko pe pantalla rehe": Epoko pe pantalla rehe eñepyrũ hag̃ua,
           "--eñeha'ã jey": ¡Eñeha'ã jey!,
           "--puruhára réra": Pojoapy réra, //u

           "--papapy virtual": Papapy virtual, //v
           "--teléfono virtual ñemboheko": Teléfono virtual ñemboheko,
           "--oñemboguata Teléfono Virtual ñe'ẽ": Teléfono Virtual ñe'ẽ ojeporu purupyrã nivel-pe ñepyrũrã,
           "--teléfono virtual": Teléfono virtual, .
           "--omoañete": Omoañete, .
           "--peju porãite izocash cliente portal-pe": Peju porãite izocash Cliente Portal-pe, //w
           "--ehai peteĩ kódigo súper": Emoinge peteĩ kódigo Super,
           "--peju porãite": Peju porãite,
           "--ohohápe tapichakuéra resa": Ohohápe tapichakuéra resa oho viru,
           "--ganadores persevera": Umi oganáva opersevera,
           "--resẽse nde cuenta Alrani-gui": ¿Resẽse nde cuenta Alrani-gui?,
           "--heẽ": Heẽ, //y

           // tetã
           "--kongo": Congo Brazzaville, 1999-pe.
           "--camerún": Camerún,
           "--drc": RDC, 1999-pe.
           "--MarfilCosta": Costa de Marfil,

           // ñe’ẽ
        "--afrikaans": afrikaans, //a
        "--albanés": Albanés,
        "--amharic": Amharic,
        "--árabe": árabe,
        "--armenio": Armenio,
        "--asamese": Ñe'ẽ guarani,
        "--aymara": Aymara,
        "--azerbaiyán": Azerbaiyán,
        "--bambara": Ñe'ẽpoty, //b
        "--vasco": Vasco, .
        "--belaruso": Bielorruso,
        "--bengali": Bengali, .
        "--bhojpuri": Ñe'ẽpoty ñe'ẽpoty,
        "--bosnio": Bosnio,
        "--búlgaro": Búlgaro,
        "--catalán": Catalán, //c
        "--cebuano": Ñe'ẽ guarani,
        "--chichewa": Chichewa,
        "--chinoSimplificado": Chino (Simplificado),
        "--chinoTradicional": Chino (Tradicional), .
        "--corsicano": Córsico, .
        "--croata": Kroata, .
        "--checo": Checo,
        "--danés": Danés, //d
        "--hivehi": Ñe'ẽ guarani,
        "--dogri": Ñe'ẽ guarani,
        "--holandés": Holandés, .
        "--guaraní": Guarani, //e
        "--esperanto": Ñe'ẽ guarani,
        "--estoniano": Estonia,
        "--ovecha": Ovecha, .
        "--filipino": filipino, //f
        "--finlandés": Finlandés,
        "--francés": Francés,
        "--frisiano": Frisiano,
        "--galiciano": Galicia, //g
        "--georgiano": georgiano,
        "--alemán": Alemán,
        "--griego": Griego,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--Creollo haitiano": criollo haitiano, //h
        "--hausa": Hausa,
        "--hawaiano": Hawaiano,
        "--hebreo": Hebreo,
        "--hindi": Ñe'ẽ guarani,
        "--hmong": Hmong, .
        "--húngaro": Húngaro,
        "--islandés": islandés, //i
        "--igbo": Igbo, .
        "--ilocano": Ñe'ẽ guarani,
        "--indonesio": Indonesio,
        "--irlandés": Irlandés, .
        "--italiano": Italiano,
        "--japonés": Japonés, //j
        "--javanés": Javañe'ẽ,
        "--kannada": Kannada, //k
        "--kazajo": Kazajo, 1999.
        "--khmer": Khmer, 1999-pe.
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Ñe'ẽñemi,
        "--coreano": Coreano,
        "--krio": Krio, 1999.
        "--kurdishKurmanji": kurdo (Kurmanji),
        "--kurdishSorani": kurdo (sorani),
        "--kirguís": Kirguis,
        "--lao": Lao, //l
        "--latín": latín,
        "--letón": Letonia, .
        "--lingala": Ñe'ẽ guarani,
        "--lituano": Lituano,
        "--luganda": Ñe'ẽ guarani,
        "--luxemburgo": Luxemburgo,
        "--macedonia": Macedonia, //m
        "--maithili": Ñe'ẽ guarani,
        "--malagasy": Malgasy,
        "--malay": Malayo, .
        "--malayalam": Malayalam,
        "--malta": Malta,
        "--maori": Maorí,
        "--marathi": marathi,
        "--meiteilonManipuri": Ñe'ẽ guarani (Manipuri),
        "--mizo": Mizo,
        "--mongol": Mongol, .
        "--myanmarBirmañe'ẽ": Myanmar (Birmañe'ẽ),
        "--nepalí": Nepalí, //n
        "--norruego": Noruega,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Ñe'ẽ guarani,
        "--pasto": Pashto, //pág
        "--persa": Persa,
        "--pulido": Polaco, .
        "--portugués": Portugués,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romano": Rumano, //r
        "--ruso": Ruso,
        "--samoano": Samoano, //s
        "--sánscrito": sánscrito,
        "--scotsGaélic": Escocia gaélico,
        "--sepedi": Ñe'ẽ guarani,
        "--serbio": Serbio,
        "--sesotho": Ñe'ẽ guarani,
        "--shona": Ñe'ẽ guarani,
        "--sindhi": Sindhi, 1999.
        "--sinhala": Ñe'ẽpoty ñe'ẽpoty, .
        "--eslovaco": Eslovaco,
        "--esloveno": Esloveno,
        "--somali": Somalí, .
        "--español": Castellano,
        "--sundano": Sundano, .
        "--swahili": Swahili, .
        "--sueco": Sueco,
        "--tajik": Tajik, //t
        "--tamil": Tamil, .
        "--tatar": Tatar, .
        "--telugu": Telugu,
        "--tailandés": Tailandés,
        "--tigrinya": Ñe'ẽ guarani,
        "--tsonga": Ñe'ẽpoty, .
        "--turco": Turco,
        "--turkmen": Turkmen,
        "--twi": Ñe'ẽ guarani,
        "--ucraniano": Ucraniano, //u
        "--urdu": Urdu, .
        "--uyghur": Uyghur, .
        "--uzbek": Uzbek,
        "--vietnamés": vietnami, //v
        "--galés": Galés, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // **gujarati
      // **gujarati
      gujarati: {
        translations: {
          "--an error has occurred": "એક ભૂલ આવી છે!", //a
          "--address": "સરનામાં",
          "--advice": "સલાહ",
          "--by clicking on continue": "ચાલુ રાખવા પર ક્લિક કરવાથી તમે તમારા Veil Brillant એકાઉન્ટથી ડિસ્કનેક્ટ થઈ જશો", //b
          "--by clicking on disconnect you will be disconnected": "ડિસ્કનેક્ટ પર ક્લિક કરવાથી તમે તમારા izocash એકાઉન્ટમાંથી ડિસ્કનેક્ટ થઈ જશો",
          "--check your virtual number or try again later": "તમારો વર્ચ્યુઅલ નંબર તપાસો અથવા પછીથી ફરી પ્રયાસ કરો", //c
          "--check your virtual number": "તમારો વર્ચ્યુઅલ નંબર તપાસો",
          "--continue": "ચાલુ રાખો",
          "--connection": "જોડાણ",
          "--collaborate, live in harmony": "સહયોગ કરો, અન્ય લોકો સાથે સુમેળમાં રહો",
          "--choose language": "વર્ચ્યુઅલ ફોન ભાષા",
          "--don't prevent competition": "સ્પર્ધાને અટકાવશો નહીં, દરેકને તક આપો", //d
          "--disconnection": "ડિસ્કનેક્શન",
          "--for all virtual phone users": "બધા વર્ચ્યુઅલ ફોન વપરાશકર્તાઓ માટે, VPN નો ઉપયોગ કરવાની ભલામણ કરવામાં આવે છે", //f
          "--go to login page": "લોગિન પૃષ્ઠ પર જાઓ", //g
          "--historical": "ઐતિહાસિક", //h

           "--મારું ખાતું છે": મારી પાસે પહેલેથી જ એક ખાતું છે, //i
           "--મારી પાસે ખાતું નથી": મારી પાસે ખાતું નથી,
           "-તે તમારું ઘર છે": તે તમારું ઘર છે,
           "--છબી / વિડિઓ +": છબી / વિડિઓ +,
           "--ઓળખની ચકાસણી": ઓળખ ચકાસણી,
           "--izocash ગ્રાહક પોર્ટલ": izocash ગ્રાહક પોર્ટલ,
           "--ઓળખ દર વર્ષે અપડેટ": દર વર્ષે ઓળખ અપડેટ,
           "--izocash buy to": izocash Buy => izocash આંતરરાષ્ટ્રીય,
           "--લોગ ઇન": લોગ ઇન!, //l
           "--login": લોગ ઇન,
           "--લૉગિન ટુ વેઇલ બ્રિલિયન્ટ": વેઇલ બ્રિલન્ટ સાથે કનેક્ટ કરો,
           "--વિક્સિનોલ સ્ટોર પર લોગિન કરો": વિક્સિનોલ સ્ટોરથી કનેક્ટ કરો,
           "-તમારા વીલ બ્રિલન્ટ એકાઉન્ટમાં મફતમાં લોગિન કરો": આ સુવિધાને ઍક્સેસ કરવા માટે તમારા વીલ બ્રિલન્ટ એકાઉન્ટમાં મફતમાં લોગ ઇન કરો,
           "--લૉગિન સફળતા": લૉગિન સફળ!,
           "--login now": હમણાં લોગ ઇન કરો!,
           "--logout success": લોગઆઉટ સફળ!,
           "--લોગ આઉટ": લોગઆઉટ,
           "--logout": લોગ આઉટ,
           "--નંબર": નંબર, //n
           "--નામ": નામ,
           "--હવે લોગ ઇન કરો": હવે, લોગ ઇન કરો!,
           "--સ્પર્ધાને દબાવવા પર પ્રતિબંધ નથી":
           "--કોઈ ઈર્ષ્યા નથી, દ્વેષ નથી": કોઈ ઈર્ષ્યા નથી, દ્વેષ નથી, કોઈ વિભાજન નથી,
           "--ના": ના,
           "--તમારા વર્ચ્યુઅલ ફોનને ઍક્સેસ કરવા માટેના સત્તાવાર સરનામાં": તમારા વર્ચ્યુઅલ ફોનને ઍક્સેસ કરવા માટેના સત્તાવાર સરનામાં, //o
           "--password": પાસવર્ડ, //p
           "--પોઈન્ટ્સ ઉપાડ izocash": પોઈન્ટ્સ ઉપાડ izocash,
           "--પોઈન્ટ્સ ઉપાડ": પોઈન્ટ્સ ઉપાડ,
           "--પ્રાધાન્યમાં, vpn નો ઉપયોગ કરો": પ્રાધાન્યમાં, એવા VPN નો ઉપયોગ કરો જે તમારા ઇન્ટરનેટ સેવા પ્રદાતા સાથે સંબંધિત ન હોય,
           "--સતત હંમેશા વળતર આપે છે": દ્રઢતા હંમેશા અંતે પરિણામ આપે છે,
           "--નિયમ": નિયમો, //r
           "--recommendation": ભલામણો,
           "--registration": નોંધણી,
           "--signup to veil brillant": Veil Brillant પર નોંધણી કરો, //s
           "--વિક્સિનોલ સ્ટોર પર સાઇન અપ કરો": વિક્સિનોલ સ્ટોર પર નોંધણી કરો,
           "--સાઇનઅપ": નોંધણી કરો,
           "--સાઇનઅપ સફળતા": નોંધણી સફળ!,
           "--મફત સાઇનઅપ કરો": મફતમાં નોંધણી કરો,
           "--સાઇનઅપ સફળતા IA": કનેક્શન સફળ",
           "--settings": "સેટિંગ્સ",
           "--અલરાની એપ્લિકેશન સેટ કરવી": અલરાની એપ્લિકેશનને ગોઠવવી,
           "--izocash એપ્લિકેશન સેટ કરવી": izocash એપ્લિકેશનને ગોઠવવી,
           "--વિક્સિનોલ એપ્લિકેશન સેટ કરવી": વિક્સિનોલ એપ્લિકેશનને ગોઠવવી,
           "--વેઇલ બ્રિલન્ટ એપ્લિકેશનને સેટ કરવી": વીલ બ્રિલન્ટ એપ્લિકેશનને ગોઠવવી,
           "--ચિત્રો, વિડીયોનો સંગ્રહ": છબીઓ, વિડીયો અને અન્ય કેટલાક ઘટકોનો સંગ્રહ,
           "--રિસેપ્શનની ઝડપ": ડેટાસેન્ટરમાંથી ડેટાના રિસેપ્શનની ઝડપ,
           "--speed": ઝડપ,
           "--ટર્મિનેટ": સમાપ્ત કરો, //t
           "--vpn તમને ઍક્સેસ કરવાની મંજૂરી આપે છે": VPN તમને તમારા ઇન્ટરનેટ સેવા પ્રદાતાએ બ્લેકલિસ્ટ કરેલી સાઇટ અથવા એપ્લિકેશનને ઍક્સેસ કરવાની મંજૂરી આપે છે,
           "--સૌથી મોટું વૃક્ષ ઉપર હતું": સૌથી મોટું વૃક્ષ એક સાદા નાના બીજની ઉપર હતું,
           "-સ્ક્રીનને ટચ કરો": ચાલુ રાખવા માટે સ્ક્રીનને ટચ કરો,
           "-- try again": ફરી પ્રયાસ કરો!,
           "--username": વપરાશકર્તા નામ, //u

           "--વર્ચ્યુઅલ નંબર": વર્ચ્યુઅલ નંબર, //v
           "--વર્ચ્યુઅલ ફોન સેટિંગ્સ": વર્ચ્યુઅલ ફોન સેટિંગ્સ,
           "--વર્ચ્યુઅલ ફોન ભાષા લાગુ કરવામાં આવી છે": વર્ચ્યુઅલ ફોન ભાષા મૂળભૂત રીતે એપ્લિકેશન સ્તર પર લાગુ થાય છે,
           "--virtual phone": વર્ચ્યુઅલ ફોન,
           "--validate": માન્ય કરો,
           "-- izocash ગ્રાહક પોર્ટલ પર આપનું સ્વાગત છે": izocash ગ્રાહક પોર્ટલ પર આપનું સ્વાગત છે, //w
           "--સુપર કોડ લખો": સુપર કોડ દાખલ કરો,
           "-welcome to": સ્વાગત છે,
           "-જ્યાં લોકોનું ધ્યાન જાય છે": જ્યાં લોકોનું ધ્યાન જાય છે ત્યાં પૈસા જાય છે,
           "--વિજેતાઓ સતત રહે છે": વિજેતાઓ સતત રહે છે,
           "-શું તમે તમારા અલરાની ખાતામાંથી લોગ આઉટ કરવા માંગો છો": શું તમે તમારા અલરાની ખાતામાંથી લોગ આઉટ કરવા માંગો છો?,
           "--હા": હા, //y

           // દેશ
           "--કોંગો": કોંગો બ્રાઝાવિલે,
           "-કેમેરૂન": કેમરૂન,
           "--drc": DRC,
           "--ivoryCoast": આઇવરી કોસ્ટ,

           // ભાષા
        "--આફ્રિકાન્સ": આફ્રિકન્સ, //a
        "--આલ્બેનિયન": અલ્બેનિયન,
        "--amharic": એમ્હારિક,
        "--અરબી": અરબી,
        "--આર્મેનીયન": આર્મેનિયન,
        "--assamese": આસામી,
        "--aymara": આયમારા,
        "--અઝરબૈજાની": અઝરબૈજાની,
        "--બામ્બારા": બમ્બારા, //b
        "--basque": બાસ્ક,
        "--બેલારુસિયન": બેલારુસિયન,
        "--બંગાળી": બંગાળી,
        "--ભોજપુરી": ભોજપુરી,
        "--બોસ્નિયન": બોસ્નિયન,
        "--બલ્ગેરિયન": બલ્ગેરિયન,
        "--catalan": Catalan, //c
        "--સેબુઆનો": સેબુઆનો,
        "--ચિચેવા": ચિચેવા,
        "--chineseSimplified": ચાઇનીઝ (સરળ),
        "--ChineseTraditional": ચાઇનીઝ (પરંપરાગત),
        "--કોર્સિકન": કોર્સિકન,
        "--ક્રોએશિયન": ક્રોએશિયન,
        "--ચેક": ચેક,
        "--danish": ડેનિશ, //d
        "--ધીવેહી": દિવેહી,
        "--ડોગરી": ડોગરી,
        "--ડચ": ડચ,
        "--અંગ્રેજી": અંગ્રેજી, //e
        "--એસ્પેરાન્ટો": એસ્પેરાન્ટો,
        "--એસ્ટોનિયન": એસ્ટોનિયન,
        "--ewe": ઇવે,
        "--ફિલિપિનો": ફિલિપિનો, //f
        "--ફિનિશ": ફિનિશ,
        "--ફ્રેન્ચ": ફ્રેન્ચ,
        "--ફ્રિશિયન": ફ્રિશિયન,
        "--ગેલિશિયન": ગેલિશિયન, //જી
        "--જ્યોર્જિયન": જ્યોર્જિયન,
        "--જર્મન": જર્મન,
        "--ગ્રીક": ગ્રીક,
        "--ગુરાની": ગુરાની,
        "--ગુજરાતી": ગુજરાતી,
        "--haitianCreole": Haitian Creole, //h
        "--હૌસા": હૌસા,
        "--hawaiian": હવાઇયન,
        "--હીબ્રુ": હીબ્રુ,
        "--હિન્દી": હિન્દી,
        "--hmong": Hmong,
        "--હંગેરિયન": હંગેરિયન,
        "--આઇસલેન્ડિક": આઇસલેન્ડિક, //i
        "--igbo": ઇગ્બો,
        "--ilocano": Ilocano,
        "--ઇન્ડોનેશિયન": ઇન્ડોનેશિયન,
        "--આઇરિશ": આઇરિશ,
        "--ઇટાલિયન": ઇટાલિયન,
        "--japanese": જાપાનીઝ, //j
        "--javanese": જાવાનીઝ,
        "--kannada": કન્નડ, //k
        "--કઝાક": કઝાક,
        "--ખ્મેર": ખ્મેર,
        "--કિન્યારવાંડા": કિન્યારવાંડા,
        "--કોંકણી": કોંકણી,
        "--કોરિયન": કોરિયન,
        "--ક્રિઓ": ક્રિઓ,
        "--kurdishKurmanji": કુર્દિશ (કુર્મનજી),
        "--kurdishSorani": કુર્દિશ (સોરાની),
        "--કિર્ગીઝ": કિર્ગીઝ,
        "--lao": લાઓ, //l
        "--લેટિન": લેટિન,
        "--લાતવિયન": લાતવિયન,
        "--લિંગલા": લિંગલા,
        "--લિથુનિયન": લિથુનિયન,
        "--લુગાન્ડા": લુગાન્ડા,
        "--લક્ઝમબર્ગિશ": લક્ઝમબર્ગિશ,
        "--મેસેડોનિયન": મેસેડોનિયન, //m
        "--મૈથિલી": મૈથિલી,
        "--માલાગસી": માલાગાસી,
        "--malay": મલય,
        "--મલયાલમ": મલયાલમ,
        "--માર્ટિસ": માલ્ટિઝ,
        "--માઓરી": માઓરી,
        "--મરાઠી": મરાઠી,
        "--meiteilonManipuri": Meiteilon (મણિપુરી),
        "--મિઝો": મિઝો,
        "--મોંગોલિયન": મોંગોલિયન,
        "--myanmarBurmese": મ્યાનમાર (બર્મીઝ),
        "--નેપાળી": નેપાળી, //n
        "--નોર્વેજિયન": નોર્વેજીયન,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": ઓરોમો,
        "--પશ્તો": પશ્તો, //p
        "--persian": ફારસી,
        "--પોલિશ": પોલિશ,
        "--પોર્ટુગીઝ": પોર્ટુગીઝ,
        "--પંજાબી": પંજાબી,
        "--quechua": Quechua, //q
        "--રોમેનિયન": રોમાનિયન, //r
        "--રશિયન": રશિયન,
        "--સમોઆન": સમોઆન, //s
        "-સંસ્કૃત": સંસ્કૃત,
        "--scotsGaelic": સ્કોટ્સ ગેલિક,
        "--સેપેડી": સેપેડી,
        "--સર્બિયન": સર્બિયન,
        "--સેસોથો": સેસોથો,
        "--શોના": શોના,
        "--સિંધી": સિંધી,
        "--સિંહલા": સિંહલા,
        "--સ્લોવાક": સ્લોવાક,
        "--સ્લોવેનિયન": સ્લોવેનિયન,
        "--સોમાલી": સોમાલી,
        "--સ્પેનિશ": સ્પેનિશ,
        "--સુન્ડેનીઝ": સુન્ડેનીઝ,
        "--સ્વાહીલી": સ્વાહિલી,
        "--swedish": સ્વીડિશ,
        "--તાજિક": તાજિક, //t
        "--તમિલ": તમિલ,
        "--તતાર": તતાર,
        "--તેલુગુ": તેલુગુ,
        "--થાઈ": થાઈ,
        "--ટિગ્રિન્યા": ટાઇગ્રિન્યા,
        "-સોંગા": સોંગા,
        "--ટર્કિશ": ટર્કિશ,
        "--તુર્કમેન": તુર્કમેન,
        "--twi": ટ્વિ,
        "--યુક્રેનિયન": યુક્રેનિયન, //u
        "--urdu": ઉર્દુ,
        "--ઉઇગુર": ઉઇગુર,
        "--ઉઝ્બેક": ઉઝ્બેક,
        "--વિયેતનામીસ": વિયેતનામીસ, //v
        "--welsh": વેલ્શ, //w
        "--xhosa": ઢોસા, //x
        "--yiddish": યિદ્દિશ, //y
        "--yoruba": યોરૂબા,
        "--ઝુલુ": ઝુલુ, //z
        },
      },

      // haitianCreole
      // haitianCreole
      haitianCreole: {
        translations: {
           "--an error has occurred": "Yon erè te fèt!", //a
           "--address": "Adrès",
           "--advice": "Konsèy",
           "--by clicking on continue": "Lè w klike sou kontinye, w ap dekonekte ak kont Veil Brillant ou", //b
           "--by clicking on disconnect you will be disconnected": "Lè w klike sou dekonekte w ap dekonekte ak kont izocash ou a",
           "--check your virtual number or try again later": "tcheke nimewo vityèl ou oswa eseye ankò pita", //c
           "--check your virtual number": "Tcheke nimewo vityèl ou a",
           "--continue": "Kontinye",
           "--connection": "Koneksyon",
           "--collaborate, live in harmony": "Kolabore, viv an amoni ak lòt moun",
           "--choose language": "Lang nan telefòn vityèl",
           "--don't prevent competition": "Pa anpeche konpetisyon, bay tout moun yon chans", //d
           "--disconnection": "Dekoneksyon",
           "--for all virtual phone users": "Pou tout itilizatè Virtual Phone, li rekòmande pou itilize yon VPN", //f
           "--go to login page": "Ale nan paj login", //g
           "--historical": "Istorik", //h

          

           "--mwen gen kont": Mwen deja gen yon kont, //i
           "--mwen pa gen kont": mwen pa gen yon kont,
           "--se kay ou": se kay ou,
           "--image / video +": Imaj / Videyo +,
           "--identity verification": Verifikasyon idantite,
           "--izocash pòtal kliyan": izocash pòtal kliyan,
           "--identity update every year": Mizajou idantite chak ane,
           "--izocash achte pou": izocash Buy => izocash entènasyonal,
           "--log in": Konekte!, //l
           "--login": konekte,
           "--login to veil brilliant": Konekte ak Veil Brillant,
           "--konekte nan magazen vixinol": Konekte nan magazen Vixinol,
           "--konekte gratis sou kont veil Brillant ou a": konekte gratis sou kont Veil Brillant ou pou jwenn aksè nan karakteristik sa a,
           "--login success": Konekte siksè!,
           "--login now": Konekte kounye a!,
           "--logout success": Dekonekte siksè!,
           "--log out": Dekonekte,
           "--logout": Dekonekte,
           "--number": Nimewo, //n
           "--name": Non,
           "--now log in": Koulye a, konekte!,
           "--pa gen okenn entèdiksyon sou konpetisyon toufe":
           "--pa gen jalouzi, pa gen okenn rayi": Pa gen jalouzi, pa gen okenn rayi, pa gen divizyon,
           "--non": Non,
           "--oficial addresses to access your virtual phone": Adrès ofisyèl pou jwenn aksè nan telefòn vityèl ou, //o
           "--password": Modpas, //p
           "--points withdrawals izocash": Pwen retrè izocash,
           "--points withdrawals": Pwen retrè,
           "--preferably, use a vpn": de preferans, sèvi ak yon VPN ki pa fè pati founisè sèvis entènèt ou a,
           "--persistence always pay off": Persistence toujou peye nan fen,
           "--rule": Règ, //r
           "--rekòmandasyon": Rekòmandasyon,
           "--registration": Enskripsyon,
           "--enskri pou veil brilliant": Enskri sou Veil Brillant, //s
           "--enskri nan magazen vixinol": Enskri sou magazen Vixinol,
           "--signup": Enskri,
           "--signup success": Enskripsyon siksè!,
           "--signup for free": Enskri gratis,
           "--enskripsyon siksè IA": Koneksyon siksè",
           "--settings": "Anviwònman",
           "--setting up the alrani app": Konfigirasyon aplikasyon an Alrani,
           "--setting up the izocash app": Konfigirasyon aplikasyon izocash la,
           "--konfigirasyon aplikasyon an vixinol": Konfigirasyon aplikasyon an Vixinol,
           "--setting up the veil Brillant app": Konfigirasyon aplikasyon Veil Brillant la,
           "--storage of images, videos": Depo imaj, videyo ak plizyè lòt eleman,
           "--vitès resepsyon": vitès resepsyon done ki sòti nan Datacenter la,
           "--speed": Vitès,
           "--terminate": Mete fen, //t
           "--vpn a pèmèt ou jwenn aksè": VPN a pèmèt ou jwenn aksè nan yon sit oswa yon aplikasyon ke founisè sèvis entènèt ou a te mete nan lis nwa,
           "--pi gwo pye bwa a te pi wo a": Pi gwo pye bwa a te pi wo a yon senp ti grenn,
           "--manyen ekran an": manyen ekran an pou kontinye,
           "--try again": Eseye ankò!,
           "--username": Non itilizatè, //u

           "--virtual number": Nimewo vityèl, //v
           "--virtual phone settings": Anviwònman telefòn vityèl,
           "--Virtual Phone language is apply": Lang Virtual Phone aplike nan nivo aplikasyon an pa defo,
           "--virtual phone": Telefòn vityèl,
           "--validate": valide,
           "--welcome to the izocash customer portal": Byenveni nan izocash Customer Portal, //w
           "--write a super code": Antre yon super kòd,
           "--welcome to": Byenveni nan,
           "--kote atansyon moun ale": Kote atansyon moun ale lajan ale,
           "--winners persevere": Ganyan yo pèsevere,
           "--ou ta renmen dekonekte kont Alrani ou a": Èske ou vle dekonekte kont Alrani ou a?,
           "--wi": Wi, //y

           // peyi
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamewoun,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // lang
        "--afrikaans": Afrikaans, //a
        "--albanian": Albanè,
        "--amharic": Amharic,
        "--arabic": Arab,
        "--armenyen": Amenyen,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaydjan,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarisyen": Belarisyen,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnyen,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Chinwa (Senplifye),
        "--chineseTraditional": Chinwa (Tradisyonèl),
        "--corsican": kors,
        "--kwoasyen": kwoasyen,
        "--tchèk": Czech,
        "--danish": Danwa, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--olandè": Olandè,
        "--anglè": Angle, //e
        "--esperanto": Esperanto,
        "--estonian": Estonyen,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": Finnish,
        "--franse": franse,
        "--frisian": Frisyen,
        "--galician": Galician, //g
        "--georgian": Jòjyen,
        "--alman": Alman,
        "--grèk": grèk,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Kreyòl ayisyen, //h
        "--hausa": Hausa,
        "--hawaiian": Awayi,
        "--hebrew": Ebre,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Ongwa,
        "--islandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesyen": Endonezyen,
        "--irish": Ilandè,
        "--italian": Italyen,
        "--japonè": Japonè, //j
        "--javanese": javanèz,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--Korean": Koreyen,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": Latvian,
        "--lingala": Lingala,
        "--lithuanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--masedonyen": Masedwan, //m
        "--maithili": Maithili,
        "--malgasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolyen,
        "--myanmarBurmese": Myanma (Birma),
        "--nepali": Nepali, //n
        "--norwegian": Nòvejyen,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--pèsan": Pèsik,
        "--polish": Polonè,
        "--pòtigè": Pòtigè,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--ris": Ris,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--sèb": Sèb,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--sloveni": Sloveni,
        "--somali": Somali,
        "--spanyòl": Panyòl,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedwa": Swedish,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--tik": Tik,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ukrainian, //u
        "--urdu": Oudou,
        "--uyghur": Ouyghur,
        "--uzbek": Ouzbek,
        "--vietnamese": Vyetnamyen, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zoulou, //z
        },
      },

      // hausa
      // hausa
      hausa: {
        translations: {
          "--an error has occurred": "Kuskure ya faru!", //a
          "--address": "adireshi",
          "--advice": "Nasiha",
          "--by clicking on continue": "Ta danna ci gaba za a cire haɗin daga asusun ku na Veil Brillant", //b
          "--by clicking on disconnect you will be disconnected": "Ta danna Disconnect za a katse daga asusun izocash",
          "--check your virtual number or try again later": "Duba lambar kamala ko sake gwadawa daga baya", //c
          "--check your virtual number": "Duba kamannin lambar ku",
          "--continue": "Ci gaba",
          "--connection": "Connection",
          "--collaborate, live in harmony": "Haɗa kai, rayuwa cikin jituwa da wasu",
          "--choose language": "Harshen Waya Mai Kyau",
          "--don't prevent competition": "Kada ku hana gasa, ba kowa dama", //d
          "--disconnection": "Katsewa",
          "--for all virtual phone users": "Ga duk masu amfani da Waya, ana ba da shawarar yin amfani da VPN", //f
          "--go to login page": "Je zuwa shafin shiga", //g
          "--historical": "Tarihi", //h

          "- ina da asusu": Ina da asusu, //i
          "- ba ni da asusu": ba ni da asusu,
          "Gidan ku ne": gidan ku ne,
          "--image / bidiyo +": Hoto / Bidiyo +,
          "--identity verification": Tabbatar da ganewa,
          "--zocash portal abokin ciniki": izocash Abokin ciniki Portal,
          "--identity update kowace shekara": Sabunta asali kowace shekara,
          "--izocash buy to": izocash Buy => izocash na duniya,
          "--shiga": Shiga!, //l
          "--login": Shiga,
          "--login zuwa mayafi mai haske": Haɗa zuwa Veil Brillant,
          "--login zuwa kantin vixinol": Haɗa zuwa Shagon Vixinol,
          "--login for free to your veil Brillant account": Shiga kyauta zuwa asusunka na Veil Brillant don samun damar wannan fasalin,
          "--login nasara": Shiga cikin nasara!,
          "--login now": Shiga yanzu!,
          "--logout nasara": An yi nasara!
          "-- fita": Logout,
          "--logout": fita,
          "--lamba": lamba, //n
          "--name": Suna,
          "--yanzu shiga": Yanzu, Shiga!,
          "--babu haramcin hana gasa":
          "--ba kishi, ba kiyayya": Babu kishi, ba kiyayya, babu rarrabuwa,
          "--ba": ba,
          "--official adiresoshin don samun damar wayar ku ta kama-da-wane": Adireshin hukuma don samun damar wayar ku ta kama-da-wane, //o
          "--password": Kalmar wucewa, //p
          "--points withdrawals izocash": Points janyewar izocash,
          "--points janyewar": Fitar da maki,
          "--zai fi dacewa, yi amfani da vpn": Zai fi dacewa, yi amfani da VPN wanda baya na mai bada sabis na intanit,
          "- Juriya koyaushe yana biya": Juriya koyaushe yana biya a ƙarshe,
          "--mulki": Dokoki, //r
          "--shawarwari": Shawarwari,
          "--rejista": Rajista,
          "--signup to veil brilliant": Yi rijista akan Veil Brillant, //s
          "--signup to vixinol store": Yi rijista akan Shagon Vixinol,
          "--signup": Yi rijista,
          "--nasarawar rajista": An yi nasarar yin rijista!,
          "--signup for free": Yi rijista kyauta,
          "--Nasarar rajista IA": Nasarar haɗi",
          "--settings": "Settings",
          "--kafa alrani app": Yana daidaita aikace-aikacen Alrani,
          "--kafa izocash app": Yana daidaita aikace-aikacen izocash,
          "--kafa vixinol app": Yana daidaita aikace-aikacen Vixinol,
          "--kafa mayafin Brillant app": Yana daidaita aikace-aikacen Veil Brillant,
          "--ajiya na hotuna, bidiyo": Adana hotuna, bidiyo da wasu abubuwa da yawa,
          "--speed of reception": Gudun karɓar bayanai daga Datacenter,
          "--gudun": Gudun,
          "--terminate": Ƙarshe, //t
          "--vpn yana ba ku damar shiga": VPN yana ba ku damar shiga wani shafi ko aikace-aikacen da mai ba da sabis na intanet ɗin ku ya sanya,
          "- Itace mafi girma tana sama": Itace mafi girma tana saman kowane ɗan ƙaramin iri,
          "--touch the screen": Taba allon don ci gaba,
          "-- gwada sake": sake gwadawa!,
          "--username": Sunan mai amfani, //u

          "--virtual lamba": Virtual lamba, //v
           "--virtual phone settings": Virtual phone settings,
           "--Virtual Phone Language is apply": Ana amfani da Yaren Waya Mai Kyau a matakin aikace-aikace ta tsohuwa,
           "--virtual phone": Virtual phone,
           "--validate": Tabbatarwa,
           "- barka da zuwa tashar abokin ciniki na izocash": Barka da zuwa Portal Abokin Ciniki na izocash, //w
           "--rubuta babban code": Shigar da Super code,
           "--barka da zuwa": Barka da zuwa,
           "- inda hankalin mutane ke tafiya": Inda hankalin mutane ya tafi kudi,
           "--winners persevere": Masu nasara sun daure,
           "-- za ku so ku fita daga asusunku na Alrani": Shin kuna son fita daga asusunku na Alrani?,
           "--iya": iya, //y

           // kasar
           "- Kongo": Kongo Brazzaville,
           "- Kamaru": Kamaru,
           "--dc": DRC,
           "- Ivory Coast": Ivory Coast,

           // harshe
        "--afrikaans": Afrikaans, //a
        "--albaniya": Albaniya,
        "--amharic": Amharic,
        "--larabci": Larabci,
        "--Armenian": Armenian,
        "--assamese": Asalin,
        "--aymara": Aymara,
        "--azabaijan": Azabaijan,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarushiyanci,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosniya": Bosniya,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Sinanci (Sauƙaƙe),
        "--chineseTraditional": Sinanci (Na gargajiya),
        "--Corsican": harshen Corsican,
        "--croatian": Croatian,
        "--Czech": Czech,
        "--Danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Yahudanci": Yaren mutanen Holland,
        "-- Turanci": Turanci, //e
        "--esperanto": Esperanto,
        "--estoniya": Estoniya,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": Finnish,
        "- Faransanci": Faransanci,
        "--frisian": Frisian,
        "--galiciyan": Galiciyan, //g
        "--georgian": Jojin,
        "--Jamus": Jamusanci,
        "--Girkanci": Girkanci,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiyan,
        "--Ibrananci": Ibrananci,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--Hungarian": Hungarian,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--Indonesiyan": Indonesian,
        "- Irish": Irish,
        "- Italiyanci": Italiyanci,
        "--Japanese": Jafananci, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "-konkani": Konkani,
        "--kore": Koriya,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyzstan,
        "--lao": Lao, //l
        "-Latin": Latin,
        "--latvia": Latvia,
        "--lingala": Lingala,
        "--littuanian": Lithuaniyanci,
        "-luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--Masedoniya": Makidoniya, //m
        "--maithili": Maithili,
        "- Malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "-meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "- Norwegian": Yaren mutanen Norway,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "- Persian": Farisa,
        "-- goge": Yaren mutanen Poland,
        "- Portuguese": Portuguese,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--Romaniyanci": Romanian, //r
        "--Russian": Rashanci,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--sloveniya": Sloveniya,
        "--somali": Somaliya,
        "--spanish": Mutanen Espanya,
        "--sundanese": Sundanci,
        "--swahili": Swahili,
        "--swedish": Yaren mutanen Sweden,
        "--tajik": Tajik, //t
        "-tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "-Turkish": Baturke,
        "- Turkmen": Turkmen,
        "--twi": Twi,
        "--Ukrainian": Ukrainian, //u
        "--urdu": Urdu,
        "--uyghur": Uygur,
        "--Uzbek": Uzbek,
        "--Vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // hawaiian
      // hawaiian
      hawaiian: {
        translations: {
           "--an error has occurred": "Ua hewa!", //a
           "--address": "Nā helu wahi",
           "--advice": "Ōlelo Aʻo",
           "--by clicking on continue": "Ma ke kaomi ʻana i ka continue e kāpae ʻia ʻoe mai kāu moʻokāki Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "Ma ke kaomi 'ana i ka Disconnect e hemo 'oe mai kāu mo'okāki izocash",
           "--check your virtual number or try again later": "E nānā i kāu helu virtual a i ʻole e hoʻāʻo hou ma hope", //c
           "--check your virtual number": "E nānā i kāu helu virtual",
           "--continue": "E hoʻomau",
           "--connection": "Hoʻohui",
           "--collaborate, live in harmony": "E hui like, e noho like me kekahi",
           "--choose language": "ʻŌlelo Kelepona Kūikawā",
           "--don't prevent competition": "Mai pale i ka hoʻokūkū, hāʻawi i nā mea a pau i manawa", //d
           "--disconnection": "Wehewehe",
           "--for all virtual phone users": "No nā mea hoʻohana kelepona Virtual āpau, pono e hoʻohana i kahi VPN", //f
           "--go to login page": "E hele i ka palapala komo", //g
           "--historical": "Ka mōʻaukala", //h

          
           "--i loaʻa iaʻu kahi moʻokāki": Ua loaʻa iaʻu kahi moʻokāki, //i
           "--ʻaʻohe aʻu moʻokāki": ʻAʻohe aʻu moʻokāki,
           "--ʻo kou hale ia": ʻo kou hale ia,
           "--kiʻi / wikiō +": Kiʻi / wikiō +,
           "--identity verification": Hōʻoia ʻike,
           "--izocash customer portal": izocash Customer Portal,
           "--identity update every year": Hōʻike ʻike i kēlā me kēia makahiki,
           "--izocash kūʻai iā": izocash Buy => izocash international,
           "--log in": E komo!, //l
           "--login": E komo,
           "--login to veil brilliant": Hoʻohui iā Veil Brillant,
           "--login to vixinol store": Hoʻohui i ka hale kūʻai Vixinol,
           "--login for free to your veil Brillant account": E komo manuahi i kāu moʻokāki Veil Brillant no ke komo ʻana i kēia hiʻohiʻona,
           "--login success": Ua holomua ke komo ʻana!,
           "--login now": E komo i kēia manawa!,
           "--logout success": Ua lanakila ka puka ʻana!,
           "--log out": Haʻalele,
           "--logout": E puka i waho,
           "--helu": Helu, //n
           "--name": inoa,
           "--now log in": Ano, E komo!,
           "--ʻaʻole pāpā i ka hoʻokūkū hoʻokūkū":
           "--no jealousy, no hatred": ʻAʻohe lili, ʻaʻohe inaina, ʻaʻohe māhele,
           "--ʻaʻole": ʻAʻole,
           "--official addresses to access your virtual phone": Nā helu kūhelu no ke kiʻi ʻana i kāu kelepona virtual, //o
           "--password": ʻŌlelo huna, //p
           "--points withdrawals izocash": Hoʻihoʻi i nā helu izocash,
           "--points withdrawals": Hoʻihoʻi i nā helu,
           "--ʻoi aku ka maikaʻi, e hoʻohana i kahi vpn": ʻOi aku ka maikaʻi, e hoʻohana i kahi VPN i pili ʻole i kāu mea lawelawe pūnaewele,
           "--persistence always pays off": ʻO ka hoʻomau mau ka uku i ka hopena,
           "--rule": Rula, //r
           "--recommendation": Manaʻo,
           "--registration": Kakau inoa,
           "--signup to veil brilliant": E kākau inoa ma Veil Brillant, //s
           "--kau inoa i ka hale kūʻai vixinol": E kākau inoa ma ka hale kūʻai Vixinol,
           "--signup": Kakau inoa,
           "--signup success": Ua holomua ke kau inoa!,
           "--signup for free": Kakau no ka manuahi,
           "--signup success IA": Ua holomua ka pilina",
           "--settings": "Nā hoʻonohonoho",
           "--setting up the alrani app": Ka hoʻonohonoho ʻana i ka polokalamu Alrani,
           "--setting up the izocash app": Hoʻonohonoho i ka noi izocash,
           "--setting up the vixinol app": Hoʻonohonoho i ka noi Vixinol,
           "--setting up the veil Brillant app": Hoʻonohonoho i ka palapala Veil Brillant,
           "--storage of images, videos": Ka waiho ʻana o nā kiʻi, wikiō a me nā mea ʻē aʻe,
           "--speed of reception": Ka wikiwiki o ka loaʻa ʻana o ka ʻikepili mai ka Datacenter,
           "--speed": Ka wikiwiki,
           "--terminate": Hoʻopau, //t
           "--ʻae ka vpn iā ʻoe e komo": ʻAe ka VPN iā ʻoe e komo i kahi pūnaewele a i ʻole kahi noi a kāu mea lawelawe pūnaewele i papa inoa ʻeleʻele,
           "--ʻo ka lāʻau nui ma luna": ʻO ka lāʻau nui ma luna o nā mea a pau he hua liʻiliʻi maʻalahi,
           "--touch the screen": Hoʻopā i ka pale e hoʻomau,
           "--try again": E ho'āʻo hou!,
           "--username": inoa hoʻohana, //u

           "--huahelu virtual": Helu pilikua, //v
           "--virtual phone settings": Nā hoʻonohonoho kelepona maʻamau,
           "--virtual Phone language is applied": Hoʻohana ʻia ka ʻōlelo kelepona Virtual ma ka pae noi ma ke ʻano paʻamau,
           "--virtual phone": Kelepona uila,
           "--validate": Hōʻoia,
           "--welcome i ka izocash customer portal": Welina mai i ka izocash Customer Portal, //w
           "--write a super code": E hookomo i ka Super code,
           "--welcome to": Welina mai iā,
           "--where people's attention goes": Kahi e hele ai ka noonoo o kanaka, hele ke dala,
           "--winners persevere": Hoʻomau ka poʻe lanakila,
           "--makemake ʻoe e haʻalele i kāu moʻokāki Alrani": Makemake ʻoe e haʻalele i kāu moʻokāki Alrani?,
           "--ʻae": ʻAe, //y

           // ʻāina
           "--congo": Congo Brazzaville,
           "--cameroon": Kamerona,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // ʻōlelo
        "--afrikaans": ʻApelika, //a
        "--albanian": ʻAlepania,
        "--amharic": Amharic,
        "--arabic": ʻAlapia,
        "--armenian": ʻAmenia,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusian,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnia,
        "--bulgarian": Bulgaria,
        "--catalan": Katalana, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Pākē (Maʻalahi),
        "--chineseTraditional": Pākē (Kuʻuna),
        "--corsican": Koleka,
        "--croatian": Koloa,
        "--czech": Czech,
        "--danish": Denemaka, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Holani,
        "--english": Pelekania, //e
        "--esperanto": Esperanto,
        "--estonian": Estonian,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": Finnish,
        "--french": Palani,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "--german": Kelemānia,
        "--greek": Helene,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": Hebera,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilokano,
        "--indonesian": Inikini,
        "--irish": Irish,
        "--italian": Italia,
        "--japanese": Kepanī, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Kōlea,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latina,
        "--latvian": Latvia,
        "--lingala": Lingala,
        "--lituanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Makedonia, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maleka,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--nowegian": Norewai,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": ʻOromo,
        "--pashto": Pashto, //p
        "--persian": Pelekania,
        "--polish": Polani,
        "--portuguese": Pukiki,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--russian": Lūkini,
        "--samoan": Sāmoa, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Paniolo,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Kuekene,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Tureke,
        "--turkmen": Turkmen,
        "--twi": ʻElua,
        "--ukrainian": Ukrainian, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": ʻōlelo Hawaiʻi, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // **hebrew
      // **hebrew
      hebrew: {
        translations: {
           "--an error has occurred": "אירעה שגיאה!", //a
           "--address": "כתובות",
           "--advice": "עצה",
           "--by clicking on continue": "על ידי לחיצה על המשך תתנתק מחשבון Veil Brillant שלך", //b
           "--by clicking on disconnect you will be disconnected": "בלחיצה על ניתוק תתנתק מחשבון izocash שלך",
           "--check your virtual number or try again later": "בדוק את המספר הווירטואלי שלך או נסה שוב מאוחר יותר", //c
           "--check your virtual number": "בדוק את המספר הווירטואלי שלך",
           "--continue": "המשך",
           "--connection": "חיבור",
           "--collaborate, live in harmony": "שתף פעולה, חי בהרמוניה עם אחרים",
           "--choose language": "שפת טלפון וירטואלי",
           "--don't prevent competition" : "אל תמנע תחרות, תן לכולם צ'אנס", //d
           "--disconnection": "ניתוק",
           "--for all virtual phone users": "לכל משתמשי טלפון וירטואלי, מומלץ להשתמש ב-VPN", //f
           "--go to login page": "עבור לדף ההתחברות", //g
           "--historical": "היסטורי", //h


           
           "--i have account": כבר יש לי חשבון, //i
           "--אין לי חשבון": אין לי חשבון,
           "--זה הבית שלך": זה הבית שלך,
           "--image / video +": תמונה / וידאו +,
           "--identity verification": אימות זהות,
           "--izocash פורטל לקוחות": פורטל לקוחות izocash,
           "--עדכון זהות בכל שנה": עדכון זהות מדי שנה,
           "--izocash buy to": izocash Buy => izocash international,
           "--log in": התחבר!, //l
           "--login": התחבר,
           "--התחבר ל-Veil Brilliant": התחבר ל-Veil Brillant,
           "--התחבר לחנות Vixinol": התחבר לחנות Vixinol,
           "--התחבר בחינם לחשבון Veil Brillant שלך": היכנס בחינם לחשבון Veil Brillant שלך כדי לגשת לתכונה זו,
           "--login success": הכניסה מוצלחת!,
           "--התחבר עכשיו": היכנס עכשיו!,
           "--logout success": היציאה מוצלחת!,
           "--log out": התנתק,
           "--logout": התנתק,
           "--number": מספר, //n
           "--שם שם,
           "--now log in": עכשיו, התחבר!,
           "--אין איסור לחנוק תחרות":
           "--אין קנאה, אין שנאה": אין קנאה, אין שנאה, אין פילוגים,
           "--לא לא,
           "--כתובות רשמיות לגישה לטלפון הוירטואלי שלך": כתובות רשמיות לגישה לטלפון הוירטואלי שלך, //o
           "--password": סיסמה, //p
           "--נקודות משיכות izocash": משיכות נקודות izocash,
           "--משיכות נקודות": משיכת נקודות,
           "--עדיף להשתמש ב-vpn": רצוי להשתמש ב-VPN שאינו שייך לספק שירותי האינטרנט שלך,
           "--התמדה תמיד משתלמת": התמדה תמיד משתלמת בסופו של דבר,
           "--rule": כללים, //r
           "--recommendation": המלצות,
           "--registration": רישום,
           "--הרשמה ל-Veil Brilliant": הירשם ב-Veil Brillant, //s
           "--הרשמה לחנות Vixinol": הירשם בחנות Vixinol,
           "--signup": הרשמה,
           "--signup success": ההרשמה הצליחה!,
           "--הרשמה בחינם": הרשמה בחינם,
           "--signup success IA": החיבור הצליח",
           "--settings": "הגדרות",
           "--setting up the alrani app": הגדרת אפליקציית Alrani,
           "--setting up the izocash app": הגדרת אפליקציית izocash,
           "--setting up the vixinol app": הגדרת היישום Vixinol,
           "--setting up the veil Brillant app": הגדרת אפליקציית Veil Brillant,
           "--אחסון של תמונות, סרטונים": אחסון תמונות, סרטונים ועוד מספר אלמנטים,
           "--speed of קליטה": מהירות קליטה של ​​נתונים ממרכז הנתונים,
           "--speed": מהירות,
           "--terminate": Terminate, //t
           "--ה-vpn מאפשר לך לגשת": ה-VPN מאפשר לך לגשת לאתר או לאפליקציה שספק שירותי האינטרנט שלך הכניס לרשימה השחורה,
           "--העץ הגדול ביותר היה למעלה": העץ הגדול ביותר היה מעל הכל זרע קטן ופשוט,
           "--גע במסך": גע במסך כדי להמשיך,
           "--try again": נסה שוב!,
           "--username": שם משתמש, //u

           "--virtual number": מספר וירטואלי, //v
           "--Virtual phone settings": הגדרות טלפון וירטואלי,
           "--virtual Phone language is used": שפת ה-Virtual Phone מוחלת ברמת היישום כברירת מחדל,
           "--virtual phone": טלפון וירטואלי,
           "--validate": אימות,
           "--ברוכים הבאים לפורטל הלקוחות של izocash": ברוכים הבאים לפורטל הלקוחות של izocash, //w
           "--כתוב קוד על": הזן קוד על,
           "--ברוכים הבאים ל": ברוכים הבאים,
           "--לאן הולכת תשומת הלב של אנשים": לאן תשומת הלב של אנשים הולכת הכסף הולך,
           "--מנצחים מתמידים": המנצחים מתמידים,
           "--האם תרצה להתנתק מחשבון Alrani שלך": האם אתה רוצה להתנתק מחשבון Alrani שלך?,
           "--yes": כן, //y

           // מדינה
           "--קונגו": קונגו ברזוויל,
           "--cameroon": קמרון,
           "--drc": DRC,
           "--ivoryCoast": חוף השנהב,

           // שפה
        "--afrikaans": אפריקאנס, //a
        "--albanian": אלבני,
        "--אמהרית": אמהרית,
        "--ערבית": ערבית,
        "--armenian": ארמנית,
        "--assamese": Assamese,
        "--aymara": אימרה,
        "--אזרביג'אני": אזרבייג'נית,
        "--במברה": במברה, //ב
        "--basque": באסקית,
        "--בלרוסית": בלארוסית,
        "--בנגלית": בנגלית,
        "--בהוג'פורי": בהוג'פורי,
        "--בוסנית": בוסנית,
        "--בולגרית": בולגרית,
        "--catalan": קטלאנית, //c
        "--סבואנו": סבואנו,
        "--צ'יצ'ווה": צ'יצ'ווה,
        "--chineseSimplified": סינית (פשוטה),
        "--chineseTraditional": סינית (מסורתית),
        "--קורסיקאן": קורסיקנית,
        "--קרואטית": קרואטית,
        "--צ'כית": צ'כית,
        "--danish": דנית, //d
        "--dhivehi": Dhivehi,
        "--dogri": דוגרי,
        "--הולנדית": הולנדית,
        "--english": אנגלית, //e
        "--esperanto": אספרנטו,
        "--estonian": אסטונית,
        "--ewe": איווה,
        "--פיליפינו": פיליפינית, //f
        "--פינית": פינית,
        "--צרפתית": צרפתית,
        "--frisian": פריזית,
        "--galician": גליציאנית, //g
        "--ג'ורג'ית": גרוזינית,
        "--גרמן": גרמנית,
        "--גריק": יוונית,
        "--גוארני": גוארני,
        "--גוג'ראטי": גוג'ראטי,
        "--haitianCreole": קריאולי האיטי, //h
        "--hausa": האוסה,
        "--hawaiian": הוואי,
        "--עברית": עברית,
        "--הינדי": הינדי,
        "--המונג": המונג,
        "--הונגרית": הונגרית,
        "--איסלנדית": איסלנדית, //i
        "--igbo": איגבו,
        "--ilocano": Ilocano,
        "--אינדונזית": אינדונזית,
        "--אירית": אירית,
        "--italian": איטלקית,
        "--japanese": יפנית, //j
        "--javanese": ג'אווה,
        "--kannada": קנאדה, //k
        "--קזחית": קזחית,
        "--חמר": חמר,
        "--kinyarwanda": קיניארואנדה,
        "--konkani": Konkani,
        "--קוריאני": קוריאנית,
        "--krio": קריו,
        "--kurdishKurmanji": כורדית (Kurmanji),
        "--kurdishSorani": כורדית (סוראני),
        "--קירגיז": קירגיזית,
        "--lao": לאו, //l
        "--latin": לטינית,
        "--לטבית": לטבית,
        "--lingala": לינגאלה,
        "--ליטאית": ליטאית,
        "--לוגנדה": לוגנדה,
        "--לוקסמבורגיש": לוקסמבורג,
        "--macedonian": מקדונית, //m
        "--maithili": Maithili,
        "--מלגסי": מלגזית,
        "--מאלאי": מלאית,
        "--malayalam": מלאיאלאם,
        "--maltese": מלטזית,
        "--מאורי": מאורי,
        "--marathi": מראטי,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--מיזו": מיזו,
        "--מונגולית": מונגולית,
        "--myanmar בורמזית": מיאנמר (בורמזית),
        "--nepali": נפאלית, //n
        "--נורווגית": נורבגית,
        "--odiaOriya": אודיה (אוריה), //o
        "--oromo": אורומו,
        "--pashto": פשטו, //p
        "--פרסית": פרסית,
        "--פוליש": פולנית,
        "--portuguese": פורטוגזית,
        "--פונג'בי": פונג'בי,
        "--quechua": Quechua, //q
        "--רומנית": רומנית, //r
        "--רוסית": רוסית,
        "--samoan": Samoan, //s
        "--סנסקריט": סנסקריט,
        "--scotsGaelic": גאלית סקוטית,
        "--sepedi": Sepedi,
        "--סרבית": סרבית,
        "--sesotho": ססוטו,
        "--שונה": שונה,
        "--sindhi": סינדי,
        "--sinhala": סינהאלה,
        "--slovak": סלובקית,
        "--סלובנית": סלובנית,
        "--סומלי": סומלי,
        "--ספרדית": ספרדית,
        "--sundanese": סונדני,
        "--swahili": סוואהילי,
        "--שוודית": שוודית,
        "--tajik": טג'יקית, //t
        "--טמיל": טמילית,
        "--טטאר": טטרית,
        "--telugu": טלוגו,
        "--תאי": תאילנדית,
        "--טיגריניה": טיגריניה,
        "--tsonga": צונגה,
        "--טורקית": טורקית,
        "--טורקמן": טורקמנית,
        "--טווי": טווי,
        "--ukrainian": אוקראינית, //u
        "--urdu": אורדו,
        "--uyghur": אויגורי,
        "--uzbek": אוזבקית,
        "--vietnamese": וייטנאמית, //v
        "--welsh": וולשית, //w
        "--xhosa": Xhosa, //x
        "--יידיש": יידיש, //י
        "--יורובה": יורובה,
        "--zulu": זולו, //z
        },
      },*/

      // **hindi
      // **hindi
      hindi: {
        translations: {
          "--an error has occurred": "एक त्रुटि उत्पन्न हुई है!", //a
          "--address": "पते",
          "--advice": "सलाह",
          "--by clicking on continue": "जारी रखें पर क्लिक करके आप अपने वील ब्रिलेंट खाते से डिस्कनेक्ट हो जाएंगे", //b
          "--by clicking on disconnect you will be disconnected": "डिस्कनेक्ट पर क्लिक करने से आप अपने आईज़ोकैश खाते से डिस्कनेक्ट हो जाएंगे",
          "--check your virtual number or try again later": "अपना वर्चुअल नंबर जांचें या बाद में पुनः प्रयास करें", //c
          "--check your virtual number": "अपना वर्चुअल नंबर जांचें",
          "--continue": "जारी रखें",
          "--connection": "कनेक्शन",
          "--collaborate, live in harmony": "सहयोग करें, दूसरों के साथ सद्भाव से रहें",
          "--virtual phone language": "वर्चुअल फ़ोन भाषा",
          "--don't prevent competition": "प्रतिस्पर्धा को न रोकें, सभी को एक मौका दें", //d
          "--disconnection": "डिसकनेक्शन",
          "--for all virtual phone users": "सभी वर्चुअल फ़ोन उपयोगकर्ताओं के लिए VPN, का उपयोग करने की अनुशंसा की जाती है", //f
          "--go to login page": "लॉगिन पेज पर जाएं", //g
          "--historical": "ऐतिहासिक", //h
          "--i have account": "मेरे पास पहले से ही एक खाता है", //i
          "--i don't have account": "मेरे पास कोई खाता नहीं है",
          "--it is your house": "यह आपका घर है",
          "--image / video +": "छवि / वीडियो +",
          "--identity verification": "पहचान सत्यापन",
          "--izocash customer portal": "इज़ोकैश ग्राहक पोर्टल",
          "--identity update every year": "पहचान अद्यतन हर साल",
          "--izocash buy to": "izocash खरीदें => izocash अंतर्राष्ट्रीय",
          "--log in": "लॉग इन करें!", //एल
          "--login": "लॉगिन",
          "--login to veil brillant": "वील ब्रिलेंट से जुड़ें",
          "--login to vixinol store": "विक्सिनोल स्टोर से कनेक्ट करें",
          "--login for free to your veil brillant account": "इस सुविधा तक पहुंचने के लिए अपने वेइल ब्रिलेंट खाते में निःशुल्क लॉग इन करें",
          "--login success": "लॉगिन सफल!",
          "--login now": "अभी लॉग इन करें!",
          "--logout success": "लॉगआउट सफल!",
          "--log out": "लॉगआउट",
          "--logout": "लॉग आउट करें",
          "--number": "संख्या", //n
          "--name": "नाम",
          "--now log in": "अब, लॉग इन करें!",
          "--no ban on stifling competition": "दमघोंटू प्रतिस्पर्धा पर कोई प्रतिबंध नहीं",
          "--no jealousy, no hatred": "कोई ईर्ष्या नहीं, कोई घृणा नहीं, कोई विभाजन नहीं",
          "--no": "नहीं",
          "--official addresses to access your virtual phone": "आपके वर्चुअल फोन तक पहुंचने के लिए आधिकारिक पते", //ओ
          "--password": "पासवर्ड", //पी
          "--points withdrawals izocash": "अंक निकासी इज़ोकैश",
          "--points withdrawals": "अंक निकासी",
          "--preferably, use a vpn": "अधिमानतः, एक ऐसे वीपीएन का उपयोग करें जो आपके इंटरनेट सेवा प्रदाता से संबंधित नहीं है",
          "--persistence always pays off": "दृढ़ता हमेशा अंततः फल देती है",
          "--rule": "नियम", //आर
          "--recommendation": "सिफ़ारिशें",
          "--registration": "पंजीकरण",
          "--signup to veil brillant": "वेइल ब्रिलेंट पर रजिस्टर करें", //एस
          "--signup to vixinol store": "विक्सिनोल स्टोर पर रजिस्टर करें",
          "--signup": "रजिस्टर करें",
          "--signup success": "पंजीकरण सफल!",
          "--signup for free": "निःशुल्क पंजीकरण करें",
          "--signup success IA": "कनेक्शन सफल",
          "--settings": "सेटिंग्स",
          "--setting up the alrani app": "अलरानी एप्लिकेशन को कॉन्फ़िगर करना",
          "--setting up the izocash app": "इज़ोकैश एप्लिकेशन को कॉन्फ़िगर करना",
          "--setting up the vixinol app": "विक्सिनोल एप्लिकेशन को कॉन्फ़िगर करना",
          "--setting up the veil brillant app": "वेइल ब्रिलेंट एप्लिकेशन को कॉन्फ़िगर करना",
          "--storage of images, videos": "छवियों, वीडियो और कई अन्य तत्वों का भंडारण",
          "--speed of reception": "डेटासेंटर से डेटा प्राप्त करने की गति",
          "--speed": "गति",
          "--terminate": "समाप्त करें", //टी
          "--the vpn allows you to access": "वीपीएन आपको उस साइट या एप्लिकेशन तक पहुंचने की अनुमति देता है जिसे आपके इंटरनेट सेवा प्रदाता ने ब्लैकलिस्ट किया है",
          "--the largest tree was above": "सबसे बड़ा पेड़ सबसे ऊपर एक साधारण सा बीज था",
          "--touch the screen": "जारी रखने के लिए स्क्रीन को स्पर्श करें",
          "--try again": "पुनः प्रयास करें!",
          "--username": "उपयोगकर्ता नाम", //u
          "--virtual number": "वर्चुअल नंबर", //v
           "--virtual phone settings": "वर्चुअल फ़ोन सेटिंग्स",
           "--virtual phone language is applied": "वर्चुअल फ़ोन भाषा डिफ़ॉल्ट रूप से एप्लिकेशन स्तर पर लागू होती है",
           "--virtual phone": "आभासी फ़ोन",
           "--validate": "मान्य करें",
           "--welcome to the izocash customer portal": "इज़ोकैश ग्राहक पोर्टल में आपका स्वागत है", //w
           "--write a super code": "एक सुपर कोड दर्ज करें",
           "--welcome to": "आपका स्वागत है",
           "--where people's attention goes": "जहां लोगों का ध्यान जाता है वहां पैसा जाता है",
           "--winners persevere": "विजेता दृढ़ रहते हैं",
           "--would you like to log out of your Alrani account": "क्या आप अपने अलरानी खाते से लॉग आउट करना चाहते हैं?",
           "--yes": "हाँ", //y

           // country
           "--congo": "कांगो ब्रेज़ाविल",
           "--cameroon": "कैमरून",
           "--drc": "डीआरसी",
           "--ivoryCoast": "आइवरी कोस्ट",

           // langues
        "--afrikaans": "अफ़्रीकांस", //ए
        "--albanian": "अल्बानियाई",
        "--amharic": "aअम्हारिक्",
        "--arabic": "अरबी",
        "--armenian": "अर्मेनियाई",
        "--assamese": "असमिया",
        "--aymara": "आयमारा",
        "--azerbaijani": "अज़रबैजानी",
        "--bambara": "बाम्बारा", //बी
        "--basque": "बास्क",
        "--belarusian": "बेलारूसी",
        "--bengali": "बंगाली",
        "--bhojpuri": "भोजपुरी",
        "--bosnian": "बोस्नियाई",
        "--bulgarian": "बल्गेरियाई",
        "--catalan": "कैटलन", //सी
        "--cebuano": "सेबुआनो",
        "--chichewa": "चिचेवा",
        "--chineseSimplified": "चीनी (सरलीकृत)",
        "--chineseTraditional": "चीनी (पारंपरिक)",
        "--corsican": "कोर्सीकन",
        "--croatian": "क्रोएशियाई",
        "--czech": "चेक",
        "--danish": "डेनिश", //डी
        "--dhivehi": "धिवेही",
        "--dogri": "डोगरी",
        "--dutch": "डच",
        "--english": "अंग्रेजी", //ई
        "--esperanto": "एस्पेरान्तो",
        "--estonian": "एस्टोनियाई",
        "--ewe": "ईवे",
        "--filipino": "फिलिपिनो", //एफ
        "--finnish": "फिनिश",
        "--french": "फ़्रेंच",
        "--frisian": "फ़्रिसियाई",
        "--galician": "गैलिशियन", //जी
        "--georgian": "जॉर्जियाई",
        "--german": "जर्मन",
        "--greek": "ग्रीक",
        "--guarani": "गुआरानी",
        "--gujarati": "गुजराती",
        "--haitianCreole": "हाईटियन क्रियोल", //एच
        "--hausa": "हौसा",
        "--hawaiian": "हवाईयन",
        "--hebrew": "हिब्रू",
        "--hindi": "हिन्दी",
        "--hmong": "हमोंग",
        "--hungarian": "हंगेरियन",
        "--icelandic": "आइसलैंडिक", //i
        "--igbo": "इग्बो",
        "--ilocano": "इलोकानो",
        "--indonesian": "इंडोनेशियाई",
        "--irish": "आयरिश",
        "--italian": "इतालवी",
        "--japanese": "जापानी", //जे
        "--javanese": "जावानीस",
        "--kannada": "कन्नड़", //k
        "--kazakh": "कज़ाख",
        "--khmer": "खमेर",
        "--kinyarwanda": "किन्यारवांडा",
        "--konkani": "कोंकणी",
        "--korean": "कोरियाई",
        "--krio": "क्रियो",
        "--kurdishKurmanji": "कुर्दिश (कुरमानजी)",
        "--kurdishSorani": "कुर्दिश (सोरानी)",
        "--kyrgyz": "किर्गिज़",
        "--lao": "Lao", //एल
        "--latin": "लैटिन",
        "--latvian": "लातवियाई",
        "--lingala": "लिंगला",
        "--lithuanian": "लिथुआनियाई",
        "--luganda": "लुगांडा",
        "--luxembourgish": "लक्ज़मबर्गिश",
        "--macedonian": "मैथिली",
        "--maithili": "मालागासी",
        "--malagasy": "मलय",
        "--malay": "मलयालम",
        "--malayalam": "माल्टीज़",
        "--maltese": "माओरी",
        "--maori": "मराठी",
        "--marathi": "मेइतेइलोन (मणिपुरी)",
        "--mizo": "मिज़ो",
        "--mongolian": "मंगोलियाई",
        "--myanmarBurmese": "म्यांमार (बर्मी)",
        "--nepali": "नेपाली", //एन
        "--norwegian": "नार्वेजियन",
        "--odiaOriya": "उड़िया (उड़िया)", //ओ
        "--oromo": "ओरोमो",
        "--pashto": "पश्तो", //p
        "--persian": "फ़ारसी",
        "--polish": "पोलिश",
        "--portuguese": "पुर्तगाली",
        "--punjabi": "पंजाबी",
        "--quechua": "क्वेशुआ", //क्यू
        "--romanian": "रोमानियाई", //आर
        "--russian": "रूसी",
        "--samoan": "सामोन", //एस
        "--sanskrit": "संस्कृत",
        "--scotsGaelic": "स्कॉट्स गेलिक",
        "--sepedi": "सेपेडी",
        "--serbian": "सर्बियाई",
        "--sesotho": "सेसोथो",
        "--shona": "शोना",
        "--sindhi": "सिंधी",
        "--sinhala": "सिंहल",
        "--slovak": "स्लोवाक",
        "--slovenian": "स्लोवेनियाई",
        "--somali": "सोमाली",
        "--spanish": "स्पैनिश",
        "--sundanese": "सुंडानीज़",
        "--swahili": "स्वाहिली",
        "--swedish": "स्वीडिश",
        "--tajik": "ताजिक", //टी
        "--tamil": "तमिल",
        "--tatar": "तातार",
        "--telugu": "तेलुगु",
        "--thai": "थाई",
        "--tigrinya": "तिग्रीन्या",
        "--tsonga": "सोंगा",
        "--turkish": "तुर्की",
        "--turkmen": "तुर्कमेन",
        "--twi": "ट्वी",
        "--ukrainian": "यूक्रेनी", //यू
        "--urdu": "उर्दू",
        "--uyghur": "उइघुर",
        "--uzbek": "उज़्बेक",
        "--vietnamese": "वियतनामी", //v
        "--welsh": "वेल्श", //डब्ल्यू
        "--xhosa": "Xhosa", //x
        "--yiddish": "येहुदी", //य
        "--yoruba": "योरूबा",
        "--zulu": "ज़ुलु", //z
        },
      },

      // **hmong
      // **hmong
      /*hmong: {
        translations: {
           "--an error has occurred": "Ib qho yuam kev tau tshwm sim!", //a
           "--address": "Chaw nyob",
           "--advice": "Lus qhia",
           "--by clicking on continue": "Los ntawm txhaj rau txuas ntxiv koj yuav raug txiav tawm ntawm koj tus account Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "Los ntawm txhaj rau Disconnect koj yuav raug txiav tawm ntawm koj tus account izocash",
           "--check your virtual number or try again later": "Tshawb xyuas koj tus lej virtual lossis sim dua tom qab", //c
           "--check your virtual number": "Tshawb xyuas koj tus lej virtual",
           "--continue": "Txuas ntxiv",
           "--connection": "kev sib txuas",
           "--collaborate, live in harmony": "Sib koom, nyob sib haum xeeb nrog lwm tus",
           "--choose language": "Virtual Phone Language",
           "--don't prevent competition": "Tsis txhob tiv thaiv kev sib tw, muab sijhawm rau txhua tus", //d
           "--disconnection": "disconnection",
           "--for all virtual phone users": "Rau txhua tus neeg siv xov tooj Virtual, nws raug nquahu kom siv VPN", //f
           "--go to login page": "Mus rau nplooj ntawv nkag", //g
           "--historical": "Keeb kwm", //h

           "--i have account": Kuv twb muaj tus account, //i
           "--Kuv tsis muaj tus account": Kuv tsis muaj tus account,
           "--nws yog koj lub tsev": nws yog koj lub tsev,
           "--image / video +": Duab / Video +,
           "--identity verification": Kev txheeb xyuas tus kheej,
           "--izocash neeg siv khoom portal": izocash Cov neeg siv khoom Portal,
           "--identity update every year": Tus kheej hloov tshiab txhua xyoo,
           "--izocash yuav": izocash Yuav => izocash thoob ntiaj teb,
           "--log in": Nkag mus!, //l
           "--login": Nkag mus,
           "--login to veil brilliant": Txuas rau Veil Brillant,
           "--login to vixinol store": Txuas rau Vixinol Store,
           "--login pub dawb rau koj daim ntaub thaiv Brillant account": Nkag mus rau hauv koj tus account Veil Brillant kom nkag mus rau qhov no,
           "--login success": Nkag mus ua tiav!,
           "--login now": Nkag mus tam sim no!,
           "--logout Success": Logout tiav!,
           "--logout": logout,
           "--logout": Log out,
           "--num": Number, //n
           "--npe": npe,
           "--tam sim no nkag rau hauv": Tam sim no, Nkag mus!,
           "--tsis txwv rau kev sib tw stifling":
           "--tsis muaj kev khib, tsis muaj kev ntxub ntxaug": Tsis muaj kev khib, tsis muaj kev ntxub ntxaug, tsis muaj kev sib cais,
           "--tsis": Tsis yog,
           "--chaw nyob rau nkag mus rau koj lub xov tooj virtual": Cov chaw nyob hauv koj lub xov tooj virtual, //o
           "--password": Tus password, //p
           "--points rho tawm izocash": Cov ntsiab lus rho tawm izocash,
           "--points rho tawm": Cov ntsiab lus rho tawm,
           "--zoo dua, siv vpn": Zoo dua, siv VPN uas tsis yog rau koj tus neeg muab kev pabcuam hauv internet,
           "--persistence ib txwm them tawm": Persistence ib txwm them tawm thaum kawg,
           "--rule": Cov cai, //r
           "--recommendation": Cov lus pom zoo,
           "--registration": Sau npe,
           "--signup rau daim ntaub thaiv ci ntsa iab": Sau npe ntawm Veil Brillant, //s
           "--signup to vixinol store": Sau npe ntawm Vixinol Store,
           "--signup": Sau npe,
           "--signup Success": Sau npe ua tiav!,
           "--signup for free": Sau npe pub dawb,
           "--signup Success IA": Kev sib txuas ua tiav",
           "--settings": "Settings",
           "-- teeb tsa lub alrani app": Configuring Alrani daim ntawv thov,
           "-- teeb tsa izocash app": Kev teeb tsa daim ntawv thov izocash,
           "-- teeb tsa lub vixinol app": Configuring Vixinol daim ntawv thov,
           "-- teeb tsa daim ntaub thaiv Brillant app": Kev teeb tsa daim ntaub thaiv npog Brillant daim ntawv thov,
           "--cia cov duab, yeeb yaj duab": Cia cov duab, yeeb yaj duab thiab ob peb lwm yam,
           "--ceev ntawm kev txais tos": Kev ceev ntawm kev txais cov ntaub ntawv los ntawm Datacenter,
           "--speed": Ceev,
           "--terminate": Teem caij, //t
           "--vpn tso cai rau koj nkag mus": Lub VPN tso cai rau koj nkag mus rau lub vev xaib lossis ib daim ntawv thov uas koj tus neeg muab kev pabcuam hauv internet tau teev npe dub,
           "-- tsob ntoo loj tshaj plaws yog saum toj no": tsob ntoo loj tshaj plaws yog cov noob me me,
           "--kov lub vijtsam": kov lub vijtsam txuas ntxiv,
           "--sim dua": Sim dua!,
           "--username": Tus neeg siv lub npe, //u

           "--virtual number": tus lej virtual, //v
           "--virtual phone settings": Virtual phone settings,
           "--virtual Phone language is application": Cov lus Xov tooj Virtual yog siv rau ntawm qib kev thov los ntawm lub neej ntawd,
           "--virtual phone": Xov tooj Virtual,
           "--validate": validate,
           "--zoo siab txais tos rau izocash cov neeg siv khoom portal": Zoo siab txais tos rau izocash Customer Portal, //w
           "--sau tus lej super": Sau tus lej super,
           "--welcome to": Zoo siab txais tos,
           "--qhov twg neeg txoj kev xav mus": Qhov twg tib neeg txoj kev mloog mus nyiaj mus,
           "--winners persevere": Cov yeej ua siab ntev,
           "--koj puas xav tawm ntawm koj tus lej Alrani": Koj puas xav tawm ntawm koj tus lej Alrani?,
           "--yes": Yog, //y

           // lub teb chaws
           "--congo": Congo Brazzaville, UA
           "--cameroon": zoo siab nrog rau ib qho ntawm cov nplooj Facebook tshaj plaws hauv Cameroon!
           "--drc": DRC,
           "--ivoryCoast": Ivory ntug dej hiav txwv,

           // lus
        "--afrikaans": Afrikaans, //a
        "--albanian": Albanian,
        "--amharic": Amharic,
        "--Arabic": Arabic,
        "--Armenian": Armenian,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--Azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--Belarusian": Belarusian,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnian,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Suav teb,
        "--txoj kev": Chichewa,
        "--chineseSimplified": Suav (Simplified),
        "--chineseTraditional": Suav (Traditional),
        "--corsican": Corsican,
        "--croatian": Croatian,
        "--czech": Czech,
        "--danish": Danish, //d
        "--Dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Dutch,
        "--english": English, //e
        "--esperanto": Esperanto,
        "--estonian": Estonian,
        "---": Aw,
        "--filipino": Filipino, //f
        "--finnish": Finnish,
        "--french": Fabkis,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--Georgian": Georgian,
        "-- German": German,
        "--greek": Greek,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--Hawaiian": Hawaiian,
        "--hebrew": Hebrew,
        "--hindi": Hindi,
        "--hmong": hmoob,
        "--hungarian": Hungarian,
        "--icelandic": Icelandic, //i
        "--ib": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": Indonesian,
        "--Irish": Irish,
        "--Italian": Italian,
        "--japanese": Japanese, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khoom": Khmer,
        "--kev hlub": Kev hlub,
        "--Konkani": Kev,
        "--korean": Korean,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "-- Latin": Latin,
        "--latvian": Latvian,
        "--lingala": Lingala,
        "--lithuanian": Lithuanian,
        "--lus": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Macedonian, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--miv": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Persian,
        "--polish": Polish,
        "--portuguese": Portuguese,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--russian": lus,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--tso": Sesotho,
        "--xov": Shona,
        "--sinthi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Spanish,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Swedish,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thaib,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsog,
        "--turkish": Turkish,
        "--turkmen": Turkmen,
        "--twi": twi,
        "--ukrainian": Ukrainian, //u
        "--urdu": ua,
        "--yghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Nyab Laj, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // hungarian
      // hungarian
      hungarian: {
        translations: {
          "--an error has occurred": "Hiba történt!", //a
          "--address": "címek",
          "--advice": "Tanács",
          "--by clicking on continue": "A tovább gombra kattintva megszakad Veil Brillant-fiókjától", //b
          "--by clicking on disconnect you will be disconnected": "A Leválasztás gombra kattintva megszakad az izocash-fiókja",
          "--check your virtual number or try again later": "Ellenőrizze a virtuális számot, vagy próbálkozzon újra később", //c
          "--check your virtual number": "Ellenőrizze a virtuális számot",
          "--continue": "Folytatás",
          "--connection": "kapcsolat",
          "--collaborate, live in harmony": "Együttműködj, élj harmóniában másokkal",
          "--choose language": "Virtuális telefon nyelve",
          "--don't prevent competition": "Ne akadályozza meg a versenyt, adjon esélyt mindenkinek", //d
          "--disconnection": "leválasztás",
          "--for all virtual phone users": "Minden virtuális telefon felhasználó számára javasolt VPN használata", //f
          "--go to login page": "Ugrás a bejelentkezési oldalra", //g
          "--historical": "Történelmi", //h

           "--i have account": Már van fiókom, //i
           "--nincs fiókom": Nincs fiókom,
           "--ez a te házad": ez a te házad,
           "--image / video +": Kép / Videó +,
           "--identity verification": személyazonosság ellenőrzése,
           "--izocash ügyfélportál": izocash ügyfélportál,
           "--identity update every year": Identity update every year,
           "--izocash buy to": izocash Buy => izocash nemzetközi,
           "--log in": Bejelentkezés!, //l
           "--login": Bejelentkezés,
           "--login to veil brilliant": Csatlakozás a Veil Brillanthoz,
           "--login to Vixinol Store": Csatlakozás a Vixinol Store-hoz,
           "--bejelentkezés ingyen a veil Brillant fiókjába": Jelentkezzen be ingyenesen Veil Brillant fiókjába a funkció eléréséhez,
           "--bejelentkezés sikeres": Sikeres bejelentkezés!,
           "--login now": Jelentkezzen be most!,
           "--kijelentkezés sikeres": Sikeres kijelentkezés!,
           "--log out": Kijelentkezés,
           "--logout": Kijelentkezés,
           "--szám": Szám, //n
           "--name": Név,
           "--now log in": Most, jelentkezzen be!,
           "--nincs tilalom a verseny elfojtására":
           "--nincs féltékenység, nincs gyűlölet": Nincs féltékenység, nincs gyűlölet, nincs megosztottság,
           "--nem nem,
           "--hivatalos címek a virtuális telefon eléréséhez": Hivatalos címek a virtuális telefon eléréséhez, //o
           "--password": Jelszó, //p
           "--pontok visszavonása izocash": Pontkivonás izocash,
           "--pontok visszavonása": Pontok visszavonása,
           "--lehetőleg használj vpn-t": Lehetőleg olyan VPN-t használj, amely nem az internetszolgáltatódhoz tartozik,
           "--a kitartás mindig kifizetődik": A kitartás mindig kifizetődik a végén,
           "--rule": Szabályok, //r
           "--recommendation": Ajánlások,
           "--regisztráció": Regisztráció,
           "--signup to veil brilliant": Regisztráljon a Veil Brillant, //s
           "--regisztráció a vixinol boltba": Regisztráció a Vixinol Store-ban,
           "--signup": Regisztráció,
           "--regisztráció sikeres": Sikeres regisztráció!,
           "--regisztráció ingyen": Ingyenes regisztráció,
           "--regisztráció sikeres IA": Sikeres csatlakozás",
           "--settings": "Beállítások",
           "--az alrani alkalmazás beállítása": Az Alrani alkalmazás konfigurálása,
           "--az izocash alkalmazás beállítása": Az izocash alkalmazás konfigurálása,
           "--a vixinol alkalmazás beállítása": A Vixinol alkalmazás konfigurálása,
           "--a veil Brillant alkalmazás beállítása": A Veil Brillant alkalmazás konfigurálása,
           "--Képek, videók tárolása": Képek, videók és számos egyéb elem tárolása,
           "--fogadási sebesség": az adatközpontból érkező adatok fogadásának sebessége,
           "--speed": sebesség,
           "--terminate": Megszakítás, //t
           "--a VPN lehetővé teszi a hozzáférést": A VPN lehetővé teszi olyan webhelyek vagy alkalmazások elérését, amelyeket internetszolgáltatója feketelistára helyezett,
           "-- fent volt a legnagyobb fa": A legnagyobb fa mindenekelőtt egy egyszerű kis mag volt,
           "--touch the screen": érintse meg a képernyőt a folytatáshoz,
           "--try again": Próbáld újra!,
           "--felhasználónév": Felhasználónév, //u

           "--virtuális szám": Virtuális szám, //v
           "--virtual phone settings": Virtuális telefon beállításai,
           "--virtuális telefon nyelve van alkalmazva": A virtuális telefon nyelve alapértelmezés szerint az alkalmazás szintjén kerül alkalmazásra,
           "--virtual phone": virtuális telefon,
           "--validate": Érvényesítés,
           "--üdvözöljük az izocash ügyfélportálon": Üdvözöljük az izocash ügyfélportálon, //w
           "--write a super code": Írjon be egy szuper kódot,
           "--welcome to": Üdvözöljük,
           "--ahová az emberek figyelme irányul": Ahová az emberek figyelme irányul, oda megy a pénz,
           "-- a győztesek kitartanak": A győztesek kitartanak,
           "--szeretne kijelentkezni Alrani-fiókjából": Ki szeretne jelentkezni az Alrani-fiókjából?,
           "--yes": Igen, //y

           // ország
           "--congo": Kongói Brazzaville,
           "--cameroon": Kamerun,
           "--drc": Kongói Demokratikus Köztársaság,
           "--ivoryCoast": Elefántcsontpart,

           // nyelv
        "--afrikaans": afrikaans, //a
        "--albanian": albán,
        "--amhara": amhara,
        "--arabic": arab,
        "--örmény": örmény,
        "--assamese": asszámi,
        "--aymara": Aymara,
        "--azerbaijani": azerbajdzsáni,
        "--bambara": Bambara, //b
        "--baszk": baszk,
        "--fehérorosz": fehérorosz,
        "--bengáli": bengáli,
        "--bhojpuri": Bhojpuri,
        "--bosnyák": bosnyák,
        "--bolgár": bolgár,
        "--katalán": katalán, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kínai (egyszerűsített),
        "--chineseTraditional": kínai (hagyományos),
        "--korzikai": korzikai,
        "--horvát": horvát,
        "--cseh": cseh,
        "--dán": dán, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": holland,
        "--angol": angol, //e
        "--esperanto": eszperantó,
        "--észt": észt,
        "--juh": Juh,
        "--filipino": filippínó, //f
        "--finn": finn,
        "--francia": francia,
        "--frisian": fríz,
        "--galíciai": galíciai, //g
        "--georgian": grúz,
        "--german": német,
        "--görög": görög,
        "--guarani": guarani,
        "--gudzsaráti": gudzsaráti,
        "--haiti kreol": haiti kreol, //h
        "--hausa": Hausa,
        "--hawaii": hawaii,
        "--héber": héber,
        "--hindi": hindi,
        "--hmong": hmong,
        "--magyar": magyar,
        "--icelandic": izlandi, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": indonéz,
        "--irish": ír,
        "--olasz": olasz,
        "--japán": japán, //j
        "--javanese": jávai,
        "--kannada": kannada, //k
        "--kazah": kazah,
        "--khmer": khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--koreai": koreai,
        "--krio": Krio,
        "--kurdishKurmanji": kurd (kurmandzsi),
        "--kurdishSorani": kurd (sorani),
        "--kirgiz": kirgiz,
        "--lao": Lao, //l
        "--latin": latin,
        "--latv": lett,
        "--lingala": lingala,
        "--litván": litván,
        "--luganda": Luganda,
        "--luxembourgish": luxemburgi,
        "--macedón": macedón, //m
        "--maithili": Maithili,
        "--madagaszkári": madagaszkári,
        "--malay": maláj,
        "--malayalam": Malayalam,
        "--maltese": máltai,
        "--maori": maori,
        "--marathi": marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongol": mongol,
        "--myanmarBurmese": Mianmar (burmai),
        "--nepali": nepáli, //n
        "--norwegian": norvég,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": pastu, //p
        "--persian": perzsa,
        "--polish": lengyel,
        "--portuguese": portugál,
        "--pandzsábi": pandzsábi,
        "--quechua": kecsua, //q
        "--román": román, //r
        "--orosz": orosz,
        "--samoan": szamoai, //s
        "--szanszkrit": szanszkrit,
        "--scotsGaelic": skót gael,
        "--sepedi": Sepedi,
        "--szerb": szerb,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": szindhi,
        "--sinhala": szingaléz,
        "--szlovák": szlovák,
        "--szlovén": szlovén,
        "--somali": szomáliai,
        "--spanyol": spanyol,
        "--sundanese": szundanai,
        "--szuahéli": szuahéli,
        "--svéd": svéd,
        "--tajik": tadzsik, //t
        "--tamil": tamil,
        "--tatár": tatár,
        "--telugu": telugu,
        "--thai": thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": török,
        "--türkmen": türkmén,
        "--twi": Twi,
        "--ukrán": ukrán, //u
        "--urdu": urdu,
        "--ujgur": ujgur,
        "--uzbek": üzbég,
        "--vietnami": vietnami, //v
        "--welsh": walesi, //w
        "--xhosa": Xhosa, //x
        "--jiddis": jiddis, //y
        "--yoruba": joruba,
        "--zulu": Zulu, //z
        },
      },

      // **icelandic
      // **icelandic
      icelandic: {
        translations: {
           "--an error has occurred": "Villa hefur komið upp!", //a
           "--address": "Heimilisföng",
           "--advice": "Ráð",
           "--by clicking on continue": "Með því að smella á halda áfram verður þú aftengdur Veil Brillant reikningnum þínum", //b
           "--by clicking on disconnect you will be disconnected": "Með því að smella á Aftengja verður þú aftengdur izocash reikningnum þínum",
           "--check your virtual number or try again later": "Athugaðu sýndarnúmerið þitt eða reyndu aftur síðar", //c
           "--check your virtual number": "Athugaðu sýndarnúmerið þitt",
           "--continue": "Áfram",
           "--connection": "Tenging",
           "--collaborate, live in harmony": "Samvinna, lifa í sátt við aðra",
           "--choose language": "Sýndartungumál síma",
           "--don't prevent competition": "Ekki koma í veg fyrir samkeppni, gefa öllum tækifæri", //d
           "--disconnection": "Aftenging",
           "--for all virtual phone users": "Fyrir alla sýndarsímanotendur er mælt með því að nota VPN", //f
           "--go to login page": "Farðu á innskráningarsíðuna", //g
           "--historical": "Sögulegt", //h

           "--i have account": Ég er nú þegar með reikning, //i
           "- ég er ekki með reikning": Ég er ekki með reikning,
           "--það er þitt hús": það er þitt hús,
           "--mynd / myndband +": Mynd / myndband +,
           "--identity verification": Auðkennisstaðfesting,
           "--izocash viðskiptavinagátt": izocash viðskiptavinagátt,
           "--kenndaruppfærsla á hverju ári": Uppfærsla auðkennis á hverju ári,
           "--izocash buy to": izocash Buy => izocash international,
           "--log in": Skráðu þig inn!, //l
           "--login": Skráðu þig inn,
           "--skráning á veil brilliant": Tengstu við Veil Brillant,
           "--skráning í Vixinol Store": Tengstu við Vixinol Store,
           "--skráðu þig frítt inn á Veil Brillant reikninginn þinn": Skráðu þig ókeypis inn á Veil Brillant reikninginn þinn til að fá aðgang að þessum eiginleika,
           "--login success": Innskráning tókst!,
           "--login núna": Skráðu þig inn núna!,
           "--logout success": Útskráning tókst!,
           "--log out": Útskrá,
           "--logout": Skráðu þig út,
           "--númer": Númer, //n
           "--name": Nafn,
           "--nú skráðu þig inn": Nú, skráðu þig inn!,
           "--ekkert bann við að hefta samkeppni":
           "--engin afbrýðisemi, ekkert hatur": Engin öfund, ekkert hatur, engin sundrung,
           "--Nei nei,
           "--opinber heimilisföng til að fá aðgang að sýndarsímanum þínum": Opinber heimilisföng til að fá aðgang að sýndarsímanum þínum, //o
           "--password": Lykilorð, //bls
           "--punktaúttektir izocash": Úttektir punkta izocash,
           "--punktaúttektir": Úttektir punkta,
           "--helst, notaðu vpn": Notaðu helst VPN sem tilheyrir ekki netþjónustunni þinni,
           "--þráleiki borgar sig alltaf": Þrautseigja borgar sig alltaf á endanum,
           "--rule": Reglur, //r
           "--recommendation": Ráðleggingar,
           "--skráning": Skráning,
           "--skráning á veil brilliant": Skráðu þig á Veil Brillant, //s
           "--skráning í Vixinol Store": Skráðu þig á Vixinol Store,
           "--signup": Skráðu þig,
           "--signup success": Skráning tókst!,
           "--signup for free": Skráðu þig ókeypis,
           “--signup success IA”: Tenging tókst”,
           "--settings": "Stillingar",
           "--setja upp alrani appið": Stilla Alrani forritið,
           "--setja upp izocash appið": Stilla izocash forritið,
           "--setja upp vixinol appið": Stilla Vixinol forritið,
           "--setja upp veil Brillant forritið": Stilla Veil Brillant forritið,
           "--geymsla á myndum, myndböndum": Geymsla á myndum, myndböndum og nokkrum öðrum þáttum,
           "--hraði móttöku": Hraði móttöku gagna frá gagnaverinu,
           "--speed": Hraði,
           "--terminate": Ljúka, //t
           "--vpn leyfir þér aðgang": VPN gerir þér kleift að fá aðgang að síðu eða forriti sem netþjónustan þín hefur sett á svartan lista,
           "--stærsta tréð var fyrir ofan": Stærsta tréð var umfram allt einfalt lítið fræ,
           "--snertu skjáinn": Snertu skjáinn til að halda áfram,
           "--reyna aftur": Reyndu aftur!,
           "--notandanafn": Notandanafn, //u

           "--virtual number": Sýndarnúmer, //v
           "--sýndarstillingar síma": Sýndarstillingar síma,
           "--sýndartungumál símans er beitt": Sýndarsímatungumálið er sjálfgefið notað á forritastigi,
           "--virtual phone": Sýndarsími,
           "--validate": Staðfesta,
           "--velkomin á izocash viðskiptavinagáttina": Velkomin á izocash viðskiptavinagáttina, //w
           "--skrifaðu ofurkóða": Sláðu inn ofurkóða,
           "--velkomin til": Velkomin til,
           "--þar sem athygli fólks fer": Þar sem athygli fólks fer fara peningar,
           "--vinningshafar þrauka": Sigurvegararnir þrauka,
           "--viltu skrá þig út af Alrani reikningnum þínum": Viltu skrá þig út af Alrani reikningnum þínum?,
           "--já": Já, //y

           // land
           "--kongó": Kongó Brazzaville,
           "--kamerún": Kamerún,
           "--drc": DRC,
           "--ivoryCoast": Fílabeinsströndin,

          // tungu
        "--afrikaans": Afrikaans, //a
        "--albanian": albanska,
        "--amharíska": amharíska,
        "--arabic": arabíska,
        "--armenska": armenska,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaídsjan": aserska,
        "--bambara": Bambara, //b
        "--basque": baskneska,
        "--hvítrússneska": hvítrússneska,
        "--bengali": bengalska,
        "--bhojpuri": Bhojpuri,
        "--bosníska": bosníska,
        "--búlgarska": búlgarska,
        "--catalan": katalónska, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Kínverska (einfölduð),
        "--chineseTraditional": kínverska (hefðbundið),
        "--corsican": korsíkanskt,
        "--croatian": króatíska,
        "--czech": tékkneska,
        "--danska": danska, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--hollenska": hollenska,
        "--enska": enska, //e
        "--esperanto": esperantó,
        "--estonian": eistneska,
        "--ewe": Æ,
        "--filippseyska": filippseyska, //f
        "--finnish": finnska,
        "--franska": franska,
        "--frisian": frísneska,
        "--galísíska": galisíska, //g
        "--georgian": georgíska,
        "--þýska": þýska,
        "--greek": gríska,
        "--guarani": Guarani,
        "--gújarati": gújaratí,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": hebreska,
        "--hindí": hindí,
        "--hmong": Hmong,
        "--ungverska": ungverska,
        "--íslenska": íslenska, //i
        "--igbo": Ígbó,
        "--ilocano": Ilocano,
        "--indónesíska": indónesíska,
        "--irish": írska,
        "--italian": ítalska,
        "--japanska": japanska, //j
        "--javanese": javanska,
        "--kannada": Kannada, //k
        "--kazakh": kasakska,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--kórean": kóreska,
        "--kríó": kríó,
        "--kurdishKurmanji": Kúrdíska (Kurmanji),
        "--kurdishSorani": Kúrdíska (Sorani),
        "--kyrgyz": kirgiska,
        "--lao": Lao, //l
        "--latín": latína,
        "--latneska": lettneska,
        "--lingala": Lingala,
        "--litháíska": litháíska,
        "--luganda": Luganda,
        "--luxembourgish": lúxemborgíska,
        "--makedónska": makedónska, //m
        "--maithili": Maithili,
        "--malagasy": malagasíska,
        "--malay": malaíska,
        "--malayalam": malayalam,
        "--maltese": maltneska,
        "--maórí": maórí,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongólska": mongólska,
        "--myanmarBurmese": Myanmar (burmneska),
        "--nepali": nepalska, //n
        "--norska": norskt,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //bls
        "--persneska": persneska,
        "--pólska": pólska,
        "--portúgalska": portúgalska,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--rómanska": rúmenska, //r
        "--rússneska": rússneska,
        "--samoan": Samósk, //s
        "--sanskrít": sanskrít,
        "--scotsGaelic": skosk gelíska,
        "--sepedi": Sepedi,
        "--serbneska": serbneska,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": slóvakíska,
        "--slóvenska": slóvenska,
        "--sómali": sómalska,
        "--spænska": spænska,
        "--sundanese": Sundanese,
        "--swahili": svahílí,
        "--sænska": sænska,
        "--tajik": tadsjikska, //t
        "--tamil": tamílska,
        "--tatar": Tatar,
        "--telugu": telúgú,
        "--tælendingur": taílenska,
        "--tigrinya": Tígrinja,
        "--tsonga": Tsonga,
        "--tyrkneska": tyrkneska,
        "--túrkmenar": Túrkmena,
        "--tví": Tví,
        "--ukrainian": úkraínska, //u
        "--úrdú": Úrdú,
        "--uyghur": Uyghur,
        "--uzbek": úsbekskur,
        "--víetnamska": Víetnamska, //v
        "--velsh": velska, //w
        "--xhosa": Xhosa, //x
        "--yiddish": jiddíska, //y
        "--jórúba": Jórúba,
        "--zulu": Zulu, //z
        },
      },

      // **igbo
      // **igbo
      igbo: {
        translations: {
           "--an error has occurred": "Emehiela!", //a
           "--address": "adreesị",
           "--advice": "Ndụmọdụ",
           "--by clicking on continue": "Site na ịpị na-aga n'ihu, a ga-ewepụ gị na akaụntụ Veil Brillant gị", //b
           "--by clicking on disconnect you will be disconnected": "Site na ịpị Disconnect, ị ga-apụ na akaụntụ izocash gị",
           "--check your virtual number or try again later": "Lelee nọmba mebere gị ma ọ bụ nwaa ọzọ ma emechaa", //c
           "--check your virtual number": "Lelee nọmba mebere gị",
           "--continue": "Gaa n'ihu",
           "--connection": "njikọ",
           "--collaborate, live in harmony": "Imekọ ọnụ, na-ebi ndụ kwekọrọ na ndị ọzọ",
           "--choose language": "Asụsụ ekwentị mebere",
           "--don't prevent competition": "Akwụsịla asọmpi, nye onye ọ bụla ohere", //d
           "--disconnection": "Ịkwụsị",
           "--for all virtual phone users": "Maka ndị ọrụ ekwentị mebere, a na-atụ aro ka iji VPN", //f
           "--go to login page": "Gaa na ibe nbanye", //g
           "--historical": "Akụkọ ihe mere eme", //h

          
           "--enwere m akaụntụ": Enwere m akaụntụ, //i
           "--enweghị m akaụntụ": Enweghị m akaụntụ,
           "- ọ bụ ụlọ gị": ọ bụ ụlọ gị,
           "--oyi / vidiyo +": Foto / Vidiyo +,
           "--identity verification": Nyocha njirimara,
           "--zocash ọnụ ụzọ ndị ahịa": Portal ahịa izocash,
           "--identity update kwa afọ": Mmelite njirimara kwa afọ,
           "--izocash zụta na": izocash Buy => izocash mba ụwa,
           "--abanye": Banye!, //l
           "--login": Banye,
           "--nbanye na veil na-egbuke egbuke": Jikọọ na Veil Brillant,
           "--nbanye na ụlọ ahịa vixinol": Jikọọ na Ụlọ Ahịa Vixinol,
           "--nbanye n'efu na akaụntụ Brillant gị veil": Banye n'efu na akaụntụ Veil Brillant gị iji nweta atụmatụ a,
           "--nbanye ihe ịga nke ọma": Nbanye nke ọma!,
           "--login now": Banye ugbu a!,
           "--Logout success": Ọpụpụ gara nke ọma!,
           "--pụọ": Apụọ,
           "--logout": pụọ,
           "--nọmba": Nọmba, //n
           "--aha": aha,
           "--ugbua banye": Ugbu a, Banye!,
           "--enweghị mmachibido iwu n'ọsọ asọmpi":
           " --enweghị ekworo, ọ dịghị ịkpọasị": Enweghị ekworo, ọ dịghị ịkpọasị, ọ dịghị nkewa;
           "- mba": Mba,
           "--official addresses to access your virtual phone": Adreesị ndị ọrụ iji nweta ekwentị mebere gị, //o
           "--paswọọdụ": Okwuntughe, //p
           "--points withdrawals izocash": Points withdrawals izocash,
           "--points withdrawals": Nkwụghachi ụgwọ,
           "--ọkachamma, jiri vpn": Ọkachamma, jiri VPN na-abụghị nke ndị na-eweta ọrụ ịntanetị,
           "--adịgide adịgide na-akwụ ụgwọ": Ịkwụsi ike na-akwụ ụgwọ mgbe niile n'ikpeazụ,
           "--ọchịchị": Iwu, //r
           "--nkwado": Aro,
           "--ndebanye aha": ndebanye aha,
           "-- debanyere aha na veil na-egbuke egbuke": Debanye aha na Veil Brillant, //s
           "--debanye aha na ụlọ ahịa vixinol": Debanye aha na Ụlọ Ahịa Vixinol,
           "--signup": Deba aha,
           "--signup success": Ndebanye aha gara nke ọma!,
           "--signup for free": Debanye aha n'efu,
           "--nbanye aha ọma IA": Njikọ aga nke ọma",
           "--settings": "Ntọala",
           "--ịtọlite ​​​​ngwa alrani": Na-ahazi ngwa Alrani,
           "--ịtọlite ​​​​ngwa izocash": Na-ahazi ngwa izocash,
           "--ịtọlite ​​​​vixinol ngwa": Ịhazi ngwa Vixinol,
           "--ịtọlite ​​​​app veil Brillant": Na-ahazi ngwa Veil Brillant,
           "--nchekwa nke onyonyo, vidiyo": Nchekwa onyonyo, vidiyo na ọtụtụ ihe ndị ọzọ,
           "--speed nke nnabata": Ọsọ nke nnata data sitere na Datacenter,
           "--ọsọ": Ọsọ,
           "--kwụsị": kwụsị, //t
           "--vpn na-enye gị ohere ịnweta": VPN na-enye gị ohere ịnweta saịtị ma ọ bụ ngwa nke ndị na-ahụ maka ịntanetị gị debere aha ojii,
           "--osisi kachasị ukwuu dị n'elu": Osisi kachasị ukwuu dị n'elu obere mkpụrụ osisi dị mfe;
           "--metụ ihuenyo ahụ": Metụ ihuenyo ka ọ gaa n'ihu,
           "--gbalịa ọzọ": Gbalịa ọzọ!,
           "--aha njirimara": Aha njirimara, //u

           "--nọmba mebere": Nọmba mebere, //v
           "--virtual phone settings": Ntọala ekwentị mebere,
           "--virtual ekwentị na-etinye n'ọrụ": A na-etinye asụsụ ekwentị mebere na ọkwa ngwa na ndabara,
           "--virtual phone": Ekwentị mebere,
           "--validate": kwadoro,
           "--nabata n'ọnụ ụzọ ndị ahịa izocash": Nnọọ na Portal Ahịa izocash, //w
           "--dee nnukwu koodu": Tinye koodu Super,
           "-- welcome to": Nnọọ na,
           "- ebe anya ndị mmadụ na-aga": Ebe ndị mmadụ na-aga ego na-aga,
           "--ndị mmeri na-anọgidesi ike": Ndị mmeri na-anọgidesi ike,
           "--ọ ga-amasị gị ịpụ na akaụntụ Alrani gị": Ị chọrọ ịpụ na akaụntụ Alrani gị?,
           "--ee": Ee, //y

           // obodo
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "- Ivory Coast": Ivory Coast,

           // asụsụ
        "--afrikaans": Afrikaans, //a
        "--albanian": Albania,
        "--amharic": Amharic,
        "--arabic": Arabic,
        "--Armenian": Armenian,
        "--assamese": assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusian,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": onye Bosnia,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Chinese (Simplified),
        "--Chinese Omenala": Chinese (Omenala),
        "--corsican": onye Kọsika,
        "--croatian": Croatian,
        "--czech": Czech,
        "--Danish": Danish, //d
        "--Dịvehi": Dhivehi,
        "--dogri": Dogri,
        "--Dutch": Dutch,
        "-- bekee": Bekee, //e
        "--esperanto": Esperanto,
        "--estonia": ndị Estonia,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--Finnish": Finnish,
        "--french": French,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "-- German": German,
        "--Greek": Grik,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": onye Hawaii,
        "- Hibru": Hibru,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--aislandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--Indonesian": Indonesian,
        "--irish": Irish,
        "--italian": Ịtali,
        "--Japanese": Japanese, //j
        "--javanese": asụsụ Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Korean,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvia": Latvia,
        "--lingala": Lingala,
        "--lithuanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--Masedonia": Masedonia, //m
        "--maithili": Maithili,
        "- Malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwiiji": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "- Persian": Persian,
        "--polish": Polish,
        "-- Portuguese": Portuguese,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romania": Romanian, //r
        "--Russian": Russian,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Spanish,
        "--sundanese": asụsụ Sundan,
        "--swahili": Swahili,
        "--swedish": Swedish,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--Turkish": Turkish,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ukraine, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // **ilocano
      // **ilocano
      ilocano: {
        translations: {
           "--an error has occurred": "Napasamak ti biddut!", //a
           "--address": "Dagiti adres",
           "--advice": "Balakad",
           "--by clicking on continue": "Babaen ti panangi-klik iti agtultuloy ket maidiskonektaka iti Veil Brillant account-mo", //b
           "--by clicking on disconnect you will be disconnected": "Babaen ti panangi-click iti Disconnect ket maidiskonektaka iti izocash account-mo",
           "--check your virtual number or try again later": "Sukimaten ti birtual a numerom wenno padasem manen inton agangay", //c
           "--check your virtual number": "Sukimaten ti birtual a numerom",
           "--continue": "Ituloy",
           "--connection": "Koneksyon",
           "--collaborate, live in harmony": "Agtitinnulong, agbiag a maitunos kadagiti dadduma",
           "--choose language": "Birtual a Pagsasao ti Telepono",
           "--don't prevent competition": "Dimo ​​lapdan ti kompetision, ikkam ti gundaway ti amin", //d
           "--disconnection": "Panagdiskonekta",
           "--for all virtual phone users": "Para kadagiti amin nga agar-aramat ti Birtual a Telepono, mairekomendar ti panagusar ti VPN", //f
           "--go to login page": "Mapan iti panid ti panaglogin", //g
           "--historical": "Naipakasaritaan", //h

          
           "--adda account ko": Adda account ko, //i
           "--awan ti account ko": Awan ti account ko,
           "--balaymo dayta": balaymo dayta, .
           "--ladawan / video +": Ladawan / Video +,
           "--panagpaneknek ti kinasiasino": Panangpaneknek ti kinasiasino, .
           "--portal ti kostumer ti izocash": Portal ti kostumer ti izocash,
           "--panagpabaro ti pakabigbigan iti tunggal tawen": Panagpabaro ti pakabigbigan iti tunggal tawen, .
           "--izocash gumatang iti": izocash Gatangen => izocash internasional,
           "--aglog in": Aglog-in!, //l
           "--login": Aglog-in, .
           "--login iti belo a naraniag": Ikonekta iti Veil Brillant, .
           "--login iti tiendaan ti vixinol": Agkonekta iti Tiendaan ti Vixinol, .
           "--aglog-in a libre iti veil Brillant account-mo": Aglog-in a libre iti Veil Brillant account-mo tapno makastrek iti daytoy a tampok,
           "--balligi ti panaglogin": Naballigi ti panaglogin!,
           "--login ita": Aglog-in itan!,
           "--balligi ti panag-logout": Naballigi ti panag-logout!,
           "--ag-log out": Agruar, .
           "--logout": Rummuar, .
           "--numero": Numero, //n
           "--nagan": Nagan, .
           "--ita aglog-in": Ita, Aglog-in!,
           "--awan ti panangiparit iti pananglapped iti kompetision":
           "--awan ti apal, awan ti gura": Awan ti apal, awan ti gura, awan ti panagsisina,
           "--saan": Saan, .
           "--dagiti opisial a pagtaengan tapno makastrek iti birtual a teleponom": Dagiti opisial a pagtaengan tapno makastrek iti birtual a teleponom, //o
           "--password": Password, //p
           "--dagiti puntos dagiti panagikkat izocash": Dagiti puntos Dagiti panagikkat izocash, .
           "--dagiti puntos a panagikkat": Dagiti Puntos a Panagikkat, .
           "--nasaysayaat, agusar ti vpn": Nasaysayaat, agusar ti VPN a saan a kukua ti mangipapaay ti serbisio ti internetmo, .
           "--kanayon nga agbayad ti panagibtur": Kanayon nga agbayad ti panagibtur iti kamaudiananna, .
           "--rule": Dagiti pagalagadan, //r
           "--rekomendasion": Dagiti rekomendasion, .
           "--panagrehistro": Panagrehistro, .
           "--agpirma iti belo a naraniag": Agparehistro iti Belo a Brillant, //s
           "--agpirma iti tiendaan ti vixinol": Agparehistro iti Tiendaan ti Vixinol,
           "--agpirma": Agparehistro, .
           "--balligi ti panagpirma": Naballigi ti panagrehistro!,
           "--agpirma a libre": Agparehistro a libre,
           “--balligi ti panagpirma IA”: Naballigi ti koneksion”,
           "--dagiti panagitunos": "Dagiti panagitunos", .
           "--panangisaad ti app ti alrani": Panag-configure ti aplikasion ti Alrani, .
           "--panangisaad ti izocash app": Panag-configure ti aplikasion ti izocash, .
           "--panagsaad ti vixinol app": Panag-configure ti aplikasion ti Vixinol, .
           "--panagsaad ti belo a Brillant app": Panag-configure ti aplikasion ti Veil Brillant, .
           "--panagidulin kadagiti ladawan, video": Panagidulin kadagiti ladawan, video ken sumagmamano a dadduma pay nga elemento, .
           "--kapartak ti panagawat": Napartak ti panagawat ti datos manipud iti Datacenter, .
           "--kapartak": Kapardas, .
           "--terminate": Isardeng, //t
           "--ti vpn ket palubosannaka a makastrek": Ti VPN ket palubosannaka a makastrek iti maysa a site wenno maysa nga aplikasion nga in-blacklist ti mangipapaay ti serbisio ti internetmo,
           "--ti kadakkelan a kayo ket adda iti ngato": Ti kadakkelan a kayo ket iti ngato ti amin ket simple a bassit a bukel, .
           "--i-touch ti iskrin": I-touch ti iskrin tapno agtultuloy, .
           "--padasem manen": Padasem manen!,
           "--nagan ti agar-aramat": Nagan ti agar-aramat, //u

           "--birtual a numero": Birtual a numero, //v
           "--dagiti birtual a panagitunos ti telepono": Dagiti birtual a panagitunos ti telepono, .
           "--birtual a pagsasao ti Telepono ket naipakat": Ti pagsasao ti Birtual a Telepono ket naipakat iti lebel ti aplikasion babaen ti default, .
           "--birtual a telepono": Birtual a telepono, .
           "--balido": Balidate, .
           "--abrasakayo iti portal ti kostumer ti izocash": Maikablaawkayo iti Portal ti Kostumer ti izocash, //w
           "--isurat ti super a kodigo": Mangisurat ti Super a kodigo, .
           "--welcome to": Maikablaaw iti,
           "--sadino ti papanan ti atension dagiti tattao": Sadino ti papanan ti atension dagiti tattao ti kuarta, .
           "--agpursigi dagiti nangabak": Agpursigi dagiti nangabak, .
           "--kayatmo kadi ti ag-log out iti Alrani account-mo": Kayatmo kadi ti ag-log out iti Alrani account-mo?,
           "--wen": Wen, //y

           // pagilian
           "--kongo": Kongo Brazzaville, .
           "--kamerun": Kamerun, .
           "--drc": DRC,
           "--MarfilCoast": Baybay Marfil, .

           // langue
        "--afrikaano": Afrikaano, //a
        "--albaniano": Albaniano, .
        "--amharic": Amharic, .
        "--arabiko": Arabiko, .
        "--armeniano": Armeniano, .
        "--assamese": Assamese, .
        "--aymara": Aymara, .
        "--azerbaijano": Azerbaijano, .
        "--bambara": Bambara, //b
        "--basko": Basko, .
        "--belarusian": Belarusian, .
        "--bengali": Bengali, .
        "--bhojpuri": Bhojpuri, .
        "--bosniano": Bosniano, .
        "--bulgariano": Bulgariano, .
        "--katalan": Katalan, //c
        "--cebuano": Cebuano, .
        "--chichewa": Chichewa, .
        "--chineseNapasimple": Insik (Napasimple), .
        "--chineseTradisional": Insik (Tradisional), .
        "--korsikano": Korsikano, .
        "--kroata": Kroata, .
        "--tseko": Tseko, .
        "--danes": Danes, //d
        "--dhivehi": Nalaing, .
        "--dogri": Dogri, .
        "--olandes": Olandes, .
        "--ilokano": Ingles, //e
        "--esperanto": Esperanto, .
        "--estoniano": Estoniano, .
        "--kaba": Karnero, .
        "--filipino": Filipino, //f
        "--pinlandes": Pinlandes, .
        "--pranses": Pranses, .
        "--frisiano": Frisiano, .
        "--galiciano": Galiciano, //g
        "--georgian": Georgiano, .
        "--aleman": Aleman, .
        "--griego": Griego, .
        "--guarani": Guarani, .
        "--gujarati": Gujarati, .
        "--haitiano a Kreol": Haitiano a Kreol, //h
        "--hausa": Hausa, .
        "--hawaiian": Hawaiian, .
        "--hebreo": Hebreo, .
        "--hindi": Hindi, .
        "--hmong": Hmong, .
        "--hungarian": Hungarian, .
        "--islandiko": Islandiko, //i
        "--igbo": Igbo, .
        "--ilocano": Ilokano, .
        "--indonesio": Indonesiano, .
        "--irlandes": Irlandes, .
        "--italiano": Italiano, .
        "--hapon": Hapon, //j
        "--javanese": Javanese, .
        "--kannada": Kannada, //k
        "--kazakh": Kazakh, .
        "--khmer": Khmer, .
        "--kinyarwanda": Kinyarwanda, .
        "--konkani": Konkani, .
        "--koreano": Koreano, .
        "--krio": Krio, .
        "--kurdishKurmanji": Kurdo (Kurmanji), .
        "--kurdishSorani": Kurdo (Sorani), .
        "--kyrgyz": Kirgisno, .
        "--lao": Lao, //l
        "--latin": Latin, .
        "--latviano": Latviano, .
        "--lingala": Lingala, .
        "--lituano": Lituano, .
        "--luganda": Luganda, .
        "--luxembourgo": Luxembourgo, .
        "--masedonio": Macedoniano, //m
        "--maithili": Maithili, .
        "--malagasy": Malagasyo, .
        "--malay": Malayo, .
        "--malayalam": Malayalam, .
        "--malta": Malta, .
        "--maori": Maori, .
        "--marathi": Marathi, .
        "--meiteilonManipuri": Meiteilon (Manipuri), .
        "--mizo": Mizo, .
        "--mongolian": Mongolian, .
        "--myanmarBurmese": Myanmar (Birma), .
        "--nepali": Nepali, //n
        "--norwego": Norwego, .
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo, .
        "--pasto": Pashto, //p
        "--persiano": Persiano, .
        "--pasileng": Polish, .
        "--portuges": Portuges, .
        "--punjabi": Punjabi, .
        "--quechua": Quechua, //q
        "--romano": Rumano, //r
        "--ruso": Ruso, .
        "--samoano": Samoano, //s
        "--sanskrito": Sanskrito, .
        "--scotsGaelic": Eskoses Gaeliko, .
        "--sepedi": Sepedi, .
        "--serbiano": Serbio, .
        "--sesoto": Sesoto, .
        "--shona": Shona, .
        "--sindhi": Sindhi, .
        "--sinhala": Sinhala, .
        "--eslovako": Eslovako, .
        "--eslobeno": Eslobeno, .
        "--somali": Somalia, .
        "--español": Espaniol, .
        "--sundano": Sundano, .
        "--swahili": Swahili, .
        "--sueko": Sueko, .
        "--tajik": Tajik, //t
        "--tamil": Tamil, .
        "--tatar": Tatar, .
        "--telugu": Telugu, .
        "--thai": Tailandi, .
        "--tigrinya": Tigrinya, .
        "--tsonga": Tsonga, .
        "--turko": Turko, .
        "--turkmen": Turkmen, .
        "--twi": Twi, .
        "--ukranio": Ukranio, //u
        "--urdu": Urdu, .
        "--uyghur": Uyghur, .
        "--uzbek": Uzbek, .
        "--bietnamese": Bietnam, //v
        "--welsh": Gales, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba, .
        "--zulu": Zulu, //z
        },
      },*/

      // **indonesian
      // **indonesian
      indonesian: {
        translations: {
           "--an error has occurred": "Telah terjadi kesalahan!", //a
           "--address": "Alamat",
           "--advice": "Saran",
           "--by clicking on continue": "Dengan mengklik lanjutkan, Anda akan terputus dari akun Veil Brillant Anda", //b
           "--by clicking on disconnect you will be disconnected": "Dengan mengeklik Putus, Anda akan terputus dari akun izocash Anda",
           "--check your virtual number or try again later": "Periksa nomor virtual Anda atau coba lagi nanti", //c
           "--check your virtual number": "Periksa nomor virtual Anda",
           "--continue": "Lanjutkan",
           "--connection": "Koneksi",
           "--collaborate, live in harmony": "Berkolaborasi, hidup dalam harmoni dengan orang lain",
           "--virtual phone language": "Bahasa Telepon Virtual",
           "--don't prevent competition": "Jangan cegah persaingan, beri kesempatan kepada semua orang", //d
           "--disconnection": "Pemutusan",
           "--for all virtual phone users": "Untuk semua pengguna Telepon Virtual, disarankan untuk menggunakan VPN", //f
           "--go to login page": "Buka halaman login", //g
           "--historical": "Historis", //h
           "--i have account": "Saya sudah punya akun", //i
           "--i don't have account": "Saya tidak punya akun",
           "--it is your house": "itu adalah rumahmu",
           "--image / video +": "Gambar / Video +",
           "--identity verification": "Verifikasi identitas",
           "--izocash customer portal": "Portal Pelanggan izocash",
           "--identity update every year": "Pembaruan identitas setiap tahun",
           "--izocash buy to": "izocash Beli => izocash internasional",
           "--log in": "Masuk!", //l
           "--login": "Masuk",
           "--login to veil brillant": "Hubungkan ke Veil Brillant",
           "--login to vixinol store": "Hubungkan ke Toko Vixinol",
           "--login for free to your veil brillant account": "Masuk gratis ke akun Veil Brillant Anda untuk mengakses fitur ini",
           "--login success": "Login berhasil!",
           "--login now": "Masuk sekarang!",
           "--logout success": "Logout berhasil!",
           "--log out": "Keluar",
           "--logout": "Keluar",
           "--number": "Nomor", //n
           "--name": "Nama",
           "--now log in": "Sekarang, Masuk!",
           "--no ban on stifling competition": "tidak ada larangan untuk menghambat persaingan",
           "--no jealousy, no hatred": "Tidak ada iri hati, tidak ada kebencian, tidak ada perpecahan",
           "--no": "tidak",
           "--official addresses to access your virtual phone": "Alamat resmi untuk mengakses telepon virtual Anda", //o
           "--password": "Kata sandi", //p
           "--points withdrawals izocash": "Penarikan Poin izocash",
           "--points withdrawals": "Penarikan Poin",
           "--preferably, use a vpn": "Sebaiknya gunakan VPN yang bukan milik penyedia layanan internet Anda",
           "--persistence always pays off": "Kegigihan selalu membuahkan hasil pada akhirnya",
           "--rule": "Aturan", //r
           "--recommendation": "Rekomendasi",
           "--registration": "Pendaftaran",
           "--signup to veil brillant": "Daftar di Veil Brillant", //s
           "--signup to vixinol store": "Daftar di Toko Vixinol",
           "--signup": "Daftar",
           "--signup success": "Pendaftaran berhasil!",
           "--signup for free": "Daftar gratis",
           "--signup success IA": "Koneksi berhasil”",
           "--settings": "Pengaturan",
           "--setting up the alrani app": "Mengonfigurasi aplikasi Alrani",
           "--setting up the izocash app": "Mengonfigurasi aplikasi izocash",
           "--setting up the vixinol app": "Mengonfigurasi aplikasi Vixinol",
           "--setting up the veil brillant app": "Mengonfigurasi aplikasi Veil Brillant",
           "--storage of images, videos": "Penyimpanan gambar, video dan beberapa elemen lainnya",
           "--speed of reception": "Kecepatan penerimaan data dari Pusat Data",
           "--speed": "Kecepatan",
           "--terminate": "Hentikan", //t
           "--the vpn allows you to access": "VPN memungkinkan Anda mengakses situs atau aplikasi yang telah dimasukkan daftar hitam penyedia layanan internet Anda",
           "--the largest tree was above": "Pohon terbesar di atas segalanya adalah sebuah benih kecil yang sederhana",
           "--touch the screen": "Sentuh layar untuk melanjutkan",
           "--try again": "Coba lagi!",
           "--username": "Nama pengguna", //u
           "--virtual number": "Nomor virtual", //v
           "--virtual phone settings": "Pengaturan telepon virtual",
           "--virtual phone language is applied": "Bahasa Telepon Virtual diterapkan pada tingkat aplikasi secara default",
           "--virtual phone": "Telepon virtual",
           "--validate": "Validasi",
           "--welcome to the izocash customer portal": "Selamat datang di Portal Pelanggan izocash", //w
           "--write a super code": "Masukkan kode Super",
           "--welcome to": "Selamat datang di",
           "--where people's attention goes": "Ke mana perhatian orang tertuju, uang mengalir",
           "--winners persevere": "Para pemenang bertahan",
           "--would you like to log out of your Alrani account": "Apakah Anda ingin keluar dari akun Alrani Anda?",
           "--yes": "Ya", //y

           // pays
           "--congo": "Kongo Brazzaville",
           "--cameroon": "Kamerun",
           "--drc": "RDK",
           "--ivoryCoast": "Pantai Gading",

           // langues
        "--afrikaans": "Afrikaans", //a
        "--albanian": "bahasa Albania",
        "--amharic": "Amharik",
        "--arabic": "Arab",
        "--armenian": "bahasa Armenia",
        "--assamese": "bahasa Assam",
        "--aymara": "Aymara",
        "--azerbaijani": "Azerbaijan",
        "--bambara": "Bambara", //b
        "--basque": "Basque",
        "--belarusian": "Belarusia",
        "--bengali": "bahasa Bengali",
        "--bhojpuri": "Bhojpuri",
        "--bosnian": "bahasa Bosnia",
        "--bulgarian": "Bulgaria",
        "--catalan": "Katalan", //c
        "--cebuano": "Cebuano",
        "--chichewa": "Chichewa",
        "--chineseSimplified": "China (Sederhana)",
        "--chineseTraditional": "Cina (Tradisional)",
        "--corsican": "Korsika",
        "--croatian": "Kroasia",
        "--czech": "Ceko",
        "--danish": "Denmark", //d
        "--dhivehi": "Dhivehi",
        "--dogri": "Dogri",
        "--dutch": "Belanda",
        "--english": "Bahasa Inggris", //e
        "--esperanto": "Esperanto",
        "--estonian": "bahasa Estonia",
        "--ewe": "Ya",
        "--filipino": "Filipina", //f
        "--finnish": "Finlandia",
        "--french": "Perancis",
        "--frisian": "Frisia",
        "--galician": "Galicia", //g
        "--georgian": "bahasa Georgia",
        "--german": "Jerman",
        "--greek": "Yunani",
        "--guarani": "Guarani",
        "--gujarati": "Gujarati",
        "--haitianCreole": "Kreol Haiti", //h
        "--hausa": "Hausa",
        "--hawaiian": "Hawaii",
        "--hebrew": "Ibrani",
        "--hindi": "Hindi",
        "--hmong": "Hmong",
        "--hungarian": "Hongaria",
        "--icelandic": "Islandia", //i
        "--igbo": "Igbo",
        "--ilocano": "Ilocano",
        "--indonesian": "bahasa indonesia",
        "--irish": "orang Irlandia",
        "--italian": "Italia",
        "--japanese": "Jepang", //j
        "--javanese": "Jawa",
        "--kannada": "Kannada", //k
        "--kazakh": "Kazakh",
        "--khmer": "Khmer",
        "--kinyarwanda": "Kinyarwanda",
        "--konkani": "Konkani",
        "--korean": "Korea",
        "--krio": "Krio",
        "--kurdishKurmanji": "Kurdi (Kurmanji)",
        "--kurdishSorani": "Kurdi (Sorani)",
        "--kyrgyz": "Kirgistan",
        "--lao": "Lao", //l
        "--latin": "Latin",
        "--latvian": "bahasa Latvia",
        "--lingala": "Lingala",
        "--lithuanian": "bahasa Lituania",
        "--luganda": "Luganda",
        "--luxembourgish": "Luksemburg",
        "--macedonian": "Makedonia", //m
        "--maithili": "Maithili",
        "--malagasi": "Malagasi",
        "--malay": "Melayu",
        "--malayalam": "Malayalam",
        "--maltese": "Malta",
        "--maori": "Maori",
        "--marathi": "Marathi",
        "--mizo": "Mizo",
        "--mongolian": "Mongolia",
        "--myanmarBurmese": "Myanmar (Burma)",
        "--nepali": "Nepal", //n
        "--norwegian": "Norwegia",
        "--odiaOriya": "Odia (Oriya)", //o
        "--oromo": "Oromo",
        "--pashto": "Pashto", //hal
        "--persian": "Persia",
        "--polish": "Polandia",
        "--portuguese": "Portugis",
        "--punjabi": "Punjabi",
        "--quechua": "Quechua", //q
        "--romanian": "Rumania", //r
        "--russian": "Rusia",
        "--samoan": "Samoa", //s
        "--sanskrit": "Sansekerta",
        "--scotsGaelic": "Gaelik Skotlandia",
        "--sepedi": "Sepedi",
        "--serbian": "Serbia",
        "--sesotho": "Sesotho",
        "--shona": "Shona",
        "--sindhi": "Sindhi",
        "--sinhala": "Sinhala",
        "--slovak": "bahasa Slowakia",
        "--slovenian": "bahasa Slovenia",
        "--somali": "Somalia",
        "--spanish": "Spanyol",
        "--sundanese": "bahasa Sunda",
        "--swahili": "Swahili",
        "--swedish": "Swedia",
        "--tajik": "Tajik", //t
        "--tamil": "Tamil",
        "--tatar": "Tatar",
        "--telugu": "Telugu",
        "--thai": "Thailand",
        "--tigrinya": "Tigrinya",
        "--tsonga": "Tsonga",
        "--turkish": "Turki",
        "--turkmen": "Turkmenistan",
        "--twi": "Dua",
        "--ukrainian": "Ukraina", //u
        "--urdu": "Urdu",
        "--uyghur": "Uyghur",
        "--uzbek": "Uzbekistan",
        "--vietnamese": "Vietnam", //v
        "--welsh": "Welsh", //w
        "--xhosa": "Xhosa", //x
        "--yiddish": "Yiddish", //y
        "--yoruba": "Yoruba",
        "--zulu": "Zulu", //z
        },
      },

      // irish
      // irish
      /*irish: {
        translations: {
          " --an error has occurred": "Tharla earráid!", //a
           "--address": "Seoltaí",
           "--advice": "Comhairle",
           "--by clicking on continue": "Trí chliceáil ar leanúint ar aghaidh dícheanglaeofar tú ó do chuntas Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "Trí chliceáil ar Dínascadh dínasfar thú ó do chuntas izocash",
           "--check your virtual number or try again later": "Seiceáil d'uimhir fhíorúil nó bain triail eile as níos déanaí", //c
           "--check your virtual number": "Seiceáil d'uimhir fhíorúil",
           "--continue": "Lean ort",
           "--connection": "Ceangal",
           "--collaborate, live in harmony": "Comhoibriú, maireachtáil ar aon dul le daoine eile",
           "--choose language": "Teanga Ghutháin Fhíorúil",
           "--don't prevent competition": "Ná bac leis an iomaíocht, tabhair seans do gach duine", //d
           "--disconnection": "Dícheangal",
           "--for all virtual phone users": "I gcás gach úsáideoir Fón Fíorúil, moltar VPN a úsáid", //f
           "--go to login page": "Téigh go dtí an leathanach logála isteach", //g
           "--historical": "Stairiúil", //h

           "--i have account": Tá cuntas agam cheana, //i
           "--níl cuntas agam": níl cuntas agam,
           "--is é do theach": is é do theach é,
           "--image / video +": Íomhá / Físeán +,
           "--fíorú aitheantais": Fíorú aitheantais,
           "-- izocash tairseach do chustaiméirí": Tairseach do Chustaiméirí izocash,
           "--shonrú aitheantais gach bliain": Nuashonrú aitheantais gach bliain,
           "--izocash buy to": izocash Ceannaigh => izocash idirnáisiúnta,
           "--log in": Logáil isteach!, //l
           "--login": Logáil isteach,
           "--login to veil brilliant": Ceangail le Veil Brillant,
           "--login to vixinol store": Ceangail le Vixinol Store,
           "--logáil isteach saor in aisce chuig do chuntas Brillant veil": Logáil isteach saor in aisce ar do chuntas Veil Brillant chun rochtain a fháil ar an ngné seo,
           "--login success": D'éirigh leis an logáil isteach!,
           "--login now": Logáil isteach anois!,
           "--logout success": D'éirigh leis an logáil amach!,
           "--log out": Logáil amach,
           "--logout": Logáil amach,
           "--number": Uimhir, //n
           "--name": Ainm,
           " --logáil isteach anois": Anois, Logáil isteach!,
           "--gan aon toirmeasc ar iomaíocht a bhacadh":
           "--gan éad, gan fuath": Gan éad, gan fuath, gan deighilt,
           "--ní": Ní hea,
           "--seoltaí oifigiúla chun rochtain a fháil ar do ghuthán fíorúil": Seoltaí oifigiúla chun rochtain a fháil ar do ghuthán fíorúil, //o
           "--password": Pasfhocal, //p
           "--points aistarraingtí izocash": Aistarraingtí Pointí izocash,
           "--pointí a tharraingt siar": Aistarraingtí Pointí,
           "--b'fhearr, úsáid vpn": B'fhearr, úsáid VPN nach le do sholáthraí seirbhíse idirlín é,
           "--íocann buanseasmhacht as i gcónaí": Íocann marthanacht i gcónaí as sa deireadh,
           "--rule": Rialacha, //r
           "--moladh": Moltaí,
           "--clárú": Clárú,
           "--signup to veil brilliant": Cláraigh ar Veil Brillant, //s
           "--clárú le siopa vixinol": Cláraigh ar Vixinol Store,
           "--signup": Cláraigh,
           "--signup success": D'éirigh leis an gclárú!,
           "--clárú saor in aisce": Cláraigh saor in aisce,
           “--signup success IA”: Ceangal rathúil”,
           "--settings": "Socruithe",
           "--ag socrú an aip alrani": Feidhmchlár Alrani á chumrú,
           "--socrú an aip izocash": Cumrú an fheidhmchláir izocash,
           "--ag socrú an aip vixinol": Feidhmchlár Vixinol á chumrú,
           "--ag socrú an aip Brillant veil": Feidhmchlár Veil Brillant a chumrú,
           "--stóráil íomhánna, físeáin": Stóráil íomhánna, físeáin agus roinnt eilimintí eile,
           "--luas glactha": Luas glactha na sonraí ón Datacenter,
           "--speed": Luas,
           "--terminate": Críochnaigh, //t
           "--the vpn cead duit rochtain a fháil": Ceadaíonn an VPN duit rochtain a fháil ar shuíomh nó ar fheidhmchlár a bhfuil do sholáthraí seirbhíse idirlín ar liosta dubh,
           "--an crann is mó a bhí thuas": Bhí an crann is mó thar aon rud eile ina shíol beag simplí,
           "--dteagmháil leis an scáileán": Dteagmháil leis an scáileán chun leanúint ar aghaidh,
           "--try again": Bain triail eile as!,
           "--username": Ainm úsáideora, //u

           "--virtual number": Uimhir fhíorúil, //v
           "--socruithe fón fíorúil": Socruithe gutháin fhíorúla,
           "-- cuirtear teanga fhíorúil Fón i bhfeidhm": Cuirtear an teanga Fón Fíorúil i bhfeidhm ag leibhéal an fheidhmchláir de réir réamhshocraithe,
           "--fón fíorúil": Fón fíorúil,
           "--validate": Bailíochtaigh,
           "--fáilte go dtí an tairseach do chustaiméirí izocash": Fáilte chuig an Tairseach do Chustaiméirí izocash, //w
           "--write a supercode": Cuir isteach Sárchód,
           "--fáilte go dtí": Fáilte go dtí,
           "--áit a dtéann aird daoine": An áit a dtéann aird na ndaoine ar airgead,
           "--buaiteoirí persevere": Seasann na buaiteoirí,
           "--would you like to logáil amach as do chuntas Alrani": Ar mhaith leat logáil amach as do chuntas Alrani?,
           "--tá": Tá, //y

           // tír
           "--congo": Congo Brazzaville,
           "--cameroon": Camarún,
           "--drc": DRC,
           "--Cósta Eabhair": Cósta Eabhair,

           // langue
        "-- afrikaans": Afracáinis, //a
        "--Albanach": Albanach,
        "--amharic": Amáiris,
        "--Araibis": Araibis,
        "--armenian": Airméinis,
        "--Asaimis": Asaimis,
        "--aymara": Aymara,
        "--Asarbaiseáinis": Asarbaiseáinis,
        "--bambara": Bambara, //b
        "--basque": Bascais,
        "--bealarúisis": Bealarúisis,
        "--bengali": Beangáilis,
        "--bhojpuri": Bhojpuri,
        "--boisnis": Boisnis,
        "--bulgáiris": Bulgáiris,
        "--catalan": Catalóinis, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Sínis (Simplithe),
        "--ChineseTraditional": Sínis (Traidisiúnta),
        "--corsaiceach": Corsaiceach,
        "-- croatian": Cróitis,
        "--czech": Seicis,
        "--danish": Danmhairgis, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Ollainnis": Ollainnis,
        "--english": Béarla, //e
        "--esperanto": Esperanto,
        "--estonian": Eastóinis,
        "--ewe": caorach,
        "--filipino": Tagálaigis, //f
        "--Fionlainnis": Fionlainnis,
        "--Fraincis": Fraincis,
        "--frisian": Freaslainnis Iartharach,
        "--gailís": Gailísis, //g
        "--Seoirsia": Seoirsis,
        "--Gearmáinis": Gearmáinis,
        "--greek": Gréigis,
        "--guaráinis": Guaráinis,
        "--gúisearáití": Gúisearáitis,
        "--haitianCreole": Creol Haitian, //h
        "--hausa": Hásaí,
        "--hawaiian": Haváíais,
        "--eabhrais": Eabhrais,
        "--indi": Hiondúis,
        "--hmong": Hmong,
        "-- Ungáiris": Ungáiris,
        "--Íoslainnis": Íoslainnis, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "-- indonesian": Indinéisis,
        "--irish": Gaeilge,
        "--iodáilis": Iodáilis,
        "--japanese": Seapáinis, //j
        "--javanese": Iávais,
        "--cannadais": Cannadais, //k
        "--kazakh": Kazakh,
        "--khmer": Ciméiris,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Concáin,
        "--cóiréis": Cóiréis,
        "--krio": Krio,
        "--kurdishKurmanji": Coirdis (Curmanji),
        "--kurdishSorani": Coirdis (Sorani),
        "--Cirgeastáin": An Chirgeastáin,
        "--lao": Lao, //l
        "--latin": Laidin,
        "--Laitvis": Laitvis,
        "--lingala": Lingala,
        "--liotuáinis": Liotuáinis,
        "--luganda": Luganda,
        "--luxembourgish": Lucsamburgach,
        "--macadóinis": Macadóinis, //m
        "--maithili": Maithili,
        "--malagasacht": Malagásais,
        "--malay": Malaeis,
        "--mailéalaimis": Mailéalaimis,
        "--maltese": Máltais,
        "--maori": Maorais,
        "--marathi": Maraitis,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongóil": Mongóilis,
        "--myanmarBurmais": Maenmar (Burmais),
        "--neipeail": Neipealais, //n
        "--norwegian": Ioruais,
        "--odiaOriya": Odia (Oryia), //o
        "--oromo": Oromo,
        "--pashto": Paistis, //p
        "--Peirsis": Peirsis,
        "--polish": Polainnis,
        "-- portuguese": Portaingéilis,
        "--puinseáibis": Puinseáibis,
        "--quechua": Ceatsuais, //q
        "--romanian": Rómáinis, //r
        "--russian": Rúisis,
        "--samoan": Samóis, //s
        "--sanscrait": Sanscrait,
        "--scotsGaelic": Gaeilge na hAlban,
        "--sepedi": Sepedi,
        "--seirbis": Seirbis,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Siolóinis,
        "--slóvaicis": Slóvaicis,
        "--slóivéinis": Slóivéinis,
        "--somali": Somáilis,
        "--spanish": Spáinnis,
        "--sundanese": Sundais,
        "--swahili": Svahaílis,
        "--swedish": Sualainnis,
        "--tajik": Táidsícis, //t
        "--tamail": Tamailis,
        "--tatar": Tatairis,
        "--telugu": Teileagúis,
        "--thai": Téalainnis,
        "--tigrinya": Tigrinis,
        "--tsonga": Tsonga,
        "--turkish": Tuircis,
        "--turkmen": Tuircméinis,
        "--twi": Twi,
        "--Úcráinis": Úcráinis, //u
        "--urdu": Urdais,
        "--uyghur": Uyghur,
        "--uzbek": Úisbéiceastáinis,
        "--vietnamese": Vítneaimis, //v
        "--welsh": Breatnais, //w
        "--xhosa": Xhosa, //x
        "--giúdais": Giúdais, //y
        "--yoruba": Iarúibis,
        "--zulu": Súlúis, //z
        },
      },*/

      // **italian
      // **italian
      italian: {
        translations: {
           "--an error has occurred": "si è verificato un errore!", //a
           "--address": "indirizzi",
           "--advice": "consiglio",
           "--by clicking on continue": "Facendo clic su continua verrai disconnesso dal tuo account Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "Cliccando su Disconnetti verrai disconnesso dal tuo account izocash",
           "--check your virtual number or try again later": "controlla il tuo numero virtuale o riprova più tardi", //c
           "--check your virtual number": "controlla il tuo numero virtuale",
           "--continue": "continua",
           "--connection": "connessione",
           "--collaborate, live in harmony": "Collaborare, vivere in armonia con gli altri",
           "--virtual phone language": "lingua del telefono virtuale",
           "--don't prevent competition": "non impedire la concorrenza, dare a tutti una possibilità", //d
           "--disconnection": "disconnessione",
           "--for all virtual phone users": "Per tutti gli utenti di Virtual Phone, si consiglia di utilizzare una VPN", //f
           "--go to login page": "Vai alla pagina di login", //g
           "--historical": "Storico", //h
           "--i have account": "ho già un account", //i
           "--i don't have account": "non ho un account",
           "--it is your house": "è casa tua",
           "--image / video +": "Immagine/Video+",
           "--identity verification": "verifica dell'identità",
           "--izocash customer portal": "Portale clienti izocash",
           "--identity update every year": "aggiornamento dell'identità ogni anno",
           "--izocash buy to": "izocash Acquista => izocash internazionale",
           "--log in": "Accedi!", //l
           "--login": "Entra",
           "--login to veil brillant": "Connettiti a Veil Brillant",
           "--login to vixinol store": "Connettiti a Vixinol Store",
           "--login for free to your veil brillant account": "accedi gratuitamente al tuo account Veil Brillant per accedere a questa funzione",
           "--login success": "Accesso riuscito!",
           "--login now": "Accedi ora!",
           "--logout success": "Disconnessione riuscita!",
           "--log out": "disconnettersi",
           "--logout": "disconnettersi",
           "--number": "Numero", //n
           "--name": "Nome",
           "--now log in": "Ora, accedi!",
           "--no ban on stifling competition": "nessun divieto di soffocare la concorrenza",
           "--no jealousy, no hatred": "Nessuna gelosia, nessun odio, nessuna divisione",
           "--no": "No",
           "--official addresses to access your virtual phone": "Indirizzi ufficiali per accedere al tuo telefono virtuale", //o
           "--password": "Password", //p
           "--points withdrawals izocash": "Prelievi punti izocash",
           "--points withdrawals": "Prelievi Punti",
           "--preferably, use a vpn": "utilizzare preferibilmente una VPN che non appartiene al proprio fornitore di servizi Internet",
           "--persistence always pays off": "la perseveranza alla fine ripaga sempre",
           "--rule": "Regole", //r
           "--recommendation": "raccomandazioni",
           "--registration": "registrazione",
           "--signup to veil brillant": "Registrati su Veil Brillant", //s
           "--signup to vixinol store": "Registrati su Vixinol Store",
           "--signup": "Registrati",
           "--signup success": "Registrazione riuscita!",
           "--signup for free": "Registrati gratuitamente",
           "--signup success IA": "Connessione riuscita”",
           "--settings": "Impostazioni",
           "--setting up the alrani app": "Configurazione dell'applicazione Alrani",
           "--setting up the izocash app": "Configurazione dell'applicazione izocash",
           "--setting up the vixinol app": "configurazione dell'applicazione Vixinol",
           "--setting up the veil brillant app": "Configurazione dell'applicazione Veil Brillant",
           "--storage of images, videos": "archiviazione di immagini, video e molti altri elementi",
           "--speed of reception": "Velocità di ricezione dei dati dal Datacenter",
           "--speed": "velocità",
           "--terminate": "termina", //t
           "--the vpn allows you to access": "la VPN ti consente di accedere a un sito o a un'applicazione che il tuo provider di servizi Internet ha inserito nella lista nera",
           "--the largest tree was above": "L'albero più grande era soprattutto un semplice piccolo seme",
           "--touch the screen": "tocca lo schermo per continuare",
           "--try again": "riprova!",
           "--username": "nome utente", //u
           "--virtual number": "numero virtuale", //v
           "--virtual phone settings": "impostazioni del telefono virtuale",
           "--virtual phone language is applied": "la lingua del telefono virtuale viene applicata a livello di applicazione per impostazione predefinita",
           "--virtual phone": "telefono virtuale",
           "--validate": "convalida",
           "--welcome to the izocash customer portal": "Benvenuti nel portale clienti izocash", //w
           "--write a super code": "inserisci un super codice",
           "--welcome to": "benvenuto a",
           "--where people's attention goes": "dove va l'attenzione delle persone vanno i soldi",
           "--winners persevere": "i vincitori perseverano",
           "--would you like to log out of your Alrani account": "Vuoi uscire dal tuo account Alrani?",
           "--yes": "Sì", //y

           // pays
           "--congo": "Congo Brazzaville",
           "--cameroon": "Camerun",
           "--drc": "RDC",
           "--ivoryCoast": "Costa d'Avorio",

        // langues
        "--afrikaans": "afrikaans", //a
        "--albanian": "albanese",
        "--amharic": "Amarico",
        "--arabic": "Arabo",
        "--armenian": "armeno",
        "--assamese": "assamese",
        "--aymara": "Aymara",
        "--azerbaijani": "azero",
        "--bambara": "Bambara", //b
        "--basque": "basco",
        "--belarusian": "bielorusso",
        "--bengali": "bengalese",
        "--bhojpuri": "Bhojpuri",
        "--bosnian": "bosniaco",
        "--bulgarian": "bulgaro",
        "--catalan": "catalano", //c"
        "--cebuano": "cebuano",
        "--chichewa": "Chichewa",
        "--chineseSimplified": "Cinese (semplificato)",
        "--chineseTraditional": "Cinese (tradizionale)",
        "--corsican": "corso",
        "--croatian": "croato",
        "--czech": "ceco",
        "--danish": "danese", //d
        "--dhivehi": "Dhivehi",
        "--dogri": "Dogri",
        "--dutch": "olandese",
        "--english": "Inglese", //e
        "--esperanto": "esperanto",
        "--estonian": "estone",
        "--ewe": "pecora",
        "--filipino": "filippino", //f
        "--finnish": "finlandese",
        "--french": "Francese",
        "--frisian": "frisone",
        "--galician": "galiziano", //g
        "--georgian": "georgiano",
        "--german": "Tedesco",
        "--greek": "greco",
        "--guarani": "Guarani",
        "--gujarati": "gujarati",
        "--haitianCreole": "creolo haitiano", //h
        "--hausa": "Hausa",
        "--hawaiian": "hawaiano",
        "--hebrew": "ebraico",
        "--hindi": "Hindi",
        "--hmong": "Hmong",
        "--hungarian": "ungherese",
        "--icelandic": "islandese", //i
        "--igbo": "igbo",
        "--ilocano": "Ilocano",
        "--indonesian": "indonesiano",
        "--irish": "irlandese",
        "--italian": "italiano",
        "--japanese": "Giapponese", //j
        "--javanese": "giavanese",
        "--kannada": "Kannada", //k
        "--kazakh": "kazako",
        "--khmer": "khmer",
        "--kinyarwanda": "Kinyarwanda",
        "--konkani": "Konkani",
        "--korean": "coreano",
        "--krio": "Krio",
        "--kurdishKurmanji": "curdo (Kurmanji)",
        "--kurdishSorani": "curdo (Sorani)",
        "--kyrgyz": "kirghiso",
        "--lao": "Lao", //l
        "--latin": "latino",
        "--latvian": "lettone",
        "--lingala": "lingala",
        "--lithuanian": "lituano",
        "--luganda": "luganda",
        "--luxembourgish": "lussemburghese",
        "--macedonian": "macedone", //m
        "--maithili": "Maithili",
        "--malagasy": "malgascio",
        "--malay": "malese",
        "--malayalam": "malayalam",
        "--maltese": "maltese",
        "--maori": "maori",
        "--marathi": "marathi",
        "--mizo": "Mizo",
        "--mongolian": "mongolo",
        "--myanmarBurmese": "Myanmar (birmano)",
        "--nepali": "nepalese", //n
        "--norwegian": "norvegese",
        "--odiaOriya": "Odia (Oriya)", //o
        "--oromo": "Oromo",
        "--pashto": "Pashtu", //p
        "--persian": "persiano",
        "--polish": "polacco",
        "--portuguese": "Portoghese",
        "--punjabi": "punjabi",
        "--quechua": "quechua", //q
        "--romanian": "rumeno", //r
        "--russian": "Russo",
        "--samoan": "samoano", //s
        "--sanskrit": "sanscrito",
        "--scotsGaelic": "gaelico scozzese",
        "--sepedi": "Sepedi",
        "--serbian": "serbo",
        "--sesotho": "Sesotho",
        "--shona": "Shona",
        "--sindhi": "Sindhi",
        "--sinhala": "singalese",
        "--slovak": "slovacco",
        "--slovenian": "sloveno",
        "--somali": "somalo",
        "--spanish": "Spagnolo",
        "--sundanese": "sundanese",
        "--swahili": "swahili",
        "--swedish": "svedese",
        "--tajik": "tagico", //t
        "--tamil": "tamil",
        "--tatar": "tartaro",
        "--telugu": "telugu",
        "--thai": "tailandese",
        "--tigrinya": "tigrino",
        "--tsonga": "Tsonga",
        "--turkish": "turco",
        "--turkmen": "turkmeno",
        "--twi": "due",
        "--ukrainian": "Ucraino", //u
        "--urdu": "urdu",
        "--uyghur": "uiguro",
        "--uzbek": "uzbeko",
        "--vietnamese": "vietnamita", //v
        "--welsh": "gallese", //w
        "--xhosa": "Xhosa", //x
        "--yiddish": "yiddish", //y
        "--yoruba": "yoruba",
        "--zulu": "Zulu", //z
        },
      },

      // **japanese
      // **japanese
      japanese: {
        translations: {
          "--an error has occurred": "エラーが発生しました!", //a
          "--address": "アドレス",
          "--advice": "アドバイス",
          "--by clicking on continue": "[続行] をクリックすると、Veil Brillant アカウントから切断されます", //b
          "--by clicking on disconnect you will be disconnected": "「切断」をクリックすると、izocash アカウントから切断されます",
          "--check your virtual number or try again later": "仮想番号を確認するか、後で再試行してください", //c
          "--check your virtual number": "仮想番号を確認してください",
          "--continue": "続行します",
          "--connection": "接続",
          "--collaborate, live in harmony": "他人と協力し、調和して生きる",
          "--virtual phone language": "仮想電話の言語",
          "--don't prevent competition": "競争を妨げず、全員にチャンスを与えてください", //d
          "--disconnection": "切断",
          "--for all virtual phone users": "すべての仮想電話ユーザーには、VPN を使用することをお勧めします", //f
          "--go to login page": "ログイン ページに移動します", //g
          "--historical": "履歴", //h
          "--i have account": "私はすでにアカウントを持っています", //i
          "--i don't have account": "アカウントを持っていません", 
          "--it is your house": "それはあなたの家です", 
          "--image / video +": "画像 / ビデオ +", 
          "--identity verification": "本人確認", 
          "--izocash customer portal": "izocash カスタマー ポータル", 
          "--identity update every year": "ID は毎年更新されます", 
          "--izocash buy to": "izocash 購入 => izocash インターナショナル", 
          "--log in": "ログイン!", //l
          "--login": "ログインします", 
          "--login to veil Brillant": "ヴェール ブリリアントに接続し", 
          "--login to vixinol store": "Vixinol ストアに接続し", 
          "--login for free to your veil brillant account": "この機能にアクセスするには、Veil Brillant アカウントに無料でログインします",
          "--login success": "ログイン成功!", 
          "--login now": "今すぐログインしてください!", 
          "--logout success": "ログアウト成功!", 
          "--log out": "ログアウト", 
          "--logout": "ログアウトします", 
          "--number": "数値", //n
          "--name": "名前",
          "--now log in": "さあ、ログインしてください!", 
          "--no ban on stifling competition": "抑圧的な競争を禁止しない",
          "--no jealousy, no hatred": "嫉妬も憎しみも分裂もありません", 
          "--no": "いいえ",
          "--official addresses to access your virtual phone": "仮想電話にアクセスするための公式アドレス", //o
          "--password": "パスワード", //p
          "--points withdrawals izocash": "ポイント引き出し izocash", 
          "--points withdrawals": "ポイントの引き出し", 
          "--preferably, use a vpn": "できれば、インターネット サービス プロバイダーに属さない VPN を使用してください", 
          "--persistence always pays off": "粘り強さは最後には必ず報われます", 
          "--rule": "ルール", //r
          "--recommendation": "推奨事項", 
          "--registration": "登録", 
          "--signup to veil brillant": "Veil Brillant に登録します。", //s
          "--signup to vixinol store": "Vixinol ストアに登録し", 
          "--signup": "登録", 
          "--signup success": "登録に成功しました!", 
          "--signup for free": "無料で登録します", 
          "--signup success IA": "接続成功”",
          "--settings": "設定",
          "--setting up the alrani app": "Alrani アプリケーションを構成します", 
          "--setting up the izocash app": "izocash アプリケーションを構成します", 
          "--setting up the vixinol app": "Vixinol アプリケーションの設定", 
          "--setting up the veil brillant app": "Veil Brillant アプリケーションの設定", 
          "--storage of images, videos": "画像、ビデオ、およびその他のいくつかの要素のストレージ", 
          "--speed of reception": "データセンターからのデータの受信速度", 
          "--speed": "速度",
          "--terminate": "終了", //t
          "--the vpn allows you to access": "VPN を使用すると、インターネット サービス プロバイダーがブラックリストに登録したサイトまたはアプリケーションにアクセスできます",
          "--the largest tree was above": "最大の木は何よりも単純な小さな種でした", 
          "--touch the screen": "画面をタッチして続行します", 
          "--try again": "もう一度お試しください!", 
          "--username": "ユーザー名", //u
           "--virtual number": "仮想番号", //v
           "--virtual phone settings": "仮想電話設定", 
           "--virtual phone language is applied": "仮想電話言語はデフォルトでアプリケーション レベルで適用されます",
           "--virtual phone": ": 仮想電話", 
           "--validate": "検証します", 
           "--welcome to the izocash customer portal": "izocash カスタマー ポータルへようこそ", //w
           "--write a super code": "スーパーコードを入力します", 
           "--welcome to": "ようこそ", 
           "--where people's attention goes": "人々の注意が向かうところ、お金が行きます", 
           "--winners persevere": " 勝者は粘り強く", 
           "--would you like to log out of your Alrani account": "Alrani アカウントからログアウトしますか?",
           "--yes": "はい", //y

           // pays
           "--congo": "コンゴ・ブラザヴィル", 
           "--cameroon": "カメルーン", 
           "--drc": "DRC", 
           "--ivoryCoast": "コートジボワール", 

        // langues
        "--afrikaans": "アフリカーンス語", //a
        "--albanian": "アルバニア人", 
        "--amharic": "アムハラ語", 
        "--arabic": "アラビア語", 
        "--armenian": "アルメニア語", 
        "--assamese": "アッサム語", 
        "--aymara": "アイマラ", 
        "--azerbaijani": "アゼルバイジャン語", 
        "--bambara": "バンバラ", //b
        "--basque": "バスク語", 
        "--belarusian": "ベラルーシ語", 
        "--bengali": "ベンガル語", 
        "--bhojpuri": "ボージュプリ", 
        "--bosnian": "ボスニア語",
        "--bulgarian": "ブルガリア語", 
        "--catalan": "カタロニア語", //c
        "--cebuano": "セブアノ語", 
        "--chichewa": "チチェワ", 
        "--chineseSimplified": "中国語 (簡体字)", 
        "--chineseTraditional": "中国語 (繁体字)", 
        "--corsican": "コルシカ島",
        "--croatian": "クロアチア語", 
        "--czech": "チェコ語", 
        "--danish": "デンマーク語", //d
        "--dhivehi": "ディベヒ", 
        "--dogri": "ドグリ", 
        "--dutch": "オランダ語", 
        "--english": "英語",//e
        "--esperanto": "エスペラント", 
        "--estonian": "エストニア語", 
        "--ewe": "羊", 
        "--filipino": "フィリピン語",//f
        "--finnish": "フィンランド語", 
        "--french": "フランス語", 
        "--frisian": "フリジア語", 
        "--galician": "ガリシア語", //g
        "--georgian": "グルジア語", 
        "--german": "ドイツ語", 
        "--greek": "ギリシャ語", 
        "--guarani": "グアラニー語", 
        "--gujarati": "グジャラート語", 
        "--haitianCreole": "ハイチ クレオール", //h
        "--hausa": "ハウサ語", 
        "--hawaiian": "ハワイアン", 
        "--hebrew": "ヘブライ語", 
        "--hindi": "ヒンディー語", 
        "--hmong": "モン族", 
        "--hungarian": "ハンガリー語", 
        "--icelandic": "アイスランド語", //i
        "--igbo": "イボ", 
        "--ilocano": "イロカノ", 
        "--indonesian": "インドネシア語", 
        "--irish": "アイルランド語", 
        "--italian": "イタリア語", 
        "--japanese": "日本語", //j
        "--javanese": "ジャワ語", 
        "--kannada": "カンナダ語", //k
        "--kazakh": "カザフ語", 
        "--khmer": "クメール語", 
        "--kinyarwanda": "ルワンダ", 
        "--konkani": "コンカニ", 
        "--korean": "韓国語", 
        "--krio": "クリオ", 
        "--kurdishKurmanji": "クルド語 (クルマンジ)", 
        "--kurdishSorani": "クルド語 (ソラニ)", 
        "--kyrgyz": "キルギス語", 
        "--lao": "ラオ語", //l
        "--latin": "ラテン語", 
        "--latvian": "ラトビア語", 
        "--lingala": "リンガラ語", 
        "--lithuanian": "リトアニア語", 
        "--luganda": "ルガンダ", 
        "--luxembourgish": "ルクセンブルク語",
        "--macedonian": "マケドニア語、//",
        "--maithili": "マイティリ語",
        "--malagasy": "マダガスカル語",
        "--malay": "マレー語",
        "--malayalam": "マラヤーラム語",
        "--maltese": "マルタ語",
        "--maori": "マオリ族",
        "--marathi": "マラーティー語",
        "--mizo": "ミゾ",
        "--mongolian": "モンゴル語",
        "--myanmarBurmese": "ミャンマー (ビルマ語)",
        "--nepali": "ネパール語", //n
        "--norwegian": "ノルウェー語",
        "--odiaOriya": "オディア (オリヤ)", //o
        "--oromo": "オロモ",
        "--pashto": "パシュトゥー語", //p
        "--persian": "ペルシア語",
        "--polish": "ポーランド語",
        "--portuguese": "ポルトガル語",
        "--punjabi": "パンジャブ語", 
        "--quechua": "ケチュア語", //q
        "--romanian": "ルーマニア語", //r
        "--russian": "ロシア語", 
        "--samoan": "サモア語", //s
        "--sanskrit": "サンスクリット語", 
        "--scotsGaelic": "スコットランドゲール語", 
        "--sepedi": "セペディ", 
        "--serbian": "セルビア語", 
        "--sesotho": "セソト語", 
        "--shona": "ショナ",
        "--sindhi": "シンド語",
        "--sinhala": "シンハラ語",
        "--slovak": "スロバキア語",
        "--slovenian": "スロベニア語",
        "--somali": "ソマリ語",
        "--spanish": "スペイン語",
        "--sundanese": "スンダ語",
        "--swahili": "スワヒリ語",
        "--swedish": "スウェーデン語",
        "--tajik": "タジク語", //t
        "--tamil": "タミル語",
        "--tatar": "タタール語",
        "--telugu": "テルグ語",
        "--thai": "タイ語",
        "--tigrinya": "ティグリニャ",
        "--tsonga": "ツォンガ",
        "--turkish": "トルコ語",
        "--turkmen": "トルクメン",
        "--twi": "ツイ",
        "--ukrainian": "ウクライナ語", //u
        "--urdu": "ウルドゥー語",
        "--uyghur": "ウイグル語",
        "--uzbek": "ウズベク語",
        "--vietnamese": "ベトナム語", //v
        "--welsh": "ウェールズ語", //w
        "--xhosa": "コサ語", //x
        "--yiddish": "イディッシュ語",//y
        "--yoruba": "ヨルバ語",
        "--zulu": "ズールー語", //z
        },
      },

      // **javanese
      // **javanese
      /*javanese: {
        translations: {
           "--an error has occurred": "Ana kesalahan!", //a
           "--address": "Alamat",
           "--advice": "Pitutur",
           "--by clicking on continue": "Kanthi ngeklik terus sampeyan bakal pedhot saka akun Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "Kanthi ngeklik ing Disconnect, sampeyan bakal pedhot saka akun izocash",
           "--check your virtual number or try again later": "Priksa nomer virtual sampeyan utawa coba maneh mengko", //c
           "--check your virtual number": "Priksa nomer virtual sampeyan",
           "--continue": "Terusake",
           "--connection": "Sambungan",
           "--collaborate, live in harmony": "Gotong royong, urip rukun karo wong liya",
           "--choose language": "Basa Telepon Virtual",
           "--don't prevent competition": "Aja nyegah kompetisi, menehi kabeh kesempatan", //d
           "--disconnection": "Pedhot sambungan",
           "--for all virtual phone users": "Kanggo kabeh pangguna Virtual Phone, disaranake nggunakake VPN", //f
           "--go to login page": "Pindhah menyang kaca login", //g
           "--historical": "Historis", //h

           "--aku duwe akun": Aku wis duwe akun, //i
           "--aku ora duwe akun": Aku ora duwe akun,
           "-- iku omahmu": iku omahmu,
           "--gambar / video +": Gambar / Video +,
           "--identity verification": Verifikasi identitas,
           "--izocash customer portal": izocash Customer Portal,
           "--identity update every year": Nganyari identitas saben taun,
           "--izocash buy to": izocash Buy => izocash internasional,
           "--log in": Mlebu!, //l
           "--login": mlebu log,
           "--login to veil brilliant": Sambungake menyang Veil Brillant,
           "--login to vixinol store": Sambungake menyang Vixinol Store,
           "--login gratis menyang akun Veil Brillant sampeyan": Mlebet gratis menyang akun Veil Brillant sampeyan kanggo ngakses fitur iki,
           "--login success": Login sukses!,
           "--login now": Mlebu saiki!,
           "--logout success": Logout sukses!,
           "--log out": Logout,
           "--logout": Log metu,
           "--nomer": Nomer, //n
           "--name": Jeneng,
           "--now log in": Saiki, Mlebu!,
           "--ora ana larangan kanggo kompetisi stifling":
           "--ora cemburu, ora gething": Ora meri, ora gething, ora ana perpecahan,
           "--ora": Ora,
           "--alamat resmi kanggo ngakses telpon virtual sampeyan": Alamat resmi kanggo ngakses telpon virtual sampeyan, //o
           "--password": Sandi, //p
           "--points withdrawals izocash": Points Withdrawals izocash,
           "--points withdrawals": Points Withdrawals,
           "--luwih becik, gunakake vpn": Luwih becik, gunakake VPN sing dudu panyedhiya layanan internet sampeyan,
           "--persistence always pays off": Ketekunan mesthi ana ing pungkasan,
           "--rule": Aturan, //r
           "--recommendation": Rekomendasi,
           "--registration": Registrasi,
           "--signup to veil brilliant": Register ing Veil Brillant, //s
           "--signup to vixinol store": Register ing Vixinol Store,
           "--signup": Ndaftar,
           "--signup success": Registrasi sukses!,
           "--signup for free": Daftar gratis,
           "--signup success IA": Sambungan sukses",
           "--settings": "Setelan",
           "--setting up the alrani app": Konfigurasi aplikasi Alrani,
           "--setting up the izocash app": Konfigurasi aplikasi izocash,
           "--setting up the vixinol app": Konfigurasi aplikasi Vixinol,
           "--setting up the veil Brillant app": Konfigurasi aplikasi Veil Brillant,
           "--storage of images, videos": Panyimpenan gambar, video lan sawetara unsur liyane,
           "--speed of reception": Kacepetan panrima data saka Pusat Data,
           "--speed": Kacepetan,
           "--terminate": Mungkasi, //t
           "--vpn ngidini sampeyan ngakses": VPN ngidini sampeyan ngakses situs utawa aplikasi sing wis diselehake panyedhiya layanan internet,
           "--wit paling gedhe ana ing ndhuwur": Wit paling gedhe ing ndhuwur kabeh wiji cilik sing prasaja,
           "--touch the screen": Tutul layar kanggo nerusake,
           "--try again": Coba maneh!,
           "--username": Jeneng panganggo, //u

           "--nomer virtual": Nomer virtual, //v
           "--virtual phone settings": Setelan telpon virtual,
           "--virtual Phone language is applied": Basa Virtual Phone diterapake ing tingkat aplikasi kanthi gawan,
           "--telepon virtual": Telpon virtual,
           "--validate": Validasi,
           "--welcome to the izocash customer portal": Welcome to the izocash Customer Portal, //w
           "--write a super code": Ketik kode Super,
           "--welcome to": Sugeng rawuh,
           "--where people's attention goes": Endi manungsa waé dadi dhuwit,
           "--winners persevere": Sing menang tabah,
           "--arep metu saka akun Alrani sampeyan": Apa sampeyan pengin metu saka akun Alrani sampeyan?,
           "--ya": Ya, //y

           // negara
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Pantai Gading,

           // basa
        "--afrikaans": Afrikaans, //a
        "--albanian": basa Albania,
        "--amharic": Amharic,
        "--arabic": Arab,
        "--armenian": basa Armenia,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": basa Azerbaijan,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusia": Belarusia,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnia,
        "--bulgarian": basa Bulgaria,
        "--catalan": Katalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Cina (Simplified),
        "--chineseTraditional": Cina (Tradisional),
        "--corsican": Korsika,
        "--croatian": Kroasia,
        "--czech": Ceko,
        "--danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Walanda,
        "--english": Inggris, //e
        "--esperanto": Esperanto,
        "--estonian": basa Estonia,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": basa Finlandia,
        "--french": Prancis,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgia,
        "--jerman": Jerman,
        "--greek": Yunani,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haiti Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": Ibrani,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungaria,
        "--icelandic": Islandia, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": basa Indonesia,
        "--irish": Irlandia,
        "--italian": basa Italia,
        "--japanese": Jepang, //j
        "--jawa": Jawa,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Korea,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdi (Sorani),
        "--kyrgyz": Kirgizstan,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": Latvia,
        "--lingala": Lingala,
        "--lithuanian": Lithuania,
        "--luganda": Luganda,
        "--luxembourgish": Luksemburg,
        "--macedonian": Makedonia, //m
        "--maithili": Maithili,
        "--malagasy": Malagasi,
        "--malay": Melayu,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolia,
        "--myanmarBurmese": Myanmar (Burma),
        "--nepali": Nepali, //n
        "--norwegian": basa Norwegia,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Persia,
        "--polish": Polandia,
        "--portuguese": Portugis,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Rumania, //r
        "--russian": Rusian,
        "--samoan": Samoan, //s
        "--sanskrit": Sansekerta,
        "--scotsGaelic": Gaelik Skotlandia,
        "--sepedi": Sepedi,
        "--serbian": Serbia,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": basa Slovenia,
        "--somali": Somali,
        "--spanish": Spanyol,
        "--Sundanese": Basa Sunda,
        "--swahili": Swahili,
        "--swedish": Swedia,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": basa Turki,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ukrainia, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnam, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // **kannada
      // **kannada
      kannada: {
        translations: {
          "--an error has occurred": "ದೋಷ ಸಂಭವಿಸಿದೆ!", //a
          "--address": "ವಿಳಾಸಗಳು",
          "--advice": "ಸಲಹೆ",
          "--by clicking on continue": "ಮುಂದುವರಿಸು ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ ನಿಮ್ಮ ವೈಲ್ ಬ್ರಿಲಂಟ್ ಖಾತೆಯಿಂದ ನೀವು ಸಂಪರ್ಕ ಕಡಿತಗೊಳ್ಳುತ್ತೀರಿ", //b
          "--by clicking on disconnect you will be disconnected": "ಡಿಸ್ಕನೆಕ್ಟ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡುವುದರ ಮೂಲಕ ನಿಮ್ಮ izocash ಖಾತೆಯಿಂದ ನೀವು ಸಂಪರ್ಕ ಕಡಿತಗೊಳ್ಳುತ್ತೀರಿ",
          "--check your virtual number or try again later": "ನಿಮ್ಮ ವರ್ಚುವಲ್ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ ಅಥವಾ ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ", //c
          "--check your virtual number": "ನಿಮ್ಮ ವರ್ಚುವಲ್ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ",
          "--continue": "ಮುಂದುವರಿಸಿ",
          "--connection": "ಸಂಪರ್ಕ",
          "--collaborate, live in harmony": "ಸಹಕರಿಸಿ, ಇತರರೊಂದಿಗೆ ಸೌಹಾರ್ದತೆಯಿಂದ ಬಾಳು",
          "--choose language": "ವರ್ಚುವಲ್ ಫೋನ್ ಭಾಷೆ",
          "--don't prevent competition": "ಸ್ಪರ್ಧೆಯನ್ನು ತಡೆಯಬೇಡಿ, ಎಲ್ಲರಿಗೂ ಅವಕಾಶ ನೀಡಿ", //d
          "--disconnection": "ಸಂಪರ್ಕ ಕಡಿತ",
          "--for all virtual phone users": "ಎಲ್ಲಾ ವರ್ಚುವಲ್ ಫೋನ್ ಬಳಕೆದಾರರಿಗೆ, VPN ಅನ್ನು ಬಳಸಲು ಶಿಫಾರಸು ಮಾಡಲಾಗಿದೆ", //f
          "--go to login page": "ಲಾಗಿನ್ ಪುಟಕ್ಕೆ ಹೋಗಿ", //g
          "--historical": "ಐತಿಹಾಸಿಕ", //h

          "--ನಾನು ಖಾತೆಯನ್ನು ಹೊಂದಿದ್ದೇನೆ": ನಾನು ಈಗಾಗಲೇ ಖಾತೆಯನ್ನು ಹೊಂದಿದ್ದೇನೆ, //i
          "--ನಾನು ಖಾತೆಯನ್ನು ಹೊಂದಿಲ್ಲ": ನನ್ನ ಬಳಿ ಖಾತೆ ಇಲ್ಲ,
          "--ಇದು ನಿಮ್ಮ ಮನೆ": ಇದು ನಿಮ್ಮ ಮನೆ,
          "--ಚಿತ್ರ / ವಿಡಿಯೋ +": ಚಿತ್ರ / ವಿಡಿಯೋ +,
          "--ಗುರುತಿನ ಪರಿಶೀಲನೆ": ಗುರುತಿನ ಪರಿಶೀಲನೆ,
          "--izocash ಗ್ರಾಹಕ ಪೋರ್ಟಲ್": izocash ಗ್ರಾಹಕ ಪೋರ್ಟಲ್,
          "--ಐಡೆಂಟಿಟಿ ಅಪ್ಡೇಟ್ ಪ್ರತಿ ವರ್ಷ": ಪ್ರತಿ ವರ್ಷ ಐಡೆಂಟಿಟಿ ಅಪ್ಡೇಟ್,
          "--izocash ಖರೀದಿಗೆ": izocash ಖರೀದಿಸಿ => izocash ಅಂತರರಾಷ್ಟ್ರೀಯ,
          "--ಲಾಗ್ ಇನ್": ಲಾಗ್ ಇನ್!, //ಎಲ್
          "--ಲಾಗಿನ್": ಲಾಗಿನ್,
          "--ವೈಲ್ ಬ್ರಿಲಿಯಂಟ್‌ಗೆ ಲಾಗಿನ್ ಮಾಡಿ": ವೈಲ್ ಬ್ರಿಲಂಟ್‌ಗೆ ಸಂಪರ್ಕಪಡಿಸಿ,
          "--ವಿಕ್ಸಿನಾಲ್ ಸ್ಟೋರ್‌ಗೆ ಲಾಗಿನ್ ಮಾಡಿ": ವಿಕ್ಸಿನಾಲ್ ಸ್ಟೋರ್‌ಗೆ ಸಂಪರ್ಕಪಡಿಸಿ,
          "--ನಿಮ್ಮ ಮುಸುಕು ಬ್ರಿಲಂಟ್ ಖಾತೆಗೆ ಉಚಿತವಾಗಿ ಲಾಗಿನ್ ಮಾಡಿ": ಈ ವೈಶಿಷ್ಟ್ಯವನ್ನು ಪ್ರವೇಶಿಸಲು ನಿಮ್ಮ ವೈಲ್ ಬ್ರಿಲಂಟ್ ಖಾತೆಗೆ ಉಚಿತವಾಗಿ ಲಾಗ್ ಇನ್ ಮಾಡಿ,
          "--ಲಾಗಿನ್ ಯಶಸ್ಸು": ಲಾಗಿನ್ ಯಶಸ್ವಿಯಾಗಿದೆ!,
          "--ಈಗ ಲಾಗಿನ್ ಮಾಡಿ": ಈಗ ಲಾಗ್ ಇನ್ ಮಾಡಿ!,
          "--ಲಾಗ್ಔಟ್ ಯಶಸ್ಸು": ಲಾಗ್ಔಟ್ ಯಶಸ್ವಿಯಾಗಿದೆ!,
          "--ಲಾಗ್ ಔಟ್": ಲಾಗ್ ಔಟ್,
          "--ಲಾಗ್ಔಟ್": ಲಾಗ್ ಔಟ್,
          "--ಸಂಖ್ಯೆ": ಸಂಖ್ಯೆ, //n
          "--ಹೆಸರು": ಹೆಸರು,
          "--ಈಗ ಲಾಗ್ ಇನ್": ಈಗ, ಲಾಗ್ ಇನ್!,
          "--ಸ್ಪರ್ಧೆಯನ್ನು ತಡೆಯಲು ಯಾವುದೇ ನಿಷೇಧವಿಲ್ಲ":
          "--ಅಸೂಯೆ ಇಲ್ಲ, ದ್ವೇಷವಿಲ್ಲ": ಯಾವುದೇ ಅಸೂಯೆ ಇಲ್ಲ, ದ್ವೇಷವಿಲ್ಲ, ಯಾವುದೇ ವಿಭಜನೆಗಳಿಲ್ಲ,
          "--ಇಲ್ಲ ಇಲ್ಲ,
          "--ನಿಮ್ಮ ವರ್ಚುವಲ್ ಫೋನ್ ಅನ್ನು ಪ್ರವೇಶಿಸಲು ಅಧಿಕೃತ ವಿಳಾಸಗಳು": ನಿಮ್ಮ ವರ್ಚುವಲ್ ಫೋನ್ ಅನ್ನು ಪ್ರವೇಶಿಸಲು ಅಧಿಕೃತ ವಿಳಾಸಗಳು, //o
          "--ಪಾಸ್ವರ್ಡ್": ಪಾಸ್ವರ್ಡ್, //p
          "--ಪಾಯಿಂಟ್‌ಗಳ ಹಿಂಪಡೆಯುವಿಕೆ izocash": ಪಾಯಿಂಟ್‌ಗಳ ಹಿಂತೆಗೆದುಕೊಳ್ಳುವಿಕೆ izocash,
          "--ಅಂಕಗಳ ಹಿಂಪಡೆಯುವಿಕೆಗಳು": ಅಂಕಗಳ ಹಿಂಪಡೆಯುವಿಕೆಗಳು,
          "--ಮೇಲಾಗಿ, vpn ಬಳಸಿ": ಮೇಲಾಗಿ, ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಸೇವಾ ಪೂರೈಕೆದಾರರಿಗೆ ಸೇರದ VPN ಅನ್ನು ಬಳಸಿ,
          "--ಹಂತವು ಯಾವಾಗಲೂ ಫಲ ನೀಡುತ್ತದೆ": ನಿರಂತರತೆಯು ಯಾವಾಗಲೂ ಕೊನೆಯಲ್ಲಿ ಪಾವತಿಸುತ್ತದೆ,
          "--ನಿಯಮ": ನಿಯಮಗಳು, //r
          "--ಶಿಫಾರಸು": ಶಿಫಾರಸುಗಳು,
          "--ನೋಂದಣಿ": ನೋಂದಣಿ,
          "--ಸೈನ್‌ಅಪ್ ಟು ವೇಲ್ ಬ್ರಿಲಿಯಂಟ್": ವೆಯಿಲ್ ಬ್ರಿಲಂಟ್‌ನಲ್ಲಿ ನೋಂದಾಯಿಸಿ, //s
          "--ವಿಕ್ಸಿನಾಲ್ ಸ್ಟೋರ್‌ಗೆ ಸೈನ್ ಅಪ್ ಮಾಡಿ": ವಿಕ್ಸಿನಾಲ್ ಸ್ಟೋರ್‌ನಲ್ಲಿ ನೋಂದಾಯಿಸಿ,
          "--ಸೈನ್ಅಪ್": ನೋಂದಣಿ,
          "--ಸೈನ್‌ಅಪ್ ಯಶಸ್ಸು": ನೋಂದಣಿ ಯಶಸ್ವಿಯಾಗಿದೆ!,
          "--ಉಚಿತವಾಗಿ ಸೈನ್ ಅಪ್": ಉಚಿತವಾಗಿ ನೋಂದಾಯಿಸಿ,
          “--ಸೈನ್‌ಅಪ್ ಯಶಸ್ಸು IA”: ಸಂಪರ್ಕ ಯಶಸ್ವಿಯಾಗಿದೆ”,
          "--ಸೆಟ್ಟಿಂಗ್‌ಗಳು": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
          "--ಅಲ್ರಾನಿ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಹೊಂದಿಸಲಾಗುತ್ತಿದೆ": ಅಲ್ರಾನಿ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಲಾಗುತ್ತಿದೆ,
          "--izocash ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಹೊಂದಿಸಲಾಗುತ್ತಿದೆ": izocash ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಲಾಗುತ್ತಿದೆ,
          "--ವಿಕ್ಸಿನಾಲ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಹೊಂದಿಸಲಾಗುತ್ತಿದೆ": ವಿಕ್ಸಿನಾಲ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಲಾಗುತ್ತಿದೆ,
          "--ವೆಲ್ ಬ್ರಿಲಂಟ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಹೊಂದಿಸಲಾಗುತ್ತಿದೆ": ವೇಲ್ ಬ್ರಿಲಂಟ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಲಾಗುತ್ತಿದೆ,
          "--ಚಿತ್ರಗಳ ಸಂಗ್ರಹಣೆ, ವೀಡಿಯೊಗಳು": ಚಿತ್ರಗಳು, ವೀಡಿಯೊಗಳು ಮತ್ತು ಹಲವಾರು ಇತರ ಅಂಶಗಳ ಸಂಗ್ರಹಣೆ,
          "--ಸ್ವೀಕಾರದ ವೇಗ": ಡೇಟಾಸೆಂಟರ್‌ನಿಂದ ಡೇಟಾವನ್ನು ಸ್ವೀಕರಿಸುವ ವೇಗ,
          "--ವೇಗ": ವೇಗ,
          "--ಟರ್ಮಿನೇಟ್": ಟರ್ಮಿನೇಟ್, //ಟಿ
          "--ವಿಪಿಎನ್ ನಿಮಗೆ ಪ್ರವೇಶಿಸಲು ಅನುಮತಿಸುತ್ತದೆ": ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಸೇವಾ ಪೂರೈಕೆದಾರರು ಕಪ್ಪುಪಟ್ಟಿಗೆ ಸೇರಿಸಿರುವ ಸೈಟ್ ಅಥವಾ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಪ್ರವೇಶಿಸಲು VPN ನಿಮಗೆ ಅನುಮತಿಸುತ್ತದೆ,
          "--ದೊಡ್ಡ ಮರವು ಮೇಲಿತ್ತು": ಅತಿ ದೊಡ್ಡ ಮರವು ಎಲ್ಲಕ್ಕಿಂತ ಹೆಚ್ಚಾಗಿ ಸರಳವಾದ ಚಿಕ್ಕ ಬೀಜವಾಗಿತ್ತು,
          "--ಸ್ಕ್ರೀನ್ ಅನ್ನು ಸ್ಪರ್ಶಿಸಿ": ಮುಂದುವರಿಸಲು ಪರದೆಯನ್ನು ಸ್ಪರ್ಶಿಸಿ,
          "--ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ": ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ!,
          "--ಬಳಕೆದಾರಹೆಸರು": ಬಳಕೆದಾರಹೆಸರು, //u

          "--ವರ್ಚುವಲ್ ಸಂಖ್ಯೆ": ವರ್ಚುವಲ್ ಸಂಖ್ಯೆ, //v
           "--ವರ್ಚುವಲ್ ಫೋನ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು": ವರ್ಚುವಲ್ ಫೋನ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು,
           "--ವರ್ಚುವಲ್ ಫೋನ್ ಭಾಷೆಯನ್ನು ಅನ್ವಯಿಸಲಾಗಿದೆ": ವರ್ಚುವಲ್ ಫೋನ್ ಭಾಷೆಯನ್ನು ಪೂರ್ವನಿಯೋಜಿತವಾಗಿ ಅಪ್ಲಿಕೇಶನ್ ಮಟ್ಟದಲ್ಲಿ ಅನ್ವಯಿಸಲಾಗುತ್ತದೆ,
           "--ವರ್ಚುವಲ್ ಫೋನ್": ವರ್ಚುವಲ್ ಫೋನ್,
           "--ಮೌಲ್ಯಮಾಪನ": ಮೌಲ್ಯೀಕರಿಸು,
           "--izocash ಗ್ರಾಹಕ ಪೋರ್ಟಲ್‌ಗೆ ಸ್ವಾಗತ": izocash ಗ್ರಾಹಕ ಪೋರ್ಟಲ್‌ಗೆ ಸುಸ್ವಾಗತ, //w
           "--ಸೂಪರ್ ಕೋಡ್ ಬರೆಯಿರಿ": ಸೂಪರ್ ಕೋಡ್ ನಮೂದಿಸಿ,
           "--ಸುಸ್ವಾಗತ": ಸುಸ್ವಾಗತ,
           "--ಜನರ ಗಮನ ಎಲ್ಲಿಗೆ ಹೋಗುತ್ತದೆ": ಜನರ ಗಮನ ಎಲ್ಲಿ ಹೋಗುತ್ತದೆಯೋ ಅಲ್ಲಿ ಹಣ ಹೋಗುತ್ತದೆ,
           "--ವಿಜೇತರು ಪರಿಶ್ರಮ": ವಿಜೇತರು ಪರಿಶ್ರಮ,
           "--ನಿಮ್ಮ ಅಲ್ರಾನಿ ಖಾತೆಯಿಂದ ಲಾಗ್ ಔಟ್ ಮಾಡಲು ನೀವು ಬಯಸುತ್ತೀರಾ": ನಿಮ್ಮ ಅಲ್ರಾನಿ ಖಾತೆಯಿಂದ ಲಾಗ್ ಔಟ್ ಮಾಡಲು ನೀವು ಬಯಸುವಿರಾ?,
           "--ಹೌದು": ಹೌದು, //y

           // ದೇಶ
           "--ಕಾಂಗೊ": ಕಾಂಗೋ ಬ್ರ್ಯಾಜಾವಿಲ್ಲೆ,
           "--ಕ್ಯಾಮರೂನ್": ಕ್ಯಾಮರೂನ್,
           "--drc": DRC,
           "--ಐವರಿಕೋಸ್ಟ್": ಐವರಿ ಕೋಸ್ಟ್,

           // ಭಾಷೆ
        "--ಆಫ್ರಿಕಾನ್ಸ್": ಆಫ್ರಿಕಾನ್ಸ್, //a
        "--ಅಲ್ಬೇನಿಯನ್": ಅಲ್ಬೇನಿಯನ್,
        "--ಅಮ್ಹಾರಿಕ್": ಅಂಹರಿಕ್,
        "--ಅರೇಬಿಕ್": ಅರೇಬಿಕ್,
        "--ಅರ್ಮೇನಿಯನ್": ಅರ್ಮೇನಿಯನ್,
        "--ಅಸ್ಸಾಮಿ": ಅಸ್ಸಾಮಿ,
        "--aymara": ಅಯ್ಮಾರಾ,
        "--ಅಜೆರ್ಬೈಜಾನಿ": ಅಜೆರ್ಬೈಜಾನಿ,
        "--ಬಂಬಾರ": ಬಂಬಾರಾ, //b
        "--ಬಾಸ್ಕ್": ಬಾಸ್ಕ್,
        "--ಬೆಲರೂಸಿಯನ್": ಬೆಲರೂಸಿಯನ್,
        "--ಬಂಗಾಳಿ": ಬೆಂಗಾಲಿ,
        "--ಭೋಜ್‌ಪುರಿ": ಭೋಜ್‌ಪುರಿ,
        "--ಬೋಸ್ನಿಯನ್": ಬೋಸ್ನಿಯನ್,
        "--ಬಲ್ಗೇರಿಯನ್": ಬಲ್ಗೇರಿಯನ್,
        "-- ಕ್ಯಾಟಲಾನ್": ಕ್ಯಾಟಲಾನ್, //c
        "--ಸೆಬುವಾನೋ": ಸೆಬುವಾನೋ,
        "--ಚಿಚೆವಾ": ಚಿಚೆವಾ,
        "--ಚೈನೀಸ್ ಸರಳೀಕೃತ": ಚೈನೀಸ್ (ಸರಳೀಕೃತ),
        "--ಚೀನೀಸಾಂಪ್ರದಾಯಿಕ": ಚೈನೀಸ್ (ಸಾಂಪ್ರದಾಯಿಕ),
        "--ಕಾರ್ಸಿಕನ್": ಕಾರ್ಸಿಕನ್,
        "--ಕ್ರೊಯೇಷಿಯನ್": ಕ್ರೊಯೇಷಿಯನ್,
        "--ಜೆಕ್": ಜೆಕ್,
        "--ಡ್ಯಾನಿಷ್": ಡ್ಯಾನಿಶ್, //d
        "--ಧಿವೇಹಿ": ಧಿವೇಹಿ,
        "--ಡೋಗ್ರಿ": ಡೋಗ್ರಿ,
        "--ಡಚ್": ಡಚ್,
        "--ಇಂಗ್ಲಿಷ್": ಇಂಗ್ಲೀಷ್, //ಇ
        "--ಎಸ್ಪೆರಾಂಟೊ": ಎಸ್ಪೆರಾಂಟೊ,
        "--ಎಸ್ಟೋನಿಯನ್": ಎಸ್ಟೋನಿಯನ್,
        "--ewe": ಈವ್,
        "--ಫಿಲಿಪಿನೋ": ಫಿಲಿಪಿನೋ, //f
        "--ಫಿನ್ನಿಷ್": ಫಿನ್ನಿಷ್,
        "--ಫ್ರೆಂಚ್": ಫ್ರೆಂಚ್,
        "--ಫ್ರಿಷಿಯನ್": ಫ್ರಿಸಿಯನ್,
        "--ಗ್ಯಾಲಿಷಿಯನ್": ಗ್ಯಾಲಿಷಿಯನ್, //g
        "--ಜಾರ್ಜಿಯನ್": ಜಾರ್ಜಿಯನ್,
        "--ಜರ್ಮನ್": ಜರ್ಮನ್,
        "--ಗ್ರೀಕ್": ಗ್ರೀಕ್,
        "--ಗೌರಾನಿ": ಗೌರಾನಿ,
        "--ಗುಜರಾತಿ": ಗುಜರಾತಿ,
        "--haitianCreole": ಹೈಟಿಯನ್ ಕ್ರಿಯೋಲ್, //h
        "--ಹೌಸಾ": ಹೌಸಾ,
        "--ಹವಾಯಿಯನ್": ಹವಾಯಿಯನ್,
        "--ಹೀಬ್ರೂ": ಹೀಬ್ರೂ,
        "--ಹಿಂದಿ": ಹಿಂದಿ,
        "--ಹ್ಮಾಂಗ್": ಮೋಂಗ್,
        "--ಹಂಗೇರಿಯನ್": ಹಂಗೇರಿಯನ್,
        "--ಐಸ್ಲ್ಯಾಂಡಿಕ್": ಐಸ್ಲ್ಯಾಂಡಿಕ್, //i
        "--igbo": Igbo,
        "--ಇಲೊಕಾನೊ": ಇಲೊಕಾನೊ,
        "--ಇಂಡೋನೇಷಿಯನ್": ಇಂಡೋನೇಷಿಯನ್,
        "--ಐರಿಶ್": ಐರಿಶ್,
        "--ಇಟಾಲಿಯನ್": ಇಟಾಲಿಯನ್,
        "--ಜಪಾನೀಸ್": ಜಪಾನೀಸ್, //j
        "--ಜಾವಾನೀಸ್": ಜಾವಾನೀಸ್,
        "--ಕನ್ನಡ": ಕನ್ನಡ, //ಕೆ
        "--ಕಜಾಖ್": ಕಝಕ್,
        "--ಖ್ಮೇರ್": ಖಮೇರ್,
        "--ಕಿನ್ಯಾರವಾಂಡ": ಕಿನ್ಯಾರವಾಂಡ,
        "--ಕೊಂಕಣಿ": ಕೊಂಕಣಿ,
        "--ಕೊರಿಯನ್": ಕೊರಿಯನ್,
        "--ಕ್ರಿಯೋ": ಕ್ರಿಯೋ,
        "--kurdishKurmanji": ಕುರ್ದಿಶ್ (ಕುರ್ಮಾಂಜಿ),
        "--kurdishSorani": ಕುರ್ದಿಶ್ (ಸೊರಾನಿ),
        "--ಕಿರ್ಗಿಜ್": ಕಿರ್ಗಿಜ್,
        "--ಲಾವೋ": ಲಾವೋ, //ಎಲ್
        "--ಲ್ಯಾಟಿನ್": ಲ್ಯಾಟಿನ್,
        "--ಲಟ್ವಿಯನ್": ಲಟ್ವಿಯನ್,
        "--ಲಿಂಗಲ": ಲಿಂಗಲ,
        "--ಲಿಥುವೇನಿಯನ್": ಲಿಥುವೇನಿಯನ್,
        "--ಲುಗಾಂಡಾ": ಲುಗಾಂಡಾ,
        "--ಲಕ್ಸೆಂಬರ್ಗ್": ಲಕ್ಸೆಂಬರ್ಗ್,
        "--ಮೆಸಿಡೋನಿಯನ್": ಮೆಸಿಡೋನಿಯನ್, //m
        "--ಮೈಥಿಲಿ": ಮೈಥಿಲಿ,
        "--ಮಲಗಾಸಿ": ಮಲಗಾಸಿ,
        "--ಮಲಯ": ಮಲಯ,
        "--ಮಲಯಾಳಂ": ಮಲಯಾಳಂ,
        "--ಮಾಲ್ಟೀಸ್": ಮಾಲ್ಟೀಸ್,
        "--ಮಾವೋರಿ": ಮಾವೋರಿ,
        "--ಮರಾಠಿ": ಮರಾಠಿ,
        "--meiteilonManipuri": Meiteilon (ಮಣಿಪುರಿ),
        "--ಮಿಜೊ": ಮಿಜೋ,
        "--ಮಂಗೋಲಿಯನ್": ಮಂಗೋಲಿಯನ್,
        "--ಮ್ಯಾನ್ಮಾರ್ ಬರ್ಮೀಸ್": ಮ್ಯಾನ್ಮಾರ್ (ಬರ್ಮೀಸ್),
        "--ನೇಪಾಳಿ": ನೇಪಾಳಿ, //n
        "--ನಾರ್ವೇಜಿಯನ್": ನಾರ್ವೇಜಿಯನ್,
        "--odiaOriya": ಒಡಿಯಾ (ಒರಿಯಾ), //o
        "--ಒರೊಮೊ": ಒರೊಮೊ,
        "--ಪಾಷ್ಟೋ": ಪಾಷ್ಟೋ, //ಪು
        "--ಪರ್ಷಿಯನ್": ಪರ್ಷಿಯನ್,
        "--ಪಾಲಿಷ್": ಪೋಲಿಷ್,
        "--ಪೋರ್ಚುಗೀಸ್": ಪೋರ್ಚುಗೀಸ್,
        "--ಪಂಜಾಬಿ": ಪಂಜಾಬಿ,
        "--ಕ್ವೆಚುವಾ": ಕ್ವೆಚುವಾ, //q
        "--ರೊಮೇನಿಯನ್": ರೊಮೇನಿಯನ್, //ಆರ್
        "--ರಷ್ಯನ್": ರಷ್ಯನ್,
        "--ಸಮೋವನ್": ಸಮೋವನ್, //s
        "--ಸಂಸ್ಕೃತ": ಸಂಸ್ಕೃತ,
        "--scotsGaelic": ಸ್ಕಾಟ್ಸ್ ಗೇಲಿಕ್,
        "--ಸೆಪೆಡಿ": ಸೆಪೆಡಿ,
        "--ಸರ್ಬಿಯನ್": ಸರ್ಬಿಯನ್,
        "--ಸೆಸೊಥೊ": ಸೆಸೊತೊ,
        "--ಶೋನಾ": ಶೋನಾ,
        "--ಸಿಂಧಿ": ಸಿಂಧಿ,
        "--ಸಿಂಹಳ": ಸಿಂಹಳ,
        "--ಸ್ಲೋವಾಕ್": ಸ್ಲೋವಾಕ್,
        "--ಸ್ಲೊವೇನಿಯನ್": ಸ್ಲೊವೇನಿಯನ್,
        "--ಸೋಮಾಲಿ": ಸೊಮಾಲಿ,
        "--ಸ್ಪ್ಯಾನಿಷ್": ಸ್ಪ್ಯಾನಿಷ್,
        "--ಸುಂಡಾನೀಸ್": ಸುಂಡಾನೀಸ್,
        "--ಸ್ವಾಹಿಲಿ": ಸ್ವಹಿಲಿ,
        "--ಸ್ವೀಡಿಷ್": ಸ್ವೀಡಿಷ್,
        "--ತಾಜಿಕ್": ತಾಜಿಕ್, //ಟಿ
        "--ತಮಿಳು": ತಮಿಳು,
        "--ಟಾಟರ್": ಟಾಟರ್,
        "--ತೆಲುಗು": ತೆಲುಗು,
        "--ಥಾಯ್": ಥಾಯ್,
        "--ಟಿಗ್ರಿನ್ಯಾ": ಟಿಗ್ರಿನ್ಯಾ,
        "--ತ್ಸೋಂಗಾ": ಸೋಂಗಾ,
        "--ಟರ್ಕಿಶ್": ಟರ್ಕಿಶ್,
        "--ಟರ್ಕ್ಮೆನ್": ಟರ್ಕ್ಮೆನ್,
        "--ಟ್ವಿ": ಟ್ವಿ,
        "--ಉಕ್ರೇನಿಯನ್": ಉಕ್ರೇನಿಯನ್, //u
        "--urdu": ಉರ್ದು,
        "--ಉಯ್ಘೂರ್": ಉಯ್ಘೂರ್,
        "--ಉಜ್ಬೆಕ್": ಉಜ್ಬೆಕ್,
        "--ವಿಯೆಟ್ನಾಮೀಸ್": ವಿಯೆಟ್ನಾಮೀಸ್, //v
        "--ವೆಲ್ಷ್": ವೆಲ್ಷ್, //w
        "--xhosa": Xhosa, //x
        "--ಯಿಡ್ಡಿಷ್": ಯಿಡ್ಡಿಷ್, //y
        "--ಯೊರುಬಾ": ಯೊರುಬಾ,
        "--zulu": ಜುಲು, //z
        },
      },

      // **kazakh
      // **kazakh
      kazakh: {
        translations: {
          "--an error has occurred": "Қате орын алды!", //a
          "--address": "Мекенжайлар",
          "--advice": "кеңес",
          "--by clicking on continue": "Жалғастыру түймесін басу арқылы сіз Veil Brillant тіркелгіңізден ажыратыласыз", //b
          "--by clicking on disconnect you will be disconnected": "Ажырату түймесін басу арқылы izocash есептік жазбаңыздан ажыратыласыз",
          "--check your virtual number or try again later": "Виртуалды нөміріңізді тексеріңіз немесе кейінірек қайталап көріңіз", //c
          "--check your virtual number": "виртуалды нөміріңізді тексеріңіз",
          "--continue": "Жалғастыру",
          "--connection": "қосылу",
          "--collaborate, live in harmony": "Бірлесіп жұмыс істеу, басқалармен үйлесімді өмір сүру",
          "--choose language": "Виртуалды телефон тілі",
          "--don't prevent competition": "Бәсекелестікке кедергі болма, әркімге мүмкіндік бер", //d
          "--disconnection": "ажырату",
          "--for all virtual phone users": "Барлық виртуалды телефон пайдаланушылары үшін VPN пайдалану ұсынылады", //f
          "--go to login page": "Жүйеге кіру бетіне өтіңіз", //g
          "--historical": "Тарихи", //h

          "--i have account": менде тіркелгі бар, //i
          "--i don't have account": Менде есептік жазба жоқ,
          «--бұл сіздің үйіңіз»: бұл сіздің үйіңіз,
          "--сурет / бейне +": сурет / бейне +,
          "--идентификаторды тексеру": жеке басын тексеру,
          "--izocash тұтынушы порталы": izocash тұтынушы порталы,
          "--жыл сайын жеке куәлікті жаңарту": Жыл сайын жеке куәлікті жаңарту,
          "--izocash buy to": izocash Сатып алу => izocash international,
          "--login": Жүйеге кіріңіз!, //l
          "--login": кіру,
          "--login to veil brilliant": Veil Brillant-қа қосылыңыз,
          "--vixinol дүкеніне кіру": Vixinol дүкеніне қосылыңыз,
          "--Veil Brillant есептік жазбаңызға тегін кіру": Бұл мүмкіндікке қол жеткізу үшін Veil Brillant есептік жазбаңызға тегін кіріңіз,
          "--логин сәтті": Кіру сәтті!,
          "--қазір кіру": Қазір кіріңіз!,
          "--шығу сәтті": Шығу сәтті болды!,
          "--шығу": Шығу,
          "--logout": Шығу,
          "--сан": Сан, //n
          "--name": аты,
          "--now log in": Енді, кіріңіз!,
          «--бәсекелестікті тұншықтыруға тыйым салу жоқ»:
          «--қызғаныш жоқ, жек көрушілік жоқ»: Қызғаныш жоқ, өшпенділік жоқ, бөліну жоқ,
          «--жоқ Жоқ,
          "--виртуалды телефоныңызға кіруге арналған ресми мекенжайлар": виртуалды телефоныңызға кіруге арналған ресми мекенжайлар, //o
          "--password": Құпия сөз, //б
          "--points withdrawals izocash": ұпай алу izocash,
          "--ұпайларды алу": ұпайларды алу,
          "--мүмкіндігінше, vpn пайдаланыңыз": Интернет-провайдеріңізге тиесілі емес VPN-ді пайдаланған дұрыс,
          «--қажырлылық әрқашан нәтиже береді»: Табандылық әрқашан соңында өтейді,
          "--ереже": Ережелер, //r
          "--recommendation": Ұсыныстар,
          "--registration": Тіркеу,
          "--жазбаға тіркелу": Veil Brillant-те тіркелу, //s
          "--vixinol дүкеніне тіркелу": Vixinol дүкеніне тіркелу,
          "--тіркелу": Тіркелу,
          "--тіркелу сәтті": Тіркелу сәтті өтті!,
          "--тегін тіркелу": Тегін тіркелу,
          “--тіркелу сәтті IA”: қосылым сәтті”,
          "--settings": "Параметрлер",
          "--alrani қолданбасын орнату": Alrani қолданбасын конфигурациялау,
          "--izocash қолданбасын орнату": izocash қолданбасын конфигурациялау,
          "--vixinol қолданбасын орнату": Vixinol қолданбасын конфигурациялау,
          "--Veil Brillant қолданбасын орнату": Veil Brillant қолданбасын конфигурациялау,
          "--суреттерді, бейнелерді сақтау": кескіндерді, бейнелерді және бірнеше басқа элементтерді сақтау,
          "--қабылдау жылдамдығы": Деректер орталығынан деректерді қабылдау жылдамдығы,
          "--speed": Жылдамдық,
          "--terminate": Аяқтау, //т
          "--vpn кіруге мүмкіндік береді": VPN сізге интернет провайдері қара тізімге енгізген сайтқа немесе қолданбаға кіруге мүмкіндік береді,
          «--ең үлкен ағаш жоғарыда болды»: Ең үлкен ағаш бәрінен бұрын қарапайым кішкентай тұқым болды,
          "--экранды түрту": Жалғастыру үшін экранды түртіңіз,
          "--қайталап көріңіз": Қайталап көріңіз!,
          "--username": Пайдаланушы аты, //u

          "--виртуалды сан": Виртуалды сан, //v
           "--виртуалды телефон параметрлері": виртуалды телефон параметрлері,
           "--виртуалды телефон тілі қолданылады": Виртуалды телефон тілі әдепкі бойынша қолданба деңгейінде қолданылады,
           "--виртуалды телефон": виртуалды телефон,
           "--validate": Тексеру,
           "-- izocash тұтынушы порталына қош келдіңіз": izocash тұтынушы порталына қош келдіңіз, //w
           "--супер кодты жазу": Супер кодты енгізіңіз,
           "--қош келдіңіз": қош келдіңіз,
           "--адамдардың назары қайда барса": Адамдардың назары қайда кетсе, ақша қайда кетеді,
           "--жеңімпаздар табанды": Жеңімпаздар табанды,
           "--Alrani есептік жазбаңыздан шыққыңыз келе ме?": Alrani есептік жазбаңыздан шыққыңыз келе ме?,
           "--иә": Иә, //ж

           // ел
           «--конго»: Конго Браззавиль,
           "--cameroon": Камерун,
           "--drc": DRC,
           "--піл сүйегі жағалауы": Кот-д'Ивуар,

           // тіл
        "--африкандар": африкандықтар, //а
        "--albanian": албан,
        «--амхар»: амхар,
        "--arabic": араб,
        "--armenian": армян,
        «--ассам»: ассам,
        "--аймара": Аймара,
        "--azerbaijani": әзірбайжан,
        «--бамбара»: Бамбара, //б
        "--баск": баск,
        «--беларусь»: беларусь,
        "--бенгали": бенгал,
        "--бходжпури": Бходжпури,
        "--босниялық": босниялық,
        "--болгар": болгар,
        "--catalan": каталан, //c
        "--cebuano": Себуано,
        "--чичева": Чичева,
        "--chineseSimplified": қытай (жеңілдетілген),
        "--chineseTraditional": қытай (дәстүрлі),
        "--корсикандық": корсикалық,
        "--croatian": хорват,
        "--чех": чех,
        "--danish": дат, //қ
        "--дивехи": Дивехи,
        "--догри": Догри,
        «--голланд»: голланд,
        "--english": ағылшын, //е
        "--esperanto": эсперанто,
        "--estonian": эстон,
        «--еу»: аналық,
        "--филипино": Филиппин, //f
        "--финдік": фин,
        «--француз»: француз,
        "--фриз": фриз,
        "--галициялық": Галисия, //г
        "--грузин": грузин,
        «--неміс»: неміс,
        «--грек»: грек,
        "--гуарани": гуарани,
        «--гуджарати»: гуджарати,
        "--haitianCreole": Гаити креолы, //сағ
        "--hausa": хауса,
        "--gawaiian": гавайи,
        "--еврей": иврит,
        "--хинди": хинди,
        "--хмонг": Хмонг,
        "--венгр": венгр,
        "--исландша": исландша, //i
        "--igbo": Игбо,
        "--ilocano": Илокано,
        "--индонезиялық": индонезиялық,
        "--irish": ирланд,
        "--итальянша": итальяндық,
        "--жапонша": жапон, //j
        "--javanese": яванша,
        "--каннада": Каннада, //k
        "--қазақ": қазақша,
        "--khmer": кхмер,
        "--кинярванда": кинярванда,
        "--konkani": Конкани,
        "--korean": корей,
        "--krio": Крио,
        "--kurdishKurmanji": күрд (курманджи),
        "--kurdishSorani": күрд (сорани),
        "--киргиз": қырғыз,
        "--лао": Лао, //л
        "--латын": латын,
        "--латвия": латыш,
        "--лингала": лингала,
        "--литвалық": литвалық,
        "--луганда": Луганда,
        "--luxembourgish": Люксембург,
        "--македониялық": македон, //м
        "--maithili": Майтилли,
        "--малагаси": малагаси,
        "--малай": малай,
        "--malayalam": малаялам,
        "--мальталық": мальталық,
        «--маори»: маори,
        "--марати": маратхи,
        "--meiteilonManipuri": Мейтейлон (Манипури),
        "--mizo": Мизо,
        "--монғолша": моңғол,
        "--myanmarBurmese": Мьянма (Бирма),
        "--непали": непал, //n
        "--norwegian": норвег,
        "--odiaOriya": Одия (ория), //о
        "--oromo": Оромо,
        "--пашту": пушту, //б
        "--persian": парсы,
        "--поляк": поляк,
        "--португалша": португал,
        "--панджаби": пенджаби,
        "--кечуа": кечуа, //қ
        "--румын": румын, //r
        "--орысша": орыс,
        "--самоан": самоа, //с
        "--санскрит": санскрит,
        "--scotsGaelic": шотланд галл,
        "--sepedi": Сепеди,
        "--serbian": серб,
        "--sesotho": Сесото,
        "--shona": Шона,
        «--синдхи»: синди,
        «--синхала»: сингал,
        "--словак": словак,
        "--slovenian": словен,
        "--somali": сомали,
        "--spanish": испан,
        "--сундандық": сундан,
        "--суахили": суахили,
        «--швед»: швед,
        "--тәжік": тәжік, //т
        "--tamil": тамил,
        "--татар": татар,
        "--телугу": телугу,
        "--тай": тай,
        "--тигриня": Тигринья,
        "--цонга": Цонга,
        "--түрік": түрік,
        "--түркмен": түрікмен,
        "--twi": Twi,
        "--украинша": украин, //у
        "--урду": урду,
        "--ұйғыр": ұйғыр,
        "--өзбек": өзбек,
        "--вьетнамдық": вьетнамдық, //v
        "--welsh": Уэльс, //w
        "--хоса": Хоса, //x
        "--идиш": Идиш, //ы
        "--yoruba": йоруба,
        "--зулу": Зулу, //з
        },
      },

      // **khmer
      // **khmer
      khmer: {
        translations: {
           "--an error has occurred": "កំហុសបានកើតឡើង!", //a
           "--address": "អាស័យដ្ឋាន",
           "--advice": "ដំបូន្មាន",
           "--by clicking on continue": "ដោយចុចលើ បន្ត អ្នកនឹងត្រូវបានផ្តាច់ចេញពីគណនី Veil Brillant របស់អ្នក" //b
           "--by clicking on disconnect you will be disconnected": "ដោយចុចលើ Disconnect អ្នកនឹងត្រូវបានផ្តាច់ចេញពីគណនី izocash របស់អ្នក",
           "--check your virtual number or try again later": "ពិនិត្យលេខនិម្មិតរបស់អ្នក ឬព្យាយាមម្តងទៀតនៅពេលក្រោយ" // c
           "--check your virtual number": "ពិនិត្យលេខនិម្មិតរបស់អ្នក",
           "--continue": "បន្ត",
           "--connection": "ការតភ្ជាប់",
           "--collaborate, live in harmony": "សហការ, រស់នៅ​ចុះសម្រុង​នឹង​អ្នក​ដទៃ",
           "--choose language": "ភាសាទូរស័ព្ទនិម្មិត",
           "--don't prevent competition": "កុំរារាំងការប្រកួតប្រជែង ផ្តល់ឱកាសឱ្យអ្នកគ្រប់គ្នា" // d
           "--disconnection": "ផ្តាច់",
           "--for all virtual phone users": "សម្រាប់អ្នកប្រើប្រាស់ Virtual Phone ទាំងអស់ វាត្រូវបានណែនាំអោយប្រើ VPN", //f
           "--go to login page": "ទៅកាន់ទំព័រចូល"//g
           "--historical": "ប្រវត្តិសាស្ត្រ", // h

           "--i have account": ខ្ញុំមានគណនីរួចហើយ //i
           "--i dont have account": ខ្ញុំមិនមានគណនី,
           "--it is your house": វាជាផ្ទះរបស់អ្នក,
           "--image / video +": រូបភាព / វីដេអូ +,
           "--identity verification": ការផ្ទៀងផ្ទាត់អត្តសញ្ញាណ,
           "--izocash customer portal": វិបផតថលអតិថិជន izocash,
           "--identity update every year": ការធ្វើបច្ចុប្បន្នភាពអត្តសញ្ញាណជារៀងរាល់ឆ្នាំ,
           "--izocash buy to": izocash ទិញ => izocash អន្តរជាតិ,
           "--log in": ចូល!, //l
           "--login": ចូល,
           "--login to veil brilliant"៖ ភ្ជាប់ទៅ Veil Brillant,
           "--login to vixinol store": ភ្ជាប់ទៅ Vixinol Store,
           "--login for your free to your veil Brillant account": ចូលដោយឥតគិតថ្លៃទៅកាន់គណនី Veil Brillant របស់អ្នកដើម្បីចូលប្រើមុខងារនេះ,
           "--login Success": ចូលបានជោគជ័យ!,
           "--login now": ចូលឥឡូវនេះ!,
           "--logout Success": ចេញដោយជោគជ័យ!,
           "--log out": ចេញ,
           "--logout": ចេញ,
           "--number": លេខ, // ន
           "--name": ឈ្មោះ,
           "--now log in": ឥឡូវនេះ ចូល!,
           "-- គ្មានការហាមប្រាមលើការប្រកួតប្រជែង"៖
           "--គ្មានការច្រណែន គ្មានការស្អប់": គ្មានការច្រណែន គ្មានការស្អប់ គ្មានការបែកបាក់។
           "--ទេ​ទេ,
           "--official addresses to access your virtual phone": អាសយដ្ឋានផ្លូវការដើម្បីចូលប្រើទូរស័ព្ទនិម្មិតរបស់អ្នក //o
           "--password": ពាក្យសម្ងាត់ // ទំ
           "--ពិន្ទុដក izocash": ពិន្ទុដក izocash,
           "--ការដកពិន្ទុ": ការដកពិន្ទុ,
           "--preferably, use a vpn": និយមប្រើ VPN ដែលមិនមែនជារបស់អ្នកផ្តល់សេវាអ៊ីនធឺណិតរបស់អ្នក,
           "-- ការតស៊ូតែងតែផ្តល់ផល": ការតស៊ូតែងតែផ្តល់ផលនៅទីបញ្ចប់,
           "--rule": ក្បួន, // r
           "--recommendation": អនុសាសន៍,
           "--registration": ការចុះឈ្មោះ,
           "--signup to veil brilliant": ចុះឈ្មោះនៅលើ Veil Brillant, //s
           "--signup to vixinol store": ចុះឈ្មោះនៅលើ Vixinol Store,
           "--ចុះឈ្មោះ": ចុះឈ្មោះ,
           "--ចុះឈ្មោះជោគជ័យ"៖ ការចុះឈ្មោះជោគជ័យ!,
           "--ចុះឈ្មោះដោយឥតគិតថ្លៃ": ចុះឈ្មោះដោយឥតគិតថ្លៃ,
           “--ចុះឈ្មោះជោគជ័យ IA”៖ ការតភ្ជាប់ជោគជ័យ”,
           "--settings": "ការកំណត់",
           "--setting up the alrani app": ការកំណត់រចនាសម្ព័ន្ធកម្មវិធី Alrani,
           "--setting up the izocash app": ការកំណត់រចនាសម្ព័ន្ធកម្មវិធី izocash,
           "--setting up the vixinol app": ការកំណត់រចនាសម្ព័ន្ធកម្មវិធី Vixinol,
           "--setting up the veil Brillant app": ការកំណត់រចនាសម្ព័ន្ធកម្មវិធី Veil Brillant,
           "--ការផ្ទុករូបភាព វីដេអូ"៖ ការផ្ទុករូបភាព វីដេអូ និងធាតុផ្សេងទៀតជាច្រើន,
           "--speed of reception": ល្បឿននៃការទទួលទិន្នន័យពី Datacenter,
           "--speed": ល្បឿន,
           "--terminate": បញ្ចប់, //t
           "--the vpn អនុញ្ញាតឱ្យអ្នកចូលប្រើ"៖ VPN អនុញ្ញាតឱ្យអ្នកចូលទៅកាន់គេហទំព័រ ឬកម្មវិធីដែលអ្នកផ្តល់សេវាអ៊ីនធឺណិតរបស់អ្នកបានចុះក្នុងបញ្ជីខ្មៅ។
           "-- ដើមឈើធំជាងគេគឺនៅខាងលើ"៖ ដើមឈើធំជាងគេគឺនៅពីលើគ្រាប់ពូជតូចៗសាមញ្ញទាំងអស់
           "--touch the screen": ប៉ះអេក្រង់ដើម្បីបន្ត,
           "--try again": ព្យាយាមម្តងទៀត!,
           "--username": ឈ្មោះអ្នកប្រើ //u

           "--លេខនិម្មិត"៖ លេខនិម្មិត // v
           "--virtual phone settings": ការកំណត់ទូរសព្ទនិម្មិត,
           "--virtual Phone language is used": ភាសា Virtual Phone ត្រូវបានអនុវត្តនៅកម្រិតកម្មវិធីតាមលំនាំដើម,
           "--virtual phone": ទូរស័ព្ទនិម្មិត,
           "--validate": បញ្ជាក់,
           "--welcome to the izocash customer portal": សូមស្វាគមន៍មកកាន់វិបផតថលអតិថិជន izocash //w
           "--write a super code": បញ្ចូល Super code,
           "--welcome to": សូមស្វាគមន៍មកកាន់,
           "-- where people's attention goes": កន្លែងដែលការយកចិត្តទុកដាក់របស់មនុស្សទៅលុយ,
           "--អ្នកឈ្នះ តស៊ូ": អ្នកឈ្នះ តស៊ូ,
           "--តើអ្នកចង់ចេញពីគណនី Alrani របស់អ្នកទេ": តើអ្នកចង់ចេញពីគណនី Alrani របស់អ្នកទេ?,
           "--បាទ"៖ បាទ//y

           // ប្រទេស
           "--congo": កុងហ្គោ Brazzaville,
           "--cameroon": កាមេរូន,
           "--drc": DRC,
           "--ivoryCoast": កូតឌីវ័រ,

           // ភាសា
        "--afrikaans": អាហ្រ្វិក, //a
        "--albanian": អាល់បានី,
        "--amharic": អាំហារិក,
        "--Arabic": ភាសា​អារ៉ាប់,
        "--អាមេនី": អាមេនី,
        "--assamese": អាសាំ,
        "--aymara": អៃម៉ារ៉ា,
        "--azerbaijani": អាស៊ែបៃហ្សង់,
        "--bambara": បាបារ៉ា, // ខ
        "--basque": បាស,
        "--belarusian": បេឡារុស្ស,
        "--bengali": បង់ក្លាដែស,
        "--bhojpuri": Bhojpuri,
        "--bosnian": បូស្នៀន,
        "--bulgarian": ប៊ុលហ្គារី,
        "--catalan": កាតាឡាន, // គ
        "--cebuano": សេប៊ូណូ,
        "--chichewa": ឈីឈីវ៉ា,
        "--chineseSimplified": ចិន (សាមញ្ញ),
        "--chineseTraditional": ចិន (ប្រពៃណី),
        "--corsican": Corsican,
        "--croatian": ក្រូអាត,
        "--czech": ឆេក,
        "--danish": ដាណឺម៉ាក // ឃ
        "--dhivehi": ឌីវីហ៊ី,
        "--dogri": Dogri,
        "--dutch": ហូឡង់,
        "--english": ភាសាអង់គ្លេស, //e
        "--esperanto": អេ​ស្ប៉ា​រ៉ា​តូ,
        "--estonian": អេស្តូនី,
        "--ewe": អឺ,
        "--filipino": ហ្វីលីពីន, // f
        "--finnish": ហ្វាំងឡង់,
        "--french": បារាំង,
        "--frisian": ហ្វ្រីសៀន,
        "--galician": ហ្គាលីសៀន // g
        "--georgian": ហ្សកហ្ស៊ី,
        "--german": អាល្លឺម៉ង់,
        "--greek": ក្រិក,
        "--guarani": ហ្គារ៉ានី,
        "--gujarati": ហ្គូចារ៉ាទី,
        "--haitianCreole"៖ ហៃទី ក្រេអូល // ម៉ោង
        "--hausa": ហូសា,
        "--hawaiian": ហាវ៉ៃ,
        "--hebrew": ហេព្រើរ,
        "--hindi": ហិណ្ឌូ,
        "--hmong" : ម៉ុង,
        "--hungarian": ហុងគ្រី,
        "--icelandic": អ៊ីស្លង់, //i
        "--igbo": អ៊ីហ្គបូ,
        "--ilocano": អ៊ីឡូកាណូ,
        "--indonesian": ឥណ្ឌូណេស៊ី,
        "--irish": អៀរឡង់,
        "--itali": អ៊ីតាលី,
        "--japanese": ភាសាជប៉ុន, //j
        "--javanese": ភាសាជ្វា,
        "--kannada": កាណាដា, // គ
        "--kazakh": កាហ្សាក់ស្ថាន,
        "--khmer": ខ្មែរ,
        "--kinyarwanda": គីនីយ៉ារវ៉ាន់ដា,
        "--konkani": ខុនកានី,
        "--korean": កូរ៉េ,
        "--krio": គ្រីអូ,
        "--kurdishKurmanji": ឃឺដ (Kurmanji),
        "--kurdishSorani": ឃឺដ (សូរ៉ានី),
        "--kyrgyz": កៀហ្ស៊ីស៊ី,
        "--lao": ឡាវ, //l
        "--latin": ឡាតាំង,
        "--latvian": ឡាតវី,
        "--lingala": លីងឡា,
        "--lithuanian": លីទុយអានី,
        "--luganda": លូហ្គានដា,
        "--luxembourgish": លុចសំបួរ,
        "--macedonian": ម៉ាសេដូនៀន // ម
        "--maithili": ម៉ៃធីលី,
        "--malagasy": ម៉ាឡាហ្គាស៊ី,
        "--malay": ម៉ាឡេ,
        "--malayalam": ម៉ាឡាយ៉ាឡា,
        "--maltese": ភាសា​ម៉ាល់​ទី,
        "--maori": ម៉ៅរី,
        "--ម៉ារ៉ាធី" : ម៉ារ៉ាធី,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": មីហ្សូ,
        "--mongolian": ម៉ុងហ្គោលី,
        "--myanmarBurmese": មីយ៉ាន់ម៉ា (ភូមា),
        "--nepali": នេប៉ាល់ // ន
        "--norwegian": ន័រវេស,
        "--odiaOriya": អូឌីយ៉ា (អូរីយ៉ា), // o
        "--oromo": អូរ៉ូម៉ូ,
        "--pashto": Pashto, // ទំ
        "--persian": ពែរ្ស,
        "--polish": ប៉ូឡូញ,
        "--ព័រទុយហ្គាល់": ព័រទុយហ្គាល់,
        "--punjabi": ពុនចាប៊ី,
        "--quechua": Quechua, //q
        "--romanian"៖ រ៉ូម៉ានី //r
        "--russian": រុស្ស៊ី,
        "--samoan": សាម័រ, // ស
        "--សំស្ក្រឹត" : សំស្ក្រឹត,
        "--scotsGaelic": ស្កុត ហ្គេលិក,
        "--sepedi": សេប៉េឌី,
        "--serbian": ស៊ែប៊ី,
        "--sesotho" : សេសថូ,
        "--shona": សូណា,
        "--sinhi": ស៊ីនឌី,
        "--sinhala": ស៊ីនហាឡា,
        "--slovak": ស្លូវ៉ាគី,
        "--slovenian": ស្លូវេនី,
        "--somali": សូម៉ាលី,
        "--spanish": អេស្ប៉ាញ,
        "--sundanese": ស៊ុនដានីស,
        "--swahili": ស្វាហ៊ីលី,
        "--swedish": ស៊ុយអែត,
        "--tajik": តាជីគី, // t
        "--តាមីល": តាមីល,
        "--tatar": តាតា,
        "--telugu": តេលូហ្គូ,
        "--thai": ថៃ,
        "--tigrinya": ទីគ្រីយ៉ា,
        "--tsonga": សុងហ្គា,
        "--turkish": ទួរគី,
        "--turkmen": តួកមេន,
        "--twi": ធីវី,
        "--ukrainian": អ៊ុយក្រែន, //u
        "--urdu": អ៊ូឌូ,
        "--uyghur": អ៊ុយហ្គួ,
        "--uzbek": អ៊ូសបេក,
        "--vietnamese": វៀតណាម // v
        "--welsh": វេល, // w
        "--xhosa": Xhosa, //x
        "--yiddish": យីតឌីស // y
        "--yoruba": យូរូបា,
        "--zulu": ហ្សូលូ, //z
        },
      },

      // **kinyarwanda
      // **kinyarwanda
      kinyarwanda: {
        translations: {
          "--an error has occurred": "Ikosa ryabaye!", // a
          "--address": "Aderesi",
          "--advice": "Inama",
          "--by clicking on continue": "Ukanze komeza uzahagarikwa kuri konte yawe ya Veil Brillant", // b
          "--by clicking on disconnect you will be disconnected": "Nukanda kuri Disconnect uzacibwa kuri konte yawe izocash",
          "--check your virtual number or try again later": "Reba numero yawe igaragara cyangwa ugerageze nyuma", // c
          "--check your virtual number": "Reba numero yawe igaragara",
          "--continue": "Komeza",
          "--connection": "Guhuza",
          "--collaborate, live in harmony": "Gufatanya, kubana neza n'abandi",
          "--choose language": "Ururimi rwa Terefone Virtual",
          "--don't prevent competition": "Ntukabuze irushanwa, uhe buri wese amahirwe", // d
          "--disconnection": "Guhagarika",
          "--for all virtual phone users": "Kubakoresha telefone zose za Virtual, birasabwa gukoresha VPN", // f
          "--go to login page": "Jya kurupapuro rwinjira", // g
          "--historical": "Amateka", // h

          
          "- mfite konte": Mfite konte, // i
          "--ntafite konti": Nta konte mfite,
          "--ni inzu yawe": ni inzu yawe,
          "--image / video +": Ishusho / Video +,
          "- Kugenzura indangamuntu": Kugenzura indangamuntu,
          "--izocash portal portal": izocash Urubuga rwabakiriya,
          "- kuvugurura indangamuntu buri mwaka": Kuvugurura indangamuntu buri mwaka,
          "--izocash buy to": izocash Kugura => izocash mpuzamahanga,
          "--log in": Injira!, // l
          "--login": Injira,
          "--login to veil brilliance": Ihuze na Veil Brillant,
          "--login kububiko bwa vixinol": Kwihuza Mububiko bwa Vixinol,
          "--login kubuntu kuri konte yawe ya Brillant": Injira kubuntu kuri konte yawe ya Veil Brillant kugirango ubone iyi mikorere,
          "--login intsinzi": Injira neza!,
          "--login nonaha": Injira nonaha!,
          "--Gutsindira gutsinda": Logout yatsinze!,
          "--sohora": Logout,
          "--logout": Sohoka,
          "--umubare": Umubare, // n
          "--izina": Izina,
          "--none injira": Noneho, Injira!,
          "--nta kubuza guhagarika amarushanwa":
          "--nta ishyari, nta rwango": Nta ishyari, nta rwango, nta macakubiri,
          "--no": Oya,
          "- aderesi yemewe kugirango ugere kuri terefone yawe isanzwe": Aderesi zemewe kugirango ugere kuri terefone yawe isanzwe, // o
          "--ibanga": Ijambobanga, // p
          "- amanota yo gukuramo izocash": Gukuramo amanota izocash,
          "- gukuramo ingingo": Gukuramo amanota,
          "- birashoboka, koresha vpn": Byaba byiza, koresha VPN itari iy'itangwa rya serivise yawe ya interineti,
          "--kubaho buri gihe bitanga umusaruro": Kwihangana buri gihe bitanga umusaruro amaherezo,
          "--ubuyobozi": Amategeko, // r
          "--ibyifuzo": Ibyifuzo,
          "- kwiyandikisha": Kwiyandikisha,
          "--kwiyandikisha kugirango witwikire neza": Iyandikishe kuri Veil Brillant, // s
          "--yandikishe mububiko bwa vixinol": Iyandikishe mububiko bwa Vixinol,
          "--signup": Iyandikishe,
          "--signup intsinzi": Kwiyandikisha byatsinze!,
          "--kwiyandikisha kubuntu": Iyandikishe kubuntu,
          “--Signup intsinzi IA”: Kwihuza bigenda neza ”,
          "- Igenamiterere": "Igenamiterere",
          "- gushiraho porogaramu ya alrani": Kugena porogaramu ya Alrani,
          "- gushiraho porogaramu izocash": Kugena porogaramu izocash,
          "- gushiraho porogaramu ya vixinol": Kugena porogaramu ya Vixinol,
          "- gushiraho porogaramu yitwikiriye Brillant": Kugena porogaramu ya Veil Brillant,
          "- kubika amashusho, videwo": Kubika amashusho, videwo nibindi bintu byinshi,
          "- Umuvuduko wo Kwakira": Umuvuduko wo kwakira amakuru kuva Datacenter,
          "- Umuvuduko": Umuvuduko,
          "- kurangiza": Kurangiza, // t
          "- vpn igushoboza kugera": VPN igushoboza kugera kurubuga cyangwa porogaramu utanga serivise ya enterineti yanditse kurutonde,
          "--igiti kinini cyari hejuru": Igiti kinini cyari hejuru yimbuto yoroshye,
          "--kora kuri ecran": Kora kuri ecran kugirango ukomeze,
          "- ongera ugerageze": Gerageza nanone!,
          "--ukoresha izina": Izina ryukoresha, // u

          "--umubare wukuri": Umubare wukuri, // v
           "- Igenamiterere rya terefone igaragara": Igenamiterere rya terefone,
           "- Ururimi rwa Terefone rushyirwa mu bikorwa": Ururimi rwa Terefone rushyirwa mu bikorwa ku rwego rusaba,
           "- telefone isanzwe": Terefone igaragara,
           "- Kwemeza": Kwemeza,
           "--wakiriye neza kurubuga rwabakiriya ba izocash": Murakaza neza kurubuga rwabakiriya ba izocash, // w
           "- andika super code": Injira super code,
           "- Ikaze kuri": Ikaze kuri,
           "--aho abantu berekeza ibitekerezo": Aho abantu berekeza amafaranga,
           "- abatsinze bihangane": Abatsinze bihangane,
           "--wifuza gusohoka muri konte yawe ya Alrani": Urashaka gusohoka muri konte yawe ya Alrani?,
           "--yego": Yego, // y

           // igihugu
           "--congo": Congo Brazzaville,
           "--cameruni": Kameruni,
           "--drc": DRC,
           "--ivoryCoast": Coryte d'Ivoire,

           // ururimi
        "--afrikaans": Abanyafurika, // a
        "--albanian": Ikinyalubaniya,
        "--amharic": Amharic,
        "--arabic": Icyarabu,
        "--arumeniya": Ikinyarumeniya,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerubayijani,
        "--bambara": Bambara, // b
        "--basque": Basque,
        "--Biyelorusiya": Biyelorusiya,
        "--bengali": Ikibengali,
        "--bhojpuri": Bhojpuri,
        "--bosniyani": Bosiniya,
        "--bulgarian": Buligariya,
        "--katalani": Igikatalani, // c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--Abashinwa Byoroheje": Igishinwa (Byoroheje),
        "--AbashinwaIbisanzwe": Igishinwa (Gakondo),
        "--corsican": Corsikani,
        "- Umunyakoreya": Igikorowasiya,
        "--ceki": Ceki,
        "--danish": Danemarke, // d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--igituba": Ikidage,
        "--icyongereza": Icyongereza, // e
        "--esperanto": Esperanto,
        "--estoniya": Esitoniya,
        "--ewe": Ewe,
        "--filipino": Abanyafilipine, // f
        "--finish": Igifinilande,
        "- Igifaransa": Igifaransa,
        "--Frisiyani": Igifaransa,
        "- Umunyamerika": Abagalatiya, // g
        "--georgian": Jeworujiya,
        "--german": Ikidage,
        "--greek": Ikigereki,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitiyaniCreole": Igikerewole cyo muri Hayiti, // h
        "--hausa": Hausa,
        "--hawaiian": Hawayi,
        "--hebrew": Igiheburayo,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hongiriya,
        "--icelandic": Isilande, // i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indoneziya": Indoneziya,
        "--irish": Irilande,
        "--italiyani": Umutaliyani,
        "--Abayapani": Ikiyapani, // j
        "--javanese": Javanese,
        "--kannada": Kannada, // k
        "--kazakh": Qazaqistan,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--koreya": Igikoreya,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kirigizisitani,
        "--lao": Lao, // l
        "--latin": Ikilatini,
        "--latvian": Lativiya,
        "--lingala": Lingala,
        "--lituwaniya": Lituwaniya,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--Macedoniya": Makedoniya, // m
        "--maithili": Maithili,
        "--malagasy": Malagasi,
        "--malay": Malayika,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--Mongoliya": Mongoliya,
        "--myanmarBurmes": Miyanimari (Ikirundi),
        "--nepali": Nepali, // n
        "--Norwegian": Noruveje,
        "--odiaOriya": Odia (Oriya), // o
        "--oromo": Oromo,
        "--pashto": Igishinwa, // p
        "--persian": Umuperesi,
        "--polish": Igipolonye,
        "--portuguese": Igiporutugali,
        "--punjabi": Punjabi,
        "--quechua": Quechua, // q
        "--umunyamerika": Umunyarumaniya, // r
        "--russian": Ikirusiya,
        "--samoan": Samoan, // s
        "--sanskrit": Sanskrit,
        "--SotsGaelic": Abanya-Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Umuseribiya,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--Slovakiya": Igisilovakiya,
        "--Sloveniya": Igisiloveniya,
        "--somali": Somaliya,
        "--Icyesipanyoli": Icyesipanyoli,
        "--sundanese": Sundanese,
        "--igiswahili": Igiswahiri,
        "--swedish": Igisuwede,
        "--tajik": Tajik, // t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Tayilande,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turukiya,
        "--turkmen": Abanyaturukiya,
        "--twi": Twi,
        "--ukrainian": Ukraine, // u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Abanya Vietnam, // v
        "--welsh": Welsh, // w
        "--xhosa": Xhosa, // x
        "--yiddish": Yiddish, // y
        "--yoruba": Yoruba,
        "--zulu": Abazulu, // z
        },
      },

      // **konkani
      // **konkani
      konkani: {
        translations: {
           "--an error has occurred": "एक त्रुटी जाल्या!", //a
           "--address": "पत्त",
           "--advice": "सल्ल"ो, .
           "--by clicking on continue": "चालू दवरल्यार तुमी तुमच्या Veil Brillant खात्यांतल्यान काडून उडयतले", //b
           "--by clicking on disconnect you will be disconnected": "Disconnect हाचेर क्लिक केल्यार तुमी तुमच्या izocash खात्या कडल्यान डिस्कनेक्ट जातले",
           "--check your virtual number or try again later": "तुमचो आभासी क्रमांक तपासात वा फुडें परतून यत्न करात", //c
           "--check your virtual number": "तुमचो आभासी क्रमांक तपासात",
           "--continue": "चालू दवरात",
           "--connection": "जोडणी", .
           "--collaborate, live in harmony": "सहकार्य करप, हेरां वांगडा एकचारान जगप",
           "--choose language": "आभासी फोन भास",
           "--don't prevent competition": "सर्त आडावंक नाकात, सगळ्यांक संद दिवची", //d
           "--disconnection": "विच्छेदन", .
           "--for all virtual phone users": "सगळ्या आभासी फोन वापरप्यां खातीर, VPN वापरपाची शिफारस केल्या", //f
           "--go to login page": "लॉगीन पानाचेर वचचें", //g
           "--historical": "इतिहासीक", //h

           "--i have account": म्हाका पयलींच खातें आसा, //i
           "--i don't have account": म्हाका खातें ना,
           "--तुजें घर": तुजें घर,
           "--प्रतिमा / व्हिडिओ +": प्रतिमा / व्हिडिओ +,
           "--ओळख सत्यापन": वळख सत्यापन,
           "--izocash गिरायक पोर्टल": izocash गिरायक पोर्टल,
           "--दर वर्सा वळख अद्ययावत": दर वर्सा वळख अद्ययावत,
           "--izocash खरेदी करपाक": izocash खरेदी => izocash आंतरराष्ट्रीय,
           "--लॉग इन": लॉग इन!, //l
           "--लॉगिन": लॉग इन,
           "--login to veil brilliant": Veil Brillant कडेन जोडप,
           "--विक्सिनोल स्टोरांत लॉग इन करात": विक्सिनोल स्टोराक जोडणी करात,
           "--तुमच्या veil Brillant खात्यांत फुकट लॉग इन करात": हें वैशिश्ट्य ऍक्सॅस करपाक तुमच्या Veil Brillant खात्यांत फुकट लॉग इन करात,
           "--लॉगिन यशस्वी": लॉगिन यशस्वी!,
           "--आतां लॉग इन करात": आतां लॉग इन करात!,
           "--लॉगआउट यशस्वी": लॉगआउट यशस्वी!,
           "--लॉग आउट": लॉगआउट,
           "--लॉगआउट": लॉग आउट,
           "--संख्या": संख्या, //n
           "--नांव": नांव, .
           "--आतां लॉग इन करात": आतां, लॉग इन करात!,
           "--सर्त घुस्मटमार करपाचेर बंदी ना":
           "--ना मत्सर, ना दुस्वास": ना मत्सर, ना दुस्वास, ना विभाजन,
           "--ना": ना,
           "--तुमचो आभासी फोन ऍक्सॅस करपाक अधिकृत पत्ते": तुमचो आभासी फोन ऍक्सॅस करपाक अधिकृत पत्ते, //o
           "--पासवर्ड": पासवर्ड, //p
           "--बिंदू काडप izocash": गुण काडप izocash,
           "--बिंदू काडप": गुण काडप,
           "--बरें, vpn वापरात": बऱ्यांतलें बरें, तुमच्या इंटरनॅट सेवा पुरवणदाराक नाशिल्लो VPN वापरात,
           "--जिद्द सदांच फायद्याचें": जिद्द सदांच निमाणें फायद्याचें जाता,
           "--नियम": नेम, //r
           "--शिफारशी": शिफारशी,
           "--नोंदणी": नोंदणी,
           "--signup to veil brilliant": Veil Brillant, //s चेर नोंदणी करात
           "--विक्सिनोल स्टोरांत सायनअप करात": विक्सिनोल स्टोराचेर नोंदणी करात,
           "--साइनअप": नोंदणी करात,
           "--साइनअप यशस्वी": नोंदणी यशस्वी!,
           "--फुकट सायनअप करात": फुकट नोंदणी करात,
           “--साइनअप यशस्वी आयए”: जोडणी यशस्वी”,
           "--सेटिंग्स": "सेटिंग्स",
           "--alrani ऍप्लिकेशन सेट करप": Alrani ऍप्लिकेशन संरचीत करप,
           "--izocash ऍप्लिकेशन सेट करप": izocash ऍप्लिकेशन संरचीत करप,
           "--विक्सिनोल ऍप्लिकेशन सेट करप": विक्सिनोल ऍप्लिकेशन संरचीत करप,
           "--घटक ब्रिलंट ऍप्लिकेशन सेट करप": व्हील ब्रिलंट ऍप्लिकेशन संरचीत करप,
           "--प्रतिमा, व्हिडियो सांठोवप": प्रतिमा, व्हिडियो आनी हेर जायत्या घटकांचो सांठो,
           "--प्राप्तीची गती": डेटासेंटरांतल्यान डेटा मेळोवपाची गती,
           "--गती": गती, .
           "--समाप्त करप": समाप्त करप, //t
           "--the vpn तुमकां ऍक्सॅस करपाक परवानगी दिता": VPN तुमकां तुमच्या इंटरनॅट सेवा पुरवणदारान ब्लॅकलिस्ट केल्ली साइट वा ऍप्लिकेशन ऍक्सॅस करूंक परवानगी दिता,
           "--सगल्यांत व्हडलें झाड वयर आशिल्लें": सगळ्यांत व्हडलें झाड सगळ्यांत चड सादें ल्हान बीं आशिल्लें,
           "--स्क्रीनाक स्पर्श करचो": चालू दवरपाक पडद्याक स्पर्श करचो,
           "--परत प्रयत्न कर": परत प्रयत्न कर!,
           "--वापरप्याचें नांव": वापरप्याचें नांव, //u

           "--आभासी क्रमांक": आभासी क्रमांक, //v
           "--आभासी फोन मांडावळी": आभासी फोन मांडावळी,
           "--आभासी फोन भास लागू केल्या": आभासी फोन भास पूर्वनिर्धारीतपणान ऍप्लिकेशन पातळेचेर लागू जाता,
           "--आभासी फोन": आभासी फोन,
           "--मान्य करप": प्रमाणीत करप,
           "--izocash गिरायक पोर्टलाक येवकार": izocash गिरायक पोर्टलाक येवकार, //w
           "--सुपर कोड बरयात": सुपर कोड दाखयात,
           "--येवकार": येवकार,
           "--जंय लोकांचें लक्ष वता": जंय लोकांचें लक्ष वता पयशे वतात,
           "--विजेते जिद्द करतात": विजेते जिद्द करतात,
           "--तुमकां तुमच्या आल्रानी खात्यांतल्यान लॉग आउट करपाक आवडटलें": तुमकां तुमच्या आल्रानी खात्यांतल्यान लॉग आउट करपाक जाय?,
           "--होय": हय, //य

           // देश
           "--कांगो": काँगो ब्राझाविले, 1999.
           "--कॅमेरून": कॅमेरून,
           "--drc": डीआरसी, 1999.
           "--ivoryCoast": हस्तिदंत कोस्ट, 1999.

           // langue हें नांव
        "--आफ्रिकन": आफ्रिकन, //अ
        "--अल्बेनियन": आल्बेनियन,
        "--अम्हारिक": अमहारिक,
        "--अरबी": अरबी,
        "--आर्मेनिया": आर्मेनियाई,
        "--आसामी": आसामी,
        "--आयमारा": आयमारा, २.
        "--आझरबैजानी": आझरबैजानी,
        "--बांबरा": बांबारा, //ब
        "--बास्क": बास्क,
        "--बेलारूसी": बेलारूसी,
        "--बंगाली": बंगाली,
        "--भोजपुरी": भोजपुरी,
        "--बोस्नियाई": बोस्नियाई,
        "--बल्गेरियन": बल्गेरियन,
        "--कातालान": कातालान, //सी
        "--सेबुआनो": सेबुआनो,
        "--चिचेवा": चिचेवा,
        "--chineseSimplified": चीनी (सरलीकृत),
        "--chineseTraditional": चीनी (पारंपारीक),
        "--कॉर्सिकन": कोर्सिकन,
        "--क्रोएशियन": क्रोएशियन,
        "--चेक": चेक,
        "--danish": डॅनीश, //d
        "--धिवेही": धिवेही, २.
        "--डोगरी": डोगरी, २.
        "--डच": डच,
        "--इंग्लीश": इंग्लीश, //e
        "--एस्पेरान्तो": एस्पेरान्तो,
        "--एस्टोनियाई": एस्टोनियाई,
        "--मेवडें": मेढरां, २.
        "--फिलिपिनो": फिलीपीनो, //f
        "--फिनिश": फिनिश,
        "--फ्रेंच": फ्रेंच,
        "--फ्रीझियन": फ्रीसियन,
        "--गॅलिशियन": गॅलिशियन, //जी
        "--जॉर्जियन": जॉर्जियन,
        "--जर्मन": जर्मन,
        "--ग्रीक": ग्रीक,
        "--गुआरानी": गुआरानी,
        "--गुजरती": गुजराती, २.
        "--haitianCreole": हैती क्रियोल, //h
        "--हौसा": हौसा, २.
        "--हवाईयन": हवाईयन,
        "--हिब्रू": हिब्रू,
        "--हिंदी": हिंदी,
        "--हमोंग": ह्मोंग, .
        "--हंगेरी": हंगेरी,
        "--आयसलँडिक": आयसलँडिक, //i
        "--इग्बो": इग्बो,
        "--इलोकानो": इलोकानो,
        "--इंडोनेशियन": इंडोनेशियन,
        "--आयरिश": आयरीश,
        "--इटालियन": इटालियन,
        "--जपानी": जपानी, //j
        "--जावानी": जावानी,
        "--कन्नड": कन्नड, //k
        "--कझाख": कझाख,
        "--खमेर": ख्मेर, ४.
        "--किन्यारवांडा": किन्यारवांडा,
        "--konkani": कोंकणी, २.
        "--कोरियन": कोरियन,
        "--क्रिओ": क्रिओ, ९.
        "--kurdishKurmanji": कुर्द (कुर्मनजी),
        "--kurdishSorani": कुर्द (सोरानी),
        "--किर्गिझ": किर्गिझ,
        "--लाओ": लाओ, //l
        "--लॅटीन": लॅटीन,
        "--लॅट्वियन": लॅटव्हियन,
        "--लिंगला": लिंगला,
        "--लिथुआनियाई": लिथुआनियाई,
        "--लुगांडा": लुगांडा,
        "--लक्समबर्गिश": लक्समबर्ग,
        "--मॅसिडोनियाई": मॅसिडोनियाई, //म
        "--मैथिली": मैथिली,
        "--मालागासी": मालागासी,
        "--मलय": मलय, २.
        "--मलयाळम": मलयाळम,
        "--माल्टीज": माल्टीज,
        "--माओरी": माओरी,
        "--मराठी": मराठी, २.
        "--meiteilonManipuri": Meiteilon (मणिपुरी),
        "--मिझो": मिझो, 1999.
        "--मंगोलियन": मंगोलियन,
        "--myanmarबर्मी": म्यानमार (बर्मी),
        "--नेपाली": नेपाली, //n
        "--नॉर्वेजियन": नॉर्वेजियन,
        "--ओडियाओरिया": ओडिया (ओडिया), //ओ
        "--ओरोमो": ओरोमो,
        "--पश्तो": पश्तो, //पृ
        "--फारसी": फार्सी,
        "--पालिश": पोलिश,
        "--पोर्तुगेज": पोर्तुगेज,
        "--पंजाबी": पंजाबी,
        "--क्वेचुआ": क्वेचुआ, //q
        "--रोमानियन": रोमानियन, //आर
        "--रशियन": रशियन,
        "--सामोआन": समोआन, //s
        "--संस्कृत": संस्कृत, २.
        "--scotsGaelic": स्कॉट्स गेलिक,
        "--सेपेडी": सेपेडी, 1999.
        "--सर्बियाई": सर्बियन,
        "--सेसोथो": सेसोथो, 1999.
        "--शोना": शोना, २.
        "--सिंधी": सिंधी, २.
        "--सिंहल": सिंहली,
        "--स्लोव्हाक": स्लोवाक,
        "--स्लोवेनिया": स्लोवेनियाई,
        "--सोमाली": सोमाली,
        "--स्पेनिश": स्पॅनिश,
        "--सुंडानीज": सुंडानी,
        "--स्वाहिली": स्वाहिली,
        "--स्वीडीश": स्विडीश,
        "--ताजिक": ताजिक, //टी
        "--तमिळ": तमिळ,
        "--तातार": तातार, ९.
        "--तेलुगू": तेलुगू,
        "--थाई": थाई,
        "--तिग्रीन्या": तिग्रीन्या, २.
        "--त्सोंगा": त्सोंगा, 1999.
        "--तुर्की": तुर्की,
        "--तुर्कमेन": तुर्कमेन,
        "--twi": ट्वी, 1999.
        "--युक्रेनियन": युक्रेनियन, //u
        "--उर्दू": उर्दू, २.
        "--उयघुर": उयघुर, २.
        "--उझबेक": उझबेक,
        "--व्हिएतनामी": व्हिएतनामी, //v
        "--वेल्श": वेल्श, //डब्ल्यू
        "--xhosa": क्षोसा, //x
        "--यिद्दीश": यिद्दीश, //y
        "--योरूबा": योरूबा,
        "--झुलु": झुलु, //झ
        },
      },

      // **korean
      // **korean
      korean: {
        translations: {
          "--an error has occurred": "오류가 발생했습니다!", //a
          "--address": "주소",
          "--advice": "조언",
          "--by clicking on continue": "계속을 클릭하면 Veil Brillant 계정 연결이 끊어집니다", //b
          "--by clicking on disconnect you will be disconnected": "연결 끊기를 클릭하면 izocash 계정에서 연결이 끊어집니다",
          "--check your virtual number or try again later": "가상번호를 확인하거나 나중에 다시 시도하세요", //c
          "--check your virtual number": "가상번호를 확인하세요",
          "--continue": "계속",
          "--connection": "연결",
          "--collaborate, live in harmony": "협력하고, 다른 사람들과 조화롭게 생활하며",
          "--choose language": "가상 전화 언어",
          "--don't prevent competition": "경쟁을 방지하지 말고 모든 사람에게 기회를 주십시오", //d
          "--disconnection": "연결 해제",
          "--for all virtual phone users": "모든 가상 전화 사용자에게는 VPN 사용을 권장합니다", //f
          "--go to login page": "로그인 페이지로 이동", //g
          "--historical": "역사적", //h

          "--i have account": 이미 계정이 있습니다. //i
          "--i don't have account": 계정이 없습니다.
          "--그것은 당신의 집입니다": 그것은 당신의 집입니다,
          "--이미지 / 비디오 +": 이미지 / 비디오 +,
          "--identity verify": 신원 확인,
          "--izocash 고객 포털": izocash 고객 포털,
          "--매년 신원 업데이트": 매년 신원 업데이트,
          "--izocash 구매": izocash 구매 => izocash 국제,
          "--로그인": 로그인!, //l
          "--login": 로그인,
          "--login to 베일 브릴리언트": Veil Brillant에 연결,
          "--빅시놀 스토어에 로그인": 빅시놀 스토어에 연결합니다.
          "--veil Brillant 계정에 무료로 로그인": 이 기능에 액세스하려면 Veil Brillant 계정에 무료로 로그인하세요.
          "--로그인 성공": 로그인 성공!,
          "--지금 로그인": 지금 로그인하세요!,
          "--로그아웃 성공": 로그아웃 성공!,
          "--로그아웃": 로그아웃,
          "--logout": 로그아웃,
          "--number": 숫자, //n
          "--name": 이름,
          "--이제 로그인": 이제 로그인하세요!,
          "--압박적인 경쟁을 금지하지 않습니다":
          "--질투도 없고 미움도 없고": 질투도 없고 미움도 없고 분열도 없고
          "--아니 아니,
          "--가상 전화에 액세스하기 위한 공식 주소": 가상 전화에 액세스하기 위한 공식 주소, //o
          "--password": 비밀번호, //p
          "--포인트 인출 izocash": 포인트 인출 izocash,
          "--포인트 인출": 포인트 인출,
          "--vpn을 사용하는 것이 좋습니다.": 인터넷 서비스 제공업체에 속하지 않는 VPN을 사용하는 것이 좋습니다.
          "--지속성은 항상 보상을 받습니다.": 지속성은 항상 결국에는 보상을 받습니다.
          "--rule": 규칙, //r
          "--recommendation": 권장 사항,
          "--등록": 등록,
          "--signup to 베일 브릴리언트": Veil Brillant에 등록, //s
          "--signup to vixinol store": 빅시놀 스토어에 등록하세요.
          "--signup": 등록,
          "--signupuccess": 등록 성공!,
          "--signup for free": 무료로 등록합니다.
          "--가입 성공 IA": 연결 성공",
          "--settings": "설정",
          "--alrani 앱 설정": Alrani 애플리케이션 구성,
          "--izocash 앱 설정": izocash 애플리케이션 구성,
          "--vixinol 앱 설정": Vixinol 애플리케이션 구성,
          "--베일 Brillant 앱 설정": Veil Brillant 애플리케이션 구성,
          "--이미지, 비디오 저장": 이미지, 비디오 및 기타 여러 요소 저장,
          "--speed of receive": 데이터센터로부터의 데이터 수신 속도,
          "--speed": 속도,
          "--terminate": 종료, //t
          "--VPN을 사용하면 액세스할 수 있습니다.": VPN을 사용하면 인터넷 서비스 제공업체가 블랙리스트에 추가한 사이트나 애플리케이션에 액세스할 수 있습니다.
          "--가장 큰 나무가 위에 있었다": 가장 큰 나무는 무엇보다도 단순한 작은 씨앗이었습니다.
          "--화면 터치": 계속하려면 화면을 터치하세요.
          "--다시 시도": 다시 시도하세요!,
          "--username": 사용자 이름, //u

          "--virtual number": 가상 번호, //v
           "--가상 전화 설정": 가상 전화 설정,
           "--virtual Phone 언어가 적용됩니다": 가상 전화 언어는 기본적으로 애플리케이션 수준에서 적용되며,
           "--가상 전화": 가상 전화,
           "--validate": 유효성을 검사합니다,
           "--izocash 고객 포털에 오신 것을 환영합니다": izocash 고객 포털에 오신 것을 환영합니다, //w
           "--슈퍼 코드 작성": 슈퍼 코드를 입력하고,
           "--환영합니다": 환영합니다,
           "--사람들의 관심이 가는 곳": 사람들의 관심이 가는 곳에 돈이 가고,
           "--winners persevere": 승자는 인내합니다.
           "--Alrani 계정에서 로그아웃하시겠습니까?": Alrani 계정에서 로그아웃하시겠습니까?,
           "--yes": 예, //y

           // 국가
           "--congo": 콩고 브라자빌,
           "--카메룬": 카메룬,
           "--drc": DRC,
           "--ivoryCoast": 코트디부아르,

           // 랑그
        "--afrikaans": 아프리칸스어, //a
        "--albanian": 알바니아어,
        "--amharic": 암하라어,
        "--아랍어": 아랍어,
        "--아르메니아어": 아르메니아어,
        "--assamese": 아삼어,
        "--aymara": 아이마라어,
        "--azerbaijani": 아제르바이잔어,
        "--bambara": 밤바라, //b
        "--basque": 바스크어,
        "--belarusian": 벨로루시어,
        "--벵골어": 벵골어,
        "--bhojpuri": 보즈푸리,
        "--bosnian": 보스니아어,
        "--bulgarian": 불가리아어,
        "--catalan": 카탈로니아어, //c
        "--cebuano": 세부아노어,
        "--치체와": 치체와어,
        "--chineseSimplified": 중국어(간체),
        "--chineseTraditional": 중국어(번체),
        "--코르시카어": 코르시카어,
        "--croatian": 크로아티아어,
        "--czech": 체코어,
        "--danish": 덴마크어, //d
        "--dhivehi": 디베히어,
        "--dogri": 도그리,
        "--dutch": 네덜란드어,
        "--english": 영어, //e
        "--esperanto": 에스페란토,
        "--에스토니아어": 에스토니아어,
        "--ewe": 에웨,
        "--filipino": 필리핀어, //f
        "--finnish": 핀란드어,
        "--프랑스어": 프랑스어,
        "--프리지아어": 프리지아어,
        "--galician": 갈리시아어, //g
        "--georgian": 그루지야어,
        "--german": 독일어,
        "--그리스어": 그리스어,
        "--과라니": 과라니어,
        "--gujarati": 구자라트어,
        "--haitianCreole": 아이티 크리올어, //h
        "--hausa": 하우사,
        "--hawaiian": 하와이어,
        "--히브리어": 히브리어,
        "--힌디어": 힌디어,
        "--hmong": 몽족,
        "--헝가리어": 헝가리어,
        "--아이슬란드어": 아이슬란드어, //i
        "--igbo": 이그보,
        "--ilocano": 일로카노,
        "--indonesian": 인도네시아어,
        "--irish": 아일랜드어,
        "--italian": 이탈리아어,
        "--japanese": 일본어, //j
        "--javanese": 자바어,
        "--칸나다어": 칸나다어, //k
        "--kazakh": 카자흐어,
        "--khmer": 크메르어,
        "--kinyarwanda": 키냐르완다,
        "--konkani": 콘카니,
        "--한국어": 한국어,
        "--krio": 크리오,
        "--kurdishKurmanji": 쿠르드어(Kurmanji),
        "--kurdishSorani": 쿠르드어(Sorani),
        "--kyrgyz": 키르기스어,
        "--lao": 라오스어, //l
        "--latin": 라틴어,
        "--latvian": 라트비아어,
        "--lingala": 링갈라,
        "--리투아니아어": 리투아니아어,
        "--luganda": 루간다어,
        "--luxembourgish": 룩셈부르크어,
        "--마케도니아어": 마케도니아어, //m
        "--maithili": 마이틸리,
        "--malagasy": 마다가스카르어,
        "--malay": 말레이어,
        "--malayalam": 말라얄람어,
        "--maltese": 몰타어,
        "--마오리": 마오리,
        "--marathi": 마라티어,
        "--meiteilonManipuri": 메이테일론(마니푸리),
        "--mizo": 미조,
        "--mongolian": 몽골어,
        "--myanmarBurmese": 미얀마(버마어),
        "--nepali": 네팔어, //n
        "--norwegian": 노르웨이어,
        "--odiaOriya": 오디아(오리야어), //o
        "--oromo": 오로모,
        "--pashto": 파슈토어, //p
        "--페르시아어": 페르시아어,
        "--polish": 폴란드어,
        "--포르투갈어": 포르투갈어,
        "--펀잡어": 펀잡어,
        "--quechua": 케추아어, //q
        "--romanian": 루마니아어, //r
        "--russian": 러시아어,
        "--samoan": 사모아어, //s
        "--산스크리트어": 산스크리트어,
        "--scotsGaelic": 스코틀랜드 게일어,
        "--sepedi": 세페디,
        "--serbian": 세르비아어,
        "--세소토": 세소토어,
        "--shona": 쇼나,
        "--sindhi": 신디,
        "--sinhala": 싱할라어,
        "--slovak": 슬로바키아어,
        "--슬로베니아어": 슬로베니아어,
        "--somali": 소말리아어,
        "--spanish": 스페인어,
        "--순다어": 순다어,
        "--swahili": 스와힐리어,
        "--스웨덴어": 스웨덴어,
        "--tajik": 타지크어, //t
        "--타밀어": 타밀어,
        "--tatar": 타타르어,
        "--telugu": 텔루구어,
        "--thai": 태국어,
        "--tigrinya": 티그리냐,
        "--tsonga": 총가,
        "--turkish": 터키어,
        "--turkmen": 투르크멘어,
        "--twi": 트위,
        "--ukrainian": 우크라이나어, //u
        "--urdu": 우르두어,
        "--uyghur": 위구르어,
        "--uzbek": 우즈베크어,
        "--베트남어": 베트남어, //v
        "--welsh": 웨일스어, //w
        "--xhosa": 코사어, //x
        "--yiddish": 이디시어, //y
        "--yoruba": 요루바어,
        "--zulu": 줄루어, //z
        },
      },

      // **krio
      // **krio
      krio: {
        translations: {
          "--an error has occurred": "Wan mistek dɔn apin!", //a
          "--address": "Adrɛs dɛn",
          "--advice": "Advays",
          "--by clicking on continue": "We yu klik pan kɔntinyu yu go diskɔnekt frɔm yu Veil Brillant akɔn", //b
          "--by clicking on disconnect you will be disconnected": "We yu klik pan Disconnect yu go diskonekt frɔm yu zocash akɔn",
          "--check your virtual number or try again later": "Chɛk yu vayrɔyal nɔmba ɔ tray bak leta", //c
          "--check your virtual number": "Chɛk yu vayrɔyal nɔmba",
          "--continue": "Kɔntinyu",
          "--connection": "Kɔnɛkshɔn",
          "--collaborate, live in harmony": "Kolaborate, liv in harmoni wit oda pipul",
          "--choose language": "Vayrɔyal Fɔn Langwej",
          "--don't prevent competition": "Nɔ mek kɔmpitishɔn, gi ɔlman chans", //d
          "--disconnection": "Diskɔnekshɔn",
          "--for all virtual phone users": "Fɔ ɔl di wan dɛn we de yuz Vayrɔyal Fɔn, i fayn fɔ yuz VPN", //f
          "--go to login page": "Go to di login pej", //g
          "--historical": "Istrikal", //h

           "--a gɛt akɔn": A dɔn gɛt akɔn, //i
           "--a nɔ gɛt akɔn": A nɔ gɛt akɔn,
           "--na yu os": na yu os,
           "--imej / vidio +": Imej / Vidio +,
           "--aydentiti verifyeshɔn": Aydentiti verifyeshɔn, .
           "--izocash kɔstɔma pɔtal": izocash Kastamɔ Pɔtal,
           "--aydentiti ɔpdet ɛvri ia": Aydentiti ɔpdet ɛvri ia,
           "--izocash bay to": izocash Bay => izocash intanashɔnal,
           "--log in": Lɔg in!, //l
           "--login": Lɔg in, .
           "--lɔgin fɔ vel briliant": Kɔnekt to Veil Brillant,
           "--login to vixinol stoa": Kɔnekt to Vixinol Stɔ,
           "--login fɔ fri to yu veil Brillant akɔn": Log in fɔ fri to yu Veil Brillant akɔn fɔ akses dis ficha,
           "--login sakses": Login saksesful!,
           "--login naw": Log in naw!,
           "--logout sakses": Logout saksesful!,
           "--lɔg ɔut": Lɔg ɔut,
           "--logout": Lɔg ɔut, .
           "--nɔmba": Nɔmba, //n
           "--nem": Nem, .
           "--naw log in": Naw, Log in!,
           "--nɔ ban fɔ stif kɔmpitishɔn":
           "--nɔ jɛlɔs, nɔ et": Nɔ jɛlɔs, nɔ et, nɔ divɛlɔpmɛnt,
           "--nɔ": Nɔ, .
           "--ɔfishal adrɛs fɔ akses yu vayrɔyal fon": Ɔfishal adrɛs fɔ akses yu vayrɔyal fon, //o
           "--paswɔd": Paswɔd, //p
           "--points witdraws izocash": Points witdraws izocash,
           "--points we dɛn pul": Points we dɛn pul,
           "--i bɛtɛ fɔ yuz vpn": I bɛtɛ fɔ yuz VPN we nɔto yu intanɛt savis prɔvayda in yon,
           "--persistence always pays off": Prɛsistɛns ɔltɛm de pe ɔf na di ɛnd,
           "--rul": Rul dɛn, //r
           "--rɛkɔmɛnd": Rikɔmɛndishɔn, .
           "--rɛjista": Rɛjista, .
           "--sayn fɔ vel briliant": Rɛjista pan Veil Brillant, //s
           "--sayn ap to vixinol stoa": Rɛjista na Vixinol Stɔ,
           "--sayn ap": Rɛjista, .
           "--sayn ap sakses": Rejista saksesful!,
           "--sayn fɔ fri": Rɛjista fɔ fri,
           “--sayn ap sakses IA”: Kɔnɛkshɔn saksesful”,
           "--sɛtin dɛn": "Sɛtin dɛn",
           "--set up di alrani ap": Kɔnfigyut di Alrani aplikeshɔn,
           "--set up di izocash ap": Kɔnfigyut di izocash aplikeshɔn,
           "--set up di vixinol ap": Kɔnfigyut di Vixinol aplikeshɔn,
           "--set up di veil Brillant ap": Kɔnfigyut di Veil Brillant aplikeshɔn,
           "--stɔrɔj ​​fɔ pikchɔ, vidio": Stɔrej fɔ pikchɔ, vidio ɛn sɔm ɔda ɛlimɛnt dɛn,
           "--spid fɔ risepshɔn": Spid fɔ risepshɔn fɔ di data frɔm di Datasenta,
           "--spid": Spid, .
           "--terminate": Tεrminεt, //t
           "--di vpn alaw yu fɔ akses": Di VPN de alaw yu fɔ akses sayt ɔ aplikeshɔn we yu intanɛt savis provayda dɔn blaklist,
           "--di big tik bin de ɔp": Di tik we big pas ɔl bin de ɔp ɔl wan simpul smɔl sid,
           "--tɔch di skrin": Tɔch di skrin fɔ kɔntinyu,
           "--tray bak": Tray bak!,
           "--yuz nem": Yuz nem, //u

           "--virtual nɔmba": Virtual nɔmba, //v
           "--virtual fon sɛtin": Virtual fon sɛtin,
           "--virtual Phone language is applied": Di Virtual Phone langwej de aplay na di aplikeshɔn lɛvɛl bay difɔlt,
           "--virtual fon": Vayrɔyal fon,
           "--validɛt": Validɛt, .
           "--wɛlkɔm to di izocash kɔstɔma pɔtal": Wɛlkɔm to di izocash Kastamɔ Pɔtal, //w
           "--rayt wan supa kɔd": Ɛntay wan Supa kɔd,
           "--welkam to": Welkam to,
           "--wea pipul atenshon de go": Wea pipul atenshon de go moni go,
           "--winners persevere": Di wan dɛn we win de peshɛnt,
           "--yu go lɛk fɔ kɔmɔt na yu Alrani akɔn": Yu want fɔ kɔmɔt na yu Alrani akɔn?,
           "--yes": Yɛs, //y

           // kɔntri
           "--kongo": Kongo Brazavil,
           "--kamɛrun": Kamɛrun,
           "--drc": DRC, 1999.
           "--ivoryCoast": Ayvri Kost,

          // langwej
        "--afrikaans": Afrikaans, //a
        "--albanian": Albanian, .
        "--amharic": Amharik, .
        "--arabik": Arabik, .
        "--amɛnian": Amɛnian, .
        "--asam": Asam, .
        "--aymara": Aymara, .
        "--azerbaijani": Azaybayjani, .
        "--bambara": Bambara, //b
        "--bask": Bask, .
        "--belarusian": Belarusian, .
        "--bengali": Bɛngali, .
        "--bhojpuri": Na Bhojpuri, .
        "--bosnian": Bɔsnian, .
        "--bulgarian": Bɔlgarian, .
        "--katalan": Katalan, //c
        "--sɛbuano": Sibuano,
        "--chichewa": Chichewa, 2019.
        "--chineseSimplified": Chaynish (Simplified),
        "--chineseTraditional": Chaynish (Tradishɔnal),
        "--kɔrsikan": Kɔsikan, .
        "--kroeshian": Kroeshian,
        "--chɛk": Chɛk,
        "--danish": Danish, //d
        "--divɛhi": Dhivehi, .
        "--dogri": Dɔgri, .
        "--dɔch": Dɔch, .
        "--inglish": Inglish, //e
        "--ɛsperanto": Ɛsperanto, .
        "--estonian": Ɛstonia, .
        "--ewe": Ewe, .
        "--filipino": Filipino, //f
        "--finnish": Finnish, .
        "--french": Frɛnch, .
        "--frisian": Frisian, .
        "--galician": Galisian, //g
        "--jiɔjian": Jɔjian, .
        "--jaman": Jaman,
        "--grik": Grik, .
        "--guarani": Guarani, .
        "--gujarati": Gujarati, .
        "--haitianKriɔl": Haitian Krio, //h
        "--hausa": Hausa, .
        "--hawaiian": Awayian, .
        "--ibru": Ibru, .
        "--hindi": Hindi, .
        "--hmong": Hmong, .
        "--ɔngari": Ɔngari, .
        "--aylandik": Ayland, //i
        "--igbo": Igbo, .
        "--ilokano": Ilokano, .
        "--indonishian": Indonishian, .
        "--irish": Ayrish, .
        "--italian": Italiyan, .
        "--japan": Japan, //j
        "--javanese": Javan, .
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Kmɛri, .
        "--kinyarwanda": Kinyarwanda, .
        "--konkani": Konkani,
        "--korian": Korian, .
        "--krio": Krio, 1999.
        "--kurdishKurmanji": Kurdish (Kurmanji), .
        "--kurdishSorani": Kurdish (Sorani), .
        "--kyrgyz": Kirgiz, .
        "--lao": Lao, //l
        "--latin": Latin, .
        "--latvian": Latvian, .
        "--lingala": Lingala, .
        "--lituanian": Lituɛnia, .
        "--luganda": Luganda, 2019.
        "--lɔksmbɔrgish": Laksambɔrgish,
        "--masidonian": Masidonian, //m
        "--maithili": Maithili, .
        "--malagasi": Malagasy, .
        "--malay": Malay, .
        "--malayalam": Malayalam, .
        "--maltese": Mɔltɔ, .
        "--maori": Maori, .
        "--marathi": Marathi, 2019.
        "--meiteilonManipuri": Meiteilon (Manipuri), we gɛt di taytul.
        "--mizo": Mizo, .
        "--mɔngolian": Mɔngolian, .
        "--myanmarBɔm": Mianma (Bɔm),
        "--nɛpali": Nepali, //n
        "--nɔwej": Nɔwe, .
        "--odiaOriya": Ɔdia (Oriya), //o
        "--oromo": Ɔromo, .
        "--pashto": Pashto, //p
        "--pasian": Pashya, .
        "--polish": Polish, .
        "--pɔtogis": Pɔtyugis, .
        "--punjabi": Panjabi, .
        "--kɛchua": Kwɛchua, //q
        "--romanian": Romanian, //r
        "--rɔshian": Rɔshian, .
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Skɔt Gelik,
        "--sepedi": Sɛpidi, 2019.
        "--sɛbian": Sɛbian, .
        "--sɛsoto": Sɛsoto, .
        "--shona": Shona, .
        "--sindhi": Sindhi, 2019.
        "--sinhala": Sinhala, .
        "--slovak": Slovak,
        "--slɔvenian": Slɔvenian, .
        "--somali": Sɔmali, .
        "--spanish": Spanish, .
        "--sundanese": Sɔndanis, .
        "--swahili": Swahili, .
        "--swedish": Swedish, .
        "--tajik": Tajik, //t
        "--tamil": Tamil, .
        "--tatar": Tatar, .
        "--telugu": Telugu, 1999.
        "--thai": Tayland,
        "--tigrinya": Tigrinya, .
        "--tsonga": Tsonga, 2019.
        "--tɔk": Turkish, .
        "--turkmen": Turkmen, .
        "--twi": Twi, 2019.
        "--ukren": Yukren, //u
        "--urdu": Ɔdu, .
        "--uyghur": Uyghur, .
        "--uzbek": Ɔzbek, .
        "--vietnam": Vietnamese, //v
        "--welsh": Wɛlsh, //w
        "--xhosa": Ksosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba, .
        "--zulu": Zulu, //z
        },
      },

      // Kurdish (Kurmanji)
      // Kurdish (Kurmanji)
      kurdishKurmanji: {
        translations: {
           "--an error has occurred": "Çewtiyek çêbû!", //a
           "--address": "Navnîşan",
           "--advice": "Şîret",
           "--by clicking on continue": "Bi tikandina li ser berdewamkirinê hûn ê ji hesabê xweya Veil Brillant qut bibin", //b
           "--by clicking on disconnect you will be disconnected": "Bi tikandina li ser Veqetandinê hûn ê ji hesabê xweya izocash qut bibin",
           "--check your virtual number or try again later": "Jimara xweya virtual kontrol bike an paşê dîsa biceribîne", //c
           "--check your virtual number": "Jimara xweya virtual kontrol bike",
           "--continue": "Berdewam bike",
           "--connection": "Têkilî",
           "--collaborate, live in harmony": "Hevkarî, bi yên din re bi hev re bijîn",
           "--choose language": "Zimanê Telefonê Virtual",
           "--don't prevent competition": "Pêşberî pêşbaziyê negirin, derfetê bidin her kesî", //d
           "--disconnection": "Veqetandin",
           "--for all virtual phone users": "Ji bo hemî bikarhênerên Têlefona Virtual, tê pêşniyar kirin ku VPN bikar bînin", //f
           "--go to login page": "Biçe rûpela têketinê", //g
           "--historical": "Dîrokî", //h

           "--hesabê min heye": Jixwe hesabek min heye, //i
           "--hesabê min tune": Hesabê min tune,
           "-- mala te ye": ew mala te ye,
           "--wêne / vîdyo +": Wêne / Vîdyo +,
           "--verastkirina nasnameyê": Verastkirina nasnameyê,
           "--portala xerîdar izocash": Portala xerîdar izocash,
           "--her sal nûvekirina nasnameyê": Her sal nûvekirina nasnameyê,
           "--izocash buy to": izocash Buy => izocash navneteweyî,
           "--log in": Têkeve!, //l
           "--login": Têkeve,
           "--login bo veil brilliant": Bi Veil Brillant ve girêdin,
           "--têketin dikana vixinol": Têkeve Store Vixinol,
           "-- belaş têkeve hesabê xweya veil Brillant": Ji bo gihîştina vê taybetmendiyê belaş têkeve hesabê xweya Veil Brillant,
           "--serkeftina têketinê": Têketin serketî!,
           "--niha têketinê": Niha têkeve!,
           "--logout serkeftin": Derketin serketî!,
           "--log out": Derketin,
           "--logout": Derketin,
           "--hejmar": Hejmar, //n
           "--name": Nav,
           "--niha têketinê": Niha, Têkeve!,
           "--ne qedexeya pêşbaziya xitimandinê":
           "--ne çavnebarî, bê nefret": Bê çavnebarî, bê kîn, bê dubendî,
           "--no": Na,
           "--Navnîşanên fermî ji bo gihîştina têlefona xweya virtual": Navnîşanên fermî ji bo gihîştina têlefona xweya virtual, //o
           "--password": Şîfre, //r
           "--points drawals izocash": Points Driving izocash,
           "--vekişandina xalan": Vekêşana xalan,
           "--tercîh e, vpn bikar bînin": Bi tercîh, VPN-ya ku ne aîdî pêşkêşvanê karûbarê weya înternetê ye bikar bînin,
           "-- îsrar her dem berdêl dide": israr tim di dawiyê de berdêl dide,
           "--rule": Rêgez, //r
           "--pêşniyar": Pêşniyar,
           "--qeydkirin": Qeydkirin,
           "--signup to veil brilliant": Li Veil Brillant qeyd bikin, //s
           "--tevlî dikana vixinol": Li Vixinol Store qeyd bikin,
           "--signup": Qeyd bike,
           "--serkeftina qeydkirinê": Qeydkirin serketî bû!,
           "-- belaş qeyd kirin": Belaş qeyd bikin,
           "--serkeftina qeydkirinê IA": Têkilî serketî",
           "--settings": "Settings",
           "--sazkirina sepana alrani": Veavakirina sepana Alrani,
           "--sazkirina sepana izocash": Veavakirina sepana izocash,
           "--sazkirina sepana vixinol": Veavakirina sepana Vixinol,
           "--sazkirina sepana veil Brillant": Veavakirina sepana Veil Brillant,
           "--parkirina wêneyan, vîdyoyan": Parzûnkirina wêneyan, vîdyoyan û çend hêmanên din,
           "--leza wergirtinê": Leza wergirtina daneyan ji Navenda Daneyê,
           "--speed": Lez,
           "--dawîkirin": Dawî, //t
           "--vpn destûrê dide te ku hûn bigihîjin": VPN dihêle hûn bigihîjin malperek an serîlêdanek ku pêşkêşvanê karûbarê weya înternetê xistiye lîsteya reş,
           "-- Dara herî mezin li jor bû": Dara herî mezin berî her tiştî toveke piçûk a hêsan bû,
           "--touch the screen": Ji bo berdewamiyê bi ekranê bigerin,
           "-- dîsa biceribîne": Dîsa biceribîne!,
           "--username": Navê bikarhêner, //u

           "--hejmara virtual": Hejmara virtual, //v
           "--Mîhengên têlefona virtual": Mîhengên têlefonê yên virtual,
           "--Zimanê Têlefonê Virtual tê sepandin": Zimanê Têlefonê Virtual ji hêla xwerû ve di asta serîlêdanê de tê sepandin,
           "--telefona virtual": Telefona virtual,
           "--validate": Rastkirin,
           "--bi xêr hatî portalê xerîdar izocash": Bi xêr hatî Portala Xerîdar izocash, //w
           "--kodek super binivîse": Kodek Super binivîse,
           "--welcome to": Bi xêr hatî,
           "-- cihê ku bala mirovan diçe": Cihê ku bala mirovan diçe pere diçe,
           "--winners persevere": Serketî berdewam dikin,
           "--dixwazî ​​ji hesabê xwe yê Alrani derkevî": Ma tu dixwazî ​​ji hesabê xwe yê Alranî derkevî?,
           "--erê": Belê, //y

           // welat
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerûn,
           "--drc": DRC,
           "--IvoryCoast": Perava Fîlan,

           // ziman
        "-- afrikaans": afrîcanî, //a
        "--albanî": Albanî,
        "--amharî": amharî,
        "--erebî": Erebî,
        "--ermenî": ermenî,
        "--assamese": asamî,
        "--aymara": Aymara,
        "--azerbaijani": Azerî,
        "--bambara": Bambara, //b
        "--baskî": baskî,
        "--belarusî": Belarusî,
        "--bengalî": bengalî,
        "--bhojpuri": Bhojpuri,
        "--bosnî": boşnak,
        "--bulgarî": Bulgarî,
        "--catalan": katalanî, //c
        "--cebuano": Cebuano,
        "--çîçewa": Çiçewa,
        "--chineseSimplified": Çînî (Hêsandî),
        "--chineseTraditional": Çînî (Kevneşopî),
        "--corsîkî": korsîkî,
        "--kroatî": Croatian,
        "--çekî": Çekî,
        "--danîmarkî": Danîmarkî, //d
        "--dhivehi": Dîvehî,
        "--dogrî": Dogrî,
        "--hollandî": hollandî,
        "--îngilîzî": Îngilîzî, //e
        "--esperanto": esperanto,
        "--estonî": estonî,
        "--ewe": Ewe,
        "--filipino": Fîlîpînî, //f
        "--Fînî": Fînî,
        "--frensî": Fransî,
        "--frisian": frîzî,
        "--galîsî": galîsî, //g
        "--gurcî": gurcî,
        "--almanî": Almanî,
        "--yûnanî": Yewnanî,
        "--guarani": Guaranî,
        "--gujarati": Gujarati,
        "--haitianCreole": Kreoliya Haîtî, //h
        "--hausa": Hausa,
        "--hawaiian": hawayî,
        "--Îbranî": Îbranî,
        "--hindî": Hindi,
        "--hmong": Hmong,
        "--macarî": macarî,
        "--îslandî": îslandî, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": Endonezyayî,
        "--irlandî": îrlandî,
        "--îtalî": îtalî,
        "--Japonî": Japonî, //j
        "--javanî": Javanî,
        "--kannada": Kannada, //k
        "--kazaxî": kazakî,
        "--khmer": Kmerî,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkanî,
        "--koreyî": Koreyî,
        "--krio": Krio,
        "--kurdishKurmanci": Kurdî (kurmancî),
        "--kurdishSorani": Kurdî (Soranî),
        "--kyrgyz": Kirgiz,
        "--lao": Lao, //l
        "--latînî": Latînî,
        "--latwî": Letonî,
        "--lingala": Lingala,
        "--lîtvanî": Lîtvanyayî,
        "--luganda": Luganda,
        "--Luxemburgî": Luksembûrgî,
        "--makedanî": Makedonî, //m
        "--maithili": Maitili,
        "--malagasy": Malagasî,
        "--malayî": Malayî,
        "--malayalam": malayalam,
        "--maltî": Malteyî,
        "--maorî": Maorî,
        "--marathi": Maratî,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolî": mongolî,
        "--myanmarBurmese": Myanmar (Burmî),
        "--nepalî": Nepalî, //n
        "--norwêcî": Norwêcî,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--paşto": Paşto, //r
        "--farisî": farisî,
        "--polandî": Polonî,
        "--portûgalî": Portekîzî,
        "--punjabi": Pencabî,
        "--quechua": Keçua, //q
        "--romenî": Romanî, //r
        "--rûsî": rûsî,
        "--samoanî": Samoyî, //s
        "--sanskrîtî": sanskrîtî,
        "--scotsGaelic": ScotsGaelic,
        "--sepedi": Sepedî,
        "--serbî": sirbî,
        "--sesotho": Sesoto,
        "--shona": Şona,
        "--sindî": Sindî,
        "--sinhala": Şengal,
        "--slovak": Slovak,
        "--slovenî": slovenî,
        "--somali": somalî,
        "--spanyolî": spanî,
        "--sundanese": Sundanî,
        "--swahili": swahîlî,
        "--swêdî": swêdî,
        "--tacîk": tacîk, //t
        "--tamil": Tamîlî,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Taylandî,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--tirkî": tirkî,
        "--turkmen": Tirkmen,
        "--twi": Twi,
        "--ukraynî": Ukraynayî, //u
        "--urdu": Urdu,
        "--ûygûr": ûygûrî,
        "--uzbek": Ozbek,
        "--vietname": Viyetnamî, //v
        "--welş": Welşî, //w
        "--xosa": Xhosa, //x
        "--yiddiş": yiddî, //y
        "--yoruba": Yoruba,
        "--zulu": Zûlû, //z
        },
      },

      // **Kurdish (Sorani)
      // **Kurdish (Sorani)
      kurdishSorani: {
        translations: {
          "--an error has occurred": "هەڵەیەک ڕوویداوە!", //a
          "--address": "ناونیشانەکان",
          "--advice": "ئامۆژگاری",
          "--by clicking on continue": "بە کرتەکردن لەسەر بەردەوام پەیوەندیت لە ئەکاونتی Veil Brillant ـت دەبڕدرێت،", //b
          "--by clicking on disconnect you will be disconnected": "بە کرتەکردن لەسەر Disconnect پەیوەندیت لە ئەکاونتی izocash ـەکەت دەبڕدرێت،",
          "--check your virtual number or try again later": "ژمارەی مەجازی خۆت بپشکنە یان دواتر هەوڵبدەرەوە", //c
          "--check your virtual number": "ژمارەی مەجازی خۆت بپشکنە",
          "--continue": "بەردەوام",
          "--connection": "پەیوەندی",
          "--collaborate, live in harmony": "هاوکاری، بە هاوئاهەنگی لەگەڵ ئەوانی تر بژی",
          "--choose language": "زمانی تەلەفۆنی مەجازی",
          "--don't prevent competition": "ڕێگری لە کێبڕکێ مەکە، دەرفەت بە هەموو کەسێک بدە", //d
          "--disconnection": "پچڕان،",
          "--for all virtual phone users": "بۆ هەموو بەکارهێنەرانی مۆبایلی مەجازی، پێشنیار دەکرێت VPN",
          "--go to login page": "بڕۆ بۆ لاپەڕەی چوونەژوورەوە،", //g
          "--historical": "مێژوویی،", //h

           "--من ئەکاونتم هەیە": من پێشتر ئەکاونتێکم هەیە، //i
           "--ئەکاونتم نییە": ئەکاونتم نییە،
           "--ماڵی تۆیە": ماڵی تۆیە،
           "--وێنە / ڤیدیۆ +": وێنە / ڤیدیۆ +،
           "--دڵنیاکردنەوەی ناسنامە": پشتڕاستکردنەوەی ناسنامە،
           "--پۆرتاڵی کڕیارانی izocash": پۆرتاڵی کڕیارانی izocash،
           "--هەموو ساڵێک نوێکردنەوەی ناسنامە": نوێکردنەوەی ناسنامە هەموو ساڵێک،
           "--izocash کڕین بۆ": izocash کڕین => izocash نێودەوڵەتی،
           "--چوونە ژوورەوە": چوونەژوورەوە!، //l
           "---login": چوونەژوورەوە،
           "--login to veil brilliant": پەیوەندی بکە بە Veil Brillant،
           "--چوونە ژوورەوە بۆ فرۆشگای ڤیکسینۆڵ": پەیوەندی بە فرۆشگای ڤیکسینۆڵەوە بکە،
           "--بە خۆڕایی بچۆرە ژوورەوە بۆ ئەکاونتی Veil Brillant ـەکەت": بە خۆڕایی بچۆرە ژوورەوە بۆ ئەکاونتی Veil Brillant ـەکەت بۆ دەستگەیشتن بەم تایبەتمەندییە،
           "--سەرکەوتووی چوونەژوورەوە": چوونەژوورەوە سەرکەوتوو بوو!،
           "--ئێستا بچۆرە ژوورەوە": ئێستا بچۆرە ژوورەوە!،
           "--سەرکەوتووی دەرچوون": دەرچوون سەرکەوتوو بوو!،
           "--دەرچوون": دەرچوون،
           "--logout": دەرچوون،
           "--ژمارە": ژمارە، //n
           "--ناو": ناو،
           "--ئێستا بچۆرە ژوورەوە": ئێستا، چوونەژوورەوە!،
           "--هیچ قەدەغەکردنێک لە دامرکاندنەوەی کێبڕکێ":
           "--نە ئیرەیی، نە ڕق": نە ئیرەیی، نە ڕق، نە دابەشکاری،
           "--نەخێر نەخێر,
           "--ناونیشانی فەرمی بۆ دەستگەیشتن بە مۆبایلە مەجازییەکەت": ناونیشانی فەرمی بۆ دەستگەیشتن بە مۆبایلە مەجازییەکەت، //o
           "--وشەی نهێنی": وشەی نهێنی، //ل
           "--خاڵەکان کشانەوە izocash": خاڵەکان کشانەوە izocash,
           "--کشاندنەوەی خاڵەکان": کشاندنەوەی خاڵەکان،
           "--بە باشتر دەزانرێت، vpn بەکاربهێنە": باشترە، VPN بەکاربهێنە کە سەر بە دابینکەری خزمەتگوزاری ئینتەرنێتەکەت نییە،
           "--بەردەوامبوون هەمیشە سوودی دەبێت": خۆڕاگری هەمیشە لە کۆتاییدا سوودی دەبێت،
           "--rule": یاساکان، //r
           "--پێشنیار": پێشنیارەکان،
           "--تۆمارکردن": تۆمارکردن،
           "--signup to veil brilliant": ناوت تۆمار بکە لە Veil Brillant، //s
           "--ناوت تۆمار بکە بۆ فرۆشگای ڤیکسینۆڵ": ناوت تۆمار بکە لە فرۆشگای ڤیکسینۆڵ،
           "--ناو تۆمارکردن": تۆمارکردن،
           "--سەرکەوتنی ناو تۆمارکردن": ناو تۆمارکردن سەرکەوتوو بوو!،
           "--بە خۆڕایی ناوت تۆمار بکە": بە خۆڕایی ناوت تۆمار بکە،
           “--سەرکەوتنی ناو تۆمارکردن IA”: پەیوەندیکردن سەرکەوتوو بوو”,
           "--ڕێکخستنەکان": "ڕێکخستنەکان"،
           "--ڕێکخستنی ئەپی alrani": ڕێکخستنی بەرنامەی Alrani،
           "--ڕێکخستنی ئەپی izocash": ڕێکخستنی بەرنامەی izocash،
           "--ڕێکخستنی ئەپی ڤیکسینۆڵ": ڕێکخستنی بەرنامەی ڤیکسینۆڵ،
           "--ڕێکخستنی ئەپی veil Brillant": ڕێکخستنی بەرنامەی Veil Brillant،
           "--هەڵگرتنی وێنە، ڤیدیۆ": هەڵگرتنی وێنە و ڤیدیۆ و چەند توخمێکی تر،
           "--خێرایی وەرگرتن": خێرایی وەرگرتنی داتا لە ناوەندی داتا،
           "--خێرایی": خێرایی،
           "--terminate": کۆتایی پێهێنان، //t
           "--vpn ڕێگەت پێدەدات بچیتە ناوەوە": VPN ڕێگەت پێدەدات بچیتە ناو سایتێک یان بەرنامەیەکەوە کە پێشکەشکاری خزمەتگوزاری ئینتەرنێتەکەت لە لیستی ڕەشدا داناوە،
           "--گەورەترین دار لە سەرەوە بوو": گەورەترین دار لە سەرووی هەموو شتێکەوە تۆوێکی بچووکی سادە بوو،
           "--دەست لە شاشەکە بدە": دەست لە شاشەکە بدە بۆ بەردەوامبوون،
           "--دوبارە هەوڵبدەرەوە": دووبارە هەوڵبدەرەوە!،
           "--ناوی بەکارهێنەر": ناوی بەکارهێنەر، //u

           "--ژمارەی مەجازی": ژمارەی مەجازی، //v
           "--ڕێکخستنەکانی مۆبایلی مەجازی": ڕێکخستنەکانی مۆبایلی مەجازی،
           "--زمانی مۆبایلی مەجازی جێبەجێ دەکرێت": زمانی مۆبایلی مەجازی بە شێوازی پێشوەختە لە ئاستی بەرنامەکەدا جێبەجێ دەکرێت،
           "--مۆبایلی مەجازی": مۆبایلی مەجازی،
           "--validate": چەسپاندن،
           "--بەخێربێن بۆ پۆرتاڵی کڕیارانی izocash": بەخێربێن بۆ پۆرتاڵی کڕیارانی izocash، //w
           "--نووسینی کۆدێکی سوپەر": کۆدێکی سوپەر داخڵ بکە،
           "--بەخێربێن بۆ": بەخێربێن بۆ،
           "--سەرنجی خەڵک بۆ کوێ دەڕوات": سەرنجی خەڵک بۆ کوێ دەڕوات پارە دەچێت،
           "--براوەکان خۆڕاگر دەبن": براوەکان خۆڕاگر دەبن،
           "--ئایا حەز دەکەیت لە ئەکاونتی ئەلرانی خۆت دەربچیت": دەتەوێت لە ئەکاونتی ئەلرانی خۆت دەربچیت؟،
           "--بەڵێ": بەڵێ، //ی

           // وڵات
           "--کۆنگۆ": کۆنگۆ برازاڤیل،
           "--cameroon": کامیرۆن،
           "--drc": DRC،
           "--ivoryCoast": کەناری عاج،

           // زمان
        "--afrikaans": ئەفریقایی، //a
        "--ئەلبانی": ئەلبانی،
        "--ئەمهاریکی": ئەمهاریکی،
        "--عەرەبی": عەرەبی،
        "--ئەرمەنی": ئەرمەنی،
        "--assamese": ئاسامی،
        "--ئایمارە": ئایمارە،
        "--ئازەری": ئازەری،
        "--bambara": بامبارا، //ب
        "--باسک": باسکی،
        "--belarusian": بێلاڕوسی،
        "--bengali": بەنگالی،
        "--bhojpuri": بۆجپوری،
        "--بۆسنی": بۆسنی،
        "--بولگاری": بولگاری،
        "--کەتەلۆنی": کەتەلۆنی، //c
        "--cebuano": سیبوانۆ،
        "--چیچەوا": چیچەوا،
        "--chineseSimplified": چینی (سادەکراوە)،
        "--chineseTraditional": چینی (نەریتی)،
        "--کۆرسیکان": کۆرسی،
        "--کرواتی": کرواتی،
        "--چێکی": چێکی،
        "--danish": دانیمارکی، //د
        "--دیڤێهی": دیڤێهی،
        "--دۆگری": دۆگری،
        "--هۆڵەندی": هۆڵەندی،
        "--ئینگلیزی": ئینگلیزی، //e
        "--ئیسپێرانتۆ": ئێسپێرانتۆ،
        "--ئیستۆنی": ئیستۆنی،
        "--مەڕ": مەڕ،
        "--filipino": فلیپینی، //f
        "--فنلاندی": فینلەندی،
        "--فەرەنسی": فەرەنسی،
        "--frisian": فریسی،
        "--galician": گالیسی، //g
        "--جۆرجیا": جۆرجیی،
        "--ئەڵمانی": ئەڵمانی،
        "--یۆنانی": یۆنانی،
        "--گوارانی": گوارانی،
        "--گوجاراتی": گوجاراتی،
        "--haitianCreole": کرێۆلی هایتی، //h
        "--hausa": هاوسا،
        "--هاوای": هاوایی،
        "--عیبری": عیبری،
        "--hindi": زمانی هیندی،
        "--همۆنگ": همۆنگ،
        "--هەنگاری": هەنگاری،
        "--ئایسلەندی": ئایسلەندی، //i
        "--igbo": ئیگبۆ،
        "--ilocano": ئیلۆکانۆ،
        "--ئیندۆنیزی": ئەندەنوسیا،
        "--ئیرلەندی": ئێرلەندی،
        "--ئیتاڵی": ئیتاڵی،
        "--یابانی": ژاپۆنی، //j
        "--javanese": جاڤانی،
        "--kannada": کەنەدا، //ک
        "--کازاخی": کازاخی،
        "--خمەر": خمێر،
        "--kinyarwanda": کینیارواند،
        "--konkani": کۆنکانی،
        "--کۆری": کۆری،
        "--کریۆ": کریۆ،
        "--kurdishKurmanji": کوردی (کرمانجی)،
        "--kurdishSorani": کوردی (سۆرانی)،
        "--kyrgyz": قیرغیز،
        "--لاو": لاو، //ل
        "--لاتینی": لاتینی،
        "--لاتڤیایی": لاتڤیایی،
        "--لینگالا": لینگالا،
        "--لیتوانی": لیتوانی،
        "--لوگاندا": لوگاندا،
        "--luxembourgish": لوکسێمبۆرگی،
        "--مەقدۆنی": مەقدۆنی، //م
        "--maithili": زمانی ئینگلیزی،
        "--مەلاگازی": مالاگاسی،
        "--مەلای": مالای،
        "--مالایالم": مالایالم،
        "--ماڵتی": ماڵتی،
        "--ماوری": ماوری،
        "--ماراتی": ماراتی،
        "--meiteilonManipuri": Meiteilon (مانیپوری)،
        "--میزۆ": میزۆ،
        "--مەنگۆلی": مەنگۆلی،
        "--myanmarBurmase": میانمار (Burmese)،
        "--نیپالی": نیپاڵی، //ن
        "--نەرویجی": نەرویجی،
        "--odiaOriya": ئۆدیا (ئۆریا)، //o
        "--ئۆرۆمۆ": ئۆرۆمۆ،
        "--پاشتۆ": پشتو، //ل
        "--فارسی": فارسی،
        "--پۆڵەسی": پۆلۆنی،
        "--پۆرتوگالی": پورتوگالی،
        "--punjabi": پەنجابی،
        "--کوێچوا": کیچوا، //ق
        "--ڕۆمانی": ڕۆمانی، //ر
        "--ڕووسی": ڕووسی،
        "--سامۆئان": سامۆئان، //س
        "--سانسکریت": سانسکریت،
        "--scotsGaelic": سکۆتلەندی گەیلیک،
        "--sepedi": سێپێدی،
        "--سربی": سربی،
        "--سێسۆتۆ": سێسۆتۆ،
        "--شۆنا": شۆنا،
        "--sindhi": سندی،
        "--sinhala": سینهالی،
        "--سلۆڤاکی": سلۆڤاکی،
        "--سلۆڤینی": سلۆڤینی،
        "--سۆماڵی": سۆماڵی،
        "--ئیسپانی": ئیسپانی،
        "--sundanese": سوندانی،
        "--سواحیلی": سواحیلی،
        "--سویدی": سویدی،
        "--تاجیک": تاجیکی، //ت
        "--تامیل": تامیل،
        "--تاتار": تەتار،
        "--telugu": تیلوگو،
        "--تای": تایلەندی،
        "--tigrinya": تیگرینیا،
        "--tsonga": تسۆنگا،
        "--تورکی": تورکی،
        "--تورکمان": تورکمان،
        "--twi": توی،
        "--ئۆکرانی": ئۆکراینی، //u
        "--urdu": ئوردو،
        "--ئویغور": ئویغور،
        "--ئۆزبەک": ئۆزبەک،
        "--ڤیتنامیی": ڤێتنامیی، //v
        "--وێڵش": وێڵزی، //و
        "--xhosa": خۆسا، //x
        "--yiddish": ییدیش، //y
        "--یۆرۆبا": یۆرۆبا،
        "--zulu": زولو، //z
        },
      },

      // **kyrgyz
      // **kyrgyz
      kyrgyz: {
        translations: {
           "--an error has occurred": "Ката кетти!", //a
           "--address": "Даректер",
           "--advice": "Кеңеш",
           "--by clicking on continue": "Улантуу баскычын чыкылдатуу менен сиз Veil Brillant аккаунтуңуздан ажыратыласыз", //b
           "--by clicking on disconnect you will be disconnected": "Ажыратуу баскычын чыкылдатуу менен сиз izocash эсебиңизден ажыратыласыз",
           "--check your virtual number or try again later": "Виртуалдык номериңизди текшериңиз же кийинчерээк кайра аракет кылыңыз", //c
           "--check your virtual number": "текшерүү сиздин виртуалдык номери",
           "--continue": "Улантуу",
           "--connection": "Байланыш",
           "--collaborate, live in harmony": "Башкалар менен ынтымакта жаша",
           "--choose language": "Виртуалдык телефон тили",
           "--don't prevent competition": "Атаандаштыкка тоскоол болбо, баарына мүмкүнчүлүк бер", //д
           "--disconnection": "Ажыратуу",
           "--for all virtual phone users": "Бардык виртуалдык телефон колдонуучулары үчүн VPN колдонуу сунушталат", //f
           "--go to login page": "Кирүү барагына өтүңүз", //g
           "--historical": "Тарыхый", //ч

           "--i have account": Менде аккаунт бар, //i
           "--i don't have account": Менде аккаунт жок,
           "--it is your house": ал сенин үйүң,
           "--сүрөт / видео +": Сүрөт / Видео +,
           "--идентификатордук текшерүү": өздүгүн текшерүү,
           "--izocash кардар порталы": izocash Кардар порталы,
           "--identity update every year": Жыл сайын идентификация жаңыртуу,
           "--izocash buy to": izocash Сатып алуу => izocash эл аралык,
           "--log in": Кириңиз!, //l
           "--login": Кирүү,
           "--login to veil brilliant": Veil Brillant менен туташуу,
           "--vixinol дүкөнүнө кирүү": Vixinol дүкөнүнө туташуу,
           "--парда Brillant аккаунтуңузга бекер кириңиз": Бул функцияга жетүү үчүн Veil Brillant аккаунтуңузга бекер кириңиз,
           "--логин ийгиликтүү": Кирүү ийгиликтүү!,
           "--login now": Азыр кириңиз!,
           "--чыгуу ийгиликтүү": Чыгуу ийгиликтүү!,
           "--чыгуу": Чыгуу,
           "--logout": Чыгуу,
           "--сан": Сан, //n
           "--name": аты,
           "--азыр кириңиз": Азыр, Кириңиз!,
           "--конкуренцияга тыюу салуу жок":
           "--кызгануу жок, жек көрүү жок": көрө албастык жок, жек көрүү жок, бөлүнүү жок,
           "--жок жок,
           "-- виртуалдык телефонуңузга кирүү үчүн расмий даректер": виртуалдык телефонуңузга кирүү үчүн расмий даректер, //o
           "--password": Сырсөз, //б
           "--упайларды алып салуу izocash": Упайларды алуу izocash,
           "--упайларды алуу": Упайларды алуу,
           "--жакшы, VPN колдонуңуз": Интернет провайдериңизге таандык болбогон VPNди колдонуңуз,
           "--тырышчаактык ар дайым акыбети кайтпай койбойт": туруктуулук ар дайым акыр аягында,
           "--regus": Эрежелер, //r
           "--recommendation": Сунуштар,
           "--registration": Каттоо,
           "--signup to veil brilliant": Veil Brillant боюнча катталуу, //s
           "--vixinol дүкөнүнө катталуу": Vixinol дүкөнүнө катталуу,
           "--катталуу": Каттоо,
           "--каттоо ийгиликтүү": Каттоо ийгиликтүү болду!,
           "--акысыз катталуу": Бекер катталуу,
           “--катталуу ийгиликтүү IA”: Туташуу ийгиликтүү”,
           "--settings": "Орнотуулар",
           "--alrani колдонмосун орнотуу": Alrani тиркемесин конфигурациялоо,
           "--izocash колдонмосун орнотуу": izocash тиркемесин конфигурациялоо,
           "--vixinol колдонмосун орнотуу": Vixinol тиркемесин конфигурациялоо,
           "--парда Brillant колдонмосун орнотуу": Veil Brillant тиркемесин конфигурациялоо,
           "--сүрөттөрдү, видеолорду сактоо": Сүрөттөрдү, видеолорду жана башка бир нече элементтерди сактоо,
           "--кабыл алуу ылдамдыгы": Маалымат борборунан маалыматтарды кабыл алуу ылдамдыгы,
           "--speed": Ылдамдык,
           "--terminate": Аяктоо, //т
           "--vpn сизге кирүү мүмкүнчүлүгүн берет": VPN сизге интернет провайдериңиз кара тизмеге киргизген сайтка же тиркемеге кирүүгө мүмкүндүк берет,
           "--эн чоң дарак жогоруда болчу": Эң чоң дарак баарынан мурда жөнөкөй кичинекей үрөн эле,
           "--экранга тийүү": ​​Улантуу үчүн экранга тийип,
           "--try again": Кайталап көрүңүз!,
           "--username": Колдонуучунун аты, //u

           "--виртуалдык сан": Виртуалдык сан, //v
           "--виртуалдык телефон орнотуулары": Виртуалдык телефон орнотуулары,
           "--виртуалдык телефон тили колдонулат": Виртуалдык телефон тили демейки боюнча колдонмо деңгээлинде колдонулат,
           "--виртуалдык телефон": Виртуалдык телефон,
           "--validate": Текшерүү,
           "-- izocash кардарлар порталына кош келиңиз": izocash Кардар порталына кош келиңиз, //w
           "--супер кодду жаз": Супер кодду киргизиңиз,
           "--welcome to": Кош келиңиз,
           "--элдин көңүлү кайда кетет": Адамдардын көңүлү кайда кетет, акча кайда кетет,
           "--winners persevere": Жеңүүчүлөр чыдамкай,
           "--сиз Alrani аккаунтуңуздан чыккыңыз келеби?": Alrani аккаунтуңуздан чыккыңыз келеби?,
           "--yes": Ооба, // ж

           // өлкө
           "--конго": Конго Браззавил,
           "--cameroon": Камерун,
           "--drc": DRC,
           "--пилдик жээги": Пил Сөөгүнүн Жээги,

           // тил
        "--afrikaans": Африкаанс, //а
        "--albanian": албан,
        "--amharic": амхарча,
        "--arabic": араб,
        "--armenian": армян,
        "--assamese": ассамча,
        "--aymara": Аймара,
        "--azerbajani": азербайжанча,
        "--бамбара": Бамбара, //б
        "--баск": баск,
        "--беларусча": белорус,
        "--bengali": бенгалча,
        "--bhojpuri": Бхожпури,
        "--босниялык": босниялык,
        "--bulgarian": болгарча,
        "--catalan": каталан, //c
        "--cebuano": Себуано,
        "--chichewa": Чичева,
        "--chineseSimplified": кытайча (жөнөкөйлөштүрүлгөн),
        "--chineseTraditional": кытайча (Салттуу),
        "--korsican": корсикалык,
        "--croatian": хорватча,
        "--czech": чех,
        "--danish": Дания, //д
        "--dhivehi": Дивехи,
        "--dogri": Догри,
        "--dutch": голландча,
        "--english": англисче, //e
        "--esperanto": эсперанто,
        "--estonian": эстонча,
        "--ewe": Эве,
        "--filipino": Филиппин, //f
        "--finnish": финче,
        "--fransuz": француз,
        "--frisian": фризча,
        "--galician": Галисия, //г
        "--грузин": грузин,
        "--немец": немис,
        "--грек": грек,
        "--guarani": Гуарани,
        "--gujarati": гуджарати,
        "--haitianCreole": Гаити Креол, //h
        "--hausa": Хауса,
        "--hawaiian": Гавайи,
        "--еврей": ивритче,
        "--hindi": хинди,
        "--hmong": Хмонг,
        "--hungarian": венгр,
        "--icelandic": исландча, //i
        "--igbo": Игбо,
        "--ilocano": Ilocano,
        "--indonesian": Индонезия,
        "--irish": ирландиялык,
        "--italian": италия,
        "--жапонча": жапон, //j
        "--javanese": Java,
        "--kannada": Каннада, //k
        "--казак": казакча,
        "--khmer": кхмер,
        "--kinyarwanda": Кинярванда,
        "--konkani": Конкани,
        "--korean": корейче,
        "--krio": Крио,
        "--kurdishKurmanji": күрт (курманжы),
        "--kurdishSorani": күрт (сорани),
        "--kyrgyz": кыргыз,
        "--lao": Лао, //л
        "--latin": латын,
        "--latvian": латышча,
        "--lingala": лингала,
        "--lithuanian": литвача,
        "--luganda": Луганда,
        "--luxembourgish": Люксембург,
        "--macedonian": македонча, //м
        "--maithili": Майтили,
        "--malagasy": малагаси,
        "--malay": малай,
        "--malayalam": малаялам,
        "--maltese": мальталык,
        "--maori": маори,
        "--marathi": маратхи,
        "--meiteilonManipuri": Мейтейлон (Манипури),
        "--mizo": Mizo,
        "--монголча": монгол,
        "--myanmarBurmese": Мьянма (Бирма),
        "--nepali": Непалча, //n
        "--norwegian": норвегче,
        "--odiaOriya": Одия (Ория), //o
        "--oromo": Оромо,
        "--пашту": пушту, //б
        "--persian": персче,
        "--polish": поляк,
        "--portuguese": португалча,
        "--punjabi": Пенджаби,
        "--quechua": Кечуа, //q
        "--румыниялык": румын, //r
        "--орусча": орусча,
        "--samoan": самоа, //s
        "--санскрит": санскрит,
        "--scotsGaelic": шотландиялык галец,
        "--sepedi": Сепеди,
        "--serbian": серб,
        "--sesotho": Сесото,
        "--shona": Шона,
        "--sindhi": Синдхи,
        "--sinhala": сингалча,
        "--slovak": словак,
        "--slovenian": словенче,
        "--somali": Сомали,
        "--spanish": испанча,
        "--сунданча": сунданча,
        "--суахили": суахили,
        "--swedish": шведче,
        "--тажик": тажик, //т
        "--tamil": Тамил,
        "--татар": татар,
        "--telugu": телугу,
        "--тай": тай,
        "--tigrinya": Тигриня,
        "--tsonga": Цонга,
        "--turkish": түркчө,
        "--turkmen": түркмөн,
        "--twi": Twi,
        "--украинский": украин, //у
        "--urdu": урду,
        "--уйгур": уйгур,
        "--uzbek": өзбек,
        "--vietnamese": вьетнамча, //v
        "--welsh": Welsh, //w
        "--xhosa": Хоса, //x
        "--yiddish": идиш, //y
        "--yoruba": Йоруба,
        "--zulu": Зулу, //з
        },
      },

      // **lao
      // **lao
      lao: {
        translations: {
          "--an error has occurred": "ຂໍ້ຜິດພາດເກີດຂຶ້ນ!", //a
           "--address": "ທີ່ຢູ"່,
           "--advice": "ຄໍາ​ແນະ​ນໍາ​",
           "--by clicking on continue": "ໂດຍການຄລິກໃສ່ສືບຕໍ່, ທ່ານຈະຖືກຕັດການເຊື່ອມຕໍ່ຈາກບັນຊີ Veil Brillant ຂອງທ່ານ", //b.
           "--by clicking on disconnect you will be disconnected": "ໂດຍການຄລິກໃສ່ຕັດການເຊື່ອມຕໍ່ທ່ານຈະຖືກຕັດການເຊື່ອມຕໍ່ຈາກບັນຊີ izocash ຂອງທ່ານ",
           "--check your virtual number or try again later": "ກວດເບິ່ງເລກ virtual ຂອງທ່ານ ຫຼືລອງໃໝ່ໃນພາຍຫຼັງ", //c
           "--check your virtual number": "ກວດເບິ່ງຕົວເລກ virtual ຂອງທ່ານ",
           "--continue": "ສືບຕໍ່",
           "--connection": "ການເຊື່ອມຕໍ່",
           "--collaborate, live in harmony": "ການ​ຮ່ວມ​ມື, ດໍາ​ລົງ​ຊີ​ວິດ​ຢູ່​ໃນ​ຄວາມ​ກົມ​ກຽວ​ກັບ​ຄົນ​ອື່ນ",
           "--choose language": "ພາສາໂທລະສັບສະເໝືອນ",
           "--don't prevent competition": "ຢ່າປ້ອງກັນການແຂ່ງຂັນ, ໃຫ້ໂອກາດທຸກຄົນ", //d
           "--disconnection": "ຕັດການເຊື່ອມຕໍ"່,
           "--for all virtual phone users": "ສໍາລັບຜູ້ໃຊ້ Virtual Phone ທັງໝົດ, ແນະນໍາໃຫ້ໃຊ້ VPN", //f
           "--go to login page": "ໄປຫາຫນ້າເຂົ້າສູ່ລະບົບ", //g
           "--historical": "ປະຫວັດສາດ", // h
           
           "--i have account": ຂ້ອຍມີບັນຊີແລ້ວ, //i
           "-- ຂ້ອຍບໍ່ມີບັນຊີ": ຂ້ອຍບໍ່ມີບັນຊີ,
           "--ມັນແມ່ນເຮືອນຂອງເຈົ້າ": ມັນແມ່ນເຮືອນຂອງເຈົ້າ,
           "--image / video +": ຮູບພາບ / ວິດີໂອ +,
           "--identity verification": ການຢັ້ງຢືນຕົວຕົນ,
           "--izocash customer portal": ປະຕູລູກຄ້າ izocash,
           "--identity update every year": ອັບເດດຕົວຕົນທຸກໆປີ,
           "--izocash buy to": izocash ຊື້ => izocash ສາກົນ,
           "--log in": ເຂົ້າສູ່ລະບົບ!, //l
           "--login": ເຂົ້າສູ່ລະບົບ,
           "--login to veil brilliant": ເຊື່ອມຕໍ່ຫາ Veil Brillant,
           "--login to vixinol store": ເຊື່ອມຕໍ່ຫາ Vixinol Store,
           "--login for free to your veil Brillant account": ເຂົ້າ​ສູ່​ລະ​ບົບ​ໄດ້​ຟຣີ​ກັບ​ບັນ​ຊີ Veil Brillant ຂອງ​ທ່ານ​ເພື່ອ​ເຂົ້າ​ເຖິງ​ຄຸນ​ສົມ​ບັດ​ນີ້​,
           "--login success": ເຂົ້າສູ່ລະບົບສຳເລັດແລ້ວ!,
           "--login now": ເຂົ້າສູ່ລະບົບດຽວນີ້!,
           "--logout success": ອອກຈາກລະບົບສຳເລັດແລ້ວ!,
           "--log out": ອອກຈາກລະບົບ,
           "--logout": ອອກຈາກລະບົບ,
           "--number": ຈໍານວນ, // ນ
           "--name": ຊື່,
           "--now log in": ດຽວນີ້, ເຂົ້າສູ່ລະບົບ!,
           "-- ບໍ່​ມີ​ການ​ຫ້າມ​ການ​ແຂ່ງ​ຂັນ​"​:
           "--ບໍ່ມີອິດສາ, ບໍ່ມີກຽດ": ບໍ່ມີອິດສາ, ບໍ່ກຽດຊັງ, ບໍ່ມີການແບ່ງປັນ,
           "--ບໍ່​ບໍ່,
           "--official addresses to access your virtual phone": ທີ່ຢູ່ຢ່າງເປັນທາງການເພື່ອເຂົ້າເຖິງໂທລະສັບ virtual ຂອງທ່ານ, //o
           "--password": ລະຫັດຜ່ານ, // p
           "--points ຖອນ izocash": ຈຸດຖອນເງິນ izocash,
           "--points withdrawals": ການຖອນຄະແນນ,
           "--preferably, use a vpn": ດີກວ່າ, ໃຊ້ VPN ທີ່ບໍ່ຂຶ້ນກັບຜູ້ໃຫ້ບໍລິການອິນເຕີເນັດຂອງທ່ານ,
           "--ຄວາມອົດທົນສະເໝີຕົ້ນສະເໝີປາຍ": ຄວາມອົດທົນສະເໝີຕົ້ນສະເໝີປາຍ,
           "--rule": ກົດລະບຽບ, // r
           "--recommendation": ຄຳແນະນຳ,
           "--registration": ການລົງທະບຽນ,
           "--signup to veil brilliant": ລົງທະບຽນໃນ Veil Brillant, //s
           "--signup to vixinol store": ລົງທະບຽນໃນຮ້ານ Vixinol,
           "--signup": ລົງທະບຽນ,
           "--ສະໝັກສຳເລັດ": ການລົງທະບຽນສຳເລັດແລ້ວ!,
           "--signup for free": ລົງທະບຽນຟຣີ,
           "-- ການ​ລົງ​ທະ​ບຽນ​ສໍາ​ເລັດ IA​"​: ການ​ເຊື່ອມ​ຕໍ່​ສົບ​ຜົນ​ສໍາ​ເລັດ​,
           "--settings": "ການຕັ້ງຄ່າ",
           "-- ການ​ຕັ້ງ​ຄ່າ app alrani​"​: ການ​ຕັ້ງ​ຄ່າ​ຄໍາ​ຮ້ອງ​ສະ​ຫມັກ Alrani​,
           "-- ການ​ຕັ້ງ​ຄ່າ app izocash​"​: ການ​ຕັ້ງ​ຄ່າ​ຄໍາ​ຮ້ອງ​ສະ​ຫມັກ izocash​,
           "--setting up the vixinol app": ການກຳນົດຄ່າແອັບພລິເຄຊັນ Vixinol,
           "--setting up the veil Brillant app": ການຕັ້ງຄ່າແອັບພລິເຄຊັນ Veil Brillant,
           "-- ການ​ເກັບ​ຮັກ​ສາ​ຮູບ​ພາບ​, ວິ​ດີ​ໂອ​"​: ການ​ເກັບ​ຮັກ​ສາ​ຮູບ​ພາບ​, ວິ​ດີ​ໂອ​ແລະ​ອົງ​ປະ​ກອບ​ອື່ນໆ​ຈໍາ​ນວນ​ຫນຶ່ງ​,
           "--speed of reception": ຄວາມ​ໄວ​ຂອງ​ການ​ຮັບ​ຂໍ້​ມູນ​ຈາກ Datacenter​,
           "--speed": ຄວາມໄວ,
           "--terminate": ສິ້ນສຸດ, //t
           "--the vpn ອະ​ນຸ​ຍາດ​ໃຫ້​ທ່ານ​ໃນ​ການ​ເຂົ້າ​ເຖິງ": VPN ອະ​ນຸ​ຍາດ​ໃຫ້​ທ່ານ​ເຂົ້າ​ເຖິງ​ເວັບ​ໄຊ​ຫຼື​ຄໍາ​ຮ້ອງ​ສະ​ຫມັກ​ທີ່​ຜູ້​ໃຫ້​ບໍ​ລິ​ການ​ອິນ​ເຕີ​ເນັດ​ຂອງ​ທ່ານ​ໄດ້​ບັນ​ຊີ​ດໍາ​,
           "-- ຕົ້ນ​ໄມ້​ທີ່​ໃຫຍ່​ທີ່​ສຸດ​ແມ່ນ​ຂ້າງ​ເທິງ​"​: ຕົ້ນ​ໄມ້​ທີ່​ໃຫຍ່​ທີ່​ສຸດ​ແມ່ນ​ຂ້າງ​ເທິງ​ທັງ​ຫມົດ​ທີ່​ມີ​ແກ່ນ​ພຽງ​ເລັກ​ນ້ອຍ​,
           "--touch the screen": ແຕະໜ້າຈໍເພື່ອສືບຕໍ່,
           "--try again": ລອງອີກຄັ້ງ!,
           "--username": ຊື່ຜູ້ໃຊ້, //u

           "--virtual number": ຕົວເລກ virtual, //v
           "--virtual phone settings": ການຕັ້ງຄ່າໂທລະສັບສະເໝືອນ,
           "--virtual Phone language is used": ພາສາ Virtual Phone ຖືກນຳໃຊ້ໃນລະດັບແອັບພລິເຄຊັນ ໂດຍຄ່າເລີ່ມຕົ້ນ,
           "--virtual phone": ໂທລະສັບສະເໝືອນ,
           "--validate": ກວດສອບ,
           "--welcome to the izocash customer portal": ຍິນດີຕ້ອນຮັບສູ່ປະຕູລູກຄ້າ izocash, //w
           "--write a super code": ໃສ່ Super code,
           "--welcome to": ຍິນດີຕ້ອນຮັບສູ່,
           "-- where people's attention go": ຄວາມສົນໃຈຂອງປະຊາຊົນໄປໃສ,
           "-- winners persevere": ຜູ້ຊະນະມີຄວາມອົດທົນ,
           "-- ທ່ານຕ້ອງການອອກຈາກບັນຊີ Alrani ຂອງທ່ານບໍ": ທ່ານຕ້ອງການອອກຈາກບັນຊີ Alrani ຂອງທ່ານບໍ?,
           "--yes": ແມ່ນແລ້ວ, //y

           // ປະເທດ
           "--congo": ຄອງ​ໂກ Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // ພາສາ
        "--afrikaans": ອາຟຣິການ, //a
        "--albanian": ອານບານີ,
        "--amharic": ອຳ​ຮາ​ຣິກ,
        "--Arabic": ພາສາອາຣັບ,
        "--armenian": ອາ​ເມ​ເນຍ,
        "--assamese": ອາ​ສ​ມີ​ສ,
        "--aymara": Aymara,
        "--Azerbaijani": ອາເຊີໄບຈັນ,
        "--bambara": ບັກບາຣາ, // ຂ
        "--basque": ບາ​ກ​ກີ,
        "--belarusian": ເບ​ລາ​ຣຸ​ສ,
        "--bengali": ເບັງກາລີ,
        "--bhojpuri": ໂບ​ຈ​ປູ​ຣີ,
        "--bosnian": ບອສເນຍ,
        "--bulgarian": ບຸນກາຣີ,
        "--catalan": ຄາຕາລານ, // ຄ
        "--cebuano": ເຊບູໂນ,
        "--chichewa": Chichewa,
        "--chineseSimplified": ຈີນ (ຕົວຫຍໍ້),
        "--chineseTraditional": ຈີນ (ດັ້ງເດີມ),
        "--corsican": ຄໍ​ຊິ​ກັນ,
        "--croatian": ໂຄຣເອເຊຍ,
        "--czech": ເຊັກ​ໂກ,
        "--danish": ເດັນມາກ, // ງ
        "--dhivehi​"​: Dhivehi​,
        "--dogri": Dogri,
        "--dutch": ໂຮນລັງ,
        "--english": ພາສາອັງກິດ, //e
        "--esperanto": ເອ​ສ​ເປີ​ຣັນ​ໂຕ,
        "--estonian": ເອສໂຕເນຍ,
        "--ewe": ເອີ,
        "--filipino": ຟີລິບປິນ, // f
        "--finnish": ຟິນ​ແລນ,
        "--french": ຝຣັ່ງ,
        "--frisian": ຝຣັ່ງເສດ,
        "--galician": ກາລິຊຽນ, //g
        "--georgian": ຈໍເຈຍ,
        "--german": ເຢຍລະມັນ,
        "--greek": ກຣີກ,
        "--guarani": ກວາຣານີ,
        "--gujarati": ກູ​ຈາ​ຣາ​ຕີ,
        "--haitianCreole": Haitian Creole, // h
        "--hausa": Hausa,
        "--hawaiian": ຮາ​ວາຍ,
        "--hebrew": ຍິວ,
        "--hindi": ຮິນດູ,
        "--hmong": ມົ້ງ,
        "--hungarian": ຮັງ​ກາ​ຣີ,
        "--icelandic": ໄອສແລນຕິກ, //i
        "--igbo": ອິກໂບ,
        "--ilocano": ອິ​ໂລ​ກາ​ໂນ,
        "--indonesian": ອິນໂດເນເຊຍ,
        "--irish": ໄອ​ແລນ,
        "--Italian": ອິ​ຕາ​ລີ,
        "--japanese": ພາສາຍີ່ປຸ່ນ, //j
        "--javanese": ພາສາ Javanese,
        "--kannada": ກອນນາດາ, // ກ
        "--kazakh": ຄາຊັກ,
        "--khmer": ຂະ​ແມ,
        "--kinyarwanda": ກິ​ນາ​ວັນ​ດາ,
        "--konkani": ກອນ​ກາ​ນີ,
        "--korean": ເກົາຫຼີ,
        "--krio": ຄຣີໂອ,
        "--kurdishKurmanji": ພາສາເຄີດ (Kurmanji),
        "--kurdishSorani": ຊາວເຄີດ (ໂຊຣານີ),
        "--kyrgyz": ກີ​ຈີ​ສ,
        "--lao": ພາສາລາວ, //l
        "--ລາຕິນ": ລາຕິນ,
        "--latvian": ລັດເວຍ,
        "--lingala": ລີງກາລາ,
        "--lithuanian": ລິທົວນຽນ,
        "--luganda": Luganda,
        "--luxembourgish": ລຸກຊຳບວກ,
        "--macedonian": ມາເຊໂດເນຍ, // ມ
        "--maithili": ໄມຕີລີ,
        "--malagasy": ມາລາກາຊີ,
        "--malay": ມາ​ເລ,
        "--malayalam": ພາສາມາລາຢາລໍາ,
        "--maltese": ມັ​ສ​ຕາ,
        "--maori": ມໍ​ຣີ,
        "--marathi": ມາຣາທິ,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": ມີ​ໂຊ,
        "--mongolian": ມົງ​ໂກນ,
        "--myanmarBurmese": ມຽນມາ (ພະມ້າ),
        "--nepali": ເນປານ, // ນ
        "--norwegian": ນໍເວ,
        "--odiaOriya": Odia (Oriya), // o
        "--oromo": ໂອໂຣໂມ,
        "--pashto": Pashto, // ປ
        "--persian": ເປີເຊຍ,
        "--polish": ໂປ​ແລນ,
        "--portuguese": ປອກຕຸຍການ,
        "--punjabi": ປັນ​ຈາ​ບີ,
        "--quechua": Quechua, //q
        "--romanian": ໂຣມາເນຍ, //r
        "--russian": ພາສາລັດເຊຍ,
        "--samoan": ຊາມົວ, // s
        "--sanskrit": ສັນສະກິດ,
        "--scotsGaelic": ສະ​ກັອດ​ເກ​ລິກ,
        "--sepedi": ເຊ​ເປ​ດີ,
        "--serbian": ເຊີເບຍ,
        "--sesotho": ເຊໂຊໂທ,
        "--shona": ໂຊ​ນາ,
        "--ສິນ​ດີ"​: Sindhi​,
        "--sinhala": Sinhala,
        "--slovak": ສະ​ໂລ​ວັກ,
        "--slovenian": ສະ​ໂລ​ເວ​ນີ,
        "--somali": ໂຊມາລີ,
        "--spanish": ແອສປາໂຍນ,
        "--sundanese": ຊູດານ,
        "--swahili": ພາສາສະວາຮິລີ,
        "--swedish": ຊູ​ແອັດ​,
        "--tajik": Tajik, //t
        "--tamil": ທະມິນ,
        "--tatar": ທາ​ທາ,
        "--telugu": ເຕລູກູ,
        "--ໄທ": ໄທ,
        "--tigrinya": ຕີກຣິນຍາ,
        "--tsonga": ຊັນ​ກາ,
        "--turkish": ຕວກກີ,
        "--turkmen": ເຕີກເມັນ,
        "--twi": ທະວີ,
        "--ukrainian": ອູແກຣນ, //u
        "--urdu": ອູ​ດູ,
        "--uyghur": ອຸຍເກີ,
        "--uzbek": ອຸສເບກ,
        "--vietnamese": ພາສາຫວຽດນາມ, //v
        "--welsh": ເວນ, // ວ
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": ໂຢຣູບາ,
        "--zulu": ຊູລູ, //z
        },
      },

      // latin
      // latin
      latin: {
        translations: {
          "Error inciderunt": Error inciderunt!, //a
           "--electronica": Allocutiones,
           "--admonitio": consilium,
           "--strepitando in pergere": strepitando in perseuando eris disiungitur a ratione tua Veil Brillant, //b
           "--strepitando in disconnect eris disiunctus": strepitando in Disconnect disiuncta eris ex ratione tua izocash,
           "--reprehende numerum virtualem tuum vel postea conare": reprehendo tuum virtualem numerum vel iterum conare postea, //c
           "--reprehende numerum virtualem tuum": reprehendo tuum virtualem numerum,
           "Perge": Perge,
           "--nexion": Connection,
           "--collaborate, concorditer vivite": "collaborate, concorditer cum aliis vivite";
           "-elige linguam": Phone Virtual Language,
           "--don't competition ne impediat": noli prohibere competition, da omnibus occasionem, //d
           "Disiunctio": Disiunctio;
           "-pro omnibus virtualibus telephonicis utentibus": Pro omnibus Phone Virtualibus utentibus, commendatur uti VPN, //f.
           "--ire ad paginam login": vade ad paginam login, //g
           "-historical": Historical, //h
           "--habeo rationem": iam habeo rationem, //i
           "--i rationem non habeo": rationem non habeo,
           Domus tua est: domus tua est;
           " -- image / video + " : imago / video + ,
           "--identity verificationem": Identity verificationem:
           "-izocash mos portal": izocash Customer Portal,
           "-identitas renovatio per singulos annos": Identity update every year;
           "-izocash emere": izocash Buy => izocash international;
           "--log in": Log in!, //l
           "--login": Log in,
           "--login to veil egregie": Connect to Vell Brillant,
           "--login to vixinol store": Connect to Vixinol Store,
           "--login gratis ad rationem velum tuum Brillant": Log in gratis ad rationem velum tuum Brillant accedere hanc pluma,
           "--login success": Login felix!,
           "--login now": Log in now!,
           "--logout success": Logout successful!,
           "--log out": Logout,
           "-logout": Log out,
           "-numerus": Number, //n
           "-nomen": nomen,
           "-nunc log in": Nunc, Log in!
           "--no anathematis in obstringendo certamine";
           Nulla zelus, nulla odium;
           "--Minime,
           "--officialis oratio ad tuam virtualem phone accedere": officiales inscriptiones tuas accedere ad phone virtualis, //o
           "-password": Password, //p
           "--points abstractiones izocash": recedit izocash Points;
           "--points abstractiones": abstractiones puncta,
           "-potius, utere vpn": Potius, utere VPN quae non pertinet ad provisorem interretialem servitii tui;
           "Persistentia semper solvit": Perseverantia semper in fine solvit;
           Regulae, //r
           "--commendatio": Commendationes, etc.
           " -- Registration " : Registration ;
           "-signup velare egregie": Register on Veil Brillant, //s
           "--signup to vixinol store": Register on Vixinol Store,
           "--signup": Register,
           "--signup success": Registration felix!,
           "--signup gratis": Register gratis,
           "--signup victoria IA": Connection felix";
           "Optiones": "Optiones",
           "-configurans Alrani app": Configurans Alrani applicatione;
           "--setting usque ad izocash app": izocash configurans applicationem;
           "--stare vixinol app": Configurans applicationem Vixinol,
           "--set velum Brillant app": Configurans velum Brillant application,
           "Repono imaginum, visorum": repono imaginum, visorum et plurium aliorum elementorum;
           "celeritate receptionis": celeritas receptionis datorum e Datacenter,
           "celeritate": velocitate
           "--terminare": Terminate, //t
           "--in vpn permittit te accedere": VPN te permittit accedere ad sedem vel applicationem ut provisor tuus interrete servitium notarat;
           Arbor erat maxima super omnia simplicis seminis;
           "--Tange screen": Tange screen pergere,
           "-iterum": Conare iterum!,
           "--username": usoris, // u

           "--virtual number": Virtual number, //v
           "--virtual phone settings": Phone Virtual occasus,
           "-virtualis Phone lingua adhibetur": Virtualis Phone lingua applicatur ad applicationem gradu per defaltam,
           "--virtual phone": phone Virtual,
           "-validate": Validate,
           "Suspendisse izocash mos portal": Welcome to the izocash Customer Portal, //w
           "--scribe super codicem": Super codicem intra,
           "salve to": Welcome to,
           "--ubi populus attentio it": Ubi it pecunia populi attentio it,
           victores perseverate: victores perseverate;
           "--vis Alrani rationem log tui": Visne ?, Alrani rationem log ex tuo
           "-ita": Etiam, //y

           // patriam
           "-congo": Congo Brazzaville,
           "-cameroon": Cameroon,
           "-drc": DRC,
           "-ivoryCoast": Eburneum,

           // langue
        "Afrikaans": Afrikaans, //a
        " Albanian " : Albanian ;
        "Aethiopica": Aethiopica,
        "-arabic": Arabic,
        "Armen": Armeni;
        "-assamese": Assamese,
        "-aymara": Aymara,
        "Azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        Basque: Basque,
        "-belarusian": Belarusian;
        "-bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "-bosnian": bosnian,
        "Bulgarica": Bulgarica.
        "-catalan": Catalan, //c
        "--cebuano": Cebuano,
        "-chichewa": Chichewa,
        "--chineseSimplified": Chinese (facilius);
        "--chineseTraditional": Chinese (Traditional);
        "-corsican": Corsica,
        "Croatian": Croatian;
        "-czech": bohemice,
        "--danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        " -- Batavica " :
        "-english": anglice, //e
        "--esperanto": Esperanto,
        "-estonian": Estonian,
        "Ewe": Ewe,
        "--filipino": Filipino, //f
        "Finnica": Finnica,
        "--gallice": French,
        "Frisian": Frisian,
        "-galician": galician, //g
        "georgian": georgian.
        "German": German,
        "Graecum": Greek;
        "-guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "Hebrew": hebraice;
        "-hindi": Hindi,
        "-hmong": Hmong,
        "Hungarian": Hungaricum;
        "-icelandic": Icelandic, //i
        "-igbo": Igbo,
        "--ilocano": Ilocano,
        "-indonesian": Indonesian,
        "-irish": Irish,
        "-italian": Italian;
        "--japanese": Japanese, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Coreanica,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji);
        "-kurdishSorani": Kurdish (Sorani);
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin
        "-latvian": Latvian.
        "-lingala": Lingala,
        "-lithuanian": Lithuanian,
        "-luganda": Luganda,
        "Luxembourgish": Luxembourgish,
        "macedonicus": macedonicus, //m
        "--maithili": Maithili,
        "Malagasy": Malagasy,
        "-malay": Malay,
        "-malayalam": Malayalam,
        "Maltesia": Melitensis,
        "-maori": Maori,
        Marathi: Marathi;
        "--meiteilonManipuri": Meiteilon (Manipuri);
        "-mizo": Mizo,
        "Mongolica": Mongolica;
        "--myanmarBurmese": Myanmar (Burmese);
        "--nepali": Nepali, //n
        Norwegian: Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "-oromo": Oromo,
        "--pashto": Pashto, //p
        "Persica": Persica;
        "-Polish": Polonica;
        " -- Portuguese " : Portuguese ;
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "-romanian": Romanian, //r
        "russian": Russian,
        "-samoan": Samoan, //s
        "-sanskrit": Sanskrit,
        "ScotsGaelic": Scotus Gaelic.
        "--sepedi": Sepedi,
        "--serbian": Serbian;
        "Sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "-slovenian": Slovenian;
        "--somali": Somali,
        "--spanish": Spanish,
        "-sundanese": Sundanese,
        "--swahili": Swahili,
        "Swedish": Suecica,
        "--tajik": Tajik, //t
        "-tamil": Tamil,
        "--tatar": Tatar,
        "-telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "-tsonga": Tsonga,
        "-turkish": Turcica,
        turcarii: Turci,
        "--twi": Twiae
        "-ukrainian": Ucraina, //u
        "--urdu": Urdu,
        "Uyghur": Uyghur,
        Uzbek,
        "--vietnamese": Vietnamensis, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "-yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // latvian
      // latvian
      latvian: {
        translations: {
          "--notikusi kļūda": notikusi kļūda!, //a
           "--adrese": adreses,
           "--padoms": padoms,
           "--noklikšķinot uz turpināt": noklikšķinot uz turpināt, jūs tiksit atvienots no sava Veil Brillant konta, //b
           "--noklikšķinot uz atvienot, jūs tiksit atvienots": Noklikšķinot uz Atvienot, jūs tiksit atvienots no sava izocash konta,
           "--pārbaudiet savu virtuālo numuru vai vēlāk mēģiniet vēlreiz": pārbaudiet savu virtuālo numuru vai vēlāk mēģiniet vēlreiz, //c
           "--check your virtual number": pārbaudiet savu virtuālo numuru,
           "--turpināt": Turpināt,
           "--connection": savienojums,
           "--sadarbojieties, dzīvojiet harmonijā": sadarbojieties, dzīvojiet harmonijā ar citiem,
           "--izvēlieties valodu": virtuālā tālruņa valoda,
           "--neliedz konkurenci": Nenovērš konkurenci, dod iespēju ikvienam, //d
           "--disconnection": atvienošana,
           "--visiem virtuālo tālruņu lietotājiem": visiem virtuālā tālruņa lietotājiem ir ieteicams izmantot VPN, //f
           "--pāriet uz pieteikšanās lapu": dodieties uz pieteikšanās lapu, //g
           "--vēsturisks": Vēsturisks, //h
           "--i ir konts": man jau ir konts, //i
           "--man nav konta": man nav konta,
           "--tā ir jūsu māja": tā ir jūsu māja,
           "--attēls/video +": attēls/video +,
           "--identitātes verifikācija": identitātes pārbaude,
           "--izocash klientu portāls": izocash klientu portāls,
           "--identitātes atjauninājums katru gadu": identitātes atjauninājums katru gadu,
           "--izocash buy to": izocash Buy => izocash international,
           "--log in": Piesakieties!, //l
           "--login": piesakieties,
           "--login to veil brilliant": izveidojiet savienojumu ar Veil Brillant,
           "--pieteikties vixinol veikalā": izveidojiet savienojumu ar Vixinol veikalu,
           "--bez maksas piesakieties savā Veil Brillant kontā": bez maksas piesakieties savā Veil Brillant kontā, lai piekļūtu šai funkcijai,
           "--pieteikšanās veiksmīga": Pieteikšanās veiksmīga!,
           "--login now": Piesakieties tūlīt!,
           "--logout veiksmīgi": iziet veiksmīgi!,
           "--log out": iziet,
           "--logout": iziet,
           "--number": numurs, //n
           "--name": vārds,
           "--tagad piesakieties": Tagad, piesakieties!,
           "--nav aizlieguma apslāpēt konkurenci":
           "--nav greizsirdības, nav naida": nav greizsirdības, nav naida, nav šķelšanās,
           "--Nē nē,
           "--oficiālās adreses, lai piekļūtu jūsu virtuālajam tālrunim": oficiālās adreses, lai piekļūtu jūsu virtuālajam tālrunim, //o
           "--parole": parole, //lpp
           "--punktu izņemšana izocash": punktu izņemšana izocash,
           "--punktu izņemšana": punktu izņemšana,
           "--vēlams, izmantojiet vpn": vēlams izmantot VPN, kas nepieder jūsu interneta pakalpojumu sniedzējam,
           "- neatlaidība vienmēr atmaksājas": neatlaidība vienmēr atmaksājas beigās,
           "--noteikums": noteikumi, //r
           "--recommendation": ieteikumi,
           "--reģistrācija": reģistrācija,
           "--signup to veil brilliant": Reģistrējieties vietnē Veil Brillant, //s
           "--reģistrēšanās vixinol veikalā": reģistrējieties Vixinol veikalā,
           "--signup": Reģistrēties,
           "--reģistrēšanās veiksmīga": reģistrācija ir veiksmīga!,
           "--reģistrēšanās bez maksas": Reģistrējieties bez maksas,
           “--reģistrēšanās veiksmīga IA”: savienojums sekmīgs”,
           "--settings": "Iestatījumi",
           "--alrani lietotnes iestatīšana": Alrani lietojumprogrammas konfigurēšana,
           "--izocash lietotnes iestatīšana": izocash lietojumprogrammas konfigurēšana,
           "--vixinol lietotnes iestatīšana": lietojumprogrammas Vixinol konfigurēšana,
           "--lietotnes Veil Brillant iestatīšana": lietojumprogrammas Veil Brillant konfigurēšana,
           "--attēlu, videoklipu glabāšana": attēlu, videoklipu un vairāku citu elementu glabāšana,
           "-- uztveršanas ātrums": datu saņemšanas ātrums no datu centra,
           "--speed": ātrums,
           "--terminate": pārtraukt, //t
           "--vpn ļauj jums piekļūt": VPN ļauj piekļūt vietnei vai lietojumprogrammai, ko jūsu interneta pakalpojumu sniedzējs ir iekļāvis melnajā sarakstā,
           "--lielākais koks bija augšā": lielākais koks galvenokārt bija vienkārša sēkliņa,
           "--pieskarieties ekrānam": pieskarieties ekrānam, lai turpinātu,
           "--try again": Mēģiniet vēlreiz!,
           "--lietotājvārds": lietotājvārds, //u

           "--virtual number": virtuālais numurs, //v
           "--virtuālā tālruņa iestatījumi": virtuālā tālruņa iestatījumi,
           "--tiek lietota virtuālā tālruņa valoda": virtuālā tālruņa valoda tiek lietota lietojumprogrammas līmenī pēc noklusējuma,
           "--virtual phone": virtuālais tālrunis,
           "--validate": apstiprināt,
           "--laipni lūdzam izocash klientu portālā": Laipni lūdzam izocash klientu portālā, //w
           "--write a super code": ievadiet Super kodu,
           "--welcome to": laipni lūdzam,
           "--kur vēršas cilvēku uzmanība": Kur aiziet cilvēku uzmanība, iet nauda,
           "--uzvarētāji neatlaidīgi": Uzvarētāji neatlaidīgi,
           "--vai vēlaties izrakstīties no sava Alrani konta": vai vēlaties izrakstīties no sava Alrani konta?,
           "--yes": Jā, //y

           // valsts
           "--congo": Kongo Brazavila,
           "--cameroon": Kamerūna,
           "--drc": KDR,
           "--ivoryCoast": Kotdivuāra,

           // valoda
        "--afrikāni": afrikāni, //a
        "--albanian": albāņu,
        "--amharic": amharu,
        "--arābu": arābu,
        "--armenian": armēņu,
        "--asamese": asamiešu,
        "--aymara": Aimara,
        "--azerbaidžāņi": azerbaidžāņu,
        "--bambara": Bambara, //b
        "--basque": basku,
        "--baltkrievu": baltkrievu,
        "--bengāļu": bengāļu,
        "--bhojpuri": Bhojpuri,
        "--bosniešu": bosniešu,
        "--bulgāru": bulgāru,
        "--katalāņu": katalāņu, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": ķīniešu (vienkāršota),
        "--chineseTraditional": ķīniešu (tradicionālā),
        "--corsican": korsikāņu,
        "--horvātu": horvātu,
        "--čehu": čehu,
        "--danish": dāņu, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": holandiešu,
        "--english": angļu, //e
        "--esperanto": esperanto,
        "--igauņu": igauņu,
        "--aite": aita,
        "--filipīniešu": filipīniešu, //f
        "--finnish": somu,
        "--franču": franču,
        "--frīzu": frīzu,
        "--galīcija": galisiešu, //g
        "--gruzīns": gruzīnu,
        "--vācu": vācu,
        "--grieķis": grieķu,
        "--guarani": guarani,
        "--gujarati": gudžaratu,
        "--haitianCreole": Haiti kreols, //h
        "--hausa": Hausa,
        "--havajietis": havajiešu,
        "--ebrejs": ebreju valoda,
        "--hindi": hindi,
        "--hmong": hmong,
        "--ungāru": ungāru,
        "--islandiešu": islandiešu, //i
        "--igbo": igbo,
        "--ilocano": Ilocano,
        "--indonēziešu": indonēziešu,
        "--irish": īru,
        "--itāļu": itāļu,
        "--japāņu": japāņu, //j
        "--javanese": javiešu,
        "--kannada": kannada, //k
        "--kazahu": kazahu,
        "--khmer": khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korejiešu": korejiešu,
        "--krio": Krio,
        "--kurdishKurmanji": kurdu (kurmanji),
        "--kurdishSorani": kurdu (sorani),
        "--kirgiz": kirgīzs,
        "--lao": Laosa, //l
        "--latīņu": latīņu,
        "--latviešu": latviešu,
        "--lingala": Lingala,
        "--lietuviešu": lietuviešu,
        "--luganda": Luganda,
        "--luxembourgish": luksemburgiešu,
        "--maķedoniešu": maķedoniešu, //m
        "--maithili": Maithili,
        "--malagasy": malagasu,
        "--malay": malajiešu,
        "--malajalu": malajalu,
        "--maltiešu": maltiešu,
        "--maori": maori,
        "--marathi": marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongoļu": mongoļu,
        "--myanmarBurmese": Mjanma (birmiešu),
        "--nepali": nepāliešu, //n
        "--norvēģu": norvēģu,
        "--odiaOriya": Odia (Orija), //o
        "--oromo": Oromo,
        "--puštu": puštu, //lpp
        "--persian": persiešu,
        "--polish": poļu,
        "--portugāļu": portugāļu,
        "--pandžabi": pandžabu,
        "--quechua": kečua, //q
        "--rumāņu": rumāņu, //r
        "--krievu": krievu,
        "--samoa": samoa, //s
        "--sanskrits": sanskrits,
        "--scotsGaelic": skotu gēlu,
        "--sepedi": Sepedi,
        "--serbian": serbu,
        "--sesotho": Sesoto,
        "--šona": Šona,
        "--sindhi": Sindhi,
        "--sinhala": singalu,
        "--slovāku": slovāku,
        "--slovēņu": slovēņu,
        "--somāli": somāliešu,
        "--spanish": spāņu,
        "--sundanese": sundāņu,
        "--svahili": svahili,
        "--zviedru": zviedru,
        "--tadžiks": tadžiku, //t
        "--tamil": tamilu,
        "--tatārs": tatārs,
        "--telugu": telugu,
        "--thai": taju,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turku,
        "--turkmēņi": turkmēņu,
        "--twi": Twi,
        "--ukraiņu": ukraiņu, //u
        "--urdu": urdu,
        "--uigurs": uiguri,
        "--uzbek": uzbeku,
        "--vjetnamiešu": vjetnamiešu, //v
        "--welsh": velsiešu, //w
        "--xhosa": Xhosa, //x
        "--jidišs": jidišs, //y
        "--joruba": joruba,
        "--zulu": Zulu, //z
        },
      },

      // lingala
      // lingala
      lingala: {
        translations: {
          "--libunga esalemi": Libunga esalemi!, //a
           "--address": Baadrɛsi, .
           "--toli": Toli, .
           "--na ko cliquer na continue": Na ko cliquer na continue okozala déconnecté na compte na yo ya Veil Brillant, //b
           "--na ko cliquer na disconnection okozala déconnecté": Na ko cliquer na Disconnect okozala déconnecté na compte izocash na yo,
           "--tala nimero na yo ya virtuel to meka lisusu sima": Tala nimero na yo ya virtuel to meka lisusu sima, //c
           "--tala nimero na yo ya virtuel": Tala nimero na yo ya virtuel,
           "--koba": Koba,
           "--bokangami": Bokangami, .
           "--kosala elongo, kofanda na boyokani": Kosala elongo, kofanda na boyokani na basusu,
           "--pona monoko": Monoko ya telefone ya solosolo,
           "--kopekisa momekano te": Kopekisa momekano te, pesa moto nyonso libaku, //d
           "--kokata boyokani": Kokata boyokani, .
           "--mpo na basaleli banso ya téléphone virtuel": Mpo na basaleli banso ya Telephone Virtuel, ezali malamu kosalela VPN, //f
           "--kende na lokasa ya bokɔti": Kende na lokasa ya bokɔti, //g
           "--ya lisolo": Lisolo ya kala, //h
           "--nazali na compte": Nazali déjà na compte, //i
           "--naza na compte te": Naza na compte te,
           "--ezali ndako na yo": ezali ndako na yo,
           "--elilingi / video +": Elilingi / Vidéo +,
           "--vérification ya identité": Bondimi ya identité, .
           "--portal ya ba clients ya izocash": Portal ya ba clients ya izocash,
           "--mikolo ya sika ya bomoto mbula na mbula": Mikolo ya sika ya bomoto mbula na mbula,
           "--izocash kosomba na": izocash Somba => izocash international,
           "--kota": Kokota!, //l
           "--kokɔta": Kokɔta,
           "--kokɔta na voile brillant": Bozala na boyokani na Voile Brillant,
           "--kota na magasin ya vixinol": Connecter na magasin ya Vixinol,
           "--kota ofele na compte na yo ya veil Brillant": Kota ofele na compte na yo ya Veil Brillant mpo na ko accéder na fonctionnalité oyo,
           "--login succès": Kokota elongi!,
           "--kota sikoyo": Kota sikoyo!,
           "--longout ya kolonga": Logout elongi!,
           "--bima": Bima, .
           "--longout": Bima, .
           "--motango": Motango, //n
           "--kombo": Nkombo, .
           "--sikoyo kota": Sikoyo, Kota!,
           "--epekiseli te ya kokanga momekano":
           "--zuwa te, koyina te": Zuwa te, koyina te, bokabwani te,
           "--te": Te, .
           "--ba adresses officielles pona ko accéder na téléphone virtuel na yo": Ba adresses officielles pona ko accéder na téléphone virtuel na yo, //o
           "--mot ya nzela": Mot ya nzela, //p
           "--points retraits izocash": Ba retraites ya points izocash,
           "--kolongolama ya ba points": Kolongolama ya ba points, .
           "--na malamu, salela vpn": Na lolenge ya malamu, salela VPN oyo ezali ya mopesi na yo ya service internet te,
           "--kotingama efutaka ntango nyonso": Kotingama efutaka ntango nyonso na nsuka,
           "--mobeko": Mibeko, //r
           "--likanisi": Makanisi, .
           "--kokomisa nkombo": Bokomisi nkombo, .
           "--inscription na voile brillant": Inscrivez-vous na Voile Brillant, //s
           "--kokoma na magasin ya vixinol": Inscrivez-vous na magasin ya Vixinol,
           "--kokoma": Kokomisa nkombo, .
           "--succès ya signature": Inscription elongi!,
           "--komisa nkombo ofele": Komisa nkombo ofele,
           “--kolonga ya bokomisi nkombo IA”: Bokangami elongi”,
           "--paramètres": "Ba paramètres",
           "--kobongisa appli alrani": Kobongisa application ya Alrani,
           "--kobongisa appli izocash": Kobongisa application ya izocash, .
           "--kobongisa appli vixinol": Kobongisa application ya Vixinol, .
           "--kobongisa appli ya voile Brillant": Kobongisa application ya Veil Brillant,
           "--bobombi bilili, bavideo": Bobombi bilili, bavideo mpe biloko mosusu mingi,
           "--vitesse ya boyambi": Vitesse ya boyambi ba données uta na Datacenter, .
           "--vitesse": Vitesse, .
           "--kosilisa": Kosilisa, //t
           "--vpn epesi yo nzela ya kokɔta": VPN epesaka yo nzela ya kokɔta na site to programɛ oyo mopesi na yo ya mosala ya internet akɔtisi na liste ya moindo,
           "--nzete ya monene ezalaki likolo": Nzete ya monene ezalaki likolo ya nionso mwa mboto ya pete,
           "--simba écran": Finá na écran mpo na kokoba,
           "--meka lisusu": Meka lisusu!,
           "--kombo ya mosaleli": Nkombo ya mosaleli, //u

           "--motango ya solosolo": Motango ya solosolo, //v
           "--paramètres ya téléphone virtuel": Paramètres ya téléphone virtuel,
           "--monoko ya Telephone virtuel esalelami": Monoko ya Telephone Virtuel esalelami na nivo ya bosaleli na ndenge ya libela,
           "--telefone ya solosolo": Telephone virtuel,
           "--kondimisa": Kondimisa, .
           "--boyei malamu na portail ya ba clients ya izocash": Boyei malamu na Portal ya ba clients ya izocash, //w
           "--koma code ya super": Tyá code ya Super,
           "--boyei malamu na": Boyei malamu na,
           "--esika likebi ya bato ekendaka": Esika likebi ya bato ekendaka mbongo ekendaka,
           "--balongi bayika mpiko": Balongi bayika mpiko,
           "--olingi kobima na compte na yo ya Alrani": Olingi kobima na compte na yo ya Alrani?,
           "--ɛɛ": Ee, //y

           // mboka
           "--kongo": Congo Brazzaville,
           "--cameroun": Cameroun,
           "--drc": RDC,
           "--Libongo ya nzoku": Côte d'Ivoire,

           // monoko ya koloba
        "--ba afrikaans": Afrikaans, //a
        "--albanais": Albanie, .
        "--amharic": Amharic, .
        "--arabe": Arabe, .
        "--arménien": Arménien, .
        "--assamese": Liloba lya Assamese, .
        "--aymara": Aymara, .
        "--azerbaïdjan": Azerbaïdjan, .
        "--bambara": Bambara, //b
        "--basque": Basque, .
        "--belarusien": Biélorussie, .
        "--bengali": Libenga, .
        "--bhojpuri": Liloba lya Nzambe,
        "--bosnien": Bosnien, .
        "--bulgarien": Bulgarien, .
        "--catalan": Catalan, //c
        "--cebuano": Cébuano, 1999.
        "--chichewa": Chichewa, 1999.
        "--chinoisSimplified": Chinois (Ezali na pete),
        "--chinoisTraditional": Chinois (Bokoko),
        "--corse": Corse, .
        "--croatien": Croatien, .
        "--tchèque": Tchèque, .
        "--danois": Danois, //d
        "--dhivehi": Moto oyo azali na bomoi,
        "--dogri": Dogri, .
        "--néerlandais": Néerlandais, .
        "--lingala": Lingelesi, //e
        "--esperanto": Esperanto, .
        "--estonie": Estonie, .
        "--mpate ya mpate": Mwasi ya mpate, .
        "--filipino": Mofilipino, //f
        "--finlandais": Finnois, .
        "--français": Lifalanse, .
        "--frisien": Frisien, .
        "--galician": Galicien, //g
        "--georgien": Géorgien, .
        "--allemand": Allemand, .
        "--greke": Grɛki, .
        "--guarani": Guarani, .
        "--gujarati": Na Gujarati, .
        "--Créole ya Haïtien": Créole ya Haïtien, //h
        "--hausa": Hausa, .
        "--hawaïen": Moto ya Hawaii, .
        "--ebre": Liebele, .
        "--hindi": Hindi, .
        "--hmong": Hmong, .
        "--mongongo": Hongrois, .
        "--islandais": Islande, //i
        "--igbo": Igbo, .
        "--ilocano": Ilocano, .
        "--indonésie": Indonésien, .
        "--irlandais": Irlandais, .
        "--italien": Italien, .
        "--japonais": Japonais, //j
        "--javanais": Moto ya Java, .
        "--kannada": Kannada, //k
        "--kazakh": Kazakhstan, .
        "--khmer": Khmer, .
        "--kinyarwanda": Kinyarwanda, .
        "--konkani": Kokani, .
        "--coréen": Coréen, .
        "--krio": Krio, 1999.
        "--kurdishKurmanji": Kurde (Kurmanji), .
        "--kurdishSorani": Kurde (Sorani), .
        "--kyrghise": Kirghizistan, 1999.
        "--lao": Lao, //l
        "--latin": Latin, .
        "--letvien": Lettonien, .
        "--lingala": Lingala, .
        "--lituanien": Lituanien, .
        "--luganda": Luganda, .
        "--luxembourg": Luxembourg, .
        "--momacédonien": Momasedonia, //m
        "--maithili": Liloba lya Nzambe,
        "--malagasy": Malagasy, .
        "--malay": Malais, .
        "--malayalam": Malayalam, .
        "--maltese": Moto ya Malte, .
        "--maori": Maori, .
        "--marathi": Marathi, .
        "--meiteilonManipuri": Meiteilon (Manipuri), .
        "--mizo": Mizo, .
        "--mongolia": Mongolia, .
        "--myanmarBurme": Myanmar (Burme),
        "--népal": Népal, //n
        "--norvégien": Norvège, .
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo, .
        "--pashto": Pashto, //lok
        "--perse": Perse, .
        "--polish": Polonais, .
        "--portugais": Portugais, .
        "--punjabi": Lipunjabi, .
        "--quechua": Quechua, //q
        "--romain": Roumanien, //r
        "--russe": Russe, .
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit, .
        "--scotsGaelic": Gaélic ya Écosse, .
        "--sepedi": Sepedi, 1999.
        "--serbian": Serbien, .
        "--sesotho": Liloba lya lokótá, .
        "--shona": Shona, .
        "--sindhi": Sindhi, 1999.
        "--sinhala": Siinhala, .
        "--slovaque": Slovaque, .
        "--slovénien": Slovénien, .
        "--somali": Somalia, .
        "--espagnol": Espagnol, .
        "--sondanese": Mosundais, .
        "--swahili": Swahili, .
        "--suède": Suède, .
        "--tajik": Tajik, //t
        "--tamil": Tamil, .
        "--tatar": Tatar, .
        "--telugu": Telugu, .
        "--thai": Thaïlande, .
        "--tigrinya": Tigrinya, .
        "--tsonga": Tsonga, 2019.
        "--turc": Turc, .
        "--turkmen": Turkmen, .
        "--twi": Twi, 1999.
        "--ukrainien": Ukrainien, //u
        "--urdu": Urdu, .
        "--uyghur": Uyghur, .
        "--ouzbek": Ouzbek, .
        "--vietnamien": Vietnamien, //v
        "--welsh": Galles, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba, .
        "--zulu": Zulu, //z
        },
      },

      // lithuanian
      // lithuanian
      lithuanian: {
        translations: {
          "--įvyko klaida": Įvyko klaida!, //a
          "--adresas": adresai,
          "--advice": patarimas,
          "--spustelėdami tęsti": spustelėję tęsti būsite atjungti nuo Veil Brillant paskyros, //b
          "--paspaudę atjungti būsite atjungti": Spustelėję Atsijungti būsite atjungti nuo savo izocash paskyros,
          "--patikrinkite virtualų numerį arba bandykite dar kartą vėliau": patikrinkite virtualų numerį arba bandykite dar kartą vėliau, //c
          "--check your virtual number": patikrinkite savo virtualų numerį,
          "--continue": Tęsti,
          "--connection": ryšys,
          "--bendradarbiaukite, gyvenkite harmonijoje": Bendradarbiaukite, gyvenkite darnoje su kitais,
          "--choose language": virtualiojo telefono kalba,
          "--netrukdykite konkurencijai": Netrukdykite konkurencijai, suteikite visiems galimybę, //d
          "--disconnection": atjungimas,
          „--visiems virtualiųjų telefonų naudotojams“: visiems virtualaus telefono naudotojams rekomenduojama naudoti VPN, //f
          "--eikite į prisijungimo puslapį": eikite į prisijungimo puslapį, //g
          "--istorinis": istorinis, //val
          "--i have account": jau turiu paskyrą, //i
          "----i neturiu paskyros": Aš neturiu paskyros,
          "-tai tavo namai": tai tavo namai,
          "--vaizdas / vaizdo įrašas +": vaizdas / vaizdo įrašas +,
          "--identity verification": tapatybės patvirtinimas,
          "--izocash klientų portalas": izocash klientų portalas,
          "--identity update every year": tapatybės atnaujinimas kiekvienais metais,
          "--izocash buy to": izocash Buy => izocash international,
          "--log in": Prisijunkite!, //l
          "--login": prisijunkite,
          „--login to veil brilliant“: prisijunkite prie „Veil Brillant“,
          "--prisijunkite prie vixinol parduotuvės": prisijunkite prie Vixinol parduotuvės,
          "--nemokamai prisijunkite prie savo veil Brillant paskyros": nemokamai prisijunkite prie savo Veil Brillant paskyros, kad pasiektumėte šią funkciją,
          "--login sėkmingai": Prisijungimas sėkmingas!,
          "--login now": Prisijunkite dabar!,
          "--logout sėkmingai": Atsijungimas sėkmingas!,
          "--log out": Atsijungti,
          "--logout": atsijungti,
          "--number": skaičius, //n
          "--name": vardas,
          "-- dabar prisijunkite": Dabar prisijunkite!,
          "--jokio draudimo slopinti konkurenciją":
          „– Jokio pavydo, jokios neapykantos“: Jokio pavydo, jokios neapykantos, jokio susiskaldymo,
          "--ne": Ne,
          "--oficialūs adresai pasiekti virtualųjį telefoną": oficialūs adresai, skirti pasiekti virtualųjį telefoną, //o
          "--password": slaptažodis, //p
          "--taškų išėmimas izocash": taškų išėmimas izocash,
          "--taškų išėmimas": taškų išėmimas,
          "-- pageidautina, naudokite vpn": pageidautina naudoti VPN, kuris nepriklauso jūsų interneto paslaugų teikėjui,
          "--atkaklumas visada atsiperka": atkaklumas visada atsiperka galų gale,
          "--rule": taisyklės, //r
          "--recommendation": rekomendacijos,
          "--registracija": registracija,
          "--registracija į veil brilliant": registruokitės Veil Brillant, //s
          "--prisiregistruokite į vixinol parduotuvę": užsiregistruokite Vixinol parduotuvėje,
          "--registracija": Registruotis,
          "--registracija sėkminga": registracija sėkminga!,
          "--registracija nemokamai": Registruokitės nemokamai,
          „--registravimosi sėkmė IA“: prisijungimas sėkmingas“,
          "--settings": "Nustatymai",
          „--alrani programos nustatymas“: „Alrani“ programos konfigūravimas,
          "--izocash programos nustatymas": konfigūruokite izocash programą,
          "--vixinol programos nustatymas": Vixinol programos konfigūravimas,
          „--programėlės „Veil Brillant“ nustatymas“: „Veil Brillant“ programos konfigūravimas,
          „--vaizdų, vaizdo įrašų saugykla“: vaizdų, vaizdo įrašų ir kelių kitų elementų saugojimas,
          "--priėmimo greitis": duomenų iš duomenų centro priėmimo greitis,
          "--speed": greitis,
          "--terminate": nutraukti, //t
          „--vpn leidžia jums pasiekti“: VPN leidžia pasiekti svetainę arba programą, kurią jūsų interneto paslaugų teikėjas įtraukė į juodąjį sąrašą,
          "-- didžiausias medis buvo aukščiau": didžiausias medis visų pirma buvo paprasta maža sėkla,
          „--touch the screen“: palieskite ekraną, kad tęstumėte,
          "--bandyti dar kartą": Bandykite dar kartą!,
          "--username": vartotojo vardas, //u

          "--virtualus skaičius": virtualus skaičius, //v
           "--virtualaus telefono nustatymai": virtualaus telefono nustatymai,
           "--Taikoma virtualiojo telefono kalba": Virtualiojo telefono kalba taikoma programos lygiu pagal numatytuosius nustatymus,
           "--virtualus telefonas": virtualus telefonas,
           "--validate": patvirtinti,
           "--sveiki atvykę į izocash klientų portalą": Sveiki atvykę į izocash klientų portalą, //w
           "--write a super code": įveskite Super kodą,
           "--welcome to": Sveiki atvykę į,
           "- kur kreipiamas žmonių dėmesys": kur krypsta žmonių dėmesys, eina pinigai,
           "--laimėtojai ištveria": Nugalėtojai ištveria,
           "--ar norėtumėte atsijungti nuo Alrani paskyros": Ar norite atsijungti nuo Alrani paskyros?,
           "--yes": Taip, //y

           // Šalis
           "--congo": Kongo Brazavilis,
           "--cameroon": Kamerūnas,
           "--drc": KDR,
           "--ivoryCoast": Dramblio Kaulo Krantas,

           // kalba
        "--afrikanai": afrikanų, //a
        "--albanian": albanų,
        "--amharic": amharų,
        "--arabic": arabų,
        "--armenian": armėnų,
        "--asamese": asamų,
        "--aymara": Aimara,
        "--azerbaidžanietis": azerbaidžaniečių,
        "--bambara": Bambara, //b
        "--basque": baskų,
        "--baltarusų": baltarusių,
        "--bengalų": bengalų,
        "--bhojpuri": Bhojpuri,
        "--bosnių": bosnių,
        "--bulgarų": bulgarų,
        "--katalonų": katalonų, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kinų (supaprastinta),
        "--chineseTraditional": kinų (tradicinė),
        "--corsic": korsikiečių,
        "--croatian": kroatų,
        "--čekų": čekų,
        "--danish": danų, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--olandų": olandų,
        "--anglų kalba": anglų, //e
        "--esperanto": esperanto,
        "--estų": estų,
        "--ewe": Ave,
        "--filipino": filipiniečių, //f
        "--finnish": suomių,
        "--french": prancūzų,
        "--frisian": fryzų,
        "--galician": galisų, //g
        "--gruzinų": gruzinų,
        "--vokiečių kalba": vokiškai,
        "--greek": graikų,
        "--guarani": Guarani,
        "--gujarati": gudžarati,
        "--haitianCreole": Haičio kreolų, //val
        "--hausa": Hausa,
        "--havajų": havajų,
        "--hebrew": hebrajų,
        "--hindi": hindi,
        "--hmong": hmong,
        "--vengrų": vengrų,
        "--islandų": islandų, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indoneziečių": indoneziečių,
        "--irish": airių,
        "--italų": italų,
        "--japonų": japonų, //j
        "--javanese": javiečių,
        "--kannada": kanada, //k
        "--kazachų": kazachų,
        "--khmer": khmeras,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korėjiečių": korėjiečių,
        "--krio": Krio,
        "--kurdishKurmanji": kurdų (kurmanji),
        "--kurdishSorani": kurdų (sorani),
        "--kirgizas": kirgizas,
        "--lao": Laosas, //l
        "--lotynų": lotynų,
        "--latviškai": latvių,
        "--lingala": lingala,
        "--lietuvių": lietuvių,
        "--luganda": Luganda,
        "--luxembourgish": liuksemburgiečių,
        "--makedonų": makedonų, //m
        "--maithili": Maithili,
        "--malagasy": malagasų,
        "--malay": malajiečių,
        "--malajalam": malajalių,
        "--maltese": maltiečių,
        "--maoriai": maorių,
        "--marathi": marati,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolų": mongolų,
        "--myanmarBurmese": Mianmaras (birmiečių),
        "--nepali": Nepali, //n
        "--norwegian": norvegų,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pušto": puštonų, //p
        "--persian": persų,
        "--polish": lenkų,
        "--portuguese": portugalų,
        "--pandžabi": pandžabų,
        "--quechua": kečua, //q
        "--rumunų": rumunų, //r
        "--rusų kalba": rusų,
        "--samoan": samoa, //s
        "--sanskritas": sanskritas,
        "--scotsGaelic": škotų gėlų,
        "--sepedi": sepedi,
        "--serbian": serbų,
        "--sesotho": Sesotho,
        "--šona": Šona,
        "--sindhi": Sindhi,
        "--sinhala": sinhala,
        "--slovak": slovakų,
        "--slovėnų": slovėnų,
        "--somali": Somalis,
        "--spanish": ispanų,
        "--sundanese": Sundanese,
        "--swahili": suahilių,
        "--swedish": švedų,
        "--tadžikas": tadžikų, //t
        "--tamil": tamilų,
        "--totaras": totorių,
        "--telugu": telugų,
        "--thai": tajų,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turkiškai,
        "--turkmen": turkmėnų,
        "--twi": Twi,
        "--ukrainiečių": ukrainiečių, //u
        "--urdu": urdu,
        "--uigūras": uigūras,
        "--uzbek": uzbekų,
        "--vietnamiečių": vietnamiečių, //v
        "--welsh": valų kalba, //w
        "--xhosa": Xhosa, //x
        "--jidiš": jidiš, //y
        "--yoruba": joruba,
        "--zulu": Zulu, //z
        },
      },

      // luganda
      // luganda
      luganda: {
        translations: {
          "--Ensobi ebaddewo": Ensobi ebaddewo!, //a
           "--endagiriro": Endagiriro,
           "--amagezi": Amagezi,
           "--nga onyiga ku continue": Bw'onyiga ku continue ojja kuggyibwako akawunti yo eya Veil Brillant, //b
           "--bw'onyiga ku disconnect ojja kuggyibwako": Bw'onyiga ku Disconnect ojja kuggyibwako ku akawunti yo eya zocash,
           "--kebera ennamba yo ey'omubiri oba gezaako okuddamu oluvannyuma": Kebera ennamba yo ey'omubiri oba ddamu ogezeeko oluvannyuma, //c
           "--kebera ennamba yo ey'omubiri": Kebera ennamba yo ey'omubiri,
           "--genda mu maaso": Genda mu maaso,
           "--okuyungibwa": okuyungibwa, .
           "--okukolagana, okubeera mu kukwatagana": Okukolagana, okubeera mu kukwatagana n'abalala,
           "--londa olulimi": Olulimi lw'essimu olw'omubiri,
           "--tolemesa kuvuganya": Toziyiza kuvuganya, buli muntu muwe omukisa, //d
           "--Okukutuka": Okukutula, .
           "--for all virtual phone users": Eri bonna abakozesa essimu ey'omubiri, kirungi okukozesa VPN, //f
           "--Genda ku lupapula lw'okuyingira": Genda ku lupapula lw'okuyingira, //g
           "--ebyafaayo": Ebyafaayo, //h
           "--nina akawunti": Nnina dda akawunti, //i
           "--sirina akawunti": Sirina akawunti,
           "--ye nnyumba yo": ye nnyumba yo,
           "--ekifaananyi / vidiyo +": ekifaananyi / vidiyo +,
           "--Okukakasa Okumanya": Okukakasa endagamuntu, .
           "--Omulyango gwa bakasitoma ogwa Izocash": Izocash omukutu gwa bakasitoma,
           "--okulongoosa endagamuntu buli mwaka": Okulongoosa endagamuntu buli mwaka,
           "--izocash gula okutuuka": izocash gula => izocash International,
           "--okuyingira": Yingira!, //l .
           "--okuyingira": Yingira, .
           "--Yingira mu Veil Brilliant": Yunga ku Veil Brillant,
           "--Yingira mu dduuka lya Vixinol": Yunga ku dduuka lya Vixinol,
           "--yingira ku bwereere ku akawunti yo eya veil Brillant": Yingira ku bwereere ku akawunti yo eya Veil Brillant okufuna ekintu kino,
           "--Obuwanguzi mu Login": Okuyingira obuwanguzi!,
           "--Yingira kati": Yingira kati!,
           "--logout success": Okufuluma kwa buwanguzi!,
           "--fuluma": Okufuluma,
           "--logout": Okufuluma,
           "--Nnamba": Ennamba, //n .
           "--erinnya": Erinnya,
           "--kati yingira": Kati, Yingira!,
           "--tewali kuwera kuziyiza kuvuganya":
           "--tewali buggya, tewali bukyayi": Tewali buggya, tewali bukyayi, tewali njawukana, .
           "--nedda": Nedda,
           "--endagiriro entongole okuyingira ku ssimu yo ey'omubiri": Endagiriro entongole okuyingira ku ssimu yo ey'omubiri, //o
           "--ekigambo ky'okuyita": Ekigambo ky'okuyita, //p
           "--Ebiwandiikidde Okuggyayo Izocash": Okuggyayo obubonero Izocash,
           "--okuggyayo obubonero": Okuggyayo obubonero,
           "--okusinga, kozesa VPN": Okusinga, kozesa VPN etali ya muweereza wa mpeereza yo eya yintaneeti,
           "--okugumiikiriza bulijjo kusasula": Okugumiikiriza bulijjo kusasula ku nkomerero,
           "--etteeka": Amateeka, //r
           "--Okuteesa": Ebiteeso, .
           "--okwewandiisa": Okwewandiisa, .
           "--okwewandiisa ku Veil Brilliant": Wewandiise ku Veil Brillant, //s
           "--Ekyewandiisa ku Vixinol Store": Wewandiise ku Vixinol Store,
           "--okwewandiisa": Wewandiise,
           "--Obuwanguzi mu kwewaayo": Okwewandiisa kwatuuka ku buwanguzi!,
           "--signup for free": Wewandiise ku bwereere,
           “--Signup Success IA”: Omukago gutuuse ku buwanguzi”, .
           "--okuteekawo": "Ensengeka", .
           "--okuteekawo app ya alrani": Okutegeka enkola ya Alrani,
           "--Okuteekawo App ya Izocash": Okutegeka enkola ya izocash, .
           "--okuteekawo app ya vixinol": Okutegeka enkola ya Vixinol,
           "--Okuteekawo App ya Veil Brillant": Okutegeka enkola ya Veil Brillant, .
           "--okutereka ebifaananyi, vidiyo": Okutereka ebifaananyi, vidiyo n'ebintu ebirala ebiwerako,
           "--speed of reception": Sipiidi y'okufuna data okuva mu Datacenter,
           "--sipiidi": Sipiidi, .
           "--terminate": Okukomya, //t
           "--VPN ekukkiriza okuyingira": VPN ekusobozesa okuyingira ku mukutu oba enkola omuwa empeereza yo eya yintaneeti gy'assaako enkalala,
           "--Omuti ogusinga obunene gwali waggulu": Omuti ogusinga obunene gwali waggulu w'ensigo entono ennyangu,
           "--kwata ku screen": Koona ku screen okugenda mu maaso,
           "--gezaako nate": Gezaako nate!,
           "--erinnya ly'omukozesa": erinnya ly'omukozesa, //u

           "--ennamba entuufu": Ennamba ey'omubiri, //v
           "--ensengeka z'essimu ez'omubiri": Enteekateeka z'essimu ez'omubiri,
           "--olulimi lw'essimu olutuufu lukozesebwa": Olulimi lw'essimu ey'omubiri (virtual Phone language) lukozesebwa ku mutendera gw'okukozesa nga bwe guli,
           "--essimu ey'omubiri": Essimu ey'omubiri,
           "--okukakasa": Okukakasa, .
           "--mwaniriziddwa ku mukutu gwa bakasitoma ba izocash": Mwaniriziddwa ku mukutu gwa bakasitoma ba izocash, //w
           "--wandiika koodi ya super": Yingiza koodi ya Super,
           "--mwaniriziddwa mu": Mwaniriziddwa mu,
           "--okufaayo kw'abantu gye kugenda": Okufaayo kw'abantu gye kugenda ssente,
           "--abawanguzi bagumiikiriza": Abawanguzi bagumiikiriza,
           "--wandyagadde okuva ku akawunti yo eya Alrani": Oyagala kuva ku akawunti yo eya Alrani?,
           "--yes": Yee, //y

           // eggwanga
           "--kongo": Congo Brazzaville, 1999.
           "--cameroon": Cameroon,
           "--drc": DRC, 1999.
           "--ivoryCoast": Olubalama lw'amasanga,

           // olulimi olulimi
        "--afrikaans": Olufirika, //a
        "--lualbania": Olualbania, .
        "--luamharic": Oluamharic, .
        "--oluwarabu": Oluwarabu, .
        "--omuarmenia": Omuarmenia, .
        "--assamese": Olusumba, .
        "--aymara": Oluymara, .
        "--olulimi Oluazerbaijani": Olulimi Oluazerbaijan, .
        "--bambara": Olulimi Oluganda, //b
        "--basque": Olubasque, .
        "--belarusian": Omubelarusian, .
        "--oluganda": Oluganda, .
        "--bhojpuri": Olulimi Oluganda,
        "--bosnian": Omubosnia, .
        "--bulgaria": Olubulgaria, .
        "--olukatalani": Olukatalani, //c
        "--cebuano": Omucebuano, .
        "--chichewa": Omuchichewa, .
        "--chineseSimplified": Oluchina (Ekyangu),
        "--chineseEnnono": Oluchina (Ennono),
        "--olulimi Olukorsika": Olukorsika, .
        "--olulimi Olucroatia": Olucroatia, .
        "--czech": Oluceke, .
        "--danish": Oludansi, //d
        "--dhivehi": Omuyimbi, .
        "--dogri": Olulimi Oluganda,
        "--mudaaki": Omudaaki, .
        "--luganda": Luganda, //e
        "--esperanto": Oluganda, .
        "--estonian": Oluestonia, .
        "--endiga": Ente, .
        "--filipino": Olufilipino, //f
        "--olulimi Olufinishi": Olufinishi, .
        "--lufaransa": Olufaransa,
        "--frisian": Omufirisiya, .
        "--galician": Omugalician, //g
        "--omugeorgia": Omugeorgia,
        "--lugirimaani": Omugirimaani, .
        "--luyonaani": Oluyonaani, .
        "--guarani": Oluganda, .
        "--olugujarati": Olulimi Oluganda, .
        "--haitianCreole": Olulimi Oluhaiti, //h
        "--hausa": Omuzungu,
        "--Oluhawaii": Oluhawaii, .
        "--hebbulaniya": Olwebbulaniya, .
        "--hindi": Olulimi Oluhindu,
        "--hmong": Omusomo, .
        "--luhungary": Oluhungary, .
        "--olulimi Oluiceland": Oluyisilandi, //i
        "--igbo": Olulimi Oluganda,
        "--ilocano": Olulimi Oluganda,
        "--oluyindi": Oluyindonesia, .
        "--irish": Oluyindi, .
        "--oluyitale": Oluyitale, .
        "--olujapani": Olujapani, //j
        "--lujavanese": Olujava, .
        "--kannada": Olukannada, //k
        "--kazakh": Olukazakh, .
        "--khmer": Omukmer, .
        "--kinyarwanda": Olulimi Oluganda,
        "--konkani": Olukonkoni,
        "--korean": Olukorea, .
        "--krio": Omusajja Omukulu,
        "--kurdishKurmanji": Olukurdi (Kurmanji), .
        "--kurdishSorani": Olukurdi (Olusorani), .
        "--kyrgyz": Omukyrgyz, .
        "--lao": Olulao, //l
        "--olulattini": Olulattini, .
        "--latvian": Olulatvia, .
        "--lingala": Olulimi Oluganda,
        "--olulimi Olulithuania": Olulithuanian, .
        "--luganda": Oluganda,
        "--luxembourgish": Oluluxembourgish, .
        "--makedoniya": Omumakedoni, //m
        "--maithili": Olulimi Oluganda,
        "--olulimi Olumalagasy": Olumalagasy, .
        "--olumalay": Olumalayi, .
        "--olumalayalam": Olumalayalam, .
        "--maltese": Olumalta, .
        "--maori": Omumaori, .
        "--marathi": Olumarathi, .
        "--meiteilonManipuri": Omuntu w'abantu (Manipuri), .
        "--mizo": Omuzungu,
        "--omungolia": Omumongoli, .
        "--myanmarOluburmaani": Myanmar (Oluburma),
        "--nepali": Olunepali, //n
        "--Olunorway": Olunorway, .
        "--odiaOriya": Olulimi Oluganda (Oriya), //o
        "--oromo": Olulimi Oluganda,
        "--pashto": Olupashto, //olupapula
        "--luperusi": Oluperusi, .
        "--polish": Okusiiga, .
        "--olupotugo": Olupotugo, .
        "--lupunjabi": Olupunjabi, .
        "--quechua": Oluganda, //q
        "--luromaani": Oluromania, //r
        "--lurusiya": Olurussia, .
        "--samoan": Omusamoa, //s
        "--lusanskrit": Olusanskrit, .
        "--scotsGaelic": Olugayiki olw'e Scotland, .
        "--sepedi": Olulimi Oluganda,
        "--omuserbia": Omuserbia, .
        "--olulimi Oluganda": Olulimi Oluganda,
        "--shona": Omusono,
        "--sindhi": Olulimi Olusindi,
        "--sinhala": Olusimbi, .
        "--Oluslovakia": Oluslovaki,
        "--Oluslovenia": Oluslovenia, .
        "--olusomali": Olusomali, .
        "--lusipeyini": Olusipeyini,
        "--sundane": Omusunda, .
        "--luswahili": Oluswayiri, .
        "--swedish": Oluswedi, .
        "--tajik": Olutajiki, //t
        "--tamil": Olutamil, .
        "--tatar": Omutaali, .
        "--telugu": Olulimi Oluganda,
        "--thai": Oluthailand, .
        "--olulimi Oluganda": Olulimi Oluganda,
        "--olulimi Oluganda": Oluganda,
        "--olutuluuki": Olutuluuki, .
        "--turkmen": Abatuluuki, .
        "--twi": Omutwe, .
        "--oluukrainian": Oluukraine, //u
        "--urdu": Oluurudu, .
        "--uyghur": Omuyighur, .
        "--oluuzbeki": Oluuzibeki, .
        "--olulimi Oluvietnam": Oluviyetnam, //v
        "--welsh": Oluwelsh, //w
        "--xhosa": Oluganda, //x
        "--yiddish": Oluyiddishi, //y
        "--yoruba": Oluyoruba, .
        "--zulu": Oluzulu, //z
        },
      },

      // luxembourgeois
      // luxembourgeois
      luxembourgish: {
        translations: {
          "--e Feeler ass geschitt": E Feeler ass geschitt!, //a
           "--address": Adressen,
           "--advice": Rotschléi,
           "--duerch weiderzeklicken": Andeems Dir op weider klickt gitt Dir vun Ärem Veil Brillant Kont ofgeschalt, //b
           "--vum Klick op disconnect Dir wäert disconnected ginn": Andeems Dir op Disconnect klickt gitt Dir vun Ärem izocash Kont ofgeschalt,
           "--checkt Är virtuell Nummer oder probéiert nach eng Kéier méi spéit": Kontrolléiert Är virtuell Nummer oder probéiert et méi spéit, //c
           "--check your virtual number": Check your virtual number,
           "--continue": Weider,
           "--connection": Verbindung,
           "--kollaboréieren, liewen an Harmonie": Zesummenaarbecht, liewen an Harmonie mat aneren,
           "--choose language": Virtuell Telefonssprooch,
           "--Konkurrenz net verhënneren": Konkurrenz net verhënneren, jidderengem eng Chance ginn, //d
           "--disconnection": Trennung,
           "--fir all virtuell Telefon Benotzer": Fir all virtuell Telefon Benotzer, ass et recommandéiert e VPN ze benotzen, //f
           "--goen op Login Säit": Gitt op d'Login Säit, //g
           "--historical": historesch, //h
           "-I have account": Ech hu schonn e Kont, //i
           "--ech hu kee Kont": Ech hu kee Kont,
           "--et ass Äert Haus": et ass Äert Haus,
           "--image / video +": Bild / Video +,
           "--identity verification": Identitéitsverifikatioun,
           "--izocash Client Portal": izocash Client Portal,
           "--identitéit update all Joer": Identitéit update all Joer,
           "--izocash kafen fir": izocash Kafen => izocash international,
           "--log an": Aloggen!, //l
           "--login": Aloggen,
           "--login zu Veil Brillant": Connect to Veil Brillant,
           "--login an de Vixinol Store": Connect to Vixinol Store,
           "--Login gratis op Äre Veil Brillant Kont": Mellt Iech gratis op Äre Veil Brillant Kont un fir op dës Fonktioun ze kommen,
           "--login Erfolleg": Aloggen erfollegräich!,
           "--login elo": Mellt Iech elo un!,
           "--logout success": Ausloggen erfollegräich!,
           "--logout": Ausloggen,
           "--logout": Ausloggen,
           "--number": Zuel, //n
           "--name": Numm,
           "--now aloggen": Elo, Mellt Iech un!,
           "- kee Verbuet fir d'Konkurrenz ze stéieren":
           "--keng Jalousie, keen Haass": Kee Jalousie, keen Haass, keng Divisiounen,
           "--Nee nee,
           "--offiziell Adressen fir Zougang zu Ärem virtuellen Telefon": Offiziell Adresse fir Zougang zu Ärem virtuellen Telefon, //o
           "--password": Passwuert, //p
           "--Punkte Réckzuch izocash": Punkte Réckzuch izocash,
           "--Punkte Réckzuch": Punkte Réckzuch,
           "--Preferably, use a vpn": Benotzt am léifsten e VPN deen net zu Ärem Internet Service Provider gehéiert,
           "--Persistenz lount sech ëmmer": Persistenz lount sech ëmmer um Enn,
           "--regel": Regelen, //r
           "--recommendation": Empfehlungen,
           "--registration": Umeldung,
           "--signup to veil brilliant": Registréiert Iech op Veil Brillant, //s
           "--signup to vixinol store": Registréiert Iech am Vixinol Store,
           "--signup": Registréiert,
           "--signup success": Aschreiwung erfollegräich!,
           "--signup gratis": Registréiert Iech gratis,
           "--signup success IA": Verbindung erfollegräich",
           "--settings": "Astellungen",
           "--d'alrani App opzestellen": D'Alrani Applikatioun konfiguréieren,
           "--astellung vun der izocash App": Konfiguratioun vun der izocash Applikatioun,
           "--d'Vixinol App opsetzen": D'Vixinol Applikatioun konfiguréieren,
           "--d'Schleier Brillant App opsetzen": D'Veil Brillant Applikatioun konfiguréieren,
           "--Späichere vu Biller, Videoen": Späichere vu Biller, Videoen a verschiddenen aneren Elementer,
           "--speed of reception": Empfangsgeschwindegkeet vun Daten aus dem Datacenter,
           "--speed": Geschwindegkeet,
           "--terminate": Ofschloss, //t
           "--de VPN erlaabt Iech Zougang": De VPN erlaabt Iech Zougang zu engem Site oder enger Applikatioun op déi Ären Internet Service Provider op d'Schwaarzlëscht gesat huet,
           "--de gréisste Bam war uewen": De gréisste Bam war virun allem en einfacht klengt Som,
           "--touch the screen": Touch den Ecran fir weiderzemaachen,
           "--try again": Probéiert nach eng Kéier!,
           "--username": Benotzernumm, //u

           "--virtuell Zuel": Virtuell Zuel, //v
           "--virtuell Telefon Astellunge": Virtuell Telefon Astellunge,
           "--virtuell Telefon Sprooch gëtt ugewannt": Déi virtuell Telefon Sprooch gëtt um Applikatiounsniveau als Standard ugewannt,
           "--virtuell Telefon": Virtuell Telefon,
           "--validate": validéieren,
           "--wëllkomm um izocash Client Portal": Wëllkomm op der izocash Client Portal, //w
           "--schreiwen e Supercode": Gitt e Supercode an,
           "--welcome to": Wëllkomm op,
           "--wou d'Opmierksamkeet vun de Leit geet": Wou d'Opmierksamkeet vun de Leit geet Geld geet,
           "--winners persevere": D'Gewënner persevere,
           "--géift Dir vun Ärem Alrani Kont ausloggen": Wëllt Dir Iech vun Ärem Alrani Kont ausloggen?,
           "--jo": Jo, //y

           // Land
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Côte d'Ivoire,

           // Sprooch
        "--afrikaans": Afrikaans, //a
        "--albanesch": Albanesch,
        "--amharesch": Amharesch,
        "--arabesch": Arabesch,
        "--armenesch": Armenesch,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--aserbaidschanesch": Aserbaidschan,
        "--Bambara": Bambara, //b
        "--basque": Baskesch,
        "--belarusian": Wäissrussesch,
        "--bengali": Bengalesch,
        "--bhojpuri": Bhojpuri,
        "--bosnesch": bosnesch,
        "--bulgaresch": Bulgaresch,
        "--katalanesch": katalanesch, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Chinesesch (vereinfacht),
        "--chineseTraditional": Chinesesch (traditionell),
        "--corsican": korsikanesch,
        "--kroatesch": kroatesch,
        "--tschechesch": Tschechesch,
        "--dänesch": Dänesch, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--hollännesch": hollännesch,
        "--englesch": Englesch, //e
        "--esperanto": Esperanto,
        "--estnesch": estnesch,
        "--ewe": Ee,
        "--Filippinesch": Filipino, //f
        "--finnesch": Finnesch,
        "--franséisch": Franséisch,
        "--frisian": friesesch,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "--däitsch": Däitsch,
        "--griechesch": Griichesch,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebräesch": Hebräesch,
        "--Hindi": Hindi,
        "--hmong": Hmong,
        "--ungaresch": Ungaresch,
        "--islännesch": Islännesch, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesesch": indonesesch,
        "--irish": Iresch,
        "--italienesch": Italienesch,
        "--japanesch": Japanesch, //j
        "--javanese": javanesch,
        "--kannada": Kannada, //k
        "--kasachesch": Kasachesch,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--koreanesch": Koreanesch,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdesch (Kurmanji),
        "--kurdishSorani": Kurdesch (Sorani),
        "--kyrgyz": Kirgisesch,
        "--lao": Lao, //l
        "--latin": Latäin,
        "--lettesch": lettesch,
        "--lingala": Lingala,
        "--litauesch": litauesch,
        "--luganda": Luganda,
        "--lëtzebuergesch": Lëtzebuergesch,
        "--macedonesch": Mazedonesch, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": malayesch,
        "--malayalam": malayalam,
        "--maltesesch": Maltesesch,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolesch": Mongolesch,
        "--myanmarBurmesesch": Myanmar (Birmesesch),
        "--nepali": Nepalesesch, //n
        "--norwegesch": Norwegesch,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persesch": persesch,
        "--polesch": polnesch,
        "--portugisesch": Portugisesch,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--rumänesch": rumänesch, //r
        "--russesch": russesch,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Schottesch Gaelesch,
        "--sepedi": Sepedi,
        "--serbesch": serbesch,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slowakesch": Slowakesch,
        "--slowenesch": Slowenesch,
        "--somali": Somalesch,
        "--spanish": spuenesch,
        "--sundanese": Sundanesesch,
        "--swahili": Swahili,
        "--swedish": schwedesch,
        "--tajik": Tadschikesch, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--tierkesch": tierkesch,
        "--turkmen": Turkmenesch,
        "--twi": zwee,
        "--ukrainesch": Ukrainesch, //u
        "--urdu": Urdu,
        "--uyghur": Uighur,
        "--uzbek": Usbekesch,
        "--vietnamesesch": Vietnamesesch, //v
        "--welsch": Waliser, //w
        "--xhosa": Xhosa, //x
        "--jiddesch": Jiddesch, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // macedonian
      // macedonian
      macedonian: {
        translations: {
          "--настана грешка": Се појави грешка!, //a
           "--address": адреси,
           "--совет": Совет,
           „--со кликнување на продолжи“: со кликнување на продолжи ќе бидете исклучени од вашата сметка на Veil Brillant, //b
           "--со кликнување на исклучување ќе бидете исклучени": со кликнување на Исклучи ќе бидете исклучени од вашата сметка на izocash,
           „--проверете го вашиот виртуелен број или обидете се повторно подоцна“: проверете го вашиот виртуелен број или обидете се повторно подоцна, //c
           „--проверете го вашиот виртуелен број“: проверете го вашиот виртуелен број,
           "--продолжи": Продолжи,
           "--connection": Врска,
           „--соработувај, живеј во хармонија“: соработувај, живеј во хармонија со другите,
           „--избери јазик“: Виртуелен јазик на телефонот,
           „--не спречувај конкуренција“: Не спречувај конкуренција, дај им шанса на сите, //г
           "--disconnection": исклучување,
           „--за сите корисници на виртуелен телефон“: за сите корисници на виртуелен телефон, се препорачува користење VPN, //f
           "--go to login page": Одете на страната за најавување, //g
           "--историски": Историски, //ч
           "--имам сметка": Јас веќе имам сметка, //i
           "--немам сметка": немам сметка,
           „--тоа е вашата куќа“: тоа е вашата куќа,
           „--слика / видео +“: слика / видео +,
           „--проверка на идентитет“: верификација на идентитет,
           "--izocash клиентски портал": izocash клиентски портал,
           „--Ажурирање на идентитет секоја година“: Ажурирање на идентитет секоја година,
           "--izocash buy to": izocash Купи => izocash international,
           "--log in": Најавете се!, //l
           "--login": најавете се,
           „--најавете се во veil brilliant“: Поврзете се со Veil Brillant,
           „--најавете се во продавницата на виксинол“: Поврзете се со продавницата Виксинол,
           „--најавете се бесплатно на вашата сметка на Veil Brillant“: најавете се бесплатно на вашата сметка на Veil Brillant за да пристапите до оваа функција,
           "--успех за најавување": Најавувањето е успешно!,
           "--најави се сега": Најавете се сега!,
           "--одјавување успех": Одјавувањето е успешно!,
           "--log out": одјавување,
           "--logout": одјави се,
           "--број": Број, //n
           "--име": име,
           "--сега најавете се": Сега, најавете се!,
           „--нема забрана за задушување на конкуренцијата“:
           „--без љубомора, без омраза“: Без љубомора, без омраза, без поделби,
           "--не": Не,
           „--официјални адреси за пристап до вашиот виртуелен телефон“: официјални адреси за пристап до вашиот виртуелен телефон, //o
           "--password": Лозинка, //стр
           „--повлекувања на поени изокаш“: Повлекувања на поени изокаш,
           „--повлекувања на поени“: Повлекувања на поени,
           „--по можност, користете vpn“: по можност, користете VPN што не му припаѓа на вашиот давател на интернет услуги,
           „--Упорноста секогаш се исплати“: Упорноста секогаш се исплати на крајот,
           "--rule": Правила, //r
           "--препорака": Препораки,
           "--регистрација": Регистрација,
           „--регистрирај се на veil brilliant“: Регистрирај се на Veil Brillant, //s
           „--регистрирајте се во продавницата на виксинол“: Регистрирајте се на продавницата Виксинол,
           "--регистрација": Регистрирајте се,
           "--успешна регистрација": Регистрацијата е успешна!,
           "--пријавете се бесплатно": Регистрирајте се бесплатно,
           „--успешна регистрација IA“: Врската е успешна“,
           "--поставки": "Поставки",
           „--поставување на апликацијата alrani“: конфигурирање на апликацијата Alrani,
           „--поставување на апликацијата izocash“: конфигурирање на апликацијата izocash,
           „--поставување на апликацијата vixinol“: конфигурирање на апликацијата Vixinol,
           „--поставување на апликацијата Veil Brillant“: Конфигурирање на апликацијата Veil Brillant,
           „--чување на слики, видеа“: Складирање на слики, видеа и неколку други елементи,
           „--брзина на прием“: Брзина на прием на податоци од Центарот за податоци,
           "--брзина": Брзина,
           "--terminate": Прекини, //t
           „-- vpn ви овозможува пристап“: VPN ви овозможува да пристапите до локација или апликација што вашиот давател на интернет услуги ја ставил на црната листа,
           „--најголемото дрво беше горе“: Најголемото дрво беше пред се едноставно мало семе,
           „--touch the screen“: допрете го екранот за да продолжите,
           "--пробај повторно": Обиди се повторно!,
           "--корисничко име": Корисничко име, //u

           „--виртуелен број“: Виртуелен број, //v
           „--виртуелни поставки на телефонот“: поставки за виртуелен телефон,
           „--Се применува виртуелен јазик на телефонот“: Јазикот на виртуелен телефон стандардно се применува на ниво на апликација,
           „--виртуелен телефон“: виртуелен телефон,
           "--validate": Потврди,
           „--добре дојдовте на порталот за клиенти на izocash“: Добредојдовте на порталот за клиенти на izocash, //w
           „--напишете супер код“: внесете супер код,
           "--добредојдовте во": Добредојдовте во,
           „--каде што оди вниманието на луѓето“: Каде што оди вниманието на луѓето одат парите,
           "--победниците истраат": Победниците истраат,
           "--дали сакате да се одјавите од вашата сметка на Алрани": Дали сакате да се одјавите од вашата сметка на Алрани?,
           "--да": Да, //y

           // земја
           "--конго": Конго Бразавил,
           "--камерун": Камерун,
           "--drc": DRC,
           "--Брегот на Слоновата Коска": Брегот на Слоновата Коска,

           // langue
        „-Африканс“: Африканс, // а
        „-Албанијан“: Албански,
        „-Амаричен“: Амхарски,
        „-арабичен“: арапски,
        "-Арменски": Ерменски,
        „-Асамес“: Асамски,
        „-ајмара“: Ајмара,
        „-Озербејџани“: Азербејџани,
        "--Бамбара": Бамбара, // б
        „--баск“: Баскија,
        „--Беларуски“: Белоруски,
        „--Бенгали“: Бенгалски,
        "----bhojpuri": bhojpuri,
        „-Боснијан“: Босанец,
        „-Булгарија“: Бугарски,
        „-каталан“: Каталонски, // в
        "--цебано": Кебуано,
        „-Кичева“: Чичева,
        "-chinesesimplified": кинески (поедноставен),
        "-kineErtaditional": кинески (традиционален),
        „--округот“: корзика,
        „-корко“: хрватски,
        „--цешка“: Чешка,
        „--Даниш“: Дански, // Д.
        "--dhivehi": dhivehi,
        „--догри“: Догри,
        „--предатка“: холандски,
        "-Англишки": англиски, // e
        „--есперанто“: Есперанто,
        „-Естон“: Естонски,
        "--EWE": еве,
       
        „-финиш“: фински,
       
       
       
       
       
        "-Грк": грчки,
        „-Гуарани“: Гуарани,
        "-Гујарати": Гуџарати,
        „--Хаитјанкреоле“: Хаити Креол, // ч
        „--Хауза“: Хауса,
        „-Хавајајан“: Хавајски,
        „--о-окре“: хебрејски,
        "--хинди": хинди,
        "--хмонг": Хмонг,
        „--унгарски“: унгарски,
        „-Аиландија“: Исландски, // јас
        "-,гбо": Игбо,
        „-Илокано“: Илокано,
        „-Индонезиски“: Индонезиски,
        „-Ириш“: Ирски,
        "--талијански": италијански,
        „-Јапонски“: Јапонски, // j
        „-Јавански“: Јаван,
        "-Канада": Канада, // k
        „-Казаххан“: Казахста,
        „-Кмер“: Кмер,
        "-Кинеарванда": Кинарванда,
       
        „-Кореан“: Корејски,
        „-Крио“: Крио,
        "-Курдишкурманџи": курдски (Курманџи),
        "-Курдшисорани": курдски (Сорани),
        "-Киргиз": Киргистан,
        "--лао": лао, // l
        "-латин": латински,
        "--латвија": Латвијан,
        "--легала": лингала,
        „--литвански“: литвански,
        „-Луганда“: Луганда,
        „-луксузбург“: Луксембург,
        "--Мекедонијан": Македонијан, // м
        "--маилили": maithili,
        „--малаги“: Малгези,
        „--Малеј“: Малезиски,
        „--Малајалам“: малајалам,
        „--малтешки“: малтешки,
        "--маори": Маори,
        "--марати": Марати,
       
        „--мизо“: Мизо,
        „-Монголски“: Монголски,
        "--Мјанмарбурмес": Мјанмар (бурмански),
        "-Непали": Непалски, // n
        „-НОРВЕГИЈАНСКИ“: Норвежанец,
        "-Одијаорија": Одија (Орија), // о
        „-Оромо“: Оромо,
       
        „-Персијан“: Персиски,
        „-Полиш“: полски,
        „-португалски“: португалски,
        „--пуџаби“: Пенџаби,
       
        „--романски“: Романски, // r
       
       
       
       
        „-сепди“: Сепеди,
        „-сербија“: српски,
       
       
       
       
       
        „--салониски“: словенец,
        „-Сомали“: Сомали,
       
       
       
       
       
       
       
       
       
       
        „-ТСонга“: Цонга,
       
       
        "-twi": twi,
       
       
       
       
       
       
       
        „-тидаш“: јидски, // y
        "--yoruba": јоруба,
        „-Зулу“: Зулу, // z
        },
      }, 

      // maithili
      // maithili
      maithili: {
        translations: {
          "--एकटा त्रुटि भेल अछि": एकटा त्रुटि भेल अछि!, //a
           "--पता": पता, 1999।
           "--सलाह": सलाह, 1999।
           "--continu पर क्लिक कए": continue पर क्लिक कए अहाँ अपन Veil Brillant खाता स डिस्कनेक्ट भ जाएब, //b
           "--डिस्कनेक्ट पर क्लिक करला सं अहां डिस्कनेक्ट भ जाएब": डिस्कनेक्ट पर क्लिक करला सं अहां अपन izocash खाता सं डिस्कनेक्ट भ जाएब,
           "--अपन आभासी संख्या जाँच करू अथवा बाद मे फेर सँ प्रयास करू": अपन आभासी संख्या जाँचू वा बाद मे फेर सँ प्रयास करू, //c
           "--अपन वर्चुअल नंबर चेक करू": अपन वर्चुअल नंबर चेक करू,
           "--जारी": जारी राखू,
           "--connection": कनेक्शन, 1999।
           "--सहयोग करब, सामंजस्य मे रहब": सहयोग करब, दोसरक संग सामंजस्य मे रहब,
           "--भाषा चुनें": वर्चुअल फोन भाषा,
           "--प्रतिस्पर्धा नहि रोकू": प्रतिस्पर्धा नहि रोकू, सभ केँ मौका दियौक, //d
           "--विच्छेद": विच्छेद, 1999।
           "--सब वर्चुअल फोन उपयोगकर्ताक कें लेल": सबटा वर्चुअल फोन उपयोगकर्ताक कें लेल, एकटा वीपीएन, //f कें उपयोग करनाय अनुशंसित छै
           "--लॉगिन पृष्ठ पर जाएँ": लॉगिन पृष्ठ पर जाएँ, //g
           "--ऐतिहासिक": ऐतिहासिक, //ज
           "--हमरा खाता अछि": हमरा लग पहिनेसँ खाता अछि, //i
           "--हमर खाता नहि अछि": हमरा लग खाता नहि अछि,
           "--ई अहाँक घर अछि": ई अहाँक घर अछि,
           "--छवि / वीडियो +": छवि / वीडियो +,
           "--पहचान सत्यापन": पहचान सत्यापन,
           "--izocash ग्राहक पोर्टल": izocash ग्राहक पोर्टल,
           "--हर साल पहचान अपडेट": हर साल पहचान अपडेट,
           "--izocash खरीदें": izocash खरीदें => izocash अंतर्राष्ट्रीय,
           "--लॉग इन": लॉग इन!, //l
           "--लॉगिन": लॉग इन,
           "--login to veil brilliant": घूंघट शानदार स कनेक्ट करू,
           "--vixinol store मे लॉगिन करू": Vixinol Store सँ कनेक्ट करू,
           "--अपन घूंघट ब्रिलंट खाता मे मुफ्त मे लॉग इन करू": एहि सुविधा कए एक्सेस करबाक लेल अपन घूंघट ब्रिलंट खाता मे मुफ्त मे लॉग इन करू,
           "--लॉगिन सफलता": लॉगिन सफल!,
           "--अखन लॉगिन करू": अखन लॉग इन करू!,
           "--लॉगआउट सफलता": लॉगआउट सफल!,
           "--लॉग आउट": लॉगआउट,
           "--लॉगआउट": लॉग आउट,
           "--संख्या": संख्या, //n
           "--नाम": नाम, 1।
           "--आब लॉग इन करू": आब, लॉग इन करू!,
           "--प्रतिस्पर्धा के दबाबै पर कोनो रोक नै":
           "--कोनो ईर्ष्या नहि, कोनो घृणा नहि": कोनो ईर्ष्या नहि, कोनो घृणा नहि, कोनो विभाजन नहि,
           "--नहि": नहि,
           "--अपन वर्चुअल फोन तक पहुँचने के लिए आधिकारिक पता": अपने वर्चुअल फोन तक पहुँचने के लिए आधिकारिक पता, //o
           "--पासवर्ड": पासवर्ड, //पृष्ठ
           "--बिंदु निकासी izocash": अंक निकासी izocash,
           "--बिंदु वापसी": अंक वापसी, 1999।
           "--अधिमानतः, एकटा vpn कें उपयोग करूं": अधिमानतः, एकटा वीपीएन कें उपयोग करूं जे अहां कें इंटरनेट सेवा प्रदाता सं संबंधित नहि छै,
           "--जिद सदिखन फलित होइत छैक": जिद सदिखन अंत मे फल दैत छैक,
           "--नियम": नियम, //आर
           "--सिफारिश": अनुशंसा, २.
           "--पंजीकरण": पंजीकरण, 1999।
           "--घूंघट शानदार के लेल साइनअप": घूंघट शानदार पर रजिस्टर करू, //s
           "--signup to vixinol store": विक्सिनोल स्टोर पर रजिस्टर करू,
           "--साइनअप": रजिस्टर, 1999।
           "--साइनअप सफलता": पंजीकरण सफल!,
           "--निःशुल्क साइनअप करू": मुफ्त मे रजिस्टर करू,
           “--साइनअप सफलता आईए”: कनेक्शन सफल”,
           "--सेटिंग्स": "सेटिंग्स",
           "--alrani ऐप सेटअप": Alrani एप्लिकेशन क कॉन्फ़िगर करब,
           "--izocash ऐप कें सेटअप करनाय": izocash एप्लिकेशन कें कॉन्फ़िगर करनाय,
           "--विक्सिनॉल ऐप सेट करब": विक्सिनॉल एप्लिकेशन केँ कॉन्फ़िगर करब,
           "--घूंघट ब्रिलंट ऐप कए सेट करब": घूंघट ब्रिलंट एप्लिकेशन कए कॉन्फ़िगर करब,
           "--छवि, वीडियो के भंडारण": छवि, वीडियो आ कई अन्य तत्व के भंडारण,
           "--स्वागत कें गति": डाटासेंटर सं डाटा कें रिसेप्शन कें गति,
           "--गति": गति, 1999।
           "--समाप्त": समाप्त, //टी
           "--vpn अहां कें एक्सेस करय कें अनुमति देयत छै": वीपीएन अहां कें कोनों साइट या कोनों एप्लीकेशन कें एक्सेस करय कें अनुमति देयत छै जे अहां कें इंटरनेट सेवा प्रदाता ब्लैकलिस्ट करय छै,
           "--सबसँ पैघ गाछ ऊपर छल": सबसँ पैघ गाछ सभसँ ऊपर एकटा साधारण छोट बीया छल,
           "--स्क्रीन स्पर्श करू": जारी रखबाक लेल स्क्रीन स्पर्श करू,
           "--पुनः प्रयास करू": फेर प्रयास करू!,
           "--उपयोगकर्ता नाम": उपयोगकर्ता नाम, //u

           "--आभासी संख्या": आभासी संख्या, //v
           "--वर्चुअल फोन सेटिंग्स": वर्चुअल फोन सेटिंग्स,
           "--वर्चुअल फोन भाषा लागू कएल गेल अछि": वर्चुअल फोन भाषा डिफ़ॉल्ट रूप सँ अनुप्रयोग स्तर पर लागू कएल गेल अछि,
           "--वर्चुअल फोन": वर्चुअल फोन,
           "--मान्य करू": मान्य करू,
           "--izocash ग्राहक पोर्टल पर स्वागत अछि": izocash ग्राहक पोर्टल पर स्वागत अछि, //w
           "--एकटा सुपर कोड लिखू": एकटा सुपर कोड दर्ज करू,
           "--स्वागत अछि": स्वागत अछि,
           "--जहाँ लोकक ध्यान जाइत अछि": जतय लोकक ध्यान जाइत अछि पाइ जाइत अछि,
           "--विजेता दृढ़तापूर्वक": विजेता दृढ़ता,
           "--की अहाँ अपन अलरानी खाता स लॉग आउट करय चाहैत छी": की अहाँ अपन अलरानी खाता स लॉग आउट करय चाहैत छी?,
           "--हाँ": हाँ, //y

           // देश
           "--कांगो": कांगो ब्राज़ाविले, 1999।
           "--कैमरून": कैमरून, 1999।
           "--drc": डीआरसी, 1999।
           "--ivoryCoast": आइवरी कोस्ट, 1999।

           // लैंग्वे
        "--afrikaans": अफ्रीकी, //क
        "--अल्बेनियाई": अल्बेनियाई, 1999।
        "--अम्हारिक": अमहारिक, 1999।
        "--अरबी": अरबी, 1999।
        "--आर्मेनियाई": आर्मेनियाई, 1999।
        "--assamese": असमिया, 1999।
        "--अयमारा": आयमारा, 1999।
        "--अजरबैजानी": अजरबैजानी, 1999।
        "--बम्बरा": बम्बरा, //b
        "--बास्क": बास्क, 1999।
        "--बेलारूसी": बेलारूसी, 1999।
        "--बंगाली": बंगला, 1999।
        "--bhojpuri": भोजपुरी, २.
        "--बोस्नियाई": बोस्नियाई, 1999।
        "--बल्गेरियाई": बल्गेरियाई,
        "--कैटेलोनियाई": कैटेलोनियाई, //सी
        "--सेबुआनो": सेबुआनो, 1999।
        "--चिचेवा": चिचेवा, 1999।
        "--chineseSimplified": चीनी (सरलीकृत),
        "--chineseTraditional": चीनी (पारंपरिक),
        "--कोर्सिकन": कोर्सिकन, 1999।
        "--क्रोएशियाई": क्रोएशियाई, 1999।
        "--चेक": चेक, 1999।
        "--danish": डेनिश, //घ
        "--धिवेहि": धिवेहि, २.
        "--dogri": डोगरी, 1999।
        "--डच": डच, 1999।
        "--अंग्रेजी": अंग्रेजी, //ई
        "--एस्पेरान्तो": एस्पेरान्तो, 1999।
        "--एस्टोनियाई": एस्टोनियाई, 1999।
        "--भेड़": भेड़, 1999।
        "--filipino": फिलिपिनो, //च
        "--फिनिश": फिनिश, 1999।
        "--फ्रेंच": फ्रेंच, 1999।
        "--फ्रीज़ियन": फ्रीसियन, 1999।
        "--गैलिशियन्": गैलिशियन्, //जी
        "--जॉर्जियन": जॉर्जियाई, 1999।
        "--जर्मन": जर्मन, 1999।
        "--ग्रीक": ग्रीक, 1999।
        "--गुआरानी": गुआरानी, 1999।
        "--gujarati": गुजराती, 1999।
        "--haitianCreole": हैतीयन क्रियोल, //ज
        "--हौसा": हौसा, 1999।
        "--हवाई": हवाईयन, 1999।
        "--हिब्रू": हिब्रू,
        "--हिन्दी": हिन्दी, २.
        "--हमोंग": हमोंग, 1999।
        "--हंगरी": हंगरी, 1999।
        "--आइसलैंडिक": आइसलैंडिक, //i
        "--इग्बो": इग्बो, 1999।
        "--ilocano": इलोकानो, 1999।
        "--इंडोनेशियाई": इंडोनेशियाई, 1999।
        "--irish": आयरिश, 1999।
        "--इटालियन": इतालवी, 1999।
        "--जापानी": जापानी, //जे
        "--जावानी": जावानी, 1999।
        "--कन्नड़": कन्नड़, //k
        "--कजाख": कजाख, 1999।
        "--खमेर": खमेर, २.
        "--किन्यरवाण्डा": किन्यरवाण्डा, 1999।
        "--konkani": कोंकणी, 1999।
        "--कोरियाई": कोरियाई, 1999।
        "--क्रिओ": क्रिओ, 1999।
        "--kurdishKurmanji": कुर्द (कुर्मनजी),
        "--kurdishSorani": कुर्द (सोरानी), 1999।
        "--kyrgyz": किर्गिज़, 1999।
        "--लाओ": लाओ, //एल
        "--लैटिन": लैटिन, 1999।
        "--लातवियाई": लातवियाई, 1999।
        "--लिंगला": लिंगला, 1999।
        "--लिथुआनियाई": लिथुआनियाई,
        "--लुगांडा": लुगांडा, 1999।
        "--luxembourgish": लक्समबर्ग, 1999।
        "--मैसिडोनियाई": मैसिडोनियाई, //एम
        "--मैथिली": मैथिली,
        "--मालागासी": मालागासी, 1999।
        "--मलय": मलय, 1999।
        "--मलयालम": मलयालम, 1999।
        "--माल्टीज": माल्टीज, 1999।
        "--माओरी": माओरी, 1999।
        "--मराठी": मराठी, 1999।
        "--meiteilonManipuri": Meiteilon (मणिपुरी), 1999।
        "--mizo": मिजो, 1999।
        "--मंगोलियन": मंगोलियन, 1999।
        "--myanmarबर्मी": म्यांमार (बर्मी),
        "--nepali": नेपाली, //n
        "--नॉर्वे": नार्वे, 1999।
        "--odiaOriya": ओडिया (उड़िया), //ओ
        "--ओरोमो": ओरोमो, 1999।
        "--पश्तो": पश्तो, //पृष्ठ
        "--फारसी": फारसी, 1999।
        "--पालिश": पॉलिश, 1999।
        "--पुर्तगाली": पुर्तगाली, 1999।
        "--पंजाबी": पंजाबी, 1999।
        "--क्वेचुआ": क्वेचुआ, //q
        "--रोमानियन": रोमानियाई, //आर
        "--रूसी": रूसी, 1999।
        "--समोआन": समोआन, //s
        "--संस्कृत": संस्कृत, २.
        "--scotsGaelic": स्कॉट्स गेलिक, 1999।
        "--सेपेडी": सेपेडी, 1999।
        "--सर्बियाई": सर्बियाई, 1999।
        "--सेसोथो": सेसोथो, 1999।
        "--शोना": शोना, २.
        "--सिंधी": सिंधी, 1999।
        "--सिन्हला": सिंहली, 1999।
        "--स्लोवाक": स्लोवाक, 1999।
        "--स्लोवेनियाई": स्लोवेनियाई,
        "--सोमाली": सोमाली, 1999।
        "--स्पेनिश": स्पेनिश, 1999।
        "--सुंडानीज़": सुंडानी, 1999।
        "--स्वाहिली": स्वाहिली, 1999।
        "--स्वीडिश": स्वीडिश, 1999।
        "--ताजिक": ताजिक, //टी
        "--तमिल": तमिल, 1999।
        "--तातार": तातार, 1999।
        "--तेलुगु": तेलुगु, 1999।
        "--थाई": थाई, 1999।
        "--tigrinya": तिग्रिनिया, 1999।
        "--tsonga": त्सोंगा, 1999।
        "--तुर्की": तुर्की, 1999।
        "--तुर्कमेन": तुर्कमेन, 1999।
        "--twi": ट्वी, 1999।
        "--यूक्रेनी": यूक्रेनी, //यू
        "--urdu": उर्दू, 1999।
        "--उयघुर": उयघुर, २.
        "--उजबेक": उजबेक, 1999।
        "--वियतनाम": वियतनामी, //v
        "--वेल्श": वेल्स, //डब्ल्यू
        "--xhosa": Xhosa, //x
        "--यिद्दिश": यिद्दीश, //y
        "--योरूबा": योरूबा, 1999।
        "--zulu": ज़ुलु, // जेड
        },
      }, 

      // malagasy
      // malagasy
      malagasy: {
        translations: {
          "--an error has occurred": Nisy hadisoana nitranga!, //a
           "--address": Adiresy,
           "--torohevitra": Toro-hevitra,
           "--amin'ny fipihana ny tohizo": Amin'ny fipihana ny tohizo dia ho tapaka amin'ny kaontinao Veil Brillant ianao, //b
           "--amin'ny fipihana ny disconnect dia ho tapaka ianao": Amin'ny fipihana ny Disconnect dia ho tapaka amin'ny kaontinao izocash ianao,
           "--jereo ny laharanao virtoaly na andramo indray any aoriana any": Hamarino ny laharanao virtoaly na andramo indray aoriana, //c
           "--check your virtual number": Jereo ny nomerao virtoaly,
           "--continue": Tohizo,
           "--connection": Fifandraisana,
           "--collaborate, live in harmony": Miara-miasa, miaina mifanaraka amin'ny hafa,
           "--choose language": Fiteny finday virtoaly,
           "--aza manakana ny fifaninanana": Aza misakana ny fifaninanana, omeo fahafahana ny rehetra, //d
           "--disconnection": Fanalana,
           "--ho an'ny mpampiasa finday virtoaly rehetra": Ho an'ny mpampiasa finday virtoaly rehetra dia asaina mampiasa VPN, //f
           "--go to login page": Mankanesa any amin'ny pejy fidirana, //g
           "--historical": Ara-tantara, //h
           "--manana kaonty": Efa manana kaonty aho, //i
           "--tsy manana kaonty aho": Tsy manana kaonty aho,
           "--tranonao io": tranonao io,
           "--sary / video +": Sary / Video +,
           "--identity verification": Fanamarinana famantarana,
           "--izocash mpanjifa vavahadin-tserasera": izocash mpanjifa Portal,
           "--identity update every year": Fanavaozana ny maha-izy azy isan-taona,
           "--izocash buy to": izocash Buy => izocash international,
           "--log in": Midira!, //l
           "--login": Midira,
           "--login to veil brilliant": mifandray amin'ny Veil Brillant,
           "--miditra amin'ny fivarotana vixinol": mifandray amin'ny fivarotana Vixinol,
           "--login for free to your veil Brillant account": Midira maimaimpoana amin'ny kaontinao Veil Brillant raha te hidirana amin'ity endri-javatra ity,
           "--login success": Tafita ny fidirana!,
           "--login now": Midira izao!,
           "--logout success": Tafita ny fivoahana!,
           "--log out": Hivoaka,
           "--logout": Hivoaka,
           "--number": Isa, //n
           "--name": Anarana,
           "--now log in": Ankehitriny, midira!,
           "--tsy misy fandrarana amin'ny fifaninanana manakana":
           "--tsy misy fialonana, tsy misy fankahalana": Tsy misy fialonana, tsy misy fankahalana, tsy misy fisarahana,
           "--tsia tsia,
           "--adiresy ofisialy hidirana amin'ny findainao virtoaly": Adiresy ofisialy hidirana amin'ny findainao virtoaly, //o
           "--password": Tenimiafina, //p
           "--points withdrawals izocash": Points withdrawals izocash,
           "--points withdrawals": Points withdrawals,
           "--preferably, mampiasa vpn": Aleo, mampiasa VPN izay tsy an'ny mpanome tolotra aterineto anao,
           "--mahazo tombony foana ny fikirizana": Mandaitra foana ny fikirizana amin'ny farany,
           "--rule": Fitsipika, //r
           "--recommendation": Soso-kevitra,
           "--registration": Fisoratana anarana,
           "--signup to veil brilliant": Misoratra anarana ao amin'ny Veil Brillant, //s
           "--misoratra anarana amin'ny fivarotana vixinol": Misoratra anarana amin'ny fivarotana Vixinol,
           "--signup": Misoratra anarana,
           "--signup success": Tafita ny fisoratana anarana!,
           "--signup for free": Misoratra anarana maimaim-poana,
           "--signup success IA": nahomby ny fifandraisana",
           "--settings": "Settings",
           "--setting up the alrani app": Fanamboarana ny fampiharana Alrani,
           "--setting up the izocash app": Fametrahana ny fampiharana izocash,
           "--setting up the vixinol app": Configuring the Vixinol application,
           "--setting up the veil Brillant app": Configuring the Veil Brillant application,
           "--storage of images, videos": fitahirizana sary, horonan-tsary ary singa maro hafa,
           "--speed of reception": Hafaingan'ny fandraisana data avy amin'ny Datacenter,
           "--speed": Haingana,
           "--terminate": Atsaharo, //t
           "--ny vpn dia mamela anao hidirana": Ny VPN dia mamela anao hiditra amin'ny tranokala na fampiharana izay nomen'ny mpanome tolotra aterineto anao anaty lisitra mainty,
           "--ny hazo lehibe indrindra dia teo ambony": Ny hazo lehibe indrindra dia voa kely tsotra indrindra,
           "--touch the screen": Tsindrio ny efijery raha hanohy,
           "--try again": Andramo indray!,
           "--username": Anarana mpampiasa, //u

           "--virtual number": Laharana virtoaly, //v
           "--virtual phone settings": Fikirana finday virtoaly,
           "--virtual Phone language is applied": Ny fiteny virtoaly Phone dia ampiharina amin'ny ambaratonga fampiharana amin'ny alàlan'ny default,
           "--telefaonina virtoaly": telefaonina virtoaly,
           "--validate": Manamarina,
           "--welcome to the izocash customer portal": Tongasoa eto amin'ny izocash Customer Portal, //w
           "--write a super code": Ampidiro ny Super code,
           "--welcome to": Tongasoa eto,
           "--ho aiza ny sain'ny olona": Ho aiza ny sain'ny olona dia mandeha ny vola,
           "--winners persevere": Maharitra ny mpandresy,
           "--te hivoaka amin'ny kaontinao Alrani ve ianao": Te-hivoaka amin'ny kaontinao Alrani ve ianao?,
           "--eny": Eny, //y

           // firenena
           "--kongo": Congo Brazzaville,
           "--cameroon": Kamerona,
           "--drc": RDC,
           "--ivoryCoast": Côte d'Ivoire,

           // fiteny
        "--afrikaans": Afrikaans, //a
        "--albanian": Albaney,
        "--amharic": Amharic,
        "--arabo": Arabo,
        "--armenianina": Armeniana,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusianina": Belarosiana,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosniaka,
        "--bulgarian": Bolgara,
        "--catalan": Katalana, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Sinoa (notsoina),
        "--chineseTraditional": Sinoa (Traditional),
        "--corsican": Korsika,
        "--croatian": Kroaty,
        "--czech": Czech,
        "--danish": Danoà, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": holandey,
        "--anglisy": anglisy, //e
        "--esperanto": Esperanto,
        "--estonian": estonianina,
        "--ewe": Ovy,
        "--filipino": Filipino, //f
        "--finnish": Finnish,
        "--frantsay": frantsay,
        "--frisian": Frisian,
        "--galician": Galisiana, //g
        "--georgian": Zeorziana,
        "--alemà": alemà,
        "--grika": grika,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiiana,
        "--hebrew": hebreo,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hongroà,
        "--icelandic": islandey, //i
        "--igbo": Igbo,
        "--ilocano": Ilokano,
        "--indonesian": indonezianina,
        "--irish": irlandey,
        "--italian": italianina,
        "--japoney": Japoney, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": koreana,
        "--krio": Krio,
        "--kurdishKurmanji": Kiorda (Kurmanji),
        "--kurdishSorani": Kiorda (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": latina,
        "--latvian": letonianina,
        "--lingala": Lingala,
        "--lituanian": Litoanianina,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Makedoniana, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Malagasy,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongoliana,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Norvezy,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Persiana,
        "--polish": poloney,
        "--portuguese": Portiogey,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romaniana, //r
        "--russian": Rosiana,
        "--samoan": Samoana, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serba,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovaky,
        "--slovenian": Slovenianina,
        "--somali": Somali,
        "--espaniola": espaniola,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--sodish": Soedoà,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": tiorka,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainien": Okrainiana, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Ozbek,
        "--vietnamese": vietnamiana, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      }, 

      // malay
      // malay
      malay: {
        translations: {
          "--an error has occurred": Ralat telah berlaku!, //a
          "--address": Alamat,
          "--nasihat": Nasihat,
          "--dengan mengklik pada teruskan": Dengan mengklik pada teruskan anda akan diputuskan sambungan daripada akaun Veil Brillant anda, //b
          "--dengan mengklik pada putus sambungan anda akan terputus sambungan": Dengan mengklik Putuskan sambungan anda akan terputus sambungan daripada akaun izocash anda,
          "--semak nombor maya anda atau cuba lagi kemudian": Semak nombor maya anda atau cuba lagi kemudian, //c
          "--semak nombor maya anda": Semak nombor maya anda,
          "--continue": Teruskan,
          "--connection": Sambungan,
          "--berkolaborasi, hidup dalam harmoni": Bekerjasama, hidup dalam harmoni dengan orang lain,
          "--choose language": Bahasa Telefon Maya,
          "--jangan halang persaingan": Jangan halang persaingan, beri peluang kepada semua orang, //d
          "--disconnection": Pemutusan sambungan,
          "--untuk semua pengguna telefon maya": Untuk semua pengguna Telefon Maya, adalah disyorkan untuk menggunakan VPN, //f
          "--pergi ke halaman log masuk": Pergi ke halaman log masuk, //g
          "--historical": Sejarah, //h
          "--saya ada akaun": Saya sudah mempunyai akaun, //i
          "--saya tidak mempunyai akaun": Saya tidak mempunyai akaun,
          "--ia rumah anda": ia adalah rumah anda,
          "--imej / video +": Imej / Video +,
          "--identity verification": Pengesahan identiti,
          "--portal pelanggan izocash": Portal Pelanggan izocash,
          "--kemas kini identiti setiap tahun": Kemas kini identiti setiap tahun,
          "--izocash buy to": izocash Beli => izocash antarabangsa,
          "--log masuk": Log masuk!, //l
          "--login": Log masuk,
          "--log masuk ke veil brilliant": Sambung ke Veil Brillant,
          "--log masuk ke kedai vixinol": Sambung ke Kedai Vixinol,
          "--log masuk secara percuma ke akaun Veil Brillant anda": Log masuk secara percuma ke akaun Veil Brillant anda untuk mengakses ciri ini,
          "--login success": Log masuk berjaya!,
          "--log masuk sekarang": Log masuk sekarang!,
          "--logout success": Log keluar berjaya!,
          "--log keluar": Log keluar,
          "--logout": Log keluar,
          "--nombor": Nombor, //n
          "--name": Nama,
          "--now log in": Sekarang, Log masuk!,
          "--tiada larangan untuk menyekat persaingan":
          "--tiada cemburu, tiada kebencian": Tiada cemburu, tiada benci, tiada perpecahan,
          "--tidak tidak,
          "--alamat rasmi untuk mengakses telefon maya anda": Alamat rasmi untuk mengakses telefon maya anda, //o
          "--password": Kata laluan, //m
          "--pengeluaran mata izocash": Pengeluaran Mata izocash,
          "--pengeluaran mata": Pengeluaran Mata,
          "--sebaik-baiknya, gunakan vpn": Sebaik-baiknya, gunakan VPN yang bukan milik pembekal perkhidmatan internet anda,
          "--kegigihan sentiasa membuahkan hasil": Kegigihan sentiasa membuahkan hasil pada akhirnya,
          "--rule": Peraturan, //r
          "--recommendation": Syor,
          "--registration": Pendaftaran,
          "--signup to veil brilliant": Daftar di Veil Brillant, //s
          "--daftar ke kedai vixinol": Daftar di Kedai Vixinol,
          "--signup": Daftar,
          "--signup success": Pendaftaran berjaya!,
          "--signup for free": Daftar percuma,
          “--signup success IA”: Sambungan berjaya”,
          "--settings": "Tetapan",
          "--setting up the alrani app": Mengkonfigurasi aplikasi Alrani,
          "--setting up the izocash app": Mengkonfigurasi aplikasi izocash,
          "--setting up the vixinol app": Mengkonfigurasi aplikasi Vixinol,
          "--seting up the veil Brillant app": Mengkonfigurasi aplikasi Veil Brillant,
          "--storage of images, videos": Penyimpanan imej, video dan beberapa elemen lain,
          "--speed of reception": Kelajuan penerimaan data daripada Pusat Data,
          "--speed": Kelajuan,
          "--terminate": Tamatkan, //t
          "--vpn membolehkan anda mengakses": VPN membenarkan anda mengakses tapak atau aplikasi yang telah disenaraihitamkan oleh pembekal perkhidmatan internet anda,
          "--pokok terbesar di atas": Pokok terbesar adalah di atas semua benih kecil yang mudah,
          "--touch the screen": Sentuh skrin untuk meneruskan,
          "--cuba lagi": Cuba lagi!,
          "--username": Nama pengguna, //u

          "--nombor maya": Nombor maya, //v
           "--virtual phone settings": Tetapan telefon maya,
           "--virtual Phone language is applied": Bahasa Telefon Maya digunakan pada peringkat aplikasi secara lalai,
           "--telefon maya": Telefon maya,
           "--validate": Sahkan,
           "--selamat datang ke portal pelanggan izocash": Selamat datang ke Portal Pelanggan izocash, //w
           "--write a super code": Masukkan kod Super,
           "--selamat datang ke": Selamat datang ke,
           "--ke mana perhatian orang pergi": Ke mana perhatian orang pergi wang pergi,
           "--winners persevere": Pemenang bertahan,
           "--adakah anda ingin log keluar daripada akaun Alrani anda": Adakah anda mahu log keluar daripada akaun Alrani anda?,
           "--ya": Ya, //y

           // negara
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivory Coast": Pantai Gading,

           // bahasa
        "--afrikaans": Afrikaans, //a
        "--albanian": Albania,
        "--amharic": Amharic,
        "--arab": Arab,
        "--armenian": Armenia,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijan,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusia,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Bosnia,
        "--bulgarian": Bahasa Bulgaria,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Cina (Simplified),
        "--chineseTraditional": Cina (Tradisional),
        "--corsican": Korsika,
        "--croatian": Bahasa Croatia,
        "--czech": Bahasa Czech,
        "--danish": Denmark, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Belanda,
        "--english": Bahasa Inggeris, //e
        "--esperanto": Esperanto,
        "--estonian": Estonia,
        "--ewe": Ewe,
        "--filipino": Filipina, //f
        "--finnish": Bahasa Finland,
        "--perancis": Perancis,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "--jerman": Jerman,
        "--greek": Greek,
        "--guarani": Guarani,
        "--gujarati": Gujerat,
        "--haitianCreole": Haiti Creole, //h
        "--hausa": Hausa,
        "--hawaii": Hawaii,
        "--hebrew": Ibrani,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungary,
        "--icelandic": Bahasa Iceland, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": Indonesia,
        "--irish": Ireland,
        "--italian": Itali,
        "--jepun": Jepun, //j
        "--javanese": bahasa Jawa,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Korea,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvia": Latvia,
        "--lingala": Lingala,
        "--lithuanian": Lithuania,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonia": Macedonia, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Melayu,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolia,
        "--myanmarBurmese": Myanmar (Burma),
        "--nepali": Nepal, //n
        "--norwegian": bahasa Norway,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //hlm
        "--persian": Parsi,
        "--polish": Poland,
        "--portuguese": Portugis,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romania, //r
        "--russian": Rusia,
        "--samoan": Samoa, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbia,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Bahasa Slovenia,
        "--somali": Somalia,
        "--sepanyol": Sepanyol,
        "--Sundanese": Sunda,
        "--swahili": Swahili,
        "--swedish": Sweden,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turki,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ukraine, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnam, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // malayalam
      // malayalam
      malayalam: {
        translations: {
          "--ഒരു പിശക് സംഭവിച്ചു": ഒരു പിശക് സംഭവിച്ചു!, //a
           "--വിലാസം": വിലാസങ്ങൾ,
           "--ഉപദേശം": ഉപദേശം,
           "--തുടരുക എന്നതിൽ ക്ലിക്കുചെയ്യുന്നതിലൂടെ": തുടരുക എന്നതിൽ ക്ലിക്കുചെയ്യുന്നതിലൂടെ നിങ്ങളുടെ വെയിൽ ബ്രില്ലന്റ് അക്കൗണ്ടിൽ നിന്ന് നിങ്ങൾ വിച്ഛേദിക്കപ്പെടും, //b
           "--വിച്ഛേദിക്കുക എന്നതിൽ ക്ലിക്കുചെയ്യുന്നതിലൂടെ നിങ്ങൾ വിച്ഛേദിക്കപ്പെടും": വിച്ഛേദിക്കുക എന്നതിൽ ക്ലിക്കുചെയ്യുന്നതിലൂടെ നിങ്ങൾ നിങ്ങളുടെ izocash അക്കൗണ്ടിൽ നിന്ന് വിച്ഛേദിക്കപ്പെടും,
           "--നിങ്ങളുടെ വെർച്വൽ നമ്പർ പരിശോധിക്കുക അല്ലെങ്കിൽ പിന്നീട് വീണ്ടും ശ്രമിക്കുക": നിങ്ങളുടെ വെർച്വൽ നമ്പർ പരിശോധിക്കുക അല്ലെങ്കിൽ പിന്നീട് വീണ്ടും ശ്രമിക്കുക, //c
           "--നിങ്ങളുടെ വെർച്വൽ നമ്പർ പരിശോധിക്കുക": നിങ്ങളുടെ വെർച്വൽ നമ്പർ പരിശോധിക്കുക,
           "--തുടരുക": തുടരുക,
           "--കണക്ഷൻ": കണക്ഷൻ,
           "-- സഹകരിക്കുക, യോജിപ്പിൽ ജീവിക്കുക": സഹകരിക്കുക, മറ്റുള്ളവരുമായി യോജിച്ച് ജീവിക്കുക,
           "--ഭാഷ തിരഞ്ഞെടുക്കുക": വെർച്വൽ ഫോൺ ഭാഷ,
           "--മത്സരം തടയരുത്": മത്സരം തടയരുത്, എല്ലാവർക്കും അവസരം നൽകുക, //d
           "--വിച്ഛേദിക്കൽ": വിച്ഛേദിക്കൽ,
           "--എല്ലാ വെർച്വൽ ഫോൺ ഉപയോക്താക്കൾക്കും": എല്ലാ വെർച്വൽ ഫോൺ ഉപയോക്താക്കൾക്കും, ഒരു VPN, //f ഉപയോഗിക്കാൻ ശുപാർശ ചെയ്യുന്നു
           "--ലോഗിൻ പേജിലേക്ക് പോകുക": ലോഗിൻ പേജിലേക്ക് പോകുക, //g
           "--ചരിത്രപരമായ": ചരിത്രപരമായ, //h
           "--എനിക്ക് അക്കൗണ്ട് ഉണ്ട്": എനിക്ക് ഇതിനകം ഒരു അക്കൗണ്ട് ഉണ്ട്, //i
           "--എനിക്ക് അക്കൗണ്ട് ഇല്ല": എനിക്ക് ഒരു അക്കൗണ്ട് ഇല്ല,
           "--ഇത് നിങ്ങളുടെ വീടാണ്": ഇത് നിങ്ങളുടെ വീടാണ്,
           "--ചിത്രം / വീഡിയോ +": ചിത്രം / വീഡിയോ +,
           "--ഐഡന്റിറ്റി വെരിഫിക്കേഷൻ": ഐഡന്റിറ്റി വെരിഫിക്കേഷൻ,
           "--izocash കസ്റ്റമർ പോർട്ടൽ": izocash കസ്റ്റമർ പോർട്ടൽ,
           "--ഐഡന്റിറ്റി അപ്ഡേറ്റ് എല്ലാ വർഷവും": ഐഡന്റിറ്റി അപ്ഡേറ്റ് എല്ലാ വർഷവും,
           "--izocash buy to": izocash Buy => izocash International,
           "--ലോഗിൻ": ലോഗിൻ ചെയ്യുക!, //l
           "--ലോഗിൻ": ലോഗിൻ ചെയ്യുക,
           "--വെയിൽ ബ്രില്ലിയന്റിലേക്ക് ലോഗിൻ ചെയ്യുക": വെയിൽ ബ്രില്ലന്റുമായി ബന്ധിപ്പിക്കുക,
           "--വിക്സിനോൾ സ്റ്റോറിലേക്ക് ലോഗിൻ ചെയ്യുക": വിക്സിനോൾ സ്റ്റോറിലേക്ക് ബന്ധിപ്പിക്കുക,
           "--നിങ്ങളുടെ വെയിൽ ബ്രില്ലന്റ് അക്കൗണ്ടിലേക്ക് സൗജന്യമായി ലോഗിൻ ചെയ്യുക": ഈ ഫീച്ചർ ആക്സസ് ചെയ്യുന്നതിന് നിങ്ങളുടെ വെയിൽ ബ്രില്ലന്റ് അക്കൗണ്ടിലേക്ക് സൗജന്യമായി ലോഗിൻ ചെയ്യുക,
           "--ലോഗിൻ വിജയം": ലോഗിൻ വിജയിച്ചു!,
           "--ഇപ്പോൾ ലോഗിൻ ചെയ്യുക": ഇപ്പോൾ ലോഗിൻ ചെയ്യുക!,
           "--ലോഗൗട്ട് വിജയം": ലോഗ്ഔട്ട് വിജയകരം!,
           "--ലോഗ് ഔട്ട്": ലോഗ്ഔട്ട്,
           "--ലോഗൗട്ട്": ലോഗ് ഔട്ട്,
           "--നമ്പർ": നമ്പർ, //n
           "--പേര്": പേര്,
           "--ഇപ്പോൾ ലോഗിൻ ചെയ്യുക": ഇപ്പോൾ, ലോഗിൻ ചെയ്യുക!,
           "--മത്സരത്തെ സ്തംഭിപ്പിക്കുന്നതിന് നിരോധനമില്ല":
           "--അസൂയയില്ല, വിദ്വേഷമില്ല": അസൂയയില്ല, വിദ്വേഷമില്ല, ഭിന്നിപ്പില്ല,
           "--ഇല്ല ഇല്ല,
           "--നിങ്ങളുടെ വെർച്വൽ ഫോൺ ആക്സസ് ചെയ്യുന്നതിനുള്ള ഔദ്യോഗിക വിലാസങ്ങൾ": നിങ്ങളുടെ വെർച്വൽ ഫോൺ ആക്സസ് ചെയ്യുന്നതിനുള്ള ഔദ്യോഗിക വിലാസങ്ങൾ, //o
           "--പാസ്‌വേഡ്": പാസ്‌വേഡ്, //p
           "--പോയിന്റ് പിൻവലിക്കലുകൾ izocash": പോയിന്റുകൾ പിൻവലിക്കലുകൾ izocash,
           "--പോയിന്റ് പിൻവലിക്കലുകൾ": പോയിന്റ് പിൻവലിക്കലുകൾ,
           "--വെയിലത്ത്, ഒരു vpn ഉപയോഗിക്കുക": വെയിലത്ത്, നിങ്ങളുടെ ഇന്റർനെറ്റ് സേവന ദാതാവിന്റെ ഭാഗമല്ലാത്ത ഒരു VPN ഉപയോഗിക്കുക,
           "--സ്ഥിരത എപ്പോഴും ഫലം നൽകുന്നു": സ്ഥിരോത്സാഹം എല്ലായ്‌പ്പോഴും ഫലം നൽകുന്നു,
           "--റൂൾ": നിയമങ്ങൾ, //r
           "--ശുപാർശ": ശുപാർശകൾ,
           "--രജിസ്ട്രേഷൻ": രജിസ്ട്രേഷൻ,
           "--സൈൻ അപ്പ് ടു വെയിൽ ബ്രില്യന്റ്": വെയിൽ ബ്രില്ലന്റിൽ രജിസ്റ്റർ ചെയ്യുക, //s
           "--വിക്സിനോൾ സ്റ്റോറിലേക്ക് സൈൻ അപ്പ് ചെയ്യുക": വിക്സിനോൾ സ്റ്റോറിൽ രജിസ്റ്റർ ചെയ്യുക,
           "--സൈൻഅപ്പ്": രജിസ്റ്റർ,
           "--സൈൻഅപ്പ് വിജയം": രജിസ്ട്രേഷൻ വിജയകരം!,
           "--സൗജന്യമായി സൈൻ അപ്പ് ചെയ്യുക": സൗജന്യമായി രജിസ്റ്റർ ചെയ്യുക,
           “--സൈൻഅപ്പ് വിജയം IA”: കണക്ഷൻ വിജയിച്ചു”,
           "--ക്രമീകരണങ്ങൾ": "ക്രമീകരണങ്ങൾ",
           "--അൽറാനി ആപ്പ് സജ്ജീകരിക്കുന്നു": അൽറാനി ആപ്ലിക്കേഷൻ കോൺഫിഗർ ചെയ്യുന്നു,
           "--izocash ആപ്പ് സജ്ജീകരിക്കുന്നു": izocash ആപ്ലിക്കേഷൻ കോൺഫിഗർ ചെയ്യുന്നു,
           "--വിക്സിനോൾ ആപ്പ് സജ്ജീകരിക്കുന്നു": വിക്സിനോൾ ആപ്ലിക്കേഷൻ കോൺഫിഗർ ചെയ്യുന്നു,
           "--വെയിൽ ബ്രില്ലന്റ് ആപ്പ് സജ്ജീകരിക്കുന്നു": വെയിൽ ബ്രില്ലന്റ് ആപ്ലിക്കേഷൻ കോൺഫിഗർ ചെയ്യുന്നു,
           "--ചിത്രങ്ങൾ, വീഡിയോകൾ എന്നിവയുടെ സംഭരണം": ചിത്രങ്ങളുടെയും വീഡിയോകളുടെയും മറ്റ് നിരവധി ഘടകങ്ങളുടെയും സംഭരണം,
           "--സ്പീഡ് ഓഫ് റിസപ്ഷൻ": ഡാറ്റാസെന്ററിൽ നിന്നുള്ള ഡാറ്റ സ്വീകരിക്കുന്നതിന്റെ വേഗത,
           "--വേഗത": വേഗത,
           "--terminate": അവസാനിപ്പിക്കുക, //t
           "--വിപിഎൻ നിങ്ങളെ ആക്സസ് ചെയ്യാൻ അനുവദിക്കുന്നു": നിങ്ങളുടെ ഇന്റർനെറ്റ് സേവന ദാതാവ് കരിമ്പട്ടികയിൽ പെടുത്തിയ ഒരു സൈറ്റോ ആപ്ലിക്കേഷനോ ആക്സസ് ചെയ്യാൻ VPN നിങ്ങളെ അനുവദിക്കുന്നു,
           "--ഏറ്റവും വലിയ മരം മുകളിലായിരുന്നു": ഏറ്റവും വലിയ വൃക്ഷം എല്ലാറ്റിനുമുപരിയായി ഒരു ചെറിയ വിത്തായിരുന്നു,
           "--സ്ക്രീൻ സ്പർശിക്കുക": തുടരാൻ സ്ക്രീനിൽ സ്പർശിക്കുക,
           "--വീണ്ടും ശ്രമിക്കുക": വീണ്ടും ശ്രമിക്കുക!,
           "--ഉപയോക്തൃനാമം": ഉപയോക്തൃനാമം, //u

           "--വെർച്വൽ നമ്പർ": വെർച്വൽ നമ്പർ, //v
           "--വെർച്വൽ ഫോൺ ക്രമീകരണങ്ങൾ": വെർച്വൽ ഫോൺ ക്രമീകരണങ്ങൾ,
           "--വെർച്വൽ ഫോൺ ഭാഷ പ്രയോഗിക്കുന്നു": വിർച്ച്വൽ ഫോൺ ഭാഷ ഡിഫോൾട്ടായി ആപ്ലിക്കേഷൻ തലത്തിൽ പ്രയോഗിക്കുന്നു,
           "--വെർച്വൽ ഫോൺ": വെർച്വൽ ഫോൺ,
           "--സാധൂകരിക്കുക": സാധൂകരിക്കുക,
           "--ഇസോകാഷ് കസ്റ്റമർ പോർട്ടലിലേക്ക് സ്വാഗതം": izocash കസ്റ്റമർ പോർട്ടലിലേക്ക് സ്വാഗതം, //w
           "--ഒരു സൂപ്പർ കോഡ് എഴുതുക": ഒരു സൂപ്പർ കോഡ് നൽകുക,
           "--സ്വാഗതം": സ്വാഗതം,
           "--ആളുകളുടെ ശ്രദ്ധ എവിടെ പോകുന്നു": ആളുകളുടെ ശ്രദ്ധ പോകുന്നിടത്തേക്ക് പണം പോകുന്നു,
           "--വിജയികൾ സ്ഥിരോത്സാഹം": വിജയികൾ സ്ഥിരോത്സാഹിക്കുന്നു,
           "--നിങ്ങളുടെ അൽറാനി അക്കൗണ്ടിൽ നിന്ന് ലോഗ് ഔട്ട് ചെയ്യാൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുണ്ടോ": നിങ്ങളുടെ അൽറാനി അക്കൗണ്ടിൽ നിന്ന് ലോഗ് ഔട്ട് ചെയ്യണോ?,
           "--അതെ": അതെ, //y

           // രാജ്യം
           "--കോംഗോ": കോംഗോ ബ്രസാവില്ലെ,
           "--കാമറൂൺ": കാമറൂൺ,
           "--drc": DRC,
           "--ഐവറികോസ്റ്റ്": ഐവറി കോസ്റ്റ്,

           // ഭാഷ
        "--ആഫ്രിക്കൻസ്": ആഫ്രിക്കൻസ്, //a
        "--അൽബേനിയൻ": അൽബേനിയൻ,
        "--അംഹാരിക്": അംഹാരിക്,
        "--അറബിക്": അറബിക്,
        "--അർമേനിയൻ": അർമേനിയൻ,
        "--ആസാമീസ്": ആസാമീസ്,
        "--aymara": അയ്മര,
        "--അസർബൈജാനി": അസർബൈജാനി,
        "--ബംബര": ബംബാര, //ബി
        "--ബാസ്ക്": ബാസ്ക്,
        "--ബെലാറഷ്യൻ": ബെലാറഷ്യൻ,
        "--ബംഗാളി": ബംഗാളി,
        "--ഭോജ്പുരി": ഭോജ്പുരി,
        "--ബോസ്നിയൻ": ബോസ്നിയൻ,
        "--ബൾഗേറിയൻ": ബൾഗേറിയൻ,
        "--കറ്റാലിയൻ": കറ്റാലൻ, //സി
        "--സെബുവാനോ": സെബുവാനോ,
        "--chichewa": ചിച്ചേവ,
        "--ചൈനീസ് ലളിതമാക്കിയത്": ചൈനീസ് (ലളിതമാക്കിയത്),
        "--ചൈനീസ് പരമ്പരാഗതം": ചൈനീസ് (പരമ്പരാഗതം),
        "--കോർസിക്കൻ": കോർസിക്കൻ,
        "--croatian": ക്രൊയേഷ്യൻ,
        "--ചെക്ക്": ചെക്ക്,
        "--danish": ഡാനിഷ്, //d
        "--ധിവേഹി": ദിവേഹി,
        "--ഡോഗ്രി": ഡോഗ്രി,
        "--ഡച്ച്": ഡച്ച്,
        "--ഇംഗ്ലീഷ്": ഇംഗ്ലീഷ്, //ഇ
        "--esperanto": Esperanto,
        "--എസ്റ്റോണിയൻ": എസ്റ്റോണിയൻ,
        "--ewe": ഈവ്,
        "--ഫിലിപ്പിനോ": ഫിലിപ്പിനോ, //f
        "--ഫിന്നിഷ്": ഫിന്നിഷ്,
        "--ഫ്രഞ്ച്": ഫ്രഞ്ച്,
        "--ഫ്രിഷ്യൻ": ഫ്രിസിയൻ,
        "--ഗലീഷ്യൻ": ഗലീഷ്യൻ, //g
        "--ജോർജിയൻ": ജോർജിയൻ,
        "--ജർമ്മൻ": ജർമ്മൻ,
        "--ഗ്രീക്ക്": ഗ്രീക്ക്,
        "--ഗുരാനി": ഗ്വാരാനി,
        "--ഗുജറാത്തി": ഗുജറാത്തി,
        "--haitianCreole": ഹെയ്തിയൻ ക്രിയോൾ, //h
        "--ഹൌസ": ഹൌസ,
        "--ഹവായിയൻ": ഹവായിയൻ,
        "--ഹീബ്രു": ഹീബ്രു,
        "--ഹിന്ദി": ഹിന്ദി,
        "--ഹ്മോങ്": മോങ്,
        "--ഹംഗേറിയൻ": ഹംഗേറിയൻ,
        "--ഐസ്‌ലാൻഡിക്": ഐസ്‌ലാൻഡിക്, //i
        "--igbo": ഇഗ്ബോ,
        "--ilocano": Ilocano,
        "--ഇന്തോനേഷ്യൻ": ഇന്തോനേഷ്യൻ,
        "--ഐറിഷ്": ഐറിഷ്,
        "--ഇറ്റാലിയൻ": ഇറ്റാലിയൻ,
        "--ജാപ്പനീസ്": ജാപ്പനീസ്, //j
        "--ജാവനീസ്": ജാവനീസ്,
        "--കന്നഡ": കന്നഡ, //കെ
        "--കസാഖ്": കസാഖ്,
        "--ഖ്മർ": ഖെമർ,
        "--kinyarwanda": Kinyarwanda,
        "--കൊങ്കണി": കൊങ്കണി,
        "--കൊറിയൻ": കൊറിയൻ,
        "--ക്രിയോ": ക്രിയോ,
        "--kurdishKurmanji": കുർദിഷ് (Kurmanji),
        "--kurdishSorani": കുർദിഷ് (സൊറാനി),
        "--കിർഗിസ്": കിർഗിസ്,
        "--lao": ലാവോ, //l
        "--ലാറ്റിൻ": ലാറ്റിൻ,
        "--ലാത്വിയൻ": ലാത്വിയൻ,
        "--ലിംഗാല": ലിംഗാല,
        "--ലിത്വാനിയൻ": ലിത്വാനിയൻ,
        "--ലുഗാണ്ട": ലുഗാണ്ട,
        "--luxembourgish": Luxembourgish,
        "--മാസിഡോണിയൻ": മാസിഡോണിയൻ, //m
        "--മൈഥിലി": മൈഥിലി,
        "--മലഗാസി": മലഗാസി,
        "--malay": മലായ്,
        "--മലയാളം": മലയാളം,
        "--മാൾട്ടീസ്": മാൾട്ടീസ്,
        "--maori": മാവോറി,
        "--മറാത്തി": മറാത്തി,
        "--meiteilonManipuri": Meiteilon (മണിപ്പൂരി),
        "--mizo": മിസോ,
        "--മംഗോളിയൻ": മംഗോളിയൻ,
        "--മ്യാൻമാർ ബർമ്മീസ്": മ്യാൻമർ (ബർമീസ്),
        "--നേപ്പാളി": നേപ്പാളി, //n
        "--നോർവീജിയൻ": നോർവീജിയൻ,
        "--odiaOriya": ഒഡിയ (ഒറിയ), //o
        "--ഒറോമോ": ഒറോമോ,
        "--പാഷ്തോ": പാഷ്തോ, //p
        "--പേർഷ്യൻ": പേർഷ്യൻ,
        "--പോളീഷ്": പോളിഷ്,
        "--പോർച്ചുഗീസ്": പോർച്ചുഗീസ്,
        "--പഞ്ചാബി": പഞ്ചാബി,
        "--quechua": ക്വെച്ചുവ, //q
        "--രൊമാനിയൻ": റൊമാനിയൻ, //r
        "--റഷ്യൻ": റഷ്യൻ,
        "--സമോവൻ": സമോവൻ, //s
        "--സംസ്കൃതം": സംസ്കൃതം,
        "--scotsGaelic": സ്കോട്ട്സ് ഗാലിക്,
        "--sepedi": Sepedi,
        "--സെർബിയൻ": സെർബിയൻ,
        "--സെസോതോ": സെസോത്തോ,
        "--ശോണ": ഷോണ,
        "--സിന്ധി": സിന്ധി,
        "--സിംഹള": സിംഹള,
        "--സ്ലോവാക്": സ്ലോവാക്,
        "--സ്ലോവേനിയൻ": സ്ലോവേനിയൻ,
        "--സൊമാലി": സോമാലി,
        "--സ്പാനിഷ്": സ്പാനിഷ്,
        "--സുന്ദനീസ്": സുന്ദനീസ്,
        "--സ്വഹിലി": സ്വാഹിലി,
        "--സ്വീഡിഷ്": സ്വീഡിഷ്,
        "--താജിക്": താജിക്ക്, //t
        "--തമിഴ്": തമിഴ്,
        "--ടാറ്റർ": ടാറ്റർ,
        "--തെലുങ്ക്": തെലുങ്ക്,
        "--തായ്": തായ്,
        "--tigrinya": Tigrinya,
        "--സോംഗ": സോംഗ,
        "--ടർക്കിഷ്": ടർക്കിഷ്,
        "--turkmen": തുർക്ക്മെൻ,
        "--twi": ട്വി,
        "--ukrainian": ഉക്രേനിയൻ, //u
        "--urdu": ഉർദു,
        "--ഉയ്ഗൂർ": ഉയ്ഗൂർ,
        "--ഉസ്ബെക്ക്": ഉസ്ബെക്ക്,
        "--വിയറ്റ്നാമീസ്": വിയറ്റ്നാമീസ്, //v
        "--welsh": വെൽഷ്, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": യൊറൂബ,
        "--zulu": സുലു, //z
        },
      },

      // maltese
      // maltese
      maltese: {
        translations: {
          "--an error has occurred": Sar żball!, //a
           "--indirizz": Indirizzi,
           "--advice": Parir,
           "--billi tikklikkja fuq tkompli": Billi tikklikkja fuq tkompli tkun skonnettjat mill-kont tiegħek Veil Brillant, //b
           "--billi tikklikkja fuq skonnettja int tkun skonnettjat": Billi tikklikkja fuq Skonnettja tkun skonnettjat mill-kont izocash tiegħek,
           "--iċċekkja n-numru virtwali tiegħek jew erġa' pprova aktar tard": Iċċekkja n-numru virtwali tiegħek jew erġa' pprova aktar tard, //c
           "--check your virtual number": Iċċekkja n-numru virtwali tiegħek,
           "--continue": Kompli,
           "--connection": Konnessjoni,
           "--collaborate, live in harmony": Ikkollabora, tgħix f'armonija ma 'oħrajn,
           "--choose language": Lingwa tat-Telefon Virtwali,
           "--ma tipprevjenix il-kompetizzjoni": Twaqqafx il-kompetizzjoni, agħti ċans lil kulħadd, //d
           "--disconnection": Skonnettjar,
           "--for all virtual phone users": Għall-utenti kollha tat-telefon virtwali, huwa rakkomandat li tuża VPN, //f
           "--go to login page": Mur fil-paġna tal-login, //g
           "--historical": Storiku, //h
           "--I have account": Diġà għandi kont, //i
           "--m'għandix kont": M'għandix kont,
           "--hija d-dar tiegħek": hija d-dar tiegħek,
           "--image / video +": Immaġni / Video +,
           "--identity verification": Verifika tal-identità,
           "--izocash customer portal": izocash Customer Portal,
           "--identity update every year": Aġġornament tal-identità kull sena,
           "--izocash jixtru lil": izocash Buy => izocash internazzjonali,
           "--log in": Idħol!, //l
           "--login": Idħol,
           "--login to veil brilliant": Qabbad ma' Veil Brillant,
           "--login to vixinol store": Qabbad mal-Vixinol Store,
           "--login for free to your veil Brillant account": Idħol b'xejn fil-kont tiegħek Veil Brillant biex taċċessa din il-karatteristika,
           "--login success": Login b'suċċess!,
           "--login now": Idħol issa!,
           "--logout success": Il-logout b'suċċess!,
           "--log out": Idgħalaq,
           "--logout": Log out,
           "--numru": Numru, //n
           "--name": Isem,
           "--now log in": Issa, Idħol!,
           "--l-ebda projbizzjoni li toħnoq il-kompetizzjoni":
           "--no jealousy, no hated": L-ebda jealousy, l-ebda mibegħda, l-ebda firdiet,
           "--le": Le,
           "--official addresses to access your virtual phone": Indirizzi uffiċjali biex taċċessa t-telefon virtwali tiegħek, //o
           "--password": Password, //p
           "--punti irtirar izocash": Irtirar ta 'punti izocash,
           "--irtirar ta' punti": Irtirar ta' punti,
           "--preferably, use a vpn": Preferibbilment, uża VPN li ma jappartjenix lill-fornitur tas-servizz tal-internet tiegħek,
           "--persistence always pay off": Il-persistenza dejjem tħallas fl-aħħar,
           "--rule": Regoli, //r
           "--recommendation": Rakkomandazzjonijiet,
           "--registration": Reġistrazzjoni,
           "--signup to veil brilliant": Irreġistra fuq Veil Brillant, //s
           "--firma għall-maħżen ta' vixinol": Irreġistra fuq Vixinol Store,
           "--signup": Irreġistra,
           "--signup success": Ir-reġistrazzjoni b'suċċess!,
           "--signup for free": Irreġistra b'xejn,
           “--signup success IA”: Konnessjoni b’suċċess”,
           "--settings": "Settings",
           "--setting up the alrani app": Konfigurazzjoni tal-applikazzjoni Alrani,
           "--setting up the izocash app": Konfigurazzjoni tal-applikazzjoni izocash,
           "--setting up the vixinol app": Konfigurazzjoni tal-applikazzjoni Vixinol,
           "--setting up the veil Brillant app": Konfigurazzjoni tal-applikazzjoni Veil Brillant,
           "--ħażna ta' immaġini, vidjows": Ħażna ta' stampi, vidjows u diversi elementi oħra,
           "--veloċità tar-riċeviment": Veloċità tar-riċeviment tad-dejta mid-Datacenter,
           "--speed": Veloċità,
           "--terminate": Ittermina, //t
           "--l-vpn jippermettilek li taċċessa": Il-VPN jippermettilek taċċessa sit jew applikazzjoni li l-fornitur tas-servizz tal-internet tiegħek imniżżla fil-lista sewda,
           "--l-akbar siġra kienet fuq": L-akbar siġra kienet fuq kollox żerriegħa żgħira sempliċi,
           "--touch the screen": Mess l-iskrin biex tkompli,
           "--pprova mill-ġdid": Erġa' pprova!,
           "--username": Username, //u

           "--virtual number": Numru virtwali, //v
           "--settings tat-telefon virtwali": Settings tat-telefon virtwali,
           "--virtual Phone language is applikata": Il-lingwa Virtual Phone hija applikata fil-livell tal-applikazzjoni b'mod awtomatiku,
           "--virtual phone": Telefon virtwali,
           "--validate": Ivvalida,
           "--welcome to the izocash customer portal": Merħba fil-izocash Customer Portal, //w
           "--write a super code": Daħħal Super code,
           "--welcome to": Merħba għal,
           "--where people's attention goes": Fejn tmur l-attenzjoni tan-nies imorru l-flus,
           "--winners persevere": Ir-rebbieħa jipperseveraw,
           "--tixtieq toħroġ mill-kont Alrani tiegħek": Trid toħroġ mill-kont Alrani tiegħek?,
           "--iva": Iva, //y

           // pajjiż
           "--congo": Kongo Brazzaville,
           "--cameroon": il-Kamerun,
           "--drc": RDK,
           "--ivoryCoast": il-Kosta tal-Avorju,

           // langue
        "--afrikaans": Afrikans, //a
        "--albaniż": Albaniż,
        "--amhariku": Amhariku,
        "--Għarbi": Għarbi,
        "--armenian": Armenjan,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Ażerbajġani,
        "--bambara": Bambara, //b
        "--bask": Bask,
        "--bjelorussu": Belarussu,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnjan": Bosnijan,
        "--Bulgaru": Bulgaru,
        "--catalan": Katalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Ċiniż (Simplifikat),
        "--chineseTraditional": Ċiniż (Tradizzjonali),
        "--korsiku": Korsiku,
        "--kroazjan": Kroat,
        "--czech": Ċek,
        "--danish": Daniż, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--olandiż": Olandiż,
        "--english": Ingliż, //e
        "--esperanto": Esperanto,
        "--estonjan": Estonjan,
        "--ewe": Nagħaġ,
        "--filipino": Filippin, //f
        "--Finlandiż": Finlandiż,
        "--Franċiż": Franċiż,
        "--frisian": Friżjan,
        "--galician": Galleg, //g
        "--ġorġjan": Ġorġjan,
        "--Ġermaniż": Ġermaniż,
        "--grieg": Grieg,
        "--guarani": Gwarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--ħawajjan": Ħawajjan,
        "--Ebrajk": Ebrajk,
        "--hindi": Ħindi,
        "--hmong": Hmong,
        "--hungarian": Ungeriż,
        "--icelandic": Iżlandiż, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indoneżjan": Indoneżjan,
        "--Irlandiż": Irlandiż,
        "--Taljan": Taljan,
        "--Ġappuniż": Ġappuniż, //j
        "--javanese": Ġavaniż,
        "--kannada": Kannada, //k
        "--kazakh": Każak,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--Korean": Korean,
        "--krio": Krio,
        "--kurdishKurmanji": Kurd (Kurmanji),
        "--kurdishSorani": Kurd (Sorani),
        "--kyrgyz": Kirgiż,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": Latvjan,
        "--lingala": Lingala,
        "--litwanjan": Litwan,
        "--luganda": Luganda,
        "--luxembourgish": Lussemburgiż,
        "--maċedonjan": Maċedonjan, //m
        "--maithili": Maithili,
        "--malagasy": Madagaskar,
        "--malaj": Malaj,
        "--malayalam": Malajalam,
        "--maltese": Malti,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongoljan": Mongoljan,
        "--myanmarBurmese": il-Mjanmar (il-Burmiż),
        "--nepali": Nepaliż, //n
        "--norveġiż": Norveġiż,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persjan": Persjan,
        "--polish": Pollakk,
        "--Portugiż": Portugiż,
        "--punjabi": Punġabi,
        "--quechua": Quechua, //q
        "--rumen": Rumen, //r
        "--Russu": Russu,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Galliku Skoċċiż,
        "--sepedi": Sepedi,
        "--serbian": Serb,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovakk,
        "--slovenian": Sloven,
        "--somali": Somali,
        "--spanjol": Spanjol,
        "--sundaniż": Sundaniż,
        "--swahili": Swaħili,
        "--Svediż": Svediż,
        "--tajik": Taġik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Tajlandiż,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turk": Tork,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ukrain, //u
        "--urdu": Urdu,
        "--uyghur": Ujgur,
        "--uzbek": Użbek,
        "--vietnamese": Vjetnamiż, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Jiddix, //y
        "--yoruba": Joruba,
        "--zulu": Żulu, //z
        },
      },

      // maori
      // maori
      maori: {
        translations: {
          "--an error has occurred": Kua puta he hapa!, //a
           "--address": Wāhitau,
           "--advice": Tohutohu,
           "--by clicking on continue": Ma te paato i te haere tonu ka momotuhia koe i to putea Veil Brillant, //b
           "--by clicking on disconnect you will be disconnected": Ma te panui i te Momotu ka momotuhia koe i to putea izocash,
           "--tirohia to nama mariko ka ngana ano i muri mai": Tirohia to nama mariko ka ngana ano ranei i muri mai, //c
           "--tirohia to tau mariko": Tirohia to tau mariko,
           "--continue": Haere tonu,
           "--connection": Hononga,
           "--collaborate, live in harmony": Mahi tahi, noho pai ki etahi atu,
           "--choose language": Reo Waea Mariko,
           "--don't prevent competition": Kaua e aukati i te whakataetae, hoatu he waahi ki nga tangata katoa, //d
           "--disconnection": Momotu,
           "--mo nga kaiwhakamahi waea mariko katoa": Mo nga kaiwhakamahi Waea Mariko katoa, ka tūtohu kia whakamahi VPN, //f
           "--go to login page": Haere ki te whārangi takiuru, //g
           "--historical": Tuhinga o mua, //h
           "--i have account": Kua whai kaute au, //i
           "--kare au he kaute": Karekau he kaute,
           "--ko to whare": ko to whare,
           "--ahua / ataata +": Ataata / Ataata +,
           "--identity verification": Manatokotanga tuakiri,
           "--izocash kiritaki portal": izocash Kiritaki Portal,
           "--identity update every year": Whakahoutanga tuakiri ia tau,
           "--izocash buy to": izocash Buy => izocash ao,
           "--log in": Takiuru!, //l
           "--login": Takiuru,
           "--login to veil brilliant": Hono ki a Veil Brillant,
           "--login to vixinol store": Hono ki Vixinol Store,
           "--login for free to your veil Brillant account": Takiuru mo te kore utu ki to Veil Brillant account kia uru atu ki tenei ahuatanga,
           "--login success": Kua angitu te takiuru!,
           "--login now": Takiuru ināianei!,
           "--logout success": Kua angitu te takiputa!,
           "--log out": Takiputa,
           "--logout": Takiputa,
           "--number": Tau, //n
           "--name": Ingoa,
           "--now log in": Inaianei, Takiuru!,
           "--kaore he aukati i te whakataetae tarai":
           "--no jealousy, no hatred": Kaore he hae, kahore he mauahara, kahore he wehewehenga,
           "--no": Kao,
           "--official addresses to access your virtual phone": Official addresses to access your virtual phone, //o
           "--password": Kupuhipa, //p
           "--points withdrawals izocash": Nga Pira Tango izocash,
           "--points withdrawals": Nga Whakaaetanga Pira,
           "--preferably, use a vpn": He pai ake, whakamahia he VPN ehara i to kaiwhakarato ratonga ipurangi,
           "--persistence always pays off": Ka whai hua tonu te manawanui i te mutunga,
           "--rule": Ture, //r
           "--recommendation": Nga Tohutohu,
           "--registration": Rehitatanga,
           "--signup to veil brilliant": Rēhita ki Veil Brillant, //s
           "--signup to vixinol store": Rēhita ki Vixinol Store,
           "--signup": Rēhita,
           "--signup success": Kua angitu te rehitatanga!,
           "--signup for free": Rēhita mō te kore utu,
           “--signup success IA”: Kua angitu te hononga”,
           "--settings": "Tautuhinga",
           "--setting up the alrani app": Whirihorahia te tono Alrani,
           "--setting up the izocash app": Te whirihora i te tono izocash,
           "--setting up the vixinol app": Whirihorahia te tono Vixinol,
           "--setting up the veil Brillant app": Whirihorahia te tono Veil Brillant,
           "--storage of images, videos": Rokiroki whakaahua, ataata me etahi atu huānga,
           "--tere o te whiwhinga": Te tere o te tango raraunga mai i te Raraunga Raraunga,
           "--tere": Tere,
           "--terminate": Whakamutua, //t
           "--ma te vpn ka taea e koe te uru atu": Ma te VPN ka taea e koe te uru atu ki tetahi waahi, ki tetahi tono ranei kua tohua e to kaiwhakarato ratonga ipurangi ki te raarangi pango,
           "--the large tree was above": Ko te rakau nui rawa atu he kakano iti noa,
           "--touch the screen": Pa ki te mata kia haere tonu,
           "--try again": Ngana ano!,
           "--username": Ingoa Kaiwhakamahi, //u

           "--virtual number": Tau mariko, //v
           "--virtual phone settings": Tautuhinga waea mariko,
           "--virtual Phone language is applied": Ka whakamahia te reo Waea Mariko ki te taumata tono ma te taunoa,
           "--virtual phone": Waea mariko,
           "--validate": Whakamana,
           "--nau mai ki te tomokanga kaihoko izocash": Nau mai ki te Paepae Kaihoko izocash, //w
           "--write a super code": Whakauruhia he waehere Super,
           "--welcome to": Nau mai,
           "--where people's attention goes": Kei hea te aro o te tangata ka haere te moni,
           "--winners persevere": Ka tohe nga toa,
           "--would you like to log out of your Alrani account": Kei te pirangi koe ki te takiputa i to putea Alrani?,
           "--ae": Ae, //y

           //whenua
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // reo
        "--afrikaans": Afrikaans, //a
        "--albanian": Albanian,
        "--amharic": Amharic,
        "--arabic": Arapi,
        "--armenian": Arameni,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusian,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnian,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Hainamana (Kuawari),
        "--chineseTraditional": Hainamana (Tawhito),
        "--corsican": Korsika,
        "--croatian": Croatian,
        "--czech": Czech,
        "--danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Tatimana,
        "--english": Ingarihi, //e
        "--esperanto": Esperanto,
        "--estonian": Estonian,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": Finnish,
        "--french": Wīwī,
        "--frisian": Frisian,
        "--galician": Kariri, //g
        "--georgian": Georgian,
        "--german": Tiamana,
        "--greek": Kariki,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haiti Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": Hiperu,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--icelandic": Tiorangi, //i
        "--igbo": Igbo,
        "--ilocano": Ilokano,
        "--indonesian": Indonesian,
        "--irish": Irish,
        "--italian": Italian,
        "--japanese": Japanese, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Korean,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": Latvian,
        "--lingala": Lingala,
        "--lithuanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Makeronia, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Pahia,
        "--polish": Polish,
        "--portuguese": Potiti,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--russian": Ruhia,
        "--samoan": Hamoa, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Spanish,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Huitene,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turkish,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--Ukrainian": Iukereiniana, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // marathi
      // marathi
      marathi: {
        translations: {
          "-एक त्रुटी आली आहे": एक त्रुटी आली आहे!, //a
           "--address": पत्ते,
           "--advice": सल्ला,
           "--सुरू ठेवा वर क्लिक करून": सुरू ठेवा वर क्लिक केल्याने तुम्ही तुमच्या Veil Brillant खात्यातून डिस्कनेक्ट व्हाल, //b
           "--डिस्कनेक्ट वर क्लिक करून तुम्ही डिस्कनेक्ट व्हाल": डिस्कनेक्ट वर क्लिक केल्याने तुम्ही तुमच्या izocash खात्यातून डिस्कनेक्ट व्हाल,
           "--तुमचा आभासी क्रमांक तपासा किंवा नंतर पुन्हा प्रयत्न करा": तुमचा आभासी क्रमांक तपासा किंवा नंतर पुन्हा प्रयत्न करा, //c
           "--तुमचा आभासी क्रमांक तपासा": तुमचा आभासी क्रमांक तपासा,
           "--continue": सुरू ठेवा,
           "--कनेक्शन": कनेक्शन,
           "-सहयोग करा, सामंजस्याने जगा": सहयोग करा, इतरांशी सुसंवादाने जगा,
           "--भाषा निवडा": आभासी फोन भाषा,
           "-स्पर्धा रोखू नका": स्पर्धा रोखू नका, प्रत्येकाला संधी द्या, //d
           "--disconnection": डिस्कनेक्शन,
           "--सर्व आभासी फोन वापरकर्त्यांसाठी": सर्व व्हर्च्युअल फोन वापरकर्त्यांसाठी, VPN वापरण्याची शिफारस केली जाते, //f
           "--लॉगिन पृष्ठावर जा": लॉगिन पृष्ठावर जा, //g
           "--historical": ऐतिहासिक, //h
           "--माझ्याकडे खाते आहे": माझ्याकडे आधीपासूनच खाते आहे, //i
           "--माझ्याकडे खाते नाही": माझ्याकडे खाते नाही,
           "- ते तुमचे घर आहे": ते तुमचे घर आहे,
           "--image / video +": प्रतिमा / व्हिडिओ +,
           "--ओळख पडताळणी": ओळख पडताळणी,
           "--izocash ग्राहक पोर्टल": izocash ग्राहक पोर्टल,
           "--दरवर्षी ओळख अपडेट": दरवर्षी ओळख अपडेट,
           "--izocash buy to": izocash Buy => izocash आंतरराष्ट्रीय,
           "-लॉग इन": लॉग इन!, //l
           "--login": लॉग इन करा,
           "-- veil brillant वर लॉगिन करा": Veil Brillant शी कनेक्ट करा,
           "--विक्सिनॉल स्टोअरमध्ये लॉग इन करा": विक्सिनॉल स्टोअरशी कनेक्ट करा,
           "--तुमच्या veil Brillant खात्यावर मोफत लॉगिन करा": या वैशिष्ट्यात प्रवेश करण्यासाठी तुमच्या Veil Brillant खात्यात मोफत लॉग इन करा,
           "--लॉगिन यशस्वी": लॉगिन यशस्वी!,
           "--login now": आता लॉग इन करा!,
           "-लॉगआउट यशस्वी": लॉगआउट यशस्वी!,
           "--लॉग आउट": लॉगआउट,
           "--logout": लॉग आउट,
           "--number": क्रमांक, //n
           "--name": नाव,
           "--आता लॉग इन करा": आता, लॉग इन करा!,
           "--स्पर्धेवर बंदी नाही":
           "- मत्सर नाही, द्वेष नाही": मत्सर नाही, द्वेष नाही, विभाजन नाही,
           "--नाही, नाही,
           "--अधिकृत पत्ते तुमच्या आभासी फोनवर प्रवेश करण्यासाठी": तुमच्या आभासी फोनमध्ये प्रवेश करण्यासाठी अधिकृत पत्ते, //o
           "--password": पासवर्ड, //p
           "--पॉइंट्स काढणे izocash": पॉइंट्स काढणे izocash,
           "--पॉइंट्स काढणे": पॉइंट्स काढणे,
           "--प्राधान्याने, vpn वापरा": प्राधान्याने, तुमच्या इंटरनेट सेवा प्रदात्याशी संबंधित नसलेले VPN वापरा,
           "--- चिकाटी नेहमीच पैसे देते": चिकाटी नेहमीच शेवटी चुकते,
           "--नियम": नियम, //r
           "--recommendation": शिफारसी,
           "--registration": नोंदणी,
           "--signup to veil brillant": Veil Brillant वर नोंदणी करा, //s
           "-- vixinol store वर साइन अप करा": Vixinol Store वर नोंदणी करा,
           "--signup": नोंदणी करा,
           "--साइनअप यशस्वी": नोंदणी यशस्वी!,
           "--साइनअप विनामूल्य": विनामूल्य नोंदणी करा,
           "--साइनअप यशस्वी IA": कनेक्शन यशस्वी",
           "--settings": "सेटिंग्ज",
           "--अलराणी अॅप सेट करणे": अलराणी ऍप्लिकेशन कॉन्फिगर करणे,
           "--izocash अॅप सेट करणे": izocash ऍप्लिकेशन कॉन्फिगर करणे,
           "--विक्सिनॉल अॅप सेट करणे": व्हिक्सिनॉल ऍप्लिकेशन कॉन्फिगर करणे,
           "--वेल ब्रिलंट अॅप सेट करणे": व्हील ब्रिलंट ऍप्लिकेशन कॉन्फिगर करणे,
           "--प्रतिमा, व्हिडिओंचे संचयन": प्रतिमा, व्हिडिओ आणि इतर अनेक घटकांचे संचयन,
           "--रिसेप्शनचा वेग": डेटासेंटरकडून डेटा रिसेप्शनचा वेग,
           "--स्पीड": वेग,
           "--terminate": समाप्त करा, //t
           "--vpn तुम्हाला प्रवेश करण्याची परवानगी देते": VPN तुम्हाला तुमच्या इंटरनेट सेवा प्रदात्याने काळ्या यादीत टाकलेल्या साइट किंवा अनुप्रयोगात प्रवेश करण्याची परवानगी देते,
           "--सर्वात मोठे झाड वर होते": सर्वात मोठे झाड सर्वांपेक्षा एक साधे छोटे बीज होते,
           "-स्क्रीनला स्पर्श करा": सुरू ठेवण्यासाठी स्क्रीनला स्पर्श करा,
           "--try again": पुन्हा प्रयत्न करा!,
           "--username": वापरकर्तानाव, //u

           "--आभासी क्रमांक": आभासी क्रमांक, //v
           "--virtual phone settings": आभासी फोन सेटिंग्ज,
           "--आभासी फोन भाषा लागू केली आहे": व्हर्च्युअल फोन भाषा डीफॉल्टनुसार अनुप्रयोग स्तरावर लागू केली जाते,
           "--virtual phone": आभासी फोन,
           "--validate": सत्यापित करा,
           "-- izocash ग्राहक पोर्टलवर आपले स्वागत आहे": izocash ग्राहक पोर्टलवर आपले स्वागत आहे, //w
           "--एक सुपर कोड लिहा": एक सुपर कोड प्रविष्ट करा,
           "-welcome to": आपले स्वागत आहे,
           "---जेकडे लोकांचे लक्ष जाते": जिथे लोकांचे लक्ष जाते तिथे पैसा जातो,
           "--विजेते चिकाटी": विजेते चिकाटी,
           "--तुम्हाला तुमच्या Alrani खात्यातून लॉग आउट व्हायला आवडेल": तुम्हाला तुमच्या Alrani खात्यातून लॉग आउट करायचे आहे का?,
           "--होय": होय, //y

           // देश
           "--कॉंगो": काँगो ब्राझाव्हिल,
           "--cameroon": कॅमेरून,
           "--drc": DRC,
           "--ivoryCoast": आयव्हरी कोस्ट,

           // भाषा
        "--afrikaans": आफ्रिकन, //a
        "--अल्बेनियन": अल्बेनियन,
        "--अम्हारिक": अम्हारिक,
        "--अरबी": अरबी,
        "--आर्मेनियन": आर्मेनियन,
        "--assamese": आसामी,
        "--आयमारा": आयमारा,
        "--अज़रबैजानी": अझरबैजानी,
        "--बांबरा": बांबरा, //b
        "--basque": बास्क,
        "--बेलारशियन": बेलारूसी,
        "--बंगाली": बंगाली,
        "--भोजपुरी": भोजपुरी,
        "--बोस्नियन": बोस्नियन,
        "--बल्गेरियन": बल्गेरियन,
        "--catalan": Catalan, //c
        "--सेबुआनो": सेबुआनो,
        "-चिचेवा": चिचेवा,
        "--chineseSimplified": चीनी (सरलीकृत),
        "--chineseTraditional": चीनी (पारंपारिक),
        "--corsican": कॉर्सिकन,
        "--क्रोएशियन": क्रोएशियन,
        "--चेक": झेक,
        "--danish": डॅनिश, //d
        "-धिवेही": धिवेही,
        "--dogri": डोगरी,
        "--dutch": डच,
        "--इंग्रजी": इंग्रजी, //ई
        "--एस्पेरांतो": एस्पेरांतो,
        "--एस्टोनियन": एस्टोनियन,
        "--ewe": इवे,
        "--फिलिपिनो": फिलिपिनो, //f
        "--finnish": फिनिश,
        "--फ्रेंच": फ्रेंच,
        "--frisian": फ्रिशियन,
        "--गॅलिशियन": गॅलिशियन, //g
        "--georgian": जॉर्जियन,
        "--जर्मन": जर्मन,
        "--ग्रीक": ग्रीक,
        "--गवारणी": ग्वारानी,
        "--गुजराती": गुजराती,
        "--haitianCreole": हैतीयन क्रेओल, //h
        "--हौसा": हौसा,
        "--hawaiian": हवाईयन,
        "--हिब्रू": हिब्रू,
        "-हिंदी": हिंदी,
        "--hmong": Hmong,
        "--हंगेरियन": हंगेरियन,
        "--icelandic": आइसलँडिक, //i
        "--igbo": इग्बो,
        "--ilocano": Ilocano,
        "--इंडोनेशियन": इंडोनेशियन,
        "--आयरिश": आयरिश,
        "--italian": इटालियन,
        "--japanese": जपानी, //j
        "--javanese": जावानीज,
        "--kannada": कन्नड, //k
        "--कझाक": कझाक,
        "--ख्मेर": ख्मेर,
        "--किन्यारवांडा": किन्यारवांडा,
        "--कोंकणी": कोकणी,
        "--कोरियन": कोरियन,
        "--क्रिओ": क्रिओ,
        "--कुर्दिशकुरमंजी": कुर्दिश (कुरमांजी),
        "--kurdishSorani": कुर्दिश (सोराणी),
        "--kyrgyz": किर्गिझ,
        "--lao": लाओ, //l
        "--लॅटिन": लॅटिन,
        "--latvian": लाटवियन,
        "--लिंगाला": लिंगाला,
        "--लिथुआनियन": लिथुआनियन,
        "--लुगांडा": लुगांडा,
        "--luxembourgish": Luxembourgish,
        "--macedonian": मॅसेडोनियन, //m
        "-मैथिली": मैथिली,
        "--malagasy": मालागासी,
        "--malay": मलय,
        "--मल्याळम": मल्याळम,
        "--- maltese": माल्टीज,
        "--maori": माओरी,
        "--marathi": मराठी,
        "--meiteilonManipuri": Meiteilon (मणिपुरी),
        "--मिझो": मिझो,
        "--मंगोलियन": मंगोलियन,
        "-myanmarBurmese": म्यानमार (बर्मीज),
        "--नेपाली": नेपाळी, //n
        "--norwegian": नॉर्वेजियन,
        "--odiaOriya": ओडिया (ओरिया), //o
        "--oromo": ओरोमो,
        "--पश्तो": पश्तो, //p
        "--पर्शियन": पर्शियन,
        "--polish": पोलिश,
        "--पोर्तुगीज": पोर्तुगीज,
        "--पंजाबी": पंजाबी,
        "--quechua": Quechua, //q
        "--रोमानियन": रोमानियन, //r
        "--रशियन": रशियन,
        "--सामोन": सामोन, //s
        "-संस्कृत": संस्कृत,
        "--scotsGaelic": स्कॉट्स गेलिक,
        "--सेपेडी": सेपेडी,
        "--सर्बियन": सर्बियन,
        "--sesotho": सेसोथो,
        "--शोना": शोना,
        "-सिंधी": सिंधी,
        "--सिंहला": सिंहला,
        "--slovak": स्लोव्हाक,
        "--slovenian": स्लोव्हेनियन,
        "--सोमाली": सोमाली,
        "--spanish": स्पॅनिश,
        "--sundanise": सुंदानीज,
        "--स्वाहिली": स्वाहिली,
        "--swedish": स्वीडिश,
        "--ताजिक": ताजिक, //t
        "--तमिल": तमिळ,
        "--tatar": तातार,
        "--तेलुगु": तेलुगु,
        "--थाई": थाई,
        "--tigrinya": Tigrinya,
        "-सोंगा": सोंगा,
        "--तुर्किश": तुर्की,
        "--तुर्कमेन": तुर्कमेन,
        "--twi": ट्वी,
        "--युक्रेनियन": युक्रेनियन, //u
        "--urdu": उर्दू,
        "--उयघुर": उईघुर,
        "--uzbek": उझबेक,
        "--व्हिएतनामी": व्हिएतनामी, //v
        "--welsh": वेल्श, //w
        "--xhosa": झोसा, //x
        "--yiddish": यिद्दिश, //y
        "--yoruba": योरूबा,
        "--झुलु": झुलू, //z
        },
      },

      // mizo
      // mizo
      mizo: {
        translations: {
          "--error a awm": Error a awm!, //a
           "--address": Address te, .
           "--thurawn": Thurawn, .
           "--by clicking on continue": continue tih click chuan i Veil Brillant account atang khan i disconnect ang, //b
           "--disconnect i click chuan i disconnect ang": Disconnect i click chuan i zocash account atanga disconnect i ni ang,
           "--i virtual number kha check la, a hnuah han try leh rawh": I virtual number kha check la, a hnuah han try leh rawh, //c
           "--i virtual number kha check rawh": I virtual number kha check la,
           "--chhunzawm rawh": Chhunzawm rawh,
           "--connection": Inzawmna, .
           "-- thawhhona, inrem taka nung": Thawhhona, midang nena inrem taka nun,
           "--ṭawng thlang rawh": Virtual Phone Language, .
           "--inelna khap suh": Inelna khap suh, mi zawng zawng chanvo pe rawh, //d
           "--disconnection": Inzawmna tihtawp, .
           "--virtual phone hmangtu zawng zawng tan": Virtual Phone hmangtu zawng zawng tan VPN, //f hman a tha
           "--login page-ah kal rawh": Login page-ah kal rawh, //g
           "--historical": Historic, //h
           "--i have account": Account ka nei tawh a, //i
           "--account ka nei lo": Account ka nei lo, .
           "--i in a ni": i in a ni,
           "--thlalak / video +": Hmanlai thil hlui / Video +,
           "--identity verification": Identity finfiahna, .
           "--izocash customer portal": izocash Customer Portal,
           "--kum tin identity update": Kum tin identity update,
           "--izocash lei tur": izocash lei tur => izocash international,
           "--log in": Log in!, //l
           "--login": Login, .
           "--login to veil brilliant": Veil Brillant nen inzawm rawh,
           "--vixinol store ah lut rawh": Vixinol Store ah connect rawh,
           "--i veil Brillant account-ah a thlawnin login rawh": He feature hi i hman theih nan i Veil Brillant account-ah a thlawnin lut la,
           "--login hlawhtlinna": Login hlawhtling!,
           "--login now": Tunah hian lut rawh!,
           "--logout hlawhtlinna": Logout hlawhtling!,
           "--log out": Chhuak chhuak, .
           "--logout": Lo chhuak rawh,
           "--number": Number, //n
           "--hming": Hming, .
           "--tunah chuan log in rawh": Tunah chuan, Log in rawh!,
           "--inelna tihtawp khap a ni lo":
           "--inhuatna a awm lo, huatna a awm lo": Inhuatna a awm lo, inhuatna a awm lo, inthenna a awm lo,
           "--ni lo": Ni lo, .
           "--i virtual phone hman theihna tur official address": I virtual phone hman theihna tur official address, //o
           "--password": Thuhmahruai, //p
           "--points lakchhuahna izocash": Points lakchhuahna izocash,
           "--point lakchhuahna": Point lakchhuahna, .
           "--a tha ber, vpn hmang rawh": A tha ber chu, i internet service provider ta ni lo VPN hmang la,
           "--chhelna hian a hlawkpui fo": Chhelna hian a tawpah a hlawkpui fo thin,
           "--rule": Dan, //r
           "--recommendation": Thurawn, .
           "--registration": Inziak lut, .
           "--signup to veil brilliant": Veil Brillant-ah inziak lut rawh, //s
           "--vixinol store-ah signup rawh": Vixinol Store-ah inziak lut rawh,
           "--signup": Inziak lut rawh,
           "--signup hlawhtlinna": Registration hlawhtling!,
           "--signup for free": A thlawna inziak lut rawh,
           “--signup hlawhtlinna IA”: Connection hlawhtling”,
           "--settings": "Settings" tih hi a ni.
           "--alrani app siam": Alrani application configure dan,
           "--izocash app siam dan": Izocash application configure dan tur,
           "--vixinol app siam": Vixinol application configure dan,
           "--veil Brillant app siam dan": Veil Brillant application configure dan,
           "--storage of images, videos": Thlalak, video leh element dang engemaw zat dahkhawmna,
           "--speed of reception": Datacenter atanga data dawn chak dan, .
           "--speed": Hman chakna, .
           "--terminate": Titawp, //t
           "--the vpn allows you to access": VPN hmang hian i internet service provider-in a blacklist site emaw application emaw a lut thei a,
           "--thing lian ber chu chung lamah a awm": Thing lian ber chu a chung berah chuan chi te tak te awlsam tak a ni a,
           "--touch the screen": Screen chu hmet la, chhunzawm rawh,
           "--e tum leh rawh": Ti leh rawh!,
           "--username": Hmanlai hming, //u

          "--virtual number": Number dik tak, //v
           "--virtual phone settings": A rilru a buai em em a, a rilru a hah em em bawk a.
           "--virtual Phone language hman a ni": Virtual Phone tawng hi application level-ah default-in hman a ni a,
           "--virtual phone": A rilru a buai em em a, a rilru a hah em em bawk a.
           "--validate": A dik leh dik loh, .
           "--izocash customer portal ah kan lo lawm a che": izocash Customer Portal ah hian kan lo lawm a che, //w
           "--super code ziak rawh": Super code ziak la,
           "--welcome to": Kan lo lawm a che,
           "--mi ngaihvenna kalna hmun": Mite ngaihvenna kalna hmunah sum a kal, .
           "--hnehtute chu an chhel": Hnehtute chu an chhel,
           "--i Alrani account atang hian i chhuak duh em": I Alrani account atang hian i chhuak duh em?,
           "--ni e": Ni e, //y

           // ram
           "--congo": Congo Brazzaville, 1999 khan a lo piang a.
           "--cameroon" tih a ni: Cameroon, 1999.
           "--drc": DRC, 1999 a ni.
           "--ivoryCoast": Ivory Coast, 1999 a ni.

           // langue tih a ni
        "--afrikaans": Afrikaans, //a
        "--albanian": Albanian tawng, .
        "--amharic": Amharic tawng, .
        "--arabic": Arabic tawng, .
        "--armenian": Armenian tawng, .
        "--assamese": Assamese tawng, .
        "--aymara": Aymara tawng, .
        "--azerbaijani": Azerbaijan tawng, 1999 a ni.
        "--bambara": Bambara tawng, //b
        "--basque": Basque tawng, .
        "--belarusian": Belarusian tawng, .
        "--bengali": Bengali tawng, .
        "--bhojpuri": Bhojpuri, .
        "--bosnian": Bosnia tawng, .
        "--bulgarian": Bulgarian tawng, .
        "--catalan": Catalan tawng, //c
        "--cebuano" tih a ni: Cebuano, .
        "--chichewa": Chichewa, .
        "--chineseSimplified": Chinese (A awlsam zawnga sawi),
        "--chineseTraditional": Chinese (Thil hlui), .
        "--corsican": Corsican tawng, .
        "--croatian": Croatian tawng, .
        "--czech": Czech tawng, .
        "--danish": Danish tawng, //d
        "--thivehi" tih hi a ni a, .
        "--dogri" tih hi a ni: Dogri, .
        "--dutch": Dutch tawng, .
        "--mizo": Mizo, //e
        "--esperanto" tih hi: Esperanto tawng, .
        "--estonian": Estonian tawng, .
        "---ewe": Bawnghnute, .
        "--filipino": Filipino tawng, //f
        "--finnish": Finnish tawng, .
        "--french": French tawng, .
        "--frisian": Frisian tawng, .
        "--galician": Galician tawng, //g
        "--georgian": Georgia tawng, .
        "--german": German tawng, .
        "--greek": Grik tawng, .
        "--guarani": Guarani tawng, .
        "--gujarati": Gujarati tawng, .
        "--haitianCreole": Haitian Creole tawng, //h
        "--hausa": Hausa, .
        "--hawaiian": Hawaii tawng, .
        "--hebrai": Hebrai tawng, .
        "--hindi": Hindi tawng, .
        "--hmong": Hmong, .
        "--hungarian": Hungarian tawng, .
        "--icelandic": Icelandic tawng, //i
        "--igbo": Igbo, .
        "--ilocano": Mizo tawng, .
        "--indonesian": Indonesia tawng, .
        "--irish": Irish tawng, .
        "--italian": Italian tawng, .
        "--japanese": Japanese tawng, //j
        "--javanese": Javanese tawng, .
        "--kannada": Kannada tawng, //k
        "--kazakh": Kazakh tawng, .
        "--khmer": Khmer, .
        "--kinyarwanda": Kinyarwanda tawng, .
        "--konkani": Konkani, 1999 a ni.
        "--korean": Korean tawng, .
        "--krio": Krio, .
        "--kurdishKurmanji": Kurdish (Kurmanji), .
        "--kurdishSorani": Kurdish (Sorani) tih a ni a, .
        "--kyrgyz": Kyrgyz tawng, .
        "--lao": Lao tawng, //l
        "--latin": Latin tawng, .
        "--latvian": Latvian tawng, .
        "--lingala": Lingala, 1999 a ni.
        "--lithuanian": Lithuanian tawng, .
        "--luganda": Luganda, .
        "--luxembourgish": Luxembourgish tawng, .
        "--macedonian": Makedonia tawng, //m
        "--maithili": Mizo tawng, .
        "--malagasy": Malagasy tawng, .
        "--malay": Malay tawng, .
        "--malayalam": Malayalam tawng, .
        "--maltese": Malta tawng, .
        "--maori": Maori, .
        "--marathi" tih: Marathi tawng, .
        "--meiteilonManipuri" tih hi a ni: Meiteilon (Manipuri), .
        "--mizo": Mizo, .
        "--mongolian": Mongolian tawng, .
        "--myanmarBurma tawng": Myanmar (Burmese tawng), .
        "--nepali": Nepali tawng, //n
        "--norwegian": Norway tawng, .
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Mizo tawng, .
        "--pashto": Pashto tawng, //p
        "--persian": Persia tawng, .
        "--polish": Polish tawng, .
        "--portuguese tawng": Portuguese tawng, .
        "--punjabi": Punjabi tawng, .
        "--quechua": Quechua, //q
        "--romanian": Romanian tawng, //r
        "--russia": Russian tawng, .
        "--samoan": Samoan tawng, //s
        "--sanskrit": Sanskrit tawng, .
        "--scotsGaelic": Scots Gaelic tawng, .
        "--sepedi" tih: Sepedi, 2019.
        "--serbian": Serbian tawng, .
        "--sesotho": Mizo tawng, .
        "--shona": Shona, 1999 a ni.
        "--sindhi" tih: Sindhi tawng, 1999.
        "--sinhala": Sinhala tawng, .
        "--slovak": Slovak tawng, .
        "--slovenian": Slovenian tawng, .
        "--somali": Somali tawng, .
        "--spanish": Spanish tawng, .
        "--sundane": Sundane tawng, .
        "--swahili": Swahili tawng, .
        "--swedish": Swedish tawng, .
        "--tajik": Tajik tawng, //t
        "--tamil": Tamil tawng, .
        "--tatar": Tatar, .
        "--telugu": Telugu, 1999.
        "--thai": Thai tawng, .
        "--tigrinya": Tigrinya, .
        "--tsonga": Tsonga, 1999 a ni.
        "--turkish": Turkish tawng, .
        "--turkmen": Turkmen, .
        "--twi": Twi, .
        "--ukrainian": Ukraine tawng, //u
        "--urdu": Urdu tawng, .
        "--uyghur": Uyghur, .
        "--uzbek": Uzbek tawng, .
        "--vietnamese": Vietnamese tawng, //v
        "--welsh": Welsh tawng, //w
        "--xhosa": Xhosa tawng, //x
        "--yiddish": Yiddish tawng, //y
        "--yoruba": Yoruba tawng, .
        "--zulu": Zulu tawng, //z
        },
      },

      // mongolian
      // mongolian
      mongolian: {
        translations: {
          "--алдаа гарсан": Алдаа гарлаа!, //a
          "--address": Хаяг,
          "--зөвлөгөө": Зөвлөгөө,
          "--үргэлжлүүлэх дээр дарснаар": Үргэлжлүүлэх дээр дарснаар та Veil Brillant бүртгэлээсээ салгагдах болно, //b
          "--таслах дээр дарснаар та салгагдах болно": Салгах дээр дарснаар та izocash данснаасаа салгагдах болно.
          "-- виртуал дугаараа шалгах эсвэл дараа дахин оролдоно уу": Виртуал дугаараа шалгах эсвэл дараа дахин оролдоно уу, //c
          "-- виртуаль дугаараа шалгана уу": Виртуал дугаараа шалгана уу.
          "--үргэлжлүүлэх": Үргэлжлүүлэх,
          "--холболт": Холболт,
          "--хамтран ажиллах, эв найртай амьдрах": Хамтран ажиллах, бусадтай эв найртай амьдрах,
          "--хэл сонгох": Виртуал утасны хэл,
          "--өрсөлдөөнөөс сэргийл": Өрсөлдөөнд бүү саад бол, хүн бүрт боломж олго, //д
          "--disconnection": Салгах,
          "--бүх виртуал утасны хэрэглэгчид": Виртуал утасны бүх хэрэглэгчдийн хувьд VPN, //f ашиглахыг зөвлөж байна
          "--нэвтрэх хуудас руу очих": Нэвтрэх хуудас руу очих, //g
          "--түүхэн": Түүхэн, //h
          "--i have account": Би аль хэдийн данстай, //i
          "--i don't account": Надад данс байхгүй,
          "--энэ бол чиний байшин": энэ бол таны байшин,
          "--зураг / видео +": Зураг / Видео +,
          "--Identity verification": Иргэний үнэмлэх баталгаажуулах,
          "--izocash хэрэглэгчийн портал": izocash хэрэглэгчийн портал,
          "--Identity update every year": Жил бүр таниулах мэдээлэл,
          "--izocash buy to": izocash Buy => izocash international,
          "--log in": Нэвтрэх!, //l
          "--login": Нэвтрэх,
          "--veil brilliant руу нэвтрэх": Veil Brillant-д холбогдох,
          "--vixinol дэлгүүрт нэвтрэх": Vixinol дэлгүүрт холбогдох,
          "--Veil Brillant данс руугаа үнэгүй нэвтрэх": Энэ функцэд хандахын тулд Veil Brillant бүртгэлдээ үнэгүй нэвтэрч,
          "--нэвтрэх амжилт": Нэвтрэх амжилттай!,
          "--одоо нэвтэрнэ үү": Одоо нэвтэрнэ үү!,
          "--гаралтын амжилт": Гарах амжилттай!,
          "--гарах": Гарах,
          "--logout": Гарах,
          "--тоо": Тоо, //n
          "--нэр": Нэр,
          "--одоо нэвтэрнэ үү": Одоо нэвтэрнэ үү!,
          "--Өрсөлдөөнийг боомилохыг хориглохгүй":
          "- Атаархал, үзэн ядалт байхгүй": Атаархал, үзэн ядалт, хуваагдал байхгүй,
          "--үгүй үгүй,
          "--албан ёсны хаягууд нь таны виртуал утсанд хандах": Таны виртуал утсанд хандах албан ёсны хаягууд, //o
          "--password": Нууц үг, //х
          "--points withdrawals izocash": Оноо авах izocash,
          "--оноо авах": Оноо авах,
          "--болж өгвөл vpn ашиглах": Таны интернет үйлчилгээ үзүүлэгчийн харьяалалгүй VPN-г ашиглавал зохимжтой.
          "--тууштай байх нь үргэлж үр өгөөжөө өгдөг": Тууштай байх нь эцэстээ үр өгөөжөө өгдөг,
          "--дүрэм": Дүрэм, //r
          "--зөвлөмж": Зөвлөмж,
          "--registration": Бүртгэл,
          "--бүртгэлд veil brilliant": Veil Brillant дээр бүртгүүлэх, //s
          "--vixinol дэлгүүрт бүртгүүлэх": Vixinol дэлгүүрт бүртгүүлэх,
          "--бүртгүүлэх": Бүртгүүлэх,
          "--бүртгэл амжилттай": Бүртгэл амжилттай боллоо!,
          "--үнэгүй бүртгүүлэх": Үнэгүй бүртгүүлэх,
          “--бүртгэлийн амжилт IA”: Холболт амжилттай”,
          "--settings": "Тохиргоо",
          "--alrani програмыг тохируулах": Alrani програмыг тохируулах,
          "--izocash програмыг тохируулах": izocash програмыг тохируулах,
          "--vixinol програмыг тохируулах": Vixinol програмыг тохируулах,
          "-- veil Brillant програмыг тохируулах": Veil Brillant програмыг тохируулах,
          "--зураг, видео хадгалах": Зураг, видео болон бусад хэд хэдэн элементүүдийг хадгалах,
          "--хүлээн авах хурд": Дата төвөөс өгөгдөл хүлээн авах хурд,
          "--speed": Хурд,
          "--terminate": дуусгавар болгох, //t
          "--vpn танд хандахыг зөвшөөрдөг": VPN нь таны интернет үйлчилгээ үзүүлэгчийн хар жагсаалтад орсон сайт эсвэл програм руу нэвтрэх боломжийг олгодог.
          "--хамгийн том мод дээр байсан": Хамгийн том мод бол энгийн жижиг үр,
          "--дэлгэцэнд хүрэх": Үргэлжлүүлэхийн тулд дэлгэцэнд хүрнэ үү,
          "--дахин оролдоно уу": Дахин оролдоно уу!,
          "--хэрэглэгчийн нэр": Хэрэглэгчийн нэр, //u

          "--виртуал тоо": Виртуал дугаар, //v
           "--виртуал утасны тохиргоо": Виртуал утасны тохиргоо,
           "--виртуал утасны хэл хэрэглэгдэж байна": Виртуал утасны хэлийг анхдагчаар програмын түвшинд ашигладаг.
           "--виртуал утас": Виртуал утас,
           "--validate": Баталгаажуулах,
           "-- izocash хэрэглэгчийн порталд тавтай морил": izocash хэрэглэгчийн порталд тавтай морил, //w
           "--супер код бичих": Супер код оруулна уу,
           "-- тавтай морил": тавтай морилно уу,
           "--хүмүүсийн анхаарал хаашаа явна": Хүмүүсийн анхаарал хаашаа явбал мөнгө,
           "--winners persevere": Ялагчид тэвчээртэй,
           "--та Alrani бүртгэлээсээ гарахыг хүсэж байна уу": Та Alrani бүртгэлээсээ гарахыг хүсэж байна уу?,
           "--тийм": Тийм, //y

           // улс
           "--конго": Конго Браззавиль,
           "--камерун": Камерун,
           "--drc": DRC,
           "--зааны ясан эрэг": Зааны ясан эрэг,

           // хэл
        "--африкчууд": Африк, //а
        "--albanian": Албани,
        "--амхар": Амхар,
        "--араб": араб,
        "--armenian": Армен,
        "--ассам": Ассам хэл,
        "--аймара": Аймара,
        "--азербайжан": Азербайжан,
        "--бамбара": Бамбара, //б
        "--баск": Баск,
        "--беларус": Беларусь,
        "--бенгали": Бенгал,
        "--бхожпури": Бхожпури,
        "--босни": Босни,
        "--болгар": Болгар,
        "--каталан": каталан, //c
        "--cebuano": Себуано,
        "--chichewa": Чичева,
        "--chineseSimplified": Хятад (Хялбаршуулсан),
        "--chineseTraditional": Хятад (Уламжлалт),
        "--корсик": Корсик,
        "--croatian": Хорват,
        "--чех": Чех,
        "--danish": Дани, //д
        "--дивехи": Дивехи,
        "--догри": Догри,
        "--голланд": Голланд,
        "--english": Англи хэл, //e
        "--эсперанто": Эсперанто,
        "--эстони": Эстони,
        "--ewe": Эвээ,
        "--Филиппин": Филиппин, //f
        "--финланд": Финлянд,
        "--франц хэл": Франц,
        "--фриз": Фриз хэл,
        "--galician": Galician, //g
        "--гүрж": Гүрж,
        "--герман": Герман,
        "--грек": Грек,
        "--гуарани": Гуарани,
        "--гужарати": Гужарати,
        "--haitianCreole": Гаити Креол, //h
        "--hausa": Хауса,
        "--hawaiian": Хавай,
        "--еврей": Еврей,
        "--хинди": Хинди,
        "--hmong": Хмонг,
        "--унгар": Унгар,
        "--исланд": Исланд, //i
        "--igbo": Игбо,
        "--ilocano": Ilocano,
        "--индонези": Индонези,
        "--irish": Ирланд,
        "--итали": итали,
        "--япон": Япон, //ж
        "--javanese": Ява,
        "--каннада": Каннада, //k
        "--казах": казах,
        "--khmer": Кхмер,
        "--kinyarwanda": Кинярванд,
        "--конкани": Конкани,
        "--солонгос": Солонгос,
        "--krio": Крио,
        "--kurdishKurmanji": Курд (Курманжи),
        "--kurdishSorani": Курд (Сорани),
        "--киргиз": Киргиз,
        "--лао": Лао, //л
        "--латин": Латин,
        "--латви": Латви,
        "--lingala": Лингала,
        "--lithuanian": Литва,
        "--luganda": Луганда,
        "--luxembourgish": Люксембург,
        "--македон": Македон, //м
        "--maithili": Майтили,
        "--малагаси": Малагаси,
        "--малай": Малай,
        "--malayalam": Малаялам,
        "--maltese": Мальта,
        "--маори": Маори,
        "--марати": Марати,
        "--meiteilonManipuri": Мейтейлон (Манипури),
        "--mizo": Мизо,
        "--mongolian": Монгол,
        "--myanmarBirmese": Мьянмар (Бирм),
        "--непал": Балба, //n
        "--норвеги": Норвеги,
        "--odiaOriya": Одиа (Ория), //о
        "--oromo": Оромо,
        "--пашто": Пашто, //х
        "--перс": Перс,
        "--polish": Польш,
        "--португал": Португал,
        "--пунжаби": Пунжаби,
        "--quechua": Кечуа, //q
        "--румын": Румын, //r
        "--орос": орос,
        "--самоан": Самоа, //s
        "--санскрит": санскрит,
        "--scotsGaelic": Шотланд Гаел,
        "--sepedi": Sepedi,
        "--серб": Серб,
        "--sesotho": Сесото,
        "--shona": Шона,
        "--синди": Синди,
        "--синхала": Синхала,
        "--словак": Словак,
        "--словени": Словен,
        "--сомали": Сомали,
        "--spanish": Испани,
        "--сундан": Сунда,
        "--суахили": Суахили,
        "--швед": Швед,
        "--тажик": Тажик, //т
        "--тамил": Тамил,
        "--татар": Татар,
        "--telugu": Тэлугу,
        "--тай": Тайланд,
        "--тигриня": Тигринья,
        "--цонга": Цонга,
        "--турк": турк,
        "--туркмен": туркмен,
        "--twi": Twi,
        "--украин": Украин, //у
        "--урду": Урду,
        "--уйгур": Уйгур,
        "--узбек": Узбек,
        "--вьетнам": Вьетнам, //v
        "--welsh": Уэльс, //w
        "--xhosa": Хоса, //x
        "--yiddish": Иддиш, //y
        "--yoruba": Йоруба,
        "--zulu": Зулу, //з
        },
      },

      // Myanmar (Burmese)
      // Myanmar (Burmese)
      myanmarBurmese: {
        translations: {
          "-- အမှားဖြစ်သွားသည်"- အမှားဖြစ်သွားသည်!, //a
           "--address": လိပ်စာများ၊
           "--advice": အကြံဉာဏ်၊
           "--by clicking on continue": Continue ကိုနှိပ်ခြင်းဖြင့် သင်သည် သင်၏ Veil Brillant အကောင့်မှ အဆက်ပြတ်သွားလိမ့်မည်၊ //b
           "-- disconnect ကိုနှိပ်ခြင်းဖြင့် သင်သည် အဆက်ပြတ်သွားလိမ့်မည်"- Disconnect ကိုနှိပ်ခြင်းဖြင့် သင်သည် သင်၏ izocash အကောင့်မှ အဆက်အသွယ်ဖြတ်သွားလိမ့်မည်၊
           "--သင်၏ virtual နံပါတ်ကို စစ်ဆေးပါ သို့မဟုတ် နောက်မှ ထပ်စမ်းကြည့်ပါ"- သင်၏ virtual နံပါတ်ကို စစ်ဆေးပါ သို့မဟုတ် နောက်မှ ထပ်လုပ်ကြည့်ပါ၊ //c
           "--သင်၏ virtual နံပါတ်ကိုစစ်ဆေးပါ"- သင်၏ virtual နံပါတ်ကို စစ်ဆေးပါ၊
           "--ဆက်ရန်"- ဆက်ရန်၊
           "--connection"- ချိတ်ဆက်မှု၊
           "--collaborate, harmony in live": ပူးပေါင်းဆောင်ရွက်ခြင်း၊ အခြားသူများနှင့် သဟဇာတဖြစ်အောင် နေထိုင်၊
           "--choose language"- ဖုန်းအတု ဘာသာစကား၊
           "-- ပြိုင်ဆိုင်မှုကို မတားဆီးပါနှင့်" - ပြိုင်ဆိုင်မှုကို မတားဆီးပါနှင့်၊ လူတိုင်းကို အခွင့်အရေးပေးပါ။ //d
           "--disconnection"- အဆက်ဖြတ်ခြင်း၊
           "--for all virtual phone users"- Virtual Phone အသုံးပြုသူများ အားလုံးအတွက်၊ VPN ကို အသုံးပြုရန် အကြံပြုထားသည်။ //f
           "--go to login page": လော့ဂ်အင်စာမျက်နှာသို့ သွားပါ၊ //g
           "--historical": သမိုင်းဆိုင်ရာ၊ //h
           "-- ငါအကောင့်ရှိတယ်": ငါ့မှာအကောင့်တစ်ခုရှိနေပြီ၊ //i
           "-- ငါ့မှာအကောင့်မရှိဘူး"- ငါ့မှာအကောင့်မရှိဘူး၊
           "--it is your house" : မင်းအိမ်ပဲ၊
           "--image/video +": ရုပ်ပုံ/ဗီဒီယို +၊
           "--identity verification"- အထောက်အထားစိစစ်ခြင်း၊
           "--izocash ဖောက်သည်ပေါ်တယ်": izocash သုံးစွဲသူ ပေါ်တယ်၊
           "--identity update every year"- နှစ်စဉ်နှစ်တိုင်း Identity update၊
           "--izocash buy to": izocash ဝယ်ရန် => izocash နိုင်ငံတကာ၊
           "--log in": လော့ဂ်အင်!၊ //l
           "--login"- လော့ဂ်အင်၊
           "--login to veil brillant"- Veil Brillant သို့ ချိတ်ဆက်ပါ၊
           "--login to vixinol store"- Vixinol Store သို့ ချိတ်ဆက်ပါ၊
           "--သင်၏ veil Brillant အကောင့်သို့ အခမဲ့ဝင်ရောက်ပါ"- ဤအင်္ဂါရပ်ကို အသုံးပြုရန် သင်၏ Veil Brillant အကောင့်သို့ အခမဲ့ဝင်ရောက်ပါ၊
           "--login အောင်မြင်သည်"- အကောင့်ဝင်ခြင်း အောင်မြင်သည်!၊
           "--login now"- ယခု လော့ဂ်အင်!၊
           "--logout အောင်မြင်သည်"- အကောင့်ထွက်အောင်မြင်ပြီ!၊
           "--log out"- ထွက်ရန်၊
           "--logout"- ထွက်ရန်၊
           "--number": နံပါတ်၊ //n
           "--name": အမည်၊
           "-- ယခု လော့ဂ်အင်"- ယခု၊ လော့ဂ်အင်!၊
           "-- ပြိုင်ဆိုင်မှုအား တားမြစ်ပိတ်ပင်ခြင်း မပြုရ"
           "-- မနာလိုမှု၊ မုန်းတီးမှု မရှိ"- မနာလိုမှု မရှိ၊ မုန်းတီးမှု မရှိ၊ ကွဲပြားခြင်း မရှိ၊
           "--မဟုတ်ဘူး။ မဟုတ်ဘူး,
           "--- မင်းရဲ့ virtual phone ကို ဝင်သုံးဖို့ တရားဝင် လိပ်စာများ"- မင်းရဲ့ virtual phone ကို သုံးဖို့ တရားဝင် လိပ်စာတွေ၊ //o
           "--password": စကားဝှက်၊ //p
           "--points ထုတ်ယူမှုများ izocash"- အမှတ်များ ထုတ်ယူမှုများ izocash၊
           "--points ထုတ်ယူမှုများ"- အမှတ်များ ထုတ်ယူမှုများ၊
           "-- ဖြစ်နိုင်ရင်၊ vpn ကိုသုံးပါ"- ဖြစ်နိုင်ရင်၊ သင့်အင်တာနက်ဝန်ဆောင်မှုပေးသူနဲ့မသက်ဆိုင်တဲ့ VPN ကိုသုံးပါ၊
           "-- မြဲမြံခြင်း အမြဲ ပြေစေသည်" - ဇွဲလုံ့လ သည် အဆုံး၌ အမြဲ ပေးသည် ။
           "--rule": စည်းကမ်းများ၊ //r
           "--recommendation": ထောက်ခံချက်၊
           "--registration": မှတ်ပုံတင်ခြင်း၊
           "-- တောက်ပသော ဖုံးအုပ်ရန် စာရင်းသွင်းရန်"- Veil Brillant တွင် မှတ်ပုံတင်ပါ၊ //s
           "--signup to vixinol store"- Vixinol Store တွင် မှတ်ပုံတင်ပါ၊
           "--signup"- မှတ်ပုံတင်ရန်၊
           "-- အကောင့်ဖွင့်ခြင်း အောင်မြင်သည်"- မှတ်ပုံတင်ခြင်း အောင်မြင်သည်!၊
           "--signup for free"- အခမဲ့ စာရင်းသွင်းပါ၊
           "-- အကောင့်ဖွင့်ခြင်း အောင်မြင်မှု IA"- ချိတ်ဆက်မှု အောင်မြင်သည်"၊
           "--settings": "ဆက်တင်များ",
           "-- alrani အက်ပ်ကို စနစ်ထည့်သွင်းခြင်း"- Alrani အက်ပ်အား ပြင်ဆင်သတ်မှတ်ခြင်း၊
           "-- izocash အက်ပ်ကို စနစ်ထည့်သွင်းခြင်း"- izocash အက်ပ်လီကေးရှင်းကို ပြင်ဆင်ခြင်း၊
           "--vixinol အက်ပ်ကို စနစ်ထည့်သွင်းခြင်း"- Vixinol အက်ပ်အား ပြင်ဆင်သတ်မှတ်ခြင်း၊
           "--brillant ဖုံးအုပ်အက်ပ်ကို တပ်ဆင်ခြင်း"- Veil Brillant အက်ပ်ကို ပြင်ဆင်ခြင်း၊
           "--ရုပ်ပုံများ၊ ဗီဒီယိုများ သိမ်းဆည်းခြင်း"- ရုပ်ပုံများ၊ ဗီဒီယိုများနှင့် အခြားဒြပ်စင်များစွာကို သိမ်းဆည်းခြင်း၊
           "--speed of reception": Datacenter မှ ဒေတာလက်ခံရယူမှု အမြန်နှုန်း၊
           "--speed": အရှိန်၊
           "--terminate": အပြီးသတ်၊ //t
           "--the vpn ခွင့်ပြုသည်" - VPN သည် သင့်အင်တာနက်ဝန်ဆောင်မှုပေးသူကို နာမည်ပျက်စာရင်းသွင်းထားသည့် ဝဘ်ဆိုက်တစ်ခု သို့မဟုတ် အက်ပ်လီကေးရှင်းကို ဝင်ရောက်ကြည့်ရှုခွင့်ပေးသည်၊
           "--the အကြီးဆုံး သစ်ပင်ကြီး" - အကြီးဆုံးသစ်ပင်သည် ရိုးရိုးမျိုးစေ့လေးများထက်၊
           "--touch the screen"- ရှေ့ဆက်ရန် မျက်နှာပြင်ကို ထိပါ၊
           "--try again"- ထပ်စမ်းကြည့်ပါ!၊
           "--username": အသုံးပြုသူအမည်၊ //u

           "--virtual number": အတုနံပါတ်၊ //v
           "--virtual phone settings"- ဖုန်းအတု ဆက်တင်များ၊
           "--virtual Phone ဘာသာစကားကို အသုံးပြုသည်"- ပုံသေဖုန်းဖြင့် Virtual ဖုန်းဘာသာစကားကို အပလီကေးရှင်းအဆင့်တွင် အသုံးပြုသည်၊
           "--virtual phone"- ဖုန်းအတု၊
           "--validate"- အတည်ပြုရန်၊
           "-- izocash ဖောက်သည်ပေါ်တယ်မှကြိုဆိုပါတယ်"- izocash ဖောက်သည်ပေါ်တယ်မှကြိုဆိုပါတယ် //w
           "---စူပါကုဒ်တစ်ခုရေးပါ"- စူပါကုဒ်ကို ရိုက်ထည့်ပါ၊
           "--welcome to"- မှကြိုဆိုပါတယ်
           "-- where people's focus goes" - လူတွေရဲ့ အာရုံစိုက်မှု က ငွေသွားတဲ့နေရာ၊
           "--အနိုင်ရသူများ ဇွဲ"- အောင်မြင်သူများသည် ဇွဲ၊
           "-- မင်းရဲ့ Alrani အကောင့်ကနေ ထွက်ချင်လား"- မင်းရဲ့ Alrani အကောင့်ကနေ ထွက်လိုသလား၊
           "--ဟုတ်ကဲ့": ဟုတ်ကဲ့၊ //y

           // တိုင်းပြည်
           "--congo": ကွန်ဂို Brazzaville၊
           "--cameroon"- ကင်မရွန်း၊
           "--drc": DRC၊
           "--ivoryCoast"- အိုင်ဗရီကို့စ်၊

           // ဘာသာစကား
        "--afrikaans": အာဖရိကန်၊ //a
        "--albanian": အယ်လ်ဘေးနီးယန်း၊
        "--amharic"- အမ်ဟာရစ်၊
        "--Arabic": အာရဗီ၊
        "--armenian": အာမေးနီးယန်း၊
        "--assamese": အာသံ၊
        "--aymara"- အေမရာ၊
        "--azerbaijani"- အဇာဘိုင်ဂျနီ၊
        "--bambara": Bambara၊ //b
        "--basque": Basque၊
        "--belarusian": ဘီလာရုရှ၊
        "--bengali": ဘင်္ဂါလီ၊
        "--bhojpuri"- Bhojpuri၊
        "--bosnian": ဘော့စနီးယား၊
        "--bulgarian": ဘူဂေးရီးယား၊
        "--catalan": ကာတာလန်၊ //c
        "--cebuano"- စီဘူနို၊
        "--chichewa": ချီချီဝါ၊
        "--chineseSimplified": တရုတ် (အလွယ်)၊
        "--chineseTraditional": တရုတ် (ရိုးရာ)၊
        "--corsican"- ကော်စီကန်၊
        "--croatian": ခရိုအေးရှား၊
        "--czech": ချက်၊
        "--danish": ဒိန်းမတ်၊ //d
        "--dhivehi"- ဒေဝီ၊
        "--dogri": Dogri၊
        "--dutch": ဒတ်ခ်ျ၊
        "--english": အင်္ဂလိပ်၊ //e
        "--esperanto": အက်စပရန်တို၊
        "--estonian": အက်စ်တိုးနီးယား၊
        "--ewe": အိုး၊
        "--filipino": ဖိလစ်ပိုင်၊ //f
        "--finnish": ဖင်လန်၊
        "--french": ပြင်သစ်၊
        "--frisian": ဖရီရှန်၊
        "--galician": ဂါလီစီယံ၊ //g
        "--georgian": ဂျော်ဂျီယံ၊
        "--german": ဂျာမန်၊
        "--greek": ဂရိ၊
        "--guarani"- ဂွာရာနီ၊
        "--gujarati": ဂူဂျာရတ်၊
        "--haitianCreole": Haitian Creole, //h
        "--hausa": ဟာဆာ၊
        "--hawaiian": ဟာဝိုင်ယီ၊
        "--hebrew"- ဟီးဘရူး၊
        "--hindi": ဟိန္ဒီ၊
        "--hmong": မုံ၊
        "--hungarian"- ဟန်ဂေရီ၊
        "--icelandic": အိုက်စလန်၊ //i
        "--igbo": အစ်ဂဘို၊
        "--ilocano"- အိုင်လိုကာနို၊
        "--indonesian"- အင်ဒိုနီးရှား၊
        "--irish": အိုင်ယာလန်၊
        "--italian": အီတလီ၊
        "--japanese": ဂျပန်၊ //j
        "--javanese": ဂျာဗားနီးစ်၊
        "--kannada": ကန်နာဒါ၊ //k
        "--kazakh": ဇတ်၊
        "--khmer": ခမာ၊
        "--kinyarwanda": ကိန္နဝန္ဒ၊
        "--konkani": ကွန်ကနီ၊
        "--korean": ကိုးရီးယား၊
        "--krio": ကရီယို၊
        "--kurdishKurmanji": ကာ့ဒ် (Kurmanji)၊
        "--kurdishSorani": ကာ့ဒ် (Sorani)၊
        "--kyrgyz"- ခရူဂျစ်၊
        "--lao": လာအို၊ //l
        "--latin"- လက်တင်၊
        "--latvian": လတ်ဗီးယား၊
        "--lingala": လင်ဂါလာ၊
        "--lithuanian": လစ်သူနီးယန်း၊
        "--luganda": လူဂန်ဒါ၊
        "--luxembourgish": လူဇင်ဘတ်ခ်၊
        "--macedonian": မက်ဆီဒိုးနီးယား၊ //m
        "--maithili": မသီလီ၊
        "--malagasy": အာလာဂါစီ၊
        "--malay": မလေး၊
        "--malayalam": မလေးလမ်၊
        "--maltese": မောလ်တီစ်၊
        "--maori": မော်ရီ၊
        "--marathi": မာရသီ၊
        "--meiteilonManipuri": Meiteilon (မဏိပူရီ)၊
        "--mizo": မီဇို၊
        "--mongolian": မွန်ဂိုလီးယား၊
        "--myanmarBurmese": မြန်မာ (ဗမာ)၊
        "--nepali": နီပေါ၊ //n
        "--norwegian"- နော်ဝေ၊
        "--odiaOriya": Odia (အိုရီယာ), //o
        "--oromo"- အိုရိုမို၊
        "--pashto": ပါရှတို၊ //p
        "--persian": ပါရှန်၊
        "--polish": ပိုလန်၊
        "--portuguese": ပေါ်တူဂီ၊
        "--punjabi"- ပန်ချာပီ၊
        "--quechua": Quechua၊ //q
        "--romanian": ရိုမေးနီးယား၊ //r
        "--russian": ရုရှား၊
        "--samoan": ဆာမိုယန်၊ //s
        "--sanskrit": သက္ကတ၊
        "--scotsGaelic"- စကော့ဂေလစ်၊
        "--sepedi"- ဆီပေဒီ၊
        "--serbian": ဆားဘီးယား၊
        "--sesotho": ဆီဆိုသို၊
        "--shona": ရှိုနာ၊
        "--sinhi": ဒြီ၊
        "--sinhala": ဆင်ဟာလ၊
        "--slovak": စလိုဗက်၊
        "--slovenian": စလိုဗေးနီးယန်း၊
        "--somali"- ဆိုမာလီ၊
        "--spanish": စပိန်၊
        "--sundanese": ဆူဒန်၊
        "--swahili": ဆွာဟီလီ၊
        "--swedish": ဆွီဒင်၊
        "--tajik": တာဂျစ်၊ //t
        "--tamil": တမီလ်၊
        "--tatar": တတာ၊
        "--telugu": ဂု၊
        "--thai": ထိုင်း၊
        "--tigrinya": တီဂရီညာ၊
        "--tsonga": ဆွန်ဂါ၊
        "--turkish": တူရကီ၊
        "--turkmen": တာ့ခ်မင်၊
        "--twi": နှစ်၊
        "--ukrainian": ယူကရိန်း၊ //u
        "--urdu": အူရဒူ၊
        "--uyghur": ဝီဂါ၊
        "--uzbek": ဥဇဘက်၊
        "--vietnamese": ဗီယက်နမ်၊ //v
        "--welsh": ဝဲလ်၊ //w
        "--xhosa": ဇိုဆာ၊ //x
        "--yiddish": Yiddish၊ //y
        "--yoruba"- ရိုရုဘာ၊
        "--zulu": ဇူလူ၊ //z
        },
      },

      // nepali
      // nepali
      nepali: {
        translations: {
          "--एरर आएको छ": एउटा त्रुटि आयो!, //a
           "--address": ठेगानाहरू,
           "--advice": सल्लाह,
           "-- जारी मा क्लिक गरेर": जारी मा क्लिक गरेर तपाईं आफ्नो Veil Brillant खाताबाट विच्छेद हुनुहुनेछ, //b
           "--विच्छेदनमा क्लिक गर्दा तपाइँ विच्छेदन हुनुहुनेछ": डिस्कनेक्टमा क्लिक गरेर तपाइँ तपाइँको izocash खाताबाट विच्छेद हुनुहुनेछ,
           "--आफ्नो भर्चुअल नम्बर जाँच गर्नुहोस् वा पछि पुन: प्रयास गर्नुहोस्": आफ्नो भर्चुअल नम्बर जाँच गर्नुहोस् वा पछि पुन: प्रयास गर्नुहोस्, //c
           "--तपाईंको भर्चुअल नम्बर जाँच गर्नुहोस्": तपाईंको भर्चुअल नम्बर जाँच गर्नुहोस्,
           "--continue": जारी राख्नुहोस्,
           "--Connection": जडान,
           "-सहयोग गर्नुहोस्, सद्भावमा बस्नुहोस्": सहकार्य गर्नुहोस्, अरूसँग मिलेर बस्नुहोस्,
           "--भाषा छान्नुहोस्": भर्चुअल फोन भाषा,
           "-प्रतिस्पर्धालाई रोक्न नदिनुहोस्": प्रतिस्पर्धालाई रोक्न नगर्नुहोस्, सबैलाई मौका दिनुहोस्, //d
           "--disconnection": विच्छेदन,
           "--सबै भर्चुअल फोन प्रयोगकर्ताहरूको लागि": सबै भर्चुअल फोन प्रयोगकर्ताहरूको लागि, यो VPN, //f प्रयोग गर्न सिफारिस गरिन्छ।
           "--लगइन पृष्ठमा जानुहोस्": लगइन पृष्ठमा जानुहोस्, //g
           "--historical": ऐतिहासिक, //h
           "--मसँग खाता छ": मसँग पहिले नै खाता छ, //i
           "--मसँग खाता छैन": मसँग खाता छैन,
           "--यो तिम्रो घर हो": यो तिम्रो घर हो,
           "--छवि / भिडियो +": छवि / भिडियो +,
           "--पहिचान प्रमाणीकरण": पहिचान प्रमाणीकरण,
           "--izocash ग्राहक पोर्टल": izocash ग्राहक पोर्टल,
           "--पहिचान हरेक वर्ष अपडेट": हरेक वर्ष पहिचान अपडेट,
           "--izocash buy to": izocash Buy => izocash अन्तर्राष्ट्रिय,
           "--log in": लग इन गर्नुहोस्!, //l
           "--login": लग इन,
           "--भिल ब्रिलियन्टमा लगइन गर्नुहोस्": पर्दा ब्रिलियन्टमा जडान गर्नुहोस्,
           "--भिक्सिनोल स्टोरमा लगइन गर्नुहोस्": भिक्सिनोल स्टोरमा जडान गर्नुहोस्,
           "--तपाईंको पर्दा ब्रिलेन्ट खातामा नि:शुल्क लगइन गर्नुहोस्": यो सुविधा पहुँच गर्नको लागि तपाईंको Veil Brillant खातामा नि:शुल्क लग इन गर्नुहोस्,
           "--login success": लगइन सफल!,
           "--login now": अहिले लग इन गर्नुहोस्!,
           "--logout success": लगआउट सफल!,
           "--log out": लगआउट,
           "--logout": लग आउट,
           "--number": नम्बर, //n
           "--नाम": नाम,
           "--अब लग इन गर्नुहोस्": अब, लग इन गर्नुहोस्!,
           "--प्रतिस्पर्धामा प्रतिबन्ध छैन":
           "न ईर्ष्या, न घृणा": न ईर्ष्या, न घृणा, न विभाजन,
           "--होइन होइन,
           "--आधिकारिक ठेगानाहरू तपाइँको भर्चुअल फोन पहुँच गर्न": तपाइँको भर्चुअल फोन पहुँच गर्न आधिकारिक ठेगानाहरू, //o
           "--password": पासवर्ड, //p
           "-- अंक निकासी izocash": अंक निकासी izocash,
           "--पोइन्ट निकासी": अंक निकासी,
           "--प्राथमिकतामा, vpn प्रयोग गर्नुहोस्": अधिमानतः, तपाइँको इन्टरनेट सेवा प्रदायकसँग सम्बन्धित नभएको VPN प्रयोग गर्नुहोस्,
           "--- दृढताले सधैं भुक्तान गर्छ": दृढताले सधैं अन्तमा चुक्ता गर्छ,
           "--नियम": नियम, //r
           "--recommendation": सिफारिसहरू,
           "--Registration": दर्ता,
           "--signup to veil brillant": Veil Brillant मा दर्ता गर्नुहोस्, //s
           "--भिक्सिनोल स्टोरमा साइन अप गर्नुहोस्": भिक्सिनोल स्टोरमा दर्ता गर्नुहोस्,
           "--signup": दर्ता,
           "--साइनअप सफलता": दर्ता सफल!,
           "--signup for free": सित्तैमा दर्ता गर्नुहोस्,
           "--साइनअप सफलता IA": जडान सफल",
           "--settings": "सेटिङहरू",
           "-- alrani एप सेट गर्दै": Alrani एप कन्फिगर गर्दै,
           "-- izocash एप सेट गर्दै": izocash एप कन्फिगर गर्दै,
           "--भिक्सिनोल एप सेट गर्दै": भिक्सिनोल एप कन्फिगर गर्दै,
           "--भेल ब्रिलन्ट एप सेट अप गर्दै": पर्दा ब्रिलन्ट एप कन्फिगर गर्दै,
           "-- छविहरू, भिडियोहरूको भण्डारण": छविहरू, भिडियोहरू र अन्य धेरै तत्वहरूको भण्डारण,
           "--रिसेप्शनको गति": डाटासेन्टरबाट डाटाको रिसेप्शनको गति,
           "--speed": गति,
           "--terminate": समाप्त, //t
           "--vpn ले तपाइँलाई पहुँच गर्न अनुमति दिन्छ": VPN ले तपाइँलाई तपाइँको इन्टरनेट सेवा प्रदायकले कालोसूचीमा राखेको साइट वा अनुप्रयोग पहुँच गर्न अनुमति दिन्छ,
           "--सबैभन्दा ठूलो रूख माथि थियो": सबैभन्दा ठूलो रूख सबै भन्दा माथि एक साधारण सानो बीउ थियो,
           "--स्क्रिन छुनुहोस्": जारी राख्न स्क्रिन छुनुहोस्,
           "--try again": फेरि प्रयास गर्नुहोस्!,
           "--username": प्रयोगकर्ता नाम, //u

           "--भर्चुअल नम्बर": भर्चुअल नम्बर, //v
           "--virtual phone settings": भर्चुअल फोन सेटिङहरू,
           "--भर्चुअल फोन भाषा लागू गरिएको छ": भर्चुअल फोन भाषा पूर्वनिर्धारित रूपमा अनुप्रयोग स्तरमा लागू हुन्छ,
           "--virtual phone": भर्चुअल फोन,
           "--validate": मान्य गर्नुहोस्,
           "-- izocash ग्राहक पोर्टलमा स्वागत छ": izocash ग्राहक पोर्टलमा स्वागत छ, //w
           "--एक सुपर कोड लेख्नुहोस्": सुपर कोड प्रविष्ट गर्नुहोस्,
           "---welcome to": स्वागत छ,
           "---जनताको ध्यान जहाँ जान्छ": जहाँ जनताको ध्यान जान्छ पैसा जान्छ,
           "--विजेताहरू दृढ रहन्छन्": विजेताहरू दृढ रहन्छन्,
           "--के तपाई आफ्नो Alrani खाताबाट लग आउट गर्न चाहनुहुन्छ": के तपाई आफ्नो Alrani खाताबाट लग आउट गर्न चाहनुहुन्छ?,
           "--हो": हो, //y

           // देश
           "--congo": कंगो ब्राजाभिल,
           "--cameroon": क्यामरुन,
           "--drc": DRC,
           "--ivoryCoast": आइभोरी कोस्ट,

           // भाषा
        "--afrikaans": अफ्रिकान्स, //a
        "--अल्बेनियन": अल्बेनियन,
        "--amharic": अम्हारिक,
        "--अरबी": अरबी,
        "--armenian": आर्मेनियन,
        "--assamese": असमिया,
        "--aymara": आयमारा,
        "--अजरबैजानी": अजरबैजानी,
        "--bambara": बम्बरा, //b
        "--basque": बास्क,
        "--belarusian": बेलारूसी,
        "--बंगाली": बंगाली,
        "--भोजपुरी": भोजपुरी,
        "--bosnian": बोस्नियाई,
        "--bulgarian": बुल्गेरियन,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": चिचेवा,
        "--chineseSimplified": चिनियाँ (सरलीकृत),
        "--chineseTraditional": चिनियाँ (परम्परागत),
        "--corsican": कोर्सिकन,
        "--क्रोएशियन": क्रोएशियाई,
        "--czech": चेक,
        "--danish": डेनिस, //d
        "--धिवेही": धिवेही,
        "--dogri": डोगरी,
        "--dutch": डच,
        "--english": अंग्रेजी, //e
        "--esperanto": एस्पेरान्तो,
        "--estonian": एस्टोनियाई,
        "--ewe": Ewe,
        "--filipino": फिलिपिनो, //f
        "--finnish": फिनिस,
        "--फ्रेन्च": फ्रेन्च,
        "--frisian": फ्रिसियन,
        "--ग्यालिशियन": ग्यालिशियन, //g
        "--georgian": Georgian,
        "--जर्मन": जर्मन,
        "--ग्रीक": ग्रीक,
        "--guarani": गुआरानी,
        "--gujarati": गुजराती,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": हौसा,
        "--hawaiian": हवाईयन,
        "--हिब्रू": हिब्रू,
        "--hindi": हिन्दी,
        "--hmong": Hmong,
        "--हंगेरियन": हंगेरियन,
        "--आइसल्याण्डिक": आइसल्याण्डिक, //i
        "--igbo": इग्बो,
        "--ilocano": Ilocano,
        "--इन्डोनेशियन": इन्डोनेसियाली,
        "--आयरिश": आयरिश,
        "--italian": इटालियन,
        "--japanese": जापानी, //j
        "--javanese": जाभानीज,
        "--kannada": कन्नड, //k
        "--kazakh": कजाख,
        "--khmer": खमेर,
        "--kinyarwanda": किन्यारवाण्डा,
        "--कोंकणी": कोंकणी,
        "--कोरियन": कोरियाली,
        "--krio": Krio,
        "--kurdishKurmanji": कुर्दिश (कुरमान्जी),
        "--kurdishSorani": कुर्दिश (सोरानी),
        "--kyrgyz": किर्गिज,
        "--lao": लाओ, //l
        "--ल्याटिन": ल्याटिन,
        "--latvian": Latvian,
        "--lingala": लिंगाला,
        "--लिथुआनियन": लिथुआनियाली,
        "--luganda": लुगान्डा,
        "--luxembourgish": Luxembourgish,
        "--macedonian": म्यासेडोनियन, //m
        "-मैथिली": मैथिली,
        "--malagasy": मालागासी,
        "--malay": मलय,
        "--malayalam": मलयालम,
        "-- माल्टीज": माल्टीज,
        "--maori": माओरी,
        "--marathi": मराठी,
        "--meiteilonManipuri": Meiteilon (मणिपुरी),
        "--mizo": मिजो,
        "--mongolian": मङ्गोलियन,
        "--myanmarBurmese": म्यानमार (बर्मी),
        "--nepali": नेपाली, //n
        "--norwegian": नर्वेजियन,
        "--odiaOriya": Odia (उडिया), //o
        "--oromo": ओरोमो,
        "--pashto": पश्तो, //p
        "--पर्शियन": फारसी,
        "--polish": पोलिश,
        "--portuguese": पोर्तुगाली,
        "--punjabi": पंजाबी,
        "--quechua": क्वेचुआ, //q
        "--रोमानियन": रोमानियन, //r
        "--russian": रूसी,
        "--सामोन": सामोन, //s
        "-संस्कृत": संस्कृत,
        "--scotsGaelic": स्कट्स गेलिक,
        "--sepedi": Sepedi,
        "--सर्बियन": सर्बियाई,
        "--sesotho": सेसोथो,
        "--शोना": शोना,
        "--sindhi": सिन्धी,
        "--sinhala": सिंहला,
        "--slovak": स्लोभाक,
        "--slovenian": स्लोभेनियाई,
        "--सोमाली": सोमाली,
        "--spanish": स्पेनिश,
        "--sundanise": सुन्दानीज,
        "--स्वाहिली": स्वाहिली,
        "--swedish": स्विडिश,
        "--ताजिक": ताजिक, //t
        "--तमिल": तमिल,
        "--tatar": टाटर,
        "--तेलुगु": तेलुगु,
        "--थाई": थाई,
        "--tigrinya": Tigrinya,
        "--सोंगा": सोंगा,
        "--टर्किश": टर्की,
        "--तुर्कमेन": तुर्कमेन,
        "--twi": Twi,
        "--ukrainian": युक्रेनी, //u
        "--urdu": उर्दू,
        "--उइघुर": उइघुर,
        "--uzbek": उज्बेक,
        "--भियतनामी": भियतनामी, //v
        "--welsh": वेल्श, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": योरुबा,
        "--zulu": जुलु, //z
        },
      },

      // norwegian
      // norwegian
      norwegian: {
        translations: {
          "--en feil har oppstått": Det har oppstått en feil!, //a
           "--address": Adresser,
           "--advice": Råd,
           "--ved å klikke på fortsett": Ved å klikke på fortsett vil du bli koblet fra Veil Brillant-kontoen din, //b
           "--ved å klikke på koble fra blir du frakoblet": Ved å klikke på Koble fra blir du koblet fra izocash-kontoen din,
           "--sjekk ditt virtuelle nummer eller prøv igjen senere": Sjekk ditt virtuelle nummer eller prøv igjen senere, //c
           "--sjekk ditt virtuelle nummer": Sjekk ditt virtuelle nummer,
           "--continue": Fortsett,
           "--connection": Tilkobling,
           "--samarbeid, lev i harmoni": Samarbeid, lev i harmoni med andre,
           "--velg språk": Virtuelt telefonspråk,
           "--ikke hindre konkurranse": Ikke hindre konkurranse, gi alle en sjanse, //d
           "--disconnection": Frakobling,
           "--for alle virtuelle telefonbrukere": For alle virtuelle telefonbrukere anbefales det å bruke en VPN, //f
           "--gå til påloggingssiden": Gå til påloggingssiden, //g
           "--historisk": Historisk, //h
           "--i have account": Jeg har allerede en konto, //i
           "--jeg har ikke konto": Jeg har ikke en konto,
           "--det er ditt hus": det er ditt hus,
           "--bilde / video +": Bilde / video +,
           "--identitetsverifisering": Identitetsverifisering,
           "--izocash kundeportal": izocash kundeportal,
           "--identitetsoppdatering hvert år": Identitetsoppdatering hvert år,
           "--izocash kjøp til": izocash Kjøp => izocash internasjonalt,
           "--log in": Logg inn!, //l
           "--login": Logg inn,
           "--logg inn på veil brilliant": Koble til Veil Brillant,
           "--logg inn på Vixinol Store": Koble til Vixinol Store,
           "--logg inn gratis på veil Brillant-kontoen din": Logg inn gratis på Veil Brillant-kontoen din for å få tilgang til denne funksjonen,
           "--login suksess": Pålogging vellykket!,
           "--logg inn nå": Logg inn nå!,
           "--logout suksess": Logg ut vellykket!,
           "--logg ut": Logg ut,
           "--logout": Logg ut,
           "--nummer": Nummer, //n
           "--name": Navn,
           "--nå logg inn": Nå, logg på!,
           "--ingen forbud mot å kvele konkurranse":
           "--ingen sjalusi, ingen hat": Ingen sjalusi, ingen hat, ingen splittelser,
           "--Nei nei,
           "--offisielle adresser for å få tilgang til din virtuelle telefon": Offisielle adresser for å få tilgang til din virtuelle telefon, //o
           "--password": Passord, //p
           "--poenguttak izocash": Poenguttak izocash,
           "--poenguttak": Poenguttak,
           "--helst, bruk en vpn": Bruk helst en VPN som ikke tilhører din internettleverandør,
           "--utholdenhet lønner seg alltid": Utholdenhet lønner seg alltid til slutt,
           "--rule": Regler, //r
           "--recommendation": Anbefalinger,
           "--registration": Registrering,
           "--registrer deg til veil brilliant": Registrer deg på Veil Brillant, //s
           "--registrer deg til vixinol store": Registrer deg på Vixinol Store,
           "--signup": Registrer deg,
           "--signup success": Registrering vellykket!,
           "--registrer deg gratis": Registrer deg gratis,
           "--registreringssuksess IA": Tilkobling vellykket",
           "--settings": "Innstillinger",
           "--sette opp alrani-appen": Konfigurering av Alrani-applikasjonen,
           "--sette opp izocash-appen": Konfigurerer izocash-applikasjonen,
           "--sette opp vixinol-appen": Konfigurerer Vixinol-applikasjonen,
           "--sette opp veil Brillant-appen": Konfigurere Veil Brillant-applikasjonen,
           "--lagring av bilder, videoer": Lagring av bilder, videoer og flere andre elementer,
           "--speed of reception": Hastighet for mottak av data fra datasenteret,
           "--speed": Hastighet,
           "--terminate": Avslutt, //t
           "--the vpn lar deg få tilgang": VPN lar deg få tilgang til et nettsted eller en applikasjon som internettleverandøren din har svartelistet,
           "--det største treet var over": Det største treet var fremfor alt et enkelt lite frø,
           "--touch the screen": Trykk på skjermen for å fortsette,
           "--try again": Prøv igjen!,
           "--brukernavn": Brukernavn, //u

           "--virtuelt nummer": Virtuelt nummer, //v
           "--virtuelle telefoninnstillinger": Virtuelle telefoninnstillinger,
           "--virtual Phone language is used": Virtual Phone-språket brukes på applikasjonsnivå som standard,
           "--virtual phone": Virtuell telefon,
           "--validate": Bekreft,
           "--velkommen til izocash-kundeportalen": Velkommen til izocash-kundeportalen, //w
           "--skriv en superkode": Skriv inn en superkode,
           "--velkommen til": Velkommen til,
           "--hvor folks oppmerksomhet går": Hvor folks oppmerksomhet går, går pengene,
           "--vinnere holder ut": Vinnerne holder ut,
           "--vil du logge ut av Alrani-kontoen din": Vil du logge ut av Alrani-kontoen din?,
           "--yes": Ja, //y

           // land
           "--kongo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Elfenbenskysten,

           // språk
        "--afrikaans": Afrikaans, //a
        "--albansk": albansk,
        "--amharisk": amharisk,
        "--arabic": arabisk,
        "--armensk": armensk,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--aserbajdsjansk": aserbajdsjansk,
        "--bambara": Bambara, //b
        "--basque": baskisk,
        "--hviterussisk": hviterussisk,
        "--bengali": bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnisk": bosnisk,
        "--bulgarsk": bulgarsk,
        "--catalan": katalansk, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kinesisk (forenklet),
        "--chineseTraditional": kinesisk (tradisjonell),
        "--corsican": korsikansk,
        "--croatian": kroatisk,
        "--czech": tsjekkisk,
        "--danish": dansk, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--nederlandsk": nederlandsk,
        "--engelsk": engelsk, //e
        "--esperanto": Esperanto,
        "--estisk": estisk,
        "--ewe": Ewe,
        "--filippinsk": filippinsk, //f
        "--finnish": finsk,
        "--french": fransk,
        "--frisian": frisisk,
        "--galisisk": galisisk, //g
        "--georgian": georgisk,
        "--german": tysk,
        "--greek": gresk,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": hawaiisk,
        "--hebrew": hebraisk,
        "--hindi": hindi,
        "--hmong": Hmong,
        "--hungarian": ungarsk,
        "--islandsk": islandsk, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesisk": indonesisk,
        "--irish": irsk,
        "--italiensk": italiensk,
        "--japansk": japansk, //j
        "--javanese": javanesisk,
        "--kannada": Kannada, //k
        "--kasakh": kasakhisk,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": koreansk,
        "--krio": Krio,
        "--kurdishKurmanji": kurdisk (Kurmanji),
        "--kurdishSorani": kurdisk (Sorani),
        "--kyrgyz": kirgisisk,
        "--lao": Lao, //l
        "--latin": latin,
        "--latvisk": latvisk,
        "--lingala": Lingala,
        "--lithuanian": litauisk,
        "--luganda": Luganda,
        "--luxembourgish": luxemburgsk,
        "--makedonsk": makedonsk, //m
        "--maithili": Maithili,
        "--malagasy": malagasisk,
        "--malay": malaysisk,
        "--malayalam": malayalam,
        "--maltesisk": maltesisk,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongolsk,
        "--myanmarburmesisk": Myanmar (burmesisk),
        "--nepali": Nepali, //n
        "--norsk": norsk,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //s
        "--persisk": persisk,
        "--polsk": polsk,
        "--portuguese": portugisisk,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romensk": rumensk, //r
        "--russisk": russisk,
        "--samoan": samoansk, //s
        "--sanskrit": sanskrit,
        "--scotsGaelic": skotsk gælisk,
        "--sepedi": Sepedi,
        "--serbian": serbisk,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": singalesisk,
        "--slovak": slovakisk,
        "--slovensk": slovensk,
        "--somali": Somali,
        "--spanish": spansk,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--svensk": svensk,
        "--tajik": Tadsjikisk, //t
        "--tamil": Tamil,
        "--tatar": tatarisk,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": tyrkisk,
        "--turkmen": turkmensk,
        "--twi": Twi,
        "--ukrainsk": ukrainsk, //u
        "--urdu": Urdu,
        "--uyghur": uigurisk,
        "--uzbek": usbekisk,
        "--vietnamesisk": vietnamesisk, //v
        "--welsh": walisisk, //w
        "--xhosa": Xhosa, //x
        "--jiddisch": Jiddisch, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // Odia (Oriya)
      // Odia (Oriya)
      odiaOriya: {
        translations: {
          "- ଏକ ତ୍ରୁଟି ଘଟିଛି": ଏକ ତ୍ରୁଟି ଘଟିଛି !, // a
           "- ଆଡ୍ରେସ୍": ଠିକଣା,
           "- ଆଡଭାଇସ୍": ଉପଦେଶ,
           "- ଜାରି ରଖିବା ଉପରେ କ୍ଲିକ୍ କରି": ଜାରି ରଖିବା ଉପରେ କ୍ଲିକ୍ କରି ତୁମେ ତୁମର ଭେଲ ବ୍ରିଲାଣ୍ଟ ଆକାଉଣ୍ଟରୁ ବିଚ୍ଛିନ୍ନ ହେବ, // b
           "- ବିଚ୍ଛିନ୍ନତା ଉପରେ କ୍ଲିକ୍ କରି ତୁମେ ସଂଯୋଗ ବିଚ୍ଛିନ୍ନ ହେବ": ବିଚ୍ଛିନ୍ନତା ଉପରେ କ୍ଲିକ୍ କରି ତୁମର izocash ଆକାଉଣ୍ଟରୁ ବିଚ୍ଛିନ୍ନ ହେବ,
           "- ଆପଣଙ୍କର ଭର୍ଚୁଆଲ୍ ନମ୍ବର ଯାଞ୍ଚ କରନ୍ତୁ କିମ୍ବା ପରେ ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ": ଆପଣଙ୍କର ଭର୍ଚୁଆଲ୍ ନମ୍ବର ଯାଞ୍ଚ କରନ୍ତୁ କିମ୍ବା ପରେ ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ, // c
           "- ଆପଣଙ୍କର ଭର୍ଚୁଆଲ୍ ନମ୍ବର ଯାଞ୍ଚ କରନ୍ତୁ": ଆପଣଙ୍କର ଭର୍ଚୁଆଲ୍ ନମ୍ବର ଯାଞ୍ଚ କରନ୍ତୁ,
           "- ଜାରି ରଖନ୍ତୁ": ଜାରି ରଖନ୍ତୁ,
           "- ସଂଯୋଗ": ସଂଯୋଗ,
           "- ସହଯୋଗ କରନ୍ତୁ, ସୁସମ୍ପର୍କରେ ବଞ୍ଚନ୍ତୁ": ସହଯୋଗ କରନ୍ତୁ, ଅନ୍ୟମାନଙ୍କ ସହିତ ସୁସମ୍ପର୍କରେ ବଞ୍ଚନ୍ତୁ,
           "- ଭାଷା ବାଛ": ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ଭାଷା,
           "- ପ୍ରତିଯୋଗିତାକୁ ପ୍ରତିରୋଧ କରନ୍ତୁ ନାହିଁ": ପ୍ରତିଯୋଗିତାକୁ ରୋକନ୍ତୁ ନାହିଁ, ସମସ୍ତଙ୍କୁ ଏକ ସୁଯୋଗ ଦିଅନ୍ତୁ, // d
           "- ସଂଯୋଗ": ବିଚ୍ଛିନ୍ନତା,
           "- ସମସ୍ତ ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ବ୍ୟବହାରକାରୀଙ୍କ ପାଇଁ": ସମସ୍ତ ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ବ୍ୟବହାରକାରୀଙ୍କ ପାଇଁ, ଏକ VPN, // f ବ୍ୟବହାର କରିବାକୁ ପରାମର୍ଶ ଦିଆଯାଇଛି |
           "- ଲଗଇନ୍ ପୃଷ୍ଠାକୁ ଯାଆନ୍ତୁ": ଲଗଇନ୍ ପୃଷ୍ଠାକୁ ଯାଆନ୍ତୁ, // g
           "- ଇତିହାସ": Histor ତିହାସିକ, // ଘ
           "- ମୋର ଖାତା ଅଛି": ମୋର ପୂର୍ବରୁ ଏକ ଖାତା ଅଛି, // i
           "- ମୋର ଖାତା ନାହିଁ": ମୋର ଖାତା ନାହିଁ,
           "- ଏହା ତୁମର ଘର": ଏହା ତୁମର ଘର,
           "- ଚିତ୍ର / ଭିଡିଓ +": ପ୍ରତିଛବି / ଭିଡିଓ +,
           "- ପରିଚୟ ଯାଞ୍ଚ": ପରିଚୟ ଯାଞ୍ଚ,
           "--izocash ଗ୍ରାହକ ପୋର୍ଟାଲ": izocash ଗ୍ରାହକ ପୋର୍ଟାଲ,
           "- ପ୍ରତିବର୍ଷ ପରିଚୟ ଅଦ୍ୟତନ": ପ୍ରତିବର୍ଷ ପରିଚୟ ଅଦ୍ୟତନ,
           "--izocash buy to": izocash Buy => izocash international,
           "- ଲଗ୍ ଇନ୍": ଲଗ୍ ଇନ୍ !, // l
           "- ଲୋଗିନ୍": ଲଗ୍ ଇନ୍,
           "- ଉଜ୍ଜ୍ୱଳ ଆବରଣ କରିବାକୁ ଲୋଗିନ୍": ଭେଲ ବ୍ରିଲାଣ୍ଟ ସହିତ ସଂଯୋଗ କରନ୍ତୁ,
           "- ଲୋଗିନ୍ ଟୁ ଭିକ୍ସିନୋଲ୍ ଷ୍ଟୋର୍": ଭିକ୍ସିନୋଲ୍ ଷ୍ଟୋର୍‌କୁ ସଂଯୋଗ କରନ୍ତୁ,
           "- ଆପଣଙ୍କର ଆବରଣ ବ୍ରିଲାଣ୍ଟ ଆକାଉଣ୍ଟକୁ ମାଗଣାରେ ଲୋଗିନ୍": ଏହି ବ feature ଶିଷ୍ଟ୍ୟକୁ ପ୍ରବେଶ କରିବାକୁ ଆପଣଙ୍କର ଭେଲ୍ ବ୍ରିଲାଣ୍ଟ ଆକାଉଣ୍ଟକୁ ମାଗଣାରେ ଲଗ୍ ଇନ୍ କରନ୍ତୁ,
           "- ଲୋଗିନ୍ ସଫଳତା": ଲଗଇନ୍ ସଫଳ!,
           "- ଲୋଗିନ୍ ବର୍ତ୍ତମାନ": ବର୍ତ୍ତମାନ ଲଗ୍ ଇନ୍ କରନ୍ତୁ!,
           "- ଲୋଗଆଉଟ୍ ସଫଳତା": ଲଗଆଉଟ୍ ସଫଳ!,
           "- ଲଗ୍ ଆଉଟ୍": ଲଗଆଉଟ୍,
           "- ଲୋଗଆଉଟ୍": ଲଗ୍ ଆଉଟ୍,
           "- ସଂଖ୍ୟା": ସଂଖ୍ୟା, // n
           "- ନାମ": ନାମ,
           "- now log in": ବର୍ତ୍ତମାନ, ଲଗ୍ ଇନ୍ କରନ୍ତୁ ,,
           "- ପ୍ରତିଦ୍ୱନ୍ଦ୍ୱିତା ଉପରେ କ ban ଣସି ପ୍ରତିବନ୍ଧକ ନାହିଁ":
           "- ealous ର୍ଷା ନାହିଁ, ଘୃଣା ନାହିଁ": No ର୍ଷା ନାହିଁ, ଘୃଣା ନାହିଁ, ବିଭାଜନ ନାହିଁ,
           "--ନା ନା,
           "- ଆପଣଙ୍କର ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ଆକ୍ସେସ୍ କରିବାକୁ ଅଫିସିଆଲ୍ ଠିକଣା": ଆପଣଙ୍କର ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ପ୍ରବେଶ କରିବାକୁ ଅଫିସିଆଲ୍ ଠିକଣା, // o |
           "- ପାସୱାର୍ଡ": ପାସୱାର୍ଡ, // p
           "- ପଏଣ୍ଟ ପ୍ରତ୍ୟାହାର izocash": ପଏଣ୍ଟ ପ୍ରତ୍ୟାହାର izocash,
           "- ପଏଣ୍ଟ ପ୍ରତ୍ୟାହାର": ପଏଣ୍ଟ ପ୍ରତ୍ୟାହାର,
           "- ସମ୍ଭବତ ,, ଏକ vpn ବ୍ୟବହାର କରନ୍ତୁ": ପସନ୍ଦ ଅନୁଯାୟୀ, ଏକ VPN ବ୍ୟବହାର କରନ୍ତୁ ଯାହା ଆପଣଙ୍କର ଇଣ୍ଟରନେଟ୍ ସେବା ପ୍ରଦାନକାରୀଙ୍କର ନୁହେଁ,
           "- ସ୍ଥିରତା ସର୍ବଦା ପରିଶୋଧ କରେ": ସ୍ଥିରତା ସର୍ବଦା ଶେଷରେ ପରିଶୋଧ କରେ,
           "--rule": ନିୟମ, // r
           "- ସୁପାରିଶ": ସୁପାରିଶ,
           "- ପଞ୍ଜୀକରଣ": ପଞ୍ଜୀକରଣ,
           "- ଉଜ୍ଜ୍ୱଳ ଆଚ୍ଛାଦନ ପାଇଁ ସାଇନ୍ ଅପ୍": ଭେଲ୍ ବ୍ରିଲାଣ୍ଟ, // s ରେ ପଞ୍ଜିକରଣ କର |
           "- ଭିକ୍ସିନୋଲ ଷ୍ଟୋରକୁ ସାଇନ୍ ଅପ୍": ଭିକ୍ସିନୋଲ ଷ୍ଟୋର୍‌ରେ ପଞ୍ଜିକରଣ,
           "- ସାଇନ୍ଅପ୍": ପଞ୍ଜିକରଣ,
           "- ସାଇନ୍ଅପ୍ ସଫଳତା": ପଞ୍ଜୀକରଣ ସଫଳ!,
           "- ମାଗଣାରେ ସାଇନ୍ ଅପ୍": ମାଗଣାରେ ପଞ୍ଜିକରଣ,
           “- ସାଇନ୍ଅପ୍ ସଫଳତା IA”: ସଂଯୋଗ ସଫଳ ”,
           "- ସେଟିଂସମୂହ": "ସେଟିଂସମୂହ",
           "- ଆଲ୍ରାନି ଆପ୍ ସେଟ୍ ଅପ୍": ଆଲ୍ରାନି ପ୍ରୟୋଗକୁ ବିନ୍ୟାସ କରୁଅଛି,
           "- izocash ଆପ୍ ସେଟ୍ ଅପ୍": izocash ପ୍ରୟୋଗକୁ ବିନ୍ୟାସ କରୁଅଛି,
           "- ଭିକ୍ସିନୋଲ୍ ଆପ୍ ସେଟ୍ ଅପ୍": ଭିକ୍ସିନୋଲ୍ ପ୍ରୟୋଗକୁ ବିନ୍ୟାସ କରୁଅଛି,
           "- ପରଦା ବ୍ରିଲାଣ୍ଟ ଆପ୍ ସେଟ୍ ଅପ୍": ଭେଲ ବ୍ରିଲାଣ୍ଟ ପ୍ରୟୋଗକୁ ବିନ୍ୟାସ କରୁଅଛି,
           "- ପ୍ରତିଛବି, ଭିଡିଓଗୁଡିକର ସଂରକ୍ଷଣ": ପ୍ରତିଛବି, ଭିଡିଓ ଏବଂ ଅନ୍ୟାନ୍ୟ ଉପାଦାନଗୁଡ଼ିକର ସଂରକ୍ଷଣ,
           "- ରିସେପ୍ସନ୍ ର ସ୍ପିଡ୍": ଡାଟାସେଣ୍ଟର୍ ଠାରୁ ତଥ୍ୟ ଗ୍ରହଣର ଗତି,
           "- ସ୍ପିଡ୍": ଗତି,
           "- ଟର୍ମିନାଟ୍": ସମାପ୍ତ, // t
           "- vpn ଆପଣଙ୍କୁ ପ୍ରବେଶ କରିବାକୁ ଅନୁମତି ଦିଏ": VPN ଆପଣଙ୍କୁ ଏକ ସାଇଟ୍ କିମ୍ବା ଏକ ଅନୁପ୍ରୟୋଗକୁ ପ୍ରବେଶ କରିବାକୁ ଅନୁମତି ଦିଏ ଯାହା ଆପଣଙ୍କର ଇଣ୍ଟରନେଟ୍ ସେବା ପ୍ରଦାନକାରୀ କଳା ତାଲିକାଭୁକ୍ତ କରିଛି,
           "- ସବୁଠୁ ବଡ ଗଛ ଉପରେ ଥିଲା": ସବୁଠୁ ବଡ ଗଛ ସବୁ ସରଳ ଛୋଟ ବିହନ ଉପରେ ଥିଲା,
           "- ପରଦାକୁ ସ୍ପର୍ଶ କରନ୍ତୁ": ଜାରି ରଖିବାକୁ ପରଦାକୁ ସ୍ପର୍ଶ କରନ୍ତୁ,
           "- ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ": ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ!,
           "- ଉପଯୋଗକର୍ତ୍ତା ନାମ": ଉପଯୋଗକର୍ତ୍ତା ନାମ, // u

           "- ଭର୍ଚୁଆଲ୍ ନମ୍ବର": ଭର୍ଚୁଆଲ୍ ନମ୍ବର, // v
           "- ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ସେଟିଂସମୂହ": ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ସେଟିଂସମୂହ,
           "- ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ଭାଷା ପ୍ରୟୋଗ କରାଯାଏ": ଭର୍ଚୁଆଲ୍ ଫୋନ୍ ଭାଷା ଡିଫଲ୍ଟ ଭାବରେ ପ୍ରୟୋଗ ସ୍ତରରେ ପ୍ରୟୋଗ ହୁଏ,
           "- ଭର୍ଚୁଆଲ୍ ଫୋନ୍": ଭର୍ଚୁଆଲ୍ ଫୋନ୍,
           "- ବ id ଧତା": ବ id ଧତା,
           "- izocash ଗ୍ରାହକ ପୋର୍ଟାଲକୁ ସ୍ୱାଗତ": izocash ଗ୍ରାହକ ପୋର୍ଟାଲକୁ ସ୍ୱାଗତ, // w
           "- ଏକ ସୁପର କୋଡ୍ ଲେଖନ୍ତୁ": ଏକ ସୁପର କୋଡ୍ ପ୍ରବେଶ କରନ୍ତୁ,
           "- ସ୍ୱାଗତ": ସ୍ୱାଗତ,
           "- ଯେଉଁଠାରେ ଲୋକଙ୍କ ଧ୍ୟାନ ଯାଏ": ଯେଉଁଠାରେ ଲୋକଙ୍କ ଧ୍ୟାନ ଟଙ୍କା ଯାଏ,
           "- ବିଜେତାମାନେ ସ୍ଥିର ହୁଅନ୍ତି": ବିଜେତାମାନେ ସ୍ଥିର ହୁଅନ୍ତି,
           "- ତୁମେ ତୁମର ଆଲ୍ରାନି ଆକାଉଣ୍ଟରୁ ଲଗ୍ ଆଉଟ୍ କରିବାକୁ ଚାହୁଁଛ": ତୁମେ ତୁମର ଆଲ୍ରାନି ଆକାଉଣ୍ଟରୁ ଲଗ୍ ଆଉଟ୍ କରିବାକୁ ଚାହୁଁଛ କି?,
           "- ହଁ": ହଁ, // y

           // ଦେଶ
           "- କଙ୍ଗୋ": କଙ୍ଗୋ ବ୍ରାଜାଭିଲ୍,
           "- କ୍ୟାମେରନ୍": କାମେରୁନ୍,
           "--drc": DRC,
           "--ivoryCoast": ଆଇଭୋରୀ କୋଷ୍ଟ,

           // ଭାଷା
        "--afrikaans": ଆଫ୍ରିକାନ୍ସ, // a
        "- ଆଲବାନିଆନ୍": ଆଲବାନିଆ,
        "- ଆମହାରିକ୍": ଆମହାରିକ୍,
        "- ଆରାବିକ୍": ଆରବୀ,
        "- ଆର୍ମେନିଆନ୍": ଆର୍ମେନିଆ,
        "--assamese": ଆସାମୀୟ,
        "--aymara": ଆୟମାରା,
        "--azerbaijani": ଆଜେରବାଇଜାନି,
        "- ବମ୍ବରା": ବମ୍ବର, // ବି
        "- ବାସ୍କ": ବାସ୍କ,
        "- ବେଲାରସୀୟ": ବେଲା Belarusian ଷ,
        "- ବେଙ୍ଗଲି": ବଙ୍ଗାଳୀ,
        "- ଭୋଜପୁରୀ": ଭୋଜପୁରୀ,
        "- ବୋସନିଆନ୍": ବୋସନିଆନ୍,
        "- ବୁଲଗେରିଆନ୍": ବୁଲଗେରିଆ,
        "- କାଟାଲାନ୍": କାଟାଲାନ୍, // ଗ
        "--cebuano": Cebuano,
        "- ଚିଚେୱା": ଚିଚେୱା,
        "- ଚାଇନିଜ୍ ସିମ୍ପ୍ଲାଇଡ୍": ଚାଇନିଜ୍ (ସରଳୀକୃତ),
        "- ଚାଇନିଜ୍ ପାରମ୍ପାରିକ": ଚାଇନିଜ୍ (ପାରମ୍ପାରିକ),
        "- କର୍ସିକାନ୍": କର୍ସିକାନ୍,
        "- କ୍ରୋଏଟିଆନ୍": କ୍ରୋଏସିଆନ୍,
        "- ଚେକ୍": ଚେକ,
        "--danish": ଡାନିଶ୍, // d
        "- dhivehi": Dhivehi,
        "- ଡୋଗ୍ରି": ଡୋଗ୍ରି,
        "- ଡଚ୍": ଡଚ୍,
        "- ଇଂରାଜୀ": ଇଂରାଜୀ, // ଇ
        "--esperanto": Esperanto,
        "- ଇଷ୍ଟୋନିଆନ୍": ଇଷ୍ଟୋନିଆନ୍,
        "--ewe": ଇୱେ,
        "- ଫିଲିପିନୋ": ଫିଲିପିନୋ, // f
        "- ଫିନିଶ୍": ଫିନଲ୍ୟାଣ୍ଡ,
        "- ଫ୍ରେଞ୍ଚ": ଫରାସୀ,
        "- ଫ୍ରିଜିଆନ୍": ଫ୍ରିଜିଆନ୍,
        "- ଗାଲିକିଆନ୍": ଗାଲିସିଆନ୍, // g
        "- ଜର୍ଜିଆନ୍": ଜର୍ଜିଆନ୍,
        "- ଜର୍ମାନ": ଜର୍ମାନ,
        "- ଗ୍ରୀକ୍": ଗ୍ରୀକ୍,
        "- ଗୁଆରାନି": ଗୁଆରାନି,
        "- ଗୁଜୁରାଟୀ": ଗୁଜରାଟୀ,
        "--haitianCreole": ହାତିଆ କ୍ରେଓଲ୍, // ଘ
        "- ହାଉସା": ହାଉସା,
        "- ହାୱାଇୟାନ୍": ହାୱାଇନ୍,
        "- ହେବ୍ରୁ": ହିବ୍ରୁ,
        "--hindi": ହିନ୍ଦୀ,
        "- ହମଙ୍ଗ": ହମଙ୍ଗ,
        "- ହୁଙ୍ଗାରିଆନ୍": ହଙ୍ଗେରୀ,
        "--icelandic": ଆଇସଲ୍ୟାଣ୍ଡ୍, // i
        "--igbo": Igbo,
        "--ilocano": ଇଲୋକାନୋ,
        "--indonesian": ଇଣ୍ଡୋନେସିଆ,
        "--irish": ଇଂରେଜ,
        "--italian": ଇଟାଲୀୟ,
        "- ଜାପାନିଜ୍": ଜାପାନିଜ୍, // j
        "- ଜାଭାନୀ": ଯବାନ,
        "- କାନ୍ନାଡା": କନ୍ନଡ, // କେ
        "- କାଜାଖ": କାଜାଖ,
        "- khmer": ଖେମର,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "- କୋରିଆନ୍": କୋରିଆନ୍,
        "- କ୍ରିଓ": କ୍ରିଓ,
        "--kurdishKurmanji": କୁର୍ଦ୍ଦ (କୁରମାନଜୀ),
        "--kurdishSorani": କୁର୍ଦ୍ଦ (ସୋରାନି),
        "--kyrgyz": କିର୍ଗିଜ୍,
        "- ଲାଓ": ଲାଓ, // l
        "- ଲାଟିନ୍": ଲାଟିନ୍,
        "- ଲାଟଭିଆନ୍": ଲାଟଭିଆନ୍,
        "--ଲିଙ୍ଗଲା": ଲିଙ୍ଗଲା,
        "- ଲିଥୁଆନିଆନ୍": ଲିଥୁଆନିଆ,
        "--ଲୁଗାଣ୍ଡା": ଲୁଗାଣ୍ଡା,
        "- ଲକ୍ସେମବର୍ଗ": ଲକ୍ସେମବର୍ଗ,
        "- ମ୍ୟାସେଡୋନିଆନ୍": ମାକେଡୋନିଆନ୍, // ମି
        "--maithili": Maithili,
        "--ମାଲାଗାସୀ": ମାଲାଗାସୀ,
        "--ମାଲେ": ମାଲାୟ,
        "--ମାଲାୟାଲମ୍": ମାଲାୟାଲମ୍,
        "- ମାଲ୍ଟି": ମାଲ୍ଟି,
        "--maori": ମାଧୁରୀ,
        "- ମରାଠୀ": ମରାଠୀ,
        "- ମିଟିଲନ୍ ମାନିପୁରୀ": ମେଟିଲନ୍ (ମଣିପୁରୀ),
        "- ମିଜୋ": ମିଜୋ,
        "- ମୋଙ୍ଗୋଲିଆନ୍": ମଙ୍ଗୋଲିଆ,
        "- ମିଆଁମାର ବର୍ମା": ମିଆଁମାର (ବର୍ମା),
        "- ନେପାଲି": ନେପାଳୀ, // n
        "- ନୋରୱେଗିଆନ୍": ନରୱେ,
        "--odiaOriya": ଓଡିଆ (ଓଡିଆ), // o |
        "- oromo": ଓରୋମୋ,
        "- ପାଶ୍ଟୋ": ପାଶ୍ଟୁ, // p
        "- ପର୍ସିଆନ୍": ପାର୍ସୀ,
        "- ପଲିସ୍": ପୋଲାଣ୍ଡ,
        "--portuguese": ପର୍ତ୍ତୁଗୀଜ୍,
        "- ପୁଞ୍ଜାବୀ": ପଞ୍ଜାବୀ,
        "--quechua": କେଚୁଆ, // q
        "- ରୋମାନିଆନ୍": ରୋମାନିଆନ୍, // r
        "- ରୁଷିଆନ୍": Russian ଷ,
        "- ସାମୋଆନ୍": ସାମୋଆନ୍, // s |
        "- ସଂସ୍କୃତ": ସଂସ୍କୃତ,
        "- ସ୍କଟ୍ସ ଗେଲିକ୍": ସ୍କଟସ୍ ଗେଲିକ୍,
        "- ସେପେଡି": ସେପେଡି,
        "- ସର୍ବିଆନ୍": ସର୍ବିଆନ୍,
        "- ସେସୋଥୋ": ସେସୋଥୋ,
        "- ଶୋନା": ଶୋନା,
        "--sindhi": ସିନ୍ଧି,
        "- ସିନ୍ହାଲା": ସିହ୍ନା,
        "- ସ୍ଲୋଭାକିଆ": ସ୍ଲୋଭାକିଆ,
        "- ସ୍ଲୋଭେନିଆନ୍": ସ୍ଲୋଭେନିଆନ୍,
        "- ସୋମାଲି": ସୋମାଲି,
        "- ସ୍ପାନିସ୍": ସ୍ପାନିସ୍,
        "--sundanese": ସୁନ୍ଦରୀ,
        "--swahili": Swahili,
        "--swedish": ସ୍ୱିଡିଶ୍,
        "- ଟାଜିକ୍": ତାଜିକ୍, // t
        "- ତାମିଲ": ତାମିଲ,
        "--tatar": ଟାଟାର,
        "- ଟେଲୁଗୁ": ତେଲୁଗୁ,
        "- ଥାଇ": ଥାଇ,
        "- ଟିଗ୍ରିନା": ଟିଗ୍ରିନା,
        "- ଟୋଙ୍ଗା": ସୋଙ୍ଗା,
        "- ତୁର୍କୀ": ତୁର୍କୀ,
        "- ତୁର୍କମେନ": ତୁର୍କମେନ,
        "--twi": Twi,
        "--ukrainian": ୟୁକ୍ରେନ, // u
        "- urdu": ଉର୍ଦ୍ଦୁ,
        "--uyghur": ଉଇଗୁର୍,
        "- uzbek": ଉଜବେକିସ୍ତାନ,
        "- ଭିଏତନାମୀ": ଭିଏତନାମ, // v
        "- ୱେଲ୍ସ": ୱେଲ୍ସ, // ୱ
        "- xhosa": ଜୋସା, // x
        "--yiddish": ୟିଦିସ୍, // y
        "- ୟୋରୁବା": ଓଡିଆ,
        "- ଜୁଲୁ": ଜୁଲୁ, // z
        },
      },

      // oromo
      // oromo
      oromo: {
        translations: {
          "--dogongorri uumameera": Dogoggorri uumameera!, //a
           "--teessoo": Teessoowwan, .
           "--gorsa": Gorsa, .
           "--itti fufa cuqaasuun": Itti fufi cuqaasuun akkaawuntii Veil Brillant keessan irraa addaan citu, //b
           "--disconnect jedhu cuqaasuun addaan citu": Disconnect cuqaasuun akkaawuntii izocash keessan irraa addaan citu,
           "--lakkoofsa dhugaa kee ilaali ykn booda irra deebi'ii yaali": Lakkoofsa dhugaa kee ilaali ykn booda irra deebi'ii yaali, //c
           "--lakkoofsa dhugaa kee ilaali": Lakkoofsa dhugaa kee ilaali, .
           "--itti fufa": Itti fufa,
           "---walqabsiisa": Walitti hidhamiinsa, .
           "--wal tumsuu, walsimsiisaa jiraachuu": Wal tumsuu, namoota biroo wajjin walsimsiisuun jiraachuu, .
           "--afaan filadhu": Afaan Bilbilaa Virtual, .
           "--dorgommii hin dhorkin": Dorgommii hin dhorkin, hundaaf carraa kenni, //d
           "--disconnection": Walitti hidhamiinsa addaan kutuu, .
           "--fayyadamtoota bilbila dhugaa hundaaf": Fayyadamtoota Bilbila Maalummaa hundaaf, VPN, //f fayyadamuun ni gorfama
           "--gara fuula seensaa deemi": Gara fuula seensaa deemi, //g
           "--seenaa": Seenaa, //h
           "--ani herrega qaba": Ani duraan herrega qaba, //i
           "--an account hin qabu": Akkaawuntii hin qabu,
           "--mana keeti": mana keeti, .
           "--fakkii / viidiyoo +": Fakkii / Viidiyoo +,
           "--mirkaneessuu eenyummaa": Mirkaneessuu eenyummaa, .
           "--izocash customer portal": Buufata Maamiltootaa izocash, .
           "--waggaa waggaan eenyummaa haaromsuu": Waggaa waggaan eenyummaa haaromsuu, .
           "--izocash bitachuuf": izocash Bituu => izocash idil-addunyaa,
           "--seensi": Galmaa!, //l
           "--seensa": Galmee, .
           "--gogin to veil brilliant": Veil Brillant waliin wal qunnamsiisaa,
           "--gara mana kuusaa vixinol seena": Kuusaa Vixinol waliin wal qunnamsiisaa, .
           "--akkaawuntii veil Brillant keessanitti bilisaan seena": Amala kana argachuuf bilisaan akkaawuntii Veil Brillant keessanitti seena,
           "--milkaa'ina seensaa": Galmee milkaa'eera!,
           "--amma seeni": Amma seeni!,
           "--milkaa'ina ba'uu": Milkaa'ina ba'uu!,
           "--ba'i": Ba'i, .
           "--logout": Ba'i, .
           "--lakkoofsa": Lakkoofsa, //n
           "--maqaa": Maqaa, .
           "--amma seena": Amma, Galmaa!,
           "--dorgommii ukkaamsuu dhorkuu hin jiru":
           "--hinaaffaa hin qabu, jibba hin qabu": Inaaffaa hin qabu, jibba hin qabu, qoqqoodinsi hin qabu,
           "--lakki": Lakki, .
           "--teessoowwan ofiisaa bilbila dhugaa keessan argachuuf": Teessoowwan ofiisaa bilbila dhugaa keessan argachuuf, //o
           "--password": Jecha icciitii, //fuula
           "--qabxii baasuu izocash": Qabxii baasuu izocash, .
           "--qabxii baasuu": Qabxii baasuu, .
           "-- filatamaadha, vpn fayyadami": Filatamaa ta'e, VPN kan dhiyeessaa tajaajila interneetii keessanii hin taane fayyadami,
           "--cibbaan yeroo hunda bu'aa qaba": Ciminaan yeroo hunda dhuma irratti bu'aa qaba, .
           "--seera": Seerota, //r
           "--yaada": Yaada, .
           "--galmee": Galmee, .
           "--mallatteessitee veil brilliant": Veil Brillant irratti galmaa'i, //s
           "--signup to vixinol store": Mana daldalaa Vixinol irratti galmaa'aa,
           "--mallatteessuu": Galmaa'i, .
           "--milkaa'ina galmaa'uu": Galmeen milkaa'eera!,
           "--bilisaan galmaa'aa": Bilisaa galmaa'aa,
           “--milkaa’ina galmee IA”: Walitti hidhamiinsi milkaa’e”,
           "--sajoo": "Qajeelfama", .
           "--appii alrani saaguu": Appilikeeshinii Alrani qindeessuu, .
           "--appii izocash saaguu": Appilikeeshinii izocash qindeessuu, .
           "--appii vixinol saaguu": Appilikeeshinii Vixinol qindeessuu, .
           "--appii Veil Brillant saaguu": Appilikeeshinii Veil Brillant qindeessuu, .
           "--kuusaa fakkiiwwan, viidiyoo": Kuusaa fakkiiwwan, viidiyoo fi qaamolee biroo hedduu, .
           "--speed of reception": Saffisa fudhachuu deetaa Datacenter irraa, .
           "--saffisa": Saffisa, .
           "--terminate": Xumura, //t
           "--vpn akka argattan isin dandeessisa": VPNn marsariitii ykn application tajaajila interneetii keessan tarree gurraacha keessa galche akka argattan isin dandeessisa,
           "--mukti guddaan gubbaa ture": Mukti guddaan hunda caalaa sanyii xiqqoo salphaa ture, .
           "--iskiriinii tuqi": Itti fufuuf iskiriinii tuqi, .
           "--ammas yaali": Irra deebi'ii yaali!,
           "--maqaa fayyadamaa": Maqaa fayyadamaa, //u

           "--lakkoofsa dhugaa": Lakkoofsa dhugaa, //v
           "--sajoo bilbila dhugaa": Sajoo bilbila dhugaa, .
           "--afaan Bilbilaa dhugaa hojiirra oola": Afaan Bilbila Maalummaa sadarkaa application irratti durtiidhaan hojiirra oola, .
           "--bilbila dhugaa": Bilbila dhugaa, .
           "--mirkaneessi": Mirkaneessi, .
           "--baga gara poortala maamiltoota izocash dhuftan": Baga gara poortala maamiltoota izocash dhuftan, //w
           "--koodii ol'aanaa barreessi": Koodii Ol'aanaa galchi, .
           "--baga nagaan dhufte": Baga nagaan gara,
           "--bakka xiyyeeffannaan namootaa deemu": Bakka xiyyeeffannaan namootaa deemu qarshiin, .
           "--mo'attoonni cichan": Mo'attoonni cichan, .
           "--akkaawuntii Alrani keessan keessaa bahuu barbaadduu": Akkaawuntii Alrani keessan keessaa bahuu barbaadduu?,
           "--eeyyee": Eeyyee, //y

           // biyya
           "--koongoo": Koongoo Biraazaaviil,
           "--kaameeruun": Kaameeruun,
           "--drc": DRC, 2019.
           "--ivoryCoast": Koost Gaanfa, 2019.

           // afaan
        "--afrikaans": Afaan Afrikaa, //a
        "--albaaniyaa": Albaaniyaa, .
        "--amaaraa": Afaan Amaaraa, .
        "--arabii": Afaan Arabaa, .
        "--armeeniyaa": Armeeniyaa, .
        "--assamese": Afaan Assamese, .
        "--aymara": Aymara, .
        "--azarbaajaan": Afaan Azarbaajaan, .
        "--bambara": Bambara, //b
        "--basque": Baaskii, .
        "--beelaaruus": Beelaaruus, .
        "--bengali": Afaan Bengali, .
        "--bhojpuri": Afaan Oromoo, .
        "--bosnian": Afaan Bosniyaa, .
        "--bulgarian": Afaan Bulgaariyaa, .
        "--kaatalaan": Afaan Kaataaloon, //c
        "--cebuano": Seebuano, 1999.
        "--chichewa": Chichewa, 1999.
        "--chineseSalphaa": Chaayinaa (Salphaa), .
        "--chineseAadaa": Chaayinaa (Aadaa), .
        "--korsikaan": Korsikaan, .
        "--kirooshiyaa": Kirooshiyaa, .
        "--cheek": Cheek, .
        "--danish": Deenmaark, //d
        "--dhivehi": Dhivehi, .
        "--dogri": Afaan Oromoo, .
        "--dutch": Dutch, .
        "--afaanoromoo": Afaan Oromoo, //e
        "--esperaantoo": Ispeeraantoo, .
        "--estonian": Afaan Istooniyaa, .
        "--hoolaa": Hoolaa, .
        "--filipino": Afaan Filiippiinsii, //f
        "--finfinnee": Finfinnee, .
        "--faranjii": Faransaayii, .
        "--frisian": Afaan Firishiyaan, .
        "--galician": Afaan Galishiyaa, //g
        "--joorjiyaa": Joorjiyaa, .
        "--jarmanii": Jarmanii, .
        "--griikii": Giriikii, .
        "--guarani": Guaranii, .
        "--gujarati": Afaan Gujii, .
        "--haitianCreole": Kiriyoolii Heeyitii, //h
        "--hausa": Haawusaa, .
        "--hawaayii": Hawaayi, .
        "--ibiroota": Afaan Ibrootaa, .
        "--hindi": Afaan Oromoo, .
        "--hmong": Hmong, .
        "--haangaarii": Haangaarii, .
        "--aayislaandi": Afaan Aayislaandi, //i
        "--igbo": Igbo, .
        "--ilocano": Afaan Oromoo, .
        "--indooneeshiyaa": Indooneezhiyaa, .
        "--irish": Afaan Aayilaandi, .
        "--xaaliyaanii": Xaaliyaanii, .
        "--jaappaan": Jaappaan, //j
        "--javanese": Afaan Jaavaa, .
        "--kannada": Afaan Oromoo, //k
        "--kaazaak": Kaazaak, .
        "--khmer": Khmer, .
        "--kinyarwanda": Kinyarwanda, 2019.
        "--konkani": Afaan Oromoo, .
        "--kooriyaa": Kooriyaa, .
        "--krio": Krio, .
        "--kurdishKurmanji": Afaan Oromoo (Kurmanji), .
        "--kurdishSorani": Afaan Oromoo (Soraanii), .
        "--kyrgyz": Kirgistaan, .
        "--lao": Laa'oo, //l
        "--laatiin": Laatiin, .
        "--laatviyaa": Laatviyaa, .
        "--lingaalaa": Afaan Liingaalaa, .
        "--lithuanian": Afaan Lituwaaniyaa, .
        "--luganda": Afaan Oromoo, .
        "--luxembourgish": Afaan Luxembourgish, .
        "--maqedooniyaa": Maqedooniyaa, //m
        "--maithili": Afaan Oromoo, .
        "--malagasy": Malagasy, .
        "--malay": Maalaay, .
        "--malayaalam": Afaan Malayaalam, .
        "--maltese": Afaan Maaltaa, .
        "--maori": Maa'oorii, .
        "--marathi": Afaan Maraatii, .
        "--meiteilonManipuri": Meiteilon (Manipuri), .
        "--mizo": Afaan Oromoo, .
        "--mongolian": Afaan Moongooliyaa, .
        "--myanmarBurmase": Miyanmaar (Afaan Burma), .
        "--nepali": Afaan Neepaal, //n
        "--norwegian": Afaan Noorweey, .
        "--odiaOriyaa": Odiyaa (Oriyaa), //o
        "--oromo": Oromoo, .
        "--pashto": Paashtoo, //fuula
        "--faarsi": Faarsii, .
        "--polish": Poolaandi, .
        "--poortugaal": Afaan Poortugaal, .
        "--punjabi": Afaan Punjaabi, .
        "--quechua": Afaan Qubee, //q
        "--romanian": Afaan Roomaa, //r
        "--raashiyaa": Raashiyaa, .
        "--samoan": Samoan, //s
        "--sanskrit": Afaan Sanskrit, .
        "--scotsGaelic": Afaan Iskootilaandi, .
        "--sepedi": Afaan Oromoo, .
        "--saarbiyaa": Afaan Sarbiyaa, .
        "--sesotho": Afaan Oromoo, .
        "--shona": Shona, .
        "--sindhi": Siindii, .
        "--sinhala": Afaan Siinhalaa, .
        "--slovak": Isloovaak, .
        "--slovenian": Afaan Islooveeniya, .
        "--somaalee": Afaan Somaalee, .
        "--ispeen": Ispeen, .
        "--sundanese": Afaan Sundaan, .
        "--swahili": Afaan Swahili, .
        "--swedish": Afaan Siwiidin, .
        "--tajik": Tajik, //t
        "--tamil": Taamill, .
        "--tatar": Taataar, .
        "--telugu": Afaan Oromoo, .
        "--thai": Afaan Taayilaandi, .
        "--tigrinya": Afaan Oromoo, .
        "--tsonga": Afaan Oromoo, .
        "--turkii": Turkii, .
        "--turkmen": Turkmen, .
        "--twi": Twi, 2019.
        "--yukireen": Yukireen, //u
        "--urdu": Afaan Urduu, .
        "--uyghur": Uyghur, .
        "--uzbeek": Uzbeek, .
        "--vieetnamese": Veetnaam, //v
        "--welsh": Weels, //w
        "--xhosa": Afaan Oromoo, //x
        "--yiddish": Afaan Yiddishii, //y
        "--yoruba": Afaan Yorubaa, .
        "--zulu": Zuluu, //z
        },
      },

      // pashto
      // pashto
      pashto: {
        translations: {
          "-- يوه تېروتنه رامنځته شوې": يوه تېروتنه رامنځته شوې ده!, //a
          "--address": پته،
          "--advice": مشوره،
          "- په دوام باندې کلیک کولو سره": په دوام کلیک کولو سره به تاسو د خپل وییل بریلنټ حساب څخه وصل شئ، //b
          "- په منحل کولو کلیک کولو سره تاسو به منحل شئ": په منحل کولو کلیک کولو سره به تاسو د خپل izocash حساب څخه وصل شئ،
          "--خپل مجازی شمیره وګورئ یا وروسته بیا هڅه وکړئ": خپل مجازی شمیره وګورئ یا وروسته بیا هڅه وکړئ، //c
          "-خپل مجازی شمیره وګورئ": خپل مجازی شمیره وګورئ،
          "-- دوام": ادامه ورکړئ،
          "--connection": پیوستون،
          "- همکاري کول، په هماهنګۍ کې ژوند کول": همکاري کول، د نورو سره په همغږۍ کې ژوند کول،
          "--choose language": د تلیفون مجازی ژبه،
          "- د سیالۍ مخنیوی مه کوئ": د سیالۍ مخنیوی مه کوئ، ټولو ته فرصت ورکړئ، //d
          "--disconnection": قطع کول،
          "--د ټولو مجازی تلیفون کاروونکو لپاره": د ټولو مجازی تلیفون کاروونکو لپاره، د VPN کارولو سپارښتنه کیږي، //f
          "-د ننوتلو پاڼې ته لاړ شئ": د ننوتلو پاڼې ته لاړ شئ، //g
          "--historical": تاریخي، //h
          "--زه حساب لرم": زه دمخه یو حساب لرم، //i
          "--زه حساب نه لرم": زه حساب نه لرم،
          "- دا ستاسو کور دی": دا ستاسو کور دی،
          "--image/video +": انځور / ویډیو +,
          "--identity verification": د هویت تصدیق،
          "--izocash customer portal": izocash پیرودونکي پورټل،
          "--پېژندنه هر کال تازه کول": هر کال د هویت تازه کول،
          "--izocash buy to": izocash Buy => izocash نړیوال،
          "--لاګ ان": ننوتل!، //l
          "--login": ننوتل،
          "--لاګ ان د veil brillant": د وییل بریلینټ سره وصل کړئ،
          "--د ویکسینول پلورنځي ته ننوتل": د ویکسینول پلورنځي سره وصل شئ،
          "-د خپل وییل بریلینټ اکاونټ ته وړیا ننوتل": دې خصوصیت ته د لاسرسي لپاره خپل وییل بریلینټ حساب ته وړیا ننوتل،
          "--login success": ننوت بریالی شو!,
          "--login now": همدا اوس ننوتل!,
          "--logout success": ننوت بریالی!,
          "--log out": ننوت،
          "--logout": ننوتل،
          "--number": شمېره، //n
          "--نوم": نوم،
          "--اوس ننوتل": اوس، ننوتل!,
          "- د سیالۍ په ټکولو بندیز نشته":
          "-نه حسد، نه نفرت": نه حسد، نه نفرت، نه ویش،
          "--نه نه،
          "--رسمي پته ستاسو مجازی تلیفون ته د لاسرسي لپاره": ستاسو مجازی تلیفون ته د لاسرسي لپاره رسمي پتې، //o
          "--password": پټنوم، //p
          "--پوائنټ ایستل izocash": د پوائنټونو ایستل izocash،
          "--پوائنټ ایستل": د پوائنټونو ایستل،
          "--preferably, use a vpn": په غوره توګه، یو VPN وکاروئ چې ستاسو د انټرنیټ خدمت چمتو کونکي پورې اړه نلري،
          "- استقامت تل تاوان ورکوي": دوام تل په پای کې تاوان ورکوي،
          "--rule": قواعد، //r
          "--recommendation": سپارښتنې،
          "--registration": نوم لیکنه،
          "--Signup to veil brillant": راجستر په Veil Brillant، //s
          "--د ویکسینول پلورنځي ته لاسلیک کول": په ویکسینول پلورنځي کې راجستر کړئ،
          "--signup": راجستر،
          "--signup success": نوم لیکنه بریالۍ شوه!,
          "--signup for free": وړیا نوم لیکنه وکړئ،
          "--د لاسلیک بریالیتوب IA": پیوستون بریالی شو،
          "--settings": "تنظیمونه",
          "--د الراني اپلیکیشن تنظیمول": د الراني اپلیکیشن ترتیبول،
          "--د izocash اپلیکیشن تنظیم کول": د izocash غوښتنلیک تنظیمول،
          "--د ویکسینول اپلیکیشن تنظیم کول": د ویکسینول غوښتنلیک تنظیم کول،
          "-د پرده برلینټ اپلیکیشن تنظیم کول": د وییل بریلنټ غوښتنلیک تنظیم کول،
          "--د انځورونو، ویډیوګانو ذخیره": د انځورونو، ویډیوګانو او څو نورو عناصرو ذخیره کول،
          "-د استقبال سرعت": د ډیټا سینټر څخه د معلوماتو ترلاسه کولو سرعت،
          "--سعت": سرعت،
          "--terminate": ختمول، //t
          "--vpn تاسو ته د لاسرسي اجازه درکوي": VPN تاسو ته اجازه درکوي یو سایټ یا غوښتنلیک ته لاسرسی ومومئ چې ستاسو د انټرنیټ خدمت چمتو کونکي تور لیست کړی وي،
          "- تر ټولو لویه ونه پورته وه": ترټولو لویه ونه د ساده کوچني تخم څخه پورته وه،
          "--سکرین ته ټچ": د دوام لپاره سکرین ته لاس ورکړئ،
          "--try again": بیا هڅه وکړئ!,
          "--username": کارن نوم، //u

          "--virtual number": مجازی شمیره، //v
           "--virtual phone settings": د مجازی تلیفون ترتیبات،
           "--مجازی تلیفون ژبه کارول کیږي": د مجازی تلیفون ژبه په ډیفالټ ډول د غوښتنلیک په کچه پلي کیږي ،
           "--virtual phone": مجازی تلیفون،
           "--validate": تاییدول،
           "--د izocash پیرودونکي پورټل ته ښه راغلاست": د izocash پیرودونکي پورټل ته ښه راغلاست، //w
           "--سوپر کوډ ولیکئ": سوپر کوډ دننه کړئ،
           "-- ښه راغلاست": ښه راغلاست،
           "- د خلکو پام چیرته ځي": چیرته چې د خلکو پام وي پیسې ځي،
           "-ګټونکي صبر کوي": ګټونکي صبر کوي،
           "--Would you want to log out your Alrani Account": ایا ته غواړې د خپل Alrani اکاونټ څخه لاګ آوټ شې؟,
           "--هو": هو، //y

           // هیواد
           "--congo": کانګو برازاویل،
           "--cameroon": کامرون،
           "--drc": DRC,
           "--ivoryCoast": د عاج ساحل،

           // ژبه
        "--afrikaans": افریقیان، //a
        "--albanian": البانیایی,
        "--amharic": اماریک،
        "--عربي": عربي،
        "--armenian": ارمني،
        "--assamese": آسامی،
        "--aymara": ایمارا،
        "--azerbaijani": اذربایجان،
        "--بامبارا": بامبارا، //ب
        "--basque": باسکی،
        "--belarusian": بیلاروس،
        "-بنګالی": بنګالی,
        "--bhojpuri": بھوجپوري،
        "--bosnian": بوسنیايي,
        "--بلغاریان": بلغاریایی,
        "--catalan": کتلان، //c
        "--cebuano": Cebuano,
        "--chichewa": چیچیوا،
        "--chineseSimplified": چینایي (ساده)،
        "--chineseTraditional": چینایي (دودیز)،
        "--corsican": Corsican,
        "--croatian": کروشین،
        "--czech": چک،
        "--danish": ډنمارکي، //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "-- هالنډي": هالنډي,
        "--انګلیسي": انګلیسي، //e
        "--esperanto": اسپرانتو,
        "--استونیا": استونیا،
        "--ewe": Ewe,
        "--filipino": فیلیپین، //f
        "--finnish": فنلنډي,
        "--french": فرانسوي,
        "--frisian": Frisian,
        "--galician": ګالیشین، //g
        "--georgian": جورجیا،
        "--german": الماني،
        "--greek": یوناني،
        "--guarani": ګاراني،
        "--gujarati": ګجراتي,
        "--haitianCreole": هایټان کریول، //h
        "--hausa": هوسا،
        "--hawaiian": Hawaiian,
        "--hebrew": عبراني،
        "--hindi": هندي,
        "--hmong": Hmong,
        "--hungarian": هنګري،
        "--icelandic": آیسلنډي، //i
        "--igbo": ایګبو،
        "--ilocano": Ilocano,
        "--indonesian": اندونیزیا,
        "--irish": آیرش،
        "--italian": ایټالوی،
        "--japanese": جاپاني، //j
        "--javanese": جاویاني،
        "--kannada": کناډا، //k
        "--kazakh": قزاق،
        "--khmer": خمیر،
        "--kinyarwanda": کینیاروندا،
        "--konkani": کونکني،
        "--korean": کوریایی,
        "--krio": کریو،
        "--kurdishKurmanji": کرد (کرمانجي)،
        "--kurdishSorani": کرد (سوراني)،
        "--kyrgyz": قرغز،
        "--lao": لاو، //l
        "--latin": لاتین،
        "--latvian": لیتوین،
        "--lingala": لینګا،
        "--lithuanian": لیتوانیا،
        "--luganda": لوګنډا،
        "--luxembourgish": Luxembourgish,
        "--macedonian": مقدونیايي، //m
        "--maithili": میتیلي،
        "--malagasy": ملاګاسي,
        "--malay": Malay,
        "--malayalam": ملیالم،
        "-- مالټي": مالټيز,
        "--maori": ماوري،
        "--marathi": مراټي،
        "--meiteilonManipuri": Meiteilon (Manipuri)،
        "--mizo": Mizo,
        "--mongolian": منګولیا،
        "--myanmarBurmese": میانمار (برمی)،
        "--nepali": نیپالی، //n
        "--norwegian": نارویژی،
        "--odiaOriya": اوډیا (اوریا)، //o
        "--oromo": اورومو،
        "--pashto": پښتو، //p
        "--persian": فارسي،
        "--polish": پولنډي,
        "--portuguese": پرتګالي،
        "--punjabi": پنجابی,
        "--quechua": کویچوا، //q
        "--رومانویان": رومانیا، //r
        "--روسی": روسی,
        "--samoan": سامون، //s
        "--sanskrit": سنسکرت،
        "--scotsGaelic": سکاټ ګیلیک،
        "--sepedi": Sepedi,
        "--serbian": سربي،
        "--sesotho": سیسوتو،
        "--shona": شونا،
        "--sindhi": سندهي،
        "--sinhala": Sinhala,
        "--slovak": سلواک،
        "--slovenian": سلووینیا,
        "--somali": صومالی،
        "--spanish": هسپانوي,
        "--sundanese": سنډانیز،
        "--swahili": سواهیلی,
        "--swedish": سویډني,
        "--tajik": تاجک، //t
        "--tamil": تامل،
        "--تاتار": تاتار،
        "--telugu": تیلوګو,
        "--thai": تای،
        "--tigrinya": Tigrinya,
        "--tsonga": سونګا،
        "--ترکی": ترکي،
        "--ترکمن": ترکمن،
        "--twi": دوه،
        "--ukrainian": اوکراین، //u
        "--urdu": اردو،
        "--اویغور": اویغور،
        "--uzbek": ازبک،
        "--vietnamese": ویتنامی، //v
        "--welsh": ویلش، // w
        "--xhosa": ژوسا، //x
        "--yiddish": یدش، //y
        "--yoruba": یوروبا،
        "--zulu": زولو، //z
        },
      },

      // persian
      // persian
      persian: {
        translations: {
          "--an error has happend": یک خطا رخ داده است!، //a
           "--address": آدرس ها،
           «--مشاوره»: نصیحت،
           "--با کلیک بر روی ادامه": با کلیک بر روی ادامه، ارتباط شما با حساب Veil Brillant خود قطع می شود، //b
           "--با کلیک بر روی قطع ارتباط شما قطع خواهد شد": با کلیک بر روی قطع ارتباط از حساب izocash خود جدا می شوید.
           "--check your virtual number or try again later": شماره مجازی خود را بررسی کنید یا بعداً دوباره امتحان کنید، //c
           "--check your virtual number": شماره مجازی خود را بررسی کنید،
           "--continue": ادامه،
           «--connection»: اتصال،
           "--collaborate, live in harmony": همکاری کنید، در هماهنگی با دیگران زندگی کنید،
           "--انتخاب زبان": زبان تلفن مجازی،
           «--موافقت نکن رقابت»: از رقابت جلوگیری نکن، به همه فرصت بده، //د
           «--قطع»: قطع،
           "--برای همه کاربران تلفن مجازی": برای همه کاربران تلفن مجازی، توصیه می شود از VPN استفاده کنند، //f
           "--go to login page": به صفحه ورود، //g بروید
           «--تاریخی»: تاریخی، //h
           "--i have account": من قبلا یک حساب دارم، //i
           "--i don't have account": من حسابی ندارم،
           «- آن خانه توست»: خانه توست،
           "--تصویر / ویدئو +": تصویر / ویدئو +،
           «--تأیید هویت»: تأیید هویت،
           "--izocash مشتری پورتال": izocash مشتری پورتال،
           "--شناسه به روز رسانی هر سال": به روز رسانی هویت هر سال،
           "--izocash buy to": izocash Buy => izocash international,
           "--log in": وارد شوید!، //l
           "--login": ورود به سیستم،
           "--login to veil brilliant": به Veil Brillant متصل شوید،
           "--ورود به فروشگاه vixinol": به فروشگاه Vixinol متصل شوید،
           "--ورود رایگان به حساب Veil Brillant خود": برای دسترسی به این ویژگی به صورت رایگان به حساب Veil Brillant خود وارد شوید.
           "--login success": ورود با موفقیت!،
           "--login now": اکنون وارد شوید!،
           "--logout موفقیت": خروج موفقیت آمیز!،
           "--log out": خروج،
           "--logout": خروج از سیستم،
           "--number": شماره، //n
           "--name": نام،
           "--now log in": اکنون، وارد شوید!،
           "--بدون ممنوعیت برای خفه کردن رقابت":
           «- لا حسد، لا بغض»: نه حسد، نه بغض، نه تفرقه،
           "--نه نه،
           "--آدرس های رسمی برای دسترسی به تلفن مجازی": آدرس های رسمی برای دسترسی به تلفن مجازی شما، //o
           "--password": رمز عبور، //p
           "--points removes izocash": Points Detrawals izocash,
           "--امتیاز برداشت": برداشت امتیاز،
           "-- ترجیحاً از vpn استفاده کنید": ترجیحاً از VPN استفاده کنید که به ارائه دهنده خدمات اینترنت شما تعلق ندارد،
           "---------------------------------------------------------------------------------------------------------------------------------------------------------------------'
           "--rule": قوانین، //r
           "--توصیه": توصیه ها،
           «--ثبت»: ثبت نام،
           "--signup to veil brilliant": ثبت نام در Veil Brillant, //s
           "--ثبت نام در فروشگاه vixinol": ثبت نام در فروشگاه Vixinol،
           "--signup": ثبت نام،
           "--موفقیت ثبت نام": ثبت نام با موفقیت انجام شد!،
           "--ثبت نام رایگان": ثبت نام رایگان،
           «--موفقیت ثبت نام IA»: اتصال موفقیت آمیز»
           "--settings": "تنظیمات"،
           "--تنظیم برنامه alrani": پیکربندی برنامه Alrani،
           "--تنظیم برنامه izocash": پیکربندی برنامه izocash،
           "--تنظیم برنامه ویکسینول": پیکربندی برنامه ویکسینول،
           "--تنظیم برنامه Veil Brillant": پیکربندی برنامه Veil Brillant،
           «--ذخیره‌سازی تصاویر، ویدیوها»: ذخیره‌سازی تصاویر، ویدیوها و چندین عنصر دیگر،
           "--speed of reception": سرعت دریافت داده ها از Datacenter،
           «--سرعت»: سرعت،
           «--terminate»: خاتمه دادن، //t
           "-- vpn به شما امکان می دهد به آن دسترسی پیدا کنید": VPN به شما امکان می دهد به سایت یا برنامه ای دسترسی داشته باشید که ارائه دهنده خدمات اینترنتی شما در لیست سیاه قرار داده است.
           "-- بزرگترین درخت بالا بود": بزرگترین درخت بیش از همه یک دانه کوچک ساده بود.
           "--touch the screen": برای ادامه صفحه را لمس کنید،
           "--try again": دوباره امتحان کن!،
           "--username": نام کاربری، //u

           "--virtual number": شماره مجازی، //v
           "--Virtual phone settings": تنظیمات تلفن مجازی،
           "--تلفن مجازی زبان اعمال می شود": زبان تلفن مجازی به طور پیش فرض در سطح برنامه اعمال می شود.
           "--تلفن مجازی": تلفن مجازی،
           «--validate»: اعتبارسنجی،
           "--به پورتال مشتری izocash خوش آمدید": به پورتال مشتری izocash خوش آمدید، //w
           "--write a super code": یک کد فوق العاده را وارد کنید،
           "--welcome to": خوش آمدید،
           «-- آنجا که توجه مردم می رود»: آنجا که توجه مردم می رود پول می رود،
           «-- برنده ها استقامت می کنند»: برنده ها استقامت می کنند،
           "--wid you like to log out of your Alrani account": آیا می خواهید از حساب Alrani خود خارج شوید؟
           "--yes": بله، //y

           // کشور
           "--congo": کنگو برازاویل،
           «--کامرون»: کامرون،
           "--drc": DRC،
           "--Ivory Coast": ساحل عاج،

           // زبان
        "-- afrikaans": آفریقایی، //a
        "--albanian": آلبانیایی،
        «--امهری»: آمهری،
        «--عربی»: عربی،
        «--ارمنی»: ارمنی،
        «--assamese»: آسامی،
        «--ایماره»: آیمارا،
        «--آذربایجانی»: آذربایجانی،
        «--بامبارا»: بامبارا، //ب
        "--basque": باسکی،
        «--belarusian»: بلاروسی،
        «--بنگالی»: بنگالی،
        «--بوجپوری»: بهجپوری،
        «--بوسنیایی»: بوسنیایی،
        «--بلغاری»: بلغاری،
        «--کاتالان»: کاتالان، //ج
        «--cebuano»: سبوانو،
        «--چیچوا»: چیچوا،
        "--chineseSimplified": چینی (ساده شده)،
        "--chineseTraditional": چینی (سنتی)،
        «--corsican»: کورسی،
        "--croatian": کرواتی،
        "--czech": چک،
        «--دانش»: دانمارکی، //د
        « ـ دیوهی»: دیوهی،
        «--دوگری»: دوگری،
        «-- هلندی»: هلندی،
        «--انگلیسی»: انگلیسی، //e
        "--esperanto": اسپرانتو،
        «--استونی»: استونیایی،
        «-- میش»: میش،
        «--filipino»: فیلیپینی، //f
        "--finnish": فنلاندی،
        «--french»: فرانسوی،
        «--frisian»: فریزی،
        «--گالیسی»: گالیسی، //g
        "--گرجی": گرجی،
        «--آلمانی»: آلمانی،
        "--greek": یونانی،
        «--گوارانی»: گوارانی،
        «--گجراتی»: گجراتی،
        «--haitianCreole»: کریول هائیتی، //h
        «--hausa»: هاوسا،
        «--hawaiian»: هاوایی،
        «--عبری»: عبری،
        «--هندی»: هندی،
        "--hmong": همونگ،
        «--مجارستانی»: مجارستانی،
        «--ایسلندی»: ایسلندی، //i
        «--ایگبو»: ایگبو،
        «--ilocano»: ایلوکانو،
        «-- اندونزیایی»: اندونزیایی،
        «--irish»: ایرلندی،
        «--ایتالیایی»: ایتالیایی،
        «--ژاپنی»: ژاپنی، //j
        «--جاوانی»: جاوه ای،
        «--کانادا»: کانادا، //k
        «--قزاق»: قزاق،
        «--khmer»: خمر،
        «--kinyarwanda»: کینیارواندا،
        «--کنکانی»: کنکانی،
        "--korean": کره ای،
        «--krio»: کریو،
        «--kurdishKurmanji»: کردی (کرمانجی)،
        «--kurdishSorani»: کردی (سورانی)،
        «--قرقیز»: قرقیز،
        «--لائو»: لائو، //ل
        «--لاتین»: لاتین،
        «--لتونیایی»: لتونیایی،
        «--لینگالا»: لینگالا،
        «--لیتوانیایی»: لیتوانیایی،
        «--لوگاندا»: لوگاندا،
        "--لوکزامبورگی": لوگزامبورگی،
        «--مقدونی»: مقدونی، //م
        «--maithili»: مایتیلی،
        «--مالاگاسی»: مالاگاسی،
        «--مالای»: مالایی،
        «--مالایلام»: مالایالام،
        «--مالتی»: مالتی،
        "--maori": مائوری،
        «--marathi»: مراتی،
        «--meiteilonManipuri»: Meiteilon (مانیپوری)،
        «--mizo»: میزو،
        «-- مغولی»: مغولی،
        «--myanmarBurmese»: میانمار (برمه)،
        «--nepali»: نپالی، //n
        «--نروژی»: نروژی،
        «--odiaOriya»: اودیا (اوریا)، //o
        «--oromo»: اورومو،
        «--پشتو»: پشتو، //ص
        «--فارسی»: فارسی،
        «--پلیش»: لهستانی،
        «--پرتغالی»: پرتغالی،
        «--پنجابی»: پنجابی،
        «--quechua»: کچوا، //q
        «--رومانیایی»: رومانیایی، //ر
        «--روسی»: روسی،
        «--ساموئن»: ساموئن، //س
        «--سانسکریت»: سانسکریت،
        "--scotsGaelic": گالیک اسکاتلندی،
        «-- sepedi»: سپدی،
        "--صربی": صربی،
        «--sesotho»: سسوتو،
        «--شونا»: شونا،
        « ـ ـ سندی»: سندی،
        « ـ سینهاله»: سینهالی،
        "--slovak": اسلواکی،
        «--اسلوونیایی»: اسلوونیایی،
        «--سومالی»: سومالیایی،
        «--اسپانیایی»: اسپانیایی،
        «--sundanese»: سوندانی،
        "--swahili": سواحیلی،
        «--سوئدی»: سوئدی،
        «--تاجیک»: تاجیک، //ت
        «--tamil»: تامیلی،
        «-- تاتار»: تاتاری،
        «--تلوگو»: تلوگو،
        «-- تای»: تایلندی،
        «--تیگرینا»: تیگرینیا،
        «--tsonga»: سونگا،
        «-- ترکی»: ترکی،
        «--ترکمن»: ترکمن،
        «--twi»: توئی،
        «--اوکراینی»: اوکراینی، //u
        «--urdu»: اردو،
        «-- اویغور»: اویغور،
        «--ازبک»: ازبکی،
        "--ویتنام": ویتنامی، //v
        «--ولش»: ولش، //و
        «--xhosa»: Xhosa، //x
        «--yiddish»: ییدیش، //y
        «--yoruba»: یوروبا،
        «--زولو»: زولو، //ز
        },
      },

      // polish
      // polish
      polish: {
        translations: {
          „--wystąpił błąd”: Wystąpił błąd!, //a
           „--adres”: adresy,
           „--advice”: rada,
           „--klikając Kontynuuj”: Klikając Kontynuuj, nastąpi rozłączenie z kontem Veil Brillant, //b
           "--klikając na rozłącz zostaniesz rozłączony": Klikając na Rozłącz zostaniesz rozłączony ze swoim kontem izocash,
           „--sprawdź swój numer wirtualny lub spróbuj ponownie później”: Sprawdź swój numer wirtualny lub spróbuj ponownie później, //c
           „--sprawdź swój numer wirtualny”: Sprawdź swój numer wirtualny,
           „--continue”: Kontynuuj,
           „--połączenie”: połączenie,
           „--współpracuj, żyj w harmonii”: Współpracuj, żyj w harmonii z innymi,
           „--wybierz język”: Język wirtualnego telefonu,
           „--nie zapobiegaj konkurencji”: nie zapobiegaj konkurencji, daj każdemu szansę, //d
           „--disconnection”: rozłączenie,
           „--dla wszystkich użytkowników telefonów wirtualnych”: Wszystkim użytkownikom telefonów wirtualnych zaleca się korzystanie z VPN, //f
           „--go to login page”: Przejdź do strony logowania, //g
           "--historical": Historyczny, //godz
           „--mam konto”: mam już konto, //i
           „--nie mam konta”: nie mam konta,
           „-to jest twój dom”: to jest twój dom,
           „--obraz / wideo +”: Obraz / wideo +,
           „--weryfikacja tożsamości”: weryfikacja tożsamości,
           „--portal klienta izocash”: Portal klienta izocash,
           „--identity update co roku”: Aktualizacja tożsamości co roku,
           "--izocash kup w": izocash Kup => izocash międzynarodowy,
           "--log in": Zaloguj się!, //l
           „--login”: zaloguj się,
           „--login to veil brillant”: Połącz się z Veil Brillant,
           „--login to vixinol store”: Połącz się ze sklepem Vixinol,
           „--zaloguj się bezpłatnie do swojego konta Veil Brillant”: Zaloguj się bezpłatnie do swojego konta Veil Brillant, aby uzyskać dostęp do tej funkcji,
           "--login Success": Logowanie powiodło się!,
           "--login now": Zaloguj się teraz!,
           "--logout Success": Wylogowanie zakończone sukcesem!,
           „--log out”: wyloguj się,
           „--logout”: wyloguj się,
           „--number”: liczba, //n
           "--Nazwa nazwa,
           „--now zaloguj się”: Teraz zaloguj się!,
           „--nie ma zakazu tłumienia konkurencji”:
           „-bez zazdrości, bez nienawiści”: bez zazdrości, bez nienawiści, bez podziałów,
           "--nie? Nie,
           „--oficjalne adresy umożliwiające dostęp do Twojego telefonu wirtualnego”: Oficjalne adresy umożliwiające dostęp do Twojego telefonu wirtualnego, //o
           „--password”: Hasło, //str
           "--wypłaty punktów izocash": Wypłaty punktów izocash,
           „--wypłaty punktów”: wypłaty punktów,
           „--najlepiej użyj VPN”: Najlepiej użyj VPN, który nie należy do Twojego dostawcy usług internetowych,
           „--wytrwałość zawsze się opłaca”: Wytrwałość zawsze się w końcu opłaca,
           „--rule”: Reguły, //r
           „--rekomendacja”: rekomendacje,
           „--rejestracja”: Rejestracja,
           „--signup to veil genialny”: Zarejestruj się na Veil Brillant, //s
           „--rejestracja w sklepie vixinol”: Zarejestruj się w sklepie Vixinol,
           „--signup”: Zarejestruj się,
           „--signup Success”: Rejestracja przebiegła pomyślnie!,
           "--signup for free": Zarejestruj się za darmo,
           „--signup Success IA”: Połączenie udane”,
           "--settings": "Ustawienia",
           „--konfigurowanie aplikacji Alrani”: Konfiguracja aplikacji Alrani,
           „--konfigurowanie aplikacji izocash”: Konfiguracja aplikacji izocash,
           „--konfigurowanie aplikacji vixinol”: Konfiguracja aplikacji Vixinol,
           „--konfigurowanie aplikacji Veil Brillant”: Konfiguracja aplikacji Veil Brillant,
           „--przechowywanie obrazów, filmów”: Przechowywanie zdjęć, filmów i kilku innych elementów,
           „--szybkość odbioru”: Szybkość odbioru danych z Datacenter,
           „--speed”: prędkość,
           „--terminate”: Zakończ, //t
           „--Vpn umożliwia dostęp”: VPN umożliwia dostęp do witryny lub aplikacji, które Twój dostawca usług internetowych umieścił na czarnej liście,
           „-największe drzewo było powyżej”: Największe drzewo było przede wszystkim prostym, małym nasionkiem,
           „--touch the screen”: dotknij ekranu, aby kontynuować,
           „--spróbuj ponownie”: Spróbuj ponownie!,
           „--username”: nazwa użytkownika, //u

           „--virtual number”: Numer wirtualny, //v
           „--ustawienia telefonu wirtualnego”: Ustawienia telefonu wirtualnego,
           „--Zastosowano język Virtual Phone”: Domyślnie na poziomie aplikacji stosowany jest język Virtual Phone,
           „--wirtualny telefon”: Telefon wirtualny,
           "--validate": Sprawdź poprawność,
           "--witamy w portalu klienta izocash": Witamy w portalu klienta izocash, //w
           „--write a super code”: Wprowadź superkod,
           „--witamy w”: Witamy w,
           „--tam, gdzie idzie uwaga ludzi”: gdzie idzie uwaga ludzi, idą pieniądze,
           „--Zwycięzcy wytrwają”: Zwycięzcy wytrwają,
           „--czy chcesz wylogować się ze swojego konta Alrani”: Czy chcesz się wylogować ze swojego konta Alrani?,
           „--yes”: Tak, //y

           // kraj
           „--congo”: Kongo Brazzaville,
           „--kamerun”: Kamerun,
           „--drc”: DRK,
           „--ivoryCoast”: Wybrzeże Kości Słoniowej,

           // język
        „--afrikaans”: afrikaans, //a
        „-albański”: albański,
        „--amharski”: amharski,
        „--arabic”: arabski,
        „--ormianin”: ormiański,
        „--assamese”: asamski,
        „--ajmara”: ajmara,
        „--azerbejdżański”: azerbejdżański,
        „--bambara”: Bambara, //ur
        „--baskijski”: baskijski,
        "--białoruski": białoruski,
        „--bengali”: bengalski,
        „--bhojpuri”: Bhojpuri,
        „--bośniak”: bośniacki,
        „--bułgarski”: bułgarski,
        „--catalan”: kataloński, //c
        „--cebuano”: cebuański,
        „--chichewa”: Chichewa,
        „--chineseSimplified”: chiński (uproszczony),
        „--chineseTraditional”: chiński (tradycyjny),
        „--korsykański”: korsykański,
        „--chorwacki”: chorwacki,
        „--czech”: czeski,
        „--danish”: duński, //zm
        „--dhivehi”: Dhivehi,
        „--dogri”: Dogri,
        „--holenderski”: holenderski,
        „--english”: angielski, //e
        „--esperanto”: esperanto,
        „--estoński”: estoński,
        „--ewe”: Ewe,
        „--filipino”: filipiński, //f
        „--fiński”: fiński,
        „--francuski”: francuski,
        „--fryzyjski”: fryzyjski,
        „--galicyjski”: galicyjski, //g
        „--gruziński”: gruziński,
        „--german”: niemiecki,
        „--grecki”: grecki,
        „--guarani”: guarani,
        „--gujarati”: gudżarati,
        „--haitianCreole”: kreolski haitański, //h
        „--hausa”: Hausa,
        „--hawajski”: hawajski,
        „--hebrajski”: hebrajski,
        „--hindi”: hindi,
        „--hmong”: Hmong,
        „--węgier”: węgierski,
        „--islandzki”: islandzki, //i
        „--igbo”: Igbo,
        „--ilocano”: Ilocano,
        „--indonezyjski”: indonezyjski,
        „--irlandzki”: irlandzki,
        „--włoski”: włoski,
        „--japanese”: japoński, //j
        „--javanese”: jawajski,
        „--kannada”: kannada, //k
        „--kazachski”: kazachski,
        „--khmer”: Khmer,
        „--kinyarwanda”: kinyarwanda,
        „--konkani”: Konkani,
        „--korean”: koreański,
        „--krio”: Krio,
        „--kurdishKurmanji”: kurdyjski (kurmanji),
        „--kurdishSorani”: kurdyjski (sorani),
        „--kirgiz”: kirgiski,
        „--lao”: laotański, //l
        „--latin”: łac.,
        „--łotewski”: łotewski,
        „--lingala”: lingala,
        „--litewski”: litewski,
        „--luganda”: Luganda,
        „--luxembourgish”: luksemburski,
        „--macedoński”: macedoński, //m
        „--maithili”: Maithili,
        „--malgaski”: malgaski,
        „--malajski”: malajski,
        „--malajalam”: malajalam,
        „--maltański”: maltański,
        „--maoryski”: maoryski,
        „--marathi”: marathi,
        „--meiteilonManipuri”: Meiteilon (Manipuri),
        „--mizo”: Mizo,
        „--mongolski”: mongolski,
        „--myanmarBirmański”: Birma (birmański),
        „--nepalski”: nepalski, //n
        „--norwegian”: norweski,
        „--odiaOriya”: Odia (Oriya), //o
        „--oromo”: Oromo,
        „--pashto”: paszto, //s
        „--persian”: perski,
        „--polish”: polski,
        „--portugalski”: portugalski,
        „--punjabi”: pendżabski,
        „--quechua”: keczua, //q
        „--rumuński”: rumuński, //r
        „--rosyjski”: rosyjski,
        „--samoan”: Samoański, //s
        „--sanskryt”: sanskryt,
        „--scotsGaelic”: szkocki gaelicki,
        „--sepedi”: Sepedi,
        „--serbian”: serbski,
        „--sesotho”: Sesotho,
        „--shona”: Shona,
        „--sindhi”: sindhi,
        „--syngaleski”: syngaleski,
        „--słowacki”: słowacki,
        "--slovenian": słoweński,
        „--somali”: somalijski,
        „--hiszpański”: hiszpański,
        „--sundajczyk”: sundajczyk,
        „--swahili”: suahili,
        „--szwedzki”: szwedzki,
        „--tajik”: tadżycki, //t
        „--tamilski”: tamilski,
        „--tatar”: tatarski,
        „--telugu”: telugu,
        „--thai”: tajski,
        „--tigrinya”: Tigrinia,
        „--tsonga”: Tsonga,
        „--turecki”: turecki,
        „--turkmen”: Turkmen,
        „--twi”: Twi,
        „--ukraiński”: ukraiński, //u
        „--urdu”: urdu,
        „--ujgur”: ujgur,
        „--uzbecki”: uzbecki,
        „--vietnamese”: wietnamski, //v
        „--welsh”: walijski, //w
        „--xhosa”: Xhosa, //x
        „--jidysz”: jidysz, //y
        „--joruba”: joruba,
        „--zulu”: Zulu, //z
        },
      },
      */

      // **portuguese
      // **portuguese
      portuguese: {
        translations: {
          "--an error has occurred": "Ocorreu um erro!", //a
          "--address": "Endereços",
          "--advice": "Conselho",
          "--by clicking on continue": "Ao clicar em continuar você será desconectado de sua conta Veil Brillant", //b
          "--by clicking on disconnect you will be disconnected": "Ao clicar em Desconectar você será desconectado de sua conta izocash",
          "--check your virtual number or try again later": "Verifique seu Número virtual ou tente novamente mais tarde", //c
          "--check your virtual number": "Verifique seu Número virtual",
          "--continue": "Continuar",
          "--connection": "Conexão",
          "--collaborate, live in harmony": "Colaborar, viver em harmonia com os outros",
          "--don't prevent competition": "Não impeça a concorrência, dê uma chance a todos", //d
          "--disconnection": "Desconexão",
          "--for all virtual phone users": "Para todos os usuários de Telefone virtual, é recomendado usar uma VPN", //f
          "--go to login page": "Vá para a página de login", //g
          "--historical": "Histórico", //h
          "--i have account": "já tenho uma conta", //i
          "--i don't have account": "não tenho uma conta",
          "--it is your house": "é a sua casa",
          "--if you have not registered": "Se você não está cadastrado, você pode iniciar seu cadastro",
          "--image / video +": "Imagem/Vídeo +",
          "--identity verification": "Verificação de identidade",
          "--izocash customer portal": "Portal do cliente izocash",
          "--identity update every year": "Atualização de identidade todos os anos",
          "--izocash buy to": "izocash Comprar => izocash internacional",
          "--log in": "Faça login!", //l
          "--login": "Faça login",
          "--login to veil brillant": "Conecte-se ao Veil Brillant",
          "--login to vixinol store": "Conecte-se ao Vixinol Store",
          "--login for free to your veil brillant account": "Faça login gratuitamente em sua conta Veil Brillant para acessar este recurso",
          "--login sucess": "Login bem-sucedido!",
          "--login now": "Faça login agora!",
          "--logout success": "Logout bem-sucedido!",
          "--log out": "Sair",
          "--logout": "Sair",
          "--number": "Número", //n
          "--name": "Nome",
          "--now log in": "Agora, faça login!",
          "--no ban on stifling competition": "Nenhuma proibição de sufocar a concorrência",
          "--no jealousy, no hatred": "Sem ciúme, sem ódio, sem divisões",
          "--no": "Não",
          "--official addresses to access your virtual phone": "Endereços oficiais para acessar seu telefone virtual", //o
          "--password": "Senha", //p
          "--points withdrawals izocash": "Retiradas de pontos izocash",
          "--points withdrawals": "retiradas de pontos",
          "--preferably, use a vpn": "De preferência, use uma VPN que não pertença ao seu provedor de serviços de Internet",
          "--persistence always pays off": "A persistência sempre compensa no final",
          "--please, check your virtual number": "Por favor, Verifique seu Número virtual", 
          "--please, try again later": "Por favor, tente novamente mais tarde !",
          "--platform 1 for virtual applications": "Plataforma Nº1 para aplicações virtuais",
          "--rule": "Regras", //r
          "--recommendation": "Recomendações",
          "--registration": "Registro",
          "--signup to veil brillant": "Registre-se no Veil Brillant", //s
          "--signup to vixinol store": "Registre-se no Vixinol Store",
          "--signup": "Cadastre-se",
          "--signup success": "Registro bem-sucedido!",
          "--signup success IA": "Conexão bem-sucedida”",
          "--signup for free": "Registre-se gratuitamente",
          "--settings": "Configurações",
          "--setting up the alrani app": "Configurando o aplicativo Alrani",
          "--setting up the izocash app": "Configurando o aplicativo izocash",
          "--setting up the vixinol app": "Configurando o aplicativo Vixinol",
          "--setting up the veil brillant app": "Configurando o aplicativo Veil Brillant",
          "--storage of images, videos": "Armazenamento de imagens, vídeos e diversos outros elementos",
          "--speed of reception": "Velocidade de recepção de dados do Datacenter",
          "--speed": "Velocidade",
          "--terminate": "Terminar", //t
          "--the vpn allows you to access": "A VPN permite que você acesse um site ou aplicativo que seu provedor de serviços de Internet colocou na lista negra",
          "--the largest tree was above": "A maior árvore era acima de tudo uma simples sementinha",
          "--touch the screen": "Toque na tela para continuar",
          "--try again": "Tente novamente!",
          "--username": "Nome de usuário", //u
           "--virtual number": "Número virtual", //v
           "--virtual phone": "Telefone virtual",
           "--virtual phone language": "Idioma do Telefone Virtual",
           "--virtual phone settings": "Configurações do Telefone Virtual",
           "--virtual phone language is applied": "O idioma do Virtual Phone é aplicado no nível do aplicativo por padrão",
           "--validate": "Validar",
           "--welcome to the izocash customer portal": "Bem-vindo ao Portal do Cliente izocash", //w
           "--write a super code": "insira um supercódigo",
           "--welcome to": "Bem-vindo a",
           "--where people's attention goes": "Para onde vai a atenção das pessoas, o dinheiro vai",
           "--winners persevere": "Os vencedores perseveram",
           "--would you like to log out of your Alrani account": "Deseja sair da sua conta Alrani ?",
           "--yes": "Sim", //y

           // country
           "--congo": "Congo Brazzaville",
           "--cameroon": "Camarões",
           "--drc": "RDC",
           "--ivoryCoast": "Costa do Marfim",

           // idioma
        "--africâner": "Africâner", //a
        "--albanês": "albanês",
        "--amharic": "Amárico",
        "--arabic": "Árabe",
        "--armênio": "armênio",
        "--assamês": "Assamês",
        "--aymara": "aimará",
        "--azerbaijano": "Azerbaijano",
        "--bambara": "Bambara", //b
        "--basco": "Basco",
        "--bielorrusso": "bielorrusso",
        "--bengali": "bengali",
        "--bhojpuri": "Bhojpuri",
        "--bósnio": "Bósnio",
        "--búlgaro": "búlgaro",
        "--catalan": "Catalão", //c
        "--cebuano": "Cebuano",
        "--chichewa": "Chichewa",
        "--chineseSimplified": "Chinês (Simplificado)",
        "--chineseTraditional": "Chinês (Tradicional)",
        "--corso": "Córsega",
        "--croata": "Croata",
        "--czech": "tcheco",
        "--danish": "dinamarquês", //d
        "--divehi": "Dhivehi",
        "--dogri": "Dogri",
        "--dutch": "holandês",
        "--english": "Inglês", //e
        "--esperanto": "Esperanto",
        "--estonian": "estoniano",
        "--ewe": "Ewe",
        "--filipino": "Filipino", //f
        "--finnish": "finlandês",
        "--french": "Francês",
        "--frisiano": "Frísio",
        "--galician": "Galego", //g
        "--georgian": "georgiano",
        "--alemão": "alemão",
        "--grego": "grego",
        "--guarani": "guarani",
        "--gujarati": "Gujarati",
        "--haitianCreole": "crioulo haitiano", //h
        "--hausa": "Hauçá",
        "--hawaiian": "havaiano",
        "--hebraico": "hebraico",
        "--hindi": "Hindi",
        "--hmong": "Hmong",
        "--húngaro": "húngaro",
        "--icelandic": "islandês", //i
        "--igbo": "Ibo",
        "--ilocano": "Ilocano",
        "--indonésio": "indonésio",
        "--irish": "irlandês",
        "--italiano": "italiano",
        "--japanese": "Japonês", //j
        "--javanês": "javanês",
        "--kannada": "Kannada", //k
        "--cazaque": "cazaque",
        "--khmer": "Khmer",
        "--kinyarwanda": "Kinyarwanda",
        "--konkani": "concani",
        "--coreano": "coreano",
        "--krio": "Krio",
        "--kurdishKurmanji": "Curdo (Kurmanji)",
        "--kurdishSorani": "Curdo (Sorani)",
        "--quirguiz": "Quirguistão",
        "--lao": "Lao", //l
        "--latin": "latim",
        "--letão": "letão",
        "--lingala": "Lingala",
        "--lithuanian": "lituano",
        "--luganda": "Luganda",
        "--luxembourgish": "Luxemburguês",
        "--macedônio": "macedônio", //m
        "--maithili": "Maithili",
        "--malagasy": "malgaxe",
        "--malay": "malaio",
        "--malayalam": "malaiala",
        "--maltese": "maltês",
        "--maori": "Maori",
        "--marathi": "Marathi",
        "--mizo": "Mizo",
        "--mongol": "mongol",
        "--myanmarBurmese": "Mianmar (birmanês)",
        "--nepalês": "nepalês", //n
        "--norueguês": "Norueguês",
        "--odiaOriya": "Odia (Oriya)", //o
        "--oromo": "Oromo",
        "--pashto": "pashto", //p
        "--persian": "Persa",
        "--polish": "polonês",
        "--portuguese": "Português",
        "--punjabi": "punjabi",
        "--quechua": "quíchua", //q
        "--romeno": "romeno", //r
        "--russo": "Russo",
        "--samoan": "Samoano", //s
        "--sânscrito": "Sânscrito",
        "--scotsGaelic": "gaélico escocês",
        "--sepedi": "Sepedi",
        "--sérvio": "sérvio",
        "--sesotho": "Sesotho",
        "--shona": "Shona",
        "--sindi": "Sindi",
        "--sinhala": "cingalês",
        "--eslovaco": "eslovaco",
        "--esloveno": "esloveno",
        "--somali": "somali",
        "--espanhol": "espanhol",
        "--sudanês": "sudanês",
        "--swahili": "suaíli",
        "--sueco": "sueco",
        "--tajik": "tadjique", //t
        "--tamil": "Tâmil",
        "--tatar": "Tártaro",
        "--telugu": "Telugu",
        "--thai": "tailandês",
        "--tigrinya": "Tigrinya",
        "--tsonga": "Tsonga",
        "--turco": "Turco",
        "--turkmen": "turcomano",
        "--twi": "Twi",
        "--ukrainian": "Ucraniano", //u
        "--urdu": "urdu",
        "--uigur": "uigur",
        "--uzbeque": "uzbeque",
        "--vietnamese": "vietnamita", //v
        "--galês": "galês", //w
        "--xhosa": "Xhosa", //x
        "--yiddish": "iídiche", //y
        "--yoruba": "Iorubá",
        "--zulu": "Zulu", //z
        },
      },

      /*
      // punjabi
      // punjabi
      punjabi: {
        translations: {
          "--ਇੱਕ ਗਲਤੀ ਆਈ ਹੈ": ਇੱਕ ਗਲਤੀ ਆਈ ਹੈ!, //a
           "--address": ਪਤੇ,
           "--advice": ਸਲਾਹ,
           "--ਜਾਰੀ ਰੱਖਣ 'ਤੇ ਕਲਿੱਕ ਕਰਕੇ": ਜਾਰੀ ਰੱਖਣ 'ਤੇ ਕਲਿੱਕ ਕਰਨ ਨਾਲ ਤੁਸੀਂ ਆਪਣੇ ਵੇਲ ਬ੍ਰਿਲੈਂਟ ਖਾਤੇ ਤੋਂ ਡਿਸਕਨੈਕਟ ਹੋ ਜਾਵੋਗੇ, //b
           "-- ਡਿਸਕਨੈਕਟ 'ਤੇ ਕਲਿੱਕ ਕਰਨ ਨਾਲ ਤੁਸੀਂ ਡਿਸਕਨੈਕਟ ਹੋ ਜਾਵੋਗੇ": ਡਿਸਕਨੈਕਟ 'ਤੇ ਕਲਿੱਕ ਕਰਨ ਨਾਲ ਤੁਹਾਨੂੰ ਤੁਹਾਡੇ izocash ਖਾਤੇ ਤੋਂ ਡਿਸਕਨੈਕਟ ਕਰ ਦਿੱਤਾ ਜਾਵੇਗਾ,
           "--ਆਪਣੇ ਵਰਚੁਅਲ ਨੰਬਰ ਦੀ ਜਾਂਚ ਕਰੋ ਜਾਂ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ": ਆਪਣੇ ਵਰਚੁਅਲ ਨੰਬਰ ਦੀ ਜਾਂਚ ਕਰੋ ਜਾਂ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ, //c
           "--ਆਪਣੇ ਵਰਚੁਅਲ ਨੰਬਰ ਦੀ ਜਾਂਚ ਕਰੋ": ਆਪਣੇ ਵਰਚੁਅਲ ਨੰਬਰ ਦੀ ਜਾਂਚ ਕਰੋ,
           "--continue": ਜਾਰੀ ਰੱਖੋ,
           "--ਕਨੈਕਸ਼ਨ": ਕੁਨੈਕਸ਼ਨ,
           "--ਸਹਿਯੋਗ ਕਰੋ, ਇਕਸੁਰਤਾ ਵਿਚ ਰਹੋ": ਸਹਿਯੋਗ ਕਰੋ, ਦੂਜਿਆਂ ਨਾਲ ਇਕਸੁਰਤਾ ਵਿਚ ਰਹੋ,
           "--ਚੋਣ ਭਾਸ਼ਾ": ਵਰਚੁਅਲ ਫ਼ੋਨ ਭਾਸ਼ਾ,
           "--ਮੁਕਾਬਲੇ ਨੂੰ ਨਾ ਰੋਕੋ": ਮੁਕਾਬਲੇ ਨੂੰ ਨਾ ਰੋਕੋ, ਹਰ ਕਿਸੇ ਨੂੰ ਮੌਕਾ ਦਿਓ, //d
           "--disconnection": ਡਿਸਕਨੈਕਸ਼ਨ,
           "--ਸਾਰੇ ਵਰਚੁਅਲ ਫੋਨ ਉਪਭੋਗਤਾਵਾਂ ਲਈ": ਸਾਰੇ ਵਰਚੁਅਲ ਫੋਨ ਉਪਭੋਗਤਾਵਾਂ ਲਈ, ਇੱਕ VPN, //f ਦੀ ਵਰਤੋਂ ਕਰਨ ਦੀ ਸਿਫਾਰਸ਼ ਕੀਤੀ ਜਾਂਦੀ ਹੈ
           "--ਲੌਗਇਨ ਪੰਨੇ 'ਤੇ ਜਾਓ": ਲੌਗਇਨ ਪੰਨੇ 'ਤੇ ਜਾਓ, //g
           "--ਇਤਿਹਾਸਕ": ਇਤਿਹਾਸਕ, //h
           "--i have account": ਮੇਰੇ ਕੋਲ ਪਹਿਲਾਂ ਹੀ ਇੱਕ ਖਾਤਾ ਹੈ, //i
           "--ਮੇਰਾ ਖਾਤਾ ਨਹੀਂ ਹੈ": ਮੇਰੇ ਕੋਲ ਖਾਤਾ ਨਹੀਂ ਹੈ,
           "--ਇਹ ਤੁਹਾਡਾ ਘਰ ਹੈ": ਇਹ ਤੁਹਾਡਾ ਘਰ ਹੈ,
           "--image / video +": ਚਿੱਤਰ / ਵੀਡੀਓ +,
           "--ਪਛਾਣ ਤਸਦੀਕ": ਪਛਾਣ ਤਸਦੀਕ,
           "--izocash ਗਾਹਕ ਪੋਰਟਲ": izocash ਗਾਹਕ ਪੋਰਟਲ,
           "--ਪਛਾਣ ਅੱਪਡੇਟ ਹਰ ਸਾਲ": ਹਰ ਸਾਲ ਪਛਾਣ ਅੱਪਡੇਟ,
           "--izocash buy to": izocash Buy => izocash ਅੰਤਰਰਾਸ਼ਟਰੀ,
           "--ਲੌਗ ਇਨ": ਲੌਗ ਇਨ!, //l
           "--login": ਲਾਗਇਨ ਕਰੋ,
           "--login to veil brilliant": ਵੇਲ ਬ੍ਰਿਲੈਂਟ ਨਾਲ ਜੁੜੋ,
           "--ਵਿਕਸੀਨੋਲ ਸਟੋਰ 'ਤੇ ਲਾਗਇਨ ਕਰੋ": ਵਿਕਸੀਨੋਲ ਸਟੋਰ ਨਾਲ ਜੁੜੋ,
           "--ਆਪਣੇ ਵੇਲ ਬ੍ਰਿਲੈਂਟ ਖਾਤੇ ਵਿੱਚ ਮੁਫਤ ਵਿੱਚ ਲੌਗਇਨ ਕਰੋ": ਇਸ ਵਿਸ਼ੇਸ਼ਤਾ ਨੂੰ ਐਕਸੈਸ ਕਰਨ ਲਈ ਆਪਣੇ ਵੇਲ ਬ੍ਰਿਲੈਂਟ ਖਾਤੇ ਵਿੱਚ ਮੁਫਤ ਵਿੱਚ ਲੌਗਇਨ ਕਰੋ,
           "--login success": ਲਾਗਇਨ ਸਫਲ!,
           "--login now": ਹੁਣੇ ਲਾਗਇਨ ਕਰੋ!,
           "--logout success": ਲਾਗਆਉਟ ਸਫਲ!,
           "--log out": ਲਾਗਆਉਟ,
           "--logout": ਲੌਗ ਆਉਟ,
           "--number": ਨੰਬਰ, //n
           "--ਨਾਮ": ਨਾਮ,
           "--ਹੁਣ ਲੌਗ ਇਨ ਕਰੋ": ਹੁਣ, ਲੌਗ ਇਨ ਕਰੋ!,
           "--ਮੁਕਾਬਲੇਬਾਜ਼ੀ 'ਤੇ ਕੋਈ ਪਾਬੰਦੀ ਨਹੀਂ":
           "--ਕੋਈ ਈਰਖਾ ਨਹੀਂ, ਕੋਈ ਨਫ਼ਰਤ ਨਹੀਂ": ਕੋਈ ਈਰਖਾ ਨਹੀਂ, ਕੋਈ ਨਫ਼ਰਤ ਨਹੀਂ, ਕੋਈ ਵੰਡ ਨਹੀਂ,
           "--ਨਹੀਂ ਨਹੀਂ,
           "--ਅਧਿਕਾਰਤ ਪਤੇ ਤੁਹਾਡੇ ਵਰਚੁਅਲ ਫ਼ੋਨ ਤੱਕ ਪਹੁੰਚ ਕਰਨ ਲਈ": ਤੁਹਾਡੇ ਵਰਚੁਅਲ ਫ਼ੋਨ ਤੱਕ ਪਹੁੰਚ ਕਰਨ ਲਈ ਅਧਿਕਾਰਤ ਪਤੇ, //o
           "--password": ਪਾਸਵਰਡ, //p
           "--ਪੁਆਇੰਟ ਕਢਵਾਉਣਾ izocash": ਪੁਆਇੰਟ ਕਢਵਾਉਣਾ izocash,
           "--ਪੁਆਇੰਟ ਕਢਵਾਉਣਾ": ਪੁਆਇੰਟ ਕਢਵਾਉਣਾ,
           "--ਤਰਜੀਹੀ ਤੌਰ 'ਤੇ, ਇੱਕ ਵੀਪੀਐਨ ਦੀ ਵਰਤੋਂ ਕਰੋ": ਤਰਜੀਹੀ ਤੌਰ 'ਤੇ, ਇੱਕ ਵੀਪੀਐਨ ਦੀ ਵਰਤੋਂ ਕਰੋ ਜੋ ਤੁਹਾਡੇ ਇੰਟਰਨੈਟ ਸੇਵਾ ਪ੍ਰਦਾਤਾ ਨਾਲ ਸਬੰਧਤ ਨਹੀਂ ਹੈ,
           "--ਦ੍ਰਿੜਤਾ ਹਮੇਸ਼ਾ ਅਦਾਇਗੀ ਕਰਦੀ ਹੈ": ਨਿਰੰਤਰਤਾ ਹਮੇਸ਼ਾ ਅੰਤ ਵਿੱਚ ਅਦਾਇਗੀ ਕਰਦੀ ਹੈ,
           "--rule": ਨਿਯਮ, //r
           "--ਸਿਫ਼ਾਰਸ਼": ਸਿਫ਼ਾਰਸ਼ਾਂ,
           "--registration": ਰਜਿਸਟਰੇਸ਼ਨ,
           "--signup to veil brillant": ਵੇਲ ਬ੍ਰਿਲੈਂਟ 'ਤੇ ਰਜਿਸਟਰ ਕਰੋ, //s
           "--ਵਿਕਸੀਨੋਲ ਸਟੋਰ ਲਈ ਸਾਈਨ ਅੱਪ ਕਰੋ": ਵਿਕਸੀਨੋਲ ਸਟੋਰ 'ਤੇ ਰਜਿਸਟਰ ਕਰੋ,
           "--signup": ਰਜਿਸਟਰ ਕਰੋ,
           "--signup success": ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਸਫਲ!,
           "--signup for free": ਮੁਫ਼ਤ ਵਿੱਚ ਰਜਿਸਟਰ ਕਰੋ,
           "--ਸਾਈਨਅੱਪ ਸਫਲਤਾ IA": ਕਨੈਕਸ਼ਨ ਸਫਲ",
           "--settings": "ਸੈਟਿੰਗ",
           "--ਅਲਰਾਨੀ ਐਪ ਨੂੰ ਸੈਟ ਕਰਨਾ": ਅਲਰਾਨੀ ਐਪਲੀਕੇਸ਼ਨ ਨੂੰ ਕੌਂਫਿਗਰ ਕਰਨਾ,
           "--izocash ਐਪ ਨੂੰ ਸੈੱਟ ਕਰਨਾ": izocash ਐਪਲੀਕੇਸ਼ਨ ਨੂੰ ਕੌਂਫਿਗਰ ਕਰਨਾ,
           "--ਵਿਕਸਿਨੋਲ ਐਪ ਨੂੰ ਸੈਟ ਕਰਨਾ": ਵਿਕਸੀਨੋਲ ਐਪਲੀਕੇਸ਼ਨ ਨੂੰ ਕੌਂਫਿਗਰ ਕਰਨਾ,
           "--ਵੇਲ ਬ੍ਰਿਲੈਂਟ ਐਪ ਨੂੰ ਸੈਟ ਕਰਨਾ": ਵੇਲ ਬ੍ਰਿਲੈਂਟ ਐਪਲੀਕੇਸ਼ਨ ਨੂੰ ਕੌਂਫਿਗਰ ਕਰਨਾ,
           "--ਚਿੱਤਰਾਂ, ਵੀਡੀਓਜ਼ ਦੀ ਸਟੋਰੇਜ": ਚਿੱਤਰਾਂ, ਵੀਡੀਓਜ਼ ਅਤੇ ਕਈ ਹੋਰ ਤੱਤਾਂ ਦੀ ਸਟੋਰੇਜ,
           "--ਰਿਸੈਪਸ਼ਨ ਦੀ ਗਤੀ": ਡੇਟਾਸੈਂਟਰ ਤੋਂ ਡੇਟਾ ਦੇ ਰਿਸੈਪਸ਼ਨ ਦੀ ਗਤੀ,
           "--ਸਪੀਡ": ਸਪੀਡ,
           "--terminate": ਸਮਾਪਤ ਕਰੋ, //t
           "--vpn ਤੁਹਾਨੂੰ ਐਕਸੈਸ ਕਰਨ ਦੀ ਇਜਾਜ਼ਤ ਦਿੰਦਾ ਹੈ": VPN ਤੁਹਾਨੂੰ ਕਿਸੇ ਸਾਈਟ ਜਾਂ ਐਪਲੀਕੇਸ਼ਨ ਨੂੰ ਐਕਸੈਸ ਕਰਨ ਦੀ ਇਜਾਜ਼ਤ ਦਿੰਦਾ ਹੈ ਜਿਸ ਨੂੰ ਤੁਹਾਡੇ ਇੰਟਰਨੈਟ ਸੇਵਾ ਪ੍ਰਦਾਤਾ ਨੇ ਬਲੈਕਲਿਸਟ ਕੀਤਾ ਹੈ,
           "--ਸਭ ਤੋਂ ਵੱਡਾ ਦਰੱਖਤ ਉੱਪਰ ਸੀ": ਸਭ ਤੋਂ ਵੱਡਾ ਦਰੱਖਤ ਇੱਕ ਸਧਾਰਨ ਛੋਟੇ ਬੀਜ ਤੋਂ ਉੱਪਰ ਸੀ,
           "--ਸਕ੍ਰੀਨ ਨੂੰ ਛੂਹੋ": ਜਾਰੀ ਰੱਖਣ ਲਈ ਸਕ੍ਰੀਨ ਨੂੰ ਛੋਹਵੋ,
           "--try again": ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ!,
           "--username": ਵਰਤੋਂਕਾਰ ਨਾਂ, //u

           "--virtual number": ਵਰਚੁਅਲ ਨੰਬਰ, //v
           "--virtual phone settings": ਵਰਚੁਅਲ ਫ਼ੋਨ ਸੈਟਿੰਗਾਂ,
           "--ਵਰਚੁਅਲ ਫ਼ੋਨ ਭਾਸ਼ਾ ਲਾਗੂ ਕੀਤੀ ਗਈ ਹੈ": ਵਰਚੁਅਲ ਫ਼ੋਨ ਭਾਸ਼ਾ ਡਿਫਾਲਟ ਰੂਪ ਵਿੱਚ ਐਪਲੀਕੇਸ਼ਨ ਪੱਧਰ 'ਤੇ ਲਾਗੂ ਕੀਤੀ ਜਾਂਦੀ ਹੈ,
           "--virtual phone": ਵਰਚੁਅਲ ਫ਼ੋਨ,
           "--validate": ਪ੍ਰਮਾਣਿਤ ਕਰੋ,
           "-- izocash ਗਾਹਕ ਪੋਰਟਲ ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ": izocash ਗਾਹਕ ਪੋਰਟਲ ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ, //w
           "--ਇੱਕ ਸੁਪਰ ਕੋਡ ਲਿਖੋ": ਇੱਕ ਸੁਪਰ ਕੋਡ ਦਰਜ ਕਰੋ,
           "-welcome to": ਸੁਆਗਤ ਹੈ,
           "--ਜਿੱਥੇ ਲੋਕਾਂ ਦਾ ਧਿਆਨ ਜਾਂਦਾ ਹੈ": ਜਿੱਥੇ ਲੋਕਾਂ ਦਾ ਧਿਆਨ ਜਾਂਦਾ ਹੈ ਪੈਸਾ ਜਾਂਦਾ ਹੈ,
           "--ਵਿਜੇਤਾ ਦ੍ਰਿੜ ਰਹਿੰਦੇ ਹਨ": ਜੇਤੂ ਦ੍ਰਿੜ ਰਹਿੰਦੇ ਹਨ,
           "--ਕੀ ਤੁਸੀਂ ਆਪਣੇ ਅਲਰਾਨੀ ਖਾਤੇ ਤੋਂ ਲੌਗ ਆਊਟ ਕਰਨਾ ਚਾਹੋਗੇ": ਕੀ ਤੁਸੀਂ ਆਪਣੇ ਅਲਰਾਨੀ ਖਾਤੇ ਤੋਂ ਲੌਗ ਆਊਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?,
           "--ਹਾਂ": ਹਾਂ, //y

           // ਦੇਸ਼
           "--ਕਾਂਗੋ": ਕਾਂਗੋ ਬ੍ਰਾਜ਼ਾਵਿਲ,
           "--cameroon": ਕੈਮਰੂਨ,
           "--drc": DRC,
           "--ivoryCoast": ਆਈਵਰੀ ਕੋਸਟ,

           // ਭਾਸ਼ਾ
        "--afrikaans": ਅਫਰੀਕੀ, //a
        "--ਅਲਬਾਨੀਅਨ": ਅਲਬਾਨੀਅਨ,
        "--ਅਮਹਾਰਿਕ": ਅਮਹਾਰਿਕ,
        "--ਅਰਬੀ": ਅਰਬੀ,
        "--armenian": ਅਰਮੀਨੀਆਈ,
        "--assamese": ਅਸਾਮੀ,
        "--aymara": ਅਯਮਾਰਾ,
        "--ਅਜ਼ਰਬਾਈਜਾਨੀ": ਅਜ਼ਰਬਾਈਜਾਨੀ,
        "--ਬੰਬਰਾ": ਬੰਬਰਾ, //ਬੀ
        "--basque": ਬਾਸਕ,
        "--ਬੇਲਾਰੂਸੀਅਨ": ਬੇਲਾਰੂਸੀ,
        "--ਬੰਗਾਲੀ": ਬੰਗਾਲੀ,
        "--ਭੋਜਪੁਰੀ": ਭੋਜਪੁਰੀ,
        "--ਬੋਸਨੀਆ": ਬੋਸਨੀਆ,
        "--ਬੁਲਗਾਰੀਆਈ": ਬਲਗੇਰੀਅਨ,
        "--catalan": ਕੈਟਲਨ, //c
        "--cebuano": ਸੇਬੁਆਨੋ,
        "--ਚੀਚੇਵਾ": ਚੀਚੇਵਾ,
        "--chineseSimplified": ਚੀਨੀ (ਸਰਲੀਕ੍ਰਿਤ),
        "--chineseTraditional": ਚੀਨੀ (ਰਵਾਇਤੀ),
        "--corsican": ਕੋਰਸਿਕਨ,
        "--croatian": ਕ੍ਰੋਏਸ਼ੀਅਨ,
        "--czech": ਚੈੱਕ,
        "--danish": ਡੈਨਿਸ਼, //d
        "--ਧਿਵੇਹੀ": ਧੀਵੇਹੀ,
        "--dogri": ਡੋਗਰੀ,
        "--ਡੱਚ": ਡੱਚ,
        "--ਅੰਗਰੇਜ਼ੀ": ਅੰਗਰੇਜ਼ੀ, //e
        "--esperanto": ਐਸਪੇਰਾਂਤੋ,
        "--ਐਸਟੋਨੀਅਨ": ਐਸਟੋਨੀਅਨ,
        "--ewe": ਈਵੇ,
        "--ਫਿਲੀਪੀਨੋ": ਫਿਲੀਪੀਨੋ, //f
        "--finnish": ਫਿਨਿਸ਼,
        "--ਫ੍ਰੈਂਚ": ਫ੍ਰੈਂਚ,
        "--frisian": Frisian,
        "--ਗੈਲੀਸ਼ੀਅਨ": ਗੈਲੀਸ਼ੀਅਨ, //g
        "--georgian": ਜਾਰਜੀਅਨ,
        "--german": ਜਰਮਨ,
        "--ਗ੍ਰੀਕ": ਯੂਨਾਨੀ,
        "--guarani": ਗੁਆਰਾਨੀ,
        "--gujarati": ਗੁਜਰਾਤੀ,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": ਹਾਉਸਾ,
        "--hawaiian": ਹਵਾਈ,
        "--ਹਿਬਰੂ": ਇਬਰਾਨੀ,
        "--ਹਿੰਦੀ": ਹਿੰਦੀ,
        "--hmong": Hmong,
        "--ਹੰਗਰੀਅਨ": ਹੰਗਰੀਆਈ,
        "--ਆਈਸਲੈਂਡਿਕ": ਆਈਸਲੈਂਡਿਕ, //i
        "--igbo": ਇਗਬੋ,
        "--ilocano": Ilocano,
        "--ਇੰਡੋਨੇਸ਼ੀਆਈ": ਇੰਡੋਨੇਸ਼ੀਆਈ,
        "--ਆਇਰਿਸ਼": ਆਇਰਿਸ਼,
        "--italian": ਇਤਾਲਵੀ,
        "--japanese": ਜਪਾਨੀ, //j
        "--javanese": ਜਾਵਨੀਜ਼,
        "--ਕੰਨੜ": ਕੰਨੜ, //k
        "--ਕਜ਼ਾਖ": ਕਜ਼ਾਖ,
        "--ਖਮੇਰ": ਖਮੇਰ,
        "--ਕਿਨਯਾਰਵਾਂਡਾ": ਕਿਨਯਾਰਵਾਂਡਾ,
        "--ਕੋਣਕਣੀ": ਕੋਂਕਣੀ,
        "--ਕੋਰੀਅਨ": ਕੋਰੀਅਨ,
        "--krio": ਕਰਿਓ,
        "--kurdishKurmanji": ਕੁਰਦਿਸ਼ (ਕੁਰਮੰਜੀ),
        "--kurdishSorani": ਕੁਰਦੀ (ਸੋਰਾਨੀ),
        "--kyrgyz": ਕਿਰਗਿਜ਼,
        "--lao": ਲਾਓ, //l
        "--ਲਾਤੀਨੀ": ਲਾਤੀਨੀ,
        "--latvian": ਲਾਤਵੀਅਨ,
        "--lingala": ਲਿੰਗਾਲਾ,
        "--ਲਿਥੁਆਨੀਅਨ": ਲਿਥੁਆਨੀਅਨ,
        "--ਲੁਗਾਂਡਾ": ਲੁਗਾਂਡਾ,
        "--luxembourgish": ਲਕਸਮਬਰਗਿਸ਼,
        "--ਮੈਸੇਡੋਨੀਅਨ": ਮੈਸੇਡੋਨੀਅਨ, //m
        "--ਮੈਥਿਲੀ": ਮੈਥਿਲੀ,
        "--malagasy": ਮੈਲਾਗਾਸੀ,
        "--malay": ਮਾਲੇ,
        "--ਮਲਿਆਲਮ": ਮਲਿਆਲਮ,
        "--ਮਾਲਾਟੀਜ਼": ਮਾਲਟੀਜ਼,
        "--maori": ਮਾਓਰੀ,
        "--marathi": ਮਰਾਠੀ,
        "--meiteilonManipuri": Meiteilon (ਮਨੀਪੁਰੀ),
        "--mizo": ਮਿਜ਼ੋ,
        "--ਮੰਗੋਲੀਆਈ": ਮੰਗੋਲੀਆਈ,
        "--myanmarBurmese": ਮਿਆਂਮਾਰ (ਬਰਮੀ),
        "--ਨੇਪਾਲੀ": ਨੇਪਾਲੀ, //n
        "--ਨਾਰਵੇਜਿਅਨ": ਨਾਰਵੇਜਿਅਨ,
        "--odiaOriya": ਓਡੀਆ (ਉੜੀਆ), //o
        "--oromo": ਓਰੋਮੋ,
        "--ਪਸ਼ਤੋ": ਪਸ਼ਤੋ, //ਪੀ
        "--ਫ਼ਾਰਸੀ": ਫ਼ਾਰਸੀ,
        "--polish": ਪੋਲਿਸ਼,
        "--ਪੁਰਤਗਾਲੀ": ਪੁਰਤਗਾਲੀ,
        "--punjabi": ਪੰਜਾਬੀ,
        "--quechua": ਕੇਚੂਆ, //q
        "--ਰੋਮਾਨੀਅਨ": ਰੋਮਾਨੀਅਨ, //r
        "--ਰੂਸੀ": ਰੂਸੀ,
        "--ਸਮੋਆਨ": ਸਮੋਅਨ, //s
        "--ਸੰਸਕ੍ਰਿਤ": ਸੰਸਕ੍ਰਿਤ,
        "--scotsGaelic": ਸਕਾਟਸ ਗੇਲਿਕ,
        "--sepedi": Sepedi,
        "--ਸਰਬੀਅਨ": ਸਰਬੀਅਨ,
        "--sesotho": ਸੇਸੋਥੋ,
        "--ਸ਼ੋਨਾ": ਸ਼ੋਨਾ,
        "--sindhi": ਸਿੰਧੀ,
        "--ਸਿਨਹਾਲਾ": ਸਿੰਹਾਲਾ,
        "--ਸਲੋਵਾਕ": ਸਲੋਵਾਕ,
        "--ਸਲੋਵੇਨੀਅਨ": ਸਲੋਵੇਨੀਅਨ,
        "--ਸੋਮਾਲੀ": ਸੋਮਾਲੀ,
        "--spanish": ਸਪੇਨੀ,
        "--ਸੁੰਡਨੀਜ਼": ਸੁੰਡਨੀਜ਼,
        "--ਸਵਹਿਲੀ": ਸਵਾਹਿਲੀ,
        "--swedish": ਸਵੀਡਿਸ਼,
        "--ਤਾਜਿਕ": ਤਾਜਿਕ, //t
        "--ਤਾਮਿਲ": ਤਮਿਲ,
        "--tatar": ਤਾਤਾਰ,
        "--ਤੇਲੁਗੂ": ਤੇਲਗੂ,
        "--ਥਾਈ": ਥਾਈ,
        "--tigrinya": ਟਾਈਗਰਨੀਆ,
        "--ਸੋਂਗਾ": ਸੋਂਗਾ,
        "--turkish": ਤੁਰਕੀ,
        "--ਤੁਰਕਮੇਨ": ਤੁਰਕਮੇਨ,
        "--twi": Twi,
        "--ਯੂਕਰੇਨੀਆਈ": ਯੂਕਰੇਨੀ, //u
        "--urdu": ਉਰਦੂ,
        "--ਉਇਘੁਰ": ਉਇਘੁਰ,
        "--ਉਜ਼ਬੇਕ": ਉਜ਼ਬੇਕ,
        "--ਵੀਅਤਨਾਮੀ": ਵੀਅਤਨਾਮੀ, //v
        "--welsh": ਵੈਲਸ਼, //w
        "--xhosa": ਖੋਸਾ, //x
        "--ਯਿੱਦੀ": ਯਿੱਦੀ, //y
        "--yoruba": ਯੋਰੂਬਾ,
        "--zulu": ਜ਼ੁਲੂ, //z

        },
      },

      // quechua
      // quechua
      quechua: {
        translations: {
         "--huk pantaymi rikurirun": ¡Huk pantaymi rikurirun!, //a
           "--dirección": Direccionkuna, .
           "--yuyaychay": Yuyaychay, .
           "--hinalla ñit'ispa": Hinalla ñit'ispaqa Veil Brillant yupayniykimanta t'aqasqa kanki, //b
           "--disconnect nisqapi ñit'ispaqa t'inkisqa kanki": Disconnect nisqapi ñit'ispaqa izocash yupayniykimanta t'aqasqa kanki,
           "--virtual yupayniykita qhaway icha qhipaman wakmanta kallpachakuy": Virtual yupayniykita qhaway icha qhipaman wakmanta kallpachakuy, //c
           "--virtual yupayniykita qhaway": Virtual yupayniykita qhaway,
           "--hinallay": Hinallay,
           "---t'inkisqa": T'inkisqa, .
           "--yanapanakuy, hukllanakuypi kawsakuy": Yanapanakuy, hukkunawan kuska kawsakuy,
           "--simi akllay": Virtual Phone Language, .
           "--ama atipanakuyta hark'aychu": Ama atipanakuy hark'aychu, llapa runaman chansata quy, //d
           "--disconnection": T'inkisqa, .
           "--llapa virtual telefono llamk'aqkunapaq": Llapan Virtual Phone llamk'achiqkunapaq, huk VPN llamk'achiyta yuyaychakun, //f
           "--yaykuna p'anqaman riy": Yaykuna p'anqaman riy, //g
           "--histórico": Ñawpa pachamanta, //h
           "--i have account": Ñuqaqa huk yupayniyuqñam kani, //i
           "--mana cuentayuqchu kani": Manam cuentayuqchu kani,
           "--wasiykim": wasiykim,
           "--imayna / video +": Imahina / Video +,
           "--identidad verificación": Identidad chiqaqchay, .
           "--izocash rantiqpa punkun": izocash rantiqpa punkun,
           "--identidad musuqyachiy sapa wata": Identidad musuqyachiy sapa wata,
           "--izocash rantiyman": izocash Rantinakuy => izocash internacional,
           "--yaykuy": Yaykuy!, //l
           "--yaykuy": Yaykuy,
           "--velo brillante nisqaman yaykuy": Veil Brillant nisqaman t'inkinakuy,
           "--vixinol tiendaman yaykuy": Vixinol Tiendaman tinkiy,
           "--mana qullqillapaq yaykuy veil Brillant yupayniykiman": Veil Brillant yupayniykiman mana qullqillapaq yaykuy kay ruwayman yaykunapaq,
           "--yaykuna allin": Yaykuna allin!,
           "--kunan yaykuy": Kunan yaykuy!,
           "--logout exito": Lloqsiy allin!,
           "--lluqsiy": Lloqsiy, .
           "--logout": Lloqsiy, .
           "--yupay": Yupay, //n
           "--sutin": Suti, .
           "--kunan yaykuy": Kunan, Yaykuy!,
           "--mana hark'ay kanchu atipanakuy asfixia":
           "--mana envidia, mana chiqninakuy": Mana envidia, mana chiqninakuy, mana rakinakuy,
           "--mana": Mana, .
           "--oficial direccionkuna virtual telefonoykiman yaykunapaq": Oficial direccionkuna virtual telefonoykiman yaykunapaq, //o
           "--yaykuna rimay": Yaykuna rimay, //p
           "--puntos retirokuna izocash": Puntos Retirokuna izocash, .
           "--puntukuna hurquy": Puntokuna hurquy, .
           "--aswan allin, huk vpn llamk'achiy": Aswan allin, huk VPN llamk'achiy mayqinchus mana internet yanapakuy quqniykimanchu,
           "--persistenciaqa sapa kutim pagan": Persistenciaqa tukuyninpim paganpuni,
           "--kamachiy": Kamachiykuna, //r
           "--yuyachay": Yuyaychaykuna, .
           "--registro": Inscripción, .
           "--inscripción a velo brillante": Velo Brillant nisqapi qillqakuy, //s
           "--vixinol tiendaman qillqakuy": Vixinol Tiendapi qillqakuy,
           "--qillqakuy": Qillqakuy, .
           "--inscripción allin": ¡Qillqakuy allin!,
           "--mana qullqillapaq qillqakuy": Mana qullqillapaq qillqakuy,
           “--inscripción allin IA”: T’inkisqa allin”,
           "--ajustes": "Ajustes",
           "--alrani ruwanata churaspa": Alrani ruwanata wakichispa,
           "--izocash ruwanata churaspa": izocash ruwanata wakichispa,
           "--vixinol ruwanata churaspa": Vixinol ruwanata wakichispa,
           "--velo Brillant ruwanata churay": Veil Brillant ruwanata wakichiy,
           "--imaynakuna, videokuna waqaychay": Siqikuna, videokuna huk achka elementokuna waqaychay,
           "--usqaylla chaskiy": Willaypa chawpinmanta willayta utqaylla chaskiy,
           "--utqaylla": Utqaylla, .
           "--terminar": Tukuchiy, //t
           "--vpn yaykuyta saqin": VPN huk sitioman utaq huk ruwanaman yaykuyta saqin mayqinmanchus internet yanapakuy quqniyki yana lista kaqpi churasqa,
           "--aswan hatun sach'aqa hawapi karqan": Aswan hatun sach'aqa llapanmanta aswan sasan huch'uy muhu karqan,
           "--pantalla llamiy": Pantalla llamiy hinalla,
           "--yapamanta kallpachakuy": ¡Hukmanta kallpachakuy!,
           "--ruraqpa sutin": Ruraqpa sutin, //u

           "--virtual yupay": Virtual yupay, //v
           "--virtual telefono churanakuna": Virtual telefono churanakuna,
           "--virtual Teléfono simi llamk'achisqa": Virtual Phone simiqa ruwana patapi ñawpaqmanta churasqa,
           "--virtual telefono": Virtual telefono, .
           "--validar": Chiqapchay, .
           "--allin hamusqayki izocash rantiqpa punkunman": Allin hamusqayki izocash rantiqpa punkunman, //w
           "--super codigota qillqay": Super codigota qillqay,
           "--allin hamusqayki": Allin hamusqayki,
           "--maypichus runakunaq yuyaynin rin": Maymanchus runakunaq yuyaynin rin qolqe rin,
           "--atipaqkuna mana saqispa purinku": Ganaqkuna mana saqispa,
           "--Alrani yupayniykimanta lluqsiyta munankichu": ¿Alrani yupayniykimanta lluqsiyta munankichu?,
           "--arí": Arí, //y

           // hatun llaqta
           "--kungo": Kungo Brazzaville, 1999 watapi.
           "--camerun": Kamerun, .
           "--drc": RDC, 1999 watapi.
           "--MarfilCosta": Marfil Costa, 1999 watapi.

           // simi
        "--afrikaans": Afrikaans, //a
        "--albanés": Albanés, .
        "--amharic": Amharic, .
        "--arabe": árabe simi, .
        "--armenu simi": Armenu simi, .
        "--asamese": Assam simi, .
        "--aymara": Aymara, .
        "--azerbaiyano simi": Azerbaiyano simi, .
        "--bambara": Bambara, //b
        "--basco": Vasco, .
        "--belarus": Bielorruso, .
        "--bengali simipi": Bengali simipi, .
        "--bhojpuri": Qhichwa simipi, .
        "--bosniano": Bosnia, .
        "--búlgaro": Bulgaro, .
        "--catalán simipi": Katalan simipi, //c
        "--cebuano": Qhichwa simipi, .
        "--chichewa": Chichewa, .
        "--chinoSimplificado": Chino (Simplificado),
        "--chinoTradicional": Chino (Tradicional), .
        "--corsicano": Kurku simi, .
        "--kroata": Kroata, .
        "--checo": Chiku simi, .
        "--danés": Danés, //d
        "--hivehi": Qhichwa simi, .
        "--dogri": Dogri, .
        "--holandés": Holandés, .
        "--inglés": Quechua, //e
        "--esperanto": Esperanto, .
        "--estonia simi": Estonia simi, .
        "--uwija": Uwija, .
        "--filipino": Filipinas, //f
        "--finlandés": Finlandés, .
        "--francés simi": Francés simipi, .
        "--frisiano": Frisiano, .
        "--galicia": Galicia, //g
        "--georgian": Georgia simi, .
        "--alemán": Aliman simi, .
        "--griego": Grigu simi, .
        "--guarani": Guarani,
        "--gujarati": Gujarati, .
        "--haitianCreole": Haitian criollo, //h
        "--hausa": Hausa, .
        "--hawaiano": Hawaiano, .
        "--hebreo": Hebreo, .
        "--hindi": Qhichwa simipi, .
        "--hmong": Hmong, .
        "--hungaro": Hungría, .
        "--islandés": Islandés simi, //i
        "--igbo": Igbo, .
        "--ilocano": Ilocano, .
        "--indonesia simi": Indonesi simi, .
        "--irlandés": Irlanda simi, .
        "--italiano": italiano, .
        "--japonés": Nihun simi, //j
        "--javanés": Javanés, .
        "--kannada": Kannada, //k
        "--kazakh": Kazakh, .
        "--khmer": Khmer, .
        "--kinyarwanda": Kinyarwanda, .
        "--konkani": Kunkani, .
        "--coreano": Kuriya simi, .
        "--krio": Krio, .
        "--kurdishKurmanji": kurdu simi (Kurmanji),
        "--kurdishSorani": Kurdu (sorani), .
        "--kirguis": Kirguis, .
        "--lao": Lao, //l
        "--latin": latin simipi, .
        "--latunu simi": Letonu simi, .
        "--lingala": Lingala, .
        "--lituano": Lituano, .
        "--luganda": Luganda, .
        "--luxemburgo": Luxemburgo, .
        "--macedoniamanta": Macedoniamanta, //m
        "--maithili": Maithili simi, .
        "--malagasy": Malagasy, .
        "--malay": Malay, .
        "--malayalam": Malayalam, .
        "--malta": Malta simi, .
        "--maori": Maori, .
        "--marathi": Marathi simipi, .
        "--meiteilonManipuri": Meiteilon (Manipuri), .
        "--mizo": Mizo, .
        "--mongol simi": Mongol simi, .
        "--myanmarBirma simi": Myanmar (Birma simi),
        "--nepali": Nepali simi, //n
        "--norwega": Noruega, .
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo, .
        "--pasto": Pashto, //p
        "--persiano": Persia simi, .
        "--pulido": Pula, .
        "--portugués simipi": Purtuyis simipi, .
        "--punjabi": Punu simi, .
        "--quechua": Quechua, //q
        "--rumanu": Rumania, //r
        "--ruso": Rusiya simi, .
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit, .
        "--scotsGaelic": Escocia gaélico, .
        "--sepedi": Sipi simi, .
        "--serbio": Serbia simi, .
        "--sesotho": Qhichwa simipi, .
        "--shona": Shuna, .
        "--sindhi": Sindhi simi, .
        "--sinhala": Sinhala, .
        "--eslovaco": Eslovaco, .
        "--eslovenia": Isluwinu, .
        "--somali": Sumali simi, .
        "--español": Kastilla simipi, .
        "--sundanu": Sundanu, .
        "--swahili simi": Swahili simipi, .
        "--sueco": Sueco, .
        "--tajik": Tajik, //t
        "--tamil": Tamil simipi, .
        "--tatar": Tatar, .
        "--telugu": Telugu, .
        "--tailandés": Tailandia, .
        "--tigrinya": Tigrinya, .
        "--tsonga": Tsonga, .
        "--turku": Turkiya, .
        "--turkmen": Turkmen, .
        "--twi": Twi, .
        "--ukraniano": Ukranya, //u
        "--urdu": Urdu simipi, .
        "--uyghur": Uyghur, .
        "--uzbek": Uzbek, .
        "--vietnamese": Vietnam simi, //v
        "--galés": Galés, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yuruba": Yoruba, .
        "--zulu": Zulu simipi, //z
        },
      },

      // romanian
      // romanian
      romanian: {
        translations: {
          „--an error has occurred”: A apărut o eroare!, //a
          "--address": Adrese,
          „--advice”: sfat,
          „--făcând clic pe continuare”: făcând clic pe continua, veți fi deconectat de la contul dvs. Veil Brillant, //b
          „--făcând clic pe deconectare veți fi deconectat”: făcând clic pe Deconectare veți fi deconectat de la contul dumneavoastră izocash,
          „--verificați numărul virtual sau încercați din nou mai târziu”: verificați numărul virtual sau încercați din nou mai târziu, //c
          „--verifică-ți numărul virtual”: verifică-ți numărul virtual,
          "--continue": Continuați,
          "--connection": Conexiune,
          „--colaborează, trăiește în armonie”: Colaborează, trăiește în armonie cu ceilalți,
          „--choose language”: Limba telefonului virtual,
          „--nu împiedicați competiția”: Nu împiedicați concurența, dați o șansă tuturor, //d
          "--disconnection": Deconectare,
          „--for all virtual phone users”: Pentru toți utilizatorii de telefon virtual, se recomandă utilizarea unui VPN, //f
          „--go to login page”: Accesați pagina de conectare, //g
          „--istoric”: Istoric, //h
          „--am cont”: Am deja un cont, //i
          „--nu am cont”: nu am un cont,
          „--este casa ta”: este casa ta,
          „--image/video +”: imagine/video +,
          „--identity verification”: verificarea identității,
          „--izocash portal pentru clienți”: izocash portal pentru clienți,
          „--identity update every year”: actualizare de identitate în fiecare an,
          „--izocash buy to”: izocash Buy => izocash international,
          „--log in”: Conectați-vă!, //l
          „--login”: Conectați-vă,
          „--login to veil brilliant”: Conectați-vă la Veil Brillant,
          „--login to vixinol store”: Conectați-vă la Vixinol Store,
          „--conectați-vă gratuit la contul dumneavoastră veil Brillant”: conectați-vă gratuit la contul dumneavoastră Veil Brillant pentru a accesa această funcție,
          "--login success": Conectare reușită!,
          "--login now": Conectați-vă acum!,
          "--logout success": Deconectare reușită!,
          "--log out": Deconectare,
          "--logout": Deconectați-vă,
          „--număr”: număr, //n
          "--name": nume,
          "--now log in": Acum, conectați-vă!,
          „--nu interzice înăbușirea concurenței”:
          „--no gelozie, fără ură”: fără gelozie, fără ură, fără diviziuni,
          "--nu Nu,
          „--oficial addresses to access your virtual phone”: adrese oficiale pentru a accesa telefonul virtual, //o
          „--parola”: Parolă, //p
          „--points drawals izocash”: Puncte Retrageri izocash,
          „--points withdrawals”: ​​Retrageri de puncte,
          „--preferably, use a vpn”: de preferință, utilizați un VPN care nu aparține furnizorului dvs. de servicii de internet,
          „--persistence always pay off”: Persistența plătește întotdeauna în final,
          „--rule”: Reguli, //r
          „--recommendation”: Recomandări,
          "--registration": înregistrare,
          „--signup to veil brilliant”: Înregistrați-vă pe Veil Brillant, //s
          „--înregistrați-vă la magazinul vixinol”: Înregistrați-vă pe magazinul Vixinol,
          „--signup”: Înregistrează-te,
          „--signup success”: Înregistrare reușită!,
          „--signup for free”: Înregistrați-vă gratuit,
          „--signup success IA”: Conexiune reușită”,
          "--settings": "Setări",
          „--setting up the alrani app”: configurarea aplicației Alrani,
          „--setting up the izocash app”: configurarea aplicației izocash,
          „--setting up the vixinol app”: configurarea aplicației Vixinol,
          „--setting up the veil Brillant app”: Configurarea aplicației Veil Brillant,
          „--storage of images, videos”: stocarea de imagini, videoclipuri și alte câteva elemente,
          „--viteza de recepție”: viteza de recepție a datelor din centrul de date,
          „--speed”: viteză,
          "--terminate": Terminare, //t
          „--vpn-ul vă permite să accesați”: VPN-ul vă permite să accesați un site sau o aplicație pe care furnizorul dvs. de servicii de internet a inclus-o pe lista neagră,
          „--the greatest tree was above”: Cel mai mare copac era mai presus de toate o simplă sămânță mică,
          „--touch the screen”: atingeți ecranul pentru a continua,
          „--încercați din nou”: Încercați din nou!,
          „--username”: Nume de utilizator, //u

          „--virtual number”: număr virtual, //v
           „--virtual phone settings”: setările telefonului virtual,
           „--Limba telefonului virtual este aplicată”: Limba telefonului virtual este aplicată implicit la nivelul aplicației,
           „--virtual phone”: telefon virtual,
           "--validate": Validați,
           „--bineveniți pe portalul clienților izocash”: Bine ați venit pe portalul clienților izocash, //w
           „--write a super code”: introduceți un super cod,
           „--welcome to”: Bine ați venit la,
           „--unde se duce atenția oamenilor”: Unde se duce atenția oamenilor, merg banii,
           „--winners persevere”: câștigătorii perseverează,
           "--doriți să vă deconectați de la contul dvs. Alrani": doriți să vă deconectați de la contul dvs. Alrani?,
           "--yes": Da, //y

           // țară
           „--congo”: Congo Brazzaville,
           „--camerun”: Camerun,
           „--drc”: RDC,
           „--ivoryCoast”: Coasta de Fildeș,

           // langue
        „--afrikaans”: Afrikaans, //a
        „--albanian”: albaneză,
        „--amharic”: amharic,
        „--arabic”: arabă,
        „--armenian”: armeană,
        „--assamese”: Assamese,
        „--aymara”: Aymara,
        „--azerbaijani”: azer,
        „--bambara”: Bambara, //b
        „--basque”: bască,
        „--belarus”: belarus,
        „--bengali”: bengaleză,
        „--bhojpuri”: Bhojpuri,
        „--bosnian”: bosniacă,
        „--bulgar”: bulgară,
        „--catalan”: catalană, //c
        „--cebuano”: Cebuano,
        "--chichewa": Chichewa,
        „--chineseSimplified”: chineză (simplificată),
        „--chineseTraditional”: chineză (tradițională),
        „--corsican”: corsicană,
        „--croat”: croată,
        „--cehă”: cehă,
        „--danish”: danez, //d
        „--dhivehi”: Dhivehi,
        „--dogri”: Dogri,
        „--olandez”: olandeză,
        „--english”: engleză, //e
        "--esperanto": Esperanto,
        „--estonian”: estonă,
        „--ewe”: oaie,
        „--filipino”: filipineză, //f
        „--finlandeză”: finlandeză,
        „--franceză”: franceză,
        „--frisian”: frizonă,
        „--galician”: Galician, //g
        „--georgian”: georgiană,
        „--german”: germană,
        „--grec”: greacă,
        "--guarani": Guarani,
        „--gujarati”: gujarati,
        „--haitianCreole”: creol haitian, //h
        "--hausa": Hausa,
        „--hawaiian”: hawaian,
        „--hebrew”: ebraică,
        „--hindi”: hindi,
        „--hmong”: Hmong,
        „--hungarian”: maghiară,
        „--islandic”: islandez, //i
        „--igbo”: Igbo,
        „--ilocano”: Ilocano,
        „--indonezian”: indoneziană,
        „--irish”: irlandez,
        „--italian”: italiană,
        „--japonez”: japoneză, //j
        „--javanese”: javaneză,
        „--kannada”: Kannada, //k
        „--kazakh”: kazah,
        „--khmer”: khmer,
        „--kinyarwanda”: kinyarwanda,
        „--konkani”: Konkani,
        „--coreean”: coreeană,
        "--krio": Krio,
        „--kurdishKurmanji”: kurdă (Kurmanji),
        „--kurdishSorani”: kurdă (Sorani),
        „--kyrgyz”: kârgâz,
        "--lao": Lao, //l
        „--latin”: latină,
        „--latvian”: letonă,
        "--lingala": Lingala,
        „--lituanian”: lituaniană,
        "--luganda": Luganda,
        „--luxembourgish”: luxemburgheză,
        „--macedonean”: macedonean, //m
        "--maithili": Maithili,
        „--malgasy”: malgaș,
        „--malay”: malay,
        „--malayalam”: malayalam,
        „--maltese”: malteză,
        "--maori": maori,
        „--marathi”: marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        „--mongolian”: mongolă,
        „--myanmarBurmese”: Myanmar (birman),
        „--nepali”: nepalez, //n
        „--norwegian”: norvegiană,
        „--odiaOriya”: Odia (Oriya), //o
        „--oromo”: Oromo,
        „--pashto”: Pashto, //p
        „--persan”: persan,
        „--polish”: poloneză,
        „--portugheză”: portugheză,
        „--punjabi”: punjabi,
        „--quechua”: Quechua, //q
        „--romanian”: română, //r
        „--rusă”: rusă,
        „--samoan”: Samoan, //s
        „--sanscrit”: sanscrită,
        „--scotsGaelic”: gaelic scoțian,
        „--sepedi”: Sepedi,
        „--sârbă”: sârbă,
        „--sesotho”: Sesotho,
        „--shona”: Shona,
        „--sindhi”: Sindhi,
        „--sinhala”: Sinhala,
        „--slovac”: slovacă,
        „--slovenă”: slovenă,
        „--somali”: somalez,
        „--spaniolă”: spaniolă,
        „--sundanese”: sundanese,
        „--swahili”: Swahili,
        „--swedish”: suedeză,
        „--tajik”: Tadjik, //t
        „--tamil”: tamil,
        „--tatar”: tătar,
        "--telugu": Telugu,
        „--thai”: thailandez,
        „--tigrinya”: Tigrinya,
        „--tsonga”: Tsonga,
        „--turkish”: turcă,
        „--turkmen”: turkmen,
        „--twi”: Twi,
        „--ucraineană”: ucraineană, //u
        "--urdu": Urdu,
        „--uyghur”: uigur,
        „--uzbek”: uzbec,
        „--vietnamez”: vietnameză, //v
        „--welsh”: galeză, //w
        "--xhosa": Xhosa, //x
        „--yiddish”: idiș, //y
        „--yoruba”: yoruba,
        "--zulu": Zulu, //z
        },
      },
*/
      // **russian
      // **russian
      russian: {
        translations: {
          "--an error has occurred": "Произошла ошибка!", //a
           "--address": "Адреса",
           "--advice": "Совет",
           "--by clicking on continue": "нажав «Продолжить», вы будете отключены от своей учетной записи Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "Нажав «Отключить», вы будете отключены от своей учетной записи izocash",
           "--check your virtual number or try again later": "проверьте свой виртуальный номер или повторите попытку позже", //c
           "--check your virtual number": "проверьте свой виртуальный номер",
           "--continue": "Продолжить",
           "--connection": "Соединение",
           "--collaborate, live in harmony": " Сотрудничать, жить в гармонии с другими",
           "--virtual phone language": "язык виртуального телефона",
           "--don't prevent competition": "Не препятствуйте конкуренции, дайте шанс каждому", //d
           "--disconnection": "Отключение",
           "--for all virtual phone users": "всем пользователям виртуальных телефонов рекомендуется использовать VPN", //f
           "--go to login page": "переход на страницу входа", //g
           "--historical": "Исторический", //h
           "--i have account": "у меня уже есть аккаунт", //i
           "--i don't have account": "у меня нет учетной записи",
           "--it is your house": "это твой дом",
           "--image / video +": "Изображение/Видео+",
           "--identity verification": "проверка личности",
           "--izocash customer portal": "клиентский портал izocash",
           "--identity update every year": "Обновление идентификации каждый год",
           "--izocash buy to": "izocash Buy => izocash International",
           "--log in": "Войти!", //l
           "--login": "Войти",
           "--login to veil brillant": "подключитесь к Veil Brillant",
           "--login to vixinol store": "подключиться к магазину Vixinol",
           "--login for free to your veil brillant account": "войдите бесплатно в свою учетную запись Veil Brillant, чтобы получить доступ к этой функции",
           "--login success": "вход успешен!",
           "--login now": "Войдите сейчас!",
           "--logout success": "Выход из системы успешен!",
           "--log out": "Выход из системы",
           "--logout": "выйти из системы",
           "--number": "Число", //n
           "--name": "Имя",
           "--now log in": "Теперь войдите в систему!",
           "--no ban on stifling competition": "--нет запрета на подавление конкуренции",
           "--no jealousy, no hatred": "Нет ревности, нет ненависти, нет разногласий",
           "--no": "нет",
           "--official addresses to access your virtual phone": "официальные адреса для доступа к вашему виртуальному телефону", //o
           "--password": "Пароль", //p
           "--points withdrawals izocash": "Вывод очков izocash",
           "--points withdrawals": "Снятие баллов",
           "--preferably, use a vpn": "желательно использовать VPN, который не принадлежит вашему интернет-провайдеру",
           "--persistence always pays off": "в конце концов настойчивость всегда окупается",
           "--rule": "Правила", //r
           "--recommendation": "Рекомендации",
           "--registration": "Регистрация",
           "--signup to veil brillant": "зарегистрируйтесь на Veil Brillant", //s
           "--signup to vixinol store": "зарегистрируйтесь в магазине Vixinol",
           "--signup": "зарегистрироваться",
           "--signup success": "Регистрация прошла успешно!",
           "--signup for free": "Зарегистрируйтесь бесплатно",
           "--signup success IA": "Соединение успешно»",
           "--settings": "Настройки",
           "--setting up the alrani app": "Настройка приложения Alrani",
           "--setting up the izocash app": "Настройка приложения izocash",
           "--setting up the vixinol app": "Настройка приложения Vixinol",
           "--setting up the veil brillant app": "Настройка приложения Veil Brillant",
           "--storage of images, videos": "Хранение изображений, видео и ряда других элементов",
           "--speed of reception": "Скорость приема данных из Датацентра",
           "--speed": "Скорость",
           "--terminate": "Завершить", //t
           "--the vpn allows you to access": "VPN позволяет вам получить доступ к сайту или приложению, которые ваш интернет-провайдер занес в черный список",
           "--the largest tree was above": "Самое большое дерево было прежде всего простым семенем",
           "--touch the screen": "коснитесь экрана, чтобы продолжить",
           "--try again": "Попробуйте еще раз!",
           "--username": "Имя пользователя", //u
           "--virtual number": "Виртуальный номер", //v
           "--virtual phone settings": "настройки виртуального телефона",
           "--virtual phone language is applied": "язык виртуального телефона применяется на уровне приложения по умолчанию.",
           "--virtual phone": "виртуальный телефон",
           "--validate": "Проверить",
           "--welcome to the izocash customer portal": "Добро пожаловать на клиентский портал izocash", //w
           "--write a super code": "введите суперкод",
           "--welcome to": "Добро пожаловать",
           "--where people's attention goes": "Куда направлено внимание людей, уходят и деньги",
           "--winners persevere": "Победители проявляют настойчивость",
           "--would you like to log out of your Alrani account": "Вы хотите выйти из своей учетной записи Alrani?",
           "--yes": "Да", //y

           // pays
           "--congo": "Конго Браззавиль",
           "--cameroon": "Камерун",
           "--drc": "ДРК",
           "--ivoryCoast": "Кот-д'Ивуар",

        // langues
        "--afrikaans": "африкаанс", //a
        "--albanian": "албанский",
        "--amharic": "амхарский",
        "--arabic": "арабский",
        "--armenian": "Армянский",
        "--assamese": "ассамский",
        "--aymara": "Аймара",
        "--azerbaijani": "азербайджанский",
        "--bambara": "Бамбара", //b
        "--basque": "баскский",
        "--belarusian": "белорусский",
        "--bengali": "бенгальский",
        "--bhojpuri": "бходжпури",
        "--bosnian": "боснийский",
        "--bulgarian": "болгарский",
        "--catalan": "каталонский", //c
        "--cebuano": "кебуано",
        "--chichewa": "Чичева",
        "--chineseSimplified": "китайский (упрощенный)",
        "--chineseTraditional": "китайский (традиционный)",
        "--corsican": "корсиканец",
        "--croatian": "хорватский",
        "--czech": "чешский",
        "--danish": "датский", //d
        "--dhivehi": "Дивехи",
        "--dogri": "Догри",
        "--dutch": "голландский",
        "--english": "английский", //e
        "--esperanto": "эсперанто",
        "--estonian": "эстонский",
        "--ewe": "Овца",
        "--filipino": "филиппинский", //f
        "--finnish": "финский",
        "--french": "французский",
        "--frisian": "фризский",
        "--galician": "галисийский", //g
        "--georgian": "грузинский",
        "--german": "немецкий",
        "--greek": "греческий",
        "--guarani": "Гуарани",
        "--gujarati": "Гуджарати",
        "--haitianCreole": "гаитянский креольский", //h
        "--hausa": "Хауса",
        "--hawaiian": "гавайский",
        "--hebrew": "иврит",
        "--hindi": "хинди",
        "--hmong": "Хмонг",
        "--hungarian": "венгерский",
        "--icelandic": "исландский", //i
        "--igbo": "Игбо",
        "--ilocano": "Илокано",
        "--indonesian": "индонезийский",
        "--irish": "ирландский",
        "--italian": "итальянский",
        "--japanese": "японский", //j
        "--javanese": "яванский",
        "--kannada": "каннада", //k
        "--kazakh": "казахский",
        "--khmer": "кхмерский",
        "--kinyarwanda": "Киньяруанда",
        "--konkani": "Конкани",
        "--korean": "корейский",
        "--krio": "Крио",
        "--kurdishKurmanji": "курдский (Курманджи)",
        "--kurdishSorani": "курдский (Сорани)",
        "--kyrgyz": "кыргызский",
        "--lao": "Лаосский", //l
        "--latin": "латынь",
        "--latvian": "латышский",
        "--lingala": "Лингала",
        "--lithuanian": "литовский",
        "--luganda": "Луганда",
        "--luxembourgish": "люксембургский",
        "--macedonian": "македонский", //м
        "--maithili": "Майтхили",
        "--malagasy": "малагасийский",
        "--malay": "малайский",
        "--malayalam": "малаялам",
        "--maltese": "мальтийский",
        "--maori": "маори",
        "--marathi": "Маратхи",
        "--mizo": "Мизо",
        "--mongolian": "монгольский",
        "--myanmarBurmese": "Мьянма (бирманский язык)",
        "--nepali": "непальский", //n
        "--norwegian": "норвежский",
        "--odiaOriya": "Одия (Ория)", //о
        "--oromo": "Оромо",
        "--pashto": "пушту", //p
        "--persian": "персидский",
        "--polish": "польский",
        "--portuguese": "португальский",
        "--punjabi": "панджаби",
        "--quechua": "кечуа", //q
        "--romanian": "румынский", //r
        "--russian": "Русский",
        "--samoan": "Самоа", //s
        "--sanskrit": "санскрит",
        "--scotsGaelic": "шотландский гэльский",
        "--sepedi": "Сепеди",
        "--serbian": "сербский",
        "--sesotho": "сесото",
        "--shona": "Шона",
        "--sindhi": "Синдхи",
        "--sinhala": "сингальский",
        "--slovak": "словацкий",
        "--slovenian": "словенский",
        "--somali": "Сомали",
        "--spanish": "испанский",
        "--sundanese": "сунданский",
        "--swahili": "суахили",
        "--swedish": "шведский",
        "--tajik": "таджикский", //т
        "--tamil": "тамильский",
        "--tatar": "татарин",
        "--telugu": "телугу",
        "--thai": "тайский",
        "--tigrinya": "Тигринья",
        "--tsonga": "Цонга",
        "--turkish": "турецкий",
        "--turkmen": "туркменский",
        "--twi": "Тви",
        "--ukrainian": "Украинский", //u
        "--urdu": "урду",
        "--uyghur": "Уйгур",
        "--uzbek": "узбек",
        "--vietnamese": "вьетнамский", //v
        "--welsh": "валлийский", //w
        "--xhosa": "коса", //x
        "--yiddish": "Идиш", //у
        "--yoruba": "йоруба",
        "--zulu": "зулу", //z
        },
      },

      /*
      // samoan
      // samoan
      samoan: {
        translations: {
          "--an error has occurred": Ua tupu se mea sese!, //a
           "--address": Tuatusi,
           "--advice": Fautuaga,
           "--i le kiliki i luga o le faaauau": O le kiliki i luga o le faaauau o le ae motusia mai lau veil Brillant account, //b
           "--o le kiliki i luga o le motusia o le a e motusia": O le kiliki i luga o le Disconnect o le ae motusia mai lau izocash account,
           "--check lou virtual number pe toe taumafai mulimuli ane": Siaki lau numera virtual pe toe taumafai mulimuli ane, //c
           "--check your virtual number": Siaki lau numera virtual,
           "--continue": Fa'aauau,
           "--connection": So'oga,
           "--collaborate, ola i le lotogatasi": Galulue, ola i le lotogatasi ma isi,
           "--choose language": Gagana Telefoni,
           "--aua le taofia le tauvaga": Aua le taofia le tauvaga, tuu atu i tagata uma se avanoa, //d
           "--disconnection": motusia,
           "--mo tagata uma e fa'aogaina telefoni feavea'i": Mo tagata uma e fa'aoga Telefoni Fa'amatalaga, e fautuaina e fa'aoga se VPN, //f
           "--go to login page": Alu i le itulau saini, //g
           "--historical": Talafa'asolopito, //h
           "--i have account": Ua uma ona i ai sa'u tala, //i
           "--e leai sa'u tala": E leai sa'u tala,
           "--o lou fale": o lou fale,
           "--image / video +": Ata / Vitio +,
           "--identity verification": Fa'amatalaga fa'asinomaga,
           "--izocash customer portal": izocash Customer Portal,
           "--identity update every year": Fa'afouga fa'asinomaga i tausaga ta'itasi,
           "--izocash fa'atau i": izocash Fa'atau => izocash fa'avaomalo,
           "--log in": Ulufale!, //l
           "--login": Ulufale mai,
           "--login to veil brilliant": Fesootai i Veil Brillant,
           "--login to vixinol store": Fesoʻotaʻi i Vixinol Store,
           "--login for free to your veil Brillant account": Log in free to your Veil Brillant account to access this feature,
           "--login success": Manuia le ulufale!,
           "--login now": Ulufale nei!,
           "--logout success": Manuia le sau i fafo!,
           "--log out": Logo i fafo,
           "--logout": Tu'u ese,
           "--numera": Numera, //n
           "--name": Igoa,
           "--now log in": Ia, Log in!,
           "--leai se fa'asa i le taofiofia o tauvaga":
           "--leai se fuā, leai se ita": Leai se fuā, leai se ita, leai se fevaevaeaʻiga,
           "--leai": Leai,
           "--official addresses to access your virtual phone": Tulaga aloaia e maua ai lau telefoni feaveai, //o
           "--password": Upu faataga, //p
           "--points withdrawals izocash": Points Withdrawals izocash,
           "--points withdrawals": Fa'ai'u togi,
           "--lelei, faʻaaoga se vpn": E sili, faʻaaoga se VPN e le o lau 'auʻaunaga initaneti,
           "--persistence always pays off": O le finafinau e masani lava ona totogi i le iuga,
           "--rule": Tulafono, //r
           "--recommendation": Fautuaga,
           "--registration": Resitala,
           "--signup to veil brilliant": Resitala ile Veil Brillant, //s
           "--signup to vixinol store": Resitala ile Vixinol Store,
           "--signup": Resitala,
           "--signup success": Manuia le lesitala!,
           "--signup for free": Resitala mo le leai o se totogi,
           “--signup success IA”: So’oga manuia”,
           "--settings": "Fa'atonu",
           "--seting up the alrani app": Fa'atonu le Alrani app,
           "--seting up the izocash app": Fa'atonu le talosaga izocash,
           "--seting up the vixinol app": Fa'atonu le Vixinol application,
           "--seting up the veil Brillant app": Fa'atonu le Veil Brillant application,
           "--storage of images, videos": Teuina o ata, vitio ma isi elemene,
           "--speed of reception": Saosaoa o le mauaina o faʻamatalaga mai le Datacenter,
           "--speed": Saosaoa,
           "--terminate": Fa'amuta, //t
           "--o le vpn e mafai ai ona e mauaina": O le VPN e mafai ai ona e mauaina se saite poʻo se talosaga na faʻapipiʻiina e lau 'auʻaunaga initaneti,
           "--o le laau sili ona tele sa i luga": O le laau sili ona maualuga e sili atu nai lo mea uma o se fatu itiiti faigofie,
           "--touch the screen": Pa'i le lau e fa'aauau,
           "--try toe": Toe taumafai!,
           "--username": Username, //u

           "--virtual number": Numera faanumera, //v
           "--virtual phone settings": Fa'atonu telefoni feavea'i,
           "--virtual Phone language is applied": O le gagana Telefoni Telefoni e faʻaaogaina i le tulaga o talosaga e ala i le faaletonu,
           "--virtual phone": Telefoni fa'apitoa,
           "--validate": Fa'amaonia,
           "--faʻafeiloaʻi i le izocash customer portal": Faʻafeiloaʻi i le izocash Customer Portal, //w
           "--write a super code": Ulufale se Super code,
           "--welcome to": Fa'afeiloa'i mai,
           "--o fea e alu i ai le mafaufau o tagata": O fea e alu i ai le mafaufau o tagata e alu i ai tupe,
           "--winners persevere": O ē manumalo e tumau,
           "--e te mana'o e alu ese mai lau Alrani account": E te mana'o e alu ese mai lau Alrani account?,
           "--ioe": Ioe, //y

           // atunuu
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivory Coast": Ivory Coast,

           // gagana
        "--afrikaans": Aferika, //a
        "--albanian": Alapania,
        "--amharic": Amharic,
        "--arabic": Alapi,
        "--armenian": Aremania,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Pelarusia,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnia,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Saina (Fa'afaigofie),
        "--chineseTraditional": Saina (Traditional),
        "--corsican": Corsican,
        "--croatian": Croatian,
        "--czech": Sieki,
        "--danish": Tenimaka, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Holani,
        "--english": Igilisi, //e
        "--esperanto": Esperanto,
        "--estonian": Estonian,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--finnish": Finelani,
        "--french": Falani,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "--german": Siamani,
        "--greek": Eleni,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaii,
        "--hebrew": Eperu,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilokano,
        "--indonesian": Initonesia,
        "--irish": Aialani,
        "--italian": Italia,
        "--japanese": Iapani, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Korea,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latina,
        "--latvian": Lativia,
        "--lingala": Lingala,
        "--lituanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Maketonia, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltese,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Monokolia,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Nouei,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persia": Peresia,
        "--polish": Polani,
        "--portuguese": Potukale,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--russian": Rusia,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Sipaniolo,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Suetena,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Take,
        "--turkmen": Turkmen,
        "--twi": Lua,
        "--ukrainian": Ukaraina, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Uelese, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // sanskrit
      // sanskrit
      sanskrit: {
        translations: {
          "--दोषः अभवत्": त्रुटिः अभवत्!, //a
          "--पता": सम्बोधनानि, .
          "--उपदेशः": उपदेशः, २.
          "-- continue इत्यत्र क्लिक् कृत्वा": continue इत्यत्र क्लिक् कृत्वा भवान् स्वस्य Veil Brillant खातेः विच्छिन्नः भविष्यति, //b
          "--disconnect इत्यत्र क्लिक् कृत्वा भवान् विच्छिन्नः भविष्यति": Disconnect इत्यत्र क्लिक् कृत्वा भवान् स्वस्य izocash खातेः विच्छिन्नः भविष्यति,
          "--भवतः आभासीसङ्ख्यां पश्यन्तु अथवा पश्चात् पुनः प्रयासं कुर्वन्तु": स्वस्य आभासीसङ्ख्यां पश्यन्तु अथवा पश्चात् पुनः प्रयासं कुर्वन्तु, //c
          "--भवतः आभासीसङ्ख्यां पश्यन्तु": स्वस्य आभासीसङ्ख्यां पश्यन्तु,
          "--continue": Continue, .
          "--संयोजनम्": संयोगः, २.
          "--सहकार्यं कुर्वन्तु, सद्भावेन जीवन्तु": सहकार्यं कुर्वन्तु, अन्यैः सह सामञ्जस्यं कुर्वन्तु,
          "--भाषां चिनोतु": आभासी दूरभाषभाषा,
          "--स्पर्धां मा निवारयन्तु": स्पर्धां मा निवारयन्तु, सर्वेभ्यः अवसरं ददातु, //d
          "--विच्छेदः": विच्छेदः, २.
          "--सर्वस्य वर्चुअल् फ़ोन उपयोक्तृणां कृते": सर्वेषां वर्चुअल् फ़ोन उपयोक्तृणां कृते VPN, //f इत्यस्य उपयोगः अनुशंसितः अस्ति
          "--प्रवेशपृष्ठं गच्छतु": प्रवेशपृष्ठं गच्छतु, //g
          "--ऐतिहासिक": ऐतिहासिक, //h
          "--मम खाता अस्ति": मम पूर्वमेव खाता अस्ति, //i
          "--मम लेखः नास्ति": मम लेखः नास्ति,
          "--तव गृहम्": तव गृहम्,
          "--चित्रम् / विडियो +": चित्रम् / विडियो +,
          "--परिचयसत्यापनम्": परिचयसत्यापनम्,
          "--izocash ग्राहक पोर्टल": izocash ग्राहक पोर्टल,
          "--प्रतिवर्षं परिचयस्य अद्यतनीकरणं": प्रतिवर्षं परिचयस्य अद्यतनीकरणं,
          "--izocash buy to": izocash Buy => izocash अन्तर्राष्ट्रीय,
          "--log in": प्रवेशः!, //l
          "--login": प्रवेशः, .
          "--login to veil brilliant": Veil Brillant इत्यनेन सह सम्बद्धं कुर्वन्तु,
          "--login to vixinol store": Vixinol Store इत्यनेन सह सम्बद्धं कुर्वन्तु,
          "--भवतः veil Brillant खाते निःशुल्कं प्रवेशं कुर्वन्तु": एतत् विशेषतां प्राप्तुं स्वस्य Veil Brillant खाते निःशुल्कं प्रवेशं कुर्वन्तु,
          "--login success": प्रवेश सफलः!,
          "--अधुना प्रवेशं कुर्वन्तु": अधुना प्रवेशं कुर्वन्तु!,
          "--लॉगआउट सफलता": लॉगआउट सफल!,
          "--लॉग आउट्": लॉगआउट्, .
          "--logout": लॉग आउट्, .
          "--संख्या": संख्या, //n
          "--नाम": नाम, .
          "--अधुना प्रवेशं कुर्वन्तु": अधुना, प्रवेशं कुर्वन्तु!,
          "--स्पर्धायाः दमनस्य प्रतिबन्धः नास्ति":
          "--न ईर्ष्या न द्वेषः": न ईर्ष्या न द्वेषः न विभागाः,
          "--न": न, .
          "--भवतः आभासी दूरभाषं प्राप्तुं आधिकारिकपत्तनम्": भवतः आभासी दूरभाषं प्राप्तुं आधिकारिकपताः, //o
          "--गुप्तशब्द": गुप्तशब्द, //पृ
          "--बिन्दु निकासी izocash": अंक निकासी izocash,
          "--बिन्दुनिवृत्तिः": बिन्दुनिवृत्तिः, २.
          "--प्राथमिकतया, vpn इत्यस्य उपयोगं कुर्वन्तु": अधिमानतः, VPN इत्यस्य उपयोगं कुर्वन्तु यत् भवतः अन्तर्जालसेवाप्रदातुः नास्ति,
          "--निरोधः सर्वदा फलं ददाति": दृढता सर्वदा अन्ते फलं ददाति,
          "--rule": नियमाः, //r
          "--अनुशंसनम्": अनुशंसाः, २.
          "--पञ्जीकरण": पञ्जीकरण, .
          "--signup to veil brilliant": घूंघट Brillant इत्यत्र पञ्जीकरणं कुर्वन्तु, //s
          "--signup to vixinol store": Vixinol Store इत्यत्र पञ्जीकरणं कुर्वन्तु,
          "--signup": पञ्जीकरणं कुर्वन्तु, .
          "--signup success": पञ्जीकरणं सफलम्!,
          "--निःशुल्कं पञ्जीकरणं कुर्वन्तु": निःशुल्कं पञ्जीकरणं कुर्वन्तु,
          “--signup success IA”: संयोजनं सफलम्”,
          "--सेटिंग्स्": "सेटिंग्स्",
          "--alrani एप्लिकेशनं स्थापयति": Alrani एप्लिकेशनं विन्यस्य,
          "--izocash एप्लिकेशनं स्थापयति": izocash एप्लिकेशनं विन्यस्य,
          "--vixinol एप्लिकेशनं स्थापयति": Vixinol एप्लिकेशनं विन्यस्य,
          "--veil Brillant app इत्यस्य स्थापना": Veil Brillant अनुप्रयोगस्य विन्यासः,
          "--प्रतिबिम्बानां, भिडियोनां भण्डारणम्": चित्राणां, भिडियोनां, अन्येषां च कतिपयानां तत्त्वानां भण्डारणम्,
          "--स्वागतस्य गतिः": Datacenter तः आँकडानां स्वागतस्य गतिः,
          "--वेगः": वेगः, २.
          "--समाप्त": समाप्त, //t
          "--the vpn allows you to access": VPN भवन्तं एकं साइट् अथवा एप्लिकेशनं प्राप्तुं शक्नोति यत् भवतः अन्तर्जालसेवाप्रदाता कालासूचीकृतवान्,
          "--बृहत्तमः वृक्षः उपरि आसीत्": बृहत्तमः वृक्षः सर्वेभ्यः उपरि सरलः अल्पः बीजः आसीत्,
          "--पर्दे स्पर्शं कुर्वन्तु": निरन्तरं कर्तुं पटलं स्पृशन्तु,
          "--पुनः प्रयतस्व": पुनः प्रयासं कुरुत!,
          "--उपयोक्तृनाम": उपयोक्तृनाम, //u

          "--आभासी संख्या": आभासी संख्या, //v
           "--वर्चुअल् फ़ोन सेटिंग्स्": वर्चुअल् फ़ोन सेटिंग्स्,
           "--virtual Phone language is applied": Virtual Phone भाषा पूर्वनिर्धारितरूपेण अनुप्रयोगस्तरस्य प्रयुक्ता भवति,
           "--वर्चुअल् फ़ोन": वर्चुअल् फ़ोन,
           "--validate": प्रमाणीकरणं, .
           "--izocash ग्राहक पोर्टल् मध्ये स्वागतम्": izocash ग्राहक पोर्टल् मध्ये स्वागतम्, //w
           "--सुपर कोडं लिखन्तु": सुपर कोडं प्रविशन्तु,
           "--स्वागतम्": स्वागतम्,
           "--यत्र जनानां ध्यानं गच्छति": यत्र जनानां ध्यानं गच्छति धनं गच्छति,
           "--विजेतारः धैर्यं कुर्वन्ति": विजेतारः धैर्यं धारयन्ति,
           "--किं भवान् स्वस्य अलरानी खातेः बहिः गन्तुं इच्छति": भवान् स्वस्य अलरानी खातेः बहिः गन्तुं इच्छति वा?,
           "--आम्": आम्, //य

           // देशः
           "--कांगो": काङ्गो ब्राज्जाविले, 1999।
           "--कैमरून": कैमरून, २.
           "--drc": डीआरसी, 1999।
           "--ivoryCoast": हस्तिदन्त तट, 1999।

           // लङ्गे
        "--afrikaans": आफ्रिकान्स, //a
        "--अल्बेनियाई": अल्बेनियाई, .
        "--अम्हारिक": अम्हारिक, .
        "--अरबी": अरबी, .
        "--आर्मेनिया": आर्मेनियाई, २.
        "--assamese": असमिया, ९.
        "--अयमारा": आयमारा, ९.
        "--अजरबैजानी": अजरबैजानी,
        "--बम्बरा": बम्बरा, //b
        "--बास्क": बास्क, .
        "--बेलारूसी": बेलारूसी, २.
        "--बङ्गली": बंगला,
        "--bhojpuri": भोजपुरी,
        "--बोस्नियाई": बोस्नियाई, २.
        "--बल्गेरियाई": बल्गेरियाई, २.
        "--catalan": कातालान, //c
        "--सेबुआनो": सेबुआनो, 1999।
        "--चिचेवा": चिचेवा, ९.
        "--chineseSimplified": चीनी (सरलीकृत),
        "--chineseTraditional": चीनी (पारम्परिक),
        "--कोर्सिकन": कोर्सिकन, २.
        "--क्रोएशियाई": क्रोएशियाई, २.
        "--चेक": चेक, .
        "--danish": डेनिश, //d
        "--धिवेहि": धिवेहि, ९.
        "--dogri": डोगरी, ९.
        "--डच": डच, २.
        "--अङ्ग्रेजी": English, //e
        "--एस्पेरान्तो": एस्पेरान्तो, २.
        "--एस्टोनियाई": एस्टोनियाई, .
        "--मेषः": मेषः, २.
        "--filipino": फिलिपिनो, //f
        "--फिनिश": फिनिश, २.
        "--फ्रेंच": फ्रेंच, .
        "--फ्रीजियन": फ्रीजियन, .
        "--galician": गैलिशियन्, //g
        "--जॉर्जियन": जॉर्जियाई,
        "--जर्मन": जर्मन,
        "--ग्रीक": ग्रीक, २.
        "--गुआरानी": गुआरानी, २.
        "--गुजरती": गुजराती, ९.
        "--haitianCreole": हैतीयन क्रियोल, //h
        "--हौसा": हौसा, ९.
        "--हवाई": हवाई,
        "--हिब्रू": हिब्रू, २.
        "--हिन्दी": हिन्दी, २.
        "--ह्मोंग": हमोङ्ग, २.
        "--हङ्गरी": हङ्गरी,
        "--आइसलैण्डिक": आइसलैण्डिक, //i
        "--इग्बो": इग्बो, २.
        "--इलोकानो": इलोकानो, २.
        "--इण्डोनेशियाई": इन्डोनेशियाई, २.
        "--इरिश": आयरिश, २.
        "--इटालियन": इटालियन,
        "--जापानी": जापानी, //j
        "--javanese": जावानी, .
        "--कन्नड": कन्नड, //k
        "--कजाख": कजाख, २.
        "--खमेर": ख्मेर, ९.
        "--किन्यरवाण्डा": किन्यरवाण्डा,
        "--konkani": कोंकणी, ९.
        "--कोरियन": कोरियाई, .
        "--क्रिओ": क्रिओ, ९.
        "--kurdishKurmanji": कुर्द (कुर्मनजी),
        "--kurdishSorani": कुर्द (सोरानी),
        "--kyrgyz": किर्गिज़, 1999।
        "--लाओ": लाओ, //l
        "--लैटिन": लैटिन, .
        "--लाट्वियन्": लाट्वियन्, .
        "--लिंगला": लिङ्गला, ९.
        "--लिथुआनियाई": लिथुआनियाई,
        "--लुगाण्डा": लुगाण्डा, २.
        "--luxembourgish": लक्समबर्ग, 1999।
        "--मैसिडोनियाई": मैसिडोनियाई, //m
        "--मैथिली": मैथिली, २.
        "--मालागासी": मालागासी, २.
        "--मलय": मलय, २.
        "--मलयालम्": मलयालम्,
        "--माल्टीज": माल्टीज, २.
        "--माओरी": माओरी, २.
        "--मराठी": मराठी, २.
        "--meiteilonManipuri": Meiteilon (मणिपुरी),
        "--मिजो": मिजो, २.
        "--मॉन्गोलियन": मंगोलियन, .
        "--myanmarबर्मी": म्यांमार (बर्मी),
        "--नेपाली": नेपाली, //n
        "--नॉर्वे": नार्वे, २.
        "--ओडियाओरिया": ओडिया (ओरिया), //o
        "--ओरोमो": ओरोमो, २.
        "--पश्तो": पश्तो, //पृ
        "--फारसी": फारसी, २.
        "--पालिश": पोलिश, .
        "--पुर्तगाली": पुर्तगाली, २.
        "--punjabi": पंजाबी, 1999।
        "--क्वेचुआ": क्वेचुआ, //q
        "--रोमानियन": रोमानियाई, //r
        "--रूसी": रूसी, .
        "--समोआन्": समोआन्, //स
        "--संस्कृतम्": संस्कृतम्, २.
        "--scotsGaelic": स्कॉट्स गैलिक, 1999।
        "--सेपेडी": सेपेडी, 1999।
        "--सर्बियाई": सर्बियाई, २.
        "--सेसोथो": सेसोथो, ९.
        "--शोना": शोना, ९.
        "--सिंधी": सिन्धी, ९.
        "--सिन्हल": सिंहल,
        "--स्लोवाक": स्लोवाक, .
        "--स्लोवेनियाई": स्लोवेनियाई, २.
        "--सोमाली": सोमाली, ९.
        "--स्पेनिश": स्पैनिश, .
        "--सुन्दनीस": सुण्डनीस, २.
        "--स्वाहिली": स्वाहिली, २.
        "--स्वीडिश": स्वीडिश, २.
        "--ताजिक": ताजिक, //त
        "--तमिल": तमिल, ९.
        "--तातार": तातार, ९.
        "--तेलुगु": तेलुगु, २.
        "--थाई": थाई, ९.
        "--tigrinya": तिग्रिण्य, 1999।
        "--त्सोङ्गा": त्सोङ्गा, ९.
        "--तुर्की": तुर्की, २.
        "--तुर्कमेन": तुर्कमेन, २.
        "--ट्वि": ट्वि, .
        "--यूक्रेनी": यूक्रेनी, //u
        "--urdu": उर्दू, ९.
        "--उयघुर": उयघुर, ९.
        "--उज्बेक": उज्बेक,
        "--वियतनाम": वियतनामी, //v
        "--वेल्श": वेल्श, //w
        "--xhosa": Xhosa, //x
        "--यिद्दिश": यिद्दीश, //य्
        "--योरुबा": योरुबा, २.
        "--zulu": ज़ुलु, //z
        },
      },  

      // Scots (Gaelic)
      // Scots (Gaelic)
      scotsGaelic: {
        translations: {
          " --an error has thachair": Thachair mearachd!, //a
           "--address": seòlaidhean,
           "--comhairle": Comhairle,
           "--by clicking on continue": Le bhith a’ briogadh air lean air adhart thèid do dhì-cheangal bhon chunntas Veil Brillant agad, //b
           "--le bhith a’ briogadh air dì-cheangal thèid do dhì-cheangal": Ma bhriogas tu air Disconnect thèid do dhì-cheangal on chunntas izocash agad,
           " --check your virtual number or try again later": Thoir sùil air an àireamh mas-fhìor agad no feuch ris a-rithist nas anmoiche, //c
           "--check your virtual number": Thoir sùil air an àireamh bhrìgheil agad,
           "--continue": Lean air adhart,
           "--connection": Ceangal,
           "--co-obraich, fuirich ann an co-sheirm": Co-obraich, fuirich ann an co-chòrdadh ri daoine eile,
           "--choose language": Cànan Fòn Mas-fhìor,
           "--na cuir casg air farpais": Na cuir casg air farpais, thoir cothrom don h-uile duine, //d
           "--disconnection": Dì-cheangal,
           "--airson a h-uile neach-cleachdaidh fòn mas-fhìor": Airson a h-uile neach-cleachdaidh Fòn Mas-fhìor, thathas a’ moladh VPN a chleachdadh, //f
           "--go to login page": Rach dhan duilleag logaidh a-steach, //g
           "--eachdraidheil": Eachdraidheil, //h
           "--i have account": Tha cunntas agam mu thràth, //i
           "--chan eil cunntas agam": chan eil cunntas agam,
           "--se do thaigh": 's e do thaigh a th' ann,
           "--image / video +": Ìomhaigh / Bhidio +,
           "--identity verification": dearbhadh dearbh-aithne,
           "--izocash portal teachdaiche": portal teachdaiche izocash,
           "--aithneachadh gach bliadhna": ùrachadh dearbh-aithne gach bliadhna,
           "--izocash buy to": izocash Buy => izocash eadar-nàiseanta,
           "--log in": Log a-steach!, //l
           "--login": Log a-steach,
           "--login to veil sgoinneil": Ceangail ri Veil Brillant,
           "--login to vixinol store": Ceangail ri Stòr Vixinol,
           "--login an-asgaidh don chunntas Brillant veil agad": Log a-steach an-asgaidh don chunntas Veil Brillant agad gus am feart seo fhaighinn,
           "--login success": Shoirbhich le logadh a-steach!,
           "--login now": Log a-steach an-dràsta!,
           "--logout success": Shoirbhich leis an t-suaicheantas!,
           "--log out": Suaicheantas a-mach,
           "--logout": Log a-mach,
           "--number": Àireamh, //n
           "--name": Ainm,
           "--now log in": A-nis, Log a-steach!,
           "--gun casg air farpais bacadh":
           "--gun eud, gun fhuath": Gun eud, gun fhuath, gun sgaradh,
           "--chan eil": Chan eil,
           "--seòlaidhean oifigeil gus faighinn chun fhòn brìgheil agad": Seòlaidhean oifigeil gus faighinn chun fhòn brìgheil agad, //o
           "--password": Facal-faire, //p
           "--points pulls izocash": puingean tarraing air ais izocash,
           "--pointstarraing air ais": Puingean a tharraing air ais,
           "--preferably, use a vpn": Mas fheàrr, cleachd VPN nach buin don t-solaraiche seirbheis eadar-lìn agad,
           "-- bidh seasmhachd an-còmhnaidh a 'pàigheadh ​​​​dheth": bidh seasmhachd an-còmhnaidh a 'pàigheadh ​​​​dheth aig a' cheann thall,
           "--rule": Riaghailtean, //r
           "--moladh": Molaidhean,
           "--registration": Clàradh,
           "--signup to veil sgoinneil": Clàr air Veil Brillant, //s
           "--signup gu stòr vixinol": Clàraich air Stòr Vixinol,
           "--signup": Clàr,
           "--signup success": Shoirbhich le clàradh!,
           "--signup an-asgaidh": Clàraich an-asgaidh,
           “--signup success IA”: Ceangal soirbheachail”,
           "--settings": "Roghainnean",
           "--setting an app alrani": A' rèiteachadh an aplacaid Alrani,
           "--stèidheachadh an aplacaid izocash": A' rèiteachadh an aplacaid izocash,
           "--stèidheachadh an aplacaid vixinol": A' rèiteachadh an aplacaid Vixinol,
           "--stèidheachadh an app Brillant veil": A’ rèiteachadh an aplacaid Veil Brillant,
           "--stòradh ìomhaighean, bhideothan": Stòradh ìomhaighean, bhideothan agus grunn eileamaidean eile,
           "--speed of fàilteachaidh": Astar glacaidh an dàta bhon Datacenter,
           "--speed": Astar,
           "--terminate": Crìochnaich, //t
           "--the vpn a 'toirt cothrom dhut faighinn a-steach": Leigidh an VPN leat faighinn gu làrach no aplacaid a chuir an solaraiche seirbheis eadar-lìn agad air liosta dhubh,
           "--bha an craobh as motha gu h-àrd": 'S e sìol beag sìmplidh a bh' anns a' chraobh a bu mhotha os cionn a h-uile càil,
           "--touch the screen": Tap air an sgrion gus leantainn air adhart,
           "--try again": Feuch ris a-rithist!,
           "--username": Ainm-cleachdaidh, //u

           "--virtual number": Àireamh mas-fhìor, //v
           "--roghainnean fòn mas-fhìor": Roghainnean fòn mas-fhìor,
           "-- cànan fòn brìgheil air a chuir an sàs": Tha an cànan Fòn Mas-fhìor air a chuir an sàs aig ìre an tagraidh gu bunaiteach,
           "--fòn brìgheil": Fòn mas-fhìor,
           "--validate": Dearbhaich,
           "--welcome gu portal teachdaiche izocash": Fàilte gu Portal Luchd-ceannach izocash, //w
           "--write a super code": Cuir a-steach sàr chòd,
           "--welcome to": Fàilte gu,
           "--far an tèid aire dhaoine": Far an tèid aire dhaoine airgead,
           "--winners persevere": Tha na buannaichean a 'leantainn air adhart,
           "--would you like to log out of your Alrani account": A bheil thu airson logadh a-mach às a’ chunntas Alrani agad?,
           "--yes": Tha, //y

           // dùthaich
           "--congo": Congo Brazzaville,
           "--cameroon": Camarún,
           "--drc": DRC,
           "--ivoryCoast": Costa Ivory,

           // cànan
        "--afracach": Afrikaans, //a
        "--albanian": Albanach,
        "--amharic": Amarais,
        "--Arabais": Arabais,
        "--armenian": Armenia,
        "--asamese": Asaimis,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basgais,
        "--Bealarúisis": Bealarúisis,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnian,
        "--bulgarian": Bulgàiris,
        "--catalan": Catalanais, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Sìnis (Sìmplidh),
        "--chineseTraditional": Sìnis (Traidiseanta),
        "--corsaiceach": Corsican,
        "-- croatian": Croatia,
        "--czech": Seiceach,
        "--danish": Danmhairgis, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Duitseach": Duitsis,
        "--english": Beurla, //e
        "--esperanto": Esperanto,
        "--estonian": Eastoiniach,
        "--ewe": Ewe,
        "--filipino": Filipineach, //f
        "--Fionnlannach": Fionnlannach,
        "--Fraingis": Fraingis,
        "--frisian": Frisianach,
        "--galician": Galician, //g
        "--Georgian": Seòrasach,
        "--Gearmailtis": Gearmailtis,
        "--Greugais": Greugais,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--eabhra": Eabhra,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--Hungarian": Ungairis,
        "--icelandic": Innis Tìle, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "-- indonesian": Indonesia,
        "--irish": Gaeilge,
        "--Eadailtis": Eadailtis,
        "--japanese": Seapanais, //j
        "--javanese": Iàvanais,
        "--kannada": Cannadais, //k
        "--kazakh": Kazakh,
        "--khmer": Ciméiris,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--Corea": Coirèanais,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Laideann,
        "--Laitvis": Laitvis,
        "--lingala": Lingala,
        "--lithuanian": Liotuàinis,
        "--luganda": Luganda,
        "--luxembourgish": Lucsamburg,
        "--macedonian": Macedonian, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Maltais,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmais": Myanmar (Burmais),
        "--nepali": Nepali, //n
        "--norwegian": Nirribhidh,
        "--odiaOriya": Odia (Oria), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Peirsis,
        "--polish": Pòlainnis,
        "--portuguese": Portagailis,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Ròmanach, //r
        "--russian": Ruiseanach,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Gàidhlig na h-Alba,
        "--sepedi": Sepedi,
        "--serbian": Sèirbis,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slòbhac": Slòcais,
        "--slovenian": Slobhiniach,
        "--somali": Somali,
        "--spanish": Spàinntis,
        "--sundanese": Sundais,
        "--swahili": Swahili,
        "--suaineach": Suainis,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinis,
        "--tsonga": Tsonga,
        "--turkish": Turcais,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": Ucràinis, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Bhietnam, //v
        "--welsh": Cuimris, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // sepedi
      // sepedi
      sepedi: {
        translations: {
          "--phošo e diregile": Phošo e diregile!, //a
           "--aterese": Diaterese, .
           "--keletšo": Keletšo, .
           "--ka go kgotla go tšwela pele": Ka go kgotla go tšwela pele o tla kgaolwa go akhaonto ya gago ya Veil Brillant, //b
           "--ka go kgotla go kgaotša o tla kgaolwa": Ka go kgotla go Kgaola o tla kgaolwa go akhaonto ya gago ya zocash,
           "--hlahloba nomoro ya gago ya go bonagala goba o leke gape ka morago": Lekola nomoro ya gago ya go bonagala goba o leke gape ka morago, //c
           "--hlahloba nomoro ya gago ya go bonagala": Lekola nomoro ya gago ya go bonagala,
           "--tšwela pele": Tšwela pele,
           "---kgokagano": Kgokagano, .
           "--dirišana, phela ka kwano": Dirišana, phela ka kwano le ba bangwe, .
           "--kgetha polelo": Polelo ya Mogala ya Boikgopolelo, .
           "--o se ke wa thibela phadišano": O se ke wa thibela phadišano, fa bohle sebaka, //d
           "--go kgaolwa": Kgaogano, .
           "--go badiriši ka moka ba mogala wa go bonagala": Bakeng sa badiriši ka moka ba Mogala wa go bonagala, go kgothaletšwa go diriša VPN, //f
           "--eya letlakaleng la go tsena": Eya letlakaleng la go tsena, //g
           "--histori": Histori, //h
           "--ke na le akhaonto": Ke šetše ke na le akhaonto, // ke
           "--ga ke na account": Ga ke na account,
           "--ke ntlo ya gago": ke ntlo ya gago, .
           "--setšoantšo / video +": Setšoantšo / Video +,
           "--netefatšo ya boitšhupo": Netefatšo ya boitšhupo, .
           "--kgoro ya bareki ya izocash": Kgoro ya bareki ya izocash,
           "--mpshafatšo ya boitšhupo ngwaga o mongwe le o mongwe": Mpshafatšo ya boitšhupo ngwaga o mongwe le o mongwe,
           "--izocash reka go": izocash Reka => izocash ya boditšhabatšhaba,
           "--tsena ka gare": Tsena!, //l
           "--go tsena": Tsena, .
           "--tsena go seširo brilliant": Kgokagana le Seširo Brillant, .
           "--tsena lebenkeleng la vixinol": Ikgokaganye le Lebenkele la Vixinol,
           "--tsena mahala akhaontong ya gago ya Veil Brillant": Tsena mahala akhaontong ya gago ya Veil Brillant go fihlelela tšobotsi ye,
           "--katlego ya go tsena": Go tsena go atlegile!,
           "--tsena bjale": Tsena bjale!,
           "--logout katlego": Logout atlegile!,
           "--go tšwa": Tloga, .
           "--logout": Tšwa ka ntle, .
           "--nomoro": Nomoro, //n
           "--lebitso": Lebitso, .
           "--bjale tsena": Bjale, Tsena!,
           "--ga go na thibelo ya go thibela phadišano":
           "--ga go na lehufa, ga go na lehloyo": Ga go na lehufa, ga go na lehloyo, ga go na dikarogano,
           "--aowa": Aowa, .
           "--diaterese tša semmušo tša go fihlelela mogala wa gago wa go bonagala": Diaterese tša semmušo tša go fihlelela mogala wa gago wa go bonagala, //o
           "--phasewete": Phasewete, //letl
           "--dintlha tša go ntšha tšhelete izocash": Dintlha tša go ntšha tšhelete izocash, .
           "--go gogwa ga dintlha": Go gogwa ga dintlha, .
           "--ka go kgethwa, šomiša vpn": Ka go kgethwa, šomiša VPN yeo e sego ya moabi wa gago wa tirelo ya inthanete,
           "--go phegelela go dula go lefa": Go phegelela go dula go lefa mafelelong,
           "--molao": Melawana, //r
           "--tšhišinyo": Ditšhišinyo, .
           "--ngwadišo": Boingwadišo, .
           "--saena go lesira brilliant": Ngwadiša go Seširo Brillant, //s
           "--ingwadiše lebenkeleng la vixinol": Ngwadiša go Lebenkele la Vixinol,
           "--go saena": Ngwadiša, .
           "--katlego ya go ingwadiša": Boingwadišo bo atlegile!,
           "--saena mahala": Ngwadiša mahala,
           “--katlego ya go ingwadiša IA”: Kgokagano e atlegile”,
           "--dipeakanyo": "Dipeakanyo",
           "--go hloma tirišo ya alrani": Go beakanya tirišo ya Alrani, .
           "--go hloma tirišo ya izocash": Go beakanya tirišo ya izocash, .
           "--go hloma tirišo ya vixinol": Go beakanya tirišo ya Vixinol, .
           "--go hloma tirišo ya lesira Brillant": Go beakanya tirišo ya Veil Brillant,
           "--polokelo ya diswantšho, dibidio": Polokelo ya diswantšho, dibidio le dielemente tše dingwe tše mmalwa,
           "--lebelo la kamogelo": Lebelo la kamogelo ya data go tšwa go Datacenter, .
           "--lebelo": Lebelo, .
           "--fediša": Fediša, //t
           "--vpn e go dumelela go fihlelela": VPN e go dumelela go tsena lefelong goba tirišo yeo moabi wa gago wa ditirelo tša inthanete a e beilego lenaneong le leso,
           "--sehlare se segolo se be se le ka godimo": Sehlare se segolo kudu e be e le ka godimo ga tšohle peu ye nnyane ye bonolo, .
           "--kgwatha skrine": Kgwatha skrine ho tsoela pele,
           "--leka gape": Leka gape!,
           "--lebitso la mosebedisi": Lebitso la mosebedisi, //u

           "--nomoro ya go bonagala": Nomoro ya go bonagala, //v
           "--dipeakanyo tša mogala wa go bonagala": Dipeakanyo tša mogala wa go bonagala, .
           "--puo ya Mogala ya go bonagala e dirišwa": Polelo ya Mogala wa go bonagala e dirišwa maemong a tirišo ka go ikemela, .
           "--mogala wa go bonagala": Mogala wa go bonagala, .
           "--netefatša": Netefatša, .
           "--re amogetšwe kgorong ya bareki ya izocash": O amogetšwe kgorong ya bareki ya izocash, //w
           "--ngwala khoutu ya super": Kenya khoutu ya Super, .
           "--re amogetšwe go": O amogetšwe go,
           "--moo tlhokomelo ya batho e yago gona": Moo tlhokomelo ya batho e yago tšhelete e ya,
           "--bafenyi ba phegelela": Bafenyi ba phegelela, .
           "--na o ka rata go tšwa akhaontong ya gago ya Alrani": Na o nyaka go tšwa akhaontong ya gago ya Alrani?,
           "--ee": Ee, //y

           // naga
           "--kongo": Kongo Brazzaville, .
           "--cameroon": Cameroon, 2019.
           "--drc": DRC, 1999.
           "--Lebopo la tlou": Lebopo la tlou, .

           // polelo
        "--afrikaans": Seafrikaans, //a
        "--sealbania": Sealbania, .
        "--seamharic": Seamharic, .
        "--searabia": Searabia, .
        "--armenia": Searmenia, .
        "--se-assamese": Seassamese, .
        "--aymara": Seymara, .
        "--se-azerbaijani": Seazerbaijani, .
        "--bambara": Bambara, //b
        "--basque": Sebasque, .
        "--belarusian": Sebelarusian, .
        "--bengali": Sebengali, .
        "--bhojpuri": Setswana, .
        "--bosnia": Bosnia, .
        "--bulgaria": Sebulgaria, .
        "--secatalan": Secatalan, //c
        "--cebuano": Secebuano, .
        "--chichewa": Chichewa, .
        "--chineseSimplified": Setšhaena (E nolofaditšwe), .
        "--chineseSetšo": Sechaena (Setso), .
        "--korsika": Sekorsika, .
        "--se-croatia": Secroatia, .
        "--czech": Seczech, .
        "--danish": Sedanishe, //d
        "--thivehi": Setswana, .
        "--dogri": Setswana, .
        "--dutch": Sedache, .
        "--sepedi": Sepedi, //e
        "--esperanto": Seesperanto, .
        "--estonia": Seestonia, .
        "--tshadi": Kgae ya tshadi, .
        "--filipino": Sefilipino, //f
        "--sefinnishe": Sefinnishe, .
        "--sefora": Sefora, .
        "--frisian": Sefrisia, .
        "--galician": Segalicia, //g
        "--Georgia": Segeorgia, .
        "--sejeremane": Sejeremane, .
        "--segerika": Segerika, .
        "--guarani": Seguwarani, .
        "--segujarati": Segujarati, .
        "--haitianCreole": Secreole sa Haiti, //h
        "--hausa": Setswana, .
        "--hawaii": Sehawaii, .
        "--seheberu": Seheberu, .
        "--hindi": Sehindi, .
        "--hmong": Sehmong, .
        "--sehungary": Sehungary, .
        "--se-iceland": Se-Iceland, //i
        "--igbo": Sekgoba, .
        "--ilocano": Ilocano, .
        "--se-indonesia": Se-Indonesia, .
        "--irish": Se-Irish, .
        "--setaliana": Setaliana, .
        "--sejapane": Sejapane, //j
        "--sejavanese": Sejavanese, .
        "--kannada": Sekannada, //k
        "--kazakh": Sekazakh, .
        "--khmer": Khmer, .
        "--kinyarwanda": Sekinyarwanda, .
        "--konkani": Sekonkana, .
        "--sekorea": Sekorea, .
        "--krio": Krio, .
        "--kurdishKurmanji": Sekurd (Kurmanji), .
        "--kurdishSorani": Sekurde (Sorani), .
        "--kyrgyz": Sekirgyz, .
        "--lao": Lao, //l
        "--selatine": Selatine, .
        "--latvia": Selatvia, .
        "--lingala": Sengala, .
        "--se-lithuania": Selithuania, .
        "--luganda": Setswana, .
        "--luxembourgish": Sebopego sa Luxembourgish, .
        "--makedonia": Momatsedonia, //m
        "--maithili": Setswana, .
        "--semalagasy": Semalagasy, .
        "--malay": Semalay, .
        "--malayalam": Semalayalam, .
        "--maleta": Semalta, .
        "--maori": Maori, .
        "--marathi": Semarathi, .
        "--meiteilonManipuri": Meiteilon (Manipuri), .
        "--mizo": Setswana, .
        "--mongolia": Semongolia, .
        "--myanmarBurmese": Myanmar (Seburmase), .
        "--nepali": Senepali, //n
        "--se-norway": Se-Norway, .
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Sesotho, .
        "--pashto": Sepashto, //letl
        "--seperesia": Seperesia, .
        "--polish": Poland, .
        "--sepotokisi": Sepotokisi, .
        "--punjabi": Sepunjabi, .
        "--quechua": Sequechua, //q
        "--romania": Seromania, //r
        "--Russia": Serussia, .
        "--samoan": Sesamoa, //s
        "--sanskrit": Sesanskrit, .
        "--scotsGaelic": Segaelic sa Scots, .
        "--sepedi": Sepedi, .
        "--seserbia": Seserbia, .
        "--sesotho": Sesotho, .
        "--shona": Sesona, .
        "--sindhi": Sesindhi, .
        "--sesinhala": Sesinhala, .
        "--se-slovak": Seslovak, .
        "--se-slovenia": Seslovenia, .
        "--somali": Sesomali, .
        "--sepaniši": Sepaniši, .
        "--se-sundane": Sesundane, .
        "--swahili": Seswahili, .
        "--swedish": Seswedishe, .
        "--tajik": Setajik, //t
        "--tamil": Setamil, .
        "--tatar": Tatar, .
        "--telugu": Setelugu, .
        "--thai": Sethai, .
        "--tigrinya": Setswana, .
        "--tsonga": Setsonga, .
        "--seturkey": Seturkey, .
        "--turkmen": Turkmen, .
        "--twi": Twi, .
        "--se-ukraine": Seukraine, //u
        "--urdu": Seurdu, .
        "--uyghur": Uyghur, .
        "--se-uzbek": Seuzbek, .
        "--se-vietnamese": Sevietnam, //v
        "--welsh": Sewalese, //w
        "--xhosa": Sesosa, //x
        "--se-yiddish": Seyiddish, //y
        "--yoruba": Seyoruba, .
        "--zulu": Sezulu, //z
        },
      },

      // serbian
      // serbian
      serbian: {
        translations: {
          "--дошло је до грешке": Дошло је до грешке!, //а
           "--аддресс": Адресе,
           "--адвице": Савет,
           "--кликом на настави": Кликом на наставак бићете искључени са вашег Веил Бриллант налога, //б
           "--кликом на прекинути везу бићете прекинути": Кликом на Прекини везу бићете искључени са свог изоцасх налога,
           "--проверите виртуелни број или покушајте поново касније": Проверите свој виртуелни број или покушајте поново касније, //ц
           "--провери свој виртуелни број": Проверите свој виртуелни број,
           "--цонтинуе": Настави,
           "--цоннецтион": Веза,
           "--сарађујте, живите у хармонији": Сарађујте, живите у хармонији са другима,
           "--одабери језик": Виртуелни језик телефона,
           "--не спречавај конкуренцију": Не спречавај конкуренцију, дај свима шансу, //д
           "--дисцоннецтион": Искључивање,
           „--за све кориснике виртуелних телефона“: За све кориснике виртуелног телефона, препоручује се коришћење ВПН-а, //ф
           "--иди на страницу за пријаву": Иди на страницу за пријаву, //г
           "--хисторицал": Историјски, //х
           "--имам налог": Већ имам налог, //и
           "--немам налог": Немам налог,
           "--то је твоја кућа": то је твоја кућа,
           "--слика / видео +": Слика / видео +,
           "--верификација идентитета": верификација идентитета,
           „--изоцасх кориснички портал“: изоцасх кориснички портал,
           "--ажурирање идентитета сваке године": ажурирање идентитета сваке године,
           "--изоцасх буи то": изоцасх Купи => изоцасх интернатионал,
           "--лог ин": Пријавите се!, //л
           "--логин": Пријавите се,
           "--логин то Веил Бриллант": Повежите се са Веил Бриллант,
           "--логин то викинол сторе": Повежите се са продавницом Викинол,
           "--пријавите се бесплатно на свој Веил Бриллант налог": Пријавите се бесплатно на свој Веил Бриллант налог да бисте приступили овој функцији,
           "--логин суццесс": Пријава је успела!,
           "--логин нов": Пријавите се сада!,
           "--логоут суццесс": Одјава је успела!,
           "--лог оут": Одјава,
           "--логоут": Одјавите се,
           "--број": Број, //н
           "--наме": Име,
           "--сад лог ин": Сада, пријавите се!,
           "--нема забране гушења конкуренције":
           "--нема љубоморе, нема мржње": Нема љубоморе, нема мржње, нема подела,
           "--не": Не,
           "--званичне адресе за приступ виртуелном телефону": званичне адресе за приступ виртуелном телефону, //о
           "--пассворд": Лозинка, //стр
           "--поени повлачења изоцасх": Повлачења поена изоцасх,
           "--повлачење поена": Повлачење поена,
           "--пожељно, користите впн": Пожељно је да користите ВПН који не припада вашем добављачу интернет услуга,
           "--упорност се увек исплати": Упорност се на крају увек исплати,
           "--руле": Правила, //р
           "--рецоммендатион": Препоруке,
           "--регистратион": Регистрација,
           "--пријава за веил бриллиант": Региструјте се на Веил Бриллант, //с
           "--пријава за продавницу викинол": Региструјте се на продавници Викинол,
           "--сигнуп": Региструјте се,
           "--сигнуп суццесс": Регистрација је успела!,
           "--региструјте се бесплатно": Региструјте се бесплатно,
           “--успех регистрације ИА”: Веза је успела”,
           "--сеттингс": "Подешавања",
           "--подешавање апликације алрани": Конфигурисање апликације Алрани,
           "--подешавање изоцасх апликације": Конфигурисање изоцасх апликације,
           "--подешавање апликације викинол": Конфигурисање апликације Викинол,
           "--подешавање апликације Веил Бриллант": Конфигурисање апликације Веил Бриллант,
           "--складиштење слика, видео записа": Чување слика, видео записа и неколико других елемената,
           "--брзина пријема": Брзина пријема података из Дата центра,
           "--спеед": брзина,
           "--терминате": Заврши, //т
           "--впн вам омогућава да приступите": ВПН вам омогућава да приступите сајту или апликацији коју је ваш интернет провајдер ставио на црну листу,
           "--највеће дрво је било изнад": Највеће дрво је било пре свега једноставно мало семе,
           "--додирни екран": Додирните екран да бисте наставили,
           "--покушај поново": Пробај поново!,
           "--усернаме": Корисничко име, //у

           "--виртуелни број": Виртуелни број, //в
           "--виртуел пхоне сеттингс": подешавања виртуелног телефона,
           "--виртуелни језик телефона је примењен": Језик виртуелног телефона се подразумевано примењује на нивоу апликације,
           "--виртуелни телефон": Виртуелни телефон,
           "--валидате": Потврди,
           "--добродошли на портал за кориснике изоцасх-а": Добродошли на портал за кориснике изоцасх-а, //в
           "--врите а супер цоде": Унесите Супер код,
           "--велцоме то": Добродошли у,
           "--куда иде пажња људи": Где иде пажња људи иде новац,
           "--виннерс персеверс": Победници истрају,
           "--да ли желите да се одјавите са свог Алрани налога": Да ли желите да се одјавите са свог Алрани налога?,
           "--иес": Да, //и

           // земља
           "--конго": Конго Бразавил,
           "--камерун": Камерун,
           "--дрц": ДРЦ,
           "--ИвориЦоаст": Обала Слоноваче,

           // лангуе
        "--африкаанс": африкаанс, //а
        "--албански": албански,
        "--амхарски": амхарски,
        "--арапиц": арапски,
        "--јерменски": јерменски,
        "--асамски": асамски,
        "--аимара": Аимара,
        „--азербејџански“: азербејџански,
        "--бамбара": Бамбара, //б
        "--баскуе": баскијски,
        "--беларусиан": белоруски,
        "--бенгалски": бенгалски,
        "--бхојпури": бхојпури,
        "--босниан": босански,
        "--бугарски": бугарски,
        "--каталонски": каталонски, //ц
        "--цебуано": цебуано,
        "--цхицхева": Цхицхева,
        "--цхинесеСимплифиед": кинески (поједностављени),
        "--цхинесеТрадитионал": кинески (традиционални),
        "--цорсицан": корзикански,
        "--хрватски": хрватски,
        "--чешки": чешки,
        "--данисх": дански, //д
        "--дхивехи": Дхивехи,
        "--догри": Догри,
        "--холандски": холандски,
        "--енглески": енглески, //е
        "--есперанто": есперанто,
        "--естонски": естонски,
        "--еве": Еве,
        "--филипино": филипински, //ф
        "--финнисх": фински,
        "--француски": француски,
        "--фризијски": фризијски,
        "--галицијски": галицијски, //г
        "--грузински": грузијски,
        "--герман": немачки,
        "--грчки": грчки,
        "--гуарани": гварани,
        "--гуџарати": гуџарати,
        "--хаитианЦреоле": хаићански креолски, //х
        "--хауса": Хауса,
        "--хаваииан": хавајски,
        "--хебрев": хебрејски,
        "--хинди": хинди,
        "--хмонг": Хмонг,
        "--мађарски": мађарски,
        "--исландски": исландски, //и
        "--игбо": игбо,
        "--илоцано": Илоцано,
        "--идонежански": индонежански,
        "--ирисх": ирски,
        „--италијански“: италијански,
        "--јапанесе": јапански, //ј
        "--јаванесе": јавански,
        "--каннада": канада, //к
        "--казакх": казашки,
        "--кхмер": кмерски,
        "--киниарванда": киниарванда,
        "--конкани": Конкани,
        "--кореан": корејски,
        "--крио": Крио,
        "--курдисхКурмањи": курдски (Курмањи),
        "--курдисхСорани": курдски (сорани),
        "--киргиз": киргиски,
        "--лао": Лао, //л
        "--латин": латиница,
        "--латвијски": летонски,
        "--лингала": Лингала,
        „--литвански“: литвански,
        "--луганда": Луганда,
        "--лукембоургисх": луксембуршки,
        "--македонски": македонски, //м
        "--маитхили": маитхили,
        "--магаскарски": малгашки,
        "--малајски": малајски,
        "--малајалам": малајалам,
        "--малтесе": малтешки,
        "--маори": маори,
        "--марати": марати,
        "--меитеилонМанипури": Меитеилон (Манипури),
        "--мизо": Мизо,
        "--монголски": монголски,
        „--мјанмар бурмански“: мјанмар (бурмански),
        "--непали": непалски, //н
        „--норвешки“: норвешки,
        "--одиаОрииа": Одија (Орија), //о
        "--оромо": Оромо,
        "--пашто": пашто, //стр
        "--перзијски": персијски,
        "--пољски": пољски,
        "--португалски": португалски,
        "--панџаби": панџаби,
        "--куецхуа": кечуа, //к
        "--румунски": румунски, //р
        "--руссиан": руски,
        "--самоан": самоански, //с
        "--санскрит": санскрит,
        "--сцотсГаелиц": шкотски галски,
        "--сепеди": Сепеди,
        "--Српски / српски,
        "--сесотхо": сесото,
        "--схона": Шона,
        "--синдхи": синдхи,
        "--синхала": синхалски,
        "--словак": словачки,
        "--словенски": словеначки,
        "--сомали": сомалијски,
        "--шпански": шпански,
        "--сундански": сундански,
        "--свахили": свахили,
        "--шведски": шведски,
        "--тајик": таџички, //т
        "--тамил": тамилски,
        "--татар": татарски,
        "--телугу": телугу,
        "--тхаи": тајландски,
        "--тигриња": тигриња,
        "--тсонга": Цонга,
        „--турски“: турски,
        "--туркмен": туркменски,
        "--тви": Тви,
        "--украјински": украјински, //у
        "--урду": урду,
        "--уигхур": ујгурски,
        "--узбек": узбечки,
        "--вијетнамски": вијетнамски, //в
        "--велсх": велшки, //в
        "--кхоса": Ксхоса, //к
        "--јидиш": јидиш, //и
        "--иоруба": јоруба,
        "--зулу": Зулу, //з
        },
      },

      // sesotho
      // sesotho
      sesotho: {
        translations: {
          "--phoso e etsahetse": Phoso e etsahetse!, //a
           "--aterese": liaterese,
           "-- keletso": Keletso,
           "-- ka ho tobetsa tsoela pele": Ka ho tobetsa tsoela pele o tla khaoloa akhaonteng ea hau ea Veil Brillant, //b
           "-- ka ho tobetsa ho disconnect o tla kgaolwa": Ka ho tobetsa Disconnect o tla kgaolwa ho tswa ho izocash account ya hao,
           "-- sheba nomoro ea hau ea nnete kapa u leke hape hamorao": Sheba nomoro ea hau ea marang-rang kapa leka hape hamorao, //c
           "-- sheba nomoro ea hau ea sebele": Sheba nomoro ea hau ea sebele,
           "--tswella": Tsoelapele,
           "--connection": Khokahano,
           "- sebelisana, phela ka kutloano": Sebelisana, phela ka kutloano le ba bang,
           "-- khetha puo": Puo ea Mohala oa Virtual,
           "--u se ke ua thibela tlhōlisano": U se ke ua thibela tlhōlisano, fa bohle monyetla, //d
           "--disconnection": Ho khaoha,
           "--bakeng sa basebelisi bohle ba lifono": Bakeng sa basebelisi bohle ba Virtual Phone, ho khothalletsoa ho sebelisa VPN, //f
           "--ea leqepheng la ho kena": E ea leqepheng la ho kena, //g
           "--historical": Histori, //h
           "-- ke na le akhaonto": Ke se ke ntse ke e-na le akhaonto, //i
           "-- ha ke na akhaonto": Ha ke na akhaonto,
           "--ke ntlo ya hao": ke ntlo ya hao,
           "--setšoantšo / video +": Setšoantšo / Video +,
           "--identity verification": Netefatso ea boitsebiso,
           "--izocash customer portal": izocash Customer Portal,
           "- ntlafatso ea boitsebiso selemo se seng le se seng": Nchafatso ea boitsebiso selemo se seng le se seng,
           "--izocash buy to": izocash Buy => izocash international,
           "--kena": Kena!, //l
           "--login": Kena,
           "- kena ho lesira le khanyang": Hokela ho Veil Brillant,
           "--kena lebenkeleng la vixinol": Hokela Lebenkeleng la Vixinol,
           "- kena mahala ho akhaonto ea hau ea Veil Brillant": Kena mahala ho akhaonto ea hau ea Veil Brillant ho fihlella tšobotsi ena,
           "--ho kena ka katleho": Ho kena ho atlehile!,
           "--kena hona joale": Kena hona joale!,
           "--logout success": Ho tsoa ho atlehile!,
           "--log out": Tsoha,
           "--logout": tsoa,
           "--nomoro": Nomoro, //n
           "--name": Lebitso,
           "- joale kena": Joale, Kena!,
           "-- ha ho thibelo ea tlholisano ea ho khina":
           "--ha ho poulelo, ha ho lehloeo": Ha ho mōna, ha ho lehloeo, ha ho likarohano,
           "-- no": Che,
           "- liaterese tsa semmuso ho fihlella mohala oa hau": Liaterese tsa semmuso ho fihlella mohala oa hau oa nnete, //o
           "--password": Lekunutu, //p
           "-points withdrawals izocash": Points Withdrawals izocash,
           "--points withdrawals": Ho tlosoa ha lintlha,
           "- ka ho khetheha, sebelisa vpn": Ka ho khetheha, sebelisa VPN eo e seng ea mofani oa litšebeletso tsa hau tsa inthanete,
           "-- ho phehella hoa lefa": Ho phehella hoa lefa qetellong,
           "--rule": Melao, //r
           "-- recommendation": likhothaletso,
           "--registration": Ngodiso,
           "-- ingolisa ho lesira le khanyang": Ngolisa ho Veil Brillant, //s
           "-- ingolisa lebenkeleng la vixinol": Ngolisa ho Vixinol Store,
           "-- ingodisa": Ngodisa,
           "--signup katleho": Ngoliso e atlehile!,
           "-- ngodisa mahala": Ngodisa mahala,
           "--signup katleho IA": Khokahano e atlehile",
           "--settings": "Litlhophiso",
           "- ho theha app ea alrani": Ho hlophisa sesebelisoa sa Alrani,
           "--setting the izocash app": Ho lokisa ts'ebeliso ea izocash,
           "- ho theha sesebelisoa sa vixinol": Ho hlophisa ts'ebeliso ea Vixinol,
           "- ho theha sesebelisoa sa Brillant": Ho hlophisa ts'ebeliso ea Veil Brillant,
           "- polokelo ea litšoantšo, livideo": Ho boloka litšoantšo, livideo le likarolo tse ling tse 'maloa,
           "--Speed ​​of Reception": Lebelo la ho amohela data ho tsoa ho Datacenter,
           "--speed": Lebelo,
           "--felisa": Felisa, //t
           "-the vpn e u lumella ho fihlella": VPN e u lumella ho fihlella sebaka sa marang-rang kapa sesebelisoa seo mofani oa litšebeletso tsa hau tsa marang-rang a se ngotseng,
           "--sefate se seholohali se ne se le ka holimo": Sefate se seholohali se ne se le ka holim'a tsohle peo e nyane e bonolo,
           "-- ama skrine": Tobetsa skrineng ho tsoela pele,
           "--try again": Leka hape!,
           "--username": Lebitso la mosebelisi, //u

           "--virtual number": Nomoro ea sebele, //v
           "--li-setting tsa fono tsa sebele": Litlhophiso tsa fono ea sebele,
           "-- Virtual Phone puo ea sebelisoa": Puo ea Virtual Phone e sebelisoa boemong ba ts'ebeliso ka ho sa feleng,
           "-- Virtual phone": Mohala oa sebele,
           "- netefatsa": netefatsa,
           "- re amohelehile ho izocash moreki portal": Rea u amohela ho izocash Customer Portal, //w
           "-- ngola khoutu e kholo": Kenya Super code,
           "--welcome to": Rea u amohela,
           "- moo tlhokomelo ea batho e eang teng": Moo tlhokomelo ea batho e eang chelete,
           "-- winners persevere": Ba hlolang ba phehella,
           "- na u ka thabela ho tsoa akhaonteng ea hau ea Alrani": Na u batla ho tsoa akhaonteng ea hau ea Alrani?,
           "--e": E, //y

           // naha
           "- Congo": Congo Brazzaville,
           "-cameroon": Cameroon,
           "--drc": DRC,
           "- IvoryCoast": Ivory Coast,

           // leleme
        "--Afrikaans": Seafrikanse, //a
        "--Albania": Sealbania,
        "--amharic": Seamharic,
        "--arabic": Searabia,
        "--Armenia": Searmenia,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Sebasque,
        "--Belarusian": Sebelarusia,
        "--bengali": Benghali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Bosnia,
        "--bulgarian": Sebulgaria,
        "--catalan": Secatalan, //c
        "--Cebuano": Cebuano,
        "-- chichewa": Sechewa,
        "--chinese Simplified": Sechaena (Se Nolofalitsoeng),
        "--chineseTraditional": Sechaena (Setso),
        "--corsican": Corsican,
        "--croatian": Secroatia,
        "--czech": Seczech,
        "--danish": Sedanishe, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Dutch,
        "--english": Senyesemane, //e
        "--esperanto": Esperanto,
        "--estonian": Seestonia,
        "--ewe": Ee,
        "--filipino": Sefilipino, //f
        "--finnish": Sefinnishe,
        "--french": Sefora,
        "--frisian": Sefrisia,
        "--galician": Segalician, //g
        "--georgian": Segeorgia,
        "--Jeremane": Sejeremane,
        "- Greek": Segerike,
        "--guarani": Guarani,
        "--gujarati": Segujarati,
        "--haitianCreole": Secreole sa Haiti, //h
        "--hausa": Hausa,
        "--hawaiian": Sehawai,
        "-hebrew": Seheberu,
        "--hindi": Sehindi,
        "--hmong": Hmong,
        "--hungarian": Sehungary,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "-- ilocano": Ilocano,
        "--Indonesian": Seindonesia,
        "--Irish": Irish,
        "--italian": Setaliana,
        "--japanese": Sejapane, //j
        "--javanese": Sejava,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Sekinyarwanda,
        "--konkani": Konkani,
        "--korean": Sekorea,
        "--krio": Krio,
        "--kurdishKurmanji": Sekurdish (Kurmanji),
        "--kurdish Sorani": Sekurdish (Sorani),
        "--kyrgyz": Sekyrgyz,
        "--lao": Lao, //l
        "--latin": Selatine,
        "--latvian": Selatvia,
        "--lingala": Lingala,
        "--lithuanian": Selithuania,
        "--luganda": Luganda,
        "- luxembourgish": Luxembourgish,
        "--macedonian": Macedonia, //m
        "--maithili": Maithili,
        "--malagasy": Semalagasy,
        "--malay": Semalay,
        "--malayalam": Semalayalam,
        "--maltese": Semalta,
        "--maori": Semaori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--Persia": Persia,
        "--polish": Sepolishe,
        "--Portuguese": Sepotoketsi,
        "--punjabi": Sepunjabi,
        "--quechua": Sequechua, //q
        "--romanian": Seromania, //r
        "--Russia": Serussia,
        "--samoan": Sesamoa, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbia": Seserbia,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Seslovak,
        "--slovenian": Seslovenia,
        "--somali": Somali,
        "--spanish": Sepanish,
        "--sundanese": Sesundanese,
        "--swahili": Seswahili,
        "--Sweden": Seswedishe,
        "--tajik": Tajik, //t
        "--tamil": Setamil,
        "--Tatar": Setatare,
        "- telugu": Setelugu,
        "--thai": Thai,
        "--tigrinya": Setigrinya,
        "--tsonga": Tsonga,
        "--Turkish": Seturkey,
        "- Turkmen": Turkmen,
        "--twi": Twi,
        "- Ukrainian": Seukraine, //u
        "--urdu": Seurdu,
        "--uyghur": Uyghur,
        "--Uzbek": Seuzbek,
        "--vietnamese": Sevietnam, //v
        "--welsh": Sewelsh, //w
        "--xhosa": Sexhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Seyoruba,
        "--zulu": Zulu, //z
        },
      },

      // shona
      // shona
      shona: {
        translations: {
          "-- an error yaitika": Pane mhosho yaitika!, //a
           "--kero": Kero,
           "--zano": Zano,
           "--nekudzvanya enderera": Nekubaya pakanzi enderera uchabviswa paVeil Brillant account yako, //b
           "-- nekudzvanya pakanzi disconnect unenge wadimburwa": Nekubaya pakanzi Disconnect uchabviswa paizocash account yako,
           "--tarisa nhamba yako chaiyo kana edza zvakare gare gare": Tarisa nhamba yako chaiyo kana edza zvakare gare gare, //c
           "--tarisa nhamba yako chaiyo": Tarisa nhamba yako chaiyo,
           "--enderera": enderera,
           "--kubatana": Kubatana,
           "--batana, raramai mukuwirirana": Bata pamwe, rarama mukuwirirana nevamwe,
           "--sarudza mutauro": Virtual Phone Mutauro,
           "--usadzivise makwikwi": Usadzivirira makwikwi, ipa munhu wese mukana, //d
           "--disconnection": Kubviswa,
           "- kune vese vashandisi vefoni": Kune vese vashandisi veVirtual Phone, zvinokurudzirwa kushandisa VPN, //f
           "--enda kune peji rekupinda": Enda kupeji yekupinda, //g
           "--nhoroondo": Nhoroondo, //h
           "--ndine account": Ndatova neakaundi, //i
           "-- handina account": handina account,
           "--Imba yako": Imba yako,
           "-- mufananidzo / vhidhiyo +": Mufananidzo / Vhidhiyo +,
           "--identity verification": Identity verification,
           "--izocash customer portal": izocash Customer Portal,
           "- identity update gore rega rega": Identity update gore negore,
           "--izocash buy to": izocash Buy => izocash international,
           "--pinda": Pinda!, //l
           "--login": Log in,
           "- pinda muchifukidzo chinopenya": Batanidza kune Veil Brillant,
           "- pinda muchitoro chevixinol": Batanidza kuVixinol Store,
           "--login mahara kuvhairi rako Brillant account": Pinda mahara kuVeil Brillant account yako kuti uwane ichi chimiro,
           "--login kubudirira": Kupinda kwakabudirira!,
           "--login izvozvi": Pinda izvozvi!,
           "--logout kubudirira": kubuda kwakabudirira!,
           "--log out": kubuda,
           "--logout": Buda kunze,
           "--nhamba": Nhamba, //n
           "--zita": Zita,
           "--zvino pinda": Zvino, Log in!,
           "--hapana kurambidzwa kumisa makwikwi":
           "--pasina godo, pasina ruvengo": Hapana godo, hapana ruvengo, hapana kupesana,
           "--kwete": Kwete,
           "-- kero dzepamutemo kuti uwane yako chaiyo foni": Kero dzepamutemo kuti uwane yako chaiyo foni, //o
           "--password": Pasiwedhi, //p
           "-points withdrawals izocash": Points Withdrawals izocash,
           "- mapoinzi ekubvisa": Mapoinzi anobvisa,
           "-- zviri nani, shandisa vpn": Zviri nani, shandisa VPN isiri yemupi wako wepa internet,
           "--kushingirira nguva dzose kunobhadhara": Kutsungirira nguva dzose kunobhadhara pakupedzisira,
           "--rule": Mitemo, //r
           "--kurudziro": Mazano,
           "--kunyoresa": Kunyoresa,
           "--signup to veil brilliant": Nyoresa paVeil Brillant, //s
           "--saina kuchitoro chevixinol": Nyoresa paVixinol Store,
           "--signup": Register,
           "--signup kubudirira": Kunyoresa kwabudirira!,
           "--signup for free": Bhalisa mahara,
           "--signup kubudirira IA": Kubatana kwakabudirira",
           "--settings": "Settings",
           "- kuseta iyo alrani app": Kugadzirisa iyo Alrani application,
           "- kuseta iyo izocash app": Kugadzirisa iyo izocash application,
           "- kuseta iyo vixinol app": Kugadzirisa iyo Vixinol application,
           "- kumisikidza chidzitiro cheBrillant app": Kugadzirisa iyo Veil Brillant application,
           "--kuchengetwa kwemifananidzo, mavhidhiyo": Kuchengetedzwa kwemifananidzo, mavhidhiyo uye zvimwe zvinhu zvakati wandei,
           "--kumhanya kwekugamuchira": Kumhanya kwekugamuchira data kubva kuDatacenter,
           "--kumhanya": Kumhanya,
           "--kugumisa": Kugumisa, //t
           "--iyo vpn inokutendera iwe kuti usvike": Iyo VPN inokutendera iwe kuti uwane saiti kana application iyo yakadzikwa nemupi webasa rako reinternet,
           "--muti mukuru kwazvo waiva pamusoro": Muti mukuru pane yose waiva mhodzi duku,
           "-- bata skrini": Bata skrini kuti uenderere mberi,
           "--try again": Edza zvakare!,
           "--username": Zita rekushandisa, //u

           "--virtual number": Virtual number, //v
           "-- virtual foni marongero": Virtual foni marongero,
           "--chaiyo Mutauro weFoni inoiswa": Mutauro Wefoni Yese unoshandiswa padanho rekushandisa nekukasira,
           "--chaiyo foni": Virtual foni,
           "--validate": simbisa,
           "- tinogamuchirwa kune izocash mutengi portal": Tikugashirei izocash Mutengi Portal, //w
           "--nyora kodhi yepamusoro": Isa Super kodhi,
           "--welcome to": Welcome to,
           "- uko kutariswa kwevanhu kunoenda": Kunotariswa nevanhu mari inoenda,
           "--vanokunda shingirira": Vakundi vanoshingirira,
           "- ungade kubuda muAlrani account yako": Unoda kubuda muAlrani account yako here?,
           "--hongu": Hongu, //y

           // nyika
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // langue
        "--Afrikaans": Afrikaans, //a
        "--Albania": Albanian,
        "--amharic": Amharic,
        "--arabic": chiArabic,
        "--chiArmenian": chiArmenian,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusian,
        "--bengali": Chibengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Bosnia,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "-chineseSimplified": chiChinese (Chakareruka),
        "--chineseTraditional": Chinese (Traditional),
        "--corsican": Corsican,
        "--croatian": Croatian,
        "--Czech": Czech,
        "--danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Dutch": Dutch,
        "--english": Chirungu, //e
        "--esperanto": Esperanto,
        "--estonian": ChiEstonian,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--chiFinnish": chiFinnish,
        "--French": French,
        "--frisian": Frisian,
        "--galician": ChiGalician, //g
        "-- georgian": chiGeorgian,
        "--German": ChiGerman,
        "--chiGiriki": chiGiriki,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": ChiHebheru,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--icelandic": Icelandic, //i
        "--igbo": Igbo,
        "-- ilocano": Ilocano,
        "--indonesian": Indonesian,
        "--Irish": Irish,
        "--italian": chiItalian,
        "--japanese": Japanese, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Korean,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": ChiLatvian,
        "--lingala": Lingala,
        "--lithuanian": Lithuanian,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": Macedonian, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "--norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--Persian": Persian,
        "--polish": chiPolish,
        "--Portuguese": Chiputukezi,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romanian, //r
        "--Russian": Russian,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": Somali,
        "--spanish": Spanish,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": Swedish,
        "--tajik": Tajik, //t
        "--tamil": chiTamil,
        "--Tatar": Tatar,
        "-- telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--Turkish": Turkish,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "-- ukrainian": Ukrainian, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--Uzbek": Uzbek,
        "--vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // sindhi
      // sindhi
      sindhi: {
        translations: {
          "--نقص پيدا ٿي ويو آهي": هڪ غلطي ٿي وئي آهي!، //a
           "--address": ايڊريس،
           "--advice": صلاح،
           "--ڪنٽينينٽ تي ڪلڪ ڪندي": جاري رکڻ تي ڪلڪ ڪندي توهان کي پنهنجي Veil Brillant اڪائونٽ کان ڌار ڪيو ويندو، //b
           "--Disconnect تي ڪلڪ ڪندي توهان ڊسڪنيڪٽ ٿي ويندا": Disconnect تي ڪلڪ ڪرڻ سان توهان پنهنجي izocash اڪائونٽ کان ڌار ٿي ويندا،
           "--پنهنجو ورچوئل نمبر چيڪ ڪريو يا وري ڪوشش ڪريو بعد ۾": پنھنجو ورچوئل نمبر چيڪ ڪريو يا وري ڪوشش ڪريو، //c
           "--پنهنجو ورچوئل نمبر چيڪ ڪريو": پنھنجو ورچوئل نمبر چيڪ ڪريو،
           "--continue": جاري رکو،
           "--Connection": ڪنيڪشن،
           "-- collaborate, live in harmony": تعاون ڪرڻ، ٻين سان هم آهنگيءَ ۾ رهو،
           "--ٻولي چونڊيو": ورچوئل فون جي ٻولي،
           "--مقابلي کي روڪڻ نه ڏيو": مقابلي کي نه روڪيو، هر ڪنهن کي موقعو ڏيو، //d
           "--منسلڪ": ڪنيڪشن،
           "--سڀني ورچوئل فون استعمال ڪندڙن لاءِ": سڀني ورچوئل فون استعمال ڪندڙن لاءِ، وي پي اين استعمال ڪرڻ جي صلاح ڏني وئي آهي، //f
           "--لاگ ان صفحي ڏانھن وڃو": لاگ ان صفحي ڏانھن وڃو، //g
           "--تاريخي": تاريخي، // ايڇ
           "--i have account": مون وٽ اڳ ۾ ئي هڪ کاتو آهي، //i
           "--مون وٽ کاتو ناهي": مون وٽ کاتو ناهي،
           "-- اھو توھان جو گھر آھي": اھو توھان جو گھر آھي،
           "--تصوير / وڊيو +": تصوير / وڊيو +,
           "--identity verification": سڃاڻپ جي تصديق،
           "--izocash ڪسٽمر پورٽل": izocash ڪسٽمر پورٽل،
           "--identity update every year": سڃاڻپ جي تازه ڪاري هر سال،
           "--izocash buy to": izocash Buy => izocash بين الاقوامي،
           "--log in": لاگ ان!، //l
           "--login": لاگ ان،
           "--login to veil brillant": ڪنيڪٽ ڪريو پردو برلينٽ،
           "-- login to vixinol store": Vixinol Store سان ڳنڍيو،
           "-- login for free to your veil Brillant اڪائونٽ": هن فيچر تائين رسائي حاصل ڪرڻ لاءِ پنهنجي Veil Brillant اڪائونٽ ۾ مفت ۾ لاگ ان ٿيو،
           "--login success": لاگ ان ڪامياب!,
           "--login now": هاڻي لاگ ان ٿيو!,
           "--logout success": لاگ آئوٽ ڪامياب!,
           "--log out": لاگ آئوٽ،
           "--logout": لاگ آئوٽ،
           "--نمبر": نمبر، //ن
           "--نالو": نالو،
           "--هاڻي لاگ ان": هاڻي، لاگ ان ٿيو!,
           "-مقابلي کي دٻائڻ تي ڪا به پابندي ناهي":
           "-نه حسد، نه نفرت": نه حسد، نه نفرت، نه تقسيم،
           "--نه نه،
           "--سرڪاري پتا توھان جي ورچوئل فون تائين پھچڻ لاءِ": توھان جي ورچوئل فون تائين پھچڻ لاءِ سرڪاري پتا، //o
           "--password": پاسورڊ، //p
           "--پوائنٽ ڪڍڻ izocash": پوائنٽون ڪڍڻ izocash،
           "--پوائنٽ ڪڍڻ": پوائنٽون واپس وٺڻ،
           "--preferably, use a vpn": ترجيحي طور تي، ھڪڙو VPN استعمال ڪريو جيڪو توھان جي انٽرنيٽ سروس فراهم ڪندڙ سان واسطو نه رکي،
           "- مسلسل هميشه ادا ڪندو آهي": ثابت قدمي هميشه آخر ۾ ادا ڪري ٿي،
           "--قاعدو": ضابطو، //ر
           "--سفارش": سفارشون،
           "--registration": رجسٽريشن،
           "--signup to veil brillant": رجسٽر ٿيو پر Veil Brillant، //s
           "--signup to vixinol store": رجسٽر ٿيو Vixinol Store تي،
           "--signup": رجسٽر،
           "--signup success": رجسٽريشن ڪامياب!,
           "--signup for free": رجسٽر ٿيو مفت ۾،
           "--سائن اپ ڪامياب IA": ڪنيڪشن ڪامياب،
           "--settings": "سيٽنگون",
           "--الراني ايپ کي ترتيب ڏيڻ": الراني ايپليڪيشن کي ترتيب ڏيڻ،
           "--سيٽ اپ izocash ايپ": izocash ايپليڪيشن کي ترتيب ڏيڻ،
           "--Vixinol ايپ کي ترتيب ڏيڻ": Vixinol ايپليڪيشن کي ترتيب ڏيڻ،
           "--Seting up the veil Brillant app": وِيل بريلنٽ ايپليڪيشن کي ترتيب ڏيڻ،
           "--تصويرن جو ذخيرو، وڊيوز": تصويرن جو ذخيرو، وڊيوز ۽ ٻيا ڪيترائي عنصر،
           "--استقبال جي رفتار": ڊيٽا سينٽر کان ڊيٽا جي استقبال جي رفتار،
           "--رفتار": رفتار،
           "--terminate": ختم ڪرڻ، //t
           "--vpn توهان کي رسائي جي اجازت ڏئي ٿي": VPN توهان کي اجازت ڏئي ٿي ته توهان جي انٽرنيٽ سروس فراهم ڪندڙ بليڪ لسٽ ڪيل سائيٽ يا ايپليڪيشن تائين رسائي،
           "--سڀ کان وڏو وڻ مٿي هو": سڀ کان وڏو وڻ سڀني کان مٿانهون ننڍڙو ٻج هو،
           "--اسڪرين کي ڇڪيو": جاري رکڻ لاءِ اسڪرين کي ڇڪيو،
           "--ٻيهر ڪوشش ڪريو": ٻيهر ڪوشش ڪريو!,
           "--username": يوزر نالو، //u

           "--virtual number": ورچوئل نمبر، //v
           "--virtual phone settings": ورچوئل فون سيٽنگون،
           "-- ورچوئل فون جي ٻولي لاڳو ڪئي وئي آهي": ورچوئل فون جي ٻولي ڊفالٽ طور ايپليڪيشن سطح تي لاڳو ٿيندي آهي،
           "--virtual phone": ورچوئل فون،
           "--validate": تصديق ڪريو،
           "--welcome to the izocash ڪسٽمر پورٽل": ڀلي ڪري آيا izocash ڪسٽمر پورٽل تي، //w
           "-سپر ڪوڊ لکو": سپر ڪوڊ داخل ڪريو،
           "-welcome to": ڀليڪار،
           "-جتي ماڻهن جو ڌيان وڃي ٿو": جتي ماڻهن جو ڌيان پوي ٿو، اتي پئسو وڃي ٿو.
           "-- فاتح ثابت قدم": فاتح ثابت قدم،
           "--ڇا توھان پنھنجي Alrani کاتي مان لاگ آئوٽ ٿيڻ چاھيو ٿا": ڇا توھان پنھنجي Alrani کاتي مان لاگ آئوٽ ٿيڻ چاھيو ٿا؟,
           "--ها": ها، //y

           // ملڪ
           "--congo": ڪانگو برازاويل،
           "--cameroon": ڪيمرون،
           "--drc": DRC،
           "--ivoryCoast": آئيوري ڪوسٽ،

           // ٻولي
        "--afrikaans": آفريڪا، //a
        "--الباني": الباني،
        "--amharic": امارڪ،
        "--عربي": عربي،
        "--armenian": آرمينيائي،
        "-آسامي": آسامي،
        "--aymara": ايمارا،
        "--آذربائيجاني": آذربائيجاني,
        "--بمبارا": بامبارا، //b
        "--basque": باسڪي،
        "--belarusian": بيلاروسي،
        "- بنگالي": بنگالي،
        "--bhojpuri": ڀوجپوري،
        "--bosnian": بوسني،
        "--bulgarian": بلغاريا،
        "--catalan": Catalan، //c
        "--cebuano": Cebuano,
        "--chichewa": چيچيوا،
        "--chineseSimplified": چيني (آسان ٿيل)،
        "--chineseTraditional": چيني (روايتي)،
        "--corsican": Corsican,
        "--croatian": ڪروشيا،
        "--czech": چيڪ،
        "--دانش": ڊينش، // ڊي
        "--dhivehi": Dhivehi،
        "--dogri": ڊوگري،
        "--ڊچ": ڊچ،
        "--انگريزي": انگريزي، //e
        "--esperanto": اسپرانتو,
        "--اسٽونين": ايسٽونيا،
        "--ewe": Ewe,
        "--filipino": فلپائن، //f
        "--finnish": فننش،
        "-french": فرينچ،
        "--frisian": فريسين،
        "--گاليشين": گاليشين، //g
        "--georgian": جارجيا،
        "--german": جرمن،
        "--greek": يوناني،
        "--گاراني": گاراني،
        "--gujarati": گجراتي،
        "--haitianCreole": Haitian Creole، //h
        "--hausa": هوسا،
        "--hawaiian": هوائي،
        "--hebrew": عبراني،
        "--هندي": هندي،
        "--hmong": Hmong,
        "--hungarian": هنگري،
        "--آئسلينڊڪ": آئس لينڊ، //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--انڊونيشيائي": انڊونيشيائي,
        "--آئرش": آئرش،
        "--اطالوي": اطالوي,
        "--japanese": جاپاني، //j
        "--javanese": جاوي،
        "--kannada": ڪنّاڊا، //k
        "--قزاخ": قازق،
        "--khmer": خمير،
        "--kinyarwanda": ڪنيارواندا،
        "--ڪوڪني": ڪوڪاڻي،
        "--korean": ڪورين،
        "--krio": ڪريو،
        "--kurdishKurmanji": کردش (Kurmanji),
        "--kurdishSorani": کردش (سوراني)،
        "--kyrgyz": ڪرغز،
        "--lao": لاؤ، //l
        "--لاطيني": لاطيني،
        "--latvian": لاتوين،
        "--lingala": لنگالا،
        "--lithuanian": لتھوانين،
        "--luganda": Luganda,
        "--luxembourgish": لگزمبرگ،
        "--macedonian": مقدوني، //m
        "--maithili": ميٿلي،
        "--malagasy": ملاگاسي،
        "--malay": ملائي،
        "--مليالم": مليالم،
        "-- مالٽي": مالٽيز,
        "--maori": ماوري،
        "--marathi": مراٺي،
        "--meiteilonManipuri": Meiteilon (Manipuri)،
        "--mizo": ميزو،
        "--mongolian": منگول،
        "--myanmarBurmese": ميانمار (برمي)،
        "--nepali": نيپالي، //n
        "--نارويجن": نارويجن،
        "--odiaOriya": اوڊيا (اوريا)، //o
        "--oromo": اورومو،
        "--pashto": پشتو، //p
        "--فارسي": فارسي،
        "--polish": پولش،
        "--portuguese": پرتگالي،
        "--punjabi": پنجابي،
        "--quechua": Quechua، //q
        "--رومانيائي": رومانوي، //r
        "--روسي": روسي،
        "--samoan": سامون، //s
        "-سنسڪرت": سنسڪرت،
        "--scotsGaelic": اسڪاٽس گيلڪ،
        "--sepedi": Sepedi,
        "--serbian": سربي،
        "--sesotho": سيسوٿو،
        "--shona": شونا،
        "-sindhi": سنڌي،
        "--sinhala": سنڌي،
        "--slovak": سلوواک،
        "--slovenian": سلوويني،
        "--صومالي": صومالي،
        "--spanish": اسپينش،
        "--sundanise": سنڊاني،
        "--swahili": سواهلي,
        "--swedish": سويڊش،
        "--تاجڪ": تاجڪ، //t
        "--تمل": تامل،
        "--تاتار": تاتار،
        "--telugu": تيلگو،
        "--ٿائي": ٿائي،
        "--tigrinya": Tigrinya,
        "--سونگا": سونگا،
        "--ترڪي": ترڪي،
        "--ترڪمن": ترڪمان،
        "-twi": ٽوئي،
        "--ukrainian": يوڪريني، //u
        "--urdu": اردو،
        "--uyghur": اويغور،
        "--uzbek": ازبڪ،
        "--ويٽنامي": ويٽنامي، //v
        "--welsh": ويلش، //w
        "--xhosa": Xhosa، //x
        "--yiddish": يدش، //y
        "--yoruba": يوروبا،
        "--zulu": زولو، //z
        },
      },

      // sinhala
      // sinhala
      sinhala: {
        translations: {
          "--දෝෂයක් සිදුවී ඇත": දෝෂයක් සිදුවී ඇත!, //a
          "--ලිපිනය": ලිපින,
          "--උපදෙස්": උපදෙස්,
          "--continue මත ක්ලික් කිරීමෙන්": continue මත ක්ලික් කිරීමෙන් ඔබ ඔබේ Veil Brillant ගිණුමෙන් විසන්ධි වනු ඇත, //b
          "--විසන්ධි කිරීම මත ක්ලික් කිරීමෙන් ඔබ විසන්ධි වනු ඇත": Disconnect මත ක්ලික් කිරීමෙන් ඔබ ඔබේ izocash ගිණුමෙන් විසන්ධි වනු ඇත,
          "--ඔබගේ අතථ්‍ය අංකය පරීක්ෂා කරන්න හෝ පසුව නැවත උත්සාහ කරන්න": ඔබගේ අතථ්‍ය අංකය පරීක්ෂා කරන්න හෝ පසුව නැවත උත්සාහ කරන්න, //c
          "--ඔබගේ අතථ්‍ය අංකය පරීක්ෂා කරන්න": ඔබගේ අතථ්‍ය අංකය පරීක්ෂා කරන්න,
          "--දිගටම": දිගටම,
          "--සම්බන්ධතාවය": සම්බන්ධතාවය,
          "--සහයෝගීව, සමගියෙන් ජීවත් වන්න": සහයෝගයෙන් කටයුතු කරන්න, අන් අය සමඟ එකඟව ජීවත් වන්න,
          "--භාෂාව තෝරන්න": අතථ්‍ය දුරකථන භාෂාව,
          "--තරඟය වළක්වන්න එපා": තරඟය වළක්වන්න එපා, හැමෝටම අවස්ථාවක් දෙන්න, //d
          "--විසන්ධි": විසන්ධි කිරීම,
          "--සියලු අතථ්‍ය දුරකථන භාවිතා කරන්නන් සඳහා": සියලුම අතථ්‍ය දුරකථන භාවිතා කරන්නන් සඳහා, VPN භාවිතා කිරීම රෙකමදාරු කරනු ලැබේ, //f
          "--පිවිසුම් පිටුවට යන්න": පිවිසුම් පිටුවට යන්න, //g
          "--ඓතිහාසික": ඓතිහාසික, //h
          "--මට ගිණුමක් ඇත": මට දැනටමත් ගිණුමක් ඇත, //i
          "--මට ගිණුමක් නැත": මට ගිණුමක් නැත,
          "- එය ඔබගේ නිවසයි": එය ඔබගේ නිවසයි,
          "--රූපය / වීඩියෝ +": රූපය / වීඩියෝ +,
          "--අනන්‍යතා සත්‍යාපනය": අනන්‍යතා සත්‍යාපනය,
          "--izocash පාරිභෝගික ද්වාරය": izocash පාරිභෝගික ද්වාරය,
          "--හැම වසරකම අනන්‍යතා යාවත්කාලීන කිරීම": සෑම වසරකම අනන්‍යතා යාවත්කාලීන කිරීම,
          "--izocash buy to": izocash Buy => izocash International,
          "--ලොගින් වන්න": පුරනය වන්න!, //l
          "--ලොගින්": පුරනය වන්න,
          "--ලොගින් වන්න veil brilliant": Veil Brillant වෙත සම්බන්ධ කරන්න,
          "--වික්සිනෝල් ගබඩාවට පිවිසෙන්න": Vixinol Store වෙත සම්බන්ධ වන්න,
          "--ඔබගේ veil Brillant ගිණුමට නොමිලේ ලොගින් වන්න": මෙම විශේෂාංගයට ප්‍රවේශ වීමට ඔබගේ Veil Brillant ගිණුමට නොමිලේ ලොග් වන්න,
          "--පිවිසුම් සාර්ථකත්වය": පුරනය වීම සාර්ථකයි!,
          "--දැන් පුරනය වන්න": දැන් ලොග් වන්න!,
          "--ලොග්අවුට් සාර්ථකත්වය": පිටවීම සාර්ථකයි!,
          "--ලොග් අවුට්": පිටවීම,
          "--logout": ලොග් අවුට්,
          "--අංක": අංකය, //n
          "--නම": නම,
          "--දැන් ලොග් වන්න": දැන්, ලොග් වන්න!,
          "--තරඟය මැඩපැවැත්වීම තහනම් නැත":
          "--ඊර්ෂ්‍යාව නැත, වෛර නැත": ඊර්ෂ්‍යාව නැත, වෛර නැත, භේද නැත,
          "--නෑ නෑ,
          "--ඔබගේ අතථ්‍ය දුරකථනයට ප්‍රවේශ වීමට නිල ලිපින": ඔබගේ අතථ්‍ය දුරකථනයට ප්‍රවේශ වීමට නිල ලිපින, //o
          "--මුරපදය": මුරපදය, //p
          "--points withdrawals izocash": Points Withdrawals izocash,
          "--ලකුණු ආපසු ගැනීම්": ලකුණු ආපසු ගැනීම්,
          "--preferably, vpn භාවිතා කරන්න": වඩාත් සුදුසු, ඔබගේ අන්තර්ජාල සේවා සපයන්නාට අයත් නොවන VPN භාවිතා කරන්න,
          "--අවස්ථාව සැම විටම ගෙවෙයි": නොපසුබට උත්සාහය සෑම විටම අවසානයේ ගෙවයි,
          "--නීතිය": රීති, //r
          "--නිර්දේශය": නිර්දේශ,
          "--ලියාපදිංචිය": ලියාපදිංචිය,
          "--විශිෂ්ට වේල් කිරීමට ලියාපදිංචි වන්න": වේල් බ්‍රිලන්ට් මත ලියාපදිංචි වන්න, //s
          "--වික්සිනෝල් ගබඩාවට ලියාපදිංචි වන්න": Vixinol ගබඩාවේ ලියාපදිංචි වන්න,
          "--ලියාපදිංචිය": ලියාපදිංචි,
          "--ලියාපදිංචිය සාර්ථකයි": ලියාපදිංචිය සාර්ථකයි!,
          "--නොමිලේ ලියාපදිංචි වන්න": නොමිලේ ලියාපදිංචි වන්න,
          “--ලියාපදිංචිය සාර්ථකයි IA”: සම්බන්ධතාවය සාර්ථකයි”,
          "--සැකසීම්": "සැකසීම්",
          "--alrani යෙදුම පිහිටුවීම": Alrani යෙදුම වින්‍යාස කිරීම,
          "--izocash යෙදුම පිහිටුවීම": izocash යෙදුම වින්‍යාස කිරීම,
          "--vixinol යෙදුම පිහිටුවීම": Vixinol යෙදුම වින්‍යාස කිරීම,
          "--veil Brillant යෙදුම සැකසීම": Veil Brillant යෙදුම වින්‍යාස කිරීම,
          "--පින්තූර, වීඩියෝ ගබඩා කිරීම": පින්තූර, වීඩියෝ සහ තවත් අංග කිහිපයක් ගබඩා කිරීම,
          "--පිළිගැනීමේ වේගය": දත්ත මධ්‍යස්ථානයෙන් දත්ත ලබා ගැනීමේ වේගය,
          "--වේගය": වේගය,
          "--terminate": අවසන් කරන්න, //t
          "--vpn ඔබට ප්‍රවේශ වීමට ඉඩ දෙයි": ඔබගේ අන්තර්ජාල සේවා සපයන්නා අසාදු ලේඛනගත කර ඇති වෙබ් අඩවියකට හෝ යෙදුමකට ප්‍රවේශ වීමට VPN ඔබට ඉඩ සලසයි.
          "--විශාලතම ගස ඉහලින් විය": විශාලතම ගස සියල්ලටම වඩා සරල කුඩා බීජයක් විය.
          "--තිරය ස්පර්ශ කරන්න": ඉදිරියට යාමට තිරය ස්පර්ශ කරන්න,
          "--යලි උත්සාහ කරන්න": නැවත උත්සාහ කරන්න!,
          "--පරිශීලක නාමය": පරිශීලක නාමය, //u

          "--අතථ්‍ය අංකය": අතථ්‍ය අංකය, //v
           "--අථත්‍ය දුරකථන සැකසුම්": අතථ්‍ය දුරකථන සැකසුම්,
           "--අථත්‍ය දුරකථන භාෂාව යෙදේ": අතථ්‍ය දුරකථන භාෂාව පෙරනිමියෙන් යෙදුම් මට්ටමින් යොදනු ලැබේ,
           "--අථත්‍ය දුරකථනය": අතථ්‍ය දුරකථනය,
           "--validate": වලංගු කරන්න,
           "--izocash පාරිභෝගික ද්වාරය වෙත සාදරයෙන් පිළිගනිමු": izocash පාරිභෝගික ද්වාරය වෙත සාදරයෙන් පිළිගනිමු, //w
           "--සුපිරි කේතයක් ලියන්න": සුපිරි කේතයක් ඇතුලත් කරන්න,
           "--සාදරයෙන් පිළිගනිමු": සාදරයෙන් පිළිගනිමු,
           "--මිනිසුන්ගේ අවධානය යන තැන": මිනිසුන්ගේ අවධානය යන තැනට මුදල් යන්නේ,
           "--ජයග්‍රාහකයන් ඉවසයි": ජයග්‍රාහකයින් විඳදරා ගනී,
           "--ඔබගේ Alrani ගිණුමෙන් ඉවත් වීමට ඔබ කැමතිද": ඔබට ඔබගේ Alrani ගිණුමෙන් ඉවත් වීමට අවශ්‍යද?,
           "--ඔව්": ඔව්, //y

           // රට
           "--congo": Congo Brazzaville,
           "--කැමරූන්": කැමරූන්,
           "--drc": DRC,
           "--ivoryCoast": අයිවරි කෝස්ට්,

           // භාෂාව
        "--අක්‍රිකාන්ස්": අප්‍රිකානු, //a
        "--ඇල්බේනියානු": ඇල්බේනියානු,
        "--amharic": Amharic,
        "--අරාබි": අරාබි,
        "--ආර්මේනියානු": ආර්මේනියානු,
        "--assamese": Assamese,
        "--aymara": අයිමාරා,
        "--azerbaijani": අසර්බයිජානියානු,
        "--බඹරා": බඹරා, //b
        "--බාස්ක්": බාස්ක්,
        "--බෙලරුසියානු": බෙලරුසියානු,
        "--බෙංගාලි": බෙංගාලි,
        "--bhojpuri": Bhojpuri,
        "--බොස්නියානු": බොස්නියානු,
        "--බල්ගේරියානු": බල්ගේරියානු,
        "-- කැටලන්": කැටලන්, //c
        "--cebuano": සෙබුවානෝ,
        "--chichewa": චිචේවා,
        "--චීන සරල කළ": චීන (සරල),
        "--චීන සම්ප්‍රදායික": චීන (සාම්ප්‍රදායික),
        "--corsican": Corsican,
        "--croatian": ක්‍රොඒෂියානු,
        "--චෙක්": චෙක්,
        "--danish": ඩෙන්මාර්ක, //d
        "--divehi": Divehi,
        "--ඩොග්රි": ඩොග්රි,
        "--ලන්දේසි": ලන්දේසි,
        "--ඉංග්‍රීසි": ඉංග්‍රීසි, //ඊ
        "--esperanto": Esperanto,
        "--එස්තෝනියානු": එස්තෝනියානු,
        "--ewe": Ewe,
        "--filipino": පිලිපීන, //f
        "--ෆින්ලන්ත": ෆින්ලන්ත,
        "--ප්රංශ": ප්රංශ,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": ජෝර්ජියානු,
        "--ජර්මානු": ජර්මානු,
        "--ග්‍රීක්": ග්‍රීක,
        "--ගුරානි": ගුරානි,
        "--ගුජරාටි": ගුජරාටි,
        "--haitianCreole": Haitian Creole, //h
        "--හවුසා": හවුසා,
        "--හවායි": හවායි,
        "--හෙබ්‍රෙව්": හෙබ්‍රෙව්,
        "--හින්දි": හින්දි,
        "--හ්මොං": හ්මොං,
        "--හංගේරියානු": හංගේරියානු,
        "--iceland": අයිස්ලන්ත, //i
        "--igbo": ඉග්බෝ,
        "--ilocano": Ilocano,
        "--ඉන්දුනීසියානු": ඉන්දුනීසියානු,
        "--irish": අයර්ලන්ත,
        "--ඉතාලි": ඉතාලි,
        "--ජපන්": ජපන්, //j
        "--javanese": Javanese,
        "--කන්නඩ": කන්නඩ, //k
        "--කසාක්": කසාක්,
        "--ඛ්මර්": ඛමර්,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--කොරියානු": කොරියානු,
        "--ක්‍රියෝ": ක්‍රියෝ,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": කිර්ගිස්,
        "--ලාඕ": ලාඕ, //එල්
        "--ලතින්": ලතින්,
        "--ලැට්වියානු": ලැට්වියානු,
        "--ලිංගා": ලිංගාලා,
        "--ලිතුවේනියානු": ලිතුවේනියානු,
        "--ලුගන්ඩා": ලුගන්ඩා,
        "--luxembourgish": Luxembourgish,
        "--මැසිඩෝනියානු": මැසිඩෝනියානු, //m
        "--maithili": මයිතිලි,
        "--malagasy": Malagasy,
        "--malay": මැලේ,
        "--මලයාලම්": මලයාලම්,
        "--මෝල්ටීස්": මෝල්ටීස්,
        "--maori": මයෝරි,
        "--මරාති": මරාති,
        "--meiteilonManipuri": Meiteilon (මනිපුරි),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": මියන්මාරය (බුරුම),
        "--nepali": නේපාල, //n
        "--නෝර්වීජියානු": නෝර්වීජියානු,
        "--odiaOriya": Odia (Oriya), //o
        "--ඔරොමෝ": ඔරොමෝ,
        "--pashto": Pashto, //p
        "--පර්සියානු": පර්සියානු,
        "--පොලිෂ්": පෝලන්ත,
        "--පෘතුගීසි": පෘතුගීසි,
        "--පන්ජාබි": පන්ජාබි,
        "--quechua": Quechua, //q
        "--romanian": රුමේනියානු, //r
        "--රුසියානු": රුසියානු,
        "--samoan": සැමෝවන්, //s
        "--සංස්කෘත": සංස්කෘත,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--සර්බියානු": සර්බියානු,
        "--සෙසෝතෝ": සෙසෝතෝ,
        "--ශෝනා": ෂෝනා,
        "--සින්දි": සින්දි,
        "--සිංහල": සිංහල,
        "--ස්ලෝවැක්": ස්ලෝවැක්,
        "--slovenian": ස්ලෝවේනියානු,
        "--සෝමාලි": සෝමාලි,
        "--ස්පාඤ්ඤ": ස්පාඤ්ඤ,
        "--sundanese": Sundanese,
        "--swahili": ස්වහීලී,
        "--ස්වීඩන්": ස්වීඩන්,
        "--ටජික්": ටජික්, //t
        "--දෙමළ": දෙමළ,
        "--ටාටාර්": ටාටාර්,
        "--තෙළිඟු": තෙළිඟු,
        "--තායි": තායි,
        "--tigrinya": Tigrinya,
        "--සොංගා": සොංගා,
        "--තුර්කි": තුර්කි,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--ukrainian": යුක්රේනියානු, //u
        "--urdu": උර්දු,
        "--uyghur": Uyghur,
        "--උස්බෙක්": උස්බෙක්,
        "--වියට්නාම": වියට්නාම, //v
        "--welsh": වේල්ස්, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--යොරුබා": යොරුබා,
        "--zulu": Zulu, //z
        },
      },

      // slovak
      // slovak
      slovak: {
        translations: {
          "--nastala chyba": Vyskytla sa chyba!, //a
          "--address": adresy,
          "--advice": rada,
          "--kliknutím na pokračovať": Kliknutím na pokračovať budete odpojení od svojho účtu Veil Brillant, //b
          "--kliknutím na odpojiť sa odpojíte": Kliknutím na Odpojiť sa odpojíte od svojho účtu izocash,
          "--skontrolujte svoje virtuálne číslo alebo to skúste znova neskôr": Skontrolujte svoje virtuálne číslo alebo to skúste znova neskôr, //c
          "--check your virtual number": Skontrolujte svoje virtuálne číslo,
          "--continue": Pokračovať,
          "--connection": pripojenie,
          "--spolupracujte, žite v harmónii": Spolupracujte, žite v súlade s ostatnými,
          "--choose language": jazyk virtuálneho telefónu,
          "--nebráni konkurencii": Nebráni konkurencii, daj každému šancu, //d
          "--disconnection": odpojenie,
          "--for all virtual phone users": Pre všetkých užívateľov virtuálneho telefónu sa odporúča použiť VPN, //f
          "--go to login page": Prejdite na prihlasovaciu stránku, //g
          "--historický": historické, //h
          "--i have account": Už mám účet, //i
          "--nemám účet": nemám účet,
          "--to je tvoj dom": je to tvoj dom,
          "--image / video +": Obrázok / Video +,
          "--overenie totožnosti": overenie totožnosti,
          "--izocash zákaznícky portál": izocash zákaznícky portál,
          "--identity update every year": aktualizácia identity každý rok,
          "--izocash buy to": izocash Buy => izocash international,
          "--log in": Prihláste sa!, //l
          "--login": Prihláste sa,
          "--login to Veil Brillant": Pripojte sa k Veil Brillant,
          "--login to vixinol store": Pripojte sa k Vixinol Store,
          "--prihlás sa zadarmo do svojho účtu Veil Brillant": Prihláste sa bezplatne do svojho účtu Veil Brillant, aby ste získali prístup k tejto funkcii,
          "--login success": Prihlásenie úspešné!,
          "--login now": Prihláste sa teraz!,
          "--logout success": Odhlásenie úspešné!,
          "--log out": Odhlásiť sa,
          "--logout": Odhlásiť sa,
          "--number": číslo, //n
          "--name": meno,
          "--now log in": Teraz, prihláste sa!,
          "--žiaden zákaz dusenia konkurencie":
          "--žiadna žiarlivosť, žiadna nenávisť": žiadna žiarlivosť, žiadna nenávisť, žiadne rozkoly,
          "--nie nie,
          "--oficiálne adresy na prístup k vášmu virtuálnemu telefónu": Oficiálne adresy na prístup k vášmu virtuálnemu telefónu, //o
          "--password": Heslo, //s
          "--body výberu izocash": výbery bodov izocash,
          "--výbery bodov": výbery bodov,
          "--prednostne použite vpn": Prednostne použite sieť VPN, ktorá nepatrí vášmu poskytovateľovi internetových služieb,
          "--vytrvalosť sa vždy oplatí": vytrvalosť sa nakoniec vždy vyplatí,
          "--rule": Pravidlá, //r
          "--recommendation": Odporúčania,
          "--registrácia": Registrácia,
          "--registrácia do Veil Brillant": Zaregistrujte sa na Veil Brillant, //s
          "--registrácia do obchodu vixinol": Zaregistrujte sa v obchode Vixinol,
          "--signup": Zaregistrujte sa,
          "--signup success": Registrácia úspešná!,
          "--registrácia zadarmo": Zaregistrujte sa zadarmo,
          “--registrácia úspešná IA”: Pripojenie úspešné”,
          "--settings": "Nastavenia",
          "--setting the alrani app": Konfigurácia aplikácie Alrani,
          "--seting the izocash app": Konfigurácia aplikácie izocash,
          "--setting the vixinol app": Konfigurácia aplikácie Vixinol,
          "--nastavenia aplikácie Veil Brillant": Konfigurácia aplikácie Veil Brillant,
          "--storage of images, videos": Ukladanie obrázkov, videí a niekoľkých ďalších prvkov,
          "--speed of income": rýchlosť príjmu dát z dátového centra,
          "--speed": rýchlosť,
          "--terminate": ukončiť, //t
          "--vpn vám umožňuje prístup": VPN vám umožňuje prístup na stránku alebo aplikáciu, ktorú váš poskytovateľ internetových služieb zaradil na čiernu listinu,
          "--najväčší strom bol hore": Najväčší strom bol predovšetkým jednoduché malé semienko,
          "--touch the screen": Dotknite sa obrazovky pre pokračovanie,
          "--try again": Skúste to znova!,
          "--username": Používateľské meno, //u

          "--virtual number": Virtuálne číslo, //v
           "--nastavenia virtuálneho telefónu": nastavenia virtuálneho telefónu,
           "--je použitý jazyk virtuálneho telefónu": Jazyk virtuálneho telefónu sa štandardne používa na úrovni aplikácie,
           "--virtuálny telefón": virtuálny telefón,
           "--validate": potvrdiť,
           "--vitajte na zákazníckom portáli izocash": Vitajte na zákazníckom portáli izocash, //w
           "--write a super code": Zadajte super kód,
           "--welcome to": Vitajte,
           "--kam ide pozornosť ľudí": Kam ide pozornosť ľudí, peniaze idú,
           "--winners persevere": Víťazi vytrvajú,
           "--chceli by ste sa odhlásiť zo svojho účtu Alrani": Chcete sa odhlásiť zo svojho účtu Alrani?,
           "--yes": Áno, //y

           // krajina
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": KDR,
           "--ivoryCoast": Pobrežie Slonoviny,

           // jazyk
        "--afrikaans": afrikánčina, //a
        "--albanian": albánsky,
        "--amharčina": amharčina,
        "--arabic": arabčina,
        "--armenian": arménsky,
        "--assamese": asamčina,
        "--aymara": ajmarčina,
        "--azerbajdžančina": azerbajdžančina,
        "--bambara": Bambara, //b
        "--basque": baskický,
        "--bieloruský": bieloruský,
        "--bengali": bengálčina,
        "--bhojpuri": bhojpuri,
        "--bosnian": bosniančina,
        "--bulharian": bulharčina,
        "--catalan": katalánčina, //c
        "--cebuano": cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": čínština (zjednodušená),
        "--chineseTraditional": čínština (tradičná),
        "--corsican": korzický,
        "--chorvátsky": chorvátčina,
        "--czech": čeština,
        "--danish": dánčina, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--holandčina": holandčina,
        "--english": angličtina, //e
        "--esperanto": esperanto,
        "--estónčina": estónčina,
        "--ovečka": ovečka,
        "--filipino": filipínčina, //f
        "--finnish": fínčina,
        "--french": francúzština,
        "--frízsky": frízsky,
        "--galician": galícijský, //g
        "--georgian": gruzínčina,
        "--german": nemčina,
        "--greek": grécky,
        "--guarani": guarani,
        "--gudžarátčina": gudžarátčina,
        "--haitianCreole": haitská kreolčina, //h
        "--hausa": Hausa,
        "--hawaiian": havajčina,
        "--hebrew": hebrejčina,
        "--hindi": hindčina,
        "--hmong": Hmong,
        "--maďarčina": maďarčina,
        "--icelandic": islandčina, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": indonézčina,
        "--irish": írčina,
        "--italian": taliančina,
        "--japanese": japončina, //j
        "--javanese": jávčina,
        "--kannada": kannadčina, //k
        "--kazakh": kazaščina,
        "--khmer": khmérčina,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": konkani,
        "--korean": kórejčina,
        "--krio": Krio,
        "--kurdishKurmanji": kurdčina (Kurmanji),
        "--kurdishSorani": kurdčina (Sorani),
        "--kyrgyz": Kirgiz,
        "--lao": Lao, //l
        "--latin": latinčina,
        "--latvian": lotyština,
        "--lingala": lingala,
        "--litovčina": litovčina,
        "--luganda": Luganda,
        "--luxemburský": luxemburský,
        "--macedónsky": macedónsky, //m
        "--maithili": maithili,
        "--malagasy": madagaskarský,
        "--malajčina": malajčina,
        "--malajálam": malajálamčina,
        "--maltese": maltčina,
        "--maori": Maori,
        "--marathi": maráthčina,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolský": mongolský,
        "--myanmarBurmese": Mjanmarsko (barmčina),
        "--nepali": nepálčina, //n
        "--norwegian": nórčina,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pašto": paštčina, //s
        "--perzština": perzština,
        "--poľský": poľština,
        "--portuguese": portugalčina,
        "--punjabi": pandžábčina,
        "--quechua": kečuánčina, //q
        "--rumunian": rumunčina, //r
        "--russian": ruština,
        "--samoan": Samoan, //s
        "--sanskrit": sanskrt,
        "--scotsGaelic": škótska gaelčina,
        "--sepedi": Sepedi,
        "--srbský": srbčina,
        "--sesotho": sesotho,
        "--shona": Shona,
        "--sindhi": sindhi,
        "--sinhala": sinhálčina,
        "--slovak": slovenčina,
        "--slovenčina": slovinčina,
        "--somali": somálčina,
        "--spanish": španielčina,
        "--sundanese": sundánčina,
        "--swahili": svahilčina,
        "--swedish": švédčina,
        "--tajik": tadžičtina, //t
        "--tamil": tamilčina,
        "--tatar": tatarský,
        "--telugu": telugčina,
        "--thai": thajčina,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turecký": turečtina,
        "--turkmen": turkménčina,
        "--twi": Twi,
        "--ukrajinský": ukrajinský, //u
        "--urdu": urdčina,
        "--uyghur": Ujgur,
        "--uzbek": uzbecký,
        "--vietnamese": vietnamčina, //v
        "--welsh": waleština, //w
        "--xhosa": Xhosa, //x
        "--jidiš": jidiš, //y
        "--yoruba": jorubčina,
        "--zulu": zulučina, //z
        },
      },

      // slovenian
      // slovenian
      slovenian: {
        translations: {
          "--prišlo je do napake": Prišlo je do napake!, //a
           "--address": naslovi,
           "--advice": nasvet,
           "--s klikom na Nadaljuj": S klikom na Nadaljuj bo prekinjena povezava z vašim računom Veil Brillant, //b
           "--s klikom na Prekini povezavo boste prekinjeni": S klikom na Prekini povezavo boste prekinili povezavo z vašim izocash računom,
           "--preverite svojo virtualno številko ali poskusite znova pozneje": Preverite svojo virtualno številko ali poskusite znova pozneje, //c
           "--check your virtual number": Preverite svojo virtualno številko,
           "--continue": Nadaljuj,
           "--connection": povezava,
           "--sodelujte, živite v harmoniji": Sodelujte, živite v harmoniji z drugimi,
           "--izberi jezik": jezik navideznega telefona,
           "--ne preprečuj konkurence": Ne preprečuj konkurence, daj vsakomur priložnost, //d
           "--disconnection": prekinitev povezave,
           "--za vse uporabnike virtualnih telefonov": Za vse uporabnike virtualnih telefonov je priporočljiva uporaba VPN, //f
           "--go to login page": Pojdi na prijavno stran, //g
           "--historical": zgodovinski, //h
           "--i have account": že imam račun, //i
           "--nimam računa": nimam računa,
           "--it is your house": to je tvoja hiša,
           "--image / video +": slika / video +,
           "--identity verification": preverjanje identitete,
           "--izocash portal za stranke": izocash portal za stranke,
           "--identity update every year": posodobitev identitete vsako leto,
           "--izocash buy to": izocash Buy => izocash international,
           "--prijava": Prijavite se!, //l
           "--login": Prijavite se,
           "--prijavite se v Veil Brillant": Povežite se z Veil Brillant,
           "--prijava v trgovino vixinol": Povežite se s trgovino Vixinol,
           "--brezplačna prijava v vaš račun Veil Brillant": Brezplačno se prijavite v svoj račun Veil Brillant za dostop do te funkcije,
           "--login success": Prijava uspešna!,
           "--login now": Prijavite se zdaj!,
           "--logout success": uspešna odjava!,
           "--log out": odjava,
           "--logout": odjava,
           "--number": Število, //n
           "--name": Ime,
           "--now log in": Zdaj se prijavite!,
           "--ni prepovedi dušenja konkurence":
           "--brez ljubosumja, brez sovraštva": Brez ljubosumja, brez sovraštva, brez delitev,
           "--ne": Ne,
           "--uradni naslovi za dostop do vašega virtualnega telefona": Uradni naslovi za dostop do vašega virtualnega telefona, //o
           "--password": Geslo, //str
           "--točke dvigi izocash": Dvigi točk izocash,
           "--points dvigi": dvigi točk,
           "--po možnosti uporabite vpn": po možnosti uporabite VPN, ki ne pripada vašemu ponudniku internetnih storitev,
           "--vztrajnost se vedno izplača": Vztrajnost se na koncu vedno izplača,
           "--pravilo": Pravila, //r
           "--recommendation": Priporočila,
           "--registration": Registracija,
           "--prijava na Veil Brillant": Registrirajte se na Veil Brillant, //s
           "--prijava v trgovino vixinol": registrirajte se v trgovini Vixinol,
           "--signup": registracija,
           "--signup success": Registracija uspešna!,
           "--signup for free": Brezplačna registracija,
           “--signup success IA”: povezava uspešna”,
           "--settings": "Nastavitve",
           "--nastavitev aplikacije alrani": Konfiguracija aplikacije Alrani,
           "--nastavitev aplikacije izocash": Konfiguracija aplikacije izocash,
           "--nastavitev aplikacije vixinol": Konfiguracija aplikacije Vixinol,
           "--nastavitev aplikacije Veil Brillant": Konfiguracija aplikacije Veil Brillant,
           "--shranjevanje slik, videoposnetkov": shranjevanje slik, videoposnetkov in več drugih elementov,
           "--hitrost sprejema": Hitrost sprejema podatkov iz Datacentra,
           "--speed": hitrost,
           "--terminate": Prekini, //t
           "--vpn vam omogoča dostop": VPN vam omogoča dostop do spletnega mesta ali aplikacije, ki jo je vaš ponudnik internetnih storitev uvrstil na črni seznam,
           "--največje drevo je bilo zgoraj": največje drevo je bilo predvsem preprosto malo seme,
           "--touch the screen": dotaknite se zaslona za nadaljevanje,
           "--poskusi znova": Poskusi znova!,
           "--username": uporabniško ime, //u

           "--virtualna številka": Virtualna številka, //v
           "--nastavitve navideznega telefona": nastavitve navideznega telefona,
           "--uporabljen jezik navideznega telefona": jezik navideznega telefona je privzeto uporabljen na ravni aplikacije,
           "--virtualni telefon": virtualni telefon,
           "--validate": potrdi,
           "--dobrodošli na portalu za stranke izocash": Dobrodošli na portalu za stranke izocash, //w
           "--write a super code": vnesite super kodo,
           "--welcome to": dobrodošli v,
           "--kamor gre pozornost ljudi": kamor gre pozornost ljudi, gre tudi denar,
           "--winners persevere": Zmagovalci vztrajajo,
           "--bi se radi odjavili iz svojega računa Alrani": Ali se želite odjaviti iz svojega računa Alrani?,
           "--yes": Da, //y

           // država
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DR Kongo,
           "--ivoryCoast": Slonokoščena obala,

           // jezik
        "--afrikaans": afrikaans, //a
        "--albanian": albanski,
        "--amharic": amharščina,
        "--arabic": arabščina,
        "--armenian": armenski,
        "--assamese": asamščina,
        "--aymara": ajmara,
        "--azerbaijani": azerbajdžanski,
        "--bambara": Bambara, //b
        "--basque": baskovščina,
        "--belorusian": beloruščina,
        "--bengali": bengalščina,
        "--bhojpuri": bhojpuri,
        "--bosnian": bosanski,
        "--bulgarian": bolgarščina,
        "--catalan": katalonščina, //c
        "--cebuano": cebuano,
        "--chichewa": čičeva,
        "--chineseSimplified": kitajščina (poenostavljeno),
        "--chineseTraditional": kitajščina (tradicionalna),
        "--corsican": Korzičan,
        "--croatian": hrvaščina,
        "--czech": češčina,
        "--danish": danščina, //d
        "--dhivehi": divehi,
        "--dogri": Dogri,
        "--dutch": nizozemščina,
        "--english": angleščina, //e
        "--esperanto": esperanto,
        "--estonian": estonščina,
        "--ewe": ovca,
        "--filipino": filipinščina, //f
        "--finnish": finščina,
        "--francoski": francoščina,
        "--frisian": frizijščina,
        "--galician": galicijščina, //g
        "--georgian": gruzijsko,
        "--nemščina": nemščina,
        "--greek": grški,
        "--guarani": gvarani,
        "--gujarati": gudžarati,
        "--haitianCreole": haitska kreolščina, //h
        "--hausa": Hausa,
        "--hawaiian": havajski,
        "--hebrew": hebrejščina,
        "--hindi": hindijščina,
        "--hmong": Hmong,
        "--madžarski": madžarščina,
        "--icelandic": islandščina, //i
        "--igbo": Igbo,
        "--ilocano": Iločan,
        "--indonesian": indonezijščina,
        "--irish": irski,
        "--italian": italijanščina,
        "--japanese": japonščina, //j
        "--javanese": javanski,
        "--kannada": kanada, //k
        "--kazah": kazahščina,
        "--khmer": kmerski,
        "--kinyarwanda": kinjaruandščina,
        "--konkani": konkani,
        "--korean": korejščina,
        "--krio": Krio,
        "--kurdishKurmanji": kurdščina (Kurmanji),
        "--kurdishSorani": kurdščina (Sorani),
        "--kyrgyz": kirgiščina,
        "--lao": Lao, //l
        "--latin": latinščina,
        "--latvian": latvijščina,
        "--lingala": lingala,
        "--lithuanian": litovščina,
        "--luganda": luganda,
        "--luxembourgish": luksemburščina,
        "--makedonski": makedonski, //m
        "--maithili": maithili,
        "--malagasy": malgaški,
        "--malajski": malajski,
        "--malayalam": malajalamščina,
        "--maltese": malteščina,
        "--maori": Maori,
        "--marathi": maratščina,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": mongolščina,
        "--mjanmarburmansko": Mjanmar (burmansko),
        "--nepali": nepalščina, //n
        "--norwegian": norveščina,
        "--odiaOriya": Odia (Orija), //o
        "--oromo": Oromo,
        "--paštu": paštu, //str
        "--persian": perzijščina,
        "--polish": poljščina,
        "--portuguese": portugalščina,
        "--punjabi": pandžabi,
        "--quechua": kečua, //q
        "--romunski": romunščina, //r
        "--ruski": ruski,
        "--samoan": samoanski, //s
        "--sanskrt": sanskrt,
        "--scotsGaelic": škotska galščina,
        "--sepedi": Sepedi,
        "--srbski": srbski,
        "--sesotho": sesoto,
        "--shona": Šona,
        "--sindhi": Sindhi,
        "--sinhala": sinhalščina,
        "--slovak": slovaščina,
        "--slovenian": slovenščina,
        "--somali": somalski,
        "--spanish": španščina,
        "--sundanese": sundansko,
        "--swahili": svahili,
        "--swedish": švedščina,
        "--tadžik": tadžik, //t
        "--tamil": tamilščina,
        "--tatar": tatarščina,
        "--telugu": telugu,
        "--thai": tajščina,
        "--tigrinya": tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turščina,
        "--turkmen": turkmenščina,
        "--twi": twi,
        "--ukrainian": ukrajinščina, //u
        "--urdu": urdu,
        "--uyghur": ujgurščina,
        "--uzbek": uzbeščina,
        "--vietnamese": vietnamščina, //v
        "--welsh": valižanščina, //w
        "--xhosa": xhosa, //x
        "--jidiš": jidiš, //y
        "--yoruba": joruba,
        "--zulu": Zulu, //z
        },
      },

      // somali
      // somali
      somali: {
        translations: {
          "-- khalad dhacay": Khalad ayaa dhacay!, //a
           "--address": Cinwaan,
           "--talo": talo,
           "-- adigoo gujinaya sii wad": Markaad gujiso sii wad waxaa lagaa jarayaa akoonkaaga Veil Brillant, //b
           "-- markaad gujiso kala-baxa waa laga jarayaa": Markaad gujiso Disconnect waxa aad ka go'aysaa akoonkaaga izocash,
           "--hubi lambarkaaga farsamada ama isku day mar kale hadhow": Hubi lambarkaaga farsamada ama isku day mar kale hadhow, //c
           "--check your virtual number": Hubi lambarkaaga farsamada,
           "--sii wad": Sii wad,
           "--connection": Xiriirinta,
           "--wada-shaqeyn, wada-noolaansho": Wada-shaqeyn, la noolow kuwa kale,
           "--door luqadda": Luuqadda Taleefanka Virtual,
           "--ha ka hortagin tartanka": Ha ka hortagin tartanka, qof walba fursad sii, //d
           "--disconnection": goynta,
           "--dhammaan isticmaalayaasha taleefannada casriga ah": Dhammaan isticmaalayaasha Taleefanka Virtual, waxaa lagula talinayaa inay isticmaalaan VPN, //f
           "--go to login page": Tag bogga galitaanka, //g
           "-taariikheed": Taariikhi, //h
           "- i have account": Waxaan horay u lahaa akoon, //i
           "--ma haysto koonto": ma lihi xisaab,
           "--waa gurigaagii": waa gurigaagii,
           "--image / muuqaal +": Sawir / Muuqaal +,
           "--identity verification": Xaqiijinta aqoonsiga,
           "--zocash portal macmiilka": izocash macmiilka,
           "--identity update sannad walba": Cusboonaysiinta aqoonsiga sannad kasta,
           "--izocash iibso": izocash Iibso => ​​izocash caalami ah,
           "--gal": gal!, //l
           "--login": gal,
           "--login si xijaabka dhalaalaya": Ku xidh Xijaabka Brillant,
           "--gal dukaanka vixinol": Ku xidh dukaanka Vixinol,
           "--login for free to your veil Brillant account": Si bilaash ah u gal akoonkaaga Veil Brillant si aad u gasho sifadan,
           "--login guul": Login guul!,
           "--login now": Hadda gal!,
           "--guusha logout": Guul ka bixida
           "--ka bax": Ka bax,
           "--logout": Ka bax,
           "--lambar": Number, //n
           "--name": Magaca,
           "- hadda gal": Hadda, gal!,
           "--ma mamnuuci karo tartanka":
           "--masayr, nacayb ma jiro": Ma xaasid, nacayb, kala qaybsanaan la'aan.
           "--maya": Maya,
           "--cinwaanada rasmiga ah si aad u gasho taleefankaaga casriga ah": Cinwaanada rasmiga ah si aad u gasho taleefankaaga casriga ah, //o
           "--password": Password, //p
           "--points withdrawals izocash": Dhibcaha Ka-noqoshada izocash,
           "--dhibcaha ka-noqoshada": Dhibcaha Ka-noqoshada,
           "--doorbidayaa, adeegso vpn": Waxaa fiican, isticmaal VPN-ka aan lahayn adeeg bixiyahaaga internetka,
           "--ku- adkaysigu had iyo jeer wax-soo-saar": Ku adkaysiga had iyo jeer waxay faa'iido u leedahay dhammaadka,
           "--xukun": Xeerarka, //r
           "--talooyin": Talooyin,
           "--diiwaangelinta": Diiwaangelinta,
           "--is-diiwaangeli si aad u qurux badan": Iska diwaangeli Veil Brillant, //s
           "--is-diiwaangeli dukaanka vixinol": Iska diwaangeli dukaanka Vixinol,
           "--signup": Diiwaangeli,
           "--guul saxiix": Diiwaangelintu waa lagu guuleystay!,
           "--is-diiwaangelinta bilaashka ah": Isku diwaangeli bilaash,
           "--guusha isdiiwaangelinta IA": Xidhiidhku waa guulaystay",
           "--settings": "Settings",
           "--dejinta abka alrani": Habaynta arjiga Alrani,
           "--dejinta app-ka izocash": Habaynta codsiga izocash,
           "--dejinta abka vixinol": Habaynta codsiga Vixinol,
           "--dejinta app-ka xijaabka Brillant": Habaynta codsiga xijaabka Brillant,
           "--kaydinta sawirada, fiidyaha": Kaydinta sawirada, fiidyaha iyo dhawr waxyaalood oo kale,
           "--xawaaraha soo dhaweynta": Xawaaraha soo dhaweynta xogta ka socota Datacenter,
           "--xawaaraha": Xawaaraha,
           "--terminate": Jooji, //t
           "--vpn-ku wuxuu kuu ogolaanayaa inaad gasho": VPN-ku wuxuu kuu ogolaanayaa inaad gasho goob ama codsi uu adeeg bixiyahaaga internetku ku daray liiska madow,
           "--geedka ugu weyn ayaa ka sarreeya": Geedka ugu weyn wuxuu ka sarreeyaa iniin yar oo fudud,
           "--taabo shaashadda": Taabo shaashadda si aad u sii waddo,
           "--isku day marlabaad": Isku day mar kale!,
           "--username": Magaca isticmaalaha, //u

           "--lambarka Virtual": Lambarka dhabta ah, //v
           "--virtual phone settings": settings phone Virtual,
           "-- luqadda talefoonka Virtual waa lagu dabaqaa": Luqadda Taleefanka Virtual waxaa lagu dabaqaa heerka codsiga si toos ah,
           "--telefoonka Virtual": Taleefanka dhabta ah,
           "--validate": Xaqiiji,
           "--ku soo dhawaada bogga macmiilka izocash": Ku soo dhawoow Xariirka Macmiilka izocash, //w
           "--qor super code": Geli koodka sare,
           "--ku soo dhawoow": Ku soo dhawoow,
           "--halka dareenka dadku tago": Meesha dareenka dadku tago lacagtu,
           "---guulaystayaashu adkaystaan": Guulaystayaashu way adkaystaan,
           "--ma jeclaan lahayd inaad ka baxdo akoonkaaga Alrani": Ma rabtaa inaad ka baxdo akoonkaaga Alrani?,
           "--haa": Haa, //y

           // dalka
           "- Kongo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--dc": DRC,
           "-- Ivory Coast": Ivory Coast,

           // af
        "--afrikaans": Afrikaans, //a
        "- Albaniyan": Albaaniyaan,
        "--amharic": Amxaari,
        "--carabi": Carabi,
        "-- Armenian": Armenian,
        "--assamese": assamese,
        "--aymara": Aymara,
        "--asarbayjaani": Asarbayjaani,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusiyaan,
        "--Bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Bosniyan,
        "--Bulgarian": Bulgaariya,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Shiine (La fududeeyay),
        "--Chinese-Dhaqameed": Shiinees (Dhaqameed),
        "--korsican": Korsican,
        "--croatian": Croatian,
        "--Czech": Czech,
        "-- Danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Dutch": Dutch,
        "--Ingiriis": Ingiriisi, //e
        "--esperanto": Esperanto,
        "--estoniyan": Estoniyan,
        "--ewe": Ewe,
        "--filipino": Filibiin, //f
        "--Finnish": Finnish,
        "--Faransiiska": Faransiis,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Joorjiyaan,
        "--Jarmalka": Jarmal,
        "--Giriig": Giriig,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiiyan": Hawaiian,
        "- Cibraaniga": Cibraaniga,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--Hungarian": Hungarian,
        "--ilandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "- Indonesian": Indonesian,
        "--Irish": Irish,
        "--talyaani": Talyaani,
        "--japanese": Jabbaan, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "- Kuuriyaan": Kuuriyaan,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdi (Sorani),
        "--kyrgyz": Kyrgyzs,
        "--lao": Lao, //l
        "--latin": Laatiinka,
        "--latvia": Latvia,
        "--lingala": Lingala,
        "--Lithuanian": Lithuanian,
        "-luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--Masedooniyaanka": Makedoniya, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malaay,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Myanmar (Burmese),
        "--nepali": Nepali, //n
        "- norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "- Persian": Faaris,
        "--Polish": Polish,
        "--Bortiqiis": Boortaqiis,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romaaniyaan": Romanian, //r
        "--ruush": Ruush,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovakia": Slovakia,
        "--slovenian": Slovenia,
        "--somali": Somali,
        "--isbaanish": Isbaanish,
        "--sundanese": Sundanese,
        "--swahili": Sawaaxili,
        "--swedish": Iswidish,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tataar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": tigree,
        "--tsonga": Tsonga,
        "--Turki": Turki,
        "--turkmen": Turkmen,
        "--twi": Twi,
        "--Yukreeniyaan": Yukreeniyaan, //u
        "--urdu": Urduu,
        "--uyghur": Uyghur,
        "--Uzbek": Uzbek,
        "--Vietnamese": Fiyatnaamiis, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },*/

       // **spanish
       // **spanish
       spanish: {
        translations: {
          "--an error has occurred": "¡Ha ocurrido un error!", //a
           "--address": "Direcciones",
           "--advice": "Consejo",
           "--by clicking on continue": "Al hacer clic en continuar, se desconectará de su cuenta de Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "Al hacer clic en Desconectar, se desconectará de su cuenta izocash",
           "--check your virtual number or try again later": "Verifica tu número virtual o vuelve a intentarlo más tarde", //c
           "--check your virtual number": "Verifica tu número virtual",
           "--continue": "Continuar",
           "--connection": "Conexión",
           "--collaborate, live in harmony": "Colaborar, vivir en armonía con los demás",
           "--virtual phone language": "Idioma del teléfono virtual",
           "--don't prevent competition": "No impidas la competencia, dales a todos una oportunidad", //d
           "--disconnection": "Desconexión",
           "--for all virtual phone users": "para todos los usuarios de teléfonos virtuales, se recomienda utilizar una VPN", //f
           "--go to login page": "Ir a la página de inicio de sesión", //g
           "--historical": "Histórico", //h
           "--i have account": "ya tengo una cuenta", //yo
           "--i don't have account": "No tengo cuenta",
           "--it is your house": "es tu casa",
           "--image / video +": "Imagen/vídeo +",
           "--identity verification": "verificación de identidad",
           "--izocash customer portal": "Portal del cliente izocash",
           "--identity update every year": "actualización de identidad cada año",
           "--izocash buy to": "izocash Comprar => izocash internacional",
           "--log in": "¡Inicia sesión!", //l
           "--login": "inicie sesión",
           "--login to veil brillant": "Conéctate a Veil Brillant",
           "--login to vixinol store": "Conéctese a la tienda Vixinol",
           "--login for free to your veil brillant account": "inicie sesión de forma gratuita en su cuenta de Veil Brillant para acceder a esta función.",
           "--login success": "¡Inicia sesión exitosamente!",
           "--login now": "¡Inicia sesión ahora!",
           "--logout success": "¡Cierre de sesión exitoso!",
           "--log out": "cerrar sesión",
           "--logout": "cerrar sesión",
           "--number": "Número", //n
           "--name": "nombre",
           "--now log in": "¡Ahora, inicia sesión!",
           "--no ban on stifling competition": "sin prohibición de reprimir la competencia",
           "--no jealousy, no hatred": "Sin celos, sin odio, sin divisiones",
           "--no": "no",
           "--official addresses to access your virtual phone": "Direcciones oficiales para acceder a tu teléfono virtual", //o
           "--password": "Contraseña", //p
           "--points withdrawals izocash": "Retiros de puntos izocash",
           "--points withdrawals": "Retiros de puntos",
           "--preferably, use a vpn": "Preferiblemente, use una VPN que no pertenezca a su proveedor de servicios de Internet",
           "--persistence always pays off": "La perseverancia siempre da sus frutos al final",
           "--rule": "Reglas", //r
           "--recommendation": "Recomendaciones",
           "--registration": "Registro",
           "--signup to veil brillant": "Regístrese en Veil Brillant", //s
           "--signup to vixinol store": "Regístrese en la tienda Vixinol",
           "--signup": "Registrarse",
           "--signup success": "¡Registro exitoso!",
           "--signup for free": "Regístrate gratis",
           "--signup success IA": "Conexión exitosa”",
           "--settings": "Configuración",
           "--setting up the alrani app": "Configurando la aplicación Alrani",
           "--setting up the izocash app": "Configurando la aplicación izocash",
           "--setting up the vixinol app": "Configurando la aplicación Vixinol",
           "--setting up the veil brillant app": "Configuración de la aplicación Veil Brillant",
           "--storage of images, videos": "Almacenamiento de imágenes, vídeos y varios otros elementos",
           "--speed of reception": "Velocidad de recepción de datos del Datacenter",
           "--speed": "Velocidad",
           "--terminate": "Terminar", //t
           "--the vpn allows you to access": "La VPN te permite acceder a un sitio o una aplicación que tu proveedor de servicios de Internet ha incluido en la lista negra.",
           "--the largest tree was above": "El árbol más grande era sobre todo una simple semillita",
           "--touch the screen": "toca la pantalla para continuar",
           "--try again": "¡Inténtalo de nuevo!",
           "--username": "nombre de usuario", //u

           "--virtual number": "número virtual", //v
           "--virtual phone settings": "configuración del teléfono virtual",
           "--virtual phone language is applied": "El idioma del teléfono virtual se aplica en el nivel de la aplicación de forma predeterminada.",
           "--virtual phone": "teléfono virtual",
           "--validate": "validar",
           "--welcome to the izocash customer portal": "Bienvenido al portal del cliente de izocash", //w
           "--write a super code": "Ingrese un supercódigo",
           "--welcome to": "Bienvenido a",
           "--where people's attention goes": "Donde va la atención de la gente va el dinero",
           "--winners persevere": "Los ganadores perseveran",
           "--would you like to log out of your Alrani account": "¿Quiere cerrar sesión en su cuenta Alrani?",
           "--yes": "Sí", //s

           // pays
           "--congo": "Congo Brazzaville",
           "--cameroon": "Camerún",
           "--drc": "República Democrática del Congo",
           "--ivoryCoast": "Costa de Marfil",

           // langues
        "--afrikaans": "afrikáans", //a
        "--albanian": "albanés",
        "--amharic": "Amárico",
        "--arabic": "Árabe",
        "--armenian": "armenio",
        "--assamese": "asamés",
        "--aymara": "aymara",
        "--azerbaijani": "azerbaiyano",
        "--bambara": "Bambara", //b
        "--basque": "vasco",
        "--belarusian": "bielorruso",
        "--bengali": "bengalí",
        "--bhojpuri": "Bhojpuri",
        "--bosnian": "bosnio",
        "--bulgarian": "búlgaro",
        "--catalan": "catalán", //c
        "--cebuano": "cebuano",
        "--chichewa": "chichewa",
        "--chineseSimplified": "Chino (simplificado)",
        "--chineseTraditional": "Chino (tradicional)",
        "--corsican": "corso",
        "--croatian": "croata",
        "--czech": "checo",
        "--danish": "danés", //d
        "--dhivehi": "Dhivehi",
        "--dogri": "Dogri",
        "--dutch": "holandés",
        "--english": "Inglés", //e
        "--esperanto": "esperanto",
        "--estonian": "estonio",
        "--ewe": "oveja",
        "--filipino": "filipino", //f
        "--finnish": "finlandés",
        "--french": "Francés",
        "--frisian": "frisón",
        "--galician": "gallego", //g
        "--georgian": "georgiano",
        "--german": "Alemán",
        "--greek": "griego",
        "--guarani": "guaraní",
        "--gujarati": "gujarati",
        "--haitianCreole": "criollo haitiano", //h
        "--hausa": "hausa",
        "--hawaiian": "hawaiano",
        "--hebrew": "hebreo",
        "--Hindi": "hindi",
        "--hmong": "Hmong",
        "--hungarian": "húngaro",
        "--icelandic": "islandés", //i
        "--igbo": "igbo",
        "--ilocano": "Ilocano",
        "--indonesian": "indonesio",
        "--irish": "irlandés",
        "--italian": "italiano",
        "--japanese": "japonés", //j
        "--javanese": "javanés",
        "--kannada": "kannada", //k
        "--kazakh": "kazajo",
        "--khmer": "jemer",
        "--kinyarwanda": "kinyarwanda",
        "--konkani": "Konkani",
        "--korean": "coreano",
        "--krio": "Krio",
        "--kurdishKurmanji": "kurdo (Kurmanji)",
        "--kurdishSorani": "kurdo (Sorani)",
        "--kyrgyz": "kirguís",
        "--lao": "Lao", //l
        "--latin": "latín",
        "--latvian": "letón",
        "--lingala": "Lingala",
        "--lithuanian": "lituano",
        "--luganda": "luganda",
        "--luxembourgish": "luxemburgués",
        "--macedonian": "macedonio", //m
        "--maithili": "Maithili",
        "--malagasy": "malgache",
        "--malay": "malayo",
        "--malayalam": "malayalam",
        "--maltese": "maltés",
        "--maori": "maorí",
        "--marathi": "marathi",
        "--mizo": "Mizo",
        "--mongolian": "mongol",
        "--myanmarBurmese": "Myanmar (birmano)",
        "--nepali": "nepalí", //n
        "--norwegian": "noruego",
        "--odiaOriya": "Odia (Oriya)", //o
        "--oromo": "Oromo",
        "--pashto": "pashto", //p
        "--persian": "persa",
        "--polish": "polaco",
        "--portuguese": "Portugués",
        "--punjabi": "punjabi",
        "--quechua": "Quechua", //q
        "--romanian": "rumano", //r
        "--russian": "Ruso",
        "--samoan": "samoano", //s
        "--sanskrit": "sánscrito",
        "--scotsGaelic": "gaélico escocés",
        "--sepedi": "Sepedi",
        "--serbian": "serbio",
        "--sesotho": "sesoto",
        "--shona": "Shona",
        "--sindhi": "sindhi",
        "--sinhala": "cingalés",
        "--slovak": "eslovaco",
        "--slovenian": "esloveno",
        "--somali": "somalí",
        "--spanish": "Español",
        "--sundanese": "sundanés",
        "--swahili": "suajili",
        "--swedish": "sueco",
        "--tajik": "tayiko", //t
        "--tamil": "tamil",
        "--tatar": "tártaro",
        "--telugu": "telugu",
        "--thai": "tailandés",
        "--tigrinya": "Tigriña",
        "--tsonga": "Tsonga",
        "--turkish": "turco",
        "--turkmen": "turcomanos",
        "--twi": "Twi",
        "--ukrainian": "Ucraniano", //u
        "--urdu": "urdu",
        "--uyghur": "uigur",
        "--uzbek": "uzbeko",
        "--vietnamese": "vietnamita", //v
        "--welsh": "galés", //w
        "--xhosa": "Xhosa", //x
        "--yiddish": "yiddish", //y
        "--yoruba": "Yoruba",
        "--zulu": "zulú", //z
        },
      },

      /*
      // sundanese
      // sundanese
      sundanese: {
        translations: {
          "--an error has occurred": Aya kasalahan!, //a
          "--address": Alamat,
          "--advice": Naséhat,
          "--by clicking on continue": Ku ngaklik teruskeun anjeun bakal dipegatkeun tina akun Veil Brillant anjeun, //b
          "--by ngaklik dina pegatkeun sambungan anjeun bakal dipegatkeun": Ku ngaklik dina Pegatkeun sambungan anjeun bakal dipegatkeun tina akun izocash anjeun,
          "--pariksa nomer virtual anjeun atanapi cobian deui engké": Pariksa nomer virtual anjeun atanapi cobian deui engké, //c
          "--check your virtual number": Pariksa virtual number Anjeun,
          "--continue": Teruskeun,
          "--connection": Sambungan,
          "--collaborate, live in harmony": Kolaborasi, hirup rukun jeung batur,
          "--choose language": Basa Telepon Virtual,
          "--ulah nyegah kompetisi": Ulah nyegah kompetisi, masihan dulur kasempetan, //d
          "--disconnection": Pegatkeun sambungan,
          "--for all virtual phone users": Kanggo sadaya pangguna Virtual Phone, disarankeun make VPN, //f
          "--go to login page": Pindah ka kaca login, //g
          "--historical": Sajarah, //h
          "--abdi gaduh akun": Abdi parantos gaduh akun, //i
          "--abdi teu gaduh akun": Abdi teu gaduh akun,
          "--imah anjeun": éta imah anjeun,
          "--gambar / video +": Gambar / Video +,
          "--identity verification": Verifikasi identitas,
          "--izocash customer portal": izocash Customer Portal,
          "--identity update every year": Update identitas unggal taun,
          "--izocash buy to": izocash Buy => izocash internasional,
          "--log in": Asup!, //l
          "--login": Asup log,
          "--login to veil brilliant": Nyambung ka Veil Brillant,
          "--login ka toko vixinol": Sambungkeun ka Toko Vixinol,
          "--login gratis ka akun Brillant veil anjeun": Asup gratis ka akun Veil Brillant anjeun pikeun ngakses fitur ieu,
          "--login success": Login suksés!,
          "--login ayeuna": Asup ayeuna!,
          "--logout success": Kaluar suksés!,
          "--kaluar": Kaluar,
          "--logout": Kaluar,
          "--number": Jumlah, //n
          "--name": Ngaran,
          "--now log in": Ayeuna, Asup!,
          "--euweuh larangan dina kompetisi stifling":
          "--no jealousy, no hatred": Taya sirik, euweuh hatena, euweuh perpecahan,
          "--henteu": Henteu,
          "--alamat resmi pikeun ngakses telepon virtual anjeun": Alamat resmi pikeun ngakses telepon virtual anjeun, //o
          "--password": Sandi, //p
          "--points withdrawals izocash": Points Withdrawals izocash,
          "--points withdrawals": Points Withdrawals,
          "--preferably, make a vpn": Preferably, make VPN nu teu milik panyadia ladenan internét anjeun,
          "--persistence always pays off": Kegigihan sok aya hasilna,
          "--rule": Aturan, //r
          "--recommendation": Rekomendasi,
          "--registration": Pendaptaran,
          "--signup to veil brilliant": Ngadaptar dina Veil Brillant, //s
          "--signup to vixinol store": Ngadaptar di Vixinol Store,
          "--signup": Ngadaptar,
          "--signup success": Pendaptaran suksés!,
          "--signup for free": Ngadaptar gratis,
          "--signup success IA": Sambungan suksés",
          "--settings": "Setélan",
          "--setting up the alrani app": Konfigurasi aplikasi Alrani,
          "--setting up the izocash app": Konfigurasi aplikasi izocash,
          "--setting up the vixinol app": Konfigurasi aplikasi Vixinol,
          "--setting up the veil Brillant app": Konfigurasi aplikasi Veil Brillant,
          "--storage of images, videos": Panyimpenan gambar, video sareng sababaraha elemen séjén,
          "--speed of reception": Laju panarimaan data ti Datacenter,
          "--speed": Laju,
          "--terminate": Panutup, //t
          "--vpn ngidinan Anjeun pikeun ngakses": VPN ngidinan Anjeun pikeun ngakses situs atawa aplikasi nu panyadia ladenan internét anjeun geus blacklisted,
          "--tangkal panggedena di luhur": Tangkal panggedena luhureun sakabeh siki leutik basajan,
          "--touch the screen": Toél layar pikeun neruskeun,
          "--coba deui": Coba deui!,
          "--username": Ngaran pamaké, //u

          "--virtual number": Nomer virtual, //v
           "--virtual phone settings": Setelan telepon virtual,
           "--virtual Phone language is applied": Basa Virtual Phone diterapkeun dina tingkat aplikasi sacara standar,
           "--telepon virtual": Telepon virtual,
           "--validate": Validasi,
           "--wilujeng sumping di portal palanggan izocash": Wilujeng sumping di Portal Pelanggan izocash, //w
           "--write a super code": Asupkeun kode Super,
           "--wilujeng sumping": Wilujeng sumping di,
           "--mana perhatian jalma indit": Dimana perhatian jalma indit duit,
           "--winners persevere": Anu meunangna tabah,
           "--naha anjeun badé kaluar tina akun Alrani anjeun": Naha anjeun badé kaluar tina akun Alrani anjeun?,
           "--enya": Leres, //y

           // nagara
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Basisir Gading,

           // basa
        "--afrikaans": Afrikaans, //a
        "--albanian": basa Albania,
        "--amharic": Amharic,
        "--arab": Arab,
        "--arménia": Arménia,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Basa Azerbaijan,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusia": Bélarus,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Bosnia,
        "--bulgarian": Bulgaria,
        "--catalan": Katalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Cina (Disederhanakeun),
        "--chineseTraditional": Cina (Tradisional),
        "--corsican": Korsika,
        "--croatian": Kroasia,
        "--czech": Ceko,
        "--danish": Denmark, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Walanda,
        "--english": Inggris, //e
        "--esperanto": Ésperanto,
        "--estonian": Éstonia,
        "--ewe": Euweuh,
        "--filipino": Filipino, //f
        "--finnish": Finlandia,
        "--french": Perancis,
        "--frisian": Frisian,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "--jerman": Jérman,
        "--greek": Yunani,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaii,
        "--hebrew": Ibrani,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Hungaria,
        "--islandia": Islandia, //i
        "--igbo": Igbo,
        "--ilocano": Ilokano,
        "--indonesian": basa Indonésia,
        "--irish": Irlandia,
        "--italian": Italia,
        "--japanese": Jepang, //j
        "--javanese": basa Jawa,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Koréa,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdi (Kurmanji),
        "--kurdishSorani": Kurdi (Sorani),
        "--kyrgyz": Kirgizstan,
        "--lao": Lao, //l
        "--latin": Latin,
        "--latvian": Latvia,
        "--lingala": Lingala,
        "--lituanian": Lituania,
        "--luganda": Luganda,
        "--luxembourgish": Luksemburg,
        "--Macedonian": Makedonia, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malayu,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongol,
        "--myanmarBurmese": Myanmar (Burma),
        "--nepali": Nepal, //n
        "--norwegian": Norwegia,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Pérsia,
        "--polish": Polandia,
        "--portuguese": Portugis,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanian": Romania, //r
        "--russian": Rusia,
        "--samoan": Samoan, //s
        "--sanskrit": basa Sanskerta,
        "--scotsGaelic": Skotlandia Gaelik,
        "--sepedi": Sepedi,
        "--serbian": Sérbia,
        "--sesotho": Sésotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovénia": Slovénia,
        "--somali": Somali,
        "--spanyol": Spanyol,
        "--Sundanese": Basa Sunda,
        "--swahili": Swahili,
        "--swedish": Swédia,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Turki,
        "--turkmen": Turkmén,
        "--twi": Dua,
        "--ukrainian": Ukrania, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--vietnamese": Vietnam, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // swahili
      // swahili
      swahili: {
        translations: {
          "--hitilafu imetokea": Hitilafu imetokea!, //a
           "--anwani": Anwani,
           "--ushauri": Ushauri,
           "--kwa kubofya endelea": Kwa kubofya endelea utaondolewa kwenye akaunti yako ya Veil Brillant, //b
           "--kwa kubofya kata muunganisho utakatishwa muunganisho": Kwa kubofya Tenganisha utaondolewa kwenye akaunti yako ya izocash,
           "--angalia nambari yako pepe au ujaribu tena baadaye": Angalia nambari yako ya mtandaoni au ujaribu tena baadaye, //c
           "--angalia nambari yako pepe": Angalia nambari yako pepe,
           "--endelea": Endelea,
           "--muunganisho": Muunganisho,
           "--shirikiana, ishi kwa maelewano": Shirikiana, ishi kwa amani na wengine,
           "--chagua lugha": Lugha ya Simu pepe,
           "--usizuie ushindani": Usizuie ushindani, mpe kila mtu nafasi, //d
           "--kukatwa": Kukatwa,
           "--kwa watumiaji wote wa simu pepe": Kwa watumiaji wote wa Simu ya Mtandaoni, inashauriwa kutumia VPN, //f
           "--nenda kwa ukurasa wa kuingia": Nenda kwenye ukurasa wa kuingia, //g
           "--kihistoria": Kihistoria, //h
           "--i have account": Tayari nina akaunti, //i
           "--sina akaunti": Sina akaunti,
           "--ni nyumba yako": ni nyumba yako,
           "--picha / video +": Picha / Video +,
           "--uthibitishaji wa kitambulisho": Uthibitishaji wa kitambulisho,
           "--izocash mteja portal": izocash Customer Portal,
           "--sasisho la kitambulisho kila mwaka": Usasishaji wa kitambulisho kila mwaka,
           "--izocash buy to": izocash Nunua => izocash international,
           "--ingia": Ingia!, //l
           "--ingia": Ingia,
           "--ingia kwa pazia nzuri": Unganisha kwa Pazia Brillant,
           "--ingia kwenye duka la vixinol": Unganisha kwenye Duka la Vixinol,
           "--ingia bila malipo kwa akaunti yako ya Veil Brillant": Ingia bila malipo kwa akaunti yako ya Veil Brillant ili kufikia kipengele hiki,
           "--mafanikio ya kuingia": Kuingia kwa mafanikio!,
           "--ingia sasa": Ingia sasa!,
           "--logout success": Kuondoka kwa mafanikio!,
           "--toka nje": Toka,
           "--toka": Toka nje,
           "--namba": Nambari, //n
           "--jina": Jina,
           "--sasa ingia": Sasa, Ingia!,
           "--hakuna marufuku ya kuzuia mashindano":
           "--hakuna wivu, hakuna chuki": hakuna wivu, hakuna chuki, hakuna migawanyiko,
           "--hapana": Hapana,
           "--anwani rasmi za kufikia simu yako pepe": Anwani rasmi za kufikia simu yako pepe, //o
           "--nenosiri": Nenosiri, //p
           "--points withdrawals izocash": Uondoaji wa Pointi izocash,
           "--uondoaji wa pointi": Uondoaji wa pointi,
           "--ikiwezekana, tumia vpn": Ikiwezekana, tumia VPN ambayo si ya mtoa huduma wako wa mtandao,
           "--kung'ang'ania daima huleta faida": Ustahimilivu daima huleta matokeo mwishowe,
           "--tawala": Kanuni, //r
           "--pendekezo": Mapendekezo,
           "--registration": Usajili,
           "--jisajili kwa pazia nzuri": Jisajili kwenye Veil Brillant, //s
           "--jisajili kwenye duka la vixinol": Jisajili kwenye Duka la Vixinol,
           "--jisajili": Jisajili,
           "--mafanikio ya kujisajili": Usajili umefaulu!,
           "--jisajili bila malipo": Jisajili bila malipo,
           "--mafanikio ya kujisajili IA": Muunganisho umefaulu",
           "--settings": "Mipangilio",
           "--kuanzisha programu ya alrani": Kusanidi programu ya Alrani,
           "--kuanzisha programu ya izocash": Kusanidi programu ya izocash,
           "--kuanzisha programu ya vixinol": Kusanidi programu ya Vixinol,
           "--kusanidi programu ya Kipaji cha pazia": Kusanidi programu ya Kipaji cha Pazia,
           "-- uhifadhi wa picha, video": Uhifadhi wa picha, video na vipengele vingine kadhaa,
           "--kasi ya mapokezi": Kasi ya upokeaji wa data kutoka kwa Datacenter,
           "--kasi": Kasi,
           "--komesha": Sitisha, //t
           "--vpn inakuruhusu kufikia": VPN inakuruhusu kufikia tovuti au programu ambayo mtoa huduma wako wa mtandao ameizuia,
           "--mti mkubwa zaidi ulikuwa juu": Mti mkubwa zaidi ulikuwa juu ya mbegu zote ndogo,
           "--gusa skrini": Gusa skrini ili kuendelea,
           "--jaribu tena": Jaribu tena!,
           "--username": Jina la mtumiaji, //u

           "--nambari halisi": Nambari pepe, //v
           "--mipangilio ya simu halisi": Mipangilio ya simu pepe,
           "--Lugha halisi ya Simu inatumika": Lugha ya Simu pepe inatumika katika kiwango cha programu kwa chaguo-msingi,
           "--simu halisi": Simu pepe,
           "--thibitisha": Thibitisha,
           "--karibu kwenye tovuti ya mteja wa izocash": Karibu kwenye Tovuti ya Wateja ya izocash, //w
           "--andika msimbo bora": Weka Msimbo Bora,
           "-- karibu kwa": Karibu kwa,
           "--ambapo umakini wa watu huenda": Mahali ambapo umakini wa watu huenda pesa huenda,
           "--washindi vumilia": Washindi huvumilia,
           "--ungependa kuondoka kwenye akaunti yako ya Alrani": Je, unataka kutoka kwenye akaunti yako ya Alrani?,
           "--ndiyo": Ndiyo, //y

           // nchi
           "--kongo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // lugha
        "--Waafrikaans": Kiafrikana, //a
        "--albania": Kialbeni,
        "--amharic": Kiamhari,
        "--arabic": Kiarabu,
        "--Kiarmenia": Kiarmenia,
        "--assamese": Kiassamese,
        "--aymara": Aymara,
        "--azerbaijani": Kiazabajani,
        "--bambara": Bambara, //b
        "--basque": Kibasque,
        "-- Kibelarusi": Kibelarusi,
        "--bengali": Kibengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Kibosnia,
        "--bulgarian": Kibulgaria,
        "--catalan": Kikatalani, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Kichina (Kilichorahisishwa),
        "--chineseTraditional": Kichina (Cha Jadi),
        "--corsican": Kikosikani,
        "--Kikroeshia": Kikroeshia,
        "-- Czech": Kicheki,
        "--danish": Kideni, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Kiholanzi,
        "--english": Kiingereza, //e
        "--esperanto": Kiesperanto,
        "--Kiestonia": Kiestonia,
        "--ewe": Ewe,
        "--filipino": Kifilipino, //f
        "--Kifini": Kifini,
        "-- Kifaransa": Kifaransa,
        "--frisian": Kifrisia,
        "--galician": Kigalisia, //g
        "--georgian": Kijojiajia,
        "--kijerumani": Kijerumani,
        "--Kigiriki": Kigiriki,
        "--guarani": Guarani,
        "--gujarati": Kigujarati,
        "--haitianCreole": Krioli ya Haiti, //h
        "--hausa": Kihausa,
        "--hawaiian": Kihawai,
        "--Kiebrania": Kiebrania,
        "--hindi": Kihindi,
        "--hmong": Hmong,
        "--hungarian": Hungarian,
        "--isilandi": Kiaislandi, //i
        "--igbo": Kiigbo,
        "-- ilocano": Ilocano,
        "--indonesian": Kiindonesia,
        "--Irish": Kiayalandi,
        "--italian": Kiitaliano,
        "--japani": Kijapani, //j
        "--javanese": Kijava,
        "--kannada": Kikannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": Kikorea,
        "--krio": Krio,
        "--kurdishKurmanji": Kikurdi (Kurmanji),
        "--kurdishSorani": Kikurdi (Kisorani),
        "--kyrgyz": Kirigizi,
        "--lao": Lao, //l
        "--latin": Kilatini,
        "--latvian": Kilatvia,
        "--lingala": Lingala,
        "--lithuanian": Kilithuania,
        "--luganda": Kiganda,
        "--luxembourgish": Luxembourgish,
        "--Masedonia": Kimasedonia, //m
        "--maithili": Maithili,
        "--malagasi": Kimalagasi,
        "--malay": Malay,
        "--malayalam": Kimalayalam,
        "--malta": Kimalta,
        "--maori": Kimaori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Kimongolia,
        "--myanmarBurmese": Myanmar (Kiburma),
        "--nepali": Kinepali, //n
        "--Kinorwe": Kinorwe,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Kipashto, //p
        "-- Kiajemi": Kiajemi,
        "--Polish": Kipolishi,
        "--Kireno": Kireno,
        "--punjabi": Kipunjabi,
        "--quechua": Kiquechua, //q
        "--romanian": Kiromania, //r
        "-- Kirusi": Kirusi,
        "--samoan": Kisamoa, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Kigaeli cha Kiskoti,
        "--sepedi": Sepedi,
        "--serbia": Kiserbia,
        "--sesotho": Sesotho,
        "--shona": Kishona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovakia": Kislovakia,
        "--Kislovenia": Kislovenia,
        "--somali": Msomali,
        "--Kihispania": Kihispania,
        "--sundanese": Kisunda,
        "--swahili": Kiswahili,
        "--Swedish": Kiswidi,
        "--tajik": Tajiki, //t
        "--tamil": Kitamil,
        "--Tatar": Kitatari,
        "--telugu": Kitelugu,
        "--thai": Thai,
        "--tigrinya": Kitigrinya,
        "--tsonga": Tsonga,
        "-- Kituruki": Kituruki,
        "--Turkmen": Waturukimeni,
        "--twi": Twi,
        "--Ukrainian": Kiukreni, //u
        "--urdu": Kiurdu,
        "--uyghur": Uyghur,
        "--Uzbeki": Kiuzbeki,
        "--vietnamese": Kivietinamu, //v
        "--welsh": Kiwelisi, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Kiyidi, //y
        "--yoruba": Kiyoruba,
        "--zulu": Kizulu, //z
        },
      },

      // swedish
      // swedish
      swedish: {
        translations: {
          "--ett fel har inträffat": Ett fel har inträffat!, //a
           "--adress": Adresser,
           "--advice": Råd,
           "--genom att klicka på fortsätt": Genom att klicka på fortsätt kommer du att kopplas bort från ditt Veil Brillant-konto, //b
           "--genom att klicka på koppla bort kommer du att kopplas bort": Genom att klicka på Koppla från kopplas du från ditt izocash-konto,
           "--kontrollera ditt virtuella nummer eller försök igen senare": Kontrollera ditt virtuella nummer eller försök igen senare, //c
           "--kontrollera ditt virtuella nummer": Kontrollera ditt virtuella nummer,
           "--continue": Fortsätt,
           "--connection": Anslutning,
           "--samarbeta, lev i harmoni": Samarbeta, lev i harmoni med andra,
           "--välj språk": virtuellt telefonspråk,
           "--förhindra inte konkurrens": Förhindra inte konkurrens, ge alla en chans, //d
           "--disconnection": Frånkoppling,
           "--för alla virtuella telefonanvändare": För alla virtuella telefonanvändare rekommenderas att använda en VPN, //f
           "--gå till inloggningssidan": Gå till inloggningssidan, //g
           "--historical": Historisk, //h
           "--jag har konto": Jag har redan ett konto, //i
           "--jag har inte ett konto": Jag har inget konto,
           "--det är ditt hus": det är ditt hus,
           "--image / video +": Bild / Video +,
           "--identity verification": Identitetsverifiering,
           "--izocash kundportal": izocash kundportal,
           "--identity update every year": Identitetsuppdatering varje år,
           "--izocash köp till": izocash Köp => izocash internationellt,
           "--log in": Logga in!, //l
           "--login": Logga in,
           "--logga in på Veil Brillant": Anslut till Veil Brillant,
           "--logga in på Vixinol Store": Anslut till Vixinol Store,
           "--logga in gratis på ditt Veil Brillant-konto": Logga in gratis på ditt Veil Brillant-konto för att komma åt den här funktionen,
           "--login success": Inloggningen lyckades!,
           "--login nu": Logga in nu!,
           "--logout success": Utloggningen lyckades!,
           "--logga ut": Logga ut,
           "--logout": Logga ut,
           "--nummer": Nummer, //n
           "--name": Namn,
           "--now log in": Nu, logga in!,
           "--inget förbud mot att kväva konkurrensen":
           "--ingen svartsjuka, inget hat": Ingen svartsjuka, inget hat, inga splittringar,
           "--Nej nej,
           "--officiella adresser för åtkomst till din virtuella telefon": Officiella adresser för åtkomst till din virtuella telefon, //o
           "--password": Lösenord, //p
           "--poänguttag izocash": Poänguttag izocash,
           "--poänguttag": Poänguttag,
           "--företrädesvis, använd en vpn": Använd helst en VPN som inte tillhör din internetleverantör,
           "--uthållighet lönar sig alltid": Uthållighet lönar sig alltid i slutändan,
           "--rule": Regler, //r
           "--recommendation": Rekommendationer,
           "--registration": Registrering,
           "--signup to veil brilliant": Registrera dig på Veil Brillant, //s
           "--signup to vixinol store": Registrera dig på Vixinol Store,
           "--signup": Registrera dig,
           "--signup success": Registreringen lyckad!,
           "--signup for free": Registrera dig gratis,
           "--signup success IA": Anslutning lyckad",
           "--settings": "Inställningar",
           "--sätta upp alrani-appen": Konfigurera Alrani-appen,
           "--sätta upp izocash-appen": Konfigurera izocash-appen,
           "--sätta upp vixinol-appen": Konfigurera Vixinol-appen,
           "--sätta upp Veil Brillant-appen": Konfigurera Veil Brillant-applikationen,
           "--lagring av bilder, videor": Lagring av bilder, videor och flera andra element,
           "--mottagningshastighet": Mottagningshastighet av data från datacentret,
           "--speed": Hastighet,
           "--terminate": Avsluta, //t
           "--vpn tillåter dig att komma åt": VPN ger dig tillgång till en webbplats eller en applikation som din internetleverantör har svartlistat,
           "--det största trädet var ovanför": Det största trädet var framför allt ett enkelt litet frö,
           "--touch the screen": Peka på skärmen för att fortsätta,
           "--try again": Försök igen!,
           "--användarnamn": Användarnamn, //u

           "--virtuellt nummer": Virtuellt nummer, //v
           "--virtuella telefoninställningar": Virtuella telefoninställningar,
           "--virtuellt telefonspråk används": Det virtuella telefonspråket tillämpas på applikationsnivå som standard,
           "--virtual phone": Virtuell telefon,
           "--validate": Validera,
           "--välkommen till izocash kundportal": Välkommen till izocash kundportal, //w
           "--skriv en superkod": Ange en superkod,
           "--välkommen till": Välkommen till,
           "--vart folks uppmärksamhet går": Dit folks uppmärksamhet går pengar går,
           "--winners persevere": Vinnarna håller ut,
           "--vill du logga ut från ditt Alrani-konto": Vill du logga ut från ditt Alrani-konto?,
           "--yes": Ja, //y

           // Land
           "--congo": Kongo Brazzaville,
           "--cameroon": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Elfenbenskusten,

           // språk
        "--afrikaans": Afrikaans, //a
        "--albanian": albanska,
        "--amhariska": amhariska,
        "--arabic": arabiska,
        "--armenian": armeniska,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbajdzjanska": azerbajdzjanska,
        "--bambara": Bambara, //b
        "--basque": baskiska,
        "--vitryska": vitryska,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": bosniska,
        "--bulgarian": bulgariska,
        "--catalan": Katalanska, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": kinesiska (förenklad),
        "--chineseTraditional": kinesiska (traditionell),
        "--corsican": Corsican,
        "--croatian": kroatiska,
        "--tjeckiska": Tjeckiska,
        "--danska": danska, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--holländska": holländska,
        "--engelska": engelska, //e
        "--esperanto": Esperanto,
        "--estniska": estniska,
        "--ewe": Tacka,
        "--filippinska": filippinska, //f
        "--finnish": finska,
        "--french": franska,
        "--frisian": frisiska,
        "--galiciska": galiciska, //g
        "--georgian": georgiska,
        "--german": tyska,
        "--greek": grekiska,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaiian,
        "--hebrew": hebreiska,
        "--hindi": hindi,
        "--hmong": Hmong,
        "--ungerska": ungerska,
        "--isländska": isländska, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesiska": indonesiska,
        "--irish": irländska,
        "--italienska": italienska,
        "--japanska": japanska, //j
        "--javanese": javanesiska,
        "--kannada": Kannada, //k
        "--kazakh": kazakiska,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korean": koreanska,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdiska (Kurmanji),
        "--kurdishSorani": Kurdiska (Sorani),
        "--kyrgyz": kirgisiska,
        "--lao": Lao, //l
        "--latin": latin,
        "--latviska": lettiska,
        "--lingala": Lingala,
        "--lithuanian": litauiska,
        "--luganda": Luganda,
        "--luxembourgish": luxemburgska,
        "--macedonian": makedonska, //m
        "--maithili": Maithili,
        "--malagasiska": malagasiska,
        "--malay": malajiska,
        "--malayalam": malayalam,
        "--maltesiska": maltesiska,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongoliska": mongoliska,
        "--myanmarburmesiska": Myanmar (burmesiska),
        "--nepali": Nepali, //n
        "--norwegian": norska,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": persiska,
        "--polska": polska,
        "--portuguese": portugisiska,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--romanska": rumänska, //r
        "--russian": ryska,
        "--samoan": Samoan, //s
        "--sanskrit": sanskrit,
        "--scotsGaelic": skotsk gaeliska,
        "--sepedi": Sepedi,
        "--serbian": serbiska,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": singalesiska,
        "--slovak": slovakiska,
        "--slovenska": slovenska,
        "--somali": somaliska,
        "--spanish": spanska,
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--svensk": svenska,
        "--tajik": Tadzjik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": turkiska,
        "--turkmen": turkmeniska,
        "--twi": Twi,
        "--ukrainska": ukrainska, //u
        "--urdu": Urdu,
        "--uyghur": Uigur,
        "--uzbek": uzbekiska,
        "--vietnamese": vietnamesiska, //v
        "--welsh": walesiska, //w
        "--xhosa": Xhosa, //x
        "--jiddisch": jiddisch, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },   

      // tajik
      // tajik
      tajik: {
        translations: {
          "--хато рӯй дод": Хатогӣ рӯй дод!, //a
          "--address": Суроғаҳо,
          "--advice": Маслиҳат,
          "--бо пахш кардани идома додан": Бо пахш кардани идома шумо аз ҳисоби Veil Brillant-и худ ҷудо карда мешавед, //b
          "--бо клик кардани пайвастшавӣ шумо ҷудо мешавед": Бо пахш кардани "Нест кардан" шумо аз ҳисоби izocash ҷудо карда мешавед,
          "--рақами виртуалии худро санҷед ё дертар бори дигар кӯшиш кунед": Рақами виртуалии худро санҷед ё дертар такрор кунед, //c
          "--рақами виртуалии худро санҷед": Рақами виртуалии худро санҷед,
          "--continue": Давом додан,
          "--connection": Пайвастшавӣ,
          "--ҳамкорӣ кардан, дар мувофиқа зиндагӣ кардан": Ҳамкорӣ кардан, дар мувофиқа бо дигарон зиндагӣ кардан,
          "--забонро интихоб кунед": Забони телефони виртуалӣ,
          «--ракобатро пешгирй накун»: Ба ракобат монеъ нашавед, ба хама имконият дихед, //д
          "--disconnection": Қатъи пайваст,
          "--барои ҳамаи корбарони телефони виртуалӣ": Барои ҳама корбарони телефони виртуалӣ тавсия дода мешавад, ки VPN, //f
          "--ба саҳифаи воридшавӣ гузаред": Ба саҳифаи воридшавӣ гузаред, //g
          "--таърихӣ": Таърихӣ, //ч
          "--i have account": Ман аллакай ҳисоб дорам, //i
          "--i don't account": Ман ҳисоб надорам,
          "--он хонаи шумо": он хонаи шумост,
          "--тасвир / видео +": Тасвир / Видео +,
          "--verification identity": Санҷиши шахсият,
          "--портали муштарӣ izocash": Портали муштариён izocash,
          "--навсозии шахсият ҳар сол": Навсозии шахсият ҳар сол,
          "--izocash buy to": izocash Buy => izocash international,
          "--log in": Ворид шавед!, //l
          "--login": Ворид шудан,
          "--login to veil brilliant": Ба Veil Brillant пайваст шавед,
          "--ба мағозаи vixinol ворид шавед": Ба мағозаи Vixinol пайваст шавед,
          "--ба ҳисоби пардаи Brillant-и худ ройгон ворид шавед": Барои дастрасӣ ба ин хусусият ба ҳисоби Veil Brillant-и худ ройгон ворид шавед,
          "--login муваффақият": Воридшавӣ муваффақ!,
          "-- ҳоло ворид шавед": Ҳоло ворид шавед!,
          "--коммуваффақияти баромад": баромадан муваффақ шуд!,
          "--баромад": баромадан,
          "--logout": Хуруҷ,
          "--рақам": Рақам, //n
          "--name": Ном,
          "--now login": Акнун, ворид шавед!,
          "-- манъи пахшкунии рақобат":
          "--на ҳасад, на бадбинӣ": Не ҳасад, на бадбинӣ, на ҷудоӣ,
          "--не": Не,
          "--адресҳои расмӣ барои дастрасӣ ба телефони виртуалии шумо": Суроғаҳои расмӣ барои дастрасӣ ба телефони виртуалии шумо, //o
          "--password": Рамз, //саҳ
          "--points withdrawals izocash": Изокаш гирифтани холҳо,
          "--баровардани нуқтаҳои": Бозхонди холҳо,
          "--беҳтараш, VPN-ро истифода баред": Бехтараш VPN-ро истифода баред, ки ба провайдери хидматрасони интернетии шумо тааллуқ надорад,
          "--истеъдод ҳамеша фоида мебахшад": Истиқомат ҳамеша дар ниҳоят фоида меорад,
          "--қоида": Қоидаҳо, //r
          "--recommendation": Тавсияҳо,
          "--registration": Бақайдгирӣ,
          "--signup to veil brilliant": Сабти ном дар Veil Brillant, //s
          "--ба мағозаи vixinol сабти ном кунед": Дар мағозаи Vixinol сабти ном кунед,
          "--signup": Сабти ном,
          "--муваффақияти сабти ном": Бақайдгирӣ муваффақ шуд!,
          "--бепул сабти ном кунед": Бепул сабти ном кунед,
          "--муваффақияти сабти ном IA": Пайвастшавӣ муваффақ",
          "--settings": "Танзимот",
          "--танзим кардани барномаи alrani": Танзими барномаи Alrani,
          "--танзим кардани барномаи izocash": Танзими замимаи izocash,
          "--танзим кардани барномаи vixinol": Танзими барномаи Vixinol,
          "--танзим кардани барномаи veil Brillant": Танзими барномаи Veil Brillant,
          "--захираи тасвирҳо, видеоҳо": Нигоҳдории тасвирҳо, видеоҳо ва якчанд унсурҳои дигар,
          "--суръати қабул": Суръати қабули маълумот аз маркази додаҳо,
          "--speed": суръат,
          "--terminate": Қатъ кардан, //т
          "--vpn ба шумо имкон медиҳад, ки дастрасӣ пайдо кунед": VPN ба шумо имкон медиҳад, ки ба сайт ё барномае, ки провайдери хидматрасони интернетии шумо ба рӯйхати сиёҳ ворид кардааст, дастрасӣ пайдо кунед,
          "--дарахти калонтарин дар боло буд": Дарахти калонтарин пеш аз ҳама як донаи хурди оддӣ буд,
          "--ба экран ламс кунед": Барои идома додан ба экран ламс кунед,
          "-- боз кӯшиш кунед": Боз кӯшиш кунед!,
          "--username": Номи корбар, //u

          "--рақами виртуалӣ": Рақами виртуалӣ, //v
           "--танзимоти виртуалии телефон": Танзимоти виртуалии телефон,
           "--забони виртуалии телефон истифода мешавад": Забони телефони виртуалӣ дар сатҳи барнома ба таври нобаёнӣ истифода мешавад,
           "--телефони виртуалӣ": телефони виртуалӣ,
           "--validate": Тасдиқ кардан,
           "--хуш омадед ба портали муштариёни izocash": Хуш омадед ба портали муштариёни izocash, //w
           "--рамзи супер нависед": Рамзи суперро ворид кунед,
           "--хуш омадед ба": Хуш омадед ба,
           "--диққати мардум ба куҷо меравад": Ба куҷо таваҷҷӯҳи одамон меравад, пул меравад,
           "--winners persevere": Ғолибон сабр мекунанд,
           "--мехоҳед аз ҳисоби Alrani-и худ берун шавед": Оё шумо мехоҳед аз ҳисоби Alrani худ берун шавед?,
           "--ҳа": Бале, //y

           // кишвар
           "--конго": Конго Браззавил,
           "--cameroon": Камерун,
           "--drc": DRC,
           "--соҳили устухон": Соҳили Кот,

           // забон
        "--afrikaans": Африқо, //а
        "--albanian": албанӣ,
        "--amharic": амҳарӣ,
        "--арабӣ": арабӣ,
        "--armenian": арманӣ,
        "--ассамӣ": ассамӣ,
        "--аймара": Аймара,
        "--азербойҷонӣ": озарбойҷонӣ,
        "--бамбара": Бамбара, //б
        "--баскӣ": баскӣ,
        "--беларусӣ": белорусӣ,
        "--bengali": банголӣ,
        "--bhojpuri": Бҳоҷпурӣ,
        "--bosnian": боснӣ,
        "--bulgarian": булғорӣ,
        "--каталан": каталанӣ, //c
        "--cebuano": Себуано,
        "--chichewa": Чичева,
        "--chineseSimplified": чинӣ (соддашуда),
        "--chineseTraditional": чинӣ (анъанавӣ),
        "--korsican": Корсика,
        "--croatian": хорватӣ,
        "--czech": чехӣ,
        "--danish": Дания, //д
        "--dhivehi": Дивеҳи,
        "--догри": Догри,
        "--dutch": Голландия,
        "--english": англисӣ, //e
        "--esperanto": эсперанто,
        "--estonian": эстонӣ,
        "--ewe": Эве,
        "--филипино": Филиппин, //ф
        "--финландӣ": финӣ,
        "--fransuz": фаронсавӣ,
        "--frisian": фризӣ,
        "--galician": Галисия, //г
        "--гурҷӣ": гурҷӣ,
        "--german": олмонӣ,
        "--юнонӣ": юнонӣ,
        "--гуарани": гуарани,
        "--gujarati": Гуҷаратӣ,
        "--haitianCreole": Креоли Гаити, //h
        "--hausa": Ҳауса,
        "--ҳавайӣ": Ҳавайӣ,
        "--ибрӣ": ибрӣ,
        "--hindi": ҳиндӣ,
        "--hmong": Хмонг,
        "--hungarian": Венгрия,
        "--icelandic": исландӣ, //i
        "--igbo": Игбо,
        "--ilocano": Илокано,
        "--indonesian": Индонезия,
        "--irish": ирландӣ,
        "--italian": Италия,
        "--japanese": Ҷопон, //j
        "--javanese": явонӣ,
        "--каннада": Каннада, //k
        "--казак": қазоқӣ,
        "--khmer": кхмер,
        "--kinyarwanda": Кинярванда,
        "--конканӣ": Конканӣ,
        "--korean": кореягӣ,
        "--krio": Крио,
        "--kurdishKurmanji": курдӣ (курманҷӣ),
        "--kurdishSorani": курдӣ (соронӣ),
        "--киргиз": киргиз,
        "--lao": Лао, //л
        "--лотинӣ": лотинӣ,
        "--latvian": Латвия,
        "--lingala": лингала,
        "--lithuanian": литваӣ,
        "--luganda": Луганда,
        "--luxembourgish": Люксембург,
        "--македонӣ": македонӣ, //м
        "--maithili": Майтилӣ,
        "--malagasy": малагасӣ,
        "--malay": малайӣ,
        "--малайям": малаялам,
        "--малтазаӣ": малтаӣ,
        "--маори": маорӣ,
        "--маратҳӣ": маратҳӣ,
        "--meiteilonManipuri": Meiteilon (Манипури),
        "--mizo": Мизо,
        "--муғулӣ": муғулӣ,
        "--myanmarBurmese": Мянмар (Бирма),
        "--непалӣ": Непалӣ, //n
        "--norwegian": норвегӣ,
        "--odiaOriya": Одия (Ориё), //о
        "--oromo": Оромо,
        "--пашту": пашту, //с
        "--forsian": форсӣ,
        "--полиш": лаҳистонӣ,
        "--португалӣ": португалӣ,
        "--punjabi": Панҷобӣ,
        "--quechua": Кечуа, //қ
        "--румынӣ": руминӣ, //r
        "--russia": русӣ,
        "--samoan": Самоа, //с
        "--санскрит": санскрит,
        "--scotsGaelic": шотландӣ галӣ,
        "--sepedi": Сепеди,
        "--serbian": сербӣ,
        "--sesotho": Сесото,
        "--shona": Шона,
        "--синдҳӣ": Синдӣ,
        "--sinhala": сингалӣ,
        "--словакӣ": словакӣ,
        "--slovenian": словенӣ,
        "--somali": Сомалӣ,
        "--spanish": испанӣ,
        "--сунданӣ": сунданӣ,
        "--суахили": суахили,
        "--swedish": шведӣ,
        "--тоҷик": тоҷикӣ, //т
        "--тамил": тамилӣ,
        "--татар": тоторӣ,
        "--telugu": телугу,
        "--thai": Тайланд,
        "--тигриня": Тигриня,
        "--tsonga": Tsonga,
        "--туркӣ": туркӣ,
        "--turkmen": туркманӣ,
        "--twi": Тви,
        "--ukrainian": украинӣ, //у
        "--урду": урду,
        "--уйғур": уйғурӣ,
        "--узбек": ӯзбек,
        "--виетнамӣ": Ветнамӣ, //v
        "--welsh": Уелсӣ, //w
        "--xhosa": Хоса, //x
        "--yiddish": идишӣ, //y
        "--yoruba": Ёруба,
        "--zulu": Зулу, //з
        },
      },

      // tamil
      // tamil
      tamil: {
        translations: {
          "--ஒரு பிழை ஏற்பட்டது": ஒரு பிழை ஏற்பட்டது!, //a
           "--முகவரி": முகவரிகள்,
           "--ஆலோசனை": ஆலோசனை,
           "--தொடர் என்பதைக் கிளிக் செய்வதன் மூலம்": தொடரவும் என்பதைக் கிளிக் செய்வதன் மூலம், உங்கள் வெயில் ப்ரில்லண்ட் கணக்கிலிருந்து துண்டிக்கப்படுவீர்கள், //b
           "--துண்டிப்பு என்பதைக் கிளிக் செய்வதன் மூலம் நீங்கள் துண்டிக்கப்படுவீர்கள்": துண்டிக்கவும் என்பதைக் கிளிக் செய்வதன் மூலம் உங்கள் izocash கணக்கிலிருந்து நீங்கள் துண்டிக்கப்படுவீர்கள்,
           "--உங்கள் மெய்நிகர் எண்ணைச் சரிபார்க்கவும் அல்லது பின்னர் மீண்டும் முயற்சிக்கவும்": உங்கள் மெய்நிகர் எண்ணைச் சரிபார்க்கவும் அல்லது பின்னர் மீண்டும் முயற்சிக்கவும், //c
           "--உங்கள் மெய்நிகர் எண்ணைச் சரிபார்க்கவும்": உங்கள் மெய்நிகர் எண்ணைச் சரிபார்க்கவும்,
           "--தொடரவும்": தொடரவும்,
           "--இணைப்பு": இணைப்பு,
           "--ஒத்துழைத்து, இணக்கமாக வாழ": ஒத்துழைத்து, மற்றவர்களுடன் இணக்கமாக வாழ,
           "--மொழியைத் தேர்ந்தெடு": மெய்நிகர் தொலைபேசி மொழி,
           "--போட்டியைத் தடுக்காதே": போட்டியைத் தடுக்காதே, அனைவருக்கும் ஒரு வாய்ப்பு கொடு, //d
           "--துண்டிப்பு": துண்டிப்பு,
           "--அனைத்து மெய்நிகர் தொலைபேசி பயனர்களுக்கும்": அனைத்து மெய்நிகர் தொலைபேசி பயனர்களுக்கும், VPN ஐப் பயன்படுத்த பரிந்துரைக்கப்படுகிறது, //f
           "--உள்நுழைவு பக்கத்திற்கு செல்": உள்நுழைவு பக்கத்திற்கு செல்க, //g
           "--வரலாற்று": வரலாற்று, //h
           "--எனக்கு கணக்கு உள்ளது": என்னிடம் ஏற்கனவே கணக்கு உள்ளது, //i
           "--என்னிடம் கணக்கு இல்லை": என்னிடம் கணக்கு இல்லை,
           "--இது உங்கள் வீடு": இது உங்கள் வீடு,
           "--படம் / வீடியோ +": படம் / வீடியோ +,
           "--அடையாள சரிபார்ப்பு": அடையாள சரிபார்ப்பு,
           "--izocash வாடிக்கையாளர் போர்டல்": izocash வாடிக்கையாளர் போர்டல்,
           "--ஒவ்வொரு ஆண்டும் அடையாள புதுப்பிப்பு": ஒவ்வொரு ஆண்டும் அடையாள புதுப்பிப்பு,
           "--izocash buy to": izocash Buy => izocash International,
           "--உள்நுழை": உள்நுழைக!, //எல்
           "--உள்நுழை": உள்நுழைக,
           "--உள்ளது புத்திசாலித்தனமான வெயில்": வெயில் ப்ரில்லண்டுடன் இணைக்கவும்,
           "--விக்ஸினால் ஸ்டோரில் உள்நுழைக": விக்சினால் ஸ்டோருடன் இணைக்கவும்,
           "--உங்கள் வெயில் ப்ரில்லண்ட் கணக்கில் இலவசமாக உள்நுழையவும்": இந்த அம்சத்தை அணுக உங்கள் வெயில் ப்ரில்லண்ட் கணக்கில் இலவசமாக உள்நுழைக,
           "--உள்நுழைவு வெற்றி": உள்நுழைவு வெற்றி!,
           "--இப்போது உள்நுழைக": இப்போது உள்நுழைக!,
           "--வெளியேறு வெற்றி": வெளியேறுதல் வெற்றி!,
           "--லாக் அவுட்": வெளியேறு,
           "--வெளியேறு": வெளியேறு,
           "--எண்": எண், //n
           "--பெயர்": பெயர்,
           "--இப்போது உள்நுழைக": இப்போது, ​​உள்நுழைக!,
           "--போட்டியை முடக்குவதற்கு தடை இல்லை":
           "--பொறாமை இல்லை, வெறுப்பு இல்லை": பொறாமை இல்லை, வெறுப்பு இல்லை, பிரிவுகள் இல்லை,
           "--இல்லை இல்லை,
           "--உங்கள் மெய்நிகர் தொலைபேசியை அணுகுவதற்கான அதிகாரப்பூர்வ முகவரிகள்": உங்கள் மெய்நிகர் தொலைபேசியை அணுகுவதற்கான அதிகாரப்பூர்வ முகவரிகள், //o
           "--கடவுச்சொல்": கடவுச்சொல், //ப
           "--புள்ளிகள் திரும்பப் பெறுதல் izocash": புள்ளிகள் திரும்பப் பெறுதல் izocash,
           "--புள்ளிகள் திரும்பப் பெறுதல்": புள்ளிகள் திரும்பப் பெறுதல்,
           "--முன்னுரிமை, vpn ஐப் பயன்படுத்தவும்": முன்னுரிமை, உங்கள் இணைய சேவை வழங்குநருக்குச் சொந்தமில்லாத VPN ஐப் பயன்படுத்தவும்,
           "--விடாமுயற்சி எப்போதும் பலன் தரும்": விடாமுயற்சி எப்பொழுதும் முடிவில் பலன் தரும்
           "--விதி": விதிகள், //r
           "--பரிந்துரை": பரிந்துரைகள்,
           "--பதிவு": பதிவு,
           "--புத்திசாலித்தனமான முக்காடு பதிவு": வெயில் ப்ரில்லண்டில் பதிவு, //s
           "--விக்சினோல் ஸ்டோரில் பதிவு செய்யவும்": விக்சினால் ஸ்டோரில் பதிவு செய்யவும்,
           "--பதிவு": பதிவு,
           "--பதிவு வெற்றி": பதிவு வெற்றி!,
           "--இலவசமாக பதிவுசெய்க": இலவசமாகப் பதிவு செய்யுங்கள்,
           “--பதிவு வெற்றி IA”: இணைப்பு வெற்றிகரமாக”,
           "--அமைப்புகள்": "அமைப்புகள்",
           "--அல்ரானி பயன்பாட்டை அமைத்தல்": அல்ரானி பயன்பாட்டை உள்ளமைத்தல்,
           "--izocash பயன்பாட்டை அமைத்தல்": izocash பயன்பாட்டை உள்ளமைத்தல்,
           "--vixinol பயன்பாட்டை அமைத்தல்": Vixinol பயன்பாட்டை உள்ளமைத்தல்,
           "--வெயில் புத்திசாலித்தனமான பயன்பாட்டை அமைத்தல்": வெயில் ப்ரில்லண்ட் பயன்பாட்டை உள்ளமைத்தல்,
           "--படங்கள், வீடியோக்களின் சேமிப்பு": படங்கள், வீடியோக்கள் மற்றும் பல கூறுகளின் சேமிப்பு,
           "- வரவேற்பின் வேகம்": டேட்டாசென்டரிலிருந்து தரவைப் பெறுவதற்கான வேகம்,
           "--வேகம்": வேகம்,
           "--டெர்மினேட்": டெர்மினேட், //டி
           "--vpn உங்களை அணுக அனுமதிக்கிறது": உங்கள் இணைய சேவை வழங்குநர் தடுப்புப்பட்டியலில் உள்ள தளம் அல்லது பயன்பாட்டை அணுக VPN உங்களை அனுமதிக்கிறது,
           "--பெரிய மரம் மேலே இருந்தது": மிகப்பெரிய மரம் எல்லாவற்றிற்கும் மேலாக ஒரு எளிய சிறிய விதை,
           "--திரையைத் தொடவும்": தொடர திரையைத் தொடவும்,
           "--மீண்டும் முயற்சிக்கவும்": மீண்டும் முயற்சிக்கவும்!,
           "--பயனர்பெயர்": பயனர்பெயர், //u

           "--மெய்நிகர் எண்": மெய்நிகர் எண், //v
           "--மெய்நிகர் தொலைபேசி அமைப்புகள்": மெய்நிகர் தொலைபேசி அமைப்புகள்,
           "--மெய்நிகர் தொலைபேசி மொழி பயன்படுத்தப்படுகிறது": மெய்நிகர் தொலைபேசி மொழி இயல்பாகவே பயன்பாட்டு மட்டத்தில் பயன்படுத்தப்படுகிறது,
           "--மெய்நிகர் தொலைபேசி": மெய்நிகர் தொலைபேசி,
           "--சரிபார்": சரிபார்,
           "--ஐசோகாஷ் வாடிக்கையாளர் போர்ட்டலுக்கு வரவேற்கிறோம்": izocash வாடிக்கையாளர் போர்ட்டலுக்கு வரவேற்கிறோம், //w
           "--ஒரு சூப்பர் குறியீட்டை எழுது": ஒரு சூப்பர் குறியீட்டை உள்ளிடவும்,
           "--வரவேற்கிறேன்": வருக,
           "--மக்களின் கவனம் எங்கே செல்கிறது": மக்களின் கவனம் எங்கு செல்கிறதோ பணம் செல்கிறது,
           "--வெற்றியாளர்கள் விடாமுயற்சியுடன்": வெற்றியாளர்கள் விடாமுயற்சியுடன்,
           "--உங்கள் அல்ரானி கணக்கிலிருந்து வெளியேற விரும்புகிறீர்களா": உங்கள் அல்ரானி கணக்கிலிருந்து வெளியேற விரும்புகிறீர்களா?,
           "--ஆம்": ஆம், //y

           //நாடு
           "--காங்கோ": காங்கோ பிரஸ்ஸாவில்,
           "--கேமரூன்": கேமரூன்,
           "--drc": DRC,
           "--ஐவரிகோஸ்ட்": ஐவரி கோஸ்ட்,

           // மொழி
        "--ஆப்ரிகான்ஸ்": ஆஃப்ரிகான்ஸ், //a
        "--அல்பேனியன்": அல்பேனியன்,
        "--அம்ஹாரிக்": அம்ஹாரிக்,
        "--அரபு": அரபு,
        "--ஆர்மேனியன்": ஆர்மேனியன்,
        "--அசாமிஸ்": அசாமிஸ்,
        "--அய்மரா": அய்மரா,
        "--azerbaijani": அஜர்பைஜானி,
        "--பம்பாரா": பம்பாரா, //பி
        "--பாஸ்க்": பாஸ்க்,
        "--பெலாரசியன்": பெலாரஷ்யன்,
        "--பெங்காலி": பெங்காலி,
        "--போஜ்புரி": போஜ்புரி,
        "--போஸ்னியன்": போஸ்னியன்,
        "--பல்கேரியன்": பல்கேரியன்,
        "--கடலான்": கேட்டலான், //c
        "--செபுவானோ": செபுவானோ,
        "--சிச்சேவா": சிச்சேவா,
        "--சீன எளிமைப்படுத்தப்பட்டது": சீனம் (எளிமைப்படுத்தப்பட்டது),
        "--சீன பாரம்பரியம்": சீனம் (பாரம்பரியம்),
        "--கோர்சிகன்": கோர்சிகன்,
        "--குரோஷியன்": குரோஷியன்,
        "--செக்": செக்,
        "--danish": டேனிஷ், //d
        "--திவேஹி": திவேஹி,
        "--டோக்ரி": டோக்ரி,
        "--டச்சு": டச்சு,
        "--ஆங்கிலம்": ஆங்கிலம், //e
        "--esperanto": Esperanto,
        "--எஸ்டோனியன்": எஸ்டோனியன்,
        "--ewe": ஈவ்,
        "--filipino": ஃபிலிப்பினோ, //f
        "--ஃபின்னிஷ்": பின்னிஷ்,
        "--பிரெஞ்சு": பிரஞ்சு,
        "--ஃப்ரிசியன்": ஃப்ரிஷியன்,
        "--கலிசியன்": காலிசியன், //g
        "--ஜார்ஜியன்": ஜார்ஜியன்,
        "--ஜெர்மன்": ஜெர்மன்,
        "--கிரீக்": கிரேக்கம்,
        "--குரானி": குரானி,
        "--குஜராத்தி": குஜராத்தி,
        "--haitianCreole": ஹைட்டியன் கிரியோல், //h
        "--ஹௌசா": ஹௌசா,
        "--ஹவாய்": ஹவாய்,
        "--ஹீப்ரு": ஹீப்ரு,
        "--ஹிந்தி": இந்தி,
        "--ஹ்மாங்": ஹ்மாங்,
        "--ஹங்கேரியன்": ஹங்கேரிய,
        "--ஐஸ்லாண்டிக்": ஐஸ்லாண்டிக், //i
        "--igbo": இக்போ,
        "--ilocano": Ilocano,
        "--இந்தோனேசிய": இந்தோனேசியன்,
        "--ஐரிஷ்": ஐரிஷ்,
        "--இத்தாலியன்": இத்தாலியன்,
        "--ஜப்பானீஸ்": ஜப்பானிய, //ஜே
        "--ஜாவனீஸ்": ஜாவானீஸ்,
        "--கன்னடம்": கன்னடம், //கே
        "--கசாக்": கசாக்,
        "--கெமர்": கெமர்,
        "--kinyarwanda": கிண்ணியா,
        "--கொங்கனி": கொங்கனி,
        "--கொரியன்": கொரியன்,
        "--கிரியோ": கிரியோ,
        "--kurdishKurmanji": குர்திஷ் (குர்மான்ஜி),
        "--kurdishSorani": குர்திஷ் (சோரானி),
        "--கிர்கிஸ்": கிர்கிஸ்,
        "--லாவ்": லாவோ, //எல்
        "--லத்தீன்": லத்தீன்,
        "--லாட்வியன்": லாட்வியன்,
        "--லிங்கலா": லிங்கலா,
        "--லிதுவேனியன்": லிதுவேனியன்,
        "--லுகாண்டா": லுகாண்டா,
        "--லக்சம்பர்கிஷ்": லக்சம்பர்கிஷ்,
        "--மாசிடோனியன்": மாசிடோனியன், //மீ
        "--மைதிலி": மைதிலி,
        "--மலகாசி": மலகாசி,
        "--malay": மலாய்,
        "--மலையாளம்": மலையாளம்,
        "--மால்டிஸ்": மால்டிஸ்,
        "--maori": மவோரி,
        "--மராத்தி": மராத்தி,
        "--meiteilonManipuri": Meiteilon (மணிப்பூரி),
        "--மிசோ": மிசோ,
        "--மங்கோலியன்": மங்கோலியன்,
        "--மியான்மர் பர்மிஸ்": மியான்மர் (பர்மிய),
        "--நேபாளி": நேபாளி, //n
        "--நார்வேஜியன்": நார்வேஜியன்,
        "--odiaOriya": ஒடியா (ஒரியா), //o
        "--ஓரோமோ": ஓரோமோ,
        "--பாஷ்டோ": பாஷ்டோ, //ப
        "--பாரசீக": பாரசீகம்,
        "--பாலிஷ்": போலிஷ்,
        "--போர்த்துகீசியம்": போர்த்துகீசியம்,
        "--பஞ்சாபி": பஞ்சாபி,
        "--கெச்சுவா": கெச்சுவா, //q
        "--ரோமேனியன்": ரோமானியன், //ஆர்
        "--ரஷ்யன்": ரஷ்யன்,
        "--சமோவான்": சமோவான், //s
        "--சமஸ்கிருதம்": சமஸ்கிருதம்,
        "--scotsGaelic": ஸ்காட்ஸ் கேலிக்,
        "--sepedi": Sepedi,
        "--செர்பியன்": செர்பியன்,
        "--செசோதோ": செசோதோ,
        "--ஷோனா": ஷோனா,
        "--சிந்தி": சிந்தி,
        "--சிங்களம்": சிங்களம்,
        "--ஸ்லோவாக்": ஸ்லோவாக்,
        "--ஸ்லோவேனியன்": ஸ்லோவேனியன்,
        "--சோமாலி": சோமாலி,
        "--ஸ்பானிஷ்": ஸ்பானிஷ்,
        "--சுண்டனீஸ்": சுண்டனீஸ்,
        "--ஸ்வாஹிலி": சுவாஹிலி,
        "--ஸ்வீடிஷ்": ஸ்வீடிஷ்,
        "--தாஜிக்": தாஜிக், //t
        "--தமிழ்": தமிழ்,
        "--டாடர்": டாடர்,
        "--தெலுங்கு": தெலுங்கு,
        "--தை": தாய்,
        "--டிக்ரின்யா": டிக்ரின்யா,
        "--சோங்கா": சோங்கா,
        "--துர்கிஷ்": துருக்கியம்,
        "--துர்க்மென்": துர்க்மென்,
        "--ட்வி": ட்வி,
        "--ukrainian": உக்ரைனியன், //u
        "--உர்து": உருது,
        "--உய்குர்": உய்குர்,
        "--உஸ்பெக்": உஸ்பெக்,
        "--வியட்நாம்": வியட்நாம், //v
        "--வெல்ஷ்": வெல்ஷ், //w
        "--xhosa": Xhosa, //x
        "--yiddish": இத்திஷ், //y
        "--யோருபா": யோருபா,
        "--zulu": Zulu, //z
        },
      },

      // tatar
      // tatar
      tatar: {
        translations: {
          "- хата килеп чыкты": Хата килеп чыкты!, // а
           "- адрес": Адреслар,
           "- киңәш": киңәш,
           "- дәвам итүгә басыгыз": дәвам итүгә басыгыз, сез Veil Brillant хисабыннан өзеләчәксез, // b
           "- Аерылуга басыгыз, сез өзеләчәксез": Аерылуга басыгыз, сез изокаш счетыннан аерылырсыз,
           "- виртуаль номерыгызны тикшерегез яки соңрак кабатлап карагыз": Виртуаль номерыгызны тикшерегез яки соңрак кабатлап карагыз, // с
           "- виртуаль номерыгызны тикшерегез": Виртуаль номерыгызны тикшерегез,
           "- дәвам итү": дәвам итегез,
           "- тоташу": тоташу,
           "- хезмәттәшлек итегез, гармониядә яшәгез": хезмәттәшлек итегез, башкалар белән гармониядә яшәгез,
           "- сайлау теле": Виртуаль телефон теле,
           "- көндәшлекне булдырмагыз": Конкуренцияне булдырмагыз, һәркемгә мөмкинлек бирегез, // d
           "- өзелү": Аерылу,
           "- барлык виртуаль телефон кулланучылары өчен": Барлык Виртуаль Телефон кулланучылары өчен VPN, // f кулланырга киңәш ителә
           "- логин битенә керегез": Керү битенә керегез, // г.
           "- тарихи": Тарихи, // ч
           "- минем счетым бар": Минем хисап бар, // i
           "- минем счетым юк": Минем счет юк,
           "- бу сезнең йортыгыз": бу сезнең йортыгыз,
           "- рәсем / видео +": Рәсем / Видео +,
           "- шәхесне тикшерү": Шәхесне тикшерү,
           "--izocash клиентлар порталы": izocash клиентлар порталы,
           "- ел саен таныклыкны яңарту": ел саен шәхесне яңарту,
           "--izocash сатып алу": izocash Buy => izocash international,
           "- керегез": Керегез!, // l
           "--логин": Керегез,
           "- якты пәрдә өчен логин": Veil Brillant белән тоташу,
           "- виксинол кибетенә логин": Виксинол кибетенә тоташу,
           "- Сезнең пәрдәгезгә бушлай блог" Бриллант счеты ": Бу функциягә керү өчен Veil Brillant счетына бушлай керегез,
           "--логин уңыш": Керегез уңышлы!,
           "--логин хәзер": Хәзер керегез!,
           "- блог уңышлары": Чыгыш уңышлы!,
           "- чыгу": Чыгу,
           "--logout": Чыгыгыз,
           "- сан": Сан, // п
           "--name": Исем,
           "- хәзер керегез": Хәзер, керегез!,
           "- конкуренцияне тыярга ярамый":
           "- көнчелек юк, нәфрәт юк": Көнчелек юк, нәфрәт юк, бүленеш юк,
           "--юк юк,
           "- виртуаль телефоныгызга керү өчен рәсми адреслар": Виртуаль телефоныгызга керү өчен рәсми адреслар, // o
           "- пассворд": Серсүз, // б
           "- нокталарны алу изокаш": Нокталарны алу изокаш,
           "- нокталарны алу": Балларны алу,
           "- яхшырак, vpn кулланыгыз": Яхшырак, сезнең интернет-хезмәт күрсәтүче булмаган VPN кулланыгыз,
           "- перспектива һәрвакыт түли": Тырышлык һәрвакыт ахырда түли,
           "- кагыйдә": кагыйдәләр, // р
           "- рекомендация": Тәкъдимнәр,
           "- теркәлү": Теркәлү,
           "- якты пәрдәгә язылу": Veil Brillant, // s
           "- виксинол кибетенә язылу": Виксинол кибетендә теркәлү,
           "--signup": Регистрация,
           "- сигнализация уңышлары": Теркәлү уңышлы!,
           "- бушлай язылу": бушлай теркәлү,
           "- сигнализация уңышлары IA": тоташу уңышлы ",
           "- көйләүләр": "көйләүләр",
           "- alrani кушымтасын көйләү": Alrani кушымтасын конфигурацияләү,
           "- izocash кушымтасын көйләү": izocash кушымтасын конфигурацияләү,
           "- виксинол кушымтасын көйләү": Vixinol кушымтасын конфигурацияләү,
           "- Brillant пәрдәсен урнаштыру": Veil Brillant кушымтасын конфигурацияләү,
           "- рәсемнәрне, видеоларны саклау": Рәсемнәрне, видеоларны һәм башка берничә элементны саклау,
           "- кабул итү тизлеге": Datacenter'тан мәгълүмат алу тизлеге,
           "- тизлек": Тизлек,
           "- терминал": туктату, // т
           "- vpn сезгә керергә мөмкинлек бирә": VPN сезгә интернет-хезмәт күрсәтүче кара исемлеккә кертелгән сайтка яки кушымтага керергә мөмкинлек бирә,
           "- иң зур агач өстендә иде": Иң зур агач иң гади орлыктан өстен иде,
           "- экранга кагылыгыз": дәвам итәр өчен экранга кагылыгыз,
           "- кабатлап карагыз": Кабатлап карагыз!,
           "- кулланучы исеме": Кулланучы исеме, // u

           "- виртуаль номер": Виртуаль номер, // v
           "- виртуаль телефон көйләүләре": Виртуаль телефон көйләүләре,
           "- виртуаль телефон теле кулланыла": Виртуаль телефон теле кушымта дәрәҗәсендә кулланыла,
           "- виртуаль телефон": Виртуаль телефон,
           "- бәяләү": раслау,
           "- izocash клиентлар порталына рәхим итегез": izocash клиентлар порталына рәхим итегез, // w
           "- супер код языгыз": Супер код кертегез,
           "- рәхим итегез": рәхим итегез,
           "- кешеләрнең игътибары кая бара": Халык игътибары кая китә,
           "- җиңүчеләр түзәләр": җиңүчеләр түзәләр,
           "- Сез Alrani счетыннан чыгарга телисезме?": Сез Alrani счетыннан чыгарга телисезме?,
           "- әйе": Әйе, // у

           // ил
           "- Конго": Конго Браззавиль,
           "- камерун": Камерун,
           "--drc": DRC,
           "--ivoryCoast": Кот-д'Ивуар,

           // тел
        "- Африканнар": Африка, // а
        "--албан": Албан,
        "--амхарик": Амхарик,
        "- карабик": гарәп,
        "- әрмән": әрмән,
        "- Ассам": Ассам,
        "--аймара": Аймара,
        "--азербайҗани": Азәрбайҗан,
        "--бамбара": Бамбара, // б
        "- баск": Баск,
        "- Беларусия": Беларусия,
        "- Бенгали": Бенгали,
        "--bhojpuri": Божпури,
        "--босниан": Босния,
        "--булгар": Болгар,
        "- каталан": Каталан, // с
        "--cebuano": Себуано,
        "- Чичева": Чичева,
        "--chineseSimplified": Кытай (Гадиләштерелгән),
        "- Кытай традицион": кытай (традицион),
        "- Корсикан": Корсика,
        "- хорват": Хорватия,
        "- Чехия": Чехия,
        "--даниш": Дания, // д
        "--dhivehi": Dhivehi,
        "--догри": Догри,
        "- дутч": Голландия,
        "- Инглиз": Инглиз, // д
        "- Эсперанто": Эсперанто,
        "- эстон": Эстония,
        "--ewe": Эве,
        "- Филипино": Филиппиннар, // ф
        "- финиш": фин,
        "- француз": Француз,
        "- фризиан": фриз,
        "- галик": Галисия, // г.
        "- Джорджия": Грузин,
        "- герман": немец,
        "- Грек": Грек,
        "--гуарани": Гуарани,
        "- Гуджарати": Гуджарати,
        "- ГаитиКреол": Гаити Креолы, // ч
        "- Хауса": Хауса,
        "- Гавайиан": Гавайи,
        "--hebrew": Иврит,
        "--hindi": Hindiинди,
        "--хмонг": Хмонг,
        "--hungarian": Венгрия,
        "--ицеландик": Исландия, // i
        "--igbo": Игбо,
        "--илокано": Илокано,
        "- Индонезия": Индонезия,
        "--ириш": Ирландия,
        "--италиан": Италия,
        "- япон": япон, // j
        "- Ява": Ява,
        "- каннада": Каннада, // к
        "--казах": Казакъстан,
        "- кхмер": Кхмер,
        "--кинярванда": Кинярванда,
        "--конкани": Конкани,
        "- Корея": Корея,
        "- крио": Крио,
        "- КурдишКурманжи": Көрд (Курманҗи),
        "- Курдиш Сорани": Көрд (Сорани),
        "--ыргыз": Кыргызстан,
        "--лао": Лаос, // л
        "--латин": Латин,
        "--латвиан": Латвия,
        "--lingala": Лингала,
        "- Литва": Литва,
        "--луганда": Луганда,
        "--луксембург": Люксембург,
        "- Македония": Македония, // м
        "--maithili": Майтили,
        "- Малагаси": Малагаси,
        "- Малай": Малай,
        "--малаялам": Малаялам,
        "- Мальта": Мальта,
        "--маори": Маори,
        "- Маратхи": Маратхи,
        "--meiteilonManipuri": Мейтейлон (Манипури),
        "--мизо": Мизо,
        "- Монголия": Монгол,
        "--мянмарБурма": Мьянма (Бирма),
        "--непали": Непал, // п
        "- Норвегия": Норвегия,
        "--odiaOriya": Одия (Ория), // о
        "--оромо": Оромо,
        "- пушту": Пушту, // б
        "- Персия": Фарсы,
        "- поляк": поляк,
        "--portuguese": Португал,
        "- пунджаби": Пәнҗаби,
        "--quechua": Кечуа, // q
        "--роман": Румыния, // р
        "--рус": рус,
        "- Самоа": Самоа, // с
        "- санскрит": Санскрит,
        "--scotsGaelic": Шотландия Гэль,
        "--сепеди": Сепеди,
        "- сербиан": Серб,
        "--сесото": Сесото,
        "--шона": Шона,
        "--sindhi": Синдхи,
        "- Синхала": Синхала,
        "- Словакия": Словакия,
        "- Словения": Словения,
        "- Сомали": Сомали,
        "- испан": испан,
        "--сундан": Сундан,
        "- Суахили": Суахили,
        "--swedish": Швед,
        "- таҗик": Таҗик, // т
        "--тамил": Тамил,
        "--татар": татар,
        "--телугу": Телугу,
        "- Тай": Тай,
        "- Тигриня": Тигриня,
        "--цонга": Тсонга,
        "- Төркиш": Төрек,
        "- Төркмән": Төрекмән,
        "--twi": Twi,
        "--украин": украин, // у
        "--урду": Урду,
        "--югхур": уйгур,
        "--узбек": Uzbekзбәк,
        "- Вьетнам": Вьетнам, // v
        "--welsh": Уэльс, // w
        "--хоса": Коса, // х
        "- Идиш": Идиш, // й
        "- Йоруба": Йоруба,
        "--зулу": Зулу, // з
        },
      },

      // telugu
      // telugu
      telugu: {
        translations: {
          "--ఒక లోపం సంభవించింది": ఒక లోపం సంభవించింది!, //a
          "--చిరునామా": చిరునామాలు,
          "--సలహా": సలహా,
          "--కొనసాగించుపై క్లిక్ చేయడం ద్వారా": కొనసాగించుపై క్లిక్ చేయడం ద్వారా మీరు మీ వీల్ బ్రిల్లంట్ ఖాతా నుండి డిస్‌కనెక్ట్ చేయబడతారు, //b
          "--డిస్‌కనెక్ట్‌పై క్లిక్ చేయడం ద్వారా మీరు డిస్‌కనెక్ట్ చేయబడతారు": డిస్‌కనెక్ట్ పై క్లిక్ చేయడం ద్వారా మీరు మీ izocash ఖాతా నుండి డిస్‌కనెక్ట్ చేయబడతారు,
          "--మీ వర్చువల్ నంబర్‌ని తనిఖీ చేయండి లేదా తర్వాత మళ్లీ ప్రయత్నించండి": మీ వర్చువల్ నంబర్‌ని తనిఖీ చేయండి లేదా తర్వాత మళ్లీ ప్రయత్నించండి, //c
          "--మీ వర్చువల్ నంబర్‌ని తనిఖీ చేయండి": మీ వర్చువల్ నంబర్‌ని తనిఖీ చేయండి,
          "--కొనసాగించు": కొనసాగించు,
          "--కనెక్షన్": కనెక్షన్,
          "--సహకరించండి, సామరస్యంగా జీవించండి": సహకరించండి, ఇతరులతో సామరస్యంగా జీవించండి,
          "--భాషను ఎంచుకోండి": వర్చువల్ ఫోన్ లాంగ్వేజ్,
          "--పోటీని నిరోధించవద్దు": పోటీని నిరోధించవద్దు, అందరికీ అవకాశం ఇవ్వండి, //d
          "--డిస్‌కనెక్ట్": డిస్‌కనెక్ట్,
          "--అందరి వర్చువల్ ఫోన్ వినియోగదారుల కోసం": వర్చువల్ ఫోన్ వినియోగదారులందరికీ, VPN, //fని ఉపయోగించమని సిఫార్సు చేయబడింది
          "--లాగిన్ పేజీకి వెళ్లండి": లాగిన్ పేజీకి వెళ్లండి, //g
          "--చారిత్రక": హిస్టారికల్, //h
          "--నాకు ఖాతా ఉంది": నాకు ఇప్పటికే ఖాతా ఉంది, //i
          "--నాకు ఖాతా లేదు": నాకు ఖాతా లేదు,
          "--ఇది మీ ఇల్లు": ఇది మీ ఇల్లు,
          "--చిత్రం / వీడియో +": చిత్రం / వీడియో +,
          "--గుర్తింపు ధృవీకరణ": గుర్తింపు ధృవీకరణ,
          "--izocash కస్టమర్ పోర్టల్": izocash కస్టమర్ పోర్టల్,
          "--ప్రతి సంవత్సరం గుర్తింపు నవీకరణ": ప్రతి సంవత్సరం గుర్తింపు నవీకరణ,
          "--izocash buy to": izocash కొనుగోలు => izocash అంతర్జాతీయ,
          "--లాగ్ ఇన్": లాగిన్!, //l
          "--లాగిన్": లాగిన్,
          "--లాగిన్ టు వీల్ బ్రిలియంట్": వీల్ బ్రిల్లంట్‌కి కనెక్ట్ చేయండి,
          "--విక్సినోల్ స్టోర్‌కి లాగిన్": Vixinol స్టోర్‌కి కనెక్ట్ చేయండి,
          "--మీ వీల్ బ్రిల్లంట్ ఖాతాకు ఉచితంగా లాగిన్ అవ్వండి": ఈ లక్షణాన్ని యాక్సెస్ చేయడానికి మీ వీల్ బ్రిల్లంట్ ఖాతాకు ఉచితంగా లాగిన్ అవ్వండి,
          "--లాగిన్ సక్సెస్": లాగిన్ విజయవంతమైంది!,
          "--ఇప్పుడే లాగిన్ అవ్వండి": ఇప్పుడే లాగిన్ అవ్వండి!,
          "--లాగ్అవుట్ సక్సెస్": లాగ్అవుట్ విజయవంతమైంది!,
          "--లాగ్ అవుట్": లాగ్ అవుట్,
          "--లాగ్ అవుట్": లాగ్ అవుట్,
          "--సంఖ్య": సంఖ్య, //n
          "--పేరు": పేరు,
          "--ఇప్పుడు లాగిన్ అవ్వండి": ఇప్పుడు, లాగిన్ అవ్వండి!,
          "--- పోటీని అణచివేయడంపై నిషేధం లేదు":
          "--అసూయ లేదు, ద్వేషం లేదు": అసూయ లేదు, ద్వేషం లేదు, విభజనలు లేవు,
          "--కాదు కాదు,
          "--మీ వర్చువల్ ఫోన్‌ని యాక్సెస్ చేయడానికి అధికారిక చిరునామాలు": మీ వర్చువల్ ఫోన్‌ని యాక్సెస్ చేయడానికి అధికారిక చిరునామాలు, //o
          "--పాస్‌వర్డ్": పాస్‌వర్డ్, //p
          "--పాయింట్‌ల ఉపసంహరణలు izocash": పాయింట్‌ల ఉపసంహరణలు izocash,
          "--పాయింట్‌ల ఉపసంహరణలు": పాయింట్‌ల ఉపసంహరణలు,
          "--ప్రాధాన్యంగా, vpn ఉపయోగించండి": ప్రాధాన్యంగా, మీ ఇంటర్నెట్ సర్వీస్ ప్రొవైడర్‌కు చెందని VPNని ఉపయోగించండి,
          "--పట్టుదల ఎల్లప్పుడూ ఫలిస్తుంది": పట్టుదల ఎల్లప్పుడూ చివరికి ఫలితం ఇస్తుంది,
          "--రూల్": నియమాలు, //r
          "--సిఫార్సు": సిఫార్సులు,
          "--నమోదు": నమోదు,
          "--సైనప్ టు వీల్ బ్రిలియంట్": వీల్ బ్రిల్లంట్‌పై నమోదు, //s
          "--విక్సినోల్ స్టోర్‌కి సైన్ అప్ చేయండి": Vixinol స్టోర్‌లో నమోదు చేయండి,
          "--సైనప్": నమోదు,
          "--సైనప్ విజయం": నమోదు విజయవంతమైంది!,
          "--ఉచితంగా సైన్ అప్ చేయండి": ఉచితంగా నమోదు చేసుకోండి,
          “--సైనప్ విజయం IA”: కనెక్షన్ విజయవంతమైంది”,
          "--సెట్టింగ్‌లు": "సెట్టింగ్‌లు",
          "--అల్రానీ యాప్‌ను ఏర్పాటు చేస్తోంది": అల్రానీ అప్లికేషన్‌ను కాన్ఫిగర్ చేయడం,
          "--izocash యాప్‌ను అమర్చడం": izocash అప్లికేషన్‌ను కాన్ఫిగర్ చేయడం,
          "--విక్సినోల్ అనువర్తనాన్ని ఏర్పాటు చేస్తోంది": Vixinol అప్లికేషన్‌ను కాన్ఫిగర్ చేయడం,
          "--వీల్ బ్రిల్లంట్ యాప్‌ను ఏర్పాటు చేస్తోంది": వీల్ బ్రిల్లంట్ అప్లికేషన్‌ను కాన్ఫిగర్ చేయడం,
          "--చిత్రాలు, వీడియోల నిల్వ": చిత్రాలు, వీడియోలు మరియు అనేక ఇతర అంశాల నిల్వ,
          "--స్పీడ్ ఆఫ్ రిసెప్షన్": డేటాసెంటర్ నుండి డేటా రిసెప్షన్ వేగం,
          "--వేగం": వేగం,
          "--టర్మినేట్": ముగించు, //t
          "--Vpn మిమ్మల్ని యాక్సెస్ చేయడానికి అనుమతిస్తుంది": VPN మీ ఇంటర్నెట్ సర్వీస్ ప్రొవైడర్ బ్లాక్ లిస్ట్ చేసిన సైట్ లేదా అప్లికేషన్‌ను యాక్సెస్ చేయడానికి మిమ్మల్ని అనుమతిస్తుంది,
          "--అతిపెద్ద చెట్టు పైన ఉంది": అతి పెద్ద చెట్టు అన్నింటికంటే సాధారణ చిన్న విత్తనం,
          "--స్క్రీన్‌ను తాకండి": కొనసాగించడానికి స్క్రీన్‌ను తాకండి,
          "--మళ్లీ ప్రయత్నించండి": మళ్లీ ప్రయత్నించండి!,
          "--వినియోగదారు పేరు": వినియోగదారు పేరు, //u

          "--వర్చువల్ నంబర్": వర్చువల్ నంబర్, //v
           "--వర్చువల్ ఫోన్ సెట్టింగ్‌లు": వర్చువల్ ఫోన్ సెట్టింగ్‌లు,
           "--వర్చువల్ ఫోన్ భాష వర్తించబడుతుంది": వర్చువల్ ఫోన్ భాష డిఫాల్ట్‌గా అప్లికేషన్ స్థాయిలో వర్తించబడుతుంది,
           "--వర్చువల్ ఫోన్": వర్చువల్ ఫోన్,
           "--ధృవీకరించు": ధృవీకరించు,
           "--ఇజోకాష్ కస్టమర్ పోర్టల్‌కు స్వాగతం": izocash కస్టమర్ పోర్టల్‌కు స్వాగతం, //w
           "--సూపర్ కోడ్ వ్రాయండి": సూపర్ కోడ్‌ని నమోదు చేయండి,
           "--స్వాగతం": స్వాగతం,
           "--ప్రజల దృష్టి ఎక్కడికి పోతుంది": ప్రజల దృష్టి ఎక్కడికి వెళ్తే డబ్బు వెళ్తుంది,
           "--విజేతలు పట్టుదలతో ఉంటారు": విజేతలు పట్టుదలతో ఉంటారు,
           "--మీరు మీ Alrani ఖాతా నుండి లాగ్ అవుట్ చేయాలనుకుంటున్నారా": మీరు మీ Alrani ఖాతా నుండి లాగ్ అవుట్ చేయాలనుకుంటున్నారా?,
           "--అవును": అవును, //y

           // దేశం
           "--కాంగో": కాంగో బ్రజ్జావిల్లే,
           "--కామెరూన్": కామెరూన్,
           "--drc": DRC,
           "--ఐవరీకోస్ట్": ఐవరీ కోస్ట్,

           // భాష
        "--ఆఫ్రికాన్స్": ఆఫ్రికాన్స్, //a
        "--అల్బేనియన్": అల్బేనియన్,
        "--అమ్హారిక్": అమ్హారిక్,
        "--అరబిక్": అరబిక్,
        "--అర్మేనియన్": అర్మేనియన్,
        "--అస్సామీ": అస్సామీ,
        "--అయ్మారా": ఐమారా,
        "--అజర్‌బైజానీ": అజర్‌బైజానీ,
        "--బంబారా": బంబారా, //బి
        "--బాస్క్": బాస్క్,
        "--బెలారసియన్": బెలారసియన్,
        "--బెంగాలీ": బెంగాలీ,
        "--భోజ్‌పురి": భోజ్‌పురి,
        "--బోస్నియన్": బోస్నియన్,
        "--బల్గేరియన్": బల్గేరియన్,
        "--కటాలన్": కాటలాన్, //c
        "--సెబువానో": సెబువానో,
        "--చిచేవా": చిచేవా,
        "--చైనీస్ సింప్లిఫైడ్": చైనీస్ (సరళీకృతం),
        "--చైనీస్ సాంప్రదాయం": చైనీస్ (సాంప్రదాయ),
        "--కార్సికన్": కోర్సికన్,
        "--croatian": క్రొయేషియన్,
        "--చెక్": చెక్,
        "--డానిష్": డానిష్, //d
        "--ధివేహి": ధివేహి,
        "--డోగ్రీ": డోగ్రీ,
        "--డచ్": డచ్,
        "--ఇంగ్లీష్": ఇంగ్లీష్, //e
        "--esperanto": ఎస్పరాంటో,
        "--ఎస్టోనియన్": ఎస్టోనియన్,
        "--ఈవే": ఈవ్,
        "--ఫిలిపినో": ఫిలిపినో, //f
        "--ఫిన్నిష్": ఫిన్నిష్,
        "--ఫ్రెంచ్": ఫ్రెంచ్,
        "--ఫ్రిసియన్": ఫ్రిసియన్,
        "--గలీషియన్": గెలీషియన్, //g
        "--జార్జియన్": జార్జియన్,
        "--జర్మన్": జర్మన్,
        "--గ్రీకు": గ్రీకు,
        "--గ్వారానీ": గ్వారానీ,
        "--గుజరాతీ": గుజరాతీ,
        "--haitianCreole": హైతియన్ క్రియోల్, //h
        "--హౌసా": హౌసా,
        "--హవాయి": హవాయి,
        "--హీబ్రూ": హీబ్రూ,
        "--హిందీ": హిందీ,
        "--హ్మాంగ్": మోంగ్,
        "--హంగేరియన్": హంగేరియన్,
        "--ఐస్లాండిక్": ఐస్లాండిక్, //i
        "--igbo": ఇగ్బో,
        "--ilocano": Ilocano,
        "--ఇండోనేషియా": ఇండోనేషియన్,
        "--ఐరిష్": ఐరిష్,
        "--ఇటాలియన్": ఇటాలియన్,
        "--జపనీస్": జపనీస్, //j
        "--జావానీస్": జావానీస్,
        "--కన్నడ": కన్నడ, //k
        "--కజాఖ్": కజఖ్,
        "--ఖ్మేర్": ఖైమర్,
        "--kinyarwanda": కిన్యర్వాండా,
        "--కొంకణి": కొంకణి,
        "--కొరియన్": కొరియన్,
        "--క్రియో": క్రియో,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": కుర్దిష్ (సొరాని),
        "--కిర్గిజ్": కిర్గిజ్,
        "--లావో": లావో, //l
        "--లాటిన్": లాటిన్,
        "--లాట్వియన్": లాట్వియన్,
        "--లింగాల": లింగాల,
        "--లిథువేనియన్": లిథువేనియన్,
        "--లుగాండా": లుగాండా,
        "--luxembourgish": Luxembourgish,
        "--మాసిడోనియన్": మాసిడోనియన్, //m
        "--మైథిలి": మైథిలి,
        "--malagasy": Malagasy,
        "--మలయ్": మలేయ్,
        "--మలయాళం": మలయాళం,
        "--మాల్టీస్": మాల్టీస్,
        "--మావోరీ": మావోరీ,
        "--మరాఠీ": మరాఠీ,
        "--meiteilonManipuri": Meiteilon (మణిపురి),
        "--మిజో": మిజో,
        "--మంగోలియన్": మంగోలియన్,
        "--మయన్మార్ బర్మీస్": మయన్మార్ (బర్మీస్),
        "--నేపాలీ": నేపాలీ, //n
        "--నార్వేజియన్": నార్వేజియన్,
        "--odiaOriya": ఒడియా (ఒరియా), //o
        "--ఒరోమో": ఒరోమో,
        "--పాష్టో": పాష్టో, //p
        "--పర్షియన్": పర్షియన్,
        "--పాలిష్": పోలిష్,
        "--పోర్చుగీస్": పోర్చుగీస్,
        "--పంజాబీ": పంజాబీ,
        "--క్వెచువా": క్వెచువా, //q
        "--రొమేనియన్": రోమేనియన్, //r
        "--రష్యన్": రష్యన్,
        "--సమోవాన్": సమోవన్, //s
        "--సంస్కృతం": సంస్కృతం,
        "--స్కాట్స్ గేలిక్": స్కాట్స్ గేలిక్,
        "--sepedi": Sepedi,
        "--సెర్బియన్": సెర్బియన్,
        "--సెసోతో": సెసోతో,
        "--షోనా": షోనా,
        "--సింధీ": సింధీ,
        "--సింహళం": సింహళం,
        "--స్లోవాక్": స్లోవాక్,
        "--స్లోవేనియన్": స్లోవేనియన్,
        "--సోమాలి": సోమాలి,
        "--స్పానిష్": స్పానిష్,
        "--సుండానీస్": సుండానీస్,
        "--స్వాహిలి": స్వాహిలి,
        "--స్వీడిష్": స్వీడిష్,
        "--తాజిక్": తాజిక్, //t
        "--తమిళం": తమిళం,
        "--టాటర్": టాటర్,
        "--తెలుగు": తెలుగు,
        "--థాయ్": థాయ్,
        "--టిగ్రిన్యా": టిగ్రిన్యా,
        "--సోంగా": సోంగా,
        "--టర్కిష్": టర్కిష్,
        "--టర్క్మెన్": తుర్క్మెన్,
        "--twi": ట్వి,
        "--ఉక్రేనియన్": ఉక్రేనియన్, //u
        "--ఉర్దూ": ఉర్దూ,
        "--ఉయ్ఘూర్": ఉయ్ఘూర్,
        "--ఉజ్బెక్": ఉజ్బెక్,
        "--వియత్నామీస్": వియత్నామీస్, //v
        "--వెల్ష్": వెల్ష్, //w
        "--xhosa": Xhosa, //x
        "--యిడ్డిష్": యిడ్డిష్, //y
        "--యోరుబా": యోరుబా,
        "--జులు": జులు, //z
        },
      },

      // thai
      // thai
      thai: {
        translations: {
          "--เกิดข้อผิดพลาด": เกิดข้อผิดพลาด!, //a
          "--ที่อยู่": ที่อยู่
          "--คำแนะนำ": คำแนะนำ
          "--โดยการคลิกที่ดำเนินการต่อ": เมื่อคลิกที่ดำเนินการต่อ คุณจะถูกตัดการเชื่อมต่อจากบัญชี Veil Brillant ของคุณ //b
          "--โดยการคลิกที่ตัดการเชื่อมต่อ คุณจะถูกตัดการเชื่อมต่อ": เมื่อคลิกที่ตัดการเชื่อมต่อ คุณจะถูกตัดการเชื่อมต่อจากบัญชี izocash ของคุณ
          "--ตรวจสอบหมายเลขเสมือนของคุณหรือลองอีกครั้งในภายหลัง": ตรวจสอบหมายเลขเสมือนของคุณหรือลองอีกครั้งในภายหลัง //c
          "--ตรวจสอบหมายเลขเสมือนของคุณ": ตรวจสอบหมายเลขเสมือนของคุณ
          "--ดำเนินการต่อ": ดำเนินการต่อ
          "--การเชื่อมต่อ": การเชื่อมต่อ,
          "--ร่วมมือ อยู่อย่างสามัคคี": ร่วมมือ อยู่ร่วมกับผู้อื่นอย่างสามัคคี
          "--เลือกภาษา": ภาษาโทรศัพท์เสมือน
          "--อย่าป้องกันการแข่งขัน": อย่าป้องกันการแข่งขัน ให้โอกาสทุกคน //ง
          "--ขาดการเชื่อมต่อ": ขาดการเชื่อมต่อ
          "--สำหรับผู้ใช้โทรศัพท์เสมือนทั้งหมด": สำหรับผู้ใช้โทรศัพท์เสมือนทั้งหมด ขอแนะนำให้ใช้ VPN, //f
          "--ไปที่หน้าเข้าสู่ระบบ": ไปที่หน้าเข้าสู่ระบบ //g
          "--ประวัติศาสตร์": ประวัติศาสตร์ //h
          "--ฉันมีบัญชี": ฉันมีบัญชีแล้ว //i
          "--ฉันไม่มีบัญชี": ฉันไม่มีบัญชี
          "--มันคือบ้านของคุณ": มันคือบ้านของคุณ
          "--รูปภาพ / วิดีโอ +": รูปภาพ / วิดีโอ +,
          "--การยืนยันตัวตน": การยืนยันตัวตน
          "--พอร์ทัลลูกค้า izocash": พอร์ทัลลูกค้า izocash
          "--identity update every year": อัปเดตข้อมูลประจำตัวทุกปี
          "--izocash ซื้อไปที่": izocash ซื้อ => izocash international,
          "--log in": เข้าสู่ระบบ!, //l
          "--เข้าสู่ระบบ": เข้าสู่ระบบ
          "--เข้าสู่ระบบสู่ Veil Brillant": เชื่อมต่อกับ Veil Brillant
          "--เข้าสู่ระบบร้านค้า vixinol": เชื่อมต่อกับร้านค้า Vixinol
          "--เข้าสู่ระบบบัญชี Veil Brillant ของคุณฟรี": เข้าสู่ระบบบัญชี Veil Brillant ของคุณฟรีเพื่อเข้าถึงคุณสมบัตินี้
          "--เข้าสู่ระบบสำเร็จ": เข้าสู่ระบบสำเร็จ!,
          "--เข้าสู่ระบบทันที": เข้าสู่ระบบทันที!,
          "--ออกจากระบบสำเร็จ": ออกจากระบบสำเร็จ!,
          "--ออกจากระบบ": ออกจากระบบ
          "--ออกจากระบบ": ออกจากระบบ
          "--number": ตัวเลข, //n
          "--ชื่อ": ชื่อ,
          "--ตอนนี้เข้าสู่ระบบ": ตอนนี้ เข้าสู่ระบบ!,
          "--ไม่มีการห้ามการแข่งขันที่ขัดขวาง":
          “--ไม่ริษยา ไม่เกลียด” ไม่ริษยา ไม่เกลียด ไม่แตกแยก
          "--ไม่ไม่,
          "--ที่อยู่อย่างเป็นทางการในการเข้าถึงโทรศัพท์เสมือนของคุณ": ที่อยู่อย่างเป็นทางการในการเข้าถึงโทรศัพท์เสมือนของคุณ //o
          "--รหัสผ่าน": รหัสผ่าน, //p
          "--ถอนคะแนน izocash": ถอนคะแนน izocash
          "--การถอนคะแนน": การถอนคะแนน
          "--ควรใช้ VPN": ควรใช้ VPN ที่ไม่ได้เป็นของผู้ให้บริการอินเทอร์เน็ตของคุณ
          "--ความพากเพียรให้ผลตอบแทนเสมอ": ความพากเพียรให้ผลตอบแทนเสมอในท้ายที่สุด
          "--กฎ": กฎ //r
          "--คำแนะนำ": คำแนะนำ
          "--การลงทะเบียน": การลงทะเบียน
          "--ลงทะเบียนเพื่อผ้าคลุมหน้าที่ยอดเยี่ยม": ลงทะเบียนบนผ้าคลุมหน้า Brillant, //s
          "--สมัครสมาชิกร้าน vixinol": ลงทะเบียนที่ร้านค้า Vixinol
          "--สมัครสมาชิก": ลงทะเบียน,
          "--สมัครสมาชิกสำเร็จ": ลงทะเบียนสำเร็จ!,
          "--สมัครฟรี": ลงทะเบียนฟรี
          “--สมัครสำเร็จ IA”: การเชื่อมต่อสำเร็จ”,
          "--settings": "การตั้งค่า",
          "--การตั้งค่าแอป alrani": การกำหนดค่าแอปพลิเคชัน Alrani
          "--การตั้งค่าแอป izocash": การกำหนดค่าแอปพลิเคชัน izocash
          "--การตั้งค่าแอป vixinol": การกำหนดค่าแอปพลิเคชัน Vixinol
          "--การตั้งค่าแอป Veil Brillant": การกำหนดค่าแอปพลิเคชัน Veil Brillant
          "--การจัดเก็บภาพ วิดีโอ": การจัดเก็บภาพ วิดีโอ และองค์ประกอบอื่นๆ อีกหลายรายการ
          "--ความเร็วของการรับสัญญาณ": ความเร็วในการรับข้อมูลจาก Datacenter,
          "--ความเร็ว": ความเร็ว,
          "--terminate": ยุติ //t
          "--VPN อนุญาตให้คุณเข้าถึง": VPN อนุญาตให้คุณเข้าถึงไซต์หรือแอปพลิเคชันที่ผู้ให้บริการอินเทอร์เน็ตของคุณอยู่ในบัญชีดำ
          "--ต้นไม้ที่ใหญ่ที่สุดอยู่เหนือ": ต้นไม้ที่ใหญ่ที่สุดอยู่เหนือสิ่งอื่นใดมีเมล็ดเล็กๆ ธรรมดาๆ
          "--สัมผัสหน้าจอ": สัมผัสหน้าจอเพื่อดำเนินการต่อ
          "--ลองอีกครั้ง": ลองอีกครั้ง!,
          "--ชื่อผู้ใช้": ชื่อผู้ใช้, //u

          "--หมายเลขเสมือน": หมายเลขเสมือน, //v
           "--การตั้งค่าโทรศัพท์เสมือน": การตั้งค่าโทรศัพท์เสมือน
           "--ใช้ภาษาโทรศัพท์เสมือน": ภาษาโทรศัพท์เสมือนถูกนำไปใช้ที่ระดับแอปพลิเคชันตามค่าเริ่มต้น
           "--โทรศัพท์เสมือน": โทรศัพท์เสมือน
           "--ตรวจสอบ": ตรวจสอบ,
           "--ยินดีต้อนรับสู่พอร์ทัลลูกค้า izocash": ยินดีต้อนรับสู่พอร์ทัลลูกค้า izocash //w
           "--write a super code": ป้อน Super code
           "--ยินดีต้อนรับสู่": ยินดีต้อนรับสู่
           "--ความสนใจของผู้คนไปไหน": ความสนใจของผู้คนไปถึงไหน เงินจะไปที่ใด
           "--ผู้ชนะมีความพากเพียร": ผู้ชนะมีความพากเพียร
           "--คุณต้องการออกจากระบบบัญชี Alrani ของคุณหรือไม่": คุณต้องการออกจากระบบบัญชี Alrani ของคุณหรือไม่,
           "--ใช่": ใช่ //y

           // ประเทศ
           "--congo": คองโก บราซซาวิล
           "--แคเมอรูน": แคเมอรูน
           "--drc": DRC,
           "--ivoryCoast": ไอวอรี่โคสต์

           // พูดไปเรื่อย
        "--แอฟริกัน": ภาษาแอฟริกัน, //a
        "--แอลเบเนีย": แอลเบเนีย
        "--อัมฮาริก": อัมฮาริก
        "--อารบิก": อารบิก
        "--อาร์เมเนีย": อาร์เมเนีย
        "--อัสสัม": อัสสัม
        "--อายมารา": ไอมารา,
        "--อาเซอร์ไบจาน": อาเซอร์ไบจาน
        "--บัมบารา": บัมบารา, //b
        "--บาสก์": บาสก์
        "--เบลารุส": เบลารุส
        "--เบงกาลี": เบงกาลี
        "--โภชปุรี": โภชปุรี
        "--บอสเนีย": บอสเนีย
        "--บัลแกเรีย": บัลแกเรีย,
        "--คาตาลัน": คาตาลัน, //ค
        "--เซบัวโน": เซบัวโน,
        "--ชิเชวา": ชิเชวา
        "--chineseSiตัวย่อ": จีน (ตัวย่อ)
        "--chineseTraditional": จีน (ดั้งเดิม)
        "--คอร์ซิกา": คอร์ซิกา
        "--croatian": โครเอเชีย,
        "--เช็ก": เช็ก,
        "--danish": ภาษาเดนมาร์ก, //d
        "--ธิเวหิ": ธิเวหิ
        "--dogri": โดกรี,
        "--ดัตช์": ภาษาดัตช์
        "--english": อังกฤษ, //e
        "--เอสเปรันโต": เอสเปรันโต
        "--เอสโตเนีย": เอสโตเนีย
        "--ewe": อุ๊ย
        "--filipino": ฟิลิปปินส์, //f
        "--ฟินแลนด์": ฟินแลนด์,
        "--ฝรั่งเศส": ฝรั่งเศส,
        "--ฟรีเซียน": ฟรีเซียน
        "--กาลิเซียน": กาลิเซีย //g
        "--จอร์เจีย": จอร์เจีย
        "--เยอรมัน": เยอรมัน,
        "--กรีก": กรีก
        "--กัวรานี": กวารานี
        "--คุชราต": คุชราต
        "--haitianCreole": ชาวเฮติครีโอล //h
        "--hausa": เฮาซา,
        "--ฮาวาย": ฮาวาย
        "--ฮีบรู": ฮิบรู
        "--ฮินดี": ฮินดี
        "--ม้ง": ม้ง
        "--ฮังการี": ฮังการี,
        "--ไอซ์แลนด์": ไอซ์แลนด์, //i
        "--อิกโบ": อิกโบ
        "--อิโลคาโน": อิโลคาโน
        "--อินโดนีเซีย": อินโดนีเซีย,
        "--ไอริช": ไอริช
        "--อิตาลี": อิตาลี,
        "--ญี่ปุ่น": ญี่ปุ่น, //j
        "--ชวา": ชวา
        "--กันนาดา": กันนาดา, //k
        "--คาซัค": คาซัค
        "--เขมร": เขมร
        "--กินยารวันดา": กินยารวันดา
        "--กนกณี": กนกณี,
        "--เกาหลี": เกาหลี,
        "--krio": คริโอ,
        "--เคิร์ดKurmanji": เคิร์ด (Kurmanji)
        "--เคิร์ดโซรานี": เคิร์ด (โซรานี)
        "--คีร์กีซ": คีร์กีซ
        "--lao": ลาว, //l
        "--latin": ละติน,
        "--ลัตเวีย": ลัตเวีย
        "--ลิงคลา": ลิงคลา
        "--ลิทัวเนีย": ลิทัวเนีย
        "--luganda": ลูกันดา,
        "--ลักเซมเบิร์ก": ภาษาลักเซมเบิร์ก
        "--มาซิโดเนีย": มาซิโดเนีย, //ม
        "--ไมถิลี": ไมถิลี,
        "--มาลากาซี": มาลากาซี,
        "--มาเลย์": มาเลย์,
        "--มาลายาลัม": มาลายาลัม
        "--maltese": ภาษามอลตา
        "--เมารี": เมารี
        "--มราฐี": มราฐี
        "--meiteilonManipuri": Meiteilon (มณีปุรี),
        "--มิโซะ": มิโซะ
        "--มองโกเลีย": มองโกเลีย
        "--myanmarBurmese": เมียนมาร์ (พม่า)
        "--เนปาล": เนปาล //n
        "--นอร์เวย์": นอร์เวย์,
        "--odiaOriya": โอเดีย (โอริยา) //o
        "--โอโรโม": โอโรโม
        "--pashto": ภาษา Pashto, //p
        "--เปอร์เซีย": เปอร์เซีย
        "--ขัด": ขัด,
        "--โปรตุเกส": โปรตุเกส,
        "--ปัญจาบ": ปัญจาบ
        "--quechua": เคชัว //q
        "--โรมาเนีย": โรมาเนีย, //r
        "--รัสเซีย": รัสเซีย,
        "--samoan": ซามัว, //s
        "--สันสกฤต": ภาษาสันสกฤต
        "--scotsGaelic": ภาษาเกลิคแบบสก็อต
        "--spedi": Sepedi,
        "--เซอร์เบีย": เซอร์เบีย,
        "--เซโซโท": เซโซโท
        "--โชนา": โชนา
        "--สินธี": สินธี
        "--สิงหล": สิงหล
        "--สโลวัก": สโลวัก,
        "--สโลเวเนีย": สโลวีเนีย
        "--โซมาลี": โซมาลี
        "--สเปน": สเปน,
        "--ซุนดา": ซุนดา
        "--สวาฮีลี": สวาฮีลี
        "--สวีดิช": สวีเดน,
        "--ทาจิกิสถาน": ทาจิกิสถาน, //t
        "--ทมิฬ": ทมิฬ
        "--ตาตาร์": ตาตาร์
        "--เตลูกู": เตลูกู
        "--thai": ไทย,
        "--ทิกริญญา": ติกรินยา
        "--ซองกา": ซองกา
        "--ตุรกี": ตุรกี,
        "--เติร์กเมนิสถาน": เติร์กเมนิสถาน
        "--twi": ทวิ,
        "--ยูเครน": ภาษายูเครน, //u
        "--ภาษาอูรดู": ภาษาอูรดู
        "--อุยกูร์": ชาวอุยกูร์
        "--อุซเบก": อุซเบก
        "--เวียดนาม": ภาษาเวียดนาม //v
        "--welsh": เวลส์ //w
        "--xhosa": Xhosa, //x
        "--ยิดดิช": ยิดดิช, //y
        "--โยรูบา": โยรูบา
        "--zulu": ซูลู, //z
        },
      },

      // tigrinya
      // tigrinya
      tigrinya: {
        translations: {
          "--ጌጋ ኣጋጢሙ": ጌጋ ኣጋጢሙ!, //a
           "--ኣድራሻ": ኣድራሻታት፣
           "--ምኽሪ": ምኽሪ፣
           "--by clicking on continue": ኣብ continue ብምጥዋቕ ካብ Veil Brillant ኣካውንትካ ክትቁረጽ ኢኻ፣ //b
           "--disconnect ዝብል ብምጥዋቕካ ክትቋረጽ ኢኻ": Disconnect ዝብል ብምጥዋቕ ካብ izocash ኣካውንትካ ክትቁረጽ ኢኻ፣
           "--ቨርቹዋል ቁጽርኻ መርምር ወይ ድሒርካ እንደገና ፈትኖ": ቨርቹዋል ቁጽርኻ መርምር ወይ ድሒርካ እንደገና ፈትኖ፣ //c
           "--ቨርቹዋል ቁጽርኻ ምፍታሽ": ቨርቹዋል ቁጽርኻ ምፍታሽ፣
           "--ቀጽል": ቀጽል፣
           "--ምትእስሳር": ምትእስሳር፣
           "--ምትሕብባር፡ ብስኒት ምንባር": ምትሕብባር፡ ምስ ካልኦት ብስኒት ምንባር፡
           "--ቋንቋ ምረጽ": ቨርቹዋል ቋንቋ ስልኪ፣
           "--ውድድር ኣይትኽልክሉ": ውድድር ኣይትኽልክሉ፣ ንኹሉ ዕድል ሃቡ፣ //መ
           "--ምቁራጽ": ምቁራጽ፣
           "--ንኹሎም ተጠቀምቲ ቨርቹዋል ስልኪ": ንኹሎም ተጠቀምቲ ቨርቹዋል ስልኪ፡ VPN፡ //f ምጥቃም ይምከር
           "--ናብ መእተዊ ገጽ ኪድ": ናብ መእተዊ ገጽ ኪድ፣ //g
           "--ታሪኻዊ": ታሪኻዊ፣ //ሕ
           "--i have account": ድሮ ኣካውንት ኣለኒ፣ //i
           "--ኣነ ኣካውንት የብለይን": ኣካውንት የብለይን፣
           "--ቤትካ እዩ": ገዛኻ እዩ፣
           "--ስእሊ / ቪድዮ +": ምስሊ / ቪድዮ +,
           "--መንነት ምርግጋጽ": መንነት ምርግጋጽ፣
           "--izocash customer portal": ፖርታል ዓማዊል izocash,
           "--ዓመታዊ ዝመሓየሽ መንነት": ዓመት ዓመት ዝመሓየሽ መንነት፣
           "--izocash buy to": izocash ዕድጊ => izocash ዓለምለኻዊ,
           "--log in": ምእታው!, //l
           "--login": ምእታው፣
           "--login to veil brilliant": ምስ Veil Brillant ምትእስሳር፣
           "--login to vixinol store": ምስ ቪክሲኖል ድኳን ምትእስሳር፣
           "--ኣብ ቬይል ብሪላንት ኣካውንትካ ብነጻ እቶ": ነዚ ባህሪ ንምርካብ ናብ ቬይል ብሪላንት ኣካውንትካ ብነጻ እቶ፣
           "--login success": ምእታው ዕዉት!,
           "--ሕጂ እቶ": ሕጂ እቶ!,
           "--logout success": ምውጻእ ዕዉት!,
           "--ውጽእ": ምውጻእ፣
           "--logout": ውጻእ፣
           "--ቁጽሪ": ቁጽሪ፣ //n
           "--ስም": ስም፣
           "--ሕጂ እቶ": ሕጂ፡ እቶ!,
           "--ውድድር ምሕንካስ እገዳ የለን":
           "--ቅንኢ የለን ጽልኢ የለን": ቅንኢ የለን ጽልኢ የለን ምፍልላይ የለን
           "--ኣይፋልን": ኣይፋልን፣
           "--ንቨርቹዋል ስልክኻ ንምእታው ዝሕግዙ ወግዓውያን ኣድራሻታት": ቨርቹዋል ስልክኻ ንምብጻሕ ዝሕግዙ ወግዓውያን ኣድራሻታት፡ //o
           "--password": ምልክት ቃል, //ገጽ
           "--ነጥቢ ምውጻእ izocash": ነጥቢ ምውጻእ izocash,
           "--ነጥቢ ምስሓብ": ነጥቢ ምስሓብ፣
           "--ተኻኢሉ፡ vpn ተጠቐም": እንተተኻኢሉ፡ ናይ ኢንተርነት ኣገልግሎት ወሃቢኻ ዘይኮነ VPN ተጠቐም፡
           "--ጽንዓት ኩሉ ግዜ ይኸፍል": ጽንዓት ኩሉ ግዜ ኣብ መወዳእታ ይኸፍል፣
           "--rule": ሕግታት, //r
           "--ለበዋ": ለበዋታት፣
           "--ምዝገባ": ምዝገባ፣
           "--signup to veil brilliant": ኣብ Veil Brillant ተመዝገብ፣ //s
           "--ናብ ድኳን ቪክሲኖል ተመዝገብ": ኣብ ድኳን ቪክሲኖል ተመዝገቡ፣
           "--ምምዝጋብ": ምዝገባ፣
           "--signup success": ምዝገባ ዕዉት!,
           "--ብነጻ ምዝገባ": ብነጻ ተመዝገቡ፣
           “--ምምዝጋብ ዓወት IA”: ምትእስሳር ዕዉት”,
           "--ቅጥዕታት": "ቅጥዕታት",
           "--ምድላው ናይ ኣልራኒ ኣፕ": ምውቃር ናይ ኣልራኒ መተግበሪ፣
           "--ምድላው ናይ izocash ኣፕ": ምውቃር ናይ izocash መተግበሪ፣
           "--ምትካል ናይ ቪክሲኖል ኣፕ": ምውቃር ናይ ቪክሲኖል መተግበሪ፣
           "--ምትካል ናይ መጋረጃ ብሪላንት ኣፕ": ምውቃር ናይ መጋረጃ ብሪላንት መተግበሪ፣
           "--መኽዘን ምስልታት፣ ቪድዮታት": መኽዘን ምስልታት፣ ቪድዮታትን ካልኦት ሓያሎ ባእታታትን፣
           "--ፍጥነት ምቕባል": ፍጥነት ምቕባል ዳታ ካብ ማእከል ዳታ፣
           "--ፍጥነት": ፍጥነት፣
           "--terminate": ምቁራጽ፣ //t
           "--the vpn allows you to access": እቲ VPN ንሓደ ወሃቢ ኣገልግሎት ኢንተርነትካ ኣብ ጸሊም ዝርዝር ዝኣተዎ መርበብ ሓበሬታ ወይ ኣፕሊኬሽን ክትኣቱ የኽእለካ፣
           "--እቲ ዝዓበየ ገረብ ኣብ ላዕሊ እዩ ነይሩ": እቲ ዝዓበየ ገረብ ልዕሊ ኩሉ ቀሊል ንእሽቶ ዘርኢ እዩ ነይሩ፣
           "--ንስክሪን ምትንካፍ": ንምቕጻል ነቲ ስክሪን ተንኪፍካ፣
           "--ደጊምካ ፈትኖ": ደጊምካ ፈትኖ!,
           "--username": ስም ተጠቃሚ፣ //u

           "--ቨርቹዋል ቁጽሪ": ምናባዊ ቁጽሪ፣ //v
           "--ቨርቹዋል ስልኪ ቅጥዕታት": ቨርቹዋል ስልኪ ቅጥዕታት፣
           "--virtual Phone language is applied": እቲ ቨርቹዋል Phone language ብነባሪ ብደረጃ መተግበሪ ይትግበር፣
           "--ቨርቹዋል ስልኪ": ቨርቹዋል ስልኪ፣
           "--validate": ምጽዳቕ፣
           "--እንቋዕ ናብ ፖርታል ዓማዊል izocash ብደሓን መጻእኩም": እንቋዕ ናብ ፖርታል ዓማዊል izocash ብደሓን መጻእኩም፣ //w
           "--ሱፐር ኮድ ጽሓፍ": ሱፐር ኮድ ኣእቱ፣
           "--እንቋዕ ናብ": እንቋዕ ናብ,
           "--ኣቓልቦ ሰባት ዝኸዶ": ኣቓልቦ ሰባት ዝኸዶ ገንዘብ ዝኸዶ፡
           "--ተዓወትቲ ይጽዕሩ": እቶም ተዓወትቲ ይጽዕሩ፣
           "--ካብ ኣልራኒ ኣካውንትካ ክትወጽእ ትደሊ ዲኻ": ካብ ኣልራኒ ኣካውንትካ ክትወጽእ ትደሊ ዲኻ?,
           "--እወ": እወ፡ //ይ

           // ሃገር
           "--ኮንጎ": ኮንጎ ብራዛቪል፡
           "--ካሜሩን": ካሜሩን፡
           "--drc": ዲ.ኣር.ሲ.
           "--ivoryCoast": ኣይቮሪኮስት፣

           // ቋንቋ
        "--ኣፍሪካውያን": ኣፍሪቃውያን፣ //ሀ
        "--ኣልባንያዊ": ኣልባንያዊ፡
        "--ኣምሓርኛ": ኣምሓርኛ፣
        "--ዓረብ": ዓረብኛ፣
        "--ኣርመንያዊ": ኣርመንያዊ፡
        "--assamese": ኣስመራ፣
        "--aymara": ኣይማራ፣
        "--ኣዘርባጃንኛ": ኣዘርባጃንኛ፣
        "--ባምባራ": ባምባራ፣ //ለ
        "--ባስክ": ባስክ፣
        "--ቤላሩስያዊ": ቤላሩስያዊ፣
        "--bengali": ቤንጋሊ፡
        "--bhojpuri": ቦጅፑሪ፣
        "--ቦዝንያዊ": ቦዝንያዊ፣
        "--ቡልጋርያዊ": ቡልጋርያዊ፣
        "--ካታሎንያ": ካታሎንያ፣ //c
        "--ሴቡኣኖ": ሴቡኣኖ፡
        "--ቺቸዋ": ቺቸዋ፣
        "--chineseSimplified": ቻይናዊ (ዝቐለለ)፣
        "--chineseTraditional": ቻይናዊ (ባህላዊ)፣
        "--ኮርሲካን": ኮርሲካን፣
        "--ክሮኤሽያ": ክሮኤሽያዊ፣
        "--ቸክ": ቸክ፣
        "--danish": ደንማርካዊ፡ //መ
        "--ድሂቨሂ": ድሂቨሂ፣
        "--dogri": ዶግሪ፡
        "--ሆላንዳዊ": ሆላንዳዊ፣
        "--ትግርኛ": ትግርኛ, //e
        "--ኤስፐራንቶ": ኤስፐራንቶ፡
        "--estonian": ኢስቶንያዊ፣
        "--ewe": ኣባጊዕ፡
        "--ፊሊፒኖ": ፊሊፒናዊ፡ //ረ
        "--ፊንላንድ": ፊንላንድኛ፣
        "--ፈረንሳ": ፈረንሳዊ፣
        "--ፍሪሻን": ፍሪሻን፣
        "--galician": ጋሊሽያዊ፣ //ግ
        "--ጆርጅያዊ": ጆርጅያዊ፡
        "--ጀርመንኛ": ጀርመንኛ፣
        "--ግሪኽ": ግሪኽ፣
        "--ጓራኒ": ጓራኒ፣
        "--ጉጃራቲ": ጉጃራቲ፣
        "--haitianCreole": ሃይቲ ክሪዮል፣ //h
        "--hausa": ሃውሳ፣
        "--ሃዋይኛ": ሃዋይኛ፣
        "--እብራይስጢ": እብራይስጢ፣
        "--ህንዲ": ህንዲ፣
        "--ህሞንግ": ህሞንግ፣
        "--ሃንጋሪኛ": ሃንጋሪኛ፣
        "--ኣይስላንድኛ": ኣይስላንድኛ፣ //i
        "--igbo": ኢግቦ፣
        "--ilocano": ኢሎካኖ፣
        "--ኢንዶነዥያዊ": ኢንዶነዥያዊ፡
        "--irish": ኣየርላንዳዊ፣
        "--ጣልያንኛ": ጣልያንኛ፣
        "--ጃፓናዊ": ጃፓናዊ፣ //j
        "--ጃቫናዊ": ጃቫናዊ፣
        "--kannada": ካናዳ, //k
        "--ካዛክ": ካዛክ፣
        "--khmer": ክመር፡
        "--ኪንያርዋንዳ": ኪንያርዋንዳ፡
        "--konkani": ኮንካኒ፣
        "--ኮርያዊ": ኮርያዊ፣
        "--ክሪዮ": ክሪዮ፣
        "--kurdishኩርማንጂ": ኩርማን (ኩርማንጂ)፣
        "--kurdishሶራኒ": ኩርዲሽ (ሶራኒ)፣
        "--kyrgyz": ኪርጊዝ፡
        "--lao": ላኦ, //l
        "--ላቲን": ላቲን፣
        "--ላቲቭያዊ": ላቲቭያዊ፣
        "--ሊንጋላ": ሊንጋላ፣
        "--ሊትዋንያኛ": ሊትዋንያኛ፣
        "--ሉጋንዳ": ሉጋንዳ፣
        "--luxembourgish": ሉክሰምበርግኛ፣
        "--መቄዶንያዊ": መቄዶንያዊ፡ //መ
        "--maithili": ቋንቋ ትግርኛ፣
        "--ማላጋሲ": ማላጋሲ፣
        "--ማሌዥያ": ማሌዥያ፣
        "--ማላያላም": ማላያላም፣
        "--ማልታ": ማልታ፡
        "--ማኦሪ": ማኦሪ፣
        "--ማራቲ": ማራቲ፣
        "--meiteilonማኒፑሪ": መይተይሎን (ማኒፑሪ)፣
        "--mizo": ሚዞ፣
        "--ሞንጎላዊ": ሞንጎሊያዊ፣
        "--myanmarBurmase": ሚያንማር (በርማኛ)፣
        "--nepali": ኔፓልኛ, //n
        "--ኖርወጃዊ": ኖርወጃዊ፣
        "--odiaOriya": ኦድያ (ኦርያ)፣ //o
        "--oromo": ኦሮሞ፣
        "--ፓሽቶ": ፓሽቶ፣ //ገጽ
        "--ፋርሳዊ": ፋርሳዊ፣
        "--ፖሊሽ": ፖላንድኛ፣
        "--ፖርቱጋልኛ": ፖርቱጋልኛ፣
        "--ፑንጃቢ": ፑንጃቢ፣
        "--ኩቹዋ": ኲቹዋ፣ //q
        "--ሮማናዊ": ሮማናዊ, //r
        "--ሩስያዊ": ሩስያዊ፣
        "--ሳሞኣዊ": ሳሞኣዊ፡ //ስ
        "--ሳንስክሪት": ሳንስክሪት፣
        "--scotsGaelic": ስኮትስ ጋሊክ፣
        "--sepedi": ሰፔዲ፣
        "--ሰርብያዊ": ሰርብያዊ፣
        "--sesotho": ሰሶቶ፣
        "--ሾና": ሾና፣
        "--ሲንዲ": ሲንዲ፣
        "--ሲንሃላ": ሲንሃላ፣
        "--ስሎቫክያ": ስሎቫክያ፣
        "--ስሎቨንያዊ": ስሎቨንያዊ፣
        "--ሶማሊ": ሶማላዊ፣
        "--ስጳንኛ": ስጳኛዊ፣
        "--sundanese": ሱንዳናዊ፣
        "--ስዋሂሊ": ስዋሂሊ፣
        "--ሽወደንኛ": ሽወደናዊ፣
        "--ታጂክ": ታጂክ፡ //ት
        "--tamil": ታሚል፣
        "--ታታር": ታታር፣
        "--telugu": ተለጉ፡
        "--ታይ": ታይላንዳዊ፣
        "--ትግርኛ": ትግርኛ፣
        "--tsonga": ጾንጋ፡
        "--ቱርኪ": ቱርኪ፣
        "--ቱርክመን": ቱርኪመን፣
        "--twi": ትዊ፣
        "--ዩክሬናዊ": ዩክሬናዊ, //u
        "--urdu": ኡርዱ፣
        "--uyghur": ዑይጉር፣
        "--uzbek": ኡዝቤክ፣
        "--ቬትናም": ቬትናምኛ፣ //v
        "--ዌልሽ": ዌልሽ፣ //w
        "--xhosa": ዞሳ፣ //x
        "--ይዲሽ": ይዲሽ፣ //ይ
        "--yoruba": ዮሩባ፣
        "--ዙሉ": ዙሉ፣ //ዝ
        },
      },

      // tsonga
      // tsonga
      tsonga: {
        translations: {
          "--xihoxo xi humelerile": Xihoxo xi humelerile!, //a
          "--adirese": Tiadirese, .
          "--xitsundzuxo": Xitsundzuxo, .
          "--hi ku tikhoma eka continue": Hi ku tikhoma eka continue u ta hambanisiwa na akhawunti ya wena ya Veil Brillant, //b
          "--hi ku click eka disconnect u ta tsemiwa": Hi ku click eka Disconnect u ta tsemiwa eka akhawunti ya wena ya izocash,
          "--languta nomboro ya wena ya xiviri kumbe u ringeta nakambe endzhaku": Languta nomboro ya wena ya xiviri kumbe u ringeta nakambe endzhaku, //c
          "--languta nomboro ya wena ya xiviri": Languta nomboro ya wena ya xiviri, .
          "--ya emahlweni": Yana emahlweni, .
          "--xihlanganisi": Xihlanganisi, .
          "--tirhisana, hanya hi ku twanana": Tirhisana, hanya hi ku twanana na van'wana, .
          "--hlawula ririmi": Ririmi ra Foni ra Xiviri, .
          "--u nga siveli mphikizano": U nga siveli mphikizano, nyika un'wana na un'wana nkarhi, //d
          "--ku tsema vuhlanganisi": Ku tsemiwa ka vuhlanganisi, .
          "--eka vatirhisi hinkwavo va tifoyini ta xiviri": Eka vatirhisi hinkwavo va Foni ya Xiviri, swa hlohleteriwa ku tirhisa VPN, //f
          "--ya eka tluka ro nghena": Yana eka tluka ro nghena, //g
          "--matimu": Matimu, //h
          "--ndzi na akhawunti": Se ndzi na akhawunti, //i
          "--a ndzi na account": A ndzi na account,
          "--i yindlu ya wena": i yindlu ya wena, .
          "--xifaniso / vhidiyo +": Xifaniso / Vhidiyo +,
          "--ku tiyisisiwa ka vutitivisi": Ku tiyisisiwa ka vutitivisi, .
          "--xiphemu xa vaxavi va izocash": Xihlovo xa vaxavi xa izocash,
          "--ku pfuxetiwa ka vutivi lembe na lembe": Ku pfuxetiwa ka vutivi lembe na lembe,
          "--izocash xava ku": izocash Xava => izocash ya matiko ya misava,
          "--nghena": Nghena!, //l
          "--login": Nghena, .
          "--nghena eka veil brilliant": Hlanganisa na Veil Brillant,
          "--nghena eka xitolo xa vixinol": Hlanganisa na Vhengele ra Vixinol,
          "--nghena mahala eka akhawunti ya wena ya veil Brillant": Nghena mahala eka akhawunti ya wena ya Veil Brillant ku fikelela xiyenge lexi,
          "--ku humelela ku nghena": Ku nghena swi humelerile!,
          "--nghena sweswi": Nghena sweswi!,
          "--ku humelela ka ku huma": Ku huma ku humelerile!,
          "--huma ehandle": Huma, .
          "--logout": Ku huma, .
          "--nomboro": Nomboro, //n
          "--vito": Vito, .
          "--sweswi nghena": Sweswi, Nghena!,
          "--ku hava ku yirisiwa ka ku sivela mphikizano":
          "--ku hava mavondzo, ku hava rivengo": Ku hava mavondzo, ku hava rivengo, ku hava ku avana, .
          "--hayi": E-e, .
          "--tiadirese ta ximfumo to nghena eka foni ya wena ya xiviri": Tiadirese ta ximfumo to nghena eka foni ya wena ya xiviri, //o
          "--phasiwedi": Phasiwedi, //p
          "--ku humesiwa ka tiphuinti izocash": Ku humesiwa ka tiphuinti izocash, .
          "--ku humesiwa ka tiphuinti": Ku humesiwa ka tiphuinti, .
          "--swi antswa, tirhisa vpn": Hi ku tsakela, tirhisa VPN leyi nga riki ya muphakeri wa wena wa vukorhokeri bya inthanete, .
          "--ku phikelela swi tshama swi hakela": Ku phikelela swi tshama swi hakela eku heteleleni,
          "--rule": Milawu, //r
          "--xitsundzuxo": Switsundzuxo, .
          "--ku tsarisa": Ku tsarisa, .
          "--tsarisa ku veil brilliant": Tsarisa eka Veil Brillant, //s
          "--tsarisa eka xitolo xa vixinol": Tsarisa eka Vhengele ra Vixinol,
          "--ku tsarisa": Tsarisa, .
          "--ku humelela ka ku tsarisa": Ku tsarisa ku humelerile!,
          "--tsarisa mahala": Tsarisa mahala,
          “--ku humelela ka ku tsarisa IA”: Nhlanganiso wu humelerile”,
          "--swiyimiso": "Swiyimiso", .
          "--ku veka app ya alrani": Ku lulamisa xitirhisiwa xa Alrani, .
          "--ku veka app ya izocash": Ku lulamisa xitirhisiwa xa izocash, .
          "--ku veka app ya vixinol": Ku lulamisa xitirhisiwa xa Vixinol, .
          "--ku veka app ya veil Brillant": Ku lulamisa xitirhisiwa xa Veil Brillant, .
          "--vuhlayiselo bya swifaniso, tivhidiyo": Vuhlayiselo bya swifaniso, tivhidiyo na swiaki swin'wana swo hlayanyana, .
          "--rivilo ra ku amukela": Rivilo ro amukela datha ku suka eka Datacenter, .
          "--rivilo": Rivilo, .
          "--terminate": Ku herisa, //t
          "--vpn yi ku pfumelela ku nghena": VPN yi ku pfumelela ku nghena eka sayiti kumbe xitirhisiwa lexi muphakeri wa wena wa vukorhokeri bya inthanete a xi vekeke eka nxaxamelo wa ntima,
          "--murhi lowukulu a wu ri ehenhla": Murhi lowukulu a wu ri ehenhla ka hinkwaswo mbewu leyitsongo yo olova, .
          "--khoma xikirini": Khoma xikirini ku ya emahlweni, .
          "--ringeta nakambe": Ringeta nakambe!,
          "--vito ra mutirhisi": Vito ra mutirhisi, //u

          "--nomboro ya xiviri": Nomboro ya xiviri, //v
           "--swiyimiso swa riqingho ra xiviri": Switirhisiwa swa riqingho ra xiviri, .
           "--virtual Phone language is applied": Ririmi ra Foni ya Xiviri ri tirhisiwa eka xiyimo xa xitirhisiwa hi ku tiyimisela, .
           "--foni ya xiviri": Foni ya xiviri, .
           "--tiyisekisa": Tiyisisa, .
           "--mi amukeriwile eka portal ya vaxavi va izocash": Mi amukeriwile eka Portal ya vaxavi ya izocash, //w
           "--tsala khodi ya super": Nghenisa khodi ya Super, .
           "--mi amukeriwile eka": Mi amukeriwile eka,
           "--laha nyingiso wa vanhu wu yaka kona": Laha nyingiso wa vanhu wu yaka kona mali,
           "--vahluri va tiyisela": Vahluri va tiyisela, .
           "--u nga tsakela ku huma eka akhawunti ya wena ya Alrani": Xana u lava ku huma eka akhawunti ya wena ya Alrani?,
           "--ina": Ina, //y

           // tiko
           "--congo": Xikolo xa Brazzaville,
           "--cameroon": Cameroon, .
           "--drc": DRC, 1999.
           "--ivoryCoast": Ribuwa ra tindlopfu,

           // ririmi ra ririmi
        "--afrikaans": Xibunu, //a
        "--xialbania": Xialbania, .
        "--xiamharic": Xiamharic, .
        "--xiarabu": Xiarabu, .
        "--xiarmenia": Xiarmenia, .
        "--xitsonga": Xiassamese, .
        "--aymara": Xiaymara, .
        "--xiazerbaijani": Xiazerbaijani, .
        "--bambara": Xitsonga, //b
        "--xibasque": Xibasque, .
        "--belarusian": Xibelarus, .
        "--bengali": Xibengali, .
        "--xitsonga": Xitsonga, .
        "--xibosnia": Xibosnia, .
        "--xibulgaria": Xibulgaria, .
        "--xicatalan": Xicatalan, //c
        "--cebuano": Xicebuano, .
        "--chichewa": Xichichewa, .
        "--chineseSimplified": Xichayina (Xi olovisiwa), .
        "--xichayinaNdhavuko": Xichayina (Ndhavuko), .
        "--xikhorsika": Xikhorsika, .
        "--xicroatia": Xicroatia, .
        "--xiczech": Xiczech, .
        "--xidanish": Xidanish, //d
        "--dhivehi": Xihlamusela-marito, .
        "--dogri": Xitsonga, .
        "--xidachi": Xidatishi, .
        "--xitsonga": Xitsonga, //e
        "--esperanto": Xiesperanto, .
        "--xiestonia": Xiestonia, .
        "--xinyimpfana": Xiharhi xa xisati, .
        "--filipino": Xifilipino, //f
        "--xifinixi": Xifinixi, .
        "--xifurwa": Xifurwa, .
        "--frisian": Xifrisian, .
        "--galician": Xigalicia, //g
        "--xigeorgia": Xigeorgia, .
        "--xijarimani": Xijarimani, .
        "--xigriki": Xigriki, .
        "--xiguarani": Xiguarani, .
        "--xigujarati": Xigujarati, .
        "--haitianCreole": Xicreole xa Xihaiti, //h
        "--hausa": Xitsonga, .
        "--xihawaii": Xihawaii, .
        "--xiheveru": Xiheveru, .
        "--hindi": Xihindi, .
        "--hmong": Xihmong, .
        "--xihungary": Xihungary, .
        "--xi-iceland": Xi-Iceland, //i
        "--igbo": Xiigbo, .
        "--ilocano": Xihlamusela-marito, .
        "--xi-indonesia": Xiindonesia, .
        "--irish": Xi-Irish, .
        "--xitaliyana": Xintariyana, .
        "--xijapani": Xijapani, //j
        "--xijavanese": Xijavani, .
        "--kannada": Xikannada, //k
        "--kazakh": Xikazakh, .
        "--khmer": Xikhmer, .
        "--kinyarwanda": Xikinyarwanda, .
        "--konkani": Xitsonga, .
        "--xikorea": Xikorea, .
        "--krio": Krio, .
        "--kurdishKurmanji": Xikurd (Xikurmanji), .
        "--kurdishSorani": Xikurd (Xisorani), .
        "--kyrgyz": Xikhirgyz, .
        "--lao": Xilao, //l
        "--xilatini": Xilatini, .
        "--xilatvian": Xilatvia, .
        "--lingala": Xitsonga, .
        "--xilithuanian": Xilithuania, .
        "--luganda": Xiluganda, .
        "--xitsonga": Xiluxembourgish, .
        "--makedoniya": Ximakedoniya, //m
        "--maithili": Xitsonga, .
        "--ximalagasy": Ximalagasy, .
        "--ximalayi": Ximalayi, .
        "--ximalayalam": Ximalayalam, .
        "--maltese": Ximalta, .
        "--maori": Ximaori, .
        "--marathi": Ximarathi, .
        "--meiteilonManipuri": Xifaniso xa xirhendzevutani (Manipuri), .
        "--mizo": Xitsonga, .
        "--ximongolia": Ximongolia, .
        "--myanmarXiburmani": Myanmar (Xiburma), .
        "--xinepali": Xinepali, //n
        "--xinorway": Xinorway, .
        "--odiaOriya": Xiodia (Xioriya), //o
        "--oromo": Xitsonga, .
        "--pashto": Xipashto, //tl
        "--xiperesiya": Xiperesiya, .
        "--polish": Xipolish, .
        "--xiputukezi": Xiputukezi, .
        "--xipunjabi": Xipunjabi, .
        "--xifunengeto": Xiquechua, //q
        "--xirhoma": Xiromania, //r
        "--xirhaxiya": Xirhaxiya, .
        "--xisamoan": Xisamoan, //s
        "--sanskrit": Xisanskrit, .
        "--scotsGaelic": Xigaelic xa le Scotland, .
        "--sepedi": Xitsonga, .
        "--xiserbia": Xiserbia, .
        "--xitsonga": Xitsonga, .
        "--shona": Xitsonga, .
        "--sindhi": Xisindhi, .
        "--xisinhala": Xisinhala, .
        "--xislovakia": Xislovaki, .
        "--xislovenia": Xislovenia, .
        "--somali": Xisomalia, .
        "--xipaniya": Xipaniya, .
        "--xitsonga": Xisundani, .
        "--xiswahili": Xiswahili, .
        "--xisweden": Xisweden, .
        "--tajik": Xitajiki, //t
        "--tamil": Xitamil, .
        "--tatar": Xitatar, .
        "--telugu": Xitsonga, .
        "--thai": Xithai, .
        "--tigrinya": Xitsonga, .
        "--tsonga": Xitsonga, .
        "--xiturkey": Xiturkey, .
        "--turkmen": Xiturkmen, .
        "--twi": Xitsonga, .
        "--xiukraine": Xiukraine, //u
        "--urdu": Xiurdu, .
        "--uyghur": Xiuyighur, .
        "--xiuzbek": Xiuzbek, .
        "--xivietnam": Xivietnam, //v
        "--xiwelsh": Xiwelsh, //w
        "--xhosa": Xitsonga, //x
        "--yiddish": Xiyiddish, //y
        "--yoruba": Xiyoruba, .
        "--zulu": Xizulu, //z
        },
      },

      // turkish
      // turkish
      turkish: {
        translations: {
          "--bir hata oluştu": Bir hata oluştu!, //a
           "--adres": Adresler,
           "--advice": Tavsiye,
           "--devam'a tıklayarak": Devam'a tıkladığınızda Veil Brillant hesabınızla bağlantınız kesilecektir, //b
           "--bağlantıyı kes'e tıkladığınızda bağlantınız kesilecektir": Bağlantıyı Kes'e tıkladığınızda izocash hesabınızla bağlantınız kesilecektir,
           "--sanal numaranızı kontrol edin veya daha sonra tekrar deneyin": Sanal numaranızı kontrol edin veya daha sonra tekrar deneyin, //c
           "--sanal numaranızı kontrol edin": Sanal numaranızı kontrol edin,
           "--devam et": Devam et,
           "--connection": Bağlantı,
           "--işbirliği yapın, uyum içinde yaşayın": İşbirliği yapın, başkalarıyla uyum içinde yaşayın,
           "--dili seç": Sanal Telefon Dili,
           "--rekabeti engellemeyin": Rekabeti engellemeyin, herkese şans verin, //d
           "--disconnection": Bağlantının kesilmesi,
           "--tüm sanal telefon kullanıcıları için": Tüm Sanal Telefon kullanıcılarının bir VPN kullanması önerilir, //f
           "--giriş sayfasına git": Giriş sayfasına git, //g
           "--historical": Tarihsel, //h
           "--hesabım var": Zaten bir hesabım var, //i
           "--hesabım yok": Hesabım yok,
           "--bu senin evin": bu senin evin,
           "--image / video +": Resim / Video +,
           "--kimlik doğrulama": Kimlik doğrulama,
           "--izocash müşteri portalı": izocash Müşteri Portalı,
           "--her yıl kimlik güncellemesi": Her yıl kimlik güncellemesi,
           "--izocash satın almak için": izocash Satın Al => izocash uluslararası,
           "--log giriş": Giriş yapın!, //l
           "--Giriş giriş,
           "--veil Brillant'a giriş yapın": Veil Brillant'a bağlanın,
           "--vixinol mağazasına giriş yapın": Vixinol Mağazasına bağlanın,
           "--veil Brillant hesabınıza ücretsiz giriş yapın": Bu özelliğe erişmek için Veil Brillant hesabınıza ücretsiz giriş yapın,
           "--login başarılı": Giriş başarılı!,
           "--şimdi giriş yapın": Şimdi giriş yapın!,
           "--logout başarılı": Oturum kapatma başarılı!,
           "--log out": Oturumu kapat,
           "--logout": Oturumu kapatın,
           "--sayı": Sayı, //n
           "--isim": Ad,
           "--şimdi giriş yapın": Şimdi, Giriş yapın!,
           "--boğucu rekabete yasak yok":
           "--kıskançlık yok, nefret yok": Kıskançlık yok, nefret yok, bölünme yok,
           "--hayır hayır,
           "--sanal telefonunuza erişmek için resmi adresler": Sanal telefonunuza erişmek için resmi adresler, //o
           "--password": Şifre, //p
           "--puan çekme izocash": Puan Çekme izocash,
           "--puan çekme": Puan Çekme,
           "--tercihen vpn kullanın": Tercihen internet servis sağlayıcınıza ait olmayan bir VPN kullanın,
           "--süreklilik her zaman karşılığını verir": Kalıcılık her zaman sonunda karşılığını verir,
           "--rule": Kurallar, //r
           "--recommendation": Öneriler,
           "--registration": Kayıt,
           "--veil Brillant'a kaydolun": Veil Brillant'a kaydolun, //s
           "--vixinol mağazasına kaydolun": Vixinol Mağazasına kaydolun,
           "--signup": Kayıt ol,
           "--signup Success": Kayıt başarılı!,
           "--ücretsiz kayıt olun": Ücretsiz kaydolun,
           “--signup başarı IA”: Bağlantı başarılı”,
           "--settings": "Ayarlar",
           "--alrani uygulamasını ayarlamak": Alrani uygulamasını yapılandırma,
           "--izocash uygulamasını ayarlamak": izocash uygulamasını yapılandırmak,
           "--vixinol uygulamasını ayarlamak": Vixinol uygulamasını yapılandırma,
           "--veil Brillant uygulamasını ayarlamak": Veil Brillant uygulamasını yapılandırma,
           "--görüntülerin, videoların depolanması": Görüntülerin, videoların ve diğer bazı öğelerin depolanması,
           "--Speed ​​of Reception": Veri merkezinden veri alım hızı,
           "--speed": Hız,
           "--terminate": Sonlandır, //t
           "--vpn erişmenizi sağlar": VPN, internet servis sağlayıcınızın kara listeye aldığı bir siteye veya uygulamaya erişmenizi sağlar,
           "--en büyük ağaç yukarıdaydı": En büyük ağaç her şeyden önce basit bir küçük tohumdu,
           "--ekrana dokunun": Devam etmek için ekrana dokunun,
           "--tekrar dene": Tekrar dene!,
           "--username": Kullanıcı adı, //u

           "--sanal sayı": Sanal sayı, //v
           "--virtual telefon ayarları": Sanal telefon ayarları,
           "--virtual Telefon dili uygulanır": Sanal Telefon dili, varsayılan olarak uygulama düzeyinde uygulanır,
           "--virtual telefon": Sanal telefon,
           "--validate": Doğrula,
           "--izocash müşteri portalına hoş geldiniz": izocash Müşteri Portalına hoş geldiniz, //w
           "--bir süper kod yazın": Bir Süper kod girin,
           "--hoş geldiniz": Hoş geldiniz,
           "--insanların dikkati nereye giderse": İnsanların dikkati nereye giderse para gider,
           "--kazananlar sebat eder": Kazananlar sebat eder,
           "--Alrani hesabınızdan çıkış yapmak ister misiniz": Alrani hesabınızdan çıkış yapmak istiyor musunuz?,
           "--evet": Evet, //y

           // ülke
           "--congo": Kongo Brazzaville,
           "--kamerun": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Fildişi Sahili,

           // dil
        "--afrikaans": Afrikaans, //a
        "--albanian": Arnavutça,
        "--amharca": Amharca,
        "--arabic": Arapça,
        "--armenian": Ermenice,
        "--assam dili": Assam dili,
        "--aymara": Aymara,
        "--azerbaijani": Azerice,
        "--bambara": Bambara, //b
        "--bask": Baskça,
        "--belarusça": Belarusça,
        "--bengali": Bengalce,
        "--bhojpuri": Bhojpuri,
        "--bosnalı": Boşnakça,
        "--bulgar": Bulgarca,
        "--catalan": Katalanca, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Çince (Basitleştirilmiş),
        "--chineseTraditional": Çince (Geleneksel),
        "--korsikalı": Korsikalı,
        "--hırvatça": Hırvatça,
        "--çekçe": Çekçe,
        "--danish": Danca, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Felemenkçe,
        "--english": İngilizce, //e
        "--esperanto": Esperanto,
        "--estonca": Estonca,
        "--ewe": Koyun,
        "--filipino": Filipince, //f
        "--fin": Fince,
        "--fransız": Fransızca,
        "--frizce": Frizce,
        "--galiçyaca": Galiçyaca, //g
        "--georgian": Gürcüce,
        "--german": Almanca,
        "--yunanca": Yunanca,
        "--guarani": Guarani,
        "--gujarati": Guceratça,
        "--haiti Kreyolu": Haiti Kreyolu, //h
        "--hausa": Hausa,
        "--hawaiian": Hawaii dili,
        "--İbranice": İbranice,
        "--hintçe": Hintçe,
        "--hmong": Hmong,
        "--macar": Macarca,
        "--izlanda dili": İzlandaca, //i
        "--igbo": İgbo,
        "--ilocano": Ilocano,
        "--indonesian": Endonezce,
        "--irish": İrlandalı,
        "--italian": İtalyanca,
        "--japonca": Japonca, //j
        "--javanese": Cava dili,
        "--kannada": Kannadaca, //k
        "--kazakh": Kazakça,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--korece": Korece,
        "--krio": Krio,
        "--kurdishKurmanji": Kürtçe (Kurmanci),
        "--kurdishSorani": Kürtçe (Sorani),
        "--kyrgyz": Kırgızca,
        "--lao": Lao, //l
        "--latin": Latince,
        "--latvian": Letonca,
        "--lingala": Lingala,
        "--lithuanca": Litvanca,
        "--luganda": Luganda,
        "--lüksemburgca": Lüksemburgca,
        "--makedonca": Makedonca, //m
        "--maithili": Maithili,
        "--malagasy": Madagaskarca,
        "--malayca": Malayca,
        "--malayalam": Malayalamca,
        "--maltalı": Maltalı,
        "--maori": Maori dili,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Moğolca,
        "--myanmarBurmese": Myanmar (Birmanya),
        "--nepali": Nepalce, //n
        "--norwegian": Norveççe,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--peştuca": Peştuca, //p
        "--farsça": Farsça,
        "--polish": Lehçe,
        "--portuguese": Portekizce,
        "--punjabi": Pencapça,
        "--quechua": Quechua, //q
        "--romanian": Rumence, //r
        "--russian": Rusça,
        "--samoaca": Samoaca, //s
        "--sanskritçe": Sanskritçe,
        "--scotsGaelic": İskoç Galcesi,
        "--sepedi": Sepedi,
        "--serbian": Sırpça,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovakça,
        "--sloven": Slovence,
        "--somali": Somalili,
        "--spanish": İspanyolca,
        "--sundanlı": Sundanlı,
        "--swahili": Svahili,
        "--swedish": İsveççe,
        "--tacik": Tacikçe, //t
        "--tamil": Tamilce,
        "--tatar": Tatarca,
        "--telugu": Telugu dili,
        "--thai": Tay dili,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkish": Türkçe,
        "--turkmen": Türkmence,
        "--twi": Twi,
        "--ukraynaca": Ukraynaca, //u
        "--urdu": Urduca,
        "--uygur": Uygurca,
        "--uzbek": Özbekçe,
        "--vietnamese": Vietnamca, //v
        "--welsh": Galce, //w
        "--xhosa": Xhosa, //x
        "--yiddiş": Yidiş, //y
        "--yoruba": Yoruba,
        "--zulu": Zuluca, //z
        },
      },

      // turkmen
      // turkmen
      turkmen: {
        translations: {
          "- ýalňyşlyk ýüze çykdy": erroralňyşlyk ýüze çykdy !, // a
           "- adres": Salgylar,
           "- maslahat": Maslahat,
           "- dowamyna basmak bilen": Dowam etmek düwmesine bassaňyz, Veil Brillant hasabyňyzdan aýrylarsyňyz, // b
           "- aýyrmak bilen bassaňyz, kesersiňiz": Aýyrmak düwmesine bassaňyz, izocash hasabyňyzdan aýrylarsyňyz,
           "- wirtual belgiňizi barlaň ýa-da soňrak synap görüň": Wirtual belgiňizi barlaň ýa-da soň gaýtadan synanyşyň, // c
           "- wirtual belgiňizi barlaň": Wirtual belgiňizi barlaň,
           "- dowamy": Dowam et,
           "- birikme": Baglanyşyk,
           "- hyzmatdaş, sazlaşykly ýaşa": Hyzmatdaşlyk ediň, beýlekiler bilen sazlaşykly ýaşaň,
           "- dil saýla": Wirtual Telefon Dili,
           "- bäsleşigiň öňüni almaň": Bäsleşigiň öňüni almaň, hemmelere pursat beriň, // d
           "- birikme": Ayrylmak,
           "- ähli wirtual telefon ulanyjylary üçin": Wirtual Telefon ulanyjylarynyň hemmesine VPN, // f ulanmak maslahat berilýär
           "- giriş sahypasyna gir": Giriş sahypasyna gir, // g
           "- taryhy": Taryhy, // sag
           "- meniň hasabym bar": Mende eýýäm hasaby bar, // i
           "- meniň hasabym ýok": Hasabym ýok,
           "- bu siziň jaýyňyz": bu siziň jaýyňyz,
           "- şekil / wideo +": Surat / Wideo +,
           "- şahsyýetini barlamak": Şahsyýeti barlamak,
           "--izocash müşderi portaly": izocash Müşderi Portaly,
           "- her ýyl şahsyýetiň täzelenişi": Her ýyl şahsyýet täzelenmesi,
           "--izocash satyn al": izocash Buy => izocash international,
           "--log in": Giriş !, // l
           "--login": Giriş,
           "- parlak ýapmak üçin login": Veil Brillant-a birikdiriň,
           "- vixinol dükanyna login": Vixinol dükanyna birikdiriň,
           "- perdäňize mugt giriň Brillant hasaby": Bu aýratynlyga girmek üçin Veil Brillant hasabyňyza mugt giriň,
           "--login üstünlik": Giriş üstünlikli!,
           "--login indi": Häzir giriň!,
           "--logout üstünlik": Çykyş üstünlikli!,
           "- çykmak": Çykmak,
           "--logout": Çykyň,
           "- san": San, // n
           "--name": Ady,
           "- giriň": Indi giriň!,
           "- bäsleşigi basyp ýatyrmak gadagan":
           "- gabanjaňlyk, ýigrenç ýok": Gabanjaňlyk, ýigrenç ýok, bölünişik ýok,
           "--ýok Ýok,
           "- wirtual telefonyňyza girmek üçin resmi salgylar": Wirtual telefonyňyza girmek üçin resmi salgylar, // o
           "--password": Parol, // s
           "- nokatlary yzyna almak izokaş": Ballary yzyna almak izocash,
           "- nokatlary yzyna almak": Ballary yzyna almak,
           "- has gowusy, vpn ulanyň": Iň gowusy, internet hyzmat üpjün edijiňize degişli bolmadyk VPN ulanyň,
           "- çydamlylyk elmydama öwezini dolýar": erjellik elmydama ahyrynda öwezini dolýar,
           "--rule": Düzgünler, // r
           "- Teklip": Teklipler,
           "- hasaba alyş": Hasaba alyş,
           "- ajaýyp perdäni bellemek": Veil Brillant, // s
           "- vixinol dükanyna ýazylmak": Vixinol dükanynda hasaba alyň,
           "--signup": Hasaba al,
           "--signup üstünlik": Hasaba alyş üstünlikli!,
           "- mugt ýazylmak": Mugt hasaba alyň,
           “- üstünlik gazanmak IA”: Baglanyşyk üstünlikli ”,
           "- sazlamalar": "Sazlamalar",
           "- alrani programmasyny gurmak": Alrani programmasyny düzmek,
           "- izocash programmasyny gurmak": izocash programmasyny düzmek,
           "- vixinol programmasyny gurmak": Vixinol programmasyny düzmek,
           "- perde Brillant programmasyny gurmak": Veil Brillant programmasyny düzmek,
           "- şekilleri, wideolary saklamak": Suratlary, wideolary we beýleki birnäçe elementleri saklamak,
           "- kabul ediş tizligi": Maglumat bazasyndan maglumat almagyň tizligi,
           "--speed": Tizlik,
           "- gutarmak": inateatyr, // t
           "- vpn size girmäge mümkinçilik berýär": VPN size internet hyzmat üpjün edijiňiziň gara sanawa giren bir sahypa ýa-da programma girmäge mümkinçilik berýär,
           "- iň uly agaç ýokarda": Iň uly agaç ýönekeý tohumdan ýokarydy,
           "- ekrana degiň": Dowam etmek üçin ekrana degiň,
           "- gaýtadan synanyşyň": gaýtadan synanyşyň!,
           "- ulanyjy ady": Ulanyjy ady, // u

           "- wirtual san": Wirtual san, // v
           "- wirtual telefon sazlamalary": Wirtual telefon sazlamalary,
           "- wirtual telefon dili ulanylýar": Wirtual Telefon dili programma derejesinde programma derejesinde ulanylýar,
           "- wirtual telefon": Wirtual telefon,
           "- tassyklamak": Barlamak,
           "- izocash müşderi portalyna hoş geldiňiz": izocash Müşderi Portalyna hoş geldiňiz, // w
           "- super kod ýazyň": Super kod giriziň,
           "- hoş geldiňiz": Hoş geldiňiz,
           "- adamlaryň ünsi nirä gidýär": Adamlaryň ünsi nirä gidýär,
           "- ýeňijiler sabyr edýärler": ýeňijiler sabyr edýärler,
           "- Alrani hasabyňyzdan çykmak isleýärsiňizmi": Alrani hasabyňyzdan çykmak isleýärsiňizmi?,
           "- hawa": Hawa, // ý

           // ýurt
           "--congo": Kongo Brazawil,
           "- kamera": Kamerun,
           "--drc": DRC,
           "--ivoryCoast": Piliory kenary,

           // dil
        "- afrikalylar": Afrika, // a
        "--alban": Alban,
        "--amharic": Amharic,
        "--arabic": Arapça,
        "- Ermenistan": Ermeni,
        "- assamese": Assam,
        "--aýmara": Aýmara,
        "--azerbaijani": Azerbaýjan,
        "--bambara": Bambara, // b
        "- bask": Bask,
        "- belarus": Belarus,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosniýa,
        "--bulgar": Bolgar,
        "- katalon": Kataloniýa, // c
        "--cebuano": Cebuano,
        "- Çiçewa": Çiçewa,
        "- HytaýSimplified": Hytaý (Simönekeýleşdirilen),
        "- Hytaý adaty": Hytaý (Adaty),
        "- korsikan": Korsikan,
        "- horwat": Horwatiýa,
        "- çeh": Çeh,
        "--daniş": Daniýaly, // d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--dutch": Gollandiýaly,
        "- Iňlis": Iňlis, // e
        "--esperanto": Esperanto,
        "--eston": Eston,
        "--ewe": Ewe,
        "--filipino": Filippinler, // f
        "- fin": Fin,
        "- fransuz": Fransuz,
        "--frisian": Frizian,
        "--galis": Galisiýa, // g
        "- Jorjiýa": gürji,
        "--german": Nemes,
        "--greek": Grek,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Gaiti Kreol, // sag
        "--hausa": Hausa,
        "--hawaiian": Gawaýi,
        "--hebrew": Hebrewewreýçe,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": Wenger,
        "--icelandic": Islandiýa, // i
        "--igbo": Igbo,
        "--ilokano": Ilokano,
        "--indonesian": Indoneziýa,
        "--irish": Irlandiýa,
        "--italian": Italýan,
        "- ýapon": ýapon, // j
        "- javaneseawa": Javaneseawan,
        "--kannada": Kannada, // k
        "--kazakh": Gazak,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "- Koreýa": Koreý,
        "--krio": Krio,
        "--kurdishKurmanji": Kürt (Kurmanji),
        "--kurdishSorani": Kürt (Sorani),
        "--kyrgyz": Gyrgyzystan,
        "--lao": Laos, // l
        "--latin": Latyn,
        "--latwian": Latwiýa,
        "--lingala": Lingala,
        "- Litwa": Litwa,
        "--luganda": Luganda,
        "--luxembourgish": Lýuksemburg,
        "--macedonian": Makedoniýa, // m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malaý": Malaý,
        "--malaýalam": Malaýalam,
        "- Malta": Malta,
        "--maori": Maori,
        "- marathi": marati,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "- mongol": Mongol,
        "--myanmarBurma": Mýanma (Birma),
        "--nepali": Nepal, // n
        "- norweg": Norweg,
        "--odiaOriya": Odiýa (Oriýa), // o
        "--oromo": Oromo,
        "- paşto": puştun, // s
        "--persian": Parsça,
        "- polish": Polýak,
        "--portuguese": Portugaliýa,
        "--punjabi": Penjabi,
        "--quechua": Keçua, // q
        "--roman": rumyn, // r
        "- rus": Rus,
        "--samoan": Samoa, // s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Şotlandlar Gael,
        "--sepedi": Sepedi,
        "--serbian": Serb,
        "--sesotho": Sesotho,
        "--shona": Şona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "- Slowakiýa": Slowakiýa,
        "- Sloweniýa": Sloweniýa,
        "--somali": Somali,
        "- Ispan": Ispan,
        "--sundanese": Sundanese,
        "- suwahili": suwaýili,
        "--swedish": Şwesiýa,
        "--tajik": Täjik, // t
        "--tamil": Tamil,
        "--tatar": tatar,
        "--telugu": Telugu,
        "- Taý": Taý,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "- türkçe": türk,
        "--turkmen": Türkmen,
        "--twi": Twi,
        "--ukrainian": ukrain, // u
        "--urdu": urdu,
        "--uyghur": uýgur,
        "--uzbek": Özbek,
        "- Wýetnam": Wýetnam, // v
        "--welsh": Uels, // w
        "--xosa": Kosa, // x
        "--yiddish": Yiddishahudy, // ý
        "- orubaoruba": Yorubaoruba,
        "--zulu": Zulu, // z
        },
      },

      // twi
      // twi
      twi: {
        translations: {
          "--mfomso bi asi": Mfomso bi asi!, //a
           "--address": Address ahorow, .
           "--afotu": Afotu, .
           "--sɛ wobɔ kɔ so": Sɛ wobɔ kɔ so a, wɔbɛtwa wo Veil Brillant akonta no mu, //b
           "--sɛ wobɔ disconnect so a wobɛtwa": Sɛ wobɔ Disconnect so a wobɛtwa wo zocash akontaabu no mu,
           "--hwɛ wo virtual nɔma anaa sɔ hwɛ bio akyiri yi": Hwɛ wo virtual nɔma anaa sɔ hwɛ bio akyiri yi, //c
           "--hwɛ wo virtual nɔma": Hwɛ wo virtual nɔma, .
           "--toa so": Toa so, .
           "---nkitahodi": Nkitahodi, .
           "--yɛ adwuma bom, tra ase wɔ biakoyɛ mu": Yɛ biako, tra ase wɔ biakoyɛ mu ne afoforo, .
           "--paw kasa": Virtual Phone Kasa, .
           "--nsiw akansi kwan": Nsiw akansi kwan, ma obiara hokwan, //d
           "--disconnection": Nkitahodi a wɔatwa, .
           "--ma virtual phone dwumadiefoɔ nyinaa": Wɔ Virtual Phone dwumadiefoɔ nyinaa fam no, wɔkamfo kyerɛ sɛ wɔmfa VPN, //f nni dwuma
           "--kɔ login krataafa no so": Kɔ login krataafa no so, //g
           "--abakɔsɛm": Abakɔsɛm, //h
           "--mewɔ akontaabu": Mewɔ akontaabu dedaw, //i
           "--me nni akontaabu": Me nni akontaabu, .
           "--ɛyɛ wo fie": ɛyɛ wo fie, .
           "--mfonini / video +": Mfonini / Video +,
           "--nnipa ho adansedi": Nnipa a wogye tom, .
           "--izocash adetɔfoɔ kwan so": izocash Adetɔfoɔ kwan so, .
           "--identity update afe biara": Identity update afe biara, .
           "--izocash tɔ kɔ": izocash Kɔtɔ => izocash amanaman ntam,
           "--kɔ mu": Kɔ mu!, //l
           "--login": Kɔ mu, .
           "--login to veil brilliant": Fa wo ho to Veil Brillant so, .
           "--kɔ vixinol sotɔɔ mu": Fa wo ho to Vixinol Store, .
           "--kɔ wo veil Brillant akontaabu mu kwa": Kɔ wo Veil Brillant akontaabu mu kwa na woanya saa ade yi,
           "--login nkonimdi": Login nkonimdi!,
           "--login now": Kɔ mu seesei!,
           "--logout nkonimdi": Logout nkonimdi!,
           "--fi mu": Fi mu, .
           "--logout": Fi adi, .
           "--nɔma": Nnɔmba, //n
           "--din": Edin, .
           "--seesei kɔ mu": Afei, Kɔ mu!,
           "--bara biara nni akansi a wɔde siw ano":
           "--anibere biara nni hɔ, nitan biara nni hɔ": Ahoɔyaw biara nni hɔ, nitan biara nni hɔ, mpaapaemu biara nni hɔ, .
           "--dabi": Dabi, .
           "--official addresses a wode bɛkɔ wo virtual fon so": Official addresses a wode bɛkɔ wo virtual fon so, //o
           "--asɛmfua": Asɛmfua, //p
           "--points a wɔde yi sika izocash": Points a wɔde yi sika izocash, .
           "--points a wɔayi afi mu": Points a wɔayi afi mu, .
           "--ɛyɛ papa sɛ, fa vpn di dwuma": Sɛ ɛbɛyɛ yiye a, fa VPN a ɛnyɛ wo intanɛt dwumadie dwumadiefoɔ no dea di dwuma,
           "--nsiyɛ tua ka bere nyinaa": Nkɔso tua ka bere nyinaa wɔ awiei no mu, .
           "--mmara": Mmara, //r
           "--kamfo": Nkamfo, .
           "--kyerɛwtohɔ": Kyerɛwtohɔ, .
           "--signup to veil brilliant": Kyerɛw wo din wɔ Veil Brillant so, //s
           "--kyerɛw wo din wɔ vixinol sotɔɔ mu": Kyerɛw wo din wɔ Vixinol Store,
           "--signup": Kyerɛw wo din, .
           "--signup success": Wɔn a wɔkyerɛw wɔn din no adi nkonim!,
           "--kyerɛw wo din kwa": Kyerɛw wo din kwa,
           “--signup nkonimdi IA”: Nkitahodi a edi mu”,
           "--nhyehyɛe": "Nhyehyɛe", .
           "--worehyehyɛ alrani app no": Woresiesie Alrani app no, .
           "--worehyehyɛ izocash app no": Woresiesie izocash app no, .
           "--rehyehyɛ vixinol app no": Vixinol app no ​​a woresiesie, .
           "--rehyehyɛ veil Brillant app no": Veil Brillant application no a woresiesie, .
           "--mfonini, video a wɔkora so": Mfonini, video ne nneɛma afoforo pii a wɔkora so, .
           "--ahoɔhare a wɔde gye": Ahoɔhare a wɔde gye data fi Datacenter, .
           "--ahoɔhare": Ahoɔhare, .
           "--terminate": Twa, //t
           "--vpn no ma wo kwan ma wokɔ": VPN no ma wo kwan ma wokɔ sait anaa application bi a wo intanɛt dwumadie dwumadie no ahyɛ blacklist so,
           "--na dua kɛse no wɔ soro": Na dua kɛse no sen ne nyinaa yɛ aba ketewaa bi a ɛnyɛ den, .
           "--ka screen no": Ka screen no na toa so, .
           "--bɔ mmɔden bio": Sɔ hwɛ bio!,
           "--ɔdefoɔ din": Ɔdefoɔ din, //u

           "--nɔma a ɛte sɛ nea ɛwɔ hɔ": Nnɔmba a ɛte sɛ nea ɛwɔ hɔ, //v
           "--virtual phone nhyehyeɛ": Virtual fon nhyehyeɛ, .
           "--virtual Phone kasa na wɔde di dwuma": Wɔde Virtual Phone kasa no di dwuma wɔ application level no default so, .
           "--telefon a wɔde di dwuma wɔ ɔkwan a ɛyɛ nokware so": Telefon a wɔde di dwuma wɔ ɔkwan a ɛyɛ nokware so, .
           "--validate": Gye sɛ, .
           "--ma wo akwaaba ba izocash adetɔfoɔ portal no so": Yɛma wo akwaaba ba izocash Adetɔfoɔ Portal no so, //w
           "--kyerɛw super koodu": Hyehyɛ Super koodu, .
           "--ma wo akwaaba ba": Yɛma wo akwaaba ba,
           "--baabi a nnipa adwene kɔ": Baabi a nnipa adwene kɔ sika kɔ, .
           "--nkonimdifo boa": Nkonimdifo no boa, .
           "--wopɛ sɛ wofiri wo Alrani akonta mu": Wopɛ sɛ wofiri wo Alrani akonta mu?,
           "--yiw": Yiw, //y

           // ɔman
           "--congo": Kongo Brazzaville, 1999. Ɔde ne nsa kyerɛɛ ne so.
           "--cameroon": Cameroon, 1999. Ɔde ne nsa kyerɛɛ ne so.
           "--drc": DRC, 1999 mu.
           "--asonse Mpoano": Asonse Mpoano, .

           // kasa
        "--afrikaans": Afrikaans, //a
        "--albania kasa": Albania kasa, .
        "--amharic": Amharic kasa, .
        "--arabic": Arabic kasa, .
        "--armenia": Armenia kasa, .
        "--assamese": Assam kasa, .
        "--aymara": Aymara, .
        "--azerbaijan kasa": Azerbaijan kasa, .
        "--bambara": Bambara kasa, //b
        "--basque": Basque kasa, .
        "--belarusian": Belarus kasa, .
        "--bengali": Bengali kasa, .
        "--bhojpuri": Kasa, .
        "--bosnia": Bosnia kasa, .
        "--bulgaria kasa": Bulgaria kasa, .
        "--catalan": Katalan kasa, //c
        "--cebuano": Cebuano, .
        "--chichewa": Chichewa, .
        "--chineseSimplified": China kasa (Wɔayɛ no mmerɛw), .
        "--chineseAmammerɛ": Chinafo (Amammerɛ), .
        "--korsika": Korsika, .
        "--croatian": Croatia kasa, .
        "--czech": Czech kasa, .
        "--danish": Danish kasa, //d
        "--hivehi": Ɔde ne nsa kyerɛɛ ne so, .
        "--dogri": Ɔkraman, .
        "--dutch": Dutch, .
        "--twi": Twi, //e
        "--esperanto": Esperanto kasa, .
        "--estonian": Estonia kasa, .
        "--ewe": Oguan, .
        "--filipino": Filipino kasa, //f
        "--finnish": Finland kasa, .
        "--franse kasa": Franse kasa, .
        "--frisian": Frisian kasa, .
        "--galician": Galician kasa, //g
        "--georgian": Georgia kasa, .
        "--german": German kasa, .
        "--greek": Hela kasa, .
        "--guarani": Guarani, .
        "--gujarati": Gujarati, .
        "--haitianCreole": Haitifo Creole, //h
        "--hausa": Hausa, .
        "--hawaii": Hawaii kasa, .
        "--hebri": Hebri kasa, .
        "--hindi": Hindi kasa, .
        "--hmong": Hmong, .
        "--hungary": Hungary kasa, .
        "--iceland kasa": Iceland kasa, //i
        "--igbo": Igbofo, .
        "--ilocano": Ilocano, .
        "--indonesian": Indonesia kasa, .
        "--irish": Ireland kasa, .
        "--italian": Italia kasa, .
        "--japan kasa": Japan kasa, //j
        "--javanese": Javan kasa, .
        "--kannada": Kannada, //k
        "--kazakh": Kazakh, .
        "--khmer": Khmerfo, .
        "--kinyarwanda": Kinyarwanda, .
        "--konkani": Konkani, .
        "--korean": Korea kasa, .
        "--krio": Krio, .
        "--kurdishKurmanji": Kurdfo (Kurmanji), .
        "--kurdishSorani": Kurdfo (Sorani kasa), .
        "--kyrgyzfoɔ": Kyrgyzfoɔ, .
        "--lao": Lao kasa, //l
        "--latin": Latin kasa, .
        "--latvian": Latvia kasa, .
        "--lingala": Lingala kasa, .
        "--lithuanian": Lithuania kasa, .
        "--luganda": Luganda, .
        "--luxembourgish": Luxembourgish kasa, .
        "--makedonia": Makedonia, //m
        "--maithili": Maithili kasa, .
        "--malagasy": Malagasy kasa, .
        "--malay": Malay kasa, .
        "--malayalam": Malayalam kasa, .
        "--maltese": Malta kasa, .
        "--maori": Maorifo, .
        "--marathi": Marathi kasa, .
        "--meiteilonManipuri": Meiteilon (Manipuri), .
        "--mizo": Mizo, .
        "--mongolian": Mongolia kasa, .
        "--myanmarBurma kasa": Myanmar (Burma kasa), .
        "--nepali": Nepali kasa, //n
        "--norway kasa": Norway kasa, .
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo, .
        "--pashto": Pashto kasa, //nkr
        "--persia kasa": Persia kasa, .
        "--polish": Polish kasa, .
        "--portuguese": Portugal kasa, .
        "--punjabi": Punjabi, .
        "--quechua": Quechua kasa, //q
        "--romanian": Romania kasa, //r
        "--russia": Russia kasa, .
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit kasa, .
        "--scotsGaelic": Scotland Gaelic kasa, .
        "--sepedi": Nsɛm a wɔka kyerɛ, .
        "--serbian": Serbia kasa, .
        "--sesotho": Kasa, .
        "--shona": Ɔsomfoɔ, .
        "--sindhi": Sindhi kasa, .
        "--sinhala": Sinhala kasa, .
        "--slovak": Slovak kasa, .
        "--slovenia": Slovenia kasa, .
        "--somali": Somalia kasa, .
        "--spanish": Spania kasa, .
        "--sundane kasa": Sundan kasa, .
        "--swahili": Swahili kasa, .
        "--swedish": Sweden kasa, .
        "--tajik": Tajik kasa, //t
        "--tamil": Tamil kasa, .
        "--tatar": Tatar, .
        "--telugu": Telugu kasa, .
        "--thai": Thai kasa, .
        "--tigrinya": Tigrinya, .
        "--tsonga": Tsonga, .
        "--turkish": Turkey kasa, .
        "--turkmen": Turkmenfo, .
        "--twi": Twi, .
        "--ukraine kasa": Ukraine kasa, //u
        "--urdu": Urdu kasa, .
        "--uyghur": Uyghur, .
        "--uzbek": Uzbek kasa, .
        "--vietnamese": Vietnam kasa, //v
        "--welsh": Welsh kasa, //w
        "--xhosa": Xhosa kasa, //x
        "--yiddish": Yiddish kasa, //y
        "--yoruba": Yoruba kasa, .
        "--zulu": Zulu kasa, //z
        },
      },*/

      // ukrainian
      // ukrainian
      ukrainian: {
        translations: {
           "--an error has occurred": "сталася помилка!", //a
           "--address": "адреси",
           "--advice": "порада",
           "--by clicking on continue": "натиснувши «Продовжити», ви будете відключені від свого облікового запису Veil Brillant", //b
           "--by clicking on disconnect you will be disconnected": "натиснувши кнопку Відключити, ви будете відключені від свого облікового запису izocash",
           "--check your virtual number or try again later": "перевірте свій віртуальний номер або повторіть спробу пізніше", //c
           "--check your virtual number": "Перевірте свій віртуальний номер",
           "--continue": "Продовжити",
           "--connection": "підключення",
           "--for all virtual phone users": "для всіх користувачів віртуального телефону рекомендується використовувати VPN", //f
           "--go to login page": "перейти на сторінку входу", //g
           "--historical": "Історичний", //ч
           "--i have account": "у мене вже є обліковий запис", //i
           "--i don't have account": "у мене немає облікового запису",
           "--it is your house": "це ваш будинок",
           "--image / video +": "зображення / відео +",
           "--identity verification": "підтвердження особи",
           "--izocash customer portal": "портал клієнтів izocash",
           "--identity update every year": "оновлення ідентифікаційних даних щороку",
           "--izocash buy to": "izocash Buy => izocash international",
           "--log in": "Увійти!", //l
           "--login": "увійти",
           "--login to veil brillant": "підключитися до Veil Brillant",
           "--login to vixinol store": "підключитися до магазину Vixinol",
           "--login for free to your veil brillant account": "увійдіть безкоштовно до свого облікового запису Veil Brillant, щоб отримати доступ до цієї функції",
           "--login success": "Вхід успішний!",
           "--login now": "Увійдіть зараз!",
           "--logout success": "Вихід успішний!",
           "--log out": "Вийти",
           "--logout": "Вийти",
           "--number": "число", //n
           "--name": "Ім'я",
           "--now log in": "Тепер увійдіть!",
           "--no ban on stifling competition": "заборони пригнічувати конкуренцію",
           "--no jealousy, no hatred": "Ні ревнощів, ні ненависті, ні розбіжностей",
           "--no": "ні",
           "--official addresses to access your virtual phone": "офіційні адреси для доступу до вашого віртуального телефону", //o
           "--password": "пароль", //стор
           "--points withdrawals izocash": "Бали зняття izocash",
           "--points withdrawals": "зняття балів",
           "--preferably, use a vpn": "бажано використовувати VPN, який не належить вашому інтернет-провайдеру",
           "--persistence always pays off": "наполегливість завжди окупається в кінці",
           "--rule": "Правила", //r
           "--recommendation": "Рекомендації",
           "--registration": "реєстрація",
           "--signup to veil brillant": "зареєструйтеся на Veil Brillant", //s
           "--signup to vixinol store": "зареєструватися в магазині Vixinol",
           "--signup": "Реєстрація",
           "--signup success": "реєстрація успішна!",
           "--signup for free": "зареєструйтеся безкоштовно",
           "--signup success IA": "підключення успішне”",
           "--settings": "Налаштування",
           "--setting up the alrani app": "налаштування програми Alrani",
           "--setting up the izocash app": "налаштування програми izocash",
           "--setting up the vixinol app": "налаштування програми Vixinol",
           "--setting up the veil brillant app": "налаштування програми Veil Brillant",
           "--storage of images, videos": "зберігання зображень, відео та кількох інших елементів",
           "--speed of reception": "Швидкість прийому даних з ЦОД",
           "--speed": "швидкість",
           "--terminate": "завершити", //t
           "--the vpn allows you to access": "VPN дозволяє отримати доступ до сайту або програми, які ваш постачальник послуг Інтернету вніс у чорний список",
           "--the largest tree was above": "найбільше дерево було перш за все простим маленьким насінням",
           "--touch the screen": "торкніться екрана, щоб продовжити",
           "--try again": "спробуйте ще раз!",
           "--username": "ім'я користувача", //u
           "--virtual number": "Віртуальний номер", //v
           "--virtual phone settings": "налаштування віртуального телефону",
           "--virtual phone language is applied": "Мова віртуального телефону за замовчуванням застосовується на рівні програми",
           "--virtual phone": "віртуальний телефон",
           "--validate": "Перевірити",
           "--welcome to the izocash customer portal": "вітаємо на порталі клієнтів izocash", //w
           "--write a supercode": "введіть суперкод",
           "--welcome to": "Ласкаво просимо до",
           "--where people's attention goes": "куди приходить увага людей, йдуть гроші",
           "--winners persevere": "Переможці витримують",
           "--would you want to log out of your Alrani account": "Ви хочете вийти зі свого облікового запису Alrani?",
           "--yes": "Так", //y

           // pays
           "--congo": "Конго Браззавіль",
           "--cameroon": "Камерун",
           "--drc": "ДРК",
           "--ivoryCoast": "Берег Слонової Кістки",

        // langues
        "--afrikaans": "африкаанс", //a
        "--albanian": "албанська",
        "--amharic": "амхарська",
        "--arabic": "арабська",
        "--armenian": "вірменська",
        "--assamese": "ассамська",
        "--aymara": "аймара",
        "--azerbaijani": "азербайджанська",
        "--bambara": "Бамбара", //b
        "--basque": "баскська",
        "--belarusian": "білоруський",
        "--bengali": "бенгальська",
        "--bhojpuri": "бходжпурі",
        "--bosnian": "боснійський",
        "--bulgarian": "болгарський",
        "--catalan": "каталонська", //c
        "--cebuano": "себуано",
        "--chichewa": "Чічева",
        "--chineseSimplified": "китайська (спрощена)",
        "--chineseTraditional": "китайська (традиційна)",
        "--corsican": "корсиканець",
        "--croatian": "хорватська",
        "--czech": "чеська",
        "--danish": "данська", //d
        "--dhivehi": "дивехі",
        "--dogri": "Догрі",
        "--dutch": "голландська",
        "--english": "англійська", //e
        "--esperanto": "есперанто",
        "--estonian": "естонська",
        "--ewe": "вівця",
        "--filipino": "філіппінський", //f
        "--finnish": "фінська",
        "--french": "французька",
        "--frisian": "фризька",
        "--galician": "галицький", //г
        "--georgian": "грузинський",
        "--german": "німецька",
        "--greek": "грецька",
        "--guarani": "гуарані",
        "--gujarati": "гуджараті",
        "--haitianCreole": "гаїтянська креольська", //h
        "--hausa": "Хауса",
        "--hawaiian": "гавайська",
        "--hebrew": "іврит",
        "--hindi": "гінді",
        "--hmong": "Хмонг",
        "--hungarian": "угорська",
        "--icelandic": "ісландська", //i
        "--igbo": "ігбо",
        "--ilocano": "Ілокано",
        "--indonesian": "індонезійська",
        "--irish": "ірландський",
        "--italian": "італійська",
        "--japanese": "японський", //j
        "--javanese": "яванська",
        "--kannada": "каннада", //k
        "--kazakh": "казахська",
        "--khmer": "кхмерський",
        "--kinyarwanda": "кіньяруанда",
        "--konkani": "конкані",
        "--korean": "корейська",
        "--krio": "Кріо",
        "--kurdishKurmanji": "курдська (Kurmanji)",
        "--kurdishSorani": "курдська (сорані)",
        "--kyrgyz": "киргизька",
        "--lao": "лао", //l
        "--latin": "латиниця",
        "--latvian": "латиська",
        "--lingala": "Лінгала",
        "--lithuanian": "литовська",
        "--luganda": "Луганда",
        "--luxembourgish": "люксембурзька",
        "--macedonian": "македонський", //м
        "--maithili": "майтхілі",
        "--malagasy": "малагасійська",
        "--malay": "малайська",
        "--malayalam": "малаялам",
        "--maltese": "мальтійська",
        "--maori": "Маорі",
        "--marathi": "маратхі",
        "--mizo": "Мізо",
        "--mongolian": "монгольська",
        "--myanmarBurmese": "М'янма (бірманська)",
        "--nepali": "непальський", //n
        "--norwegian": "норвезька",
        "--odiaOriya": "Одія (Орія)", //о
        "--oromo": "Оромо",
        "--pashto": "пушту", //стор
        "--persian": "перська",
        "--polish": "польська",
        "--portuguese": "португальська",
        "--punjabi": "панджабі",
        "--quechua": "кечуа", //q
        "--romanian": "румунська", //р
        "--russian": "російська",
        "--samoan": "самоанський", //s
        "--sanskrit": "санскрит",
        "--scotsGaelic": "шотландська гельська",
        "--sepedi": "Сепеді",
        "--serbian": "сербська",
        "--sesotho": "сесото",
        "--shona": "шона",
        "--sindhi": "Сіндхі",
        "--sinhala": "сингальська",
        "--slovak": "словацька",
        "--slovenian": "словенська",
        "--somali": "Сомалі",
        "--spanish": "іспанська",
        "--sundanese": "суданська",
        "--swahili": "суахілі",
        "--swedish": "шведська",
        "--tajik": "таджицький", //т
        "--tamil": "тамільська",
        "--tatar": "татарський",
        "--telugu": "телугу",
        "--thai": "тайська",
        "--tigrinya": "Тигриня",
        "--tsonga": "Цонга",
        "--turkish": "турецька",
        "--turkmen": "туркменський",
        "--twi": "Тві",
        "--ukrainian": "український", //у
        "--urdu": "урду",
        "--uyghur": "уйгурська",
        "--uzbek": "узбецька",
        "--vietnamese": "в'єтнамська", //v
        "--welsh": "валлійська", //w
        "--xhosa": "коса", //x
        "--yiddish": "ідиш", //y
        "--yoruba": "йоруба",
        "--zulu": "зулу", //z
        },
      },

      // urdu
      // urdu
      /*urdu: {
        translations: {
          "--ایک غلطی ہو گئی ہے": ایک خرابی ہو گئی ہے!, //a
           "--address": پتے،
           "--advice": مشورہ،
           "-- جاری پر کلک کرنے سے": جاری پر کلک کرنے سے آپ اپنے Veil Brillant اکاؤنٹ سے منقطع ہو جائیں گے، //b
           "-منقطع پر کلک کرنے سے آپ کا رابطہ منقطع ہو جائے گا": منقطع پر کلک کرنے سے آپ اپنے izocash اکاؤنٹ سے منقطع ہو جائیں گے،
           "--اپنا ورچوئل نمبر چیک کریں یا بعد میں دوبارہ کوشش کریں": اپنا ورچوئل نمبر چیک کریں یا بعد میں دوبارہ کوشش کریں، //c
           "--اپنا ورچوئل نمبر چیک کریں": اپنا ورچوئل نمبر چیک کریں،
           "--continue": جاری رکھیں،
           "--connection": کنکشن،
           "-- تعاون کریں، ہم آہنگی میں رہیں": تعاون کریں، دوسروں کے ساتھ ہم آہنگی میں رہیں،
           "--choose language": ورچوئل فون کی زبان،
           "-مقابلے کو روکنا نہیں": مقابلے کو نہ روکیں، سب کو موقع دیں، //d
           "--disconnection": منقطع ہونا،
           "-- تمام ورچوئل فون صارفین کے لیے": تمام ورچوئل فون صارفین کے لیے، VPN استعمال کرنے کی سفارش کی جاتی ہے، //f
           "-- لاگ ان پیج پر جائیں": لاگ ان پیج پر جائیں، //g
           "--historical": تاریخی، //h
           "--میرا اکاؤنٹ ہے": میرے پاس پہلے سے ہی ایک اکاؤنٹ ہے، //i
           "--میرا اکاؤنٹ نہیں ہے": میرے پاس اکاؤنٹ نہیں ہے،
           "-یہ تمہارا گھر ہے": یہ تمہارا گھر ہے،
           "--image/video +": تصویر/ویڈیو +،
           "--identity verification": شناخت کی تصدیق،
           "--izocash کسٹمر پورٹل": izocash کسٹمر پورٹل،
           "-- شناخت کی تازہ کاری ہر سال": ہر سال شناخت کی تازہ کاری،
           "--izocash buy to": izocash Buy => izocash بین الاقوامی،
           "--log in": لاگ ان!، //l
           "--login": لاگ ان کریں،
           "--login to veil brillant": پردہ شاندار سے جڑیں،
           "-- vixinol store میں لاگ ان کریں": Vixinol Store سے جڑیں،
           "-اپنے پردہ برلنٹ اکاؤنٹ میں مفت لاگ ان کریں": اس خصوصیت تک رسائی حاصل کرنے کے لیے اپنے پردہ برلنٹ اکاؤنٹ میں مفت لاگ ان کریں،
           "--login success": لاگ ان کامیاب!,
           "--login now": ابھی لاگ ان کریں!,
           "--logout success": لاگ آؤٹ کامیاب!،
           "-log out": لاگ آؤٹ،
           "--logout": لاگ آؤٹ،
           "--number": نمبر، //n
           "--نام": نام،
           "--now log in": اب لاگ ان کریں!,
           "-مقابلے کو دبانے پر کوئی پابندی نہیں":
           "--کوئی حسد، کوئی نفرت نہیں": کوئی حسد، کوئی نفرت، کوئی تقسیم نہیں،
           "--نہیں نہیں،
           "آپ کے ورچوئل فون تک رسائی کے لیے سرکاری پتے": آپ کے ورچوئل فون تک رسائی کے لیے سرکاری پتے، //o
           "--password": پاس ورڈ، //p
           "-پوائنٹس کی واپسی izocash": پوائنٹس کی واپسی izocash،
           "-پوائنٹس کی واپسی": پوائنٹس کی واپسی،
           "--preferably, use a vpn": ترجیحی طور پر، ایسا VPN استعمال کریں جس کا تعلق آپ کے انٹرنیٹ سروس فراہم کنندہ سے نہ ہو،
           "--استقامت ہمیشہ ادا کرتی ہے": استقامت ہمیشہ آخر میں ادا کرتی ہے،
           "--rule": قواعد، //r
           "--recommendation": سفارشات،
           "--رجسٹریشن": رجسٹریشن،
           "--signup to veil brillant": پردہ شاندار پر رجسٹر کریں، //s
           "--سائن اپ to vixinol store": Vixinol Store پر رجسٹر ہوں،
           "--signup": رجسٹر کریں،
           "--signup success": رجسٹریشن کامیاب!,
           "--signup for free": مفت میں رجسٹر کریں،
           "--سائن اپ کامیابی IA": کنکشن کامیاب"،
           "--settings": "ترتیبات"،
           "-الرانی ایپ کو ترتیب دینا": الرانی ایپلیکیشن کو ترتیب دینا،
           "--izocash ایپ کو ترتیب دینا": izocash ایپلیکیشن کو ترتیب دینا،
           "--vixinol ایپ کو ترتیب دینا": Vixinol ایپلیکیشن کو ترتیب دینا،
           "- پردہ برلنٹ ایپ کو ترتیب دینا": پردہ برلنٹ ایپلیکیشن کو ترتیب دینا،
           "--تصاویر، ویڈیوز کا ذخیرہ": تصاویر، ویڈیوز اور کئی دیگر عناصر کا ذخیرہ،
           "-استقبال کی رفتار": ڈیٹا سینٹر سے ڈیٹا کے استقبال کی رفتار،
           "-speed": رفتار،
           "--terminate": ختم کرنا، //t
           "--vpn آپ کو رسائی کی اجازت دیتا ہے": VPN آپ کو کسی ایسی سائٹ یا ایپلیکیشن تک رسائی کی اجازت دیتا ہے جسے آپ کے انٹرنیٹ سروس فراہم کنندہ نے بلیک لسٹ کر رکھا ہے،
           "--سب سے بڑا درخت اوپر تھا": سب سے بڑا درخت ایک چھوٹے سے بیج سے اوپر تھا،
           "--اسکرین کو چھوئیں": جاری رکھنے کے لیے اسکرین کو چھوئیں،
           "--try again": دوبارہ کوشش کریں!,
           "--username": صارف نام، //u

           "--virtual number": ورچوئل نمبر، //v
           "--virtual phone settings": ورچوئل فون سیٹنگز،
           "-- ورچوئل فون لینگویج کا اطلاق ہوتا ہے": ورچوئل فون لینگویج ایپلیکیشن لیول پر بطور ڈیفالٹ لاگو ہوتی ہے،
           "--virtual phone": ورچوئل فون،
           "--validate": توثیق کریں،
           "--welcome to the izocash کسٹمر پورٹل": izocash کسٹمر پورٹل میں خوش آمدید، //w
           "--ایک سپر کوڈ لکھیں": ایک سپر کوڈ درج کریں،
           "-welcome to": میں خوش آمدید،
           "- جہاں لوگوں کی توجہ جاتی ہے": جہاں لوگوں کی توجہ جاتی ہے پیسہ جاتا ہے،
           "--جیتنے والے ثابت قدم رہتے ہیں": فاتح ثابت قدم رہتے ہیں،
           "--کیا آپ اپنے Alrani اکاؤنٹ سے لاگ آؤٹ کرنا چاہیں گے": کیا آپ اپنے Alrani اکاؤنٹ سے لاگ آؤٹ کرنا چاہتے ہیں؟,
           "--ہاں": ہاں، //y

           // ملک
           "--congo": کانگو برازاویل،
           "-cameroon": کیمرون،
           "--drc": DRC،
           "--ivoryCoast": آئیوری کوسٹ،

           // زبان
        "--afrikaans": افریقی، //a
        "--البانی": البانی،
        "--amharic": امہاری،
        "--عربی": عربی،
        "--armenian": آرمینیائی،
        "--assamese": آسامی،
        "-aymara": عمارہ،
        "--آزربائیجانی": آذربائیجانی،
        "--bambara": بامبرا، //b
        "-basque": باسکی،
        "--belarusian": بیلاروسی،
        "- بنگالی": بنگالی،
        "--bhojpuri": بھوجپوری،
        "--bosnian": بوسنیائی،
        "--بلغاریائی": بلغاریائی،
        "--catalan": Catalan, //c
        "--cebuano": Cebuano،
        "--chichewa": چیچیوا،
        "--chineseSimplified": چینی (آسان کردہ)،
        "--chineseTraditional": چینی (روایتی)،
        "-corsican": Corsican،
        "--croatian": کروشین،
        "--czech": چیک،
        "--danish": ڈینش، //d
        "--dhivehi": Dhivehi،
        "--dogri": ڈوگری،
        "--dutch": ڈچ،
        "--انگریزی": انگریزی، //e
        "--esperanto": ایسپرانٹو،
        "--estonian": اسٹونین،
        "--ewe": ایو،
        "--filipino": فلپائنی، //f
        "-finnish": فننش،
        "--french": فرانسیسی،
        "--frisian": Frisian،
        "--galician": گالیشین، //g
        "--georgian": جارجیائی،
        "--german": جرمن،
        "--greek": یونانی،
        "--guarani": گوارانی،
        "--gujarati": گجراتی،
        "--haitianCreole": Haitian Creole، //h
        "--hausa": ہاؤسا،
        "--hawaiian": ہوائی،
        "--hebrew": عبرانی،
        "-hindi": ہندی،
        "--hmong": Hmong،
        "--hungarian": ہنگری،
        "--icelandic": آئس لینڈی، //i
        "--igbo": اگبو،
        "--ilocano": Ilocano،
        "--انڈونیشیائی": انڈونیشیائی،
        "-irish": آئرش،
        "--اطالوی": اطالوی،
        "--japanese": جاپانی، //j
        "--javanese": جاویانی،
        "--kannada": کنڑ، //k
        "--kazakh": قازق،
        "--khmer": خمیر،
        "--kinyarwanda": کنیاروانڈا،
        "--کونکنی": کونکنی،
        "--korean": کورین،
        "--krio": کریو،
        "--kurdishKurmanji": کردش (کرمانجی)،
        "--kurdishSorani": کرد (سورانی)،
        "--kyrgyz": کرغیز،
        "--lao": لاؤ، //l
        "--latin": لاطینی،
        "--latvian": لیٹوین،
        "--lingala": لنگالا،
        "--lithuanian": لتھوانیائی،
        "--luganda": لوگنڈا،
        "--luxembourgish": لکسمبرگ،
        "--macedonian": مقدونیائی، //m
        "--maithili": میتھلی،
        "--malagasy": ملاگاسی،
        "--malay": مالائی،
        "- ملیالم": ملیالم،
        "-- مالٹی": مالٹیز،
        "-maori": ماوری،
        "--مراٹھی": مراٹھی،
        "--meiteilonManipuri": Meiteilon (Manipuri)،
        "--mizo": میزو،
        "--mongolian": منگول،
        "--myanmarBurmese": میانمار (برمی)،
        "--nepali": نیپالی، //n
        "--نارویجین": نارویجن،
        "--odiaOriya": اوڈیا (اوریا)، //o
        "--oromo": اورومو،
        "--pashto": پشتو، //p
        "--persian": فارسی،
        "--polish": پولش،
        "--portuguese": پرتگالی،
        "--punjabi": پنجابی،
        "--quechua": Quechua, //q
        "--رومانیہ": رومانیہ، //r
        "--روسی": روسی،
        "--samoan": سامون، //s
        "-سنسکرت": سنسکرت،
        "--scotsGaelic": اسکاٹس گیلک،
        "--sepedi": Sepedi،
        "--serbian": سربیائی،
        "--sesotho": سیسوتھو،
        "--shona": شونا،
        "--sindhi": سندھی،
        "-سنہالا": سنہالا،
        "--slovak": سلوواک،
        "-slovenian": سلووینیائی،
        "--somali": صومالی،
        "-spanish": ہسپانوی،
        "--sundanese": سنڈانی،
        "--- swahili": سواحلی،
        "--swedish": سویڈش،
        "--tajik": تاجک، //t
        "--tamil": تمل،
        "--tatar": تاتار،
        "--telugu": تیلگو،
        "--thai": تھائی،
        "--tigrinya": ٹگرینیا،
        "-tsonga": سونگا،
        "--turkish": ترکی،
        "--ترکمان": ترکمان،
        "-twi": ٹوئی،
        "--ukrainian": یوکرینی، //u
        "--urdu": اردو،
        "--اویغور": ایغور،
        "--uzbek": ازبک،
        "--vietnamese": ویتنامی، //v
        "--welsh": ویلش، //w
        "--xhosa": ژوسا، //x
        "--yiddish": یدش، //y
        "--yoruba": یوروبا،
        "--zulu": زولو، //z
        },
      },

      // uyghur
      // uyghur
      uyghur: {
        translations: {
          "- خاتالىق كۆرۈلدى": خاتالىق كۆرۈلدى!, // a
           "- ئادرېس": ئادرېس ،
           "--advice": مەسلىھەت ،
           "- داۋاملاشتۇرۇش ئارقىلىق چېكىڭ": داۋاملاشتۇرۇشنى چەكسىڭىز ، Veil Brillant ھېساباتىڭىزدىن ئۈزۈلۈپ قالىسىز ، // b
           "- ئۈزۈشنى چەكسىڭىز ئۈزۈلۈپ قالىسىز": ئۈزۈشنى چەكسىڭىز ، izocash ھېساباتىڭىزدىن ئۈزۈۋېتىسىز ،
           "- مەۋھۇم نومۇرىڭىزنى تەكشۈرۈڭ ياكى كېيىن قايتا سىناڭ": مەۋھۇم نومۇرىڭىزنى تەكشۈرۈڭ ياكى كېيىن قايتا سىناڭ ، // c
           "- مەۋھۇم نومۇرىڭىزنى تەكشۈرۈڭ": مەۋھۇم نومۇرىڭىزنى تەكشۈرۈڭ ،
           "- داۋاملاشتۇرۇش": داۋاملاشتۇرۇش ،
           "- ئۇلىنىش": ئۇلىنىش ،
           «- ھەمكارلىشىش ، ئىناق ياشاش»: ھەمكارلىشىش ، باشقىلار بىلەن ئىناق ياشاش ،
           "- تاللاش تىلى": مەۋھۇم تېلېفون تىلى ،
           "- رىقابەتنىڭ ئالدىنى ئالماڭ": رىقابەتنىڭ ئالدىنى ئالماڭ ، كۆپچىلىككە پۇرسەت بېرىڭ ، // d
           "--disconnection": ئۈزۈش ،
           "- بارلىق مەۋھۇم تېلېفون ئىشلەتكۈچىلەر ئۈچۈن": بارلىق مەۋھۇم تېلېفون ئىشلەتكۈچىلەرگە VPN ، // f ئىشلىتىش تەۋسىيە قىلىنىدۇ
           "- كىرىش بېتىگە كىرىڭ": كىرىش بېتىگە كىرىڭ ، // g
           "- تارىخ": تارىخ ، // س
           "- مېنىڭ ھېساباتىم بار": مېنىڭ ئاللىبۇرۇن ھېساباتىم بار ، // i
           "- مېنىڭ ھېساباتىم يوق": مېنىڭ ھېساباتىم يوق ،
           "- ئۇ سىزنىڭ ئۆيىڭىز": ئۇ سىزنىڭ ئۆيىڭىز ،
           "- تەسۋىر / سىن +": رەسىم / سىن + ،
           "- كىملىك ​​دەلىللەش": كىملىك ​​دەلىللەش ،
           "--izocash خېرىدارلار ئېغىزى": izocash خېرىدارلار پورتى ،
           "- ھەر يىلى سالاھىيەت يېڭىلاش": ھەر يىلى كىملىك ​​يېڭىلاش ،
           "--izocash buy to": izocash Buy => izocash international,
           "--log in": كىرىڭ!, // l
           "--login": كىرىڭ ،
           "- پارقىراق پەردىگە لوگىن": Veil Brillant غا ئۇلاڭ ،
           "--login to vixinol دۇكىنى": Vixinol دۇكىنىغا ئۇلاڭ ،
           "- پەردىڭىز Brillant ھېساباتىڭىزغا ھەقسىز تارقىتىڭ": Veil Brillant ھېساباتىڭىزغا ھەقسىز كىرىپ بۇ ئىقتىدارنى زىيارەت قىلىڭ ،
           "--login مۇۋەپپەقىيىتى": كىرىش مۇۋەپپەقىيەتلىك!,
           "--login now": ھازىر كىرىڭ!,
           "--logout مۇۋەپپەقىيىتى": كىرىش مۇۋەپپەقىيەتلىك بولدى!,
           "--log out": Logout,
           "--logout": چېكىنىش ،
           "- سان": سان ، // n
           "--name": ئىسىم ،
           "--now log": ھازىر ، كىرىڭ!,
           "- رىقابەتنى بوغۇشنى چەكلىمەيدۇ":
           "- ھەسەتخورلۇق ، ئۆچمەنلىك يوق": ھەسەتخورلۇق ، ئۆچمەنلىك ، بۆلۈنۈش يوق ،
           "--no": ياق ،
           "- مەۋھۇم تېلېفونىڭىزنى زىيارەت قىلىدىغان رەسمىي ئادرېس": مەۋھۇم تېلېفونىڭىزنى زىيارەت قىلىدىغان رەسمىي ئادرېس ، // o
           "--password": پارول ، // ب
           "- نۇقتا چېكىنىش izocash": چېكىنىش نۇقتىلىرى izocash,
           "- نومۇر چېكىنىش": نومۇر ئېلىش ،
           "- ياخشىراق ، vpn نى ئىشلىتىڭ": ئەڭ ياخشىسى تور مۇلازىمىتى تەمىنلىگۈچىگە تەۋە بولمىغان VPN نى ئىشلىتىڭ ،
           "- قەيسەرلىك ھەمىشە پايدا بېرىدۇ": قەيسەرلىك ھەمىشە ئاخىرىدا پايدا بېرىدۇ ،
           "--rule": قائىدە ، // ر
           "- تەۋسىيە": تەۋسىيە ،
           "- تىزىملاش": تىزىملىتىش ،
           "- ئېسىل پەردىگە ئىمزا قويۇش": Veil Brillant غا تىزىملىتىڭ ، // s
           "- vixinol دۇكىنىغا ئىمزا قويۇش": Vixinol دۇكىنىغا تىزىملىتىڭ ،
           "--signup": تىزىملىتىڭ ،
           "- ئىمزا مۇۋەپپەقىيەت": تىزىملاش مۇۋەپپەقىيەتلىك!,
           "- ھەقسىز تىزىملىتىش": ھەقسىز تىزىملىتىڭ ،
           «- ئىمزا مۇۋەپپەقىيەت IA»: ئۇلىنىش مۇۋەپپەقىيەتلىك »،
           "--settings": "تەڭشەك",
           "- alrani دېتالىنى تەڭشەش": Alrani قوللىنىشچان پروگراممىسىنى تەڭشەش ،
           "- izocash دېتالىنى تەڭشەش": izocash قوللىنىشچان پروگراممىسىنى تەڭشەش ،
           "- vixinol دېتالىنى تەڭشەش": Vixinol قوللىنىشچان پروگراممىسىنى تەڭشەش ،
           "- پەردە Brillant دېتالىنى تەڭشەش": پەردە پارقىراق پروگراممىسىنى تەڭشەش ،
           "- رەسىم ، سىنلارنى ساقلاش": رەسىم ، سىن ۋە باشقا بىر قانچە ئېلېمېنتلارنى ساقلاش ،
           "- كۈتۈۋېلىش سۈرئىتى": سانلىق مەلۇمات مەركىزىنىڭ سانلىق مەلۇماتلىرىنى قوبۇل قىلىش سۈرئىتى ،
           "- سۈرئەت": سۈرئەت ،
           "- ئاخىرلاشتۇرۇڭ": ئاخىرلاشتۇرۇڭ ، // ت
           "- vpn سىزنىڭ زىيارەت قىلىشىڭىزغا يول قويىدۇ": VPN تور مۇلازىمىتى تەمىنلىگۈچىڭىز قارا تىزىملىككە كىرگەن تور بېكەت ياكى پروگراممىنى زىيارەت قىلالايسىز.
           "- ئەڭ چوڭ دەرەخ ئۈستىدە": ئەڭ چوڭ دەرەخ ھەممىدىن ئاددىي ئاددىي ئۇرۇقنىڭ ئۈستىدە ئىدى ،
           "- ئېكرانغا تېگىش": ئېكراننى چېكىپ داۋاملاشتۇرۇش ،
           "- قايتا سىناڭ": قايتا سىناڭ!,
           "- ئىشلەتكۈچى ئىسمى": ئىشلەتكۈچى ئىسمى ، // u

           "- مەۋھۇم نومۇر": مەۋھۇم نومۇر ، // v
           "- مەۋھۇم تېلېفون تەڭشىكى": مەۋھۇم تېلېفون تەڭشىكى ،
           "- مەۋھۇم تېلېفون تىلى قوللىنىلىدۇ": مەۋھۇم تېلېفون تىلى قوللىنىشچان پروگراممىدا سۈكۈتتىكى ھالەتتە قوللىنىلىدۇ ،
           "- مەۋھۇم تېلېفون": مەۋھۇم تېلېفون ،
           "- ئىناۋەتسىز": ئىناۋەتلىك ،
           "- izocash خېرىدارلار تور بېتىگە كەلگەنلىكىڭىزنى قارشى ئالىمىز": izocash خېرىدارلار تور بېتىگە كەلگەنلىكىڭىزنى قارشى ئالىمىز ، // w
           "- دەرىجىدىن تاشقىرى كود يېزىڭ": دەرىجىدىن تاشقىرى كود كىرگۈزۈڭ ،
           "- قارشى ئالىمىز": خۇش كەپسىز ،
           "- كىشىلەرنىڭ دىققىتى نەگە بارىدۇ": كىشىلەرنىڭ دىققىتى پۇل نەگە بارىدۇ ،
           "- يەڭگۈچىلەر قەيسەر": يەڭگۈچىلەر قەيسەر ،
           "- ئالرانى ھېساباتىڭىزدىن چېكىنىشنى خالامسىز": ئالرانى ھېساباتىڭىزدىن چىقماقچىمۇ؟
           "- ھەئە": ھەئە ، // y

           // دۆلەت
           "- كونگو": كونگو براززاۋىل ،
           "- كامېرون": كامېرون ،
           "--drc": DRC,
           "--ivoryCoast": پىل چىشى قىرغىقى ،
           
           // تىل
        "--afrikaans": ئافرىقالىقلار ، // a
        "- ئالبانىيە": ئالبانىيە ،
        "--amharic": ئامخارىك ،
        "--arabic": ئەرەبچە ،
        "- ئەرمەنچە": ئەرمەنىستان ،
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": ئەزەربەيجان ،
        "- بامبا": بامبا ، // ب
        "- باسك": باسك ،
        "- بېلورۇسىيە": بېلورۇسىيە ،
        "--bengali": بېنگالچە ،
        "--bhojpuri": Bhojpuri,
        "- بوسنىيە": بوسنىيە تىلى ،
        "- بۇلغارىيە": بۇلغارىيە ،
        "- كاتالان": كاتالانچە ، // c
        "--cebuano": Cebuano,
        "- چىچېۋا": چىچېۋا ،
        "- جۇڭگوچە ئاددىيلاشتۇرۇلغان": خەنزۇچە (ئاددىيلاشتۇرۇلغان) ،
        "- جۇڭگوچە ئەنئەنىۋى": خەنزۇچە (ئەنئەنىۋى) ،
        "- كورسىكا": كورسىكان ،
        "--croatian": كىرودىيە ،
        "- چېخ": چېخ ،
        "--danish": دانىيەچە ، // d
        "--dhivehi": Dhivehi,
        "--dogri": دوگرى ،
        "--dutch": گوللاندىيەچە ،
        "--english": ئىنگلىزچە ، // e
        "--esperanto": Esperanto,
        "--estonian": ئېستونىيە ،
        "--ewe": Ewe,
        "- فىلىپىنو": فىلىپپىنلىق ، // f
        "- fininnish": فىنلاندىيەچە ،
        "- فىرانسۇزچە": فىرانسۇزچە ،
        "--frisian": فرىسيان ،
        "--galician": گالىسىيەلىك ، // g
        "- گېئورگىيان": گرۇزىيە تىلى ،
        "- گېرمان": گېرمان ،
        "--greek": گرېكچە ،
        "--guarani": گۇارانى ،
        "--gujarati": گۇجارات تىلى ،
        "--haitianCreole": ھايتى كرېئول ، // س
        "--hausa": Hausa,
        "--hawaiian": ھاۋاي ،
        "--hebrew": ئىبرانىيچە ،
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--hungarian": ۋېنگرىيە ،
        "--icelandic": ئىسلاندىيە ، // i
        "--igbo": Igbo,
        "--ilocano": ئىلوكانو ،
        "--indonesian": ھىندونېزىيە ،
        "--irish": ئىرېلاندىيە ،
        "--italian": ئىتالىيەلىك ،
        "- ياپونچە": ياپونچە ، // j
        "--javanese": Javanese,
        "- كاننادا": كاننادا ، // ك
        "--كازاخ": قازاقىستان ،
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "- كورېيە": كورېيە ،
        "--krio": Krio,
        "--kurdishKurmanji": كۇرد (كۇرمانجى) ،
        "--kurdishSorani": كۇرد (سورانى) ،
        "--kyrgyz": قىرغىزىستان ،
        "- لاۋ": لائوس ، // ل
        "--latin": لاتىنچە ،
        "--latvian": لاتۋىيە ،
        "--lingala": Lingala,
        "- لىتۋانىيە": لىتۋانىيە ،
        "--luganda": لۇگاندا ،
        "--luxembourgish": لىيۇكسېمبۇرگ ،
        "- ماكېدونىيە": ماكېدونىيە ، // م
        "--maithili": Maithili,
        "--malagasy": مالاگاسى ،
        "--malay": مالايچە ،
        "- مالايالام": مالايالام ،
        "--maltese": مالتا ،
        "--maori": Maori,
        "- مارااتى": مارااتى ،
        "--meiteilonManipuri": Meiteilon (Manipuri) ،
        "--mizo": Mizo,
        "- موڭغۇل تىلى": موڭغۇلچە ،
        "--myanmarBurmese": بېرما (بېرما) ،
        "--nepali": نېپال ، // n
        "- نورۋېگچە": نورۋېگچە ،
        "--odiaOriya": ئوديا (ئۇيغۇرچە) ، // o
        "--oromo": ئورومو ،
        "--pashto": پۇشتۇ ، // ب
        "--persian": پارسچە ،
        "--polish": پولشا ،
        "--portuguese": پورتۇگال تىلى ،
        "--punjabi": Punjabi,
        "--quechua": Quechua, // q
        "--romanian": رۇمىنىيە ، // ر
        "--russian": رۇسچە ،
        "- ساموئان": ساموئان ، // س
        "- سانسكرىت": سانسكرىت تىلى ،
        "--scotsGaelic": شوتلاندىيە گال تىلى ،
        "--sepedi": Sepedi,
        "--serbian": سېربىيە ،
        "--sesotho": سېسوتو ،
        "--shona": Shona,
        "--sindhi": سىندى ،
        "--sinhala": Sinhala,
        "- سلوۋاكىيە": سلوۋاكىيە ،
        "- سىلوۋېنىيە": سىلوۋېنىيە ،
        "- سومالى": سومالى ،
        "- ئىسپانىيە": ئىسپانچە ،
        "--sundanese": Sundanese,
        "--swahili": Swahili,
        "--swedish": شىۋىتسىيە ،
        "--تاجىك": تاجىك ، // ت
        "--tamil": تامىل تىلى ،
        "--tatar": تاتار ،
        "--telugu": تېلۇگۇ ،
        "--thai": تايلاند ،
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "- تۇركىش": تۈركچە ،
        "- تۇركمەن": تۈركمەن ،
        "--twi": Twi,
        "- ukrainian": ئۇكرائىنا ، // u
        "--urdu": ئوردۇچە ،
        "--uyghur": ئۇيغۇر ،
        "--uzbek": ئۆزبېك ،
        "--vietnamese": ۋېيتناملىق ، // v
        "--welsh": ۋېلىش ، // w
        "--xhosa": Xhosa, // x
        "--yiddish": يىددىش ، // y
        "--yoruba": يورۇبا ،
        "--zulu": زۇلۇ ، // z
        },
      },

      // uzbek
      // uzbek
      uzbek: {
        translations: {
          "--xato sodir bo'ldi": Xatolik yuz berdi!, //a
           "--address": Manzillar,
           "--maslahat": maslahat,
           "--davom etishni bosish orqali": Davom etish tugmasini bosish orqali siz Veil Brillant hisobingizdan uzilib qolasiz, //b
           "--o'chirish tugmasini bosish orqali siz uzilib qolasiz": "Ajratish" tugmasini bosish orqali siz izocash hisobingizdan uzilib qolasiz,
           "-- virtual raqamingizni tekshiring yoki keyinroq qayta urinib ko'ring": Virtual raqamingizni tekshiring yoki keyinroq qayta urinib ko'ring, //c
           "-- virtual raqamingizni tekshiring": virtual raqamingizni tekshiring,
           "--davom etish": Davom etish,
           "--connection": ulanish,
           "--hamkorlik qiling, hamjihatlikda yashang": hamkorlik qiling, boshqalar bilan hamjihatlikda yashang,
           "--tilni tanlang": Virtual telefon tili,
           "--raqobatni oldini olmaslik": Raqobatga to'sqinlik qilmang, hammaga imkoniyat bering, //d
           "--disconnection": uzilish,
           "--barcha virtual telefon foydalanuvchilari uchun": Barcha Virtual telefon foydalanuvchilari uchun VPN-dan foydalanish tavsiya etiladi, //f
           "--login sahifasiga o'ting": Kirish sahifasiga o'ting, //g
           "--tarixiy": Tarixiy, //h
           "--i have account": Menda allaqachon hisob bor, //i
           "--i don't have account": Mening hisobim yo'q,
           "--it is your home": bu sizning uyingiz,
           "--rasm / video +": Rasm / Video +,
           "--identifikatsiyani tekshirish": shaxsni tasdiqlash,
           "--izocash mijozlar portali": izocash mijozlar portali,
           "--har yili identifikatsiyani yangilash": Har yili identifikatsiyani yangilash,
           "--izocash buy to": izocash Buy => izocash xalqaro,
           "--login": Kirish!, //l
           "--login": tizimga kiring,
           "--login to veil brilliant": Veil Brillant-ga ulanish,
           "--vixinol do'koniga kirish": Vixinol do'koniga ulaning,
           "--veil Brillant hisobingizga bepul kiring": Ushbu xususiyatga kirish uchun Veil Brillant hisobingizga bepul kiring,
           "--login muvaffaqiyatli": Kirish muvaffaqiyatli!,
           "--hozir kiring": Hozir kiring!,
           "--chiqish muvaffaqiyati": Chiqish muvaffaqiyatli!,
           "--chiqish": Chiqish,
           "--logout": Chiqish,
           "--raqam": raqam, //n
           "--name": Ism,
           "--hozir tizimga kiring": Endi, tizimga kiring!,
           "--raqobatni bo'g'ishga taqiq yo'q":
           "--hasad yo'q, nafrat yo'q": Hasad yo'q, nafrat yo'q, bo'linish yo'q,
           "--yo'q": Yo'q,
           "-- virtual telefoningizga kirish uchun rasmiy manzillar": virtual telefoningizga kirish uchun rasmiy manzillar, //o
           "--password": Parol, //p
           "--balls indrawals izocash": Ballarni yechib olish izocash,
           "--ballarni yechib olish": Ballarni yechib olish,
           "--afzalroq, vpn-dan foydalaning": Afzal, internet provayderingizga tegishli bo'lmagan VPN-dan foydalaning,
           "--qat'iylik har doim o'z samarasini beradi": Qat'iylik har doim oxirida to'laydi,
           "--qoida": Qoidalar, //r
           "--recommendation": Tavsiyalar,
           "--registration": Ro'yxatdan o'tish,
           "--ro'yxatdan o'tish to veil brilliant": Veil Brillant-da ro'yxatdan o'ting, //s
           "--vixinol do'koniga ro'yxatdan o'ting": Vixinol do'konida ro'yxatdan o'ting,
           "--ro'yxatdan o'tish": Ro'yxatdan o'tish,
           "--ro'yxatdan o'tish muvaffaqiyatli": Ro'yxatdan o'tish muvaffaqiyatli!,
           "--bepul ro'yxatdan o'tish": Bepul ro'yxatdan o'ting,
           “--roʻyxatdan oʻtish muvaffaqiyati IA”: Ulanish muvaffaqiyatli”,
           "--settings": "Sozlamalar",
           "--alrani ilovasini sozlash": Alrani ilovasini sozlash,
           "--izocash ilovasini sozlash": izocash ilovasini sozlash,
           "--vixinol ilovasini sozlash": Vixinol ilovasini sozlash,
           "--veil Brillant ilovasini sozlash": Veil Brillant ilovasini sozlash,
           "--rasmlarni, videolarni saqlash": Tasvirlar, videolar va boshqa bir qancha elementlarni saqlash,
           "--qabul qilish tezligi": Datacenterdan ma'lumotlarni qabul qilish tezligi,
           "--speed": Tezlik,
           "--terminate": tugatish, //t
           "--vpn sizga kirishga imkon beradi": VPN sizga internet provayderingiz qora ro'yxatga kiritgan sayt yoki ilovaga kirish imkonini beradi,
           "--eng katta daraxt tepada edi": Eng katta daraxt, avvalambor, oddiy kichkina urug' edi,
           "--touch the screen": Davom etish uchun ekranga teging,
           "--qayta urinib ko'ring": Qayta urinib ko'ring!,
           "--username": Foydalanuvchi nomi, //u

           "--virtual raqam": Virtual raqam, //v
           "--virtual telefon sozlamalari": Virtual telefon sozlamalari,
           "--virtual telefon tili qo'llaniladi": Virtual telefon tili sukut bo'yicha dastur darajasida qo'llaniladi,
           "--virtual telefon": Virtual telefon,
           "--validate": tasdiqlash,
           "-- izocash mijozlar portaliga xush kelibsiz": izocash mijozlar portaliga xush kelibsiz, //w
           "--super kod yozing": Super kodni kiriting,
           "--xush kelibsiz": xush kelibsiz,
           "--odamlarning e'tibori qayerga ketadi": Odamlarning e'tibori qaerga ketsa, pul qaerga ketadi,
           "--g'oliblar sabr qiladilar": G'oliblar sabr qiladilar,
           "--Alrani hisobingizdan chiqmoqchimisiz": Alrani hisobingizdan chiqmoqchimisiz?,
           "--ha": Ha, //y

           // mamlakat
           "--kongo": Kongo Brazzavil,
           "--kamerun": Kamerun,
           "--drc": DRC,
           "--Ivuar qirg'og'i": Kot-d'Ivuar,

           // til
        "--afrikanlar": afrikaans, //a
        "--alban": alban,
        "--amharic": Amhar,
        "--arabcha": arabcha,
        "--arman": arman,
        "--assamese": assamcha,
        "--aymara": Aymara,
        "--ozerbayjon": ozarbayjon,
        "--bambara": Bambara, //b
        "--bask": bask,
        "--belarus": belarus,
        "--bengal": Bengal,
        "--bhojpuri": Bxojpuri,
        "--bosniyalik": bosniyacha,
        "--bolgarcha": bolgar,
        "--katalan": Katalan, //c
        "--cebuano": Sebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Xitoy (soddalashtirilgan),
        "--chineseTraditional": xitoycha (an'anaviy),
        "--korsika": Korsika,
        "--xorvat": xorvat,
        "--chex": chex,
        "--danish": Daniya, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--golland": golland,
        "--english": Ingliz, //e
        "--esperanto": esperanto,
        "--estonian": eston,
        "--ewe": Ewe,
        "--filipino": Filippin, //f
        "--fin": fin,
        "--fransuzcha": frantsuz,
        "--frizian": frizcha,
        "--galician": Galisian, //g
        "--gruzin": gruzin,
        "--german": nemis,
        "--yunoncha": yunoncha,
        "--guarani": Guarani,
        "--gujarati": gujarati,
        "--haitianCreole": Gaiti kreoli, //h
        "--hausa": Hausa,
        "--gavayi": Gavayi,
        "--ibroniy": ibroniycha,
        "--hind": hind,
        "--hmong": Hmong,
        "--venger": venger,
        "--icelandic": islandcha, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indoneziya": indoneziya,
        "--irish": irland,
        "--italian": italyancha,
        "--yaponcha": yaponcha, //j
        "--javanese": yavacha,
        "--kannada": Kannada, //k
        "--qozoq": qozoq,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarvanda,
        "--konkani": Konkani,
        "--korean": koreyscha,
        "--krio": Krio,
        "--kurdishKurmanji": kurd (kurmanji),
        "--kurdishSorani": Kurd (Sorani),
        "--qirg'iz": qirg'iz,
        "--lao": Lao, //l
        "--lotin": lotin,
        "--latviya": latvcha,
        "--lingala": lingala,
        "--litva": litvacha,
        "--luganda": Luganda,
        "--luxembourgish": Lyuksemburgcha,
        "--makedoniyalik": makedon, //m
        "--maithili": Maithili,
        "--malagasy": malagasi,
        "--malay": Malay,
        "--malayalam": malayalam,
        "--maltacha": maltacha,
        "--maori": maori,
        "--marathi": marati,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mo'g'ulcha": mo'g'ul,
        "--myanmarBirma": Myanma (Birma),
        "--nepali": Nepal, //n
        "--norwegian": norvegcha,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashtu": Pashtu, //p
        "--fors": forscha,
        "--polish": polyak,
        "--portugalcha": portugalcha,
        "--punjabi": panjob,
        "--quechua": Kechua, //q
        "--rumin": Ruminiya, //r
        "--rus": ruscha,
        "--samoan": Samoa, //s
        "--sanskrit": sanskrit,
        "--scotsGaelic": Shots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": serb,
        "--sesotho": sesoto,
        "--shona": Shona,
        "--sindhi": sindhi,
        "--sinhala": Sinhala,
        "--slovak": slovak,
        "--sloven": slovencha,
        "--somali": Somali,
        "--spanish": ispancha,
        "--sundancha": sundancha,
        "--swahili": suahili,
        "--shvedcha": shvedcha,
        "--tojik": tojik, //t
        "--tamil": Tamil,
        "--tatar": tatar,
        "--telugu": telugu,
        "--tay": tay,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--turkcha": turkcha,
        "--turkman": turkman,
        "--twi": Twi,
        "--ukraincha": ukraincha, //u
        "--urdu": urdu,
        "--uyghur": uyg'ur,
        "--uzbek": o'zbek,
        "--Vyetnam": Vetnamcha, //v
        "--welsh": Uels, //w
        "--xhosa": Xosa, //x
        "--yiddish": Yahudiy, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // vietnamese
      // vietnamese
      vietnamese: {
        translations: {
          "--đã xảy ra lỗi": Đã xảy ra lỗi!, //a
           "--address": Địa chỉ,
           "--lời khuyên": Lời khuyên,
           "--bằng cách nhấp vào tiếp tục": Bằng cách nhấp vào tiếp tục, bạn sẽ bị ngắt kết nối khỏi tài khoản Veil Brillant của mình, //b
           "--bằng cách nhấp vào ngắt kết nối, bạn sẽ bị ngắt kết nối": Bằng cách nhấp vào Ngắt kết nối, bạn sẽ bị ngắt kết nối khỏi tài khoản izocash của mình,
           "--kiểm tra số ảo của bạn hoặc thử lại sau": Kiểm tra số ảo của bạn hoặc thử lại sau, //c
           "--kiểm tra số ảo của bạn": Kiểm tra số ảo của bạn,
           "--tiếp tục": Tiếp tục,
           "--kết nối": Kết nối,
           "--hợp tác, sống hòa thuận": Hợp tác, sống hòa hợp với người khác,
           "--chọn ngôn ngữ": Ngôn ngữ điện thoại ảo,
           "--không ngăn cản cạnh tranh": Đừng ngăn cản cạnh tranh, hãy cho mọi người cơ hội, //d
           "--ngắt kết nối": Ngắt kết nối,
           "--dành cho tất cả người dùng điện thoại ảo": Đối với tất cả người dùng Điện thoại ảo, nên sử dụng VPN, //f
           "--go to login page": Tới trang đăng nhập, //g
           "--histocal": Lịch sử, //h
           "--tôi có tài khoản": Tôi đã có tài khoản rồi, //i
           "--tôi không có tài khoản": Tôi không có tài khoản,
           "--đó là nhà của bạn": đó là nhà của bạn,
           "--hình ảnh/video +": Hình ảnh/Video +,
           "--xác minh danh tính": Xác minh danh tính,
           "--izocash cổng thông tin khách hàng": Cổng thông tin khách hàng izocash,
           "--cập nhật danh tính hàng năm": Cập nhật danh tính hàng năm,
           "--izocash mua vào": izocash Mua => izocash quốc tế,
           "--log in": Đăng nhập!, //l
           "--Đăng nhập đăng nhập,
           "--đăng nhập vào mạng che mặt rực rỡ": Kết nối với Veil Brillant,
           "--đăng nhập vào cửa hàng vixinol": Kết nối với Cửa hàng Vixinol,
           "--đăng nhập miễn phí vào tài khoản Veil Brillant của bạn": Đăng nhập miễn phí vào tài khoản Veil Brillant của bạn để truy cập tính năng này,
           "--đăng nhập thành công": Đăng nhập thành công!,
           "--đăng nhập ngay": Đăng nhập ngay!,
           "--đăng xuất thành công": Đăng xuất thành công!,
           "--đăng xuất": Đăng xuất,
           "--logout": Đăng xuất,
           "--number": Số, //n
           "--tên tên,
           "--bây giờ đăng nhập": Bây giờ, Đăng nhập!,
           "--không cấm cạnh tranh ngột ngạt":
           “--không ghen tị, không hận thù”: Không ghen tị, không hận thù, không chia rẽ,
           "--không không,
           "--địa chỉ chính thức để truy cập vào điện thoại ảo của bạn": Địa chỉ chính thức để truy cập vào điện thoại ảo của bạn, //o
           "--password": Mật khẩu, //p
           "--rút điểm izocash": Rút điểm izocash,
           "--rút điểm": Rút điểm,
           "--tốt nhất là sử dụng vpn": Tốt nhất là sử dụng VPN không thuộc về nhà cung cấp dịch vụ internet của bạn,
           "--sự kiên trì luôn mang lại kết quả": Sự kiên trì cuối cùng luôn mang lại kết quả,
           "--rule": Quy tắc, //r
           "--recommendation": Khuyến nghị,
           "--đăng ký": Đăng ký,
           "--đăng ký để che mặt rực rỡ": Đăng ký trên Veil Brillant, //s
           "--đăng ký cửa hàng vixinol": Đăng ký trên Cửa hàng Vixinol,
           "--signup": Đăng ký,
           "--đăng ký thành công": Đăng ký thành công!,
           "--đăng ký miễn phí": Đăng ký miễn phí,
           “--đăng ký thành công IA”: Kết nối thành công”,
           "--settings": "Cài đặt",
           "--thiết lập ứng dụng Alrani": Định cấu hình ứng dụng Alrani,
           "--thiết lập ứng dụng izocash": Định cấu hình ứng dụng izocash,
           "--thiết lập ứng dụng vixinol": Định cấu hình ứng dụng Vixinol,
           "--thiết lập ứng dụng Veil Brillant": Định cấu hình ứng dụng Veil Brillant,
           "--lưu trữ hình ảnh, video": Lưu trữ hình ảnh, video và một số thành phần khác,
           "--tốc độ tiếp nhận": Tốc độ tiếp nhận dữ liệu từ Datacenter,
           "--tốc độ": Tốc độ,
           "--terminate": Chấm dứt, //t
           "--vpn cho phép bạn truy cập": VPN cho phép bạn truy cập một trang web hoặc ứng dụng mà nhà cung cấp dịch vụ internet của bạn đã đưa vào danh sách đen,
           "--cái cây lớn nhất ở trên": Cái cây lớn nhất trên hết chỉ là một hạt giống nhỏ đơn giản,
           "--chạm vào màn hình": Chạm vào màn hình để tiếp tục,
           "--thử lại": Thử lại!,
           "--username": Tên người dùng, //u

           "--số ảo": Số ảo, //v
           "--cài đặt điện thoại ảo": Cài đặt điện thoại ảo,
           "--ngôn ngữ Điện thoại ảo được áp dụng": Ngôn ngữ Điện thoại ảo được áp dụng ở cấp ứng dụng theo mặc định,
           "--điện thoại ảo": Điện thoại ảo,
           "--xác thực": Xác thực,
           "--chào mừng đến với cổng thông tin khách hàng izocash": Chào mừng đến với Cổng thông tin khách hàng izocash, //w
           "--viết mã siêu": Nhập mã Siêu,
           "--chào mừng đến": Chào mừng đến với,
           "--nơi mọi người chú ý đến": Tiền bạc đi đến đâu sự chú ý của mọi người,
           "--người chiến thắng kiên trì": Người chiến thắng kiên trì,
           "--bạn có muốn đăng xuất khỏi tài khoản Alrani của mình không": Bạn có muốn đăng xuất khỏi tài khoản Alrani của mình không?,
           "--có": Có, //y

           // quốc gia
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Bờ Biển Ngà,

           // ngôn ngữ
        "--tiếng Nam Phi": Tiếng Afrikaans, //a
        "--tiếng Albania": tiếng Albania,
        "--amharic": Tiếng Amharic,
        "--tiếng Ả Rập": tiếng Ả Rập,
        "--tiếng Armenia": tiếng Armenia,
        "--assamese": Tiếng Assam,
        "--aymara": Aymara,
        "--azerbaijani": Tiếng Azerbaijan,
        "--bambara": Bambara, //b
        "--basque": tiếng Basque,
        "--Belarusian": Tiếng Belarus,
        "--bengali": Tiếng Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnian": tiếng Bosnia,
        "--tiếng Bungari": tiếng Bungari,
        "--catalan": tiếng Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseGiản thể": Tiếng Trung (Giản thể),
        "--chineseTruyền thống": Tiếng Trung (Phồn thể),
        "--corsican": tiếng Corsican,
        "--croatian": tiếng Croatia,
        "--séc": tiếng Séc,
        "--danish": tiếng Đan Mạch, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--tiếng Hà Lan": tiếng Hà Lan,
        "--english": Tiếng Anh, //e
        "--esperanto": Quốc tế ngữ,
        "--tiếng Estonia": tiếng Estonia,
        "--ôi": Ối,
        "--filipino": Tiếng Philipin, //f
        "--Phần Lan": Tiếng Phần Lan,
        "--tiếng Pháp": tiếng Pháp,
        "--frisian": tiếng Frisian,
        "--galician": Galicia, //g
        "--gruzia": tiếng Gruzia,
        "--tiếng Đức": tiếng Đức,
        "--Hy Lạp": tiếng Hy Lạp,
        "--guarani": Guarani,
        "--gujarati": Tiếng Gujarati,
        "--haitianCreole": Tiếng Creole Haiti, //h
        "--hausa": Tiếng Hausa,
        "--Hawaii": tiếng Hawaii,
        "--tiếng Do Thái": Tiếng Do Thái,
        "--tiếng Hin-ddi": Tiếng Hindi,
        "--hmong": Tiếng Mông,
        "--tiếng Hungary": Tiếng Hungary,
        "--icelandic": Tiếng Iceland, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesia": tiếng Indonesia,
        "--irish": Ailen,
        "--tiếng Ý": tiếng Ý,
        "--japanese": Tiếng Nhật, //j
        "--javanese": tiếng Java,
        "--kannada": Tiếng Kannada, //k
        "--kazakh": Tiếng Kazakhstan,
        "--khmer": Tiếng Khmer,
        "--kinyarwanda": Tiếng Kinyarwanda,
        "--konkani": Konkani,
        "--Hàn Quốc": Tiếng Hàn,
        "--krio": Krio,
        "--kurdishKurmanji": Tiếng Kurd (Kurmanji),
        "--kurdishSorani": Tiếng Kurd (Sorani),
        "--kyrgyz": Tiếng Kyrgyz,
        "--lao": Tiếng Lào, //l
        "--latin": tiếng Latinh,
        "--latvian": tiếng Latvia,
        "--lingala": Lingala,
        "--tiếng Litva": tiếng Litva,
        "--luganda": Luganda,
        "--Luxembourgish": Tiếng Luxembourg,
        "--macedonian": Tiếng Macedonia, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Mã Lai,
        "--malayalam": tiếng Malayalam,
        "--maltese": tiếng Malta,
        "--maori": Tiếng Maori,
        "--marathi": Tiếng Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": tiếng Mông Cổ,
        "--myanmarBurmese": Myanmar (tiếng Miến Điện),
        "--nepali": Tiếng Nepal, //n
        "--Na Uy": tiếng Na Uy,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Tiếng Pa-tô, //p
        "--tiếng Ba Tư": tiếng Ba Tư,
        "--đánh bóng": tiếng Ba Lan,
        "--tiếng Bồ Đào Nha": tiếng Bồ Đào Nha,
        "--punjabi": Tiếng Punjab,
        "--quechua": Quechua, //q
        "--romanian": Rumani, //r
        "--tiếng Nga": tiếng Nga,
        "--samoan": Tiếng Samoa, //s
        "--tiếng Phạn": Tiếng Phạn,
        "--scotsGaelic": Tiếng Gaelic Scots,
        "--sepedi": Sepedi,
        "--serbia": tiếng Serbia,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": tiếng Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Tiếng Slovak,
        "--tiếng Slovenia": Tiếng Slovenia,
        "--somali": Somali,
        "--tiếng Tây Ban Nha": tiếng Tây Ban Nha,
        "--tiếng Sundan": tiếng Sundan,
        "--swahili": Tiếng Swahili,
        "--tiếng Thụy Điển": tiếng Thụy Điển,
        "--tajik": Tiếng Tajik, //t
        "--tamil": Tiếng Tamil,
        "--tatar": Tatar,
        "--telugu": Tiếng Telugu,
        "--thai": Tiếng Thái,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "--tiếng Thổ Nhĩ Kỳ": tiếng Thổ Nhĩ Kỳ,
        "--turkmen": Người Thổ Nhĩ Kỳ,
        "--twi": Twi,
        "--tiếng Ukraina": Tiếng Ukraina, //u
        "--urdu": Tiếng Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Tiếng Uzbek,
        "--tiếng việt": Tiếng Việt, //v
        "--welsh": Tiếng Wales, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Tiếng Yiddish, //y
        "--yoruba": Tiếng Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // welsh
      // welsh
      welsh: {
        translations: {
          " --an error has occurred" : " Mae gwall wedi digwydd !, //a
           "--cyfeiriad": Cyfeiriadau,
           "--cyngor": Cyngor,
           "--by clicking on continue": Trwy glicio ar parhau byddwch yn cael eich datgysylltu o'ch cyfrif Veil Brillant, //b
           "--trwy glicio ar datgysylltu byddwch yn cael eich datgysylltu": Trwy glicio ar Datgysylltu byddwch yn cael eich datgysylltu o'ch cyfrif izocash,
           " --check your virtual number or try again later " : " Gwiriwch eich rhith-rif neu ceisiwch eto'n hwyrach, //c
           "--check your virtual number": Gwiriwch eich rhith-rif,
           "--continue": Parhau,
           "--connection": Cysylltiad,
           "--cydweithio, byw mewn cytgord": Cydweithio, byw mewn cytgord ag eraill,
           "--choose language": Iaith Ffôn Rhithwir,
           "--peidiwch ag atal cystadleuaeth": Peidiwch ag atal cystadleuaeth, rhowch gyfle i bawb, //d
           "--datgysylltu": Datgysylltu,
           "--ar gyfer pob defnyddiwr ffôn rhithwir": Ar gyfer pob defnyddiwr Ffôn Rhithwir, argymhellir defnyddio VPN, //f
           " --go to login page " : " Ewch i'r dudalen mewngofnodi, //g
           "--hanesyddol": Hanesyddol, //h
           "--i have account": Mae gennyf gyfrif yn barod, //i
           "--nid oes gennyf gyfrif": Nid oes gennyf gyfrif,
           "--dy ty di ydyw": dy dŷ di ydyw,
           "--delwedd / fideo +": Delwedd / Fideo +,
           "--identity verification": Gwirio hunaniaeth,
           "--izocash porth cwsmeriaid": Porth Cwsmeriaid izocash,
           "--diweddariad hunaniaeth bob blwyddyn": Diweddariad hunaniaeth bob blwyddyn,
           "--izocash prynu i": izocash Prynu => izocash rhyngwladol,
           " --log in ": Mewngofnodwch!, //l
           "--login": Mewngofnodi,
           "--login to veil brilliant": Cysylltu â Veil Brillant,
           "--login to vixinol store": Cysylltu â Vixinol Store,
           "--login for free to your veil Brillant account": Mewngofnodwch am ddim i'ch cyfrif Veil Brillant i gael mynediad i'r nodwedd hon,
           "--login success": Mewngofnodi'n llwyddiannus!,
           " --login now ": Mewngofnodwch nawr!,
           " --logout success ": Allgofnodi yn llwyddiannus!,
           "--log out": Allgofnodi,
           "--logout": Allgofnodi,
           "--number": Rhif, //n
           "--name": Enw,
           "--now log in": Nawr, Mewngofnodi!,
           "--dim gwaharddiad ar fygu cystadleuaeth":
           "--dim cenfigen, dim casineb": Dim cenfigen, dim casineb, dim rhaniadau,
           "--na": Na,
           "--cyfeiriadau swyddogol i gael mynediad i'ch ffôn rhithwir": Cyfeiriadau swyddogol i gael mynediad i'ch ffôn rhithwir, //o
           "--password": Cyfrinair, //p
           "--points pulls izocash": Tynnu pwyntiau izocash,
           "--points tynnu'n ôl": Tynnu Pwyntiau'n ôl,
           "--yn ddelfrydol, defnyddiwch vpn": Yn ddelfrydol, defnyddiwch VPN nad yw'n perthyn i'ch darparwr gwasanaeth rhyngrwyd,
           "--mae dyfalbarhad bob amser yn talu ar ei ganfed": Mae dyfalbarhad bob amser yn talu ar ei ganfed yn y diwedd,
           "--rule": Rheolau, //r
           "--argymhelliad": Argymhellion,
           "--cofrestru": Cofrestru,
           "--signup to veil brilliant": Cofrestrwch ar Veil Brillant, //s
           "--signup i siop vixinol": Cofrestru ar Vixinol Store,
           "--signup": Cofrestru,
           "--signup success": Cofrestru yn llwyddiannus!,
           "--cofrestru am ddim": Cofrestrwch am ddim,
           “--llwyddiant cofrestru IA”: Cysylltiad yn llwyddiannus”,
           "--settings" : "Gosodiadau",
           "--sefydlu'r ap alrani": Ffurfweddu cymhwysiad Alrani,
           "--sefydlu'r ap izocash": Ffurfweddu'r rhaglen izocash,
           "--sefydlu'r ap vixinol": Ffurfweddu'r cymhwysiad Vixinol,
           "--sefydlu'r app Brillant gorchudd": Ffurfweddu'r cymhwysiad Veil Brillant,
           "--storio delweddau, fideos": Storio delweddau, fideos a sawl elfen arall,
           "--speed of receive": Cyflymder derbyn data o'r Datacenter,
           "--speed": Cyflymder,
           "--terminate": Terfynu, //t
           "--the vpn yn caniatáu ichi gael mynediad": Mae'r VPN yn caniatáu ichi gael mynediad i wefan neu raglen y mae eich darparwr gwasanaeth rhyngrwyd wedi'i rhoi ar restr ddu,
           "--y goeden fwyaf oedd uwch ben": Yn anad dim, hedyn bach syml oedd y goeden fwyaf,
           "--touch the screen": Cyffyrddwch â'r sgrin i barhau,
           "--try again": Ceisiwch eto!,
           " --username ": Enw defnyddiwr, //u

           "--rhith-rhif": Rhif rhithwir, //v
           "--gosodiadau ffôn rhithwir": Gosodiadau ffôn rhithwir,
           "--iaith Ffôn rithwir yn cael ei chymhwyso": Mae'r iaith Ffôn Rhithwir yn cael ei chymhwyso ar lefel y cymhwysiad yn ddiofyn,
           "--ffôn rhithwir": Ffôn rhithwir,
           "--validate": Dilysu,
           "--croeso i borth cwsmeriaid izocash": Croeso i Borth Cwsmeriaid izocash, //w
           "--write a super code": Rhowch god Super,
           "--croeso i": Croeso i,
           "--ble mae sylw pobl yn mynd": I ble mae sylw pobl yn mynd mae arian yn mynd,
           "--enillwyr dyfalbarhau": Mae'r enillwyr yn dyfalbarhau,
           "-- hoffech chi allgofnodi o'ch cyfrif Alrani": Ydych chi am allgofnodi o'ch cyfrif Alrani?,
           "--yes": Ydw, //y

           // gwlad
           "--congo": Congo Brazzaville,
           "--camerŵn": Camerŵn,
           "--drc": DRC,
           "--iforCoast": Ivory Coast,

           // langue
        "-- albanian": Affricaneg, //a
        "--Albaneg": Albaneg,
        "--amharic": Amhareg,
        "--arabig": Arabeg,
        "--armenian": Armeneg,
        "--asamese": Asameg,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijani,
        "--bambara": Bambara, //b
        "--basg": Basgeg,
        "--belarwseg": Belarwseg,
        "--bengali": Bengaleg,
        "--bhojpuri": Bhojpuri,
        "--bosnian": Bosnieg,
        "--bwlgareg": Bwlgareg,
        "--catalan": Catalaneg, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Tsieinëeg (Syml),
        "--ChineseTraditional": Tsieinëeg (Traddodiadol),
        "--corseg": Corseg,
        "-- croatian": Croateg,
        "--tsiec": Tsiec,
        "--danish": Daneg, //d
        "--dhivehi": Difehi,
        "--dogri": Dogri,
        "--Iseldireg": Iseldireg,
        "--english": Saesneg, //e
        "--esperanto": Esperanto,
        "--estonian": Estoneg,
        "--ewe": mamog,
        "--filipino": Ffilipinaidd, //f
        "-- finnish": Ffinneg,
        "--frangeg": Ffrangeg,
        "--frisian": Ffriseg,
        "--galisaidd": Galiseg, //g
        "--georgian": Sioraidd,
        "--Almaeneg": Almaeneg,
        "--greek": Groeg,
        "--gwarani": Gwarani,
        "--gwjarati": Gwjarati,
        "--haitianCreole": Creol Haiti, //h
        "--hausa": Hawsa,
        "--hawaiian": Hawäieg,
        "--Hebraeg": Hebraeg,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "-- Hwngari": Hwngari,
        "--landic": Gwlad yr Iâ, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "-- indonesian": Indoneseg,
        "--irish": Gwyddeleg,
        "-- Eidaleg": Eidaleg,
        "--japanese": Japaneaidd, //j
        "--javanese": Jafana,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--Corea": Corëeg,
        "--krio": Krio,
        "--cwrdishCwrmanji": Cwrdeg (Cwrdaidd),
        "--cwrdaiddSorani": Cwrdeg (Sorani),
        "--kyrgyz": Cirgis,
        "--lao": Lao, //l
        "--latin": Lladin,
        "--Latfieg": Latfieg,
        "--lingala": Lingala,
        "--lithuanian": Lithwaneg,
        "--luganda": Luganda,
        "--lwcsembwrgaidd": Lwcsembwrgaidd,
        "--macedonian": Macedoneg, //m
        "--maithili": Maithili,
        "--malagasi": Malagasi,
        "--malay": Maleieg,
        "--malayalam": Malayalam,
        "--maltese": Malteg,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolaidd": Mongoleg,
        "--myanmarBurmese": Myanmar (Burmaneg),
        "--nepali": Nepali, //n
        "--norwegian": Norwy,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--persian": Perseg,
        "--polish": Pwyleg,
        "-- portuguese": Portiwgaleg,
        "--pwnjabi": Pwnjabi,
        "--quechua": Cetshwa, //q
        "--romanian": Rwmaneg, //r
        "--rwsieg": Rwsieg,
        "--samoan": Samoan, //s
        "--sansgrit": Sansgrit,
        "--scotsGaelic": Gaeleg yr Alban,
        "--sepedi": Sepedi,
        "--serbian": Serbeg,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slofac": Slofaceg,
        "--slofeneg": Slofeneg,
        "--somali": Somalïaidd,
        "--spanish": Sbaeneg,
        "--sundanese": Sundaneg,
        "--swahili": Swahili,
        "--swedish": Swedeg,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinia,
        "--tsonga": Tsonga,
        "--tyrcaidd": Twrceg,
        "--turkmen": Tyrcmeneg,
        "--twi": Twi,
        "--ukrainian": Wcreineg, //u
        "--urdu": Wrdw,
        "--uyghur": Uyghur,
        "--uzbek": Wsbeceg,
        "--vietnamese": Fietnameg, //v
        "--welsh": Cymraeg, //w
        "--xhosa": Xhosa, //x
        "--iddish": Iddew-Almaeneg, //y
        "--iorwba": Iorwba,
        "--zulu": Swlw, //z
        },
      },

      // xhosa
      // xhosa
      xhosa: {
        translations: {
          "--impazamo yenzekile": Kwenzeke impazamo!, //a
          "--idilesi": Iidilesi,
          "--ingcebiso": Ingcebiso,
          "--ngokucofa ku qhubeka": Ngokucofa ku qhubeka uya kukhutshwa kwiakhawunti yakho yeVeil Brillant, //b
          "--ngokucofa ku- disconnect uya kukhutshwa": Ngokucofa ku-Disconnect uya kukhutshwa kwi-akhawunti yakho izocash,
          "--jonga inombolo yakho yenyani okanye uzame kwakhona kamva": Jonga inombolo yakho yenyani okanye uzame kwakhona kamva, //c
          "--jonga inombolo yakho yenyani": Jonga inombolo yakho yenyani,
          "--qhubeka": Qhubeka,
          "--uqhagamshelwano": Uqhagamshelwano,
          "--sebenzisana, phila ngemvisiswano": Sebenzisana, phila ngemvisiswano nabanye,
          "--khetha ulwimi": Ulwimi lwefowuni olubonakalayo,
          "--musa ukuthintela ukhuphiswano": Musa ukuthintela ukhuphiswano, nika wonke umntu ithuba, //d
          "--uqhawulo": Uqhawulo,
          "- kubo bonke abasebenzisi befowuni yenyani": Kubo bonke abasebenzisi beFowuni yeVirtual, kuyacetyiswa ukuba usebenzise iVPN, //f
          "--yiya kwiphepha lokungena": Yiya kwiphepha lokungena, //g
          "--zembali": Ezembali, //h
          "--ndinayo i-akhawunti": Sendinayo i-akhawunti, //i
          "--Andinayo iakhawunti": Andinayo iakhawunti,
          "- yindlu yakho": yindlu yakho,
          "--umfanekiso / ividiyo +": Umfanekiso / Ividiyo +,
          "--ukuqinisekiswa kwesazisi": Ukuqinisekiswa kwesazisi,
          "--izocash umthengi portal": izocash Customer Portal,
          "--uhlaziyo lwesazisi rhoqo ngonyaka": Uhlaziyo lwesazisi rhoqo ngonyaka,
          "--izocash thenga ku": izocash Thenga => izocash international,
          "--ngena": Ngena!, //l
          "--ngena": Ngena,
          "--ngena kwikhuselo eliqaqambileyo": Qhagamshela kwiVeil Brillant,
          "--ngena kwivenkile yevixinol": Qhagamshela kwiVenkile yeVixinol,
          "--ngena simahla kwiakhawunti yakho yeVeil Brillant": Ngena simahla kwiakhawunti yakho yeVeil Brillant ukufikelela kweli nqaku,
          "--login impumelelo": Ngena ngempumelelo!,
          "--ngena ngoku": Ngena ngoku!,
          "--Phuma ngempumelelo": Phuma kuphumelele!,
          "--Phuma": Phuma,
          "--phuma": Phuma,
          "--inombolo": Inani, //n
          "--igama": Igama,
          "--ngena ngoku": Ngoku, Ngena!,
          "--akukho sithintelo kukhuphiswano lokuthintela":
          "-akukho mona, akukho ntiyo": Akukhomona, akukho ntiyo, akukho kwahlukana,
          "--hayi hayi,
          "- iidilesi ezisemthethweni zokufikelela kwifowuni yakho yenyani": Iidilesi ezisemthethweni zokufikelela kwifowuni yakho, //o
          "--igama lokugqitha": Igama lokugqithisa, //p
          "- iingongoma zokurhoxiswa izocash": Amanqaku Ukurhoxiswa izocash,
          "- amanqaku okurhoxiswa": Ukurhoxiswa kwamanqaku,
          "- kukhethwa, sebenzisa i-vpn": Ngokukhethekileyo, sebenzisa i-VPN engeyiyo yomboneleli wakho wenkonzo ye-intanethi,
          "--ukunyamezela kuhlala kuhlawula": Ukuzingisa kuhlala kuhlawula ekugqibeleni,
          "--umthetho": Imithetho, //r
          "--ingcebiso": Iingcebiso,
          "--registration": Ubhaliso,
          "--bhalisa kwikhuselo eliqaqambileyo": Bhalisa kwiVeil Brillant, //s
          "--bhalisa kwivenkile ye-vixinol": Bhalisa kwiVenkile yeVixinol,
          "--bhalisa": Bhalisa,
          "--signup success": Ubhaliso luphumelele!,
          "--bhalisa simahla": Bhalisa simahla,
          “--signup impumelelo IA”: Uqhagamshelo luphumelele”,
          "--settings": "Iisetingi",
          "- ukuseta i-alrani app": Ukuqwalasela usetyenziso lwe-Alrani,
          "--setting up izocash app": Ukuqwalasela isicelo izocash,
          "--seta i-vixinol app": Ukuqwalasela isicelo seVixinol,
          "--ukuseta i-veil Brillant app": Ukuqwalasela isicelo seVeil Brillant,
          "- ukugcinwa kwemifanekiso, iividiyo": Ukugcinwa kwemifanekiso, iividiyo kunye nezinye izinto ezininzi,
          "- isantya sokwamkelwa": Isantya sokufumana idatha evela kwiDatacenter,
          "--isantya": Isantya,
          "--phelisa": Cima, //t
          "- i-vpn ikuvumela ukuba ufikelele": I-VPN ikuvumela ukuba ufikelele kwindawo okanye usetyenziso olufakwe kuluhlu olumnyama lomnikezeli wakho wenkonzo ye-intanethi,
          "--owona mthi mkhulu wawungaphezulu": Owona mthi mkhulu wawungaphezu kwayo yonke imbewu encinci,
          "--chukumisa isikrini": Chukumisa isikrini ukuze uqhubeke,
          "--try again": Zama kwakhona!,
          "--igama lomsebenzisi": Igama lomsebenzisi, //u

          "--virtual number": Inombolo ebonakalayo, //v
           "--useto lwefowuni oluyinyani": Useto lwefowuni ebonakalayo,
           "--Ulwimi lwefowuni olubonakalayo luyasetyenziswa": Ulwimi lweFowuni yeVirtual lusetyenziswa kwinqanaba lesicelo ngokungagqibekanga,
           "--ifowuni ebonakalayo": Ifowuni ebonakalayo,
           "--qinisekisa": Qinisekisa,
           "-- wamkelekile kwi-izocash customer portal": Wamkelekile kwi-izocash Customer Portal, //w
           "--bhala ikhowudi ephezulu": Faka ikhowudi ephezulu,
           "-- wamkelekile ku": Wamkelekile ku,
           "-- apho abantu baya khona": Apho ingqalelo yabantu ihamba khona imali,
           "--abaphumeleleyo banyamezele": Abaphumeleleyo bazingise,
           "- ungathanda ukuphuma kwiakhawunti yakho ye-Alrani": Ngaba uyafuna ukuphuma kwiakhawunti yakho ye-Alrani?,
           "--ewe": Ewe, //y

           // ilizwe
           "--congo": Congo Brazzaville,
           "-cameroon": eCameroon,
           "--drc": DRC,
           "--IvoryCoast": Ivory Coast,

           // ulwimi
        "--Afrikaans": IsiBhulu, //a
        "--isiAlbania": isiAlbania,
        "--amharic": isiAmharic,
        "--arabic": isiArabhu,
        "--armenian": isiArmenian,
        "--assamese": isiAssamese,
        "--aymara": Aymara,
        "--azerbaijani": isiAzerbaijani,
        "--bambara": Bambara, //b
        "--basque": isiBasque,
        "--Belarusian": isiBelarusian,
        "--bengali": isiBengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": isiBosnia,
        "--bulgarian": isiBulgaria,
        "--catalan": IsiCatalan, //c
        "--Cebuano": Cebuano,
        "--chichewa": isiChewa,
        "--chineseSimplified": IsiTshayina (Esenziwe Lula),
        "--chineseTraditional": isiTshayina (Sesiko),
        "--corsican": isiCorsican,
        "--croatian": isiCroatia,
        "--Czech": isiCzech,
        "--Danish": IsiDanish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--isiDatshi": isiDatshi,
        "--english": IsiNgesi, //e
        "--esperanto": Esperanto,
        "--estonian": isiEstonian,
        "--ewe": Ewe,
        "-- isifilipino": isiFilipino, //f
        "--isiFinnish": isiFinnish,
        "--isiFrentshi": isiFrentshi,
        "--frisian": isiFrisian,
        "--galician": isiGalicia, //g
        "--georgian": isiGeorgia,
        "--German": isiJamani,
        "- isiGrike": isiGrike,
        "--guarani": Guarani,
        "--gujarati": isiGujarati,
        "--haitianCreole": isiCreole saseHaiti, //h
        "--hausa": Hausa,
        "--hawaiian": isiHawaii,
        "--hebrew": isiHebhere,
        "-- isiHindi": isiHindi,
        "--hmong": Hmong,
        "--hungarian": isiHungary,
        "--isi-Icelandic": Isi-Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": isi-Indonesian,
        "--Irish": isi-Irish,
        "--italian": isiTaliyane,
        "--japanese": Japanese, //j
        "--javanese": IsiJava,
        "--kannada": IsiKannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": isiKinyarwanda,
        "--konkani": Konkani,
        "--korean": isiKorea,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdish Sorani": Kurdish (Sorani),
        "--Kyrgyz": isiKyrgyz,
        "--lao": Lao, //l
        "--latin": isiLatini,
        "--latvian": isiLatvian,
        "--lingala": Lingala,
        "--lithuanian": isiLithuanian,
        "--luganda": isiLuganda,
        "--luxembourgish": isiLuxembourgish,
        "--macedonian": Macedonian, //m
        "--maithili": Maithili,
        "--malagasy": isiMalagasy,
        "--malay": isiMalay,
        "--malayalam": isiMalayalam,
        "--maltese": Malta,
        "--maori": isiMaori,
        "--isiMarathi": IsiMarathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": isiMongolia,
        "--myanmarBurmese": isiMyanmar (isiBurmese),
        "--nepali": IsiNepali, //n
        "--isiNorway": isiNorway,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": IsiOromo,
        "--pashto": IsiPashto, //p
        "--Persian": isiPersi,
        "--Polish": isiPolish,
        "--Portuguese": IsiPhuthukezi,
        "--punjabi": isiPunjabi,
        "--quechua": IsiQuechua, //q
        "--romanian": IsiRomania, //r
        "--Russian": isiRashiya,
        "--samoan": isiSamoa, //s
        "--sanskrit": isiSanskrit,
        "--scotsGaelic": IsiScots isiGaelic,
        "--sepedi": isiPedi,
        "--serbian": isiSerbia,
        "--esotho": isiSuthu,
        "--shona": isiShona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": Slovenian,
        "--somali": IsiSomali,
        "--isipanish": iSpanish,
        "--sundanese": isiSundanese,
        "--isiswahili": isiSwahili,
        "--isiswedish": IsiSwedish,
        "--tajik": Tajik, //t
        "--tamil": isiTamil,
        "--Tatar": isiTatar,
        "--telugu": isiTelugu,
        "--Thai": IsiThai,
        "--tigrinya": isiTigrinya,
        "--tsonga": Tsonga,
        "--Turkish": IsiTurkey,
        "--Turkmen": IsiTurkmen,
        "--twi": Twi,
        "--ukrainian": IsiUkraine, //u
        "--urdu": IsiUrdu,
        "--uyghur": Uyghur,
        "--Uzbek": IsiUzbek,
        "--Vietnamese": IsiVietnamese, //v
        "--welsh": isiWelsh, //w
        "--Xhosa": isiXhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": IsiYoruba,
        "--zulu": Zulu, //z
        },
      },

      // yiddish
      // yiddish
      yiddish: {
        translations: {
          "--אַן טעות איז פארגעקומען": אַ טעות איז פארגעקומען!, // אַ
           "--אַדרעס": אַדרעסעס,
           "--עצה": עצה,
           "--דורך קליקינג אויף פאָרזעצן": דורך געבן אַ קליק אויף פאָרזעצן איר וועט זיין דיסקאַנעקטיד פון דיין וועיל בריללאַנט חשבון, //b
           "--דורך געבן אַ קליק אויף דיסקאַנעקט איר וועט זיין דיסקאַנעקטיד": דורך געבן אַ קליק אויף דיסקאַנעקט איר וועט זיין דיסקאַנעקטיד פון דיין יזאָקאַש חשבון,
           "--טשעק דיין ווירטואַל נומער אָדער פּרובירן ווידער שפּעטער": קוק דיין ווירטואַל נומער אָדער פּרובירן ווידער שפּעטער, //c
           "--טשעק דיין ווירטואַל נומער": קוק דיין ווירטואַל נומער,
           "--פאָרזעצן": פאָרזעצן,
           "--connection": קשר,
           "- מיטאַרבעטן, לעבן אין האַרמאָניע": מיטאַרבעטן, לעבן אין האַרמאָניע מיט אנדערע,
           "--טשאָאָסע שפּראַך": ווירטועל טעלעפאָן שפּראַך,
           "--טאָן ניט פאַרמייַדן פאַרמעסט": ניט פאַרהיטן פאַרמעסט, געבן אַלעמען אַ געלעגנהייַט, //ד
           "--דיסקאַנעקשאַן": דיסקאַנעקשאַן,
           "--פֿאַר אַלע ווירטואַל טעלעפאָן יוזערז": פֿאַר אַלע ווירטואַל טעלעפאָן יוזערז, עס איז רעקאַמענדיד צו נוצן אַ VPN, //f
           "--גיין צו לאָגין בלאַט": גיין צו די לאָגין בלאַט, // ג
           "--היסטאָריש": היסטאָריש, //ה
           "--איך האָבן אַ חשבון": איך האָבן שוין אַ חשבון, //איך
           "--איך טאָן ניט האָבן אַ חשבון": איך טאָן ניט האָבן אַ חשבון,
           "--עס איז דיין הויז": עס איז דיין הויז,
           "--בילד / ווידעא +": בילד / ווידעא +,
           "--identity verification": אידענטיטעט וועראַפאַקיישאַן,
           "--izocash קונה טויער": izocash קונה טויער,
           "--identity update every year": אידענטיטעט דערהייַנטיקן יעדער יאָר,
           "--izocash קויפן צו": izocash קויפן => izocash אינטערנאַציאָנאַלער,
           "--לאָג אין": קלאָץ אין!, //ל
           "--לאָגין": קלאָץ אין,
           "--לאָגין צו שלייער בריליאַנט": פאַרבינדן צו וועיל בריליאַנט,
           "--לאָגין צו וויקסינאָל קראָם": פאַרבינדן צו וויקסינאָל קראָם,
           "--לאָגין פֿאַר פריי צו דיין שלייער בריללאַנט חשבון": קלאָץ אין פריי צו דיין וועיל בריללאַנט חשבון צו אַקסעס דעם שטריך,
           "--לאָגין הצלחה": לאָגין געראָטן!,
           "--לאָגין איצט": קלאָץ אין איצט!,
           "--logout success": לאָגאָוט געראָטן!,
           "--לאָג אויס": לאָגאָ אויס,
           "--logout": קלאָץ אויס,
           "--נומער": נומער, //n
           "--נאָמען": נאָמען,
           "--now log in": איצט, קלאָץ אין!,
           "- קיין פאַרבאָט אויף דערשטיקן פאַרמעסט":
           "--קיין קנאה, קיין האַס": קיין קנאה, קיין האַס, קיין חילוק,
           "--ניין ניין,
           "--אָפיציעלע אַדרעסעס צו אַקסעס דיין ווירטואַל טעלעפאָן": באַאַמטער אַדרעסעס צו אַקסעס דיין ווירטואַל טעלעפאָן, // אָ
           "--password": פּאַראָל, //ז
           "--ווייזט ווידדראָאַלז יזאָקאַש": ווייזט ווידדראָאַלז יזאָקאַש,
           "--פּאָינט ווידדראָאַלז": ווייזט ווידדראָאַלז,
           "--פּרעפעראַבלי, נוצן אַ וופּן": פּרעפעראַבלי, נוצן אַ וופּן וואָס געהערט נישט צו דיין אינטערנעט סערוויס שפּייַזער,
           "--פּערסיסטאַנס שטענדיק פּייַס אַוועק": פּערסיסטאַנס שטענדיק פּייַס זיך אין די סוף,
           "--rule": כּללים, //r
           "--רעקאָממענדאַטיאָן": רעקאַמאַנדיישאַנז,
           "--רעגיסטראַציע": רעגיסטראַציע,
           "--סיגנופּ צו שלייער בריליאַנט": פאַרשרייַבן אויף וועיל בריליאַנט, //s
           "--סיגנופּ צו Vixinol קראָם": פאַרשרייַבן אין Vixinol Store,
           "--signup": רעגיסטרירן,
           "--signup success": רעגיסטראַציע געראָטן!,
           "--סיגנופּ פֿאַר פריי": פאַרשרייַבן פֿאַר פריי,
           "--signup success IA": פֿאַרבינדונג געראָטן",
           "--settings": "סעטטינגס",
           "--סעטטינג די אַלראַני אַפּ": קאַנפיגיער די אַלראַני אַפּלאַקיישאַן,
           "--סעטטינג די izocash אַפּ": קאַנפיגיער די izocash אַפּלאַקיישאַן,
           "--סעטטינג די Vixinol אַפּ": קאַנפיגיער די Vixinol אַפּלאַקיישאַן,
           "--סעטטינג די שלייער בריללאַנט אַפּ": קאַנפיגיער די וועיל בריללאַנט אַפּלאַקיישאַן,
           "--סטאָרידזש פון בילדער, ווידיאס": סטאָרידזש פון בילדער, ווידיאס און עטלעכע אנדערע עלעמענטן,
           "--גיכקייַט פון אָפּטראָג": די גיכקייַט פון אָפּטראָג פון דאַטן פֿון די דאַטאַסענטער,
           "--speed": גיכקייַט,
           "--terminate": פאַרענדיקן, //ט
           "- די וופּן אַלאַוז איר צו אַקסעס": די וופּן אַלאַוז איר צו אַקסעס אַ פּלאַץ אָדער אַ אַפּלאַקיישאַן אַז דיין אינטערנעט סערוויס שפּייַזער האט בלאַקליסטיד,
           "--דער גרעסטער בוים איז געווען אויבן": דער גרעסטער בוים איז געווען אויבן אַלע אַ פּשוט קליין זוימען,
           "--טאַפּן דעם עקראַן": ריר דעם עקראַן צו פאָרזעצן,
           "--טריי ווידער": פּרוּווט ווידער!,
           "--username": נאמען, //u

           "--ווירטואַל נומער": ווירטואַל נומער, //v
           "--ווירטואַל טעלעפאָן סעטטינגס": ווירטואַל טעלעפאָן סעטטינגס,
           "--ווירטואַל פאָון שפּראַך איז געווענדט": די ווירטואַל פאָון שפּראַך איז געווענדט ביי די אַפּלאַקיישאַן מדרגה דורך פעליקייַט,
           "--ווירטואַל טעלעפאָן": ווירטואַל טעלעפאָן,
           "--validate": וואַלאַדייט,
           "-- באַגריסונג צו דער izocash קונה טויער": ברוכים הבאים צו די izocash קונה טויער, //w
           "--שרייב אַ סופּער קאָד": אַרייַן אַ סופּער קאָד,
           "--welcome to": ברוכים הבאים צו,
           "--וואוהין מענטשן ס ופמערקזאַמקייַט גייט": ווו מענטשן ס ופמערקזאַמקייַט גייט געלט גייט,
           "--ווינערס פּערסאַוויר": די געווינער פּערסאַוויר,
           "-- וואָלט איר ווי צו קלאָץ אויס פון דיין Alrani חשבון": צי איר ווילן צו קלאָץ אויס פון דיין Alrani חשבון?,
           "--יאָ": יאָ, //י

           // לאַנד
           "--קאָנגאָ": קאָנגאָ בראַזזאַוויללע,
           "--cameroon": קאַמערון,
           "--drc": DRC,
           "--ivoryCoast": העלפאַנדביין קאָוסט,

           // שפּראַך
        "--afrikaans": אַפֿריקאַנס, //אַ
        "--אַלבאַניש": אַלבאַניש,
        "--אַמהאַריק": אַמהאַריש,
        "--אַראַביש": אַראַביש,
        "--אַרמעניאַן": ארמאניש,
        "--אַסאַמעסע": אַסאַמאַסע,
        "--ייַמאַראַ": ייַמאַראַ,
        "--אַזערביידזשאַניש": אַזערביידזשאַניש,
        "--באַמבאַראַ": באַמבאַראַ, //ב
        "--basque": באַסק,
        "--בעלאָרוסיש": בעלאָרוסיש,
        "--בענגאַלי": בענגאַליש,
        "--באָדזשפּורי": בהדזשפּורי,
        "--באָסניש": באָסניש,
        "--בולגאַריש": בולגאַריש,
        "--קאַטאַלאַניש": קאַטאַלאַניש, //c
        "--סעבואַנאָ": סעבואַנאָ,
        "--טשיטשעוואַ": טשיטשעוואַ,
        "--chineseSimplified": כינעזיש (סימפּליפיעד),
        "--chineseTraditional": כינעזיש (טראַדיציאָנעל),
        "--קאָרסיקאַן": קאָרסיקאַן,
        "--קראָאַטיש": קראָאַטיש,
        "--טשעטש": טשעכיש,
        "--דניש": דאַניש, //ד
        "--דיוועהי": דיוועהי,
        "--דאָגרי": דאָגרי,
        "--האָלענדיש": האָלענדיש,
        "--ענגליש": ענגליש, // ע
        "--עספּעראַנטאָ": עספּעראַנטאָ,
        "--עסטיש": עסטיש,
        "--עווע": יי,
        "--פיליפּינאָ": פיליפּינאָ, //פ
        "--פיניש": פֿיניש,
        "--פראנצויזיש": פראנצויזיש,
        "--פריסיאַן": פריזיש,
        "--גאַלישיש": גאליציאנער, //ג
        "--דזשאָרדזשיאַן": גרוזיניש,
        "--דײַטש": דײַטש,
        "--גריכיש": גריכיש,
        "--גואַראַני": גואַראַני,
        "--גודזשאַראַטי": גודזשאַראַטי,
        "--haitianCreole": Haitian Creole, //h
        "--האַוסאַ": האַוסאַ,
        "--האַוואַייאַן": האַוואַייאַן,
        "--העברעיש": העברעאיש,
        "--הינדיש": הינדיש,
        "--המאָנג": המאָנג,
        "--אונגעריש": אונגאַריש,
        "--איסלענדיש": איסלענדיש, //י
        "--יגבאָ": יגבאָ,
        "--ילאָקאַנאָ": ילאָקאַנאָ,
        "--אינדאָנעזיש": אינדאָנעזיש,
        "--איריש": איריש,
        "--italian": איטאַליעניש,
        "--יאַפּאַניש": יאַפּאַניש, //דזש
        "--javanese": דזשאַוואַניש,
        "--קאַנאַדאַ": קאַנאַדאַ, //ק
        "--קאַזאַך": קאַזאַך,
        "--כמער": כמער,
        "--קיניאַרוואַנדאַ": קיניאַרוואַנדאַ,
        "--konkani": קאָנקאַני,
        "--קאָרעאַן": קאָרעיִש,
        "--קריאָ": קריאָ,
        "--kurdishKurmanji": קורדיש (קורמאַנדזשי),
        "--kurdishSorani": קורדיש (Sorani),
        "--קירגיז": קירגיזיש,
        "--לאַאָ": לאַו, //ל
        "--לאַטייַן": לאַטייַן,
        "--לאַטוויש": לעטיש,
        "--לינגאַלאַ": לינגאַלאַ,
        "--ליטוויש": ליטוויש,
        "--לוגאַנדאַ": לוגאַנדאַ,
        "--לוקסמבורגיש": לוקסעמבאָורגיש,
        "--מאַקעדאָניש": מאַקעדאניש, //מ
        "--מאַיטהילי": מאַיטהילי,
        "--מאַלאַגאַסי": מאַלאַגאַסי,
        "--מאַלייַ": מאַלייַיש,
        "--מאַלייַאַלאַם": מאַלייַאַלאַם,
        "--מאַלטיזיש": מאַלטעזיש,
        "--מאַאָרי": מאַאָרי,
        "--מאַראַטהי": מאַראַטהי,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--מיזאָ": מיזאָ,
        "--מאָנגאָליאַן": מאָנגאָליש,
        "--מיאַנמאַר בורמעסע": מיאַנמאַר (בורמעסע),
        "--נעפּאַלי": נעפּאַליש, //n
        "--norwegian": נאָרוועגיש,
        "--אָדיאַאָרייאַ": אָדיאַ (אָרייאַ), // אָ
        "--אָראָמאָ": אָראָמאָ,
        "--פּאַשטאָ": פּאַשטאָ, //ז
        "--פּערסיש": פּערסיש,
        "--פּאָליש": פויליש,
        "--פּאָרטוגעזיש": פּאָרטוגעזיש,
        "--פּונדזשאַבי": פּונדזשאַבי,
        "--קוועטשאַ": קוועטשאַ, //ק
        "--רומעניש": רומעניש, //ר
        "--רוסיש": רוסיש,
        "--samoan": סאַמאָאַן, //s
        "--סאַנסקריט": סאַנסקריט,
        "--scotsGaelic": סקאָץ Gaelic,
        "--סעפידיע": ספעדי,
        "--סערביש": סערביש,
        "--סעסאָטאָ": סעסאָטאָ,
        "--שאָנאַ": שאָנאַ,
        "--sindhi": סינדי,
        "--סינהאַלאַ": סינהאַלאַ,
        "--סלאָוואַקיש": סלאָוואַקיש,
        "--סלאָוועניש": סלאָוועניש,
        "--סאָמאַליש": סאָמאַליש,
        "--שפּאַניש": שפּאַניש,
        "--sundanese": סונדאַנעסע,
        "--סוואַהילי": סוואַהילי,
        "--שוועדיש": שוועדיש,
        "--טאַדזשיק": טאַדזשיק, //ה
        "--טאַמיל": טאַמיל,
        "--טאַטאַר": טאַטאַר,
        "--טעלוגו": טעלוגו,
        "--טייַלענדיש": טייַלענדיש,
        "--טיגריניאַ": טיגריניאַ,
        "--צאָנגאַ": צאָנגאַ,
        "--טערקיש": טערקיש,
        "--טורקמען": טורקמען,
        "--טווי": צוויי,
        "--אוקרייניש": אוקראַיִניש, //ו
        "--urdu": אורדו,
        "--uyghur": אויגור,
        "--וזבעק": אוזבעקיש,
        "--וויעטנאַמעזיש": וויעטנאַמעזיש, //v
        "--וועלש": וועלש, //וו
        "--קסהאָסאַ": Xhosa, //קס
        "--ייִדיש": ייִדיש, //י
        "--יאָרובאַ": יאָרובאַ,
        "--זולו": זולו, //ז
        },
      },

      // yoruba
      // yoruba
      yoruba: {
        translations: {
          "--aṣiṣe kan ti ṣẹlẹ": Aṣiṣe ti ṣẹlẹ!, //a
           "--adirẹsi": adirẹsi,
           "--imọran": Imọran,
           "--nipa titẹ tẹsiwaju": Nipa tite lori tẹsiwaju iwọ yoo ge asopọ lati akọọlẹ Veil Brillant rẹ, //b
           "--nipa titẹ ge asopọ iwọ yoo ge asopọ": Nipa tite lori Ge asopọ iwọ yoo ge asopọ lati akọọlẹ izocash rẹ,
           "--ṣayẹwo nọmba foju rẹ tabi gbiyanju lẹẹkansi nigbamii": Ṣayẹwo nọmba foju rẹ tabi gbiyanju lẹẹkansi nigbamii, //c
           "--ṣayẹwo nọmba foju rẹ": Ṣayẹwo nọmba foju rẹ,
           "--tesiwaju": Tesiwaju,
           "--asopọ": Asopọmọra,
           "--pọ, gbe ni ibamu": Ṣepọ, gbe ni ibamu pẹlu awọn omiiran,
           "--yan ede": Ede Foonu Foju,
           "--maṣe ṣe idiwọ idije": Maṣe ṣe idiwọ idije, fun gbogbo eniyan ni anfani, //d
           "--disconnection": Ge asopọ,
           "- fun gbogbo awọn olumulo foonu foju": Fun gbogbo awọn olumulo Foonu Foju, a gba ọ niyanju lati lo VPN kan, //f
           "--lọ si oju-iwe wiwọle": Lọ si oju-iwe wiwọle, //g
           "-itan": Itan-akọọlẹ, //h
           "--i ni akọọlẹ": Mo ti ni akọọlẹ tẹlẹ, //i
           "--mi ko ni iroyin": Nko ni iroyin kan,
           "--ile rẹ ni": ile rẹ ni,
           "--aworan / fidio +": Aworan / Fidio +,
           "--ìdájú ìdánimọ̀": Ìjẹ́rìí ìdánimọ̀,
           "--ezocash ọna abawọle onibara": Izocash Onibara Portal,
           "--imudojuiwọn idanimọ ni gbogbo ọdun": Imudojuiwọn idanimọ ni gbogbo ọdun,
           "--izocash ra si": izocash Buy => izocash okeere,
           "--wọle": Wọle!, //l
           "--login": Wọle,
           "--buwolu wọle si ibori didan": Sopọ si Veil Brillant,
           "--buwolu wọle si ile-itaja vixinol": Sopọ si Ile-itaja Vixinol,
           "--buwolu wọle fun ọfẹ si akọọlẹ Brillant ibori rẹ": Wọle fun ọfẹ si akọọlẹ Veil Brillant rẹ lati wọle si ẹya yii,
           "--aṣeyọri wiwọle": Wọle aṣeyọri!,
           "--login now": Wọle nisin!,
           "--logout aseyori": Jade jade!,
           "--jade": Jade,
           "--logout": Jade,
           "--nọmba": Nọmba, //n
           "--orukọ": Orukọ,
           "--bayi wọle": Bayi, Wọle!,
           "--ko si idinamọ lori idije dina":
           "--ko si owú, ko si ikorira": Ko si owú, ko si ikorira, ko si iyapa;
           "--rara rara,
           "--official addresses to access your foju phone": Awọn adirẹsi osise lati wọle si foonu foju rẹ, //o
           "--ọrọigbaniwọle": Ọrọigbaniwọle, //p
           "--points withdrawals izocash": Points Withdrawals izocash,
           "--points withdrawals": Awọn ayokuro ojuami,
           "--daradara, lo vpn": Ni pataki, lo VPN ti kii ṣe ti olupese iṣẹ intanẹẹti rẹ,
           "--itẹramọti nigbagbogbo n sanwo": Ifarada nigbagbogbo n sanwo ni opin,
           "--ofin": Awọn ofin, //r
           "--iṣeduro": Awọn iṣeduro,
           "--ìforúkọsílẹ": Iforukọsilẹ,
           "- Iforukọsilẹ si ibori ti o wuyi": Forukọsilẹ lori Veil Brillant, //s
           "- Iforukọsilẹ si ile-itaja vixinol": Forukọsilẹ lori Ile-itaja Vixinol,
           "--forukọsilẹ": Forukọsilẹ,
           "--aṣeyọri iforukọsilẹ": Iforukọsilẹ ṣaṣeyọri!,
           "--iforukọsilẹ fun ọfẹ": Forukọsilẹ fun ọfẹ,
           "-Aṣeyọri Iforukọsilẹ IA": Aṣeyọri Asopọmọra",
           "--settings": "Eto",
           "--Ṣeto ohun elo alrani": Ṣiṣeto ohun elo Alrani,
           "--Ṣiṣeto ohun elo izocash": Ṣiṣeto ohun elo izocash,
           "--Ṣiṣeto ohun elo vixinol": Ṣiṣeto ohun elo Vixinol,
           "--ṣeto ohun elo ibori Brillant soke": Ṣiṣeto ohun elo Veil Brillant,
           "--ipamọ awọn aworan, awọn fidio": Ibi ipamọ awọn aworan, awọn fidio ati ọpọlọpọ awọn eroja miiran,
           "--iyara gbigba": Iyara gbigba data lati ibi-ipamọ data,
           "--iyara": Iyara,
           "--terminate": Pari, //t
           "--vpn gba ọ laaye lati wọle si": VPN ngbanilaaye lati wọle si aaye kan tabi ohun elo kan ti olupese iṣẹ intanẹẹti rẹ ti sọ di dudu,
           "--igi ti o tobi julọ wa loke": Igi ti o tobi julọ ju gbogbo irugbin kekere kan lọ,
           "--fọwọkan iboju": Fọwọkan iboju lati tẹsiwaju,
           "--gbiyanju lẹẹkansi": Gbiyanju lẹẹkansi!,
           "--orukọ olumulo": Orukọ olumulo, //u

           "--nọmba foju": Nọmba foju, //v
           "--virtual phone settings": Eto foonu foju,
           "--Foonu Èdè fojuhan ni a lo": Ede Foonu Foju jẹ lilo ni ipele ohun elo nipasẹ aiyipada,
           "--foju foonu": Foonu foju,
           "--validate": Ifọwọsi,
           "-- kaabọ si ẹnu-ọna onibara izocash": Kaabo si Portal Onibara izocash, //w
           "--kọ koodu nla kan": Tẹ koodu Super kan sii,
           "--e kaabo si": Kaabo si,
           "- ibi ti awọn eniyan ká akiyesi lọ": Ibi ti akiyesi eniyan lọ owo lọ,
           "--aṣegun persevere": Awọn olubori foriti,
           "-- ṣe o fẹ lati jade kuro ni akọọlẹ Alrani rẹ": Ṣe o fẹ lati jade kuro ni akọọlẹ Alrani rẹ?,
           "--bẹẹni": Bẹẹni, //y

           // orilẹ-ede
           "--congo": Congo Brazzaville,
           "--cameroon": Cameroon,
           "--drc": DRC,
           "-EvoryCoast": Ivory Coast,

           // ede
        "--afrikaans": Afrikaans, //a
        "--albanian": Albania,
        "--amharic": Amharic,
        "--arabic": Arabic,
        "--Armenian": Armenian,
        "--assamese": Assamese,
        "--aymara": Aymara,
        "--azerbaijani": Azerbaijan,
        "--bambara": Bambara, //b
        "--basque": Basque,
        "--belarusian": Belarusian,
        "--bengali": Ede Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": Bosnia,
        "--bulgarian": Bulgarian,
        "--catalan": Catalan, //c
        "--cebuano": Cebuano,
        "--chichewa": Chichewa,
        "--chineseSimplified": Ṣaina (Irọrọrun),
        "--chineseTraditional": Ṣaina (Ibile),
        "--korsican": Corsican,
        "--Kroatian": Croatian,
        "--Czech": Czech,
        "-- Danish": Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Dutch": Dutch,
        "--Yoruba": English, //e
        "--esperanto": Esperanto,
        "--Estonia": Estonia,
        "--ewe": Ewe,
        "--filipino": Filipino, //f
        "--Finnish": Finnish,
        "--Faranse": Faranse,
        "--frisian": Frisia,
        "--galician": Galician, //g
        "--georgian": Georgian,
        "- German": Jẹmánì,
        "-- Giriki": Giriki,
        "--guarani": Guarani,
        "--gujarati": Gujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": Hausa,
        "--hawaiian": Hawahi,
        "-Heberu": Heberu,
        "--hindi": Hindi,
        "--hmong": Hmong,
        "--Hungarian": Hungarian,
        "--Icelandic": Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--Indonesian": Indonesian,
        "--Irish": Irish,
        "--Italian": Itali,
        "--Japanese": Japanese, //j
        "--javanese": Javanese,
        "--kannada": Kannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": Kinyarwanda,
        "--konkani": Konkani,
        "--Korean": Korean,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdishSorani": Kurdish (Sorani),
        "--kyrgyz": Kyrgyz,
        "--lao": Lao, //l
        "--latin": Latin,
        "--Latvia": Latvia,
        "--lingala": Lingala,
        "--lituania": Lithuania,
        "--luganda": Luganda,
        "--luxembourgish": Luxembourgish,
        "--Masedonian": Macedonian, //m
        "--maithili": Maithili,
        "--malagasy": Malagasy,
        "--malay": Malay,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": Maori,
        "--marathi": Marathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": Mongolian,
        "--myanmarBurmese": Mianma (Burmese),
        "--nepali": Nepali, //n
        "-- Norwegian": Norwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Pashto, //p
        "--Persia": Persian,
        "--pólándì": Polish,
        "-- Portuguese": Portuguese,
        "--punjabi": Punjabi,
        "--quechua": Quechua, //q
        "--Romaniani": Romanian, //r
        "--Russian": Russian,
        "--samoan": Samoan, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Scots Gaelic,
        "--sepedi": Sepedi,
        "--serbian": Serbian,
        "--sesotho": Sesotho,
        "--shona": Shona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovakia": Slovakia,
        "--slovenian": Slovenia,
        "--somali": Somali,
        "--spanish": Spani,
        "--sundanese": ọmọ ilu Sundan,
        "--swahili": Swahili,
        "--Swedish": Swedish,
        "--tajik": Tajik, //t
        "--tamil": Tamil,
        "--tatar": Tatar,
        "--telugu": Telugu,
        "--thai": Thai,
        "--tigrinya": Tigrinya,
        "--tsonga": Tsonga,
        "- Tọki": Tọki,
        "--Turkmen": Turkmen,
        "--twi": Twi,
        "--Ukrainian": Ti Ukarain, //u
        "--urdu": Urdu,
        "--uyghur": Uyghur,
        "--uzbek": Uzbek,
        "--Vietnamese": Vietnamese, //v
        "--welsh": Welsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": Yoruba,
        "--zulu": Zulu, //z
        },
      },

      // zulu
      // zulu
      zulu: {
        translations: {
          "--iphutha lenzekile": Kwenzeke iphutha!, //a
          "--ikheli": Amakheli,
          "--advice": Iseluleko,
          "--ngokuchofoza okuthi qhubeka": Ngokuchofoza okuthi qhubeka uzonqanyulwa ku-akhawunti yakho ye-Veil Brillant, //b
          "--ngokuchofoza okuthi nqamula uzonqanyulwa": Ngokuchofoza okuthi Nqamula uzokhishwa ku-akhawunti yakho ye-izocash,
          "--hlola inombolo yakho ye-virtual noma uzame futhi emuva kwesikhathi": Hlola inombolo yakho ye-virtual noma uzame futhi ngokuhamba kwesikhathi, //c
          "--hlola inombolo yakho ebonakalayo": Hlola inombolo yakho ye-virtual,
          "--qhubeka": Qhubeka,
          "--ukuxhumana": Ukuxhumana,
          "--sebenzisana, phila ngokuvumelana": Hlanganyela, phila ngokuzwana nabanye,
          "--khetha ulimi": Ulimi Lwefoni Olungokoqobo,
          "--ungavimbi ukuncintisana": Ungavimbeli ukuncintisana, nika wonke umuntu ithuba, //d
          "--disconnection": Ukunqanyulwa,
          "--kubo bonke abasebenzisi befoni ebonakalayo": Kubo bonke abasebenzisi be-Virtual Phone, kuyanconywa ukusebenzisa i-VPN, //f
          "--ngena ekhasini lokungena": Iya ekhasini lokungena, //g
          "--ngokomlando": Ezomlando, //h
          "--nginayo i-akhawunti": Senginayo kakade i-akhawunti, //i
          "--i don't have account": Anginayo i-akhawunti,
          "--yindlu yakho": yindlu yakho,
          "--isithombe / ividiyo +": Isithombe / Ividiyo +,
          "--ukuqinisekiswa kobunikazi": Ukuqinisekiswa kobunikazi,
          "--izocash ikhasimende portal": izocash Customer Portal,
          "--isibuyekezo sobunikazi minyaka yonke": Isibuyekezo sobunikazi minyaka yonke,
          "--izocash buy to": izocash Thenga => izocash international,
          "--ngena": Ngena!, //l
          "--login": Ngena,
          "--ngena ngemvume ku-veil brilliant": Xhuma ku-Veil Brillant,
          "--ngena ngemvume esitolo se-vixinol": Xhuma esitolo se-Vixinol,
          "--ngena mahhala ku-akhawunti yakho ye-Veil Brillant": Ngena ngemvume mahhala ku-akhawunti yakho ye-Veil Brillant ukuze ufinyelele lesi sici,
          "--login impumelelo": Ukungena kuphumelele!,
          "--ngena manje": Ngena manje!,
          "--logout success": Phuma kuphumelele!,
          "--phuma": Phuma,
          "--phuma": Phuma,
          "--inombolo": Inombolo, //n
          "--igama": Igama,
          "--now log in": Manje, Ngena!,
          "--akukho ukuvinjelwa kokuncintisana kokuncintisana":
          "--akukho mhawu, akukho nzondo": Akukho mhawu, akukho nzondo, akukho ukwahlukana,
          "--cha": Cha,
          "--amakheli asemthethweni ukuze ufinyelele ifoni yakho ebonakalayo": Amakheli asemthethweni okufinyelela ifoni yakho ebonakalayo, //o
          "--password": Iphasiwedi, //p
          "--points withdrawals izocash": Amaphuzu Ukuhoxiswa izocash,
          "--points withdrawals": Ukuhoxiswa Kwamaphuzu,
          "--okungcono, sebenzisa i-vpn": Ngokukhethekile, sebenzisa i-VPN okungeyona eyomhlinzeki wakho wesevisi ye-inthanethi,
          "--persisence always paying off": Ukuphikelela njalo kuphumelela ekugcineni,
          "--rule": Imithetho, //r
          "--recommendation": Izincomo,
          "--registration": Ukubhalisa,
          "--bhalisa ku-veil brilliant": Bhalisa ku-Veil Brillant, //s
          "--bhalisa esitolo se-vixinol": Bhalisa ku-Vixinol Store,
          "--bhalisa": Bhalisa,
          "--signup success": Ukubhalisa kuphumelele!,
          "--bhalisa mahhala": Bhalisa mahhala,
          “--signup success IA”: Uxhumano luphumelele”,
          "--settings": "Izilungiselelo",
          "--ukusetha uhlelo lokusebenza lwe-alrani": Ilungiselela uhlelo lwe-Alrani,
          "--setting up the izocash app": Ilungiselela izocash application,
          "--setting up the vixinol app": Ilungiselela uhlelo lweVixinol,
          "--setting the veil Brillant app": Ilungiselela uhlelo lokusebenza lwe-Veil Brillant,
          "--ukugcinwa kwezithombe, amavidiyo": Ukugcinwa kwezithombe, amavidiyo nezinye izinto ezimbalwa,
          "--speed of reception": Isivinini sokwamukela idatha kusuka ku-Datacenter,
          "--speed": Isivinini,
          "--qeda": Qeda, //t
          "--the vpn ikuvumela ukuthi ufinyelele": I-VPN ikuvumela ukuthi ufinyelele isayithi noma uhlelo lokusebenza umhlinzeki wakho wesevisi ye-inthanethi aluvimbile,
          "--isihlahla esikhulu kunazo zonke sasingaphezulu": Isihlahla esikhulu kunazo zonke sasingaphezu kwayo yonke imbewu encane elula,
          "--thinta isikrini": Thinta isikrini ukuze uqhubeke,
          "--try again": Zama futhi!,
          "--igama lomsebenzisi": Igama lomsebenzisi, //u

          "--virtual number": Inombolo ebonakalayo, //v
           "--izilungiselelo zocingo olubonakalayo": Izilungiselelo zefoni ebonakalayo,
           "--virtual Ulimi lwefoni lusetshenziswa": Ulimi lwe-Virtual Phone lusetshenziswa ezingeni lohlelo ngokuzenzakalelayo,
           "--ifoni ebonakalayo": Ifoni ebonakalayo,
           "--qinisekisa": Qinisekisa,
           "--Siyakwamukela ku-portal yekhasimende le-izocash": Siyakwamukela ku-izocash Customer Portal, //w
           "--bhala ikhodi enhle kakhulu": Faka ikhodi ephezulu,
           "--welcome to": Siyakwamukela ku-,
           "--lapho abantu baya khona": Lapho ukunaka kwabantu kuya khona imali,
           "--winners persevere": Abanqobi bayaphikelela,
           "--ungathanda ukuphuma ku-akhawunti yakho ye-Alrani": Ingabe ufuna ukuphuma ku-akhawunti yakho ye-Alrani?,
           "--yebo": Yebo, //y

           // izwe
           "--congo": Congo Brazzaville,
           "-cameroon": Cameroon,
           "--drc": DRC,
           "--ivoryCoast": Ivory Coast,

           // ulimi
        "--Afrikaans": IsiBhunu, //a
        "--Albania": isi-Albania,
        "--amharic": isi-Amharic,
        "--arabic": isi-Arabhu,
        "--Armenian": isi-Armenian,
        "--assamese": isi-Assamese,
        "--aymara": Aymara,
        "--azerbaijani": isi-Azerbaijani,
        "--bambara": Bambara, //b
        "--basque": Isi-Basque,
        "--belarusian": isiBelarusian,
        "--bengali": Bengali,
        "--bhojpuri": Bhojpuri,
        "--bosnia": isi-Bosnia,
        "--bulgarian": isiBulgaria,
        "--catalan": Catalan, //c
        "--Cebuano": Cebuano,
        "--chichewa": isiChewa,
        "--chineseSimplified": IsiShayina (Esenziwe Lula),
        "--chineseTraditional": Chinese (Traditional),
        "--corsican": isiCorsican,
        "--croatian": isiCroatia,
        "--Czech": isiCzech,
        "--Danish": Isi-Danish, //d
        "--dhivehi": Dhivehi,
        "--dogri": Dogri,
        "--Dutch": Dutch,
        "--english": IsiNgisi, //e
        "--esperanto": Esperanto,
        "--estonian": isi-Estonian,
        "--ewe": Ewe,
        "-- isifilipino": isiFilipino, //f
        "--isiFinnish": isiFinnish,
        "--isiFulentshi": isiFulentshi,
        "--frisian": IsiFrisian,
        "--galician": Galician, //g
        "--georgian": isiGeorgia,
        "--German": isiJalimane,
        "--Greek": isiGreki,
        "--guarani": Guarani,
        "--gujarati": IsiGujarati,
        "--haitianCreole": Haitian Creole, //h
        "--hausa": isiHausa,
        "--hawaiian": isiHawaiian,
        "--hebrew": isiHebheru,
        "--hindi": isi-Hindi,
        "--hmong": Hmong,
        "--hungarian": isiHungary,
        "--isi-Icelandic": Isi-Icelandic, //i
        "--igbo": Igbo,
        "--ilocano": Ilocano,
        "--indonesian": isi-Indonesian,
        "--Irish": isi-Irish,
        "--italian": isiNtaliyane,
        "--japanese": Japanese, //j
        "--javanese": isi-Javanese,
        "--kannada": IsiKannada, //k
        "--kazakh": Kazakh,
        "--khmer": Khmer,
        "--kinyarwanda": isiKinyarwanda,
        "--konkani": Konkani,
        "--korean": isiKorea,
        "--krio": Krio,
        "--kurdishKurmanji": Kurdish (Kurmanji),
        "--kurdish Sorani": Kurdish (Sorani),
        "--kyrgyz": isiKyrgyz,
        "--lao": Lao, //l
        "--latin": isiLatini,
        "--latvian": isi-Latvian,
        "--lingala": Lingala,
        "--lithuanian": isiLithuanian,
        "--luganda": isiLuganda,
        "--luxembourgish": Luxembourgish,
        "--macedonian": isiMacedonian, //m
        "--maithili": Maithili,
        "--malagasy": isiMalagasy,
        "--malay": isiMalay,
        "--malayalam": Malayalam,
        "--maltese": Malta,
        "--maori": isiMaori,
        "--marathi": IsiMarathi,
        "--meiteilonManipuri": Meiteilon (Manipuri),
        "--mizo": Mizo,
        "--mongolian": isiMongolia,
        "--myanmarBurmese": isiMyanmar (isiBurmese),
        "--Nepali": Isi-Nepali, //n
        "--norwegian": isiNorwegian,
        "--odiaOriya": Odia (Oriya), //o
        "--oromo": Oromo,
        "--pashto": Isi-Pashto, //p
        "--Persian": isiPheresiya,
        "--Polish": isiPolish,
        "--Portuguese": IsiPutukezi,
        "--punjabi": isiPunjabi,
        "--quechua": IsiQuechua, //q
        "--romanian": IsiRomania, //r
        "--Russian": IsiRashiya,
        "--samoan": isiSamoa, //s
        "--sanskrit": Sanskrit,
        "--scotsGaelic": Isi-Scots Gaelic,
        "--sepedi": isiPedi,
        "--serbian": isi-Serbian,
        "--sesotho": isiSuthu,
        "--shona": isiShona,
        "--sindhi": Sindhi,
        "--sinhala": Sinhala,
        "--slovak": Slovak,
        "--slovenian": isiSlovenian,
        "--somali": Somali,
        "--Spanish": iSpanishi,
        "--sundanese": isiSundanese,
        "--swahili": IsiSwahili,
        "--swedish": IsiSwidi,
        "--tajik": Tajik, //t
        "--tamil": isiTamil,
        "--Tatar": IsiTatar,
        "--telugu": isiTelugu,
        "--thai": isiThai,
        "--tigrinya": isiTigrinya,
        "--tsonga": Tsonga,
        "--Turkish": IsiTurkey,
        "--Turkmen": IsiTurkmen,
        "--twi": Twi,
        "--ukrainian": Isi-Ukraine, //u
        "--urdu": Isi-Urdu,
        "--uyghur": Isi-Uyghur,
        "--Uzbek": Uzbek,
        "--Vietnamese": Vietnamese, //v
        "--welsh": isiWelsh, //w
        "--xhosa": Xhosa, //x
        "--yiddish": Yiddish, //y
        "--yoruba": IsiYoruba,
        "--zulu": Zulu, //z
        },
      },
      */

      
    },
    fallbackLng: "english",
    debug: true,

    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
